// === GENERATED BY scripts/generate_template.py — DO NOT EDIT MANUALLY ===
// Template: React Native Mobile App
// Total files: 97

import type { FileTreeNode } from '../types/wizard';

export const reactNativeDemoFileTree: FileTreeNode[] = [
    {
      name: '.claude',
      path: '.claude',
      type: 'directory',
      children: [
        {
          name: 'rules',
          path: '.claude/rules',
          type: 'directory',
          children: [
            {
              name: 'common',
              path: '.claude/rules/common',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/common/coding-style.md', type: 'file' },
                { name: 'git-workflow.md', path: '.claude/rules/common/git-workflow.md', type: 'file' },
                { name: 'security.md', path: '.claude/rules/common/security.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/common/testing.md', type: 'file' },
              ],
            },
            {
              name: 'typescript',
              path: '.claude/rules/typescript',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/typescript/coding-style.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/typescript/testing.md', type: 'file' },
              ],
            },
          ],
        },
        { name: 'settings.json', path: '.claude/settings.json', type: 'file' },
      ],
    },
    { name: '.editorconfig', path: '.editorconfig', type: 'file' },
    { name: '.eslintrc.js', path: '.eslintrc.js', type: 'file' },
    { name: '.gitattributes', path: '.gitattributes', type: 'file' },
    {
      name: '.github',
      path: '.github',
      type: 'directory',
      children: [
        { name: 'CODEOWNERS', path: '.github/CODEOWNERS', type: 'file' },
        {
          name: 'ISSUE_TEMPLATE',
          path: '.github/ISSUE_TEMPLATE',
          type: 'directory',
          children: [
            { name: 'ai_task.md', path: '.github/ISSUE_TEMPLATE/ai_task.md', type: 'file' },
            { name: 'bug_report.md', path: '.github/ISSUE_TEMPLATE/bug_report.md', type: 'file' },
            { name: 'feature_request.md', path: '.github/ISSUE_TEMPLATE/feature_request.md', type: 'file' },
          ],
        },
        { name: 'PULL_REQUEST_TEMPLATE.md', path: '.github/PULL_REQUEST_TEMPLATE.md', type: 'file' },
        {
          name: 'workflows',
          path: '.github/workflows',
          type: 'directory',
          children: [
            { name: 'ai-code-audit.yml', path: '.github/workflows/ai-code-audit.yml', type: 'file' },
            { name: 'ci.yml', path: '.github/workflows/ci.yml', type: 'file' },
            { name: 'deploy-production.yml', path: '.github/workflows/deploy-production.yml', type: 'file' },
            { name: 'deploy-staging.yml', path: '.github/workflows/deploy-staging.yml', type: 'file' },
          ],
        },
      ],
    },
    { name: '.gitignore', path: '.gitignore', type: 'file' },
    { name: '.mcp.json', path: '.mcp.json', type: 'file' },
    { name: '.prettierrc', path: '.prettierrc', type: 'file' },
    { name: 'CLAUDE.md', path: 'CLAUDE.md', type: 'file' },
    { name: 'README.md', path: 'README.md', type: 'file' },
    {
      name: 'docs',
      path: 'docs',
      type: 'directory',
      children: [
        { name: 'AI-USAGE-POLICY.md', path: 'docs/AI-USAGE-POLICY.md', type: 'file' },
        { name: 'ARCHITECTURE.md', path: 'docs/ARCHITECTURE.md', type: 'file' },
        { name: 'CONTRIBUTING.md', path: 'docs/CONTRIBUTING.md', type: 'file' },
        { name: 'ONBOARDING.md', path: 'docs/ONBOARDING.md', type: 'file' },
      ],
    },
    {
      name: 'git-hooks',
      path: 'git-hooks',
      type: 'directory',
      children: [
        { name: 'commit-msg', path: 'git-hooks/commit-msg', type: 'file' },
        { name: 'pre-commit', path: 'git-hooks/pre-commit', type: 'file' },
        { name: 'pre-push', path: 'git-hooks/pre-push', type: 'file' },
      ],
    },
    { name: 'install.sh', path: 'install.sh', type: 'file' },
    {
      name: 'mock-mcp-servers',
      path: 'mock-mcp-servers',
      type: 'directory',
      children: [
        { name: 'README.md', path: 'mock-mcp-servers/README.md', type: 'file' },
        { name: 'github-server.mjs', path: 'mock-mcp-servers/github-server.mjs', type: 'file' },
        { name: 'jira-server.mjs', path: 'mock-mcp-servers/jira-server.mjs', type: 'file' },
        { name: 'package.json', path: 'mock-mcp-servers/package.json', type: 'file' },
      ],
    },
    { name: 'package.json', path: 'package.json', type: 'file' },
    {
      name: 'playbook',
      path: 'playbook',
      type: 'directory',
      children: [
        { name: 'PLAYBOOK.md', path: 'playbook/PLAYBOOK.md', type: 'file' },
        {
          name: 'claude-overrides',
          path: 'playbook/claude-overrides',
          type: 'directory',
          children: [
            { name: '01-discovery.claude.md', path: 'playbook/claude-overrides/01-discovery.claude.md', type: 'file' },
            { name: '02-architecture.claude.md', path: 'playbook/claude-overrides/02-architecture.claude.md', type: 'file' },
            { name: '03-foundation.claude.md', path: 'playbook/claude-overrides/03-foundation.claude.md', type: 'file' },
            { name: '04-core-implementation.claude.md', path: 'playbook/claude-overrides/04-core-implementation.claude.md', type: 'file' },
            { name: '05-integration-hardening.claude.md', path: 'playbook/claude-overrides/05-integration-hardening.claude.md', type: 'file' },
            { name: '06-testing-quality.claude.md', path: 'playbook/claude-overrides/06-testing-quality.claude.md', type: 'file' },
            { name: '07-launch.claude.md', path: 'playbook/claude-overrides/07-launch.claude.md', type: 'file' },
          ],
        },
        { name: 'codeforge-phase.sh', path: 'playbook/codeforge-phase.sh', type: 'file' },
        { name: 'current-phase.json', path: 'playbook/current-phase.json', type: 'file' },
        {
          name: 'phases',
          path: 'playbook/phases',
          type: 'directory',
          children: [
            { name: '01-discovery.md', path: 'playbook/phases/01-discovery.md', type: 'file' },
            { name: '02-architecture.md', path: 'playbook/phases/02-architecture.md', type: 'file' },
            { name: '03-foundation.md', path: 'playbook/phases/03-foundation.md', type: 'file' },
            { name: '04-core-implementation.md', path: 'playbook/phases/04-core-implementation.md', type: 'file' },
            { name: '05-integration-hardening.md', path: 'playbook/phases/05-integration-hardening.md', type: 'file' },
            { name: '06-testing-quality.md', path: 'playbook/phases/06-testing-quality.md', type: 'file' },
            { name: '07-launch.md', path: 'playbook/phases/07-launch.md', type: 'file' },
          ],
        },
        {
          name: 'prompts',
          path: 'playbook/prompts',
          type: 'directory',
          children: [
            {
              name: '01',
              path: 'playbook/prompts/01',
              type: 'directory',
              children: [
                { name: 'gather-requirements.md', path: 'playbook/prompts/01/gather-requirements.md', type: 'file' },
                { name: 'nfr-checklist.md', path: 'playbook/prompts/01/nfr-checklist.md', type: 'file' },
                { name: 'user-stories.md', path: 'playbook/prompts/01/user-stories.md', type: 'file' },
              ],
            },
            {
              name: '02',
              path: 'playbook/prompts/02',
              type: 'directory',
              children: [
                { name: 'adr-generator.md', path: 'playbook/prompts/02/adr-generator.md', type: 'file' },
                { name: 'api-design.md', path: 'playbook/prompts/02/api-design.md', type: 'file' },
                { name: 'data-model-design.md', path: 'playbook/prompts/02/data-model-design.md', type: 'file' },
              ],
            },
            {
              name: '03',
              path: 'playbook/prompts/03',
              type: 'directory',
              children: [
                { name: 'ci-pipeline.md', path: 'playbook/prompts/03/ci-pipeline.md', type: 'file' },
                { name: 'iac-setup.md', path: 'playbook/prompts/03/iac-setup.md', type: 'file' },
                { name: 'project-scaffold.md', path: 'playbook/prompts/03/project-scaffold.md', type: 'file' },
              ],
            },
            {
              name: '04',
              path: 'playbook/prompts/04',
              type: 'directory',
              children: [
                { name: 'auth-implementation.md', path: 'playbook/prompts/04/auth-implementation.md', type: 'file' },
                { name: 'crud-generator.md', path: 'playbook/prompts/04/crud-generator.md', type: 'file' },
                { name: 'feature-implementation.md', path: 'playbook/prompts/04/feature-implementation.md', type: 'file' },
              ],
            },
            {
              name: '05',
              path: 'playbook/prompts/05',
              type: 'directory',
              children: [
                { name: 'integration-adapter.md', path: 'playbook/prompts/05/integration-adapter.md', type: 'file' },
                { name: 'observability-setup.md', path: 'playbook/prompts/05/observability-setup.md', type: 'file' },
                { name: 'security-hardening.md', path: 'playbook/prompts/05/security-hardening.md', type: 'file' },
              ],
            },
            {
              name: '06',
              path: 'playbook/prompts/06',
              type: 'directory',
              children: [
                { name: 'e2e-test-generator.md', path: 'playbook/prompts/06/e2e-test-generator.md', type: 'file' },
                { name: 'load-test.md', path: 'playbook/prompts/06/load-test.md', type: 'file' },
                { name: 'test-suite-generator.md', path: 'playbook/prompts/06/test-suite-generator.md', type: 'file' },
              ],
            },
            {
              name: '07',
              path: 'playbook/prompts/07',
              type: 'directory',
              children: [
                { name: 'go-live-checklist.md', path: 'playbook/prompts/07/go-live-checklist.md', type: 'file' },
                { name: 'monitoring-setup.md', path: 'playbook/prompts/07/monitoring-setup.md', type: 'file' },
                { name: 'runbook-generator.md', path: 'playbook/prompts/07/runbook-generator.md', type: 'file' },
              ],
            },
          ],
        },
      ],
    },
    {
      name: 'plugin',
      path: 'plugin',
      type: 'directory',
      children: [
        {
          name: 'codeforge-react-native',
          path: 'plugin/codeforge-react-native',
          type: 'directory',
          children: [
            {
              name: '.claude-plugin',
              path: 'plugin/codeforge-react-native/.claude-plugin',
              type: 'directory',
              children: [
                { name: 'plugin.json', path: 'plugin/codeforge-react-native/.claude-plugin/plugin.json', type: 'file' },
              ],
            },
            { name: 'README.md', path: 'plugin/codeforge-react-native/README.md', type: 'file' },
            {
              name: 'agents',
              path: 'plugin/codeforge-react-native/agents',
              type: 'directory',
              children: [
                { name: 'architect.md', path: 'plugin/codeforge-react-native/agents/architect.md', type: 'file' },
                { name: 'build-error-resolver.md', path: 'plugin/codeforge-react-native/agents/build-error-resolver.md', type: 'file' },
                { name: 'code-reviewer.md', path: 'plugin/codeforge-react-native/agents/code-reviewer.md', type: 'file' },
                { name: 'planner.md', path: 'plugin/codeforge-react-native/agents/planner.md', type: 'file' },
                { name: 'tdd-guide.md', path: 'plugin/codeforge-react-native/agents/tdd-guide.md', type: 'file' },
              ],
            },
            {
              name: 'commands',
              path: 'plugin/codeforge-react-native/commands',
              type: 'directory',
              children: [
                { name: 'build-fix.md', path: 'plugin/codeforge-react-native/commands/build-fix.md', type: 'file' },
                { name: 'code-review.md', path: 'plugin/codeforge-react-native/commands/code-review.md', type: 'file' },
                { name: 'phase.md', path: 'plugin/codeforge-react-native/commands/phase.md', type: 'file' },
                { name: 'plan.md', path: 'plugin/codeforge-react-native/commands/plan.md', type: 'file' },
                { name: 'tdd.md', path: 'plugin/codeforge-react-native/commands/tdd.md', type: 'file' },
                { name: 'verify.md', path: 'plugin/codeforge-react-native/commands/verify.md', type: 'file' },
              ],
            },
            {
              name: 'hooks',
              path: 'plugin/codeforge-react-native/hooks',
              type: 'directory',
              children: [
                { name: 'hooks.json', path: 'plugin/codeforge-react-native/hooks/hooks.json', type: 'file' },
              ],
            },
            {
              name: 'skills',
              path: 'plugin/codeforge-react-native/skills',
              type: 'directory',
              children: [
                {
                  name: 'build-fix',
                  path: 'plugin/codeforge-react-native/skills/build-fix',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-react-native/skills/build-fix/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'code-review',
                  path: 'plugin/codeforge-react-native/skills/code-review',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-react-native/skills/code-review/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'phase',
                  path: 'plugin/codeforge-react-native/skills/phase',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-react-native/skills/phase/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'plan',
                  path: 'plugin/codeforge-react-native/skills/plan',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-react-native/skills/plan/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'tdd',
                  path: 'plugin/codeforge-react-native/skills/tdd',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-react-native/skills/tdd/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'verify',
                  path: 'plugin/codeforge-react-native/skills/verify',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-react-native/skills/verify/SKILL.md', type: 'file' },
                  ],
                },
              ],
            },
          ],
        },
        { name: 'marketplace.json.example', path: 'plugin/marketplace.json.example', type: 'file' },
      ],
    },
    { name: 'tsconfig.json', path: 'tsconfig.json', type: 'file' },
];

export const reactNativeDemoFileContents: Record<string, string> = {
  '.claude/rules/common/coding-style.md': `# Coding Style Rules

## Naming Conventions

### Files and Directories

- **Components/Screens**: \`kebab-case.tsx\` → \`user-profile-card.tsx\`, \`login-screen.tsx\`
- **Hooks**: \`kebab-case.ts\` with \`use\` prefix → \`use-auth.ts\`, \`use-offline-sync.ts\`
- **Utilities**: \`kebab-case.ts\` → \`format-currency.ts\`, \`platform-helpers.ts\`
- **Types**: \`kebab-case.ts\` → \`navigation-types.ts\`, \`api-types.ts\`
- **Constants**: \`kebab-case.ts\` → \`app-constants.ts\`, \`query-keys.ts\`
- **Test files**: \`<source-file>.test.tsx\` or \`<source-file>.test.ts\`
- **Directories**: \`kebab-case\` → \`user-profile/\`, \`push-notifications/\`

### Exports and Symbols

- **Components/Screens**: \`PascalCase\` → \`UserProfileCard\`, \`LoginScreen\`
- **Hooks**: \`camelCase\` with \`use\` prefix → \`useAuth\`, \`useOfflineSync\`
- **Utilities/Functions**: \`camelCase\` → \`formatCurrency\`, \`validateEmail\`
- **Constants**: \`SCREAMING_SNAKE_CASE\` → \`MAX_RETRY_COUNT\`, \`API_TIMEOUT_MS\`
- **Types/Interfaces**: \`PascalCase\` → \`UserProfile\`, \`NavigationParams\`
- **Enums**: \`PascalCase\` name, \`PascalCase\` members → \`AuthStatus.Authenticated\`
- **Zustand stores**: \`camelCase\` with \`use\` prefix → \`useAuthStore\`, \`useThemeStore\`
- **React Query keys**: \`camelCase\` arrays → \`['user', 'profile', userId]\`

### Platform-Specific Files

Use the React Native platform extension convention:

\`\`\`
button.tsx            # Shared implementation
button.ios.tsx        # iOS-specific override
button.android.tsx    # Android-specific override
\`\`\`

## File Structure

### Maximum File Length

Files must not exceed **250 lines**. If a file approaches this limit, extract logic into separate hooks, utilities, or subcomponents.

### Component File Template

\`\`\`typescript
// 1. External imports
// 2. Internal imports
// 3. Types
// 4. Constants
// 5. Component
// 6. Styles (if colocated)
\`\`\`

Follow this ordering within every component file:

\`\`\`typescript
// External imports
import React, { useCallback, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';

// Internal imports — grouped by category
import { Button, Text } from '@/components';
import { useAuth } from '@/hooks/use-auth';
import { formatDisplayName } from '@/utils/format-display-name';
import { PROFILE_DEFAULTS } from '@/utils/constants';

// Types
import type { ProfileScreenProps } from './types';

// Local constants
const AVATAR_SIZE = 64;

// Component
export const ProfileScreen: React.FC<ProfileScreenProps> = ({ userId }) => {
  // hooks first
  const navigation = useNavigation();
  const { user } = useAuth();

  // derived state
  const displayName = useMemo(() => formatDisplayName(user), [user]);

  // callbacks
  const handlePress = useCallback(() => {
    navigation.navigate('EditProfile');
  }, [navigation]);

  // render
  return (
    <View style={styles.container}>
      <Text>{displayName}</Text>
      <Button onPress={handlePress} accessibilityLabel="Edit profile" />
    </View>
  );
};

// Styles
const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
  },
});
\`\`\`

### Hook File Template

\`\`\`typescript
// External imports
import { useCallback, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

// Internal imports
import { fetchUserProfile } from '@/services/firebase/user-service';
import { queryKeys } from '@/utils/query-keys';

// Types
import type { UserProfile } from '@/features/profile/types';

// Hook
export const useUserProfile = (userId: string) => {
  const query = useQuery({
    queryKey: queryKeys.userProfile(userId),
    queryFn: () => fetchUserProfile(userId),
    staleTime: 5 * 60 * 1000,
  });

  return {
    profile: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};
\`\`\`

### Feature Directory Structure

Every feature under \`src/features/\` follows this layout:

\`\`\`
src/features/auth/
  screens/
    login-screen.tsx
    register-screen.tsx
  components/
    biometric-prompt.tsx
    social-login-buttons.tsx
  hooks/
    use-login.ts
    use-biometric-auth.ts
  services/
    auth-service.ts
  types/
    index.ts
  __tests__/
    login-screen.test.tsx
    use-login.test.ts
  index.ts              # Public API barrel export
\`\`\`

The barrel \`index.ts\` exports only the public API of the feature. Internal components and hooks not needed outside the feature are not exported.

## Import Ordering

Imports must follow this strict order, separated by blank lines:

\`\`\`typescript
// 1. React / React Native core
import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';

// 2. Third-party libraries (alphabetical)
import { useNavigation } from '@react-navigation/native';
import { useQuery } from '@tanstack/react-query';
import firestore from '@react-native-firebase/firestore';

// 3. Internal absolute imports — shared modules (alphabetical by path)
import { Button, Card } from '@/components';
import { useAuth } from '@/hooks/use-auth';
import { analyticsService } from '@/services/analytics';
import { useAuthStore } from '@/store/auth-store';
import { colors, spacing } from '@/theme';
import { formatDate } from '@/utils/format-date';

// 4. Internal relative imports — same feature (alphabetical)
import { ProfileAvatar } from '../components/profile-avatar';
import { useUserProfile } from '../hooks/use-user-profile';

// 5. Type-only imports (always last, using \`import type\`)
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import type { RootStackParamList } from '@/navigation/navigation-types';
import type { UserProfile } from '../types';
\`\`\`

### Import Rules

- Use path aliases (\`@/\`) for all absolute imports — never use deep relative paths like \`../../../\`
- Use \`import type\` for type-only imports — this is enforced by TypeScript \`verbatimModuleSyntax\`
- No default exports except for screens used in navigation (React Navigation lazy loading)
- Barrel imports from feature \`index.ts\` are preferred when importing across features
- Never import from another feature's internal files — only from its barrel export

## TypeScript Rules

### Strict Mode

TypeScript strict mode is enabled. These rules are non-negotiable:

- **No \`any\`** — use \`unknown\` and narrow with type guards
- **No non-null assertions** (\`!\`) — handle null/undefined explicitly
- **No type assertions** (\`as\`) unless narrowing from \`unknown\` after validation
- **Explicit return types** on exported functions and hooks
- **Readonly** for props, state objects, and constants where mutation is not intended

### Type Definitions

\`\`\`typescript
// Props — use interface for component props
interface ProfileCardProps {
  readonly userId: string;
  readonly onPress: (userId: string) => void;
  readonly variant?: 'compact' | 'full';
}

// API responses — use type for data shapes
type UserProfileResponse = {
  readonly id: string;
  readonly displayName: string;
  readonly email: string;
  readonly createdAt: string;
};

// Discriminated unions for state
type AuthState =
  | { readonly status: 'idle' }
  | { readonly status: 'loading' }
  | { readonly status: 'authenticated'; readonly user: User }
  | { readonly status: 'error'; readonly error: Error };
\`\`\`

### Enums vs Union Types

Prefer string union types for simple cases. Use enums only when you need reverse mapping or iteration:

\`\`\`typescript
// Preferred for most cases
type PaymentStatus = 'pending' | 'completed' | 'failed' | 'refunded';

// Use enum when you need runtime iteration or reverse mapping
enum DeepLinkRoute {
  Profile = 'profile',
  Settings = 'settings',
  Notification = 'notification',
}
\`\`\`

## React Native Patterns

### Styles

- Use \`StyleSheet.create()\` — never inline style objects (performance)
- Colocate styles at the bottom of the component file
- Extract shared styles to \`src/theme/\` when used across 3+ components
- Use design tokens from \`src/theme/\` for colors, spacing, typography — no magic numbers

\`\`\`typescript
// Correct — uses theme tokens
import { colors, spacing, typography } from '@/theme';

const styles = StyleSheet.create({
  container: {
    padding: spacing.md,
    backgroundColor: colors.background.primary,
  },
  title: {
    ...typography.heading2,
    color: colors.text.primary,
  },
});
\`\`\`

### Platform-Specific Code

\`\`\`typescript
// For small differences, use Platform.select
import { Platform } from 'react-native';

const shadowStyle = Platform.select({
  ios: { shadowColor: '#000', shadowOffset: { width: 0, height: 2 } },
  android: { elevation: 4 },
});

// For large differences, use platform-specific files
// button.ios.tsx / button.android.tsx
\`\`\`

### Accessibility

Every interactive element must have an accessibility label:

\`\`\`typescript
<TouchableOpacity
  onPress={handleDelete}
  accessibilityLabel={t('profile.deleteAccount')}
  accessibilityRole="button"
  accessibilityHint={t('profile.deleteAccountHint')}
>
\`\`\`

### Internationalization

All user-facing text must go through \`i18n\`. No hardcoded strings in components:

\`\`\`typescript
// Wrong
<Text>Welcome back!</Text>

// Correct
import { useTranslation } from 'react-i18next';
const { t } = useTranslation();
<Text>{t('home.welcomeBack')}</Text>
\`\`\`

## Formatting (Prettier)

These settings are enforced via Prettier and must not be overridden:

- \`singleQuote: true\`
- \`trailingComma: 'all'\`
- \`semi: true\`
- \`printWidth: 100\`
- \`tabWidth: 2\`
- \`bracketSpacing: true\`
- \`arrowParens: 'always'\`

## Export Conventions

- **Named exports** for all components, hooks, utilities, and types
- **Default exports** only for screen components registered with React Navigation
- **Barrel exports** (\`index.ts\`) at feature boundaries — keep them minimal and explicit
- Never re-export everything with \`export *\` — list exports explicitly to maintain a clear public API

\`\`\`typescript
// src/features/auth/index.ts
export { LoginScreen } from './screens/login-screen';
export { RegisterScreen } from './screens/register-screen';
export { useAuth } from './hooks/use-auth';
export type { AuthState, LoginCredentials } from './types';
\`\`\``,

  '.claude/rules/common/git-workflow.md': `# Git Workflow Rules

## Branching Strategy

This project uses **GitHub Flow** with a single protected \`main\` branch.

- \`main\` is always deployable — every merge triggers EAS Update to staging
- All work happens on short-lived feature branches created from \`main\`
- Branches are merged back to \`main\` via pull request with required review
- Delete branches after merge

## Branch Naming

Format: \`type/ticket-desc\`

| Type | Purpose | Example |
|------|---------|---------|
| \`feat\` | New feature or enhancement | \`feat/APP-42-add-push-notifications\` |
| \`fix\` | Bug fix | \`fix/APP-87-crash-on-deep-link\` |
| \`chore\` | Maintenance, deps, config | \`chore/APP-91-upgrade-expo-sdk-51\` |
| \`docs\` | Documentation only | \`docs/APP-15-deployment-runbook\` |
| \`refactor\` | Code restructure, no behavior change | \`refactor/APP-63-extract-auth-hooks\` |
| \`test\` | Adding or fixing tests | \`test/APP-44-detox-payment-flow\` |
| \`hotfix\` | Urgent production fix | \`hotfix/APP-99-firebase-auth-crash\` |

Rules:
- Always include the GitHub Issue number (e.g., \`APP-42\`)
- Use lowercase kebab-case for the description
- Keep descriptions short but meaningful (3-5 words max)
- No slashes beyond the type prefix

## Conventional Commits

Every commit message must follow the [Conventional Commits](https://www.conventionalcommits.org/) specification.

### Format

\`\`\`
type(scope): description

[optional body]

[optional footer(s)]
\`\`\`

### Types

| Type | When to Use |
|------|-------------|
| \`feat\` | New feature visible to users |
| \`fix\` | Bug fix |
| \`chore\` | Build, deps, config, tooling |
| \`docs\` | Documentation changes |
| \`refactor\` | Code change that neither fixes a bug nor adds a feature |
| \`test\` | Adding or correcting tests |
| \`perf\` | Performance improvement |
| \`ci\` | CI/CD pipeline changes (GitHub Actions, EAS config) |
| \`style\` | Formatting, missing semicolons (no logic change) |
| \`revert\` | Reverting a previous commit |

### Scopes

Use the feature or module name as scope:

- \`auth\` — Authentication, biometrics, secure storage
- \`home\` — Home feed, dashboard
- \`profile\` — User profile, settings
- \`notifications\` — Push notifications, in-app notifications
- \`payments\` — In-app purchases, subscriptions
- \`navigation\` — React Navigation config, deep linking
- \`offline\` — WatermelonDB, sync logic
- \`firebase\` — Firebase services (Firestore, Cloud Functions, Cloud Messaging)
- \`analytics\` — Firebase Analytics, Sentry
- \`i18n\` — Internationalization, translations
- \`theme\` — Design tokens, dark mode
- \`ui\` — Shared components in \`src/components/\`
- \`e2e\` — Detox E2E tests
- \`eas\` — EAS Build, EAS Submit, EAS Update config
- \`deps\` — Dependency updates
- \`ios\` — iOS-specific changes
- \`android\` — Android-specific changes

### Examples

\`\`\`
feat(notifications): add push notification opt-in screen

Implements the notification permission request flow with
Firebase Cloud Messaging token registration.

Closes APP-42
\`\`\`

\`\`\`
fix(offline): resolve WatermelonDB sync conflict on profile update

The merge resolver was not handling concurrent edits to the
user profile table. Added last-write-wins strategy with
server timestamp comparison.

Fixes APP-87
\`\`\`

\`\`\`
chore(deps): upgrade expo-sdk to 51.0.9

Also updates react-native to 0.74.1 and patches
expo-notifications for Android 14 compatibility.

APP-91
\`\`\`

\`\`\`
ci(eas): add separate staging and production build profiles
\`\`\`

\`\`\`
refactor(auth): extract biometric check into useBiometricAuth hook
\`\`\`

### Commit Rules

- **Subject line**: imperative mood, lowercase, no period, max 72 characters
- **Body**: wrap at 80 characters, explain *what* and *why* (not *how*)
- **Footer**: reference GitHub Issues with \`Closes APP-XX\` or \`Fixes APP-XX\`
- One logical change per commit — don't mix a feature with a refactor
- Never commit secrets, \`.env\` files, \`google-services.json\`, or \`GoogleService-Info.plist\`

### AI-Generated Code

When a commit contains AI-generated code (from Claude or other tools), add a trailer:

\`\`\`
feat(home): add pull-to-refresh on dashboard feed

Generated-with: Claude
\`\`\`

This is required by project CI policy. The \`Generated-with\` trailer is checked during PR review.

## Pull Request Requirements

### Before Opening a PR

1. Rebase on latest \`main\` — no merge commits in feature branches
2. Run the full local check suite:
   \`\`\`bash
   pnpm lint
   pnpm typecheck
   pnpm test
   npx expo-doctor
   \`\`\`
3. Ensure all new/modified components have accessibility labels
4. Ensure all user-facing text goes through \`i18n\`
5. Verify both iOS and Android if touching native modules:
   \`\`\`bash
   npx expo start --ios
   npx expo start --android
   \`\`\`

### PR Title

Must match conventional commit format:

\`\`\`
feat(notifications): add push notification opt-in screen
\`\`\`

### PR Description

Use the project PR template. At minimum include:

- **What**: Summary of changes
- **Why**: Link to GitHub Issue (\`Closes #42\`)
- **How**: Brief technical approach
- **Testing**: What was tested (unit, component, manual, E2E)
- **Screenshots/Video**: Required for any UI changes (both iOS and Android)
- **Platform Impact**: Note if changes are iOS-only, Android-only, or cross-platform
- **Offline Behavior**: Note if changes affect offline-first functionality
- **Breaking Changes**: Note any breaking changes to navigation, data models, or APIs

### Merge Requirements

All of these must pass before merge:

- [ ] At least **1 approval** from a team member
- [ ] All CI checks green (lint, typecheck, unit tests, component tests)
- [ ] EAS Build succeeds for both iOS and Android
- [ ] No unresolved review comments
- [ ] Branch is up to date with \`main\`
- [ ] PR title follows conventional commit format

### Review Guidelines

- Reviewers should check for platform-specific edge cases (iOS vs Android behavior)
- Verify offline scenarios are handled (network loss during operations)
- Check that new screens are added to navigation types in \`src/navigation/\`
- Verify sensitive paths (\`src/services/auth/**\`, \`src/config/**\`, \`.env*\`) get extra scrutiny
- Native module changes require review from a senior or lead developer

### CODEOWNERS

The following paths require review from designated owners:

| Path | Owner |
|------|-------|
| \`src/services/auth/**\` | @mobile-leads |
| \`src/config/**\` | @mobile-leads |
| \`src/navigation/**\` | @mobile-leads |
| \`src/features/payments/**\` | @mobile-leads |
| \`.github/workflows/**\` | @mobile-leads |
| \`eas.json\` | @mobile-leads |
| \`app.config.ts\` | @mobile-leads |
| \`google-services.json\` | @mobile-leads |
| \`GoogleService-Info.plist\` | @mobile-leads |

### After Merge

- Branch is automatically deleted
- CI triggers EAS Update to the staging channel
- Verify the staging build on physical devices via Expo Updates
- If the change affects push notifications, deep links, or in-app purchases, perform manual QA on both platforms before promoting to production

## Hotfix Process

For critical production issues:

1. Create branch: \`hotfix/APP-XX-brief-description\` from \`main\`
2. Fix the issue with minimal changes
3. Open PR with \`hotfix\` label — expedited review (still requires 1 approval)
4. After merge, immediately trigger production EAS Build:
   \`\`\`bash
   eas build --platform all --profile production
   eas submit --platform all
   \`\`\`
5. For OTA-eligible fixes, use EAS Update for immediate deployment:
   \`\`\`bash
   eas update --branch production --message "hotfix: brief description"
   \`\`\`

## Useful Commands

\`\`\`bash
# Start development server
npx expo start

# Run tests
pnpm test
pnpm test --coverage

# Lint and typecheck
pnpm lint
pnpm typecheck

# Build for staging
eas build --platform all --profile staging

# Build for production
eas build --platform all --profile production

# Deploy OTA update to staging
eas update --branch staging --message "feat: description"

# Submit to stores
eas submit --platform ios
eas submit --platform android

# Run Detox E2E tests
npx detox build --configuration ios.sim.release
npx detox test --configuration ios.sim.release
\`\`\``,

  '.claude/rules/common/security.md': `# Security Rules

## Secure Storage

- Store sensitive data (tokens, credentials, API keys) exclusively in platform secure storage:
  - iOS: Keychain Services via \`expo-secure-store\` or \`react-native-keychain\`
  - Android: Android Keystore via \`expo-secure-store\` or \`react-native-keychain\`
- Never store secrets in AsyncStorage, MMKV, or WatermelonDB — these are not encrypted at rest
- Never log, serialize, or include sensitive values in crash reports or analytics events
- Clear secure storage on user logout and account deletion
- Use biometric-gated access for high-sensitivity operations (payment confirmation, export personal data)

## Authentication & Session Management

- Use Firebase Authentication with short-lived ID tokens (1 hour default)
- Refresh tokens silently using \`onIdTokenChanged\` listener — never store refresh tokens manually
- Enforce re-authentication before sensitive actions (password change, account deletion, payment method update)
- Implement session timeout after 30 minutes of inactivity for sensitive features
- Lock the app behind biometric/PIN challenge when returning from background after timeout

## Network Security

- Enforce HTTPS for all network requests — no exceptions, no HTTP fallbacks
- Implement certificate pinning for Firebase and critical API endpoints:
  - Use \`react-native-ssl-pinning\` or TrustKit for pinning configuration
  - Pin against the intermediate CA certificate, not the leaf
  - Maintain a backup pin for certificate rotation
  - Monitor pin expiration and rotate proactively
- Set appropriate request timeouts (connection: 10s, read: 30s)
- Do not trust user-installed CA certificates in production builds
- Validate all server responses against expected schemas using Zod before processing

## API & Data Validation

- Validate and sanitize all user input on the client before sending to Firebase
- Use Firestore Security Rules as the primary authorization layer — never trust client-side checks alone
- Validate Cloud Function inputs with schema validation (Zod or joi)
- Implement rate limiting in Cloud Functions for authentication and payment endpoints
- Never expose Firebase Admin SDK credentials or service account keys in client code

## Code & Build Security

- Enable ProGuard/R8 for Android release builds to obfuscate code
- Enable Hermes bytecode compilation for additional obfuscation
- Do not ship source maps in production app bundles (upload to Sentry separately)
- Use \`expo-constants\` for environment-specific config — never hardcode environment values
- Keep \`google-services.json\` and \`GoogleService-Info.plist\` out of public repositories
- Store signing keys, provisioning profiles, and keystores in EAS Credentials or a secrets manager — never in the repo
- Pin dependency versions in \`pnpm-lock.yaml\` and audit regularly with \`pnpm audit\`
- Review native module additions for known vulnerabilities before integrating

## Environment & Secrets Management

- Use \`.env.staging\` and \`.env.production\` files locally — never commit them (listed in \`.gitignore\`)
- Inject secrets via EAS Build secrets or GitHub Actions secrets for CI/CD
- Access runtime config through \`expo-constants\` and \`react-native-config\` — never \`process.env\` directly
- Rotate API keys and Firebase credentials on a quarterly schedule or immediately upon suspected compromise
- Maintain separate Firebase projects for staging and production

## GDPR Compliance

- Collect explicit, informed consent before processing personal data — use a consent management screen
- Implement granular consent toggles: analytics, crash reporting, push notifications, personalization
- Persist consent state in Zustand store and sync to Firestore user profile
- Respect consent state throughout the app — gate analytics, crash reporting, and tracking behind consent checks:
  \`\`\`typescript
  // Pattern: check consent before tracking
  if (consentStore.getState().analyticsConsented) {
    analytics().logEvent('screen_view', { screen_name: screenName });
  }
  \`\`\`
- Implement data export (right of access) via a Cloud Function that compiles all user data into a downloadable format
- Implement account deletion (right to erasure) that removes:
  - Firebase Auth account
  - Firestore user document and all subcollections
  - Firebase Storage user files
  - WatermelonDB local data
  - Secure storage entries
  - Analytics user properties (call \`analytics().resetAnalyticsData()\`)
- Log all data processing activities for audit purposes
- Display privacy policy and terms of service with version tracking — require re-acceptance on material changes
- Set data retention policies in Firestore TTL and Cloud Functions scheduled cleanup

## App Store Privacy

- Maintain accurate iOS App Privacy labels (App Store Connect) reflecting all data collection
- Maintain accurate Google Play Data Safety section reflecting all data types and purposes
- Update privacy declarations whenever adding new SDKs, analytics events, or data collection
- Use App Tracking Transparency (ATT) on iOS before any cross-app tracking
- Declare NSUserTrackingUsageDescription in \`app.json\` Info.plist config
- Provide a functioning "Delete My Account" flow — required by both App Store and Google Play

## Deep Linking Security

- Validate all deep link parameters before navigation — treat them as untrusted input
- Use Universal Links (iOS) and App Links (Android) with domain verification over custom URI schemes
- Never pass authentication tokens, secrets, or PII through deep link URLs
- Sanitize deep link destinations to prevent open redirect attacks — whitelist allowed routes

## Sensitive File Protections

These paths require senior/lead review for any changes:
- \`src/services/auth/**\` — authentication logic
- \`src/services/payments/**\` — in-app purchase logic
- \`src/config/**\` — environment and Firebase configuration
- \`google-services.json\` — Android Firebase config
- \`GoogleService-Info.plist\` — iOS Firebase config
- \`.env*\` — environment variables
- \`firestore.rules\` — Firestore security rules
- \`storage.rules\` — Firebase Storage security rules
- \`functions/src/**\` — Cloud Functions (server-side logic)

## Security Review Checklist

Before merging any PR touching security-sensitive code:
- [ ] No secrets, tokens, or API keys in source code or logs
- [ ] Sensitive data stored only in Keychain/Keystore via secure storage APIs
- [ ] All network calls use HTTPS with certificate pinning where applicable
- [ ] User input validated on client and server (Firestore rules / Cloud Functions)
- [ ] GDPR consent checked before analytics/tracking calls
- [ ] Deep link parameters validated and sanitized
- [ ] No new permissions requested without documented justification
- [ ] Privacy labels (iOS) and Data Safety (Android) updated if data collection changed
- [ ] Crash reports and logs verified to not contain PII`,

  '.claude/rules/common/testing.md': `# Testing Standards

## Testing Stack

- **Unit/Component Tests**: Jest + React Native Testing Library (RNTL)
- **E2E Tests**: Detox (iOS Simulator + Android Emulator)
- **Coverage Tool**: Jest with \`--coverage\` flag
- **Mocking**: Jest mocks + MSW for network requests
- **Snapshot Testing**: Discouraged — prefer explicit assertions

## Coverage Thresholds

Enforced in \`jest.config.ts\`:

\`\`\`
Global minimum: 75%
- Branches: 75%
- Functions: 75%
- Lines: 75%
- Statements: 75%
\`\`\`

Sensitive paths require higher coverage:
- \`src/services/auth/**\` → 90% minimum
- \`src/features/payments/**\` → 90% minimum
- \`src/store/**\` → 85% minimum
- \`src/utils/**\` → 85% minimum

## File Organization

Test files live alongside source files with \`.test.ts\` or \`.test.tsx\` suffix:

\`\`\`
src/features/auth/
  screens/
    LoginScreen.tsx
    LoginScreen.test.tsx
  hooks/
    use-login.ts
    use-login.test.ts
  components/
    BiometricPrompt.tsx
    BiometricPrompt.test.tsx
\`\`\`

E2E tests live in the \`e2e/\` directory:

\`\`\`
e2e/
  auth.e2e.ts
  home.e2e.ts
  payments.e2e.ts
  utils/
    test-helpers.ts
\`\`\`

## Unit Test Patterns

### Hooks

Test hooks with \`renderHook\` from RNTL. Wrap with necessary providers:

\`\`\`typescript
import { renderHook, waitFor } from '@testing-library/react-native';
import { createTestWrapper } from '@/test-utils/wrapper';
import { useLogin } from './use-login';

describe('useLogin', () => {
  it('sets loading state during authentication', async () => {
    const { result } = renderHook(() => useLogin(), {
      wrapper: createTestWrapper(),
    });

    act(() => {
      result.current.login({ email: 'user@test.com', password: 'secure123' });
    });

    expect(result.current.isLoading).toBe(true);

    await waitFor(() => {
      expect(result.current.isLoading).toBe(false);
    });
  });
});
\`\`\`

### Zustand Stores

Reset store state between tests. Never test internal implementation — test through the public API:

\`\`\`typescript
import { useAuthStore } from './auth-store';

beforeEach(() => {
  useAuthStore.getState().reset();
});

describe('useAuthStore', () => {
  it('updates user on successful login', () => {
    const { setUser } = useAuthStore.getState();
    setUser({ id: '1', email: 'user@test.com', displayName: 'Test User' });

    expect(useAuthStore.getState().user?.email).toBe('user@test.com');
  });
});
\`\`\`

### Utility Functions

Pure functions get straightforward unit tests:

\`\`\`typescript
import { formatCurrency, validateEmail } from './formatting';

describe('formatCurrency', () => {
  it('formats USD amounts correctly', () => {
    expect(formatCurrency(9.99, 'USD')).toBe('$9.99');
  });

  it('handles zero amounts', () => {
    expect(formatCurrency(0, 'USD')).toBe('$0.00');
  });
});
\`\`\`

## Component Test Patterns

### Rendering and Assertions

Use RNTL queries. Prefer \`getByRole\`, \`getByLabelText\`, \`getByText\` over \`getByTestId\`. Test what the user sees, not implementation details:

\`\`\`typescript
import { render, screen, fireEvent, waitFor } from '@testing-library/react-native';
import { createTestWrapper } from '@/test-utils/wrapper';
import { LoginScreen } from './LoginScreen';

describe('LoginScreen', () => {
  it('renders email and password fields', () => {
    render(<LoginScreen />, { wrapper: createTestWrapper() });

    expect(screen.getByLabelText('Email address')).toBeOnTheScreen();
    expect(screen.getByLabelText('Password')).toBeOnTheScreen();
    expect(screen.getByRole('button', { name: 'Sign in' })).toBeOnTheScreen();
  });

  it('shows validation error for invalid email', async () => {
    render(<LoginScreen />, { wrapper: createTestWrapper() });

    fireEvent.changeText(screen.getByLabelText('Email address'), 'not-an-email');
    fireEvent.press(screen.getByRole('button', { name: 'Sign in' }));

    await waitFor(() => {
      expect(screen.getByText('Please enter a valid email')).toBeOnTheScreen();
    });
  });

  it('disables submit button while loading', async () => {
    render(<LoginScreen />, { wrapper: createTestWrapper() });

    fireEvent.changeText(screen.getByLabelText('Email address'), 'user@test.com');
    fireEvent.changeText(screen.getByLabelText('Password'), 'password123');
    fireEvent.press(screen.getByRole('button', { name: 'Sign in' }));

    await waitFor(() => {
      expect(screen.getByRole('button', { name: 'Sign in' })).toBeDisabled();
    });
  });
});
\`\`\`

### Accessibility Testing

Every interactive element must have an accessibility label. Test for it:

\`\`\`typescript
it('has accessible labels on all interactive elements', () => {
  render(<PaymentForm />, { wrapper: createTestWrapper() });

  expect(screen.getByRole('button', { name: 'Complete purchase' })).toBeOnTheScreen();
  expect(screen.getByLabelText('Card number')).toBeOnTheScreen();
  expect(screen.getByLabelText('Expiration date')).toBeOnTheScreen();
});
\`\`\`

### Navigation Testing

Mock React Navigation hooks. Test that navigation calls happen with correct params:

\`\`\`typescript
const mockNavigate = jest.fn();
jest.mock('@react-navigation/native', () => ({
  ...jest.requireActual('@react-navigation/native'),
  useNavigation: () => ({ navigate: mockNavigate }),
}));

it('navigates to profile on avatar press', () => {
  render(<HomeHeader />, { wrapper: createTestWrapper() });

  fireEvent.press(screen.getByLabelText('Open profile'));

  expect(mockNavigate).toHaveBeenCalledWith('Profile', { tab: 'settings' });
});
\`\`\`

## React Query Testing

Wrap components with a test \`QueryClientProvider\`. Use \`waitFor\` for async state:

\`\`\`typescript
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

function createTestQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: false, gcTime: 0 },
      mutations: { retry: false },
    },
  });
}

export function createTestWrapper() {
  const queryClient = createTestQueryClient();
  return function Wrapper({ children }: { children: React.ReactNode }) {
    return (
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    );
  };
}
\`\`\`

## Mocking Guidelines

### Firebase Services

Create centralized mocks in \`src/test-utils/mocks/\`:

\`\`\`typescript
// src/test-utils/mocks/firebase-auth.ts
export const mockFirebaseAuth = {
  signInWithEmailAndPassword: jest.fn(),
  signOut: jest.fn(),
  onAuthStateChanged: jest.fn(),
  currentUser: null,
};

jest.mock('@/services/firebase/auth', () => mockFirebaseAuth);
\`\`\`

### Native Modules

Mock native modules in \`jest.setup.ts\`:

\`\`\`typescript
jest.mock('react-native/Libraries/Animated/NativeAnimatedHelper');
jest.mock('@react-native-async-storage/async-storage', () =>
  require('@react-native-async-storage/async-storage/jest/async-storage-mock'),
);
jest.mock('react-native-keychain', () => ({
  setGenericPassword: jest.fn().mockResolvedValue(true),
  getGenericPassword: jest.fn().mockResolvedValue({ username: 'user', password: 'token' }),
  resetGenericPassword: jest.fn().mockResolvedValue(true),
}));
\`\`\`

### WatermelonDB

Mock the database layer, not the ORM:

\`\`\`typescript
jest.mock('@/services/database', () => ({
  database: {
    get: jest.fn().mockReturnValue({
      query: jest.fn().mockReturnValue({ observe: jest.fn() }),
      find: jest.fn(),
      create: jest.fn(),
    }),
  },
}));
\`\`\`

### Platform-Specific Behavior

Test both platforms when behavior diverges:

\`\`\`typescript
import { Platform } from 'react-native';

describe('BiometricPrompt', () => {
  it('shows Face ID prompt on iOS', () => {
    Platform.OS = 'ios';
    render(<BiometricPrompt />, { wrapper: createTestWrapper() });
    expect(screen.getByText('Authenticate with Face ID')).toBeOnTheScreen();
  });

  it('shows fingerprint prompt on Android', () => {
    Platform.OS = 'android';
    render(<BiometricPrompt />, { wrapper: createTestWrapper() });
    expect(screen.getByText('Authenticate with fingerprint')).toBeOnTheScreen();
  });
});
\`\`\`

## Detox E2E Testing

### Setup

E2E tests run against debug builds on simulators/emulators. Configure in \`.detoxrc.js\`:

\`\`\`
pnpm detox:build:ios    # Build iOS test app
pnpm detox:build:android # Build Android test app
pnpm detox:test:ios     # Run iOS E2E suite
pnpm detox:test:android # Run Android E2E suite
\`\`\`

### E2E Test Structure

Each E2E file covers a user journey, not individual screens:

\`\`\`typescript
// e2e/auth.e2e.ts
describe('Authentication Flow', () => {
  beforeAll(async () => {
    await device.launchApp({ newInstance: true });
  });

  beforeEach(async () => {
    await device.reloadReactNative();
  });

  it('should complete full login flow', async () => {
    await element(by.label('Email address')).typeText('test@example.com');
    await element(by.label('Password')).typeText('password123');
    await element(by.label('Sign in')).tap();

    await waitFor(element(by.text('Welcome back')))
      .toBeVisible()
      .withTimeout(5000);
  });

  it('should show error for invalid credentials', async () => {
    await element(by.label('Email address')).typeText('wrong@example.com');
    await element(by.label('Password')).typeText('wrongpassword');
    await element(by.label('Sign in')).tap();

    await waitFor(element(by.text('Invalid email or password')))
      .toBeVisible()
      .withTimeout(5000);
  });

  it('should navigate to registration', async () => {
    await element(by.text('Create an account')).tap();

    await waitFor(element(by.text('Sign up')))
      .toBeVisible()
      .withTimeout(3000);
  });
});
\`\`\`

### E2E Best Practices

- Use \`testID\` props only when accessibility labels are insufficient for disambiguation
- Always use \`waitFor\` with timeouts for async operations — never use \`sleep\`
- Reset app state in \`beforeEach\` with \`device.reloadReactNative()\` or \`device.launchApp({ delete: true })\`
- Use a dedicated test Firebase project with seeded data
- Keep E2E tests focused on critical user journeys: auth, core feature flows, payments
- Tag E2E tests by priority: \`@critical\`, \`@smoke\`, \`@regression\`

### E2E in CI

Detox E2E runs in GitHub Actions after successful EAS builds:

\`\`\`
Lint → Type Check → Unit Tests → EAS Build → Detox E2E → Deploy Staging
\`\`\`

Only \`@critical\` and \`@smoke\` tests run on every PR. Full \`@regression\` suite runs nightly.

## What to Test

### Always Test

- User-facing behavior (what renders, what happens on interaction)
- Form validation logic
- Navigation flows between screens
- Error states and error boundaries
- Loading states
- Offline behavior (WatermelonDB queries, sync conflicts)
- Authentication state transitions
- Payment flows and edge cases
- Deep link resolution
- Accessibility labels and roles

### Never Test

- Implementation details (internal state shape, private methods)
- Third-party library internals (Firebase SDK, React Navigation internals)
- Styles or visual layout (use visual regression tools separately if needed)
- Platform-provided UI (native alerts, share sheets)
- Generated code or type definitions

## Test Commands

\`\`\`bash
pnpm test                    # Run all unit/component tests
pnpm test --watch            # Watch mode during development
pnpm test --coverage         # Generate coverage report
pnpm test --changedSince=main # Test only changed files (CI optimization)
pnpm test:e2e:ios            # Run Detox E2E on iOS Simulator
pnpm test:e2e:android        # Run Detox E2E on Android Emulator
\`\`\`

## CI Test Pipeline

1. **Lint + Type Check**: \`pnpm lint && pnpm typecheck\` — fast fail on syntax/type errors
2. **Unit + Component Tests**: \`pnpm test --coverage --changedSince=main\` — coverage gate at 75%
3. **EAS Build**: Build iOS and Android test apps via \`eas build --profile preview\`
4. **Detox E2E**: Run \`@smoke\` suite against built apps
5. **Coverage Report**: Post coverage diff as PR comment

Tests must pass before merge. No exceptions. Flaky tests get quarantined with \`it.skip\` and a linked GitHub Issue tagged \`flaky-test\`.

## AI-Generated Test Code

When Claude generates tests, mark them with the \`// AI-generated\` comment at the top of the file. Reviewers should verify:

- Tests actually assert meaningful behavior, not just that code runs without throwing
- Mocks are realistic and match actual service interfaces
- Edge cases are covered (empty states, error responses, network failures, platform differences)
- No snapshot tests unless explicitly requested and justified`,

  '.claude/rules/typescript/coding-style.md': `# TypeScript & React Native Coding Style

## TypeScript Strict Mode

All code must compile under \`strict: true\` with zero errors. The following compiler options are enforced:

\`\`\`
strict: true
noUncheckedIndexedAccess: true
noImplicitReturns: true
noFallthroughCasesInSwitch: true
exactOptionalPropertyTypes: true
\`\`\`

Never use \`any\`. Use \`unknown\` when the type is genuinely unknown, then narrow with type guards. Prefer explicit return types on exported functions and public methods. Inferred types are acceptable for local variables and private helpers where the type is obvious.

\`\`\`typescript
// Correct
function parseApiResponse(data: unknown): UserProfile {
  if (!isUserProfile(data)) {
    throw new ParseError('Invalid user profile data');
  }
  return data;
}

// Wrong — never do this
function parseApiResponse(data: any): any { ... }
\`\`\`

Use \`as const\` assertions for literal objects and arrays that should not be widened. Prefer \`satisfies\` over \`as\` for type checking without widening.

\`\`\`typescript
const ROUTES = {
  HOME: 'Home',
  PROFILE: 'Profile',
  SETTINGS: 'Settings',
} as const;

const defaultTheme = {
  primary: '#007AFF',
  background: '#FFFFFF',
} satisfies Record<string, string>;
\`\`\`

## Naming Conventions

| Construct | Convention | Example |
|---|---|---|
| Components / Screens | PascalCase | \`ProfileScreen\`, \`AvatarCard\` |
| Hooks | camelCase with \`use\` prefix | \`useAuth\`, \`useOfflineSync\` |
| Utility functions | camelCase | \`formatCurrency\`, \`validateEmail\` |
| Constants | SCREAMING_SNAKE_CASE | \`MAX_RETRY_COUNT\`, \`API_TIMEOUT_MS\` |
| Types / Interfaces | PascalCase | \`UserProfile\`, \`NavigationParams\` |
| Enums | PascalCase (members too) | \`AuthStatus.Authenticated\` |
| Files | kebab-case | \`profile-screen.tsx\`, \`use-auth.ts\` |
| Test files | kebab-case with \`.test\` | \`profile-screen.test.tsx\` |
| Platform-specific files | kebab-case with platform | \`haptic-feedback.ios.ts\`, \`haptic-feedback.android.ts\` |

Prefix interfaces for props with the component name:

\`\`\`typescript
interface ProfileScreenProps {
  userId: string;
  onBack: () => void;
}
\`\`\`

Do not prefix interfaces with \`I\` or types with \`T\`. Use \`Props\` suffix for component props, \`Params\` suffix for navigation params, \`State\` suffix for Zustand store state.

## Component Patterns

### Functional Components Only

Use arrow function components with explicit typing. Never use class components.

\`\`\`typescript
import { type FC } from 'react';

interface AvatarCardProps {
  imageUri: string;
  name: string;
  size?: 'small' | 'medium' | 'large';
  onPress?: () => void;
}

export const AvatarCard: FC<AvatarCardProps> = ({
  imageUri,
  name,
  size = 'medium',
  onPress,
}) => {
  return (
    <Pressable
      onPress={onPress}
      accessibilityLabel={t('avatar.label', { name })}
      accessibilityRole="button"
    >
      <Image source={{ uri: imageUri }} style={styles[size]} />
      <Text style={styles.name}>{name}</Text>
    </Pressable>
  );
};
\`\`\`

For screens that receive navigation props, type them with the navigator's param list:

\`\`\`typescript
import { type NativeStackScreenProps } from '@react-navigation/native-stack';
import { type RootStackParamList } from '@/navigation/types';

type ProfileScreenProps = NativeStackScreenProps<RootStackParamList, 'Profile'>;

export const ProfileScreen: FC<ProfileScreenProps> = ({ route, navigation }) => {
  const { userId } = route.params;
  // ...
};
\`\`\`

### Component File Structure

Each component file follows this order:

1. Imports (external, then internal with \`@/\` alias)
2. Type definitions (props, local types)
3. Component definition (exported)
4. Styles (using \`StyleSheet.create\`)

\`\`\`typescript
// 1. Imports
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { type FC, useCallback } from 'react';

import { useTheme } from '@/hooks/use-theme';
import { type ThemeColors } from '@/theme/types';

// 2. Types
interface ActionButtonProps {
  label: string;
  variant: 'primary' | 'secondary';
  disabled?: boolean;
  onPress: () => void;
}

// 3. Component
export const ActionButton: FC<ActionButtonProps> = ({
  label,
  variant,
  disabled = false,
  onPress,
}) => {
  const { colors } = useTheme();
  const dynamicStyles = createStyles(colors);

  const handlePress = useCallback(() => {
    if (!disabled) {
      onPress();
    }
  }, [disabled, onPress]);

  return (
    <Pressable
      style={[dynamicStyles.container, dynamicStyles[variant]]}
      onPress={handlePress}
      disabled={disabled}
      accessibilityLabel={label}
      accessibilityRole="button"
      accessibilityState={{ disabled }}
    >
      <Text style={dynamicStyles.label}>{label}</Text>
    </Pressable>
  );
};

// 4. Styles
const createStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      borderRadius: 8,
      paddingHorizontal: 16,
      paddingVertical: 12,
      alignItems: 'center',
    },
    primary: {
      backgroundColor: colors.primary,
    },
    secondary: {
      backgroundColor: colors.secondaryBackground,
      borderWidth: 1,
      borderColor: colors.border,
    },
    label: {
      fontSize: 16,
      fontWeight: '600',
      color: colors.text,
    },
  });
\`\`\`

### Max File Length

Components must stay under 250 lines. If a component exceeds this, extract sub-components, custom hooks, or utility functions. Screens that orchestrate multiple components should delegate rendering to child components and keep orchestration logic in hooks.

### Colocation

Keep feature-specific code together:

\`\`\`
src/features/profile/
  screens/
    profile-screen.tsx
    edit-profile-screen.tsx
  components/
    avatar-card.tsx
    stats-row.tsx
  hooks/
    use-profile.ts
    use-update-profile.ts
  types/
    index.ts
\`\`\`

Shared components go in \`src/components/\`, shared hooks in \`src/hooks/\`.

## Hooks Conventions

### Custom Hook Structure

Custom hooks must have explicit return types. Prefix all hooks with \`use\`.

\`\`\`typescript
import { useQuery } from '@tanstack/react-query';

import { fetchUserProfile } from '@/services/firebase/users';
import { type UserProfile } from '@/features/profile/types';

interface UseProfileResult {
  profile: UserProfile | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export function useProfile(userId: string): UseProfileResult {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['profile', userId],
    queryFn: () => fetchUserProfile(userId),
    staleTime: 5 * 60 * 1000,
  });

  return {
    profile: data,
    isLoading,
    isError,
    refetch,
  };
}
\`\`\`

### Server State vs Client State

Use React Query (TanStack Query) for all server/remote state — Firebase data, API responses, user profiles. Use Zustand for client-only state — UI preferences, theme, navigation state, form drafts.

Never mix the two. Do not put server data in Zustand stores. Do not use React Query for purely local state.

\`\`\`typescript
// Zustand — client state only
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';

interface ThemeState {
  mode: 'light' | 'dark' | 'system';
  setMode: (mode: ThemeState['mode']) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: 'system',
      setMode: (mode) => set({ mode }),
    }),
    {
      name: 'theme-storage',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
\`\`\`

### Hook Dependencies

Always specify complete dependency arrays. Use \`useCallback\` for functions passed as props or used in dependency arrays. Use \`useMemo\` only when there is a measurable performance benefit — do not prematurely optimize.

\`\`\`typescript
// Correct — stable callback reference
const handleSubmit = useCallback(async () => {
  await updateProfile(formData);
  navigation.goBack();
}, [formData, navigation, updateProfile]);

// Wrong — unstable reference causes re-renders
const handleSubmit = async () => {
  await updateProfile(formData);
  navigation.goBack();
};
\`\`\`

## Platform-Specific Code

### Platform Files

For significant platform differences, use platform-specific file extensions. React Native's module resolution picks the correct file automatically.

\`\`\`
src/services/biometrics/
  biometric-auth.ts          # Shared types and interface
  biometric-auth.ios.ts      # iOS Face ID / Touch ID implementation
  biometric-auth.android.ts  # Android BiometricPrompt implementation
\`\`\`

The shared types file defines the contract:

\`\`\`typescript
// biometric-auth.ts
export interface BiometricAuthResult {
  success: boolean;
  biometryType: 'faceId' | 'fingerprint' | 'iris' | 'none';
  error?: string;
}

export interface BiometricAuthService {
  isAvailable: () => Promise<boolean>;
  authenticate: (reason: string) => Promise<BiometricAuthResult>;
}
\`\`\`

### Inline Platform Checks

For minor differences (a padding value, a shadow style), use \`Platform.select\` or \`Platform.OS\`:

\`\`\`typescript
import { Platform, StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  shadow: Platform.select({
    ios: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.1,
      shadowRadius: 4,
    },
    android: {
      elevation: 4,
    },
    default: {},
  }),
  statusBarPadding: {
    paddingTop: Platform.OS === 'ios' ? 44 : 0,
  },
});
\`\`\`

Do not scatter \`Platform.OS\` checks throughout business logic. Isolate platform differences in service layers or utility functions.

### Safe Area Handling

Always use \`react-native-safe-area-context\` for safe area insets. Never hardcode status bar heights or notch dimensions.

\`\`\`typescript
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const Header: FC<HeaderProps> = ({ title }) => {
  const insets = useSafeAreaInsets();

  return (
    <View style={[styles.header, { paddingTop: insets.top }]}>
      <Text style={styles.title}>{title}</Text>
    </View>
  );
};
\`\`\`

## Type Safety Patterns

### Navigation Typing

Define all navigation params in a central type file. Never use untyped navigation.

\`\`\`typescript
// src/navigation/types.ts
export type RootStackParamList = {
  Home: undefined;
  Profile: { userId: string };
  Settings: undefined;
  PostDetail: { postId: string; commentId?: string };
};

export type AuthStackParamList = {
  Login: undefined;
  Register: { referralCode?: string };
  ForgotPassword: { email?: string };
};

// Typed useNavigation hook
declare global {
  namespace ReactNavigation {
    interface RootParamList extends RootStackParamList {}
  }
}
\`\`\`

### API Response Typing

Use Zod schemas for runtime validation of external data (Firebase responses, API calls). Define the schema once and derive the TypeScript type from it.

\`\`\`typescript
import { z } from 'zod';

export const userProfileSchema = z.object({
  id: z.string(),
  displayName: z.string().min(1),
  email: z.string().email(),
  avatarUrl: z.string().url().nullable(),
  createdAt: z.coerce.date(),
  preferences: z.object({
    notifications: z.boolean(),
    theme: z.enum(['light', 'dark', 'system']),
  }),
});

export type UserProfile = z.infer<typeof userProfileSchema>;

export function parseUserProfile(data: unknown): UserProfile {
  return userProfileSchema.parse(data);
}
\`\`\`

### Discriminated Unions for State

Model async states and complex state machines with discriminated unions, not boolean flags.

\`\`\`typescript
// Correct
type AuthState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'authenticated'; user: User }
  | { status: 'unauthenticated' }
  | { status: 'error'; error: AppError };

// Wrong — ambiguous combinations
interface AuthState {
  isLoading: boolean;
  isAuthenticated: boolean;
  user: User | null;
  error: Error | null;
}
\`\`\`

### Exhaustive Checks

Use \`never\` to enforce exhaustive switch statements:

\`\`\`typescript
function getAuthMessage(state: AuthState): string {
  switch (state.status) {
    case 'idle':
      return '';
    case 'loading':
      return t('auth.loading');
    case 'authenticated':
      return t('auth.welcome', { name: state.user.displayName });
    case 'unauthenticated':
      return t('auth.signInPrompt');
    case 'error':
      return state.error.userMessage;
    default: {
      const _exhaustive: never = state;
      return _exhaustive;
    }
  }
}
\`\`\`

## Import Organization

Order imports in this sequence, separated by blank lines:

1. React and React Native core
2. Third-party libraries
3. Internal aliases (\`@/\`) — navigation, services, stores
4. Relative imports (sibling components, local types)

\`\`\`typescript
import { useCallback, useEffect, useState } from 'react';
import { ScrollView, View } from 'react-native';

import { useQuery } from '@tanstack/react-query';
import { type NativeStackScreenProps } from '@react-navigation/native-stack';

import { useAuth } from '@/hooks/use-auth';
import { analyticsService } from '@/services/analytics';
import { type RootStackParamList } from '@/navigation/types';

import { ProfileHeader } from '../components/profile-header';
import { type ProfileTabType } from '../types';
\`\`\`

Use \`type\` imports for types that are erased at compile time:

\`\`\`typescript
import { type FC } from 'react';
import { type UserProfile } from '@/features/profile/types';
\`\`\`

## Error Handling

Define typed error classes for different failure domains. Never throw raw strings or untyped Error objects.

\`\`\`typescript
export class AppError extends Error {
  constructor(
    message: string,
    public readonly code: string,
    public readonly userMessage: string,
    public readonly recoverable: boolean = true,
  ) {
    super(message);
    this.name = 'AppError';
  }
}

export class NetworkError extends AppError {
  constructor(message: string) {
    super(message, 'NETWORK_ERROR', t('errors.network'), true);
    this.name = 'NetworkError';
  }
}

export class AuthError extends AppError {
  constructor(message: string, code: string) {
    super(message, code, t('errors.auth'), false);
    this.name = 'AuthError';
  }
}
\`\`\`

Use React Query's error boundaries and \`onError\` callbacks for server state errors. Use React error boundaries for render errors. Log all errors to Sentry with context.

## Accessibility

Every interactive element must have an \`accessibilityLabel\`. Every screen must set \`accessibilityRole\` on its primary container. Use \`accessibilityState\` for dynamic states (disabled, selected, checked). Test with VoiceOver (iOS) and TalkBack (Android) before merging.

\`\`\`typescript
<Pressable
  onPress={handleToggle}
  accessibilityLabel={t('settings.darkMode')}
  accessibilityRole="switch"
  accessibilityState={{ checked: isDarkMode }}
>
\`\`\`

## Internationalization

All user-facing strings must go through the i18n system. Never hardcode display text in components. Use the \`t()\` function with typed keys.

\`\`\`typescript
// Correct
<Text>{t('profile.greeting', { name: user.displayName })}</Text>

// Wrong
<Text>Hello, {user.displayName}!</Text>
\`\`\`

## Style Rules

Use \`StyleSheet.create\` for static styles. Use dynamic style functions (accepting theme tokens) when styles depend on theme. Never use inline style objects — they create new references on every render.

\`\`\`typescript
// Correct — static styles
const styles = StyleSheet.create({
  container: { flex: 1, padding: 16 },
});

// Correct — theme-dependent styles
const createStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: { flex: 1, backgroundColor: colors.background },
  });

// Wrong — inline object
<View style={{ flex: 1, padding: 16 }} />
\`\`\`

Use spacing and typography tokens from \`@/theme/\` rather than magic numbers. Reference \`spacing.md\`, \`spacing.lg\` instead of \`8\`, \`16\`.`,

  '.claude/rules/typescript/testing.md': `# TypeScript/React Native Testing Standards

## Jest Configuration for React Native

### Native Module Mocking

Always mock native modules in \`jest.setup.ts\` — never let tests hit real native bridges:

\`\`\`typescript
// jest.setup.ts — required mocks for every test suite
jest.mock('react-native/Libraries/Animated/NativeAnimatedHelper');
jest.mock('react-native/Libraries/EventEmitter/NativeEventEmitter');

jest.mock('@react-native-async-storage/async-storage', () =>
  require('@react-native-async-storage/async-storage/jest/async-storage-mock'),
);

jest.mock('react-native-keychain', () => ({
  setGenericPassword: jest.fn().mockResolvedValue(true),
  getGenericPassword: jest.fn().mockResolvedValue({ username: 'user', password: 'token' }),
  resetGenericPassword: jest.fn().mockResolvedValue(true),
  BIOMETRY_TYPE: { TOUCH_ID: 'TouchID', FACE_ID: 'FaceID', FINGERPRINT: 'Fingerprint' },
}));

jest.mock('expo-local-authentication', () => ({
  authenticateAsync: jest.fn().mockResolvedValue({ success: true }),
  hasHardwareAsync: jest.fn().mockResolvedValue(true),
  isEnrolledAsync: jest.fn().mockResolvedValue(true),
  AuthenticationType: { FINGERPRINT: 1, FACIAL_RECOGNITION: 2 },
}));

jest.mock('expo-notifications', () => ({
  getPermissionsAsync: jest.fn().mockResolvedValue({ status: 'granted' }),
  requestPermissionsAsync: jest.fn().mockResolvedValue({ status: 'granted' }),
  getExpoPushTokenAsync: jest.fn().mockResolvedValue({ data: 'ExponentPushToken[mock]' }),
  setNotificationHandler: jest.fn(),
  addNotificationReceivedListener: jest.fn(() => ({ remove: jest.fn() })),
  addNotificationResponseReceivedListener: jest.fn(() => ({ remove: jest.fn() })),
}));

jest.mock('@react-native-firebase/auth', () => () => ({
  signInWithEmailAndPassword: jest.fn(),
  createUserWithEmailAndPassword: jest.fn(),
  signOut: jest.fn(),
  currentUser: null,
  onAuthStateChanged: jest.fn(() => jest.fn()),
}));

jest.mock('@react-native-firebase/firestore', () => () => ({
  collection: jest.fn().mockReturnThis(),
  doc: jest.fn().mockReturnThis(),
  get: jest.fn().mockResolvedValue({ exists: true, data: () => ({}) }),
  set: jest.fn().mockResolvedValue(undefined),
  onSnapshot: jest.fn(() => jest.fn()),
}));

jest.mock('@react-native-firebase/crashlytics', () => () => ({
  log: jest.fn(),
  recordError: jest.fn(),
  setCrashlyticsCollectionEnabled: jest.fn(),
}));
\`\`\`

### Mock File Pattern

Place mocks adjacent to the module or in \`__mocks__/\` at the project root:

\`\`\`
__mocks__/
  @react-native-firebase/
    auth.ts
    firestore.ts
  @nozbe/
    watermelondb.ts
src/
  services/
    __mocks__/
      analytics.ts
      push-notifications.ts
\`\`\`

### Creating Typed Mocks

Use \`jest.mocked()\` for type-safe mock access — never cast with \`as any\`:

\`\`\`typescript
import { authenticateAsync } from 'expo-local-authentication';

const mockAuthenticate = jest.mocked(authenticateAsync);

beforeEach(() => {
  mockAuthenticate.mockResolvedValue({ success: true });
});

it('handles biometric failure', async () => {
  mockAuthenticate.mockResolvedValueOnce({ success: false, error: 'user_cancel' });
  // test the failure path
});
\`\`\`

## React Native Testing Library (RNTL)

### Query Priority

Follow this strict priority order for selecting elements. Prefer queries that reflect how users interact with the app:

1. \`getByRole\` / \`getByLabelText\` — accessibility-first, matches real user interaction
2. \`getByText\` / \`getByDisplayValue\` — visible text content
3. \`getByPlaceholderText\` — form inputs when no label exists
4. \`getByTestId\` — last resort only, for elements with no accessible name

\`\`\`typescript
// CORRECT — queries by accessibility role and label
const submitButton = screen.getByRole('button', { name: /submit/i });
const emailInput = screen.getByLabelText(/email address/i);

// ACCEPTABLE — visible text
const heading = screen.getByText(/welcome back/i);

// LAST RESORT — testID
const animatedContainer = screen.getByTestId('onboarding-animation');
\`\`\`

### Required \`testID\` Convention

When \`testID\` is necessary, use kebab-case with feature prefix:

\`\`\`typescript
// Pattern: {feature}-{component}-{element}
testID="auth-login-submit-button"
testID="profile-avatar-image"
testID="home-feed-list"
\`\`\`

### Rendering Components with Providers

Create a shared \`renderWithProviders\` utility — every component test must use it:

\`\`\`typescript
// src/test-utils/render.tsx
import { render, type RenderOptions } from '@testing-library/react-native';
import { NavigationContainer } from '@react-navigation/native';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import type { ReactElement } from 'react';

interface ExtendedRenderOptions extends RenderOptions {
  initialRoute?: string;
  queryClient?: QueryClient;
}

export function renderWithProviders(
  ui: ReactElement,
  options: ExtendedRenderOptions = {},
) {
  const {
    queryClient = new QueryClient({
      defaultOptions: { queries: { retry: false, gcTime: 0 } },
    }),
    ...renderOptions
  } = options;

  function Wrapper({ children }: { children: ReactElement }) {
    return (
      <SafeAreaProvider>
        <QueryClientProvider client={queryClient}>
          <NavigationContainer>
            {children}
          </NavigationContainer>
        </QueryClientProvider>
      </SafeAreaProvider>
    );
  }

  return {
    ...render(ui, { wrapper: Wrapper, ...renderOptions }),
    queryClient,
  };
}

export { screen, waitFor, fireEvent, act } from '@testing-library/react-native';
\`\`\`

### Async Operations

Always use \`waitFor\` or \`findBy*\` for async state changes — never use arbitrary delays:

\`\`\`typescript
// CORRECT
it('shows user profile after loading', async () => {
  renderWithProviders(<ProfileScreen />);

  // findBy* waits automatically
  expect(await screen.findByText(/john doe/i)).toBeOnTheScreen();
  expect(screen.queryByTestId('profile-skeleton')).not.toBeOnTheScreen();
});

// CORRECT — waitFor for state transitions
it('displays error on failed login', async () => {
  mockSignIn.mockRejectedValueOnce(new Error('Invalid credentials'));
  renderWithProviders(<LoginScreen />);

  fireEvent.changeText(screen.getByLabelText(/email/i), 'bad@email.com');
  fireEvent.changeText(screen.getByLabelText(/password/i), 'wrong');
  fireEvent.press(screen.getByRole('button', { name: /sign in/i }));

  await waitFor(() => {
    expect(screen.getByText(/invalid credentials/i)).toBeOnTheScreen();
  });
});

// WRONG — never use fake timers for async data fetching
await new Promise((r) => setTimeout(r, 1000));
\`\`\`

### Testing Hooks

Use \`renderHook\` from RNTL for custom hook tests:

\`\`\`typescript
import { renderHook, waitFor } from '@testing-library/react-native';
import { useOfflineStatus } from '@/hooks/use-offline-status';

it('detects offline state', async () => {
  const { result } = renderHook(() => useOfflineStatus(), {
    wrapper: Wrapper,
  });

  expect(result.current.isOnline).toBe(true);

  act(() => {
    NetInfo.mockSetConnected(false);
  });

  await waitFor(() => {
    expect(result.current.isOnline).toBe(false);
  });
});
\`\`\`

### Testing Navigation

Test navigation actions by asserting on screen content, not internal navigation state:

\`\`\`typescript
import { createNativeStackNavigator } from '@react-navigation/native-stack';

const Stack = createNativeStackNavigator();

function TestNavigator() {
  return (
    <Stack.Navigator>
      <Stack.Screen name="Login" component={LoginScreen} />
      <Stack.Screen name="Home" component={HomeScreen} />
    </Stack.Navigator>
  );
}

it('navigates to home after successful login', async () => {
  mockSignIn.mockResolvedValueOnce({ user: mockUser });
  renderWithProviders(<TestNavigator />);

  fireEvent.changeText(screen.getByLabelText(/email/i), 'user@test.com');
  fireEvent.changeText(screen.getByLabelText(/password/i), 'password123');
  fireEvent.press(screen.getByRole('button', { name: /sign in/i }));

  // Assert destination screen content — not navigation.navigate call
  expect(await screen.findByText(/welcome home/i)).toBeOnTheScreen();
});
\`\`\`

## Snapshot Testing

### When to Use Snapshots

Use snapshots **only** for shared UI components in \`src/components/\` to catch unintended visual regressions. Do not snapshot screens or feature components — they change too frequently.

\`\`\`typescript
// CORRECT — shared component snapshot
it('renders Button variants correctly', () => {
  const { toJSON } = render(<Button variant="primary" label="Save" />);
  expect(toJSON()).toMatchSnapshot();
});

it('renders Button disabled state', () => {
  const { toJSON } = render(<Button variant="primary" label="Save" disabled />);
  expect(toJSON()).toMatchSnapshot();
});

// WRONG — do not snapshot entire screens
it('renders HomeScreen', () => {
  const { toJSON } = renderWithProviders(<HomeScreen />);
  expect(toJSON()).toMatchSnapshot(); // Fragile, breaks on any content change
});
\`\`\`

### Snapshot Rules

- One snapshot per visual state (default, disabled, loading, error)
- Keep snapshots small — snapshot individual components, not trees
- Review snapshot diffs in PRs carefully; do not blindly update with \`--updateSnapshot\`
- If a snapshot file exceeds 100 lines, the component under test is too large — break it down

## Zustand Store Testing

Test stores by calling actions and asserting state — no mocking of Zustand internals:

\`\`\`typescript
import { useAuthStore } from '@/store/auth-store';

beforeEach(() => {
  useAuthStore.setState({ user: null, isAuthenticated: false });
});

it('sets user on login', () => {
  const { setUser } = useAuthStore.getState();
  setUser({ id: '1', email: 'test@example.com', displayName: 'Test User' });

  const { user, isAuthenticated } = useAuthStore.getState();
  expect(user?.email).toBe('test@example.com');
  expect(isAuthenticated).toBe(true);
});

it('clears user on logout', () => {
  useAuthStore.setState({ user: mockUser, isAuthenticated: true });
  const { logout } = useAuthStore.getState();
  logout();

  expect(useAuthStore.getState().user).toBeNull();
  expect(useAuthStore.getState().isAuthenticated).toBe(false);
});
\`\`\`

## React Query Testing

\`\`\`typescript
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { renderHook, waitFor } from '@testing-library/react-native';
import { useUserProfile } from '@/features/profile/hooks/use-user-profile';

function createTestQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: false, gcTime: 0 },
      mutations: { retry: false },
    },
  });
}

it('fetches user profile', async () => {
  mockFirestore.doc.mockReturnValue({
    get: jest.fn().mockResolvedValue({
      exists: true,
      data: () => ({ displayName: 'Jane', email: 'jane@test.com' }),
    }),
  });

  const queryClient = createTestQueryClient();
  const wrapper = ({ children }: { children: ReactElement }) => (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );

  const { result } = renderHook(() => useUserProfile('user-123'), { wrapper });

  await waitFor(() => expect(result.current.isSuccess).toBe(true));
  expect(result.current.data?.displayName).toBe('Jane');
});
\`\`\`

## WatermelonDB Testing

Mock the database adapter for unit tests; use a real SQLite adapter only in integration tests:

\`\`\`typescript
import { Database } from '@nozbe/watermelondb';
import LokiJSAdapter from '@nozbe/watermelondb/adapters/lokijs';
import { schema } from '@/database/schema';
import { modelClasses } from '@/database/models';

function createTestDatabase(): Database {
  const adapter = new LokiJSAdapter({ schema, useWebWorker: false, useIncrementalIndexedDB: false });
  return new Database({ adapter, modelClasses });
}

it('creates and queries a task', async () => {
  const db = createTestDatabase();
  const tasksCollection = db.get('tasks');

  await db.write(async () => {
    await tasksCollection.create((task) => {
      task.title = 'Test task';
      task.isCompleted = false;
    });
  });

  const tasks = await tasksCollection.query().fetch();
  expect(tasks).toHaveLength(1);
  expect(tasks[0].title).toBe('Test task');
});
\`\`\`

## Detox E2E Testing

### File Structure

\`\`\`
e2e/
  config/
    detox.config.ts        # Detox configuration
  helpers/
    auth.ts                # Login/logout helpers
    navigation.ts          # Tab/screen navigation helpers
    permissions.ts         # System permission handlers
  specs/
    auth/
      login.e2e.ts
      register.e2e.ts
      biometric.e2e.ts
    home/
      feed.e2e.ts
    payments/
      subscription.e2e.ts
  matchers.ts              # Custom Detox matchers
\`\`\`

### Detox Test Patterns

\`\`\`typescript
// e2e/specs/auth/login.e2e.ts
describe('Login Flow', () => {
  beforeAll(async () => {
    await device.launchApp({ newInstance: true, permissions: { notifications: 'YES' } });
  });

  beforeEach(async () => {
    await device.reloadReactNative();
  });

  it('should login with valid credentials', async () => {
    await element(by.id('auth-login-email-input')).typeText('test@example.com');
    await element(by.id('auth-login-password-input')).typeText('Password123!');
    await element(by.id('auth-login-submit-button')).tap();

    await waitFor(element(by.id('home-feed-list')))
      .toBeVisible()
      .withTimeout(5000);
  });

  it('should show error for invalid credentials', async () => {
    await element(by.id('auth-login-email-input')).typeText('wrong@example.com');
    await element(by.id('auth-login-password-input')).typeText('bad');
    await element(by.id('auth-login-submit-button')).tap();

    await waitFor(element(by.text('Invalid email or password')))
      .toBeVisible()
      .withTimeout(3000);
  });
});
\`\`\`

### Detox Helpers

Extract reusable flows into helpers — E2E tests should read like user stories:

\`\`\`typescript
// e2e/helpers/auth.ts
export async function loginAs(email: string, password: string): Promise<void> {
  await element(by.id('auth-login-email-input')).clearText();
  await element(by.id('auth-login-email-input')).typeText(email);
  await element(by.id('auth-login-password-input')).clearText();
  await element(by.id('auth-login-password-input')).typeText(password);
  await element(by.id('auth-login-submit-button')).tap();
  await waitFor(element(by.id('home-feed-list')))
    .toBeVisible()
    .withTimeout(5000);
}

export async function logout(): Promise<void> {
  await element(by.id('tab-bar-profile')).tap();
  await element(by.id('profile-settings-button')).tap();
  await element(by.id('settings-logout-button')).tap();
  await waitFor(element(by.id('auth-login-submit-button')))
    .toBeVisible()
    .withTimeout(3000);
}
\`\`\`

### Detox Rules

- Use \`testID\` props for all Detox selectors — never match by internal component structure
- Always use \`waitFor(...).toBeVisible().withTimeout()\` — never hardcode delays
- Run Detox on CI against release builds (\`eas build --profile staging\`)
- Keep E2E tests focused on critical user paths: auth, core feature, payments
- Detox tests must be independent — each test must not depend on state from another

## Platform-Specific Testing

Test platform branches explicitly:

\`\`\`typescript
import { Platform } from 'react-native';

jest.mock('react-native/Libraries/Utilities/Platform', () => ({
  OS: 'ios',
  select: jest.fn((obj) => obj.ios),
}));

it('uses Keychain on iOS', async () => {
  const result = await secureStore.save('token', 'abc123');
  expect(Keychain.setGenericPassword).toHaveBeenCalled();
});

// Separate test file or describe block for Android
describe('Android', () => {
  beforeAll(() => {
    Platform.OS = 'android';
  });

  it('uses Keystore on Android', async () => {
    const result = await secureStore.save('token', 'abc123');
    expect(Keystore.setItem).toHaveBeenCalled();
  });
});
\`\`\`

## Test File Naming and Placement

Tests live next to the code they test:

\`\`\`
src/features/auth/
  screens/
    login-screen.tsx
    login-screen.test.tsx          # Unit/component test
  hooks/
    use-login.ts
    use-login.test.ts
  components/
    login-form.tsx
    login-form.test.tsx
    __snapshots__/
      login-form.test.tsx.snap     # Snapshot (shared components only)
\`\`\`

## Coverage Requirements

- **Global threshold**: 75% (lines, branches, functions, statements)
- **Feature services** (\`src/features/*/hooks/\`, \`src/services/\`): 85% minimum
- **Auth and payment paths** (\`src/features/auth/\`, \`src/features/payments/\`): 90% minimum
- **Shared components** (\`src/components/\`): 80% minimum
- **Navigation config and theme constants**: excluded from coverage

Configure in \`jest.config.ts\`:

\`\`\`typescript
coverageThreshold: {
  global: { branches: 75, functions: 75, lines: 75, statements: 75 },
  './src/features/auth/': { branches: 90, functions: 90, lines: 90, statements: 90 },
  './src/features/payments/': { branches: 90, functions: 90, lines: 90, statements: 90 },
  './src/services/': { branches: 85, functions: 85, lines: 85, statements: 85 },
},
collectCoverageFrom: [
  'src/**/*.{ts,tsx}',
  '!src/**/*.d.ts',
  '!src/navigation/types.ts',
  '!src/theme/**',
  '!src/assets/**',
  '!src/**/__mocks__/**',
],
\`\`\`

## Commands Reference

\`\`\`bash
pnpm test                          # Run all Jest tests
pnpm test --watch                  # Watch mode during development
pnpm test --coverage               # Generate coverage report
pnpm test --testPathPattern=auth   # Run tests matching "auth"
npx detox build --configuration ios.sim.release
npx detox test --configuration ios.sim.release
npx detox test e2e/specs/auth/     # Run specific E2E suite
\`\`\``,

  '.claude/settings.json': `{
  "permissions": {
    "allow": [
      "Read",
      "Edit",
      "MultiEdit",
      "Write",
      "Bash(pnpm install)",
      "Bash(pnpm install *)",
      "Bash(pnpm add *)",
      "Bash(pnpm remove *)",
      "Bash(pnpm run lint)",
      "Bash(pnpm run lint:fix)",
      "Bash(pnpm run format)",
      "Bash(pnpm run format:check)",
      "Bash(pnpm run typecheck)",
      "Bash(pnpm test *)",
      "Bash(pnpm test)",
      "Bash(pnpm run test:coverage)",
      "Bash(npx expo start *)",
      "Bash(npx expo prebuild *)",
      "Bash(npx expo install *)",
      "Bash(npx expo lint)",
      "Bash(npx expo export *)",
      "Bash(npx tsc --noEmit *)",
      "Bash(npx eslint *)",
      "Bash(npx prettier *)",
      "Bash(npx jest *)",
      "Bash(npx detox build *)",
      "Bash(npx detox test *)",
      "Bash(eas build *)",
      "Bash(eas update *)",
      "Bash(eas submit *)",
      "Bash(eas credentials *)",
      "Bash(eas device:list)",
      "Bash(eas channel:list)",
      "Bash(git status)",
      "Bash(git diff *)",
      "Bash(git log *)",
      "Bash(git branch *)",
      "Bash(git checkout *)",
      "Bash(git switch *)",
      "Bash(git add *)",
      "Bash(git commit *)",
      "Bash(git push *)",
      "Bash(git pull *)",
      "Bash(git fetch *)",
      "Bash(git stash *)",
      "Bash(git merge *)",
      "Bash(git rebase *)",
      "Bash(git cherry-pick *)",
      "Bash(cat *)",
      "Bash(ls *)",
      "Bash(find *)",
      "Bash(grep *)",
      "Bash(head *)",
      "Bash(tail *)",
      "Bash(wc *)",
      "Bash(sort *)",
      "Bash(mkdir *)",
      "Bash(cp *)",
      "Bash(mv *)",
      "Bash(echo *)",
      "Bash(which *)",
      "Bash(node -e *)",
      "Bash(npx react-native info)",
      "Bash(npx pod-install)",
      "Bash(cd ios && pod install *)",
      "Bash(adb *)",
      "Bash(xcrun simctl *)",
      "Bash(firebase *)",
      "WebFetch(https://docs.expo.dev/*)",
      "WebFetch(https://reactnative.dev/*)",
      "WebFetch(https://reactnavigation.org/*)",
      "WebFetch(https://firebase.google.com/docs/*)",
      "WebFetch(https://tanstack.com/query/*)",
      "WebFetch(https://github.com/pmndrs/zustand/*)",
      "WebFetch(https://nozbe.github.io/WatermelonDB/*)",
      "WebFetch(https://wix.github.io/Detox/*)"
    ],
    "deny": [
      "Bash(rm -rf /)",
      "Bash(rm -rf ~)",
      "Bash(rm -rf .git)",
      "Bash(rm -rf node_modules)",
      "Bash(rm -rf ios/Pods)",
      "Bash(eas submit --auto)",
      "Bash(*--production*)",
      "Bash(*FIREBASE_*=*)",
      "Bash(*API_KEY*=*)",
      "Bash(*SECRET*=*)",
      "Bash(cat .env*)",
      "Bash(cat google-services.json)",
      "Bash(cat GoogleService-Info.plist)",
      "Bash(cat *keystore*)",
      "Bash(cat *credentials*)",
      "Bash(*curl*|*sh*)",
      "Bash(*curl*|*bash*)",
      "Bash(npx expo publish *)",
      "Bash(firebase deploy --only functions *)"
    ]
  },
  "model": {
    "default": "sonnet",
    "codeGeneration": "sonnet",
    "codeReview": "sonnet",
    "debugging": "sonnet",
    "architecture": "opus"
  },
  "context": {
    "importRules": [
      ".claude/rules/common/coding-style.md",
      ".claude/rules/common/security.md",
      ".claude/rules/common/git-workflow.md",
      ".claude/rules/common/testing.md",
      ".claude/rules/typescript/coding-style.md"
    ]
  },
  "preferences": {
    "codeStyle": {
      "language": "typescript",
      "strictMode": true,
      "noAny": true,
      "maxFileLength": 250,
      "namingConventions": {
        "components": "PascalCase",
        "screens": "PascalCase",
        "hooks": "camelCase",
        "utils": "camelCase",
        "files": "kebab-case",
        "constants": "SCREAMING_SNAKE_CASE"
      }
    },
    "testing": {
      "framework": "jest",
      "componentTesting": "react-native-testing-library",
      "e2e": "detox",
      "coverageThreshold": 75,
      "requireAccessibilityLabels": true
    },
    "commits": {
      "convention": "conventional",
      "prefixes": ["feat", "fix", "chore", "docs", "refactor", "test", "perf", "ci"],
      "branchNaming": "type/ticket-desc",
      "markAIGenerated": true
    },
    "mobile": {
      "framework": "react-native",
      "sdk": "expo-51",
      "navigation": "react-navigation-v6",
      "stateManagement": {
        "client": "zustand",
        "server": "tanstack-query"
      },
      "offlineFirst": true,
      "localDatabase": "watermelondb",
      "i18nRequired": true,
      "accessibilityRequired": true,
      "platforms": ["ios", "android"]
    },
    "security": {
      "sensitiveFiles": [
        "src/services/auth/**",
        "src/config/**",
        "google-services.json",
        "GoogleService-Info.plist",
        ".env*"
      ],
      "requireSecureStorage": true,
      "compliance": ["GDPR", "App Store Guidelines", "Google Play Policies"]
    }
  }
}`,

  '.editorconfig': `root = true

[*]
charset = utf-8
end_of_line = lf
insert_final_newline = true
trim_trailing_whitespace = true
indent_style = space
indent_size = 2

[*.{ts,tsx}]
indent_size = 2

[*.{js,jsx,mjs,cjs}]
indent_size = 2

[*.{json,jsonc}]
indent_size = 2

[*.{yml,yaml}]
indent_size = 2

[*.md]
trim_trailing_whitespace = false
indent_size = 2

[*.{xml,plist}]
indent_size = 4

[*.{java,kt,kts}]
indent_size = 4

[*.{m,h,swift}]
indent_size = 4

[*.gradle]
indent_size = 4

[*.rb]
indent_size = 2

[Podfile]
indent_size = 2

[Gemfile]
indent_size = 2

[*.sh]
indent_size = 2

[Makefile]
indent_style = tab

[*.{env,env.*}]
insert_final_newline = true

[{package.json,tsconfig*.json,app.json,app.config.*,eas.json,babel.config.*,metro.config.*}]
indent_size = 2`,

  '.eslintrc.js': `module.exports = {
  root: true,
  extends: [
    '@react-native-community',
    'plugin:@typescript-eslint/recommended',
    'plugin:@typescript-eslint/recommended-requiring-type-checking',
    'plugin:react/recommended',
    'plugin:react-hooks/recommended',
    'plugin:react-native-a11y/all',
    'plugin:import/recommended',
    'plugin:import/typescript',
    'prettier',
  ],
  parser: '@typescript-eslint/parser',
  parserOptions: {
    ecmaFeatures: {
      jsx: true,
    },
    ecmaVersion: 'latest',
    sourceType: 'module',
    project: ['./tsconfig.json'],
    tsconfigRootDir: __dirname,
  },
  plugins: [
    '@typescript-eslint',
    'react',
    'react-hooks',
    'react-native',
    'react-native-a11y',
    'import',
    'jest',
    'detox',
  ],
  settings: {
    react: {
      version: 'detect',
    },
    'import/resolver': {
      typescript: {
        alwaysTryTypes: true,
        project: './tsconfig.json',
      },
    },
    'import/ignore': ['react-native'],
  },
  env: {
    'react-native/react-native': true,
    jest: true,
  },
  rules: {
    // TypeScript strict rules — no \`any\`
    '@typescript-eslint/no-explicit-any': 'error',
    '@typescript-eslint/no-unsafe-assignment': 'error',
    '@typescript-eslint/no-unsafe-call': 'error',
    '@typescript-eslint/no-unsafe-member-access': 'error',
    '@typescript-eslint/no-unsafe-return': 'error',
    '@typescript-eslint/no-unsafe-argument': 'error',
    '@typescript-eslint/explicit-function-return-type': [
      'warn',
      {
        allowExpressions: true,
        allowTypedFunctionExpressions: true,
        allowHigherOrderFunctions: true,
        allowConciseArrowFunctionExpressionsStartingWithVoid: true,
      },
    ],
    '@typescript-eslint/consistent-type-imports': [
      'error',
      { prefer: 'type-imports', fixStyle: 'inline-type-imports' },
    ],
    '@typescript-eslint/no-unused-vars': [
      'error',
      {
        argsIgnorePattern: '^_',
        varsIgnorePattern: '^_',
        destructuredArrayIgnorePattern: '^_',
      },
    ],
    '@typescript-eslint/no-floating-promises': 'error',
    '@typescript-eslint/no-misused-promises': [
      'error',
      { checksVoidReturn: { attributes: false } },
    ],
    '@typescript-eslint/strict-boolean-expressions': [
      'warn',
      {
        allowString: true,
        allowNumber: false,
        allowNullableObject: true,
        allowNullableBoolean: true,
        allowNullableString: true,
      },
    ],

    // React rules
    'react/react-in-jsx-scope': 'off',
    'react/prop-types': 'off',
    'react/jsx-no-bind': [
      'warn',
      {
        allowArrowFunctions: true,
        allowFunctions: false,
        allowBind: false,
      },
    ],
    'react/jsx-key': ['error', { checkFragmentShorthand: true }],
    'react/no-unstable-nested-components': ['error', { allowAsProps: true }],
    'react/jsx-no-leaked-render': ['error', { validStrategies: ['ternary', 'coerce'] }],

    // React Hooks rules
    'react-hooks/rules-of-hooks': 'error',
    'react-hooks/exhaustive-deps': 'warn',

    // React Native rules
    'react-native/no-unused-styles': 'error',
    'react-native/split-platform-components': 'warn',
    'react-native/no-inline-styles': 'error',
    'react-native/no-color-literals': 'warn',
    'react-native/no-raw-text': [
      'error',
      { skip: ['CustomText', 'Text', 'Trans'] },
    ],
    'react-native/no-single-element-style-arrays': 'error',

    // Accessibility — all interactive elements must have labels
    'react-native-a11y/has-accessibility-hint': 'warn',
    'react-native-a11y/has-accessibility-props': 'error',
    'react-native-a11y/has-valid-accessibility-actions': 'error',
    'react-native-a11y/has-valid-accessibility-role': 'error',
    'react-native-a11y/has-valid-accessibility-state': 'error',
    'react-native-a11y/has-valid-accessibility-value': 'error',
    'react-native-a11y/no-nested-touchables': 'error',

    // Import ordering and organization
    'import/order': [
      'error',
      {
        groups: [
          'builtin',
          'external',
          'internal',
          'parent',
          'sibling',
          'index',
          'type',
        ],
        pathGroups: [
          {
            pattern: 'react',
            group: 'builtin',
            position: 'before',
          },
          {
            pattern: 'react-native',
            group: 'builtin',
            position: 'before',
          },
          {
            pattern: 'expo-**',
            group: 'external',
            position: 'before',
          },
          {
            pattern: '@react-navigation/**',
            group: 'external',
            position: 'before',
          },
          {
            pattern: 'src/**',
            group: 'internal',
            position: 'before',
          },
          {
            pattern: '@features/**',
            group: 'internal',
            position: 'before',
          },
          {
            pattern: '@components/**',
            group: 'internal',
            position: 'before',
          },
          {
            pattern: '@hooks/**',
            group: 'internal',
            position: 'before',
          },
          {
            pattern: '@services/**',
            group: 'internal',
            position: 'before',
          },
          {
            pattern: '@store/**',
            group: 'internal',
            position: 'before',
          },
          {
            pattern: '@utils/**',
            group: 'internal',
            position: 'before',
          },
          {
            pattern: '@theme/**',
            group: 'internal',
            position: 'before',
          },
          {
            pattern: '@i18n/**',
            group: 'internal',
            position: 'before',
          },
          {
            pattern: '@assets/**',
            group: 'internal',
            position: 'after',
          },
        ],
        pathGroupsExcludedImportTypes: ['react', 'react-native'],
        'newlines-between': 'always',
        alphabetize: {
          order: 'asc',
          caseInsensitive: true,
        },
      },
    ],
    'import/no-duplicates': ['error', { 'prefer-inline': true }],
    'import/no-cycle': ['error', { maxDepth: 3 }],
    'import/no-self-import': 'error',
    'import/no-useless-path-segments': 'error',
    'import/no-default-export': 'warn',

    // General code quality
    'no-console': ['warn', { allow: ['warn', 'error'] }],
    'no-debugger': 'error',
    'no-alert': 'error',
    'prefer-const': 'error',
    'no-var': 'error',
    eqeqeq: ['error', 'always'],
    curly: ['error', 'all'],
    'max-lines': [
      'warn',
      {
        max: 250,
        skipBlankLines: true,
        skipComments: true,
      },
    ],
    'max-params': ['warn', 4],
    complexity: ['warn', 15],
  },
  overrides: [
    // Screen and layout files — allow default exports (required by React Navigation)
    {
      files: [
        'src/features/**/screens/**/*.tsx',
        'src/navigation/**/*.tsx',
        'app/**/*.tsx',
        'App.tsx',
        'app.config.ts',
        'metro.config.js',
        'babel.config.js',
        'detox.config.js',
        'jest.config.ts',
      ],
      rules: {
        'import/no-default-export': 'off',
      },
    },
    // Test files — relaxed rules
    {
      files: [
        '**/__tests__/**/*.{ts,tsx}',
        '**/*.test.{ts,tsx}',
        '**/*.spec.{ts,tsx}',
        'e2e/**/*.{ts,tsx}',
      ],
      plugins: ['jest', 'detox'],
      extends: ['plugin:jest/recommended'],
      rules: {
        '@typescript-eslint/no-explicit-any': 'off',
        '@typescript-eslint/no-unsafe-assignment': 'off',
        '@typescript-eslint/no-unsafe-call': 'off',
        '@typescript-eslint/no-unsafe-member-access': 'off',
        '@typescript-eslint/no-unsafe-return': 'off',
        '@typescript-eslint/no-unsafe-argument': 'off',
        '@typescript-eslint/no-floating-promises': 'off',
        'react-native/no-inline-styles': 'off',
        'react-native/no-color-literals': 'off',
        'react-native-a11y/has-accessibility-hint': 'off',
        'max-lines': 'off',
        'import/no-default-export': 'off',
        'jest/expect-expect': 'error',
        'jest/no-disabled-tests': 'warn',
        'jest/no-focused-tests': 'error',
        'jest/valid-expect': 'error',
      },
    },
    // E2E test files — Detox-specific
    {
      files: ['e2e/**/*.{ts,tsx}'],
      env: {
        'detox/detox': true,
      },
      rules: {
        'jest/expect-expect': 'off',
        'no-console': 'off',
      },
    },
    // Config files — CommonJS allowed
    {
      files: [
        '*.config.js',
        '*.config.ts',
        '.eslintrc.js',
        'babel.config.js',
        'metro.config.js',
        'scripts/**/*.{js,ts}',
      ],
      env: {
        node: true,
      },
      rules: {
        '@typescript-eslint/no-var-requires': 'off',
        '@typescript-eslint/no-require-imports': 'off',
        'no-console': 'off',
      },
    },
    // Firebase Cloud Functions
    {
      files: ['functions/**/*.ts'],
      env: {
        node: true,
      },
      rules: {
        'react-native/no-unused-styles': 'off',
        'react-native/no-inline-styles': 'off',
        'react-native/no-color-literals': 'off',
        'react-native/no-raw-text': 'off',
      },
    },
    // i18n translation files — allow default exports
    {
      files: ['src/i18n/**/*.ts'],
      rules: {
        'import/no-default-export': 'off',
        'max-lines': 'off',
      },
    },
  ],
  ignorePatterns: [
    'node_modules/',
    '.expo/',
    'ios/',
    'android/',
    'dist/',
    'build/',
    'coverage/',
    '*.generated.*',
    'functions/lib/',
    'artifacts/',
    '.eas/',
  ],
};`,

  '.gitattributes': `# Auto detect text files and ensure LF line endings
* text=auto eol=lf

# TypeScript / JavaScript
*.ts text diff=typescript
*.tsx text diff=typescript
*.js text diff=javascript
*.jsx text diff=javascript
*.mjs text diff=javascript
*.cjs text diff=javascript

# JSON / Config
*.json text diff=json
*.jsonc text diff=json

# Markup / Documentation
*.md text diff=markdown
*.mdx text diff=markdown
*.yml text diff=yaml
*.yaml text diff=yaml
*.toml text

# React Native / Expo config
app.json text diff=json
app.config.ts text diff=typescript
eas.json text diff=json
expo-env.d.ts text diff=typescript
metro.config.js text diff=javascript
babel.config.js text diff=javascript

# iOS native files
*.swift text diff=swift
*.m text diff=objc
*.h text diff=objc
*.mm text diff=objc
*.plist text
*.pbxproj text -diff
*.xcworkspacedata text -diff
*.xcscheme text
*.storyboard text
Podfile text
Podfile.lock text -diff

# Android native files
*.java text diff=java
*.kt text diff=kotlin
*.gradle text diff=java
*.pro text
*.xml text diff=html
gradlew text eol=lf
gradlew.bat text eol=crlf

# Styles / CSS-in-JS support
*.css text diff=css
*.scss text diff=css

# Shell scripts (always LF)
*.sh text eol=lf
*.bash text eol=lf

# Environment / secrets (treat as text but no diff to avoid leaks)
.env text -diff
.env.* text -diff

# Lock files (text but no diff noise)
pnpm-lock.yaml text -diff
yarn.lock text -diff
package-lock.json text -diff

# Images (binary)
*.png binary
*.jpg binary
*.jpeg binary
*.gif binary
*.webp binary
*.ico binary
*.bmp binary
*.svg text

# Fonts (binary)
*.ttf binary
*.otf binary
*.woff binary
*.woff2 binary

# Lottie animations
*.lottie binary

# App bundles / archives (binary)
*.aab binary
*.apk binary
*.ipa binary
*.zip binary
*.tar.gz binary

# Certificates / signing (binary, no diff)
*.p12 binary
*.mobileprovision binary
*.keystore binary
*.jks binary
*.cer binary
*.pem text -diff

# Firebase config (text but sensitive)
google-services.json text diff=json -diff
GoogleService-Info.plist text -diff

# SQLite / WatermelonDB (binary)
*.db binary
*.sqlite binary

# Source maps (generated, no diff)
*.map text -diff

# Patches
*.patch text diff

# Generated directories — mark as linguist-generated for GitHub stats
src/i18n/locales/*.json linguist-generated=true
ios/Pods/** linguist-generated=true
android/build/** linguist-generated=true`,

  '.github/CODEOWNERS': `# Project-wide default owners
* @react-native-mobile-app/mobile-team

# Claude and project configuration
CLAUDE.md @react-native-mobile-app/tech-leads
.claude/ @react-native-mobile-app/tech-leads
.mcp.json @react-native-mobile-app/tech-leads

# CI/CD and build configuration
.github/ @react-native-mobile-app/tech-leads
eas.json @react-native-mobile-app/tech-leads
app.json @react-native-mobile-app/tech-leads
app.config.ts @react-native-mobile-app/tech-leads
metro.config.js @react-native-mobile-app/tech-leads
babel.config.js @react-native-mobile-app/tech-leads
tsconfig.json @react-native-mobile-app/tech-leads
scripts/ @react-native-mobile-app/tech-leads

# Authentication — security-sensitive
src/features/auth/** @react-native-mobile-app/security-leads
src/services/auth/** @react-native-mobile-app/security-leads

# Payments and in-app purchases — billing-sensitive
src/features/payments/** @react-native-mobile-app/billing-leads

# Navigation and deep linking
src/navigation/** @react-native-mobile-app/senior-devs

# Shared services (Firebase, analytics, crash reporting)
src/services/** @react-native-mobile-app/senior-devs

# Zustand stores
src/store/** @react-native-mobile-app/senior-devs

# Push notifications
src/features/notifications/** @react-native-mobile-app/senior-devs

# Shared components and design system
src/components/** @react-native-mobile-app/mobile-team
src/theme/** @react-native-mobile-app/mobile-team

# Internationalization
src/i18n/** @react-native-mobile-app/mobile-team

# Shared hooks and utilities
src/hooks/** @react-native-mobile-app/mobile-team
src/utils/** @react-native-mobile-app/mobile-team

# Offline database and sync
src/services/database/** @react-native-mobile-app/senior-devs @react-native-mobile-app/security-leads

# E2E tests
e2e/** @react-native-mobile-app/senior-devs

# Environment and secrets — never merge without security review
.env* @react-native-mobile-app/security-leads @react-native-mobile-app/tech-leads
src/config/** @react-native-mobile-app/security-leads @react-native-mobile-app/tech-leads
google-services.json @react-native-mobile-app/security-leads
GoogleService-Info.plist @react-native-mobile-app/security-leads

# Native platform code
ios/ @react-native-mobile-app/tech-leads
android/ @react-native-mobile-app/tech-leads

# Plugin and playbook
plugin/ @react-native-mobile-app/tech-leads
playbook/ @react-native-mobile-app/tech-leads

# Documentation
docs/** @react-native-mobile-app/mobile-team

# Dependency management
package.json @react-native-mobile-app/senior-devs @react-native-mobile-app/tech-leads
pnpm-lock.yaml @react-native-mobile-app/senior-devs
Podfile @react-native-mobile-app/tech-leads
Podfile.lock @react-native-mobile-app/tech-leads`,

  '.github/ISSUE_TEMPLATE/ai_task.md': `---
name: AI Task (Claude Code)
about: Structured task for Claude Code to implement in the React Native mobile app
title: "[AI] "
labels: ai-task, claude-code
assignees: ''
---

## Task Type

<!-- Select one -->
- [ ] Feature implementation
- [ ] Bug fix
- [ ] Refactor
- [ ] Test coverage
- [ ] Performance optimization
- [ ] Accessibility improvement
- [ ] i18n / localization
- [ ] Native module work
- [ ] CI/CD pipeline update
- [ ] Documentation

## Priority

<!-- Select one -->
- [ ] Critical (blocking release)
- [ ] High (current sprint)
- [ ] Medium (next sprint)
- [ ] Low (backlog)

## Platform Scope

<!-- Select all that apply -->
- [ ] iOS
- [ ] Android
- [ ] Both platforms
- [ ] Platform-agnostic (JS/TS only)

## Feature Area

<!-- Select the primary feature module -->
- [ ] \`src/features/auth/\` — Authentication, biometrics
- [ ] \`src/features/home/\` — Home feed, dashboard
- [ ] \`src/features/profile/\` — User profile, settings
- [ ] \`src/features/notifications/\` — Push notifications
- [ ] \`src/features/payments/\` — In-app purchases, subscriptions
- [ ] \`src/components/\` — Shared UI components
- [ ] \`src/hooks/\` — Shared hooks
- [ ] \`src/services/\` — Firebase, analytics, crash reporting
- [ ] \`src/navigation/\` — React Navigation config
- [ ] \`src/store/\` — Zustand stores
- [ ] \`src/utils/\` — Utilities
- [ ] \`src/i18n/\` — Internationalization
- [ ] \`src/theme/\` — Design tokens
- [ ] \`e2e/\` — Detox E2E tests
- [ ] Other: <!-- specify -->

## Objective

<!-- One clear sentence describing what Claude Code should accomplish -->


## Context

<!-- Background information Claude Code needs to understand the task -->

### Current Behavior
<!-- What happens now? Include error messages, screenshots, or logs if applicable -->


### Desired Behavior
<!-- What should happen after this task is complete? -->


### Related Code
<!-- List specific files, components, hooks, or services that are relevant -->
- 
- 
- 

### Related Issues / PRs
<!-- Link any related issues or pull requests -->
- 

## Requirements

### Functional Requirements
<!-- Numbered list of what the implementation must do -->
1. 
2. 
3. 

### Non-Functional Requirements
<!-- Performance, accessibility, offline behavior, etc. -->
- [ ] Must work offline (WatermelonDB sync)
- [ ] Must support both light and dark themes
- [ ] Must include accessibility labels on all interactive elements
- [ ] All user-facing text through \`src/i18n/\`
- [ ] Must handle loading, error, and empty states
- [ ] Other: <!-- specify -->

## Technical Constraints

### Architecture Rules
<!-- Remind Claude Code of project conventions relevant to this task -->
- Feature code goes in \`src/features/<feature>/\` with \`screens/\`, \`components/\`, \`hooks/\`, \`types/\` subdirectories
- Server state via React Query (\`useQuery\`, \`useMutation\`), client state via Zustand
- Navigation must be fully typed with React Navigation v6 typed navigators
- Components must be PascalCase, hooks camelCase prefixed with \`use\`, files kebab-case
- Max 250 lines per file — split into smaller modules if needed
- TypeScript strict mode — no \`any\`, no \`@ts-ignore\`
- All constants in SCREAMING_SNAKE_CASE

### Sensitive Paths — Extra Caution
<!-- Check if this task touches sensitive areas -->
- [ ] \`src/services/auth/**\` — Authentication logic
- [ ] \`src/config/**\` — App configuration
- [ ] \`.env*\` — Environment variables
- [ ] \`google-services.json\` / \`GoogleService-Info.plist\` — Firebase config
- [ ] Native module code (ios/, android/)

### Dependencies
<!-- List any packages that may need to be added or are relevant -->
- Existing: <!-- e.g., @react-navigation/native, zustand, @tanstack/react-query -->
- New (if any): <!-- Must be reviewed — note if native module -->

## Testing Requirements

### Unit / Component Tests (Jest + RNTL)
<!-- Describe what tests Claude Code should write -->
- [ ] Test file(s) colocated in \`__tests__/\` next to source
- [ ] Cover happy path and error states
- [ ] Mock Firebase/native modules appropriately
- [ ] Minimum 75% coverage for new code
- Specific scenarios:
  1. 
  2. 
  3. 

### E2E Tests (Detox)
<!-- If this task requires E2E coverage -->
- [ ] E2E test required in \`e2e/\`
- [ ] Not required for this task
- Specific flows:
  1. 
  2. 

## Acceptance Criteria

<!-- Checklist that must be true for this task to be considered complete -->
- [ ] Implementation matches all functional requirements above
- [ ] TypeScript compiles with zero errors (\`pnpm tsc --noEmit\`)
- [ ] ESLint passes (\`pnpm lint\`)
- [ ] Prettier formatting applied (\`pnpm format\`)
- [ ] Unit/component tests pass (\`pnpm test\`)
- [ ] Test coverage ≥ 75% for changed files
- [ ] Works on iOS simulator (specify version if relevant): 
- [ ] Works on Android emulator (specify API level if relevant): 
- [ ] No new \`any\` types introduced
- [ ] No secrets or credentials in code
- [ ] Accessibility labels present on interactive elements
- [ ] All text uses i18n keys
- [ ] Conventional commit messages used
- [ ] PR targets \`main\` branch with branch name \`feat/APP-XXX-description\` or \`fix/APP-XXX-description\`

## Implementation Hints

<!-- Optional: guide Claude Code toward the right approach -->

### Suggested Approach
<!-- Step-by-step outline of how to implement this -->
1. 
2. 
3. 

### Patterns to Follow
<!-- Point to existing code that demonstrates the right pattern -->
- Similar feature: <!-- e.g., "See src/features/auth/ for feature module structure" -->
- Similar component: <!-- e.g., "See src/components/Button.tsx for shared component pattern" -->
- Similar hook: <!-- e.g., "See src/hooks/useAuth.ts for hook pattern" -->

### Patterns to Avoid
<!-- Anti-patterns or approaches that should NOT be used -->
- Do not use \`AsyncStorage\` for sensitive data — use \`expo-secure-store\`
- Do not make direct Firestore calls from components — use service layer in \`src/services/\`
- Do not use inline styles — use \`src/theme/\` tokens
- Do not skip error boundaries for new screens

## Verification Commands

<!-- Commands Claude Code should run to verify the implementation -->
\`\`\`bash
# Type check
pnpm tsc --noEmit

# Lint
pnpm lint

# Format check
pnpm format:check

# Run unit tests for affected files
pnpm test --coverage --changedSince=main

# Run full test suite
pnpm test

# Start Expo dev server to manually verify
npx expo start

# Run Detox E2E (if applicable)
npx detox build --configuration ios.sim.debug
npx detox test --configuration ios.sim.debug
\`\`\`

## AI Task Metadata

<!-- Do not edit below — used for tracking AI-generated work -->
- **AI Agent**: Claude Code
- **AI Flag**: All code generated from this task must include \`// AI-generated\` comment at the top of new files
- **Review Required**: Yes — human review mandatory before merge
- **CODEOWNERS**: <!-- Tag the code owner for the affected area, e.g., @mobile-lead -->`,

  '.github/ISSUE_TEMPLATE/bug_report.md': `---
name: Bug Report
about: Report a bug or unexpected behavior in the mobile app
title: "[BUG] "
labels: bug, triage
assignees: ''
---

## Device & Environment

| Field | Value |
|---|---|
| **App Version** | e.g., 1.2.3 (build 45) |
| **Platform** | iOS / Android |
| **Device Model** | e.g., iPhone 15 Pro, Pixel 8 |
| **OS Version** | e.g., iOS 17.4, Android 14 |
| **Expo SDK Version** | e.g., 51.0.0 |
| **Install Source** | TestFlight / EAS Staging / App Store / Google Play / Dev Build |
| **Network Condition** | WiFi / Cellular / Offline |

## Bug Description

A clear and concise description of the bug.

## Steps to Reproduce

1. Open the app and navigate to '...'
2. Tap on '...'
3. Scroll to '...'
4. Observe the issue

## Expected Behavior

What you expected to happen.

## Actual Behavior

What actually happened.

## Screenshots / Screen Recordings

If applicable, attach screenshots or screen recordings. For iOS, use the built-in screen recorder. For Android, use \`adb shell screenrecord\`.

## Crash Log / Error Output

<details>
<summary>Crash log or error stack trace</summary>

\`\`\`
Paste crash log, Sentry event link, Firebase Crashlytics link, or JS error stack trace here.
\`\`\`

</details>

<details>
<summary>React Native LogBox / Metro output (if applicable)</summary>

\`\`\`
Paste any relevant console warnings or errors from Metro bundler here.
\`\`\`

</details>

## Sentry / Crashlytics Reference

- **Sentry Event ID**: (if available)
- **Crashlytics Session ID**: (if available)
- **Firebase Analytics breadcrumbs**: (if relevant)

## Offline / Sync Context

- [ ] Bug occurs in offline mode
- [ ] Bug occurs during sync (WatermelonDB ↔ Firestore)
- [ ] Bug occurs only after coming back online
- [ ] Bug is unrelated to offline/sync

## Reproducibility

- [ ] Always reproducible
- [ ] Intermittent (roughly how often: ___)
- [ ] Only on specific device/OS
- [ ] Only on specific build channel (staging/production)

## Platform Specificity

- [ ] iOS only
- [ ] Android only
- [ ] Both platforms
- [ ] Not yet tested on both

## Related Areas

Check any areas that seem related to this bug:

- [ ] Authentication / Biometrics
- [ ] Navigation / Deep Linking
- [ ] Push Notifications
- [ ] In-App Purchases
- [ ] Offline Mode / WatermelonDB
- [ ] Camera / Media
- [ ] Permissions
- [ ] Performance / Memory
- [ ] UI / Layout
- [ ] Accessibility
- [ ] i18n / Localization
- [ ] Firebase (Auth, Firestore, Functions, Storage)

## Regression

- [ ] This worked in a previous version (specify version: ___)
- [ ] This is a new feature that never worked
- [ ] Unknown

## Severity

- [ ] **Critical** — App crashes, data loss, security issue, blocks release
- [ ] **High** — Major feature broken, no workaround
- [ ] **Medium** — Feature partially broken, workaround exists
- [ ] **Low** — Minor visual issue, edge case

## Additional Context

Add any other context about the problem here. Include relevant deep link URLs, notification payloads, or specific user account details (redact PII per GDPR).`,

  '.github/ISSUE_TEMPLATE/feature_request.md': `---
name: Feature Request
about: Propose a new screen, feature, or native integration for the mobile app
title: "[FEATURE] "
labels: enhancement
assignees: ''
---

## Summary

A clear, concise description of the feature you'd like to add.

## Problem Statement

What problem does this feature solve? Who is affected?

<!-- Link to user research, analytics data, or support tickets if available -->

## Feature Type

<!-- Check all that apply -->

- [ ] New screen / flow
- [ ] New shared component
- [ ] Native module integration (iOS + Android)
- [ ] Push notification enhancement
- [ ] Offline / sync capability
- [ ] In-app purchase / subscription
- [ ] Deep linking route
- [ ] Biometric / security feature
- [ ] Analytics / tracking event
- [ ] Performance optimization
- [ ] Accessibility improvement
- [ ] i18n / localization
- [ ] Other: ___

## Platform Scope

- [ ] iOS
- [ ] Android
- [ ] Both (required for all user-facing features)

## Proposed Solution

Describe how you envision this feature working. Include:

### User Flow

1. User navigates to...
2. User taps...
3. App displays...

### Screens / UI

<!-- Attach wireframes, Figma links, or rough sketches if available -->

### Navigation

<!-- Where does this fit in the navigation hierarchy? Which navigator (stack/tab)? -->

- **Navigator**: (e.g., \`HomeStack\`, \`ProfileTab\`, \`RootStack\`)
- **Route name**: (e.g., \`PaymentHistory\`)
- **Deep link path**: (e.g., \`/payments/history\`)

## Feature Directory Structure

<!-- Propose the file layout under src/features/ -->

\`\`\`
src/features/<feature-name>/
  screens/
    FeatureScreen.tsx
  components/
    FeatureCard.tsx
  hooks/
    useFeatureData.ts
  types/
    index.ts
\`\`\`

## State Management

<!-- Describe what state this feature needs -->

- **Server state (React Query)**: (e.g., fetching payment history from Firestore)
- **Client state (Zustand)**: (e.g., selected filter, UI toggle)
- **Local database (WatermelonDB)**: (e.g., offline cache of transactions)

## Backend Requirements

<!-- What Firebase services or Cloud Functions are needed? -->

- [ ] Firestore collection/document changes
- [ ] New Cloud Function(s)
- [ ] Firebase Authentication changes
- [ ] Cloud Storage usage
- [ ] Cloud Messaging (push notification) changes
- [ ] No backend changes needed

**Details**:

## Offline Behavior

How should this feature behave when the device is offline?

- [ ] Full offline support (read + write with sync)
- [ ] Read-only offline (cached data)
- [ ] Online only (show offline message)
- [ ] N/A

**Sync strategy**:

## Native Module Dependencies

<!-- List any new native libraries or Expo modules required -->

| Package | Purpose | iOS | Android | Expo Module? |
|---------|---------|-----|---------|--------------|
|         |         |     |         |              |

<!-- Flag: New native modules require team review per dependency policy -->

## Privacy & Compliance

<!-- Required for features that handle user data -->

- [ ] Collects new personal data — describe: ___
- [ ] Requires GDPR consent update
- [ ] Requires App Store privacy label update
- [ ] Requires Google Play data safety section update
- [ ] Uses device sensors (camera, location, biometrics)
- [ ] No privacy impact

## Security Considerations

- [ ] Handles sensitive data (PII, payment info, credentials)
- [ ] Requires secure storage (Keychain / Keystore)
- [ ] Requires certificate pinning for new endpoints
- [ ] Needs biometric gating
- [ ] No special security requirements

## Accessibility Requirements

<!-- All interactive elements require accessibility labels -->

- [ ] Screen reader support (VoiceOver / TalkBack)
- [ ] Dynamic type / font scaling
- [ ] Sufficient color contrast
- [ ] Haptic feedback where appropriate
- [ ] Reduced motion support

## Analytics Events

<!-- List tracking events for Firebase Analytics -->

| Event Name | Trigger | Parameters |
|------------|---------|------------|
|            |         |            |

## Testing Plan

- **Unit tests**: (hooks, utils, business logic)
- **Component tests**: (React Native Testing Library — render, interaction)
- **E2E tests**: (Detox — full user flow)
- **Manual testing**: (device-specific behavior, gestures)

## Acceptance Criteria

<!-- Checklist that defines "done" for this feature -->

- [ ] Feature works on iOS and Android
- [ ] All text goes through i18n
- [ ] Accessibility labels on all interactive elements
- [ ] Offline behavior implemented per spec above
- [ ] Navigation types updated in \`src/navigation/types.ts\`
- [ ] Unit + component test coverage ≥ 75%
- [ ] Detox E2E test for primary happy path
- [ ] No TypeScript \`any\` types
- [ ] Files under 250 lines
- [ ] PR reviewed and approved

## Design Resources

<!-- Links to designs, prototypes, or assets -->

- Figma:
- Prototype:
- Assets:

## Alternatives Considered

Describe any alternative approaches you considered and why you chose this one.

## Dependencies / Blockers

<!-- Other issues or features that must be completed first -->

- Blocked by: #
- Related to: #

## Estimated Effort

- [ ] Small (1-2 days) — single screen, no native modules
- [ ] Medium (3-5 days) — multi-screen flow, minor backend changes
- [ ] Large (1-2 weeks) — native integration, new sync logic, complex UI
- [ ] XL (2+ weeks) — cross-cutting feature, new infrastructure

## Additional Context

Add any other context, screenshots, or references here.`,

  '.github/PULL_REQUEST_TEMPLATE.md': `## Description

<!-- Provide a clear summary of what this PR does and why. Link the relevant issue. -->

Resolves #<!-- issue number -->

### What changed?

<!-- Bullet list of key changes -->

-

### Why?

<!-- Motivation, context, or link to design doc / RFC -->

## Type of Change

- [ ] \`feat\` — New feature
- [ ] \`fix\` — Bug fix
- [ ] \`refactor\` — Code restructuring (no behavior change)
- [ ] \`chore\` — Build, CI, dependency, or tooling update
- [ ] \`docs\` — Documentation only
- [ ] \`test\` — Adding or updating tests
- [ ] \`perf\` — Performance improvement

## Screenshots / Recordings

<!-- Required for any UI change. Show both iOS and Android. -->

| iOS | Android |
|-----|---------|
|     |         |

## Platform Testing

- [ ] Tested on **iOS simulator** (specify device/OS: _______________)
- [ ] Tested on **iOS physical device** (specify model/OS: _______________)
- [ ] Tested on **Android emulator** (specify API level: _______________)
- [ ] Tested on **Android physical device** (specify model/OS: _______________)
- [ ] Not applicable (no UI or platform-specific changes)

## Native Module Changes

<!-- Check all that apply. If none, check "No native changes." -->

- [ ] **No native changes** — pure JS/TS change
- [ ] Modified or added a **native module** (iOS — Swift/ObjC)
- [ ] Modified or added a **native module** (Android — Kotlin/Java)
- [ ] Updated **Expo config plugin** or \`app.config.ts\`
- [ ] Changed **Podfile**, **build.gradle**, or native dependencies
- [ ] Both iOS and Android implementations are present and tested
- [ ] Expo Modules API used for custom native code (preferred over bare native modules)
- [ ] Verified \`npx expo prebuild --clean\` succeeds after changes

## Offline & Data

- [ ] Works correctly in **airplane mode** (offline-first)
- [ ] WatermelonDB schema migration added (if schema changed)
- [ ] Firestore sync tested after offline → online transition
- [ ] No sensitive data stored in AsyncStorage (use SecureStore / Keychain / Keystore)
- [ ] Not applicable

## Accessibility

- [ ] All interactive elements have \`accessibilityLabel\` props
- [ ] All images have \`accessibilityRole="image"\` and descriptive labels
- [ ] Tested with **VoiceOver** (iOS) or **TalkBack** (Android)
- [ ] Touch targets are at least 44×44 points
- [ ] Color contrast meets WCAG AA (4.5:1 for text)
- [ ] Not applicable (no UI changes)

## Internationalization

- [ ] All user-facing strings go through \`i18n\` (no hardcoded text)
- [ ] New translation keys added to all locale files in \`src/i18n/\`
- [ ] RTL layout tested (if applicable)
- [ ] Not applicable

## Security & Privacy

- [ ] No API keys, secrets, or tokens committed (check \`.env*\` files are gitignored)
- [ ] Sensitive data uses \`expo-secure-store\` or platform Keychain/Keystore
- [ ] Network requests use certificate pinning where required
- [ ] GDPR: user consent obtained before data collection
- [ ] GDPR: data deletion flow works if user data is affected
- [ ] App Store privacy labels / Google Play data safety updated (if new data collected)
- [ ] Not applicable

## Deep Linking & Navigation

- [ ] Deep link routes tested (\`npx uri-scheme open <url> --ios/--android\`)
- [ ] Navigation types updated in \`src/navigation/types.ts\`
- [ ] Back navigation and gesture handling verified
- [ ] Not applicable

## Testing

- [ ] Unit tests added/updated (\`pnpm test\`)
- [ ] Component tests added/updated (React Native Testing Library)
- [ ] E2E tests added/updated (\`npx detox test\`)
- [ ] Coverage remains ≥ 75%
- [ ] All tests pass locally: \`pnpm test -- --coverage\`

## Performance

- [ ] No unnecessary re-renders (verified with React DevTools Profiler)
- [ ] Large lists use \`FlashList\` or \`FlatList\` with proper \`keyExtractor\`
- [ ] Images optimized and cached appropriately
- [ ] No blocking operations on the JS thread
- [ ] Bundle size impact checked (\`npx expo export\` before/after)
- [ ] Not applicable

## Build & CI

- [ ] \`pnpm lint\` passes
- [ ] \`pnpm typecheck\` passes (TypeScript strict, no \`any\`)
- [ ] EAS Build succeeds for both platforms (or verified via \`eas build --profile preview\`)
- [ ] \`app.config.ts\` version/build numbers updated (if releasing)

## AI Disclosure

<!-- Required by project policy. Be transparent about AI-assisted code. -->

- [ ] **No AI-generated code** in this PR
- [ ] **AI-assisted code included** — sections marked with \`// AI-GENERATED\` comments
  - Tool used: <!-- e.g., Claude Code, GitHub Copilot -->
  - Files/sections: <!-- list specific files or describe scope -->
  - Human review: <!-- describe what you verified, tested, or modified -->

## Reviewer Notes

<!-- Anything reviewers should focus on, known limitations, follow-up work planned. -->

-

## Pre-merge Checklist

- [ ] PR title follows conventional commit format (e.g., \`feat(auth): add biometric login\`)
- [ ] Branch is up to date with \`main\`
- [ ] No merge conflicts
- [ ] At least 1 approval received
- [ ] All CI checks pass
- [ ] CODEOWNERS have been notified for sensitive paths (\`src/services/auth/**\`, \`src/config/**\`, \`.env*\`)`,

  '.github/workflows/ai-code-audit.yml': `name: AI Code Audit

on:
  schedule:
    - cron: '0 9 * * 1' # Every Monday at 9:00 UTC
  workflow_dispatch:
    inputs:
      audit_scope:
        description: 'Scope of audit'
        required: false
        default: 'full'
        type: choice
        options:
          - full
          - accessibility
          - performance
          - security
          - offline-sync
          - navigation
      feature_directory:
        description: 'Specific feature to audit (e.g., auth, payments)'
        required: false
        default: ''
        type: string

permissions:
  contents: read
  issues: write
  pull-requests: read

env:
  NODE_VERSION: '20'
  PNPM_VERSION: '9'

jobs:
  prepare-audit:
    name: Prepare Audit Matrix
    runs-on: ubuntu-latest
    outputs:
      audit_targets: \${{ steps.targets.outputs.matrix }}
      run_id: \${{ steps.meta.outputs.run_id }}
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Generate audit metadata
        id: meta
        run: |
          echo "run_id=audit-$(date +%Y%m%d-%H%M%S)" >> "$GITHUB_OUTPUT"

      - name: Determine audit targets
        id: targets
        run: |
          SCOPE="\${{ github.event.inputs.audit_scope || 'full' }}"
          FEATURE="\${{ github.event.inputs.feature_directory || '' }}"

          if [ -n "$FEATURE" ]; then
            echo "matrix=[\\"src/features/$FEATURE\\"]" >> "$GITHUB_OUTPUT"
          elif [ "$SCOPE" = "full" ]; then
            TARGETS=$(find src/features -mindepth 1 -maxdepth 1 -type d | sort | jq -R -s -c 'split("\\n") | map(select(length > 0))')
            # Add shared directories
            TARGETS=$(echo "$TARGETS" | jq -c '. + ["src/components", "src/hooks", "src/services", "src/navigation", "src/store"]')
            echo "matrix=$TARGETS" >> "$GITHUB_OUTPUT"
          else
            # For scoped audits, include all source directories
            TARGETS='["src"]'
            echo "matrix=$TARGETS" >> "$GITHUB_OUTPUT"
          fi

  audit-accessibility:
    name: Accessibility Audit
    runs-on: ubuntu-latest
    needs: prepare-audit
    if: >-
      github.event.inputs.audit_scope == 'accessibility' ||
      github.event.inputs.audit_scope == 'full' ||
      github.event.inputs.audit_scope == ''
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: 'pnpm'

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Scan for accessibility issues
        id: a11y_scan
        run: |
          echo "## Accessibility Scan Results" > a11y-report.md
          echo "" >> a11y-report.md
          echo "**Date:** $(date -u +%Y-%m-%dT%H:%M:%SZ)" >> a11y-report.md
          echo "**Run ID:** \${{ needs.prepare-audit.outputs.run_id }}" >> a11y-report.md
          echo "" >> a11y-report.md

          ISSUES_FOUND=0

          # Check for missing accessibilityLabel on interactive elements
          echo "### Missing Accessibility Labels" >> a11y-report.md
          echo "" >> a11y-report.md
          echo "Interactive elements (TouchableOpacity, Pressable, Button, TextInput) without \\\`accessibilityLabel\\\`:" >> a11y-report.md
          echo "" >> a11y-report.md

          TOUCHABLE_MISSING=$(grep -rn \\
            -E '<(TouchableOpacity|Pressable|TouchableHighlight|TouchableWithoutFeedback)' \\
            --include="*.tsx" src/ | \\
            grep -vE 'accessibilityLabel|accessible={false}|\\.test\\.' || true)

          if [ -n "$TOUCHABLE_MISSING" ]; then
            echo '\`\`\`' >> a11y-report.md
            echo "$TOUCHABLE_MISSING" | head -50 >> a11y-report.md
            echo '\`\`\`' >> a11y-report.md
            COUNT=$(echo "$TOUCHABLE_MISSING" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
            echo "" >> a11y-report.md
            echo "**Found $COUNT touchable elements without accessibilityLabel.**" >> a11y-report.md
          else
            echo "✅ All touchable elements have accessibility labels." >> a11y-report.md
          fi
          echo "" >> a11y-report.md

          # Check for missing accessibilityRole
          echo "### Missing Accessibility Roles" >> a11y-report.md
          echo "" >> a11y-report.md

          ROLE_MISSING=$(grep -rn \\
            -E '<(TouchableOpacity|Pressable)' \\
            --include="*.tsx" src/ | \\
            grep -vE 'accessibilityRole|accessible={false}|\\.test\\.' || true)

          if [ -n "$ROLE_MISSING" ]; then
            echo '\`\`\`' >> a11y-report.md
            echo "$ROLE_MISSING" | head -30 >> a11y-report.md
            echo '\`\`\`' >> a11y-report.md
            COUNT=$(echo "$ROLE_MISSING" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ All interactive elements have accessibility roles." >> a11y-report.md
          fi
          echo "" >> a11y-report.md

          # Check for images without alt text
          echo "### Images Without Alt Text" >> a11y-report.md
          echo "" >> a11y-report.md

          IMG_MISSING=$(grep -rn '<Image' --include="*.tsx" src/ | \\
            grep -vE 'accessibilityLabel|accessible={false}|\\.test\\.' || true)

          if [ -n "$IMG_MISSING" ]; then
            echo '\`\`\`' >> a11y-report.md
            echo "$IMG_MISSING" | head -30 >> a11y-report.md
            echo '\`\`\`' >> a11y-report.md
            COUNT=$(echo "$IMG_MISSING" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ All images have accessibility labels." >> a11y-report.md
          fi
          echo "" >> a11y-report.md

          # Check for hardcoded strings (should use i18n)
          echo "### Hardcoded User-Facing Strings" >> a11y-report.md
          echo "" >> a11y-report.md

          HARDCODED=$(grep -rn \\
            -E '>\\s*[A-Z][a-z]+(\\s+[a-z]+)+\\s*<' \\
            --include="*.tsx" src/ | \\
            grep -vE '\\.test\\.|\\.spec\\.|__tests__|i18n|translations' | head -30 || true)

          if [ -n "$HARDCODED" ]; then
            echo "Potential hardcoded strings (should use i18n \\\`t()\\\` function):" >> a11y-report.md
            echo '\`\`\`' >> a11y-report.md
            echo "$HARDCODED" >> a11y-report.md
            echo '\`\`\`' >> a11y-report.md
            COUNT=$(echo "$HARDCODED" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ No obvious hardcoded strings found." >> a11y-report.md
          fi
          echo "" >> a11y-report.md

          # Check for color contrast (basic: hardcoded light colors on white backgrounds)
          echo "### Potential Color Contrast Issues" >> a11y-report.md
          echo "" >> a11y-report.md

          LIGHT_COLORS=$(grep -rn \\
            -E "color:\\s*['\\"]#[fFeEdD][fFeEdD][fFeEdD]" \\
            --include="*.ts" --include="*.tsx" src/ | \\
            grep -vE '\\.test\\.|background|Background|bg|Bg' | head -20 || true)

          if [ -n "$LIGHT_COLORS" ]; then
            echo "Potential low-contrast text colors:" >> a11y-report.md
            echo '\`\`\`' >> a11y-report.md
            echo "$LIGHT_COLORS" >> a11y-report.md
            echo '\`\`\`' >> a11y-report.md
          else
            echo "✅ No obvious low-contrast text colors found." >> a11y-report.md
          fi
          echo "" >> a11y-report.md

          echo "---" >> a11y-report.md
          echo "**Total potential issues: $ISSUES_FOUND**" >> a11y-report.md

          echo "issues_found=$ISSUES_FOUND" >> "$GITHUB_OUTPUT"

      - name: Upload accessibility report
        uses: actions/upload-artifact@v4
        with:
          name: a11y-report
          path: a11y-report.md
          retention-days: 30

  audit-performance:
    name: Performance Audit
    runs-on: ubuntu-latest
    needs: prepare-audit
    if: >-
      github.event.inputs.audit_scope == 'performance' ||
      github.event.inputs.audit_scope == 'full' ||
      github.event.inputs.audit_scope == ''
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: 'pnpm'

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Analyze performance patterns
        id: perf_scan
        run: |
          echo "## Performance Audit Results" > perf-report.md
          echo "" >> perf-report.md
          echo "**Date:** $(date -u +%Y-%m-%dT%H:%M:%SZ)" >> perf-report.md
          echo "" >> perf-report.md

          ISSUES_FOUND=0

          # Check for inline functions in render (common perf issue)
          echo "### Inline Arrow Functions in JSX Props" >> perf-report.md
          echo "" >> perf-report.md
          echo "Inline functions cause unnecessary re-renders. Use \\\`useCallback\\\` instead." >> perf-report.md
          echo "" >> perf-report.md

          INLINE_FNS=$(grep -rn \\
            -E 'onPress=\\{(\\(\\) =>|\\(\\w+\\) =>)' \\
            --include="*.tsx" src/ | \\
            grep -vE '\\.test\\.|\\.spec\\.' | head -30 || true)

          if [ -n "$INLINE_FNS" ]; then
            echo '\`\`\`' >> perf-report.md
            echo "$INLINE_FNS" >> perf-report.md
            echo '\`\`\`' >> perf-report.md
            COUNT=$(echo "$INLINE_FNS" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ No inline arrow functions in onPress handlers." >> perf-report.md
          fi
          echo "" >> perf-report.md

          # Check for missing React.memo on list item components
          echo "### List Item Components Without React.memo" >> perf-report.md
          echo "" >> perf-report.md

          LIST_ITEMS=$(find src/ -name "*Item.tsx" -o -name "*ListItem.tsx" -o -name "*Cell.tsx" | \\
            while read -r file; do
              if ! grep -q 'React\\.memo\\|memo(' "$file" 2>/dev/null; then
                echo "$file"
              fi
            done || true)

          if [ -n "$LIST_ITEMS" ]; then
            echo "List item components should be wrapped in \\\`React.memo\\\` for FlatList performance:" >> perf-report.md
            echo '\`\`\`' >> perf-report.md
            echo "$LIST_ITEMS" >> perf-report.md
            echo '\`\`\`' >> perf-report.md
            COUNT=$(echo "$LIST_ITEMS" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ All list item components use React.memo." >> perf-report.md
          fi
          echo "" >> perf-report.md

          # Check for FlatList without keyExtractor or getItemLayout
          echo "### FlatList Missing Optimizations" >> perf-report.md
          echo "" >> perf-report.md

          FLATLIST_FILES=$(grep -rln 'FlatList\\|SectionList' --include="*.tsx" src/ || true)
          for file in $FLATLIST_FILES; do
            MISSING=""
            if ! grep -q 'keyExtractor' "$file" 2>/dev/null; then
              MISSING="keyExtractor"
            fi
            if ! grep -q 'getItemLayout' "$file" 2>/dev/null; then
              MISSING="$MISSING\${MISSING:+, }getItemLayout"
            fi
            if [ -n "$MISSING" ]; then
              echo "- \\\`$file\\\`: missing $MISSING" >> perf-report.md
              ISSUES_FOUND=$((ISSUES_FOUND + 1))
            fi
          done

          if [ -z "$FLATLIST_FILES" ]; then
            echo "✅ No FlatList optimization issues found." >> perf-report.md
          fi
          echo "" >> perf-report.md

          # Check for large component files (>250 lines)
          echo "### Oversized Components (>250 lines)" >> perf-report.md
          echo "" >> perf-report.md

          LARGE_FILES=$(find src/ -name "*.tsx" -not -path "*__tests__*" -not -path "*.test.*" | \\
            while read -r file; do
              LINES=$(wc -l < "$file")
              if [ "$LINES" -gt 250 ]; then
                echo "$file ($LINES lines)"
              fi
            done | sort -t'(' -k2 -rn || true)

          if [ -n "$LARGE_FILES" ]; then
            echo "Components exceeding 250-line limit should be split:" >> perf-report.md
            echo '\`\`\`' >> perf-report.md
            echo "$LARGE_FILES" >> perf-report.md
            echo '\`\`\`' >> perf-report.md
            COUNT=$(echo "$LARGE_FILES" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ All components are within the 250-line limit." >> perf-report.md
          fi
          echo "" >> perf-report.md

          # Check for unnecessary re-renders (useState with objects)
          echo "### Potential Unnecessary Re-renders" >> perf-report.md
          echo "" >> perf-report.md

          OBJECT_STATE=$(grep -rn \\
            -E 'useState\\(\\{|useState\\(\\[' \\
            --include="*.ts" --include="*.tsx" src/ | \\
            grep -vE '\\.test\\.|\\.spec\\.' | head -20 || true)

          if [ -n "$OBJECT_STATE" ]; then
            echo "Object/array state may cause re-renders if not memoized properly:" >> perf-report.md
            echo '\`\`\`' >> perf-report.md
            echo "$OBJECT_STATE" >> perf-report.md
            echo '\`\`\`' >> perf-report.md
          else
            echo "✅ No obvious object state re-render issues." >> perf-report.md
          fi
          echo "" >> perf-report.md

          # Check bundle size indicators
          echo "### Heavy Import Analysis" >> perf-report.md
          echo "" >> perf-report.md

          HEAVY_IMPORTS=$(grep -rn \\
            -E "import .+ from '(lodash|moment|date-fns)'" \\
            --include="*.ts" --include="*.tsx" src/ | \\
            grep -vE 'lodash/' | head -20 || true)

          if [ -n "$HEAVY_IMPORTS" ]; then
            echo "Full library imports increase bundle size. Use specific imports:" >> perf-report.md
            echo '\`\`\`' >> perf-report.md
            echo "$HEAVY_IMPORTS" >> perf-report.md
            echo '\`\`\`' >> perf-report.md
          else
            echo "✅ No heavy full-library imports detected." >> perf-report.md
          fi
          echo "" >> perf-report.md

          echo "---" >> perf-report.md
          echo "**Total potential issues: $ISSUES_FOUND**" >> perf-report.md

          echo "issues_found=$ISSUES_FOUND" >> "$GITHUB_OUTPUT"

      - name: Upload performance report
        uses: actions/upload-artifact@v4
        with:
          name: perf-report
          path: perf-report.md
          retention-days: 30

  audit-security:
    name: Security Audit
    runs-on: ubuntu-latest
    needs: prepare-audit
    if: >-
      github.event.inputs.audit_scope == 'security' ||
      github.event.inputs.audit_scope == 'full' ||
      github.event.inputs.audit_scope == ''
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: 'pnpm'

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Run security pattern analysis
        id: security_scan
        run: |
          echo "## Security Audit Results" > security-report.md
          echo "" >> security-report.md
          echo "**Date:** $(date -u +%Y-%m-%dT%H:%M:%SZ)" >> security-report.md
          echo "" >> security-report.md

          ISSUES_FOUND=0

          # Check for secrets/keys in source
          echo "### Hardcoded Secrets & API Keys" >> security-report.md
          echo "" >> security-report.md

          SECRETS=$(grep -rn \\
            -E '(api[_-]?key|secret|password|token|private[_-]?key)\\s*[:=]\\s*["\\x27][A-Za-z0-9+/=]{16,}' \\
            --include="*.ts" --include="*.tsx" --include="*.js" src/ | \\
            grep -viE '(\\.test\\.|\\.spec\\.|mock|example|placeholder|process\\.env|Config\\.)' | head -20 || true)

          if [ -n "$SECRETS" ]; then
            echo "🚨 **CRITICAL:** Potential hardcoded secrets found:" >> security-report.md
            echo '\`\`\`' >> security-report.md
            echo "$SECRETS" >> security-report.md
            echo '\`\`\`' >> security-report.md
            COUNT=$(echo "$SECRETS" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ No hardcoded secrets detected." >> security-report.md
          fi
          echo "" >> security-report.md

          # Check for insecure storage usage
          echo "### Insecure Storage Usage" >> security-report.md
          echo "" >> security-report.md

          INSECURE_STORAGE=$(grep -rn \\
            -E 'AsyncStorage\\.(setItem|getItem).*([Tt]oken|[Pp]assword|[Ss]ecret|[Kk]ey|[Cc]redential)' \\
            --include="*.ts" --include="*.tsx" src/ | \\
            grep -vE '\\.test\\.|\\.spec\\.' | head -20 || true)

          if [ -n "$INSECURE_STORAGE" ]; then
            echo "🚨 **HIGH:** Sensitive data stored in AsyncStorage (use expo-secure-store or Keychain/Keystore):" >> security-report.md
            echo '\`\`\`' >> security-report.md
            echo "$INSECURE_STORAGE" >> security-report.md
            echo '\`\`\`' >> security-report.md
            COUNT=$(echo "$INSECURE_STORAGE" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ No sensitive data in AsyncStorage." >> security-report.md
          fi
          echo "" >> security-report.md

          # Check for HTTP (non-HTTPS) URLs
          echo "### Insecure HTTP URLs" >> security-report.md
          echo "" >> security-report.md

          HTTP_URLS=$(grep -rn \\
            -E "http://[^l][^o][^c]" \\
            --include="*.ts" --include="*.tsx" src/ | \\
            grep -vE '\\.test\\.|\\.spec\\.|localhost|127\\.0\\.0\\.1|10\\.0\\.' | head -20 || true)

          if [ -n "$HTTP_URLS" ]; then
            echo "⚠️ Non-HTTPS URLs found (App Transport Security will block these on iOS):" >> security-report.md
            echo '\`\`\`' >> security-report.md
            echo "$HTTP_URLS" >> security-report.md
            echo '\`\`\`' >> security-report.md
            COUNT=$(echo "$HTTP_URLS" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ All URLs use HTTPS." >> security-report.md
          fi
          echo "" >> security-report.md

          # Check for console.log with sensitive data
          echo "### Console Logging Sensitive Data" >> security-report.md
          echo "" >> security-report.md

          CONSOLE_SENSITIVE=$(grep -rn \\
            -E 'console\\.(log|warn|error|info).*([Tt]oken|[Pp]assword|[Ss]ecret|[Cc]redential|[Aa]uth)' \\
            --include="*.ts" --include="*.tsx" src/ | \\
            grep -vE '\\.test\\.|\\.spec\\.' | head -20 || true)

          if [ -n "$CONSOLE_SENSITIVE" ]; then
            echo "⚠️ Console statements may leak sensitive data in production:" >> security-report.md
            echo '\`\`\`' >> security-report.md
            echo "$CONSOLE_SENSITIVE" >> security-report.md
            echo '\`\`\`' >> security-report.md
            COUNT=$(echo "$CONSOLE_SENSITIVE" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ No sensitive data in console statements." >> security-report.md
          fi
          echo "" >> security-report.md

          # Check for eval or dynamic code execution
          echo "### Dynamic Code Execution" >> security-report.md
          echo "" >> security-report.md

          EVAL_USAGE=$(grep -rn \\
            -E '\\beval\\s*\\(|new\\s+Function\\s*\\(' \\
            --include="*.ts" --include="*.tsx" --include="*.js" src/ | \\
            grep -vE '\\.test\\.|\\.spec\\.' | head -10 || true)

          if [ -n "$EVAL_USAGE" ]; then
            echo "🚨 **CRITICAL:** eval() or dynamic Function() usage found:" >> security-report.md
            echo '\`\`\`' >> security-report.md
            echo "$EVAL_USAGE" >> security-report.md
            echo '\`\`\`' >> security-report.md
            COUNT=$(echo "$EVAL_USAGE" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ No eval() or dynamic code execution." >> security-report.md
          fi
          echo "" >> security-report.md

          # Check for deep link validation
          echo "### Deep Link Security" >> security-report.md
          echo "" >> security-report.md

          DEEPLINK_FILES=$(grep -rln 'Linking\\|useURL\\|useLinking\\|linking:' --include="*.ts" --include="*.tsx" src/ || true)
          if [ -n "$DEEPLINK_FILES" ]; then
            UNVALIDATED=""
            for file in $DEEPLINK_FILES; do
              if ! grep -q 'validate\\|sanitize\\|whitelist\\|allowlist' "$file" 2>/dev/null; then
                UNVALIDATED="$UNVALIDATED\\n$file"
              fi
            done
            if [ -n "$UNVALIDATED" ]; then
              echo "⚠️ Deep link handlers without visible input validation:" >> security-report.md
              echo '\`\`\`' >> security-report.md
              echo -e "$UNVALIDATED" >> security-report.md
              echo '\`\`\`' >> security-report.md
            else
              echo "✅ Deep link handlers appear to validate input." >> security-report.md
            fi
          else
            echo "ℹ️ No deep link handlers found." >> security-report.md
          fi
          echo "" >> security-report.md

          # Dependency audit
          echo "### Dependency Vulnerabilities" >> security-report.md
          echo "" >> security-report.md

          pnpm audit --json > audit-output.json 2>/dev/null || true
          VULN_COUNT=$(jq '.metadata.vulnerabilities.high + .metadata.vulnerabilities.critical' audit-output.json 2>/dev/null || echo "0")

          if [ "$VULN_COUNT" -gt 0 ] 2>/dev/null; then
            echo "🚨 **$VULN_COUNT high/critical vulnerabilities** found in dependencies." >> security-report.md
            echo "" >> security-report.md
            echo "Run \\\`pnpm audit\\\` for details." >> security-report.md
            ISSUES_FOUND=$((ISSUES_FOUND + VULN_COUNT))
          else
            echo "✅ No high/critical dependency vulnerabilities." >> security-report.md
          fi
          echo "" >> security-report.md

          echo "---" >> security-report.md
          echo "**Total potential issues: $ISSUES_FOUND**" >> security-report.md

          echo "issues_found=$ISSUES_FOUND" >> "$GITHUB_OUTPUT"

      - name: Upload security report
        uses: actions/upload-artifact@v4
        with:
          name: security-report
          path: security-report.md
          retention-days: 30

  audit-offline-sync:
    name: Offline & Sync Audit
    runs-on: ubuntu-latest
    needs: prepare-audit
    if: >-
      github.event.inputs.audit_scope == 'offline-sync' ||
      github.event.inputs.audit_scope == 'full' ||
      github.event.inputs.audit_scope == ''
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Analyze offline-first patterns
        id: offline_scan
        run: |
          echo "## Offline & Sync Audit Results" > offline-report.md
          echo "" >> offline-report.md
          echo "**Date:** $(date -u +%Y-%m-%dT%H:%M:%SZ)" >> offline-report.md
          echo "" >> offline-report.md

          ISSUES_FOUND=0

          # Check for network calls without offline handling
          echo "### Network Calls Without Offline Handling" >> offline-report.md
          echo "" >> offline-report.md

          FETCH_CALLS=$(grep -rn \\
            -E '(fetch\\(|axios\\.|\\.get\\(|\\.post\\(|\\.put\\(|\\.delete\\()' \\
            --include="*.ts" --include="*.tsx" src/ | \\
            grep -vE '\\.test\\.|\\.spec\\.|react-query|useQuery|useMutation|tanstack' | head -20 || true)

          if [ -n "$FETCH_CALLS" ]; then
            echo "Direct network calls found outside React Query (may lack offline handling):" >> offline-report.md
            echo '\`\`\`' >> offline-report.md
            echo "$FETCH_CALLS" >> offline-report.md
            echo '\`\`\`' >> offline-report.md
            COUNT=$(echo "$FETCH_CALLS" | wc -l)
            ISSUES_FOUND=$((ISSUES_FOUND + COUNT))
          else
            echo "✅ All network calls go through React Query." >> offline-report.md
          fi
          echo "" >> offline-report.md

          # Check WatermelonDB model consistency
          echo "### WatermelonDB Model Coverage" >> offline-report.md
          echo "" >> offline-report.md

          MODEL_FILES=$(find src/ -name "*.model.ts" -o -name "*Model.ts" 2>/dev/null | wc -l || echo "0")
          SCHEMA_FILES=$(find src/ -name "schema.ts" -o -name "*.schema.ts" 2>/dev/null | wc -l || echo "0")

          echo "- Model files found: $MODEL_FILES" >> offline-report.md
          echo "- Schema files found: $SCHEMA_FILES" >> offline-report.md

          if [ "$MODEL_FILES" -eq 0 ]; then
            echo "" >> offline-report.md
            echo "⚠️ No WatermelonDB models found. Ensure offline-first architecture is implemented." >> offline-report.md
            ISSUES_FOUND=$((ISSUES_FOUND + 1))
          fi
          echo "" >> offline-report.md

          # Check for sync implementation
          echo "### Sync Implementation" >> offline-report.md
          echo "" >> offline-report.md

          SYNC_FILES=$(grep -rln 'synchronize\\|pullChanges\\|pushChanges' --include="*.ts" --include="*.tsx" src/ || true)
          if [ -n "$SYNC_FILES" ]; then
            echo "Sync implementation found in:" >> offline-report.md
            echo '\`\`\`' >> offline-report.md
            echo "$SYNC_FILES" >> offline-report.md
            echo '\`\`\`' >> offline-report.md

            # Check for conflict resolution
            HAS_CONFLICT=$(grep -rn 'conflictResolver\\|resolveConflict\\|onConflict' --include="*.ts" src/ || true)
            if [ -z "$HAS_CONFLICT" ]; then
              echo "" >> offline-report.md
              echo "⚠️ No explicit conflict resolution strategy found." >> offline-report.md
              ISSUES_FOUND=$((ISSUES_FOUND + 1))
            fi
          else
            echo "⚠️ No WatermelonDB sync implementation found." >> offline-report.md
            ISSUES_FOUND=$((ISSUES_FOUND + 1))
          fi
          echo "" >> offline-report.md

          # Check for NetInfo usage (connectivity awareness)
          echo "### Connectivity Awareness" >> offline-report.md
          echo "" >> offline-report.md`,

  '.github/workflows/ci.yml': `name: CI

on:
  pull_request:
    branches: [main]
  push:
    branches: [main]

concurrency:
  group: ci-\${{ github.ref }}
  cancel-in-progress: true

env:
  NODE_VERSION: '20'
  PNPM_VERSION: '9'

jobs:
  lint:
    name: ESLint
    runs-on: ubuntu-latest
    timeout-minutes: 10
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: 'pnpm'

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Run ESLint
        run: pnpm eslint src/ e2e/ --ext .ts,.tsx --max-warnings 0 --format github

  typecheck:
    name: TypeScript
    runs-on: ubuntu-latest
    timeout-minutes: 10
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: 'pnpm'

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Run TypeScript compiler
        run: pnpm tsc --noEmit

  test:
    name: Unit & Component Tests
    runs-on: ubuntu-latest
    timeout-minutes: 15
    needs: [lint, typecheck]
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: 'pnpm'

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Run Jest tests
        run: pnpm test -- --ci --forceExit --detectOpenHandles --coverage --coverageReporters=text --coverageReporters=lcov --coverageReporters=json-summary
        env:
          CI: true

      - name: Check coverage thresholds
        run: |
          COVERAGE_FILE="coverage/coverage-summary.json"
          if [ ! -f "$COVERAGE_FILE" ]; then
            echo "::error::Coverage summary not found at $COVERAGE_FILE"
            exit 1
          fi

          THRESHOLD=75

          LINES=$(node -e "const c = require('./$COVERAGE_FILE'); console.log(c.total.lines.pct)")
          BRANCHES=$(node -e "const c = require('./$COVERAGE_FILE'); console.log(c.total.branches.pct)")
          FUNCTIONS=$(node -e "const c = require('./$COVERAGE_FILE'); console.log(c.total.functions.pct)")
          STATEMENTS=$(node -e "const c = require('./$COVERAGE_FILE'); console.log(c.total.statements.pct)")

          echo "## Coverage Report" >> $GITHUB_STEP_SUMMARY
          echo "| Metric | Coverage | Threshold | Status |" >> $GITHUB_STEP_SUMMARY
          echo "|--------|----------|-----------|--------|" >> $GITHUB_STEP_SUMMARY

          FAILED=0

          for METRIC in LINES BRANCHES FUNCTIONS STATEMENTS; do
            VALUE=\${!METRIC}
            LABEL=$(echo "$METRIC" | tr '[:upper:]' '[:lower:]')
            if (( $(echo "$VALUE < $THRESHOLD" | bc -l) )); then
              echo "| $LABEL | \${VALUE}% | \${THRESHOLD}% | ❌ |" >> $GITHUB_STEP_SUMMARY
              echo "::error::\${LABEL} coverage \${VALUE}% is below threshold \${THRESHOLD}%"
              FAILED=1
            else
              echo "| $LABEL | \${VALUE}% | \${THRESHOLD}% | ✅ |" >> $GITHUB_STEP_SUMMARY
            fi
          done

          if [ "$FAILED" -eq 1 ]; then
            exit 1
          fi

      - name: Upload coverage artifact
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: coverage-report
          path: coverage/lcov-report/
          retention-days: 14

      - name: Comment coverage on PR
        if: github.event_name == 'pull_request'
        uses: actions/github-script@v7
        with:
          script: |
            const fs = require('fs');
            const coveragePath = 'coverage/coverage-summary.json';
            if (!fs.existsSync(coveragePath)) return;

            const coverage = JSON.parse(fs.readFileSync(coveragePath, 'utf8'));
            const total = coverage.total;

            const badge = (pct) => pct >= 90 ? '🟢' : pct >= 75 ? '🟡' : '🔴';

            const body = \`## 📊 Test Coverage Report

            | Metric | Coverage | Status |
            |--------|----------|--------|
            | Statements | \${total.statements.pct}% | \${badge(total.statements.pct)} |
            | Branches | \${total.branches.pct}% | \${badge(total.branches.pct)} |
            | Functions | \${total.functions.pct}% | \${badge(total.functions.pct)} |
            | Lines | \${total.lines.pct}% | \${badge(total.lines.pct)} |

            > Threshold: **75%** · Generated by CI\`;

            const { data: comments } = await github.rest.issues.listComments({
              owner: context.repo.owner,
              repo: context.repo.repo,
              issue_number: context.issue.number,
            });

            const existing = comments.find(c =>
              c.user.type === 'Bot' && c.body.includes('📊 Test Coverage Report')
            );

            if (existing) {
              await github.rest.issues.updateComment({
                owner: context.repo.owner,
                repo: context.repo.repo,
                comment_id: existing.id,
                body,
              });
            } else {
              await github.rest.issues.createComment({
                owner: context.repo.owner,
                repo: context.repo.repo,
                issue_number: context.issue.number,
                body,
              });
            }

  expo-doctor:
    name: Expo Doctor
    runs-on: ubuntu-latest
    timeout-minutes: 10
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: 'pnpm'

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Run Expo Doctor
        run: npx expo-doctor

  sensitive-files:
    name: Sensitive File Check
    runs-on: ubuntu-latest
    timeout-minutes: 5
    if: github.event_name == 'pull_request'
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Check for sensitive file changes
        uses: actions/github-script@v7
        with:
          script: |
            const sensitivePatterns = [
              'src/services/auth/',
              'src/config/',
              'google-services.json',
              'GoogleService-Info.plist',
              '.env',
              'eas.json',
              'app.config.ts',
              'app.config.js',
            ];

            const { data: files } = await github.rest.pulls.listFiles({
              owner: context.repo.owner,
              repo: context.repo.repo,
              pull_number: context.issue.number,
            });

            const sensitiveChanges = files.filter(f =>
              sensitivePatterns.some(p => f.filename.includes(p))
            );

            if (sensitiveChanges.length > 0) {
              const fileList = sensitiveChanges.map(f => \`- \\\`\${f.filename}\\\` (\${f.status})\`).join('\\n');

              await github.rest.issues.addLabels({
                owner: context.repo.owner,
                repo: context.repo.repo,
                issue_number: context.issue.number,
                labels: ['sensitive-change'],
              });

              const body = \`## ⚠️ Sensitive Files Modified

            This PR modifies files in sensitive paths that require careful review:

            \${fileList}

            **Reviewers**: Please verify these changes follow security guidelines. See \\\`.claude/rules/common/security.md\\\` for details.\`;

              await github.rest.issues.createComment({
                owner: context.repo.owner,
                repo: context.repo.repo,
                issue_number: context.issue.number,
                body,
              });
            }

  ci-status:
    name: CI Status
    runs-on: ubuntu-latest
    timeout-minutes: 5
    needs: [lint, typecheck, test, expo-doctor]
    if: always()
    steps:
      - name: Check job results
        run: |
          if [[ "\${{ needs.lint.result }}" == "failure" || \\
                "\${{ needs.typecheck.result }}" == "failure" || \\
                "\${{ needs.test.result }}" == "failure" || \\
                "\${{ needs.expo-doctor.result }}" == "failure" ]]; then
            echo "::error::One or more CI jobs failed"
            echo "  lint: \${{ needs.lint.result }}"
            echo "  typecheck: \${{ needs.typecheck.result }}"
            echo "  test: \${{ needs.test.result }}"
            echo "  expo-doctor: \${{ needs.expo-doctor.result }}"
            exit 1
          fi
          echo "All CI checks passed ✅"`,

  '.github/workflows/deploy-production.yml': `name: Deploy Production

on:
  workflow_dispatch:
    inputs:
      platform:
        description: 'Target platform'
        required: true
        type: choice
        options:
          - all
          - ios
          - android
      version_bump:
        description: 'Version bump type'
        required: true
        type: choice
        options:
          - patch
          - minor
          - major
      submit_to_stores:
        description: 'Submit to App Store / Google Play after build'
        required: true
        type: boolean
        default: true
      release_notes:
        description: 'Release notes for this version'
        required: true
        type: string
      skip_e2e:
        description: 'Skip E2E tests (emergency hotfix only)'
        required: false
        type: boolean
        default: false

concurrency:
  group: production-deploy
  cancel-in-progress: false

env:
  NODE_VERSION: '20'
  PNPM_VERSION: '9'
  EXPO_TOKEN: \${{ secrets.EXPO_TOKEN }}
  EAS_BUILD_PROFILE: production

jobs:
  # ──────────────────────────────────────────────
  # Gate: require manual approval via environment
  # ──────────────────────────────────────────────
  approve:
    name: Approval Gate
    runs-on: ubuntu-latest
    environment: production
    steps:
      - name: Approval confirmed
        run: echo "Production deployment approved by \${{ github.actor }}"

  # ──────────────────────────────────────────────
  # Validate: lint, type-check, unit & component tests
  # ──────────────────────────────────────────────
  validate:
    name: Validate
    needs: approve
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: pnpm

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Lint
        run: pnpm lint

      - name: Type check
        run: pnpm tsc --noEmit

      - name: Unit & component tests
        run: pnpm test -- --coverage --ci --reporters=default --reporters=jest-junit
        env:
          JEST_JUNIT_OUTPUT_DIR: ./reports/junit

      - name: Check coverage threshold
        run: |
          COVERAGE=$(cat coverage/coverage-summary.json | jq '.total.lines.pct')
          echo "Line coverage: \${COVERAGE}%"
          if (( $(echo "$COVERAGE < 75" | bc -l) )); then
            echo "::error::Coverage \${COVERAGE}% is below the 75% threshold"
            exit 1
          fi

      - name: Upload test reports
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: test-reports
          path: |
            reports/
            coverage/

  # ──────────────────────────────────────────────
  # Version bump & tag
  # ──────────────────────────────────────────────
  version:
    name: Bump Version
    needs: validate
    runs-on: ubuntu-latest
    outputs:
      version: \${{ steps.bump.outputs.version }}
      build_number: \${{ steps.bump.outputs.build_number }}
      tag: \${{ steps.bump.outputs.tag }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          fetch-depth: 0
          token: \${{ secrets.GITHUB_TOKEN }}

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: pnpm

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Setup EAS CLI
        run: pnpm add -g eas-cli

      - name: Bump version
        id: bump
        run: |
          # Read current version from app.json
          CURRENT_VERSION=$(jq -r '.expo.version' app.json)
          echo "Current version: \${CURRENT_VERSION}"

          IFS='.' read -r MAJOR MINOR PATCH <<< "\${CURRENT_VERSION}"

          case "\${{ inputs.version_bump }}" in
            major) MAJOR=$((MAJOR + 1)); MINOR=0; PATCH=0 ;;
            minor) MINOR=$((MINOR + 1)); PATCH=0 ;;
            patch) PATCH=$((PATCH + 1)) ;;
          esac

          NEW_VERSION="\${MAJOR}.\${MINOR}.\${PATCH}"

          # Generate build number from run number for uniqueness
          BUILD_NUMBER=\${{ github.run_number }}

          # Update app.json
          jq --arg v "\${NEW_VERSION}" --arg bn "\${BUILD_NUMBER}" \\
            '.expo.version = $v | .expo.ios.buildNumber = $bn | .expo.android.versionCode = ($bn | tonumber)' \\
            app.json > app.json.tmp && mv app.json.tmp app.json

          echo "version=\${NEW_VERSION}" >> "$GITHUB_OUTPUT"
          echo "build_number=\${BUILD_NUMBER}" >> "$GITHUB_OUTPUT"
          echo "tag=v\${NEW_VERSION}" >> "$GITHUB_OUTPUT"

          echo "New version: \${NEW_VERSION} (build \${BUILD_NUMBER})"

      - name: Commit version bump
        run: |
          git config user.name "github-actions[bot]"
          git config user.email "github-actions[bot]@users.noreply.github.com"
          git add app.json
          git commit -m "chore: bump version to \${{ steps.bump.outputs.version }} [skip ci]"
          git tag "\${{ steps.bump.outputs.tag }}"
          git push origin main --tags

  # ──────────────────────────────────────────────
  # EAS Build — iOS
  # ──────────────────────────────────────────────
  build-ios:
    name: Build iOS
    needs: version
    if: inputs.platform == 'all' || inputs.platform == 'ios'
    runs-on: ubuntu-latest
    outputs:
      build_id: \${{ steps.build.outputs.build_id }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.version.outputs.tag }}

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: pnpm

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Setup EAS CLI
        run: pnpm add -g eas-cli

      - name: Build iOS
        id: build
        run: |
          BUILD_OUTPUT=$(eas build \\
            --platform ios \\
            --profile production \\
            --non-interactive \\
            --json)

          BUILD_ID=$(echo "$BUILD_OUTPUT" | jq -r '.[0].id')
          echo "build_id=\${BUILD_ID}" >> "$GITHUB_OUTPUT"
          echo "iOS build started: \${BUILD_ID}"

      - name: Wait for iOS build
        run: |
          echo "Waiting for iOS build \${{ steps.build.outputs.build_id }}..."
          eas build:view \${{ steps.build.outputs.build_id }} --json | jq '.status'

          # Poll until build completes
          while true; do
            STATUS=$(eas build:view \${{ steps.build.outputs.build_id }} --json | jq -r '.status')
            echo "Build status: \${STATUS}"
            if [ "$STATUS" = "FINISHED" ]; then
              echo "iOS build completed successfully"
              break
            elif [ "$STATUS" = "ERRORED" ] || [ "$STATUS" = "CANCELED" ]; then
              echo "::error::iOS build failed with status: \${STATUS}"
              exit 1
            fi
            sleep 30
          done

  # ──────────────────────────────────────────────
  # EAS Build — Android
  # ──────────────────────────────────────────────
  build-android:
    name: Build Android
    needs: version
    if: inputs.platform == 'all' || inputs.platform == 'android'
    runs-on: ubuntu-latest
    outputs:
      build_id: \${{ steps.build.outputs.build_id }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.version.outputs.tag }}

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: pnpm

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Setup EAS CLI
        run: pnpm add -g eas-cli

      - name: Build Android
        id: build
        run: |
          BUILD_OUTPUT=$(eas build \\
            --platform android \\
            --profile production \\
            --non-interactive \\
            --json)

          BUILD_ID=$(echo "$BUILD_OUTPUT" | jq -r '.[0].id')
          echo "build_id=\${BUILD_ID}" >> "$GITHUB_OUTPUT"
          echo "Android build started: \${BUILD_ID}"

      - name: Wait for Android build
        run: |
          echo "Waiting for Android build \${{ steps.build.outputs.build_id }}..."

          while true; do
            STATUS=$(eas build:view \${{ steps.build.outputs.build_id }} --json | jq -r '.status')
            echo "Build status: \${STATUS}"
            if [ "$STATUS" = "FINISHED" ]; then
              echo "Android build completed successfully"
              break
            elif [ "$STATUS" = "ERRORED" ] || [ "$STATUS" = "CANCELED" ]; then
              echo "::error::Android build failed with status: \${STATUS}"
              exit 1
            fi
            sleep 30
          done

  # ──────────────────────────────────────────────
  # E2E Tests (Detox) — runs against staging build
  # ──────────────────────────────────────────────
  e2e-tests:
    name: E2E Tests (Detox)
    needs: [version, build-ios, build-android]
    if: |
      !inputs.skip_e2e &&
      always() &&
      (needs.build-ios.result == 'success' || needs.build-ios.result == 'skipped') &&
      (needs.build-android.result == 'success' || needs.build-android.result == 'skipped') &&
      (needs.build-ios.result == 'success' || needs.build-android.result == 'success')
    runs-on: macos-14
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.version.outputs.tag }}

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: pnpm

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Install Detox CLI
        run: pnpm add -g detox-cli

      - name: Install applesimutils
        run: brew tap wix/brew && brew install applesimutils

      - name: Build Detox (iOS release)
        run: npx detox build --configuration ios.sim.release

      - name: Run Detox E2E tests
        run: npx detox test --configuration ios.sim.release --cleanup --headless --record-logs all
        env:
          FIREBASE_ENV: staging

      - name: Upload E2E artifacts
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: detox-artifacts
          path: artifacts/
          retention-days: 14

  # ──────────────────────────────────────────────
  # Submit iOS to App Store Connect
  # ──────────────────────────────────────────────
  submit-ios:
    name: Submit to App Store
    needs: [version, build-ios, e2e-tests]
    if: |
      inputs.submit_to_stores &&
      (inputs.platform == 'all' || inputs.platform == 'ios') &&
      always() &&
      needs.build-ios.result == 'success' &&
      (needs.e2e-tests.result == 'success' || needs.e2e-tests.result == 'skipped')
    runs-on: ubuntu-latest
    environment: app-store
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.version.outputs.tag }}

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: pnpm

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Setup EAS CLI
        run: pnpm add -g eas-cli

      - name: Submit to App Store Connect
        run: |
          eas submit \\
            --platform ios \\
            --profile production \\
            --non-interactive \\
            --latest
        env:
          EXPO_APPLE_APP_SPECIFIC_PASSWORD: \${{ secrets.APPLE_APP_SPECIFIC_PASSWORD }}

      - name: Notify — iOS submission complete
        if: success()
        run: |
          echo "::notice::iOS v\${{ needs.version.outputs.version }} submitted to App Store Connect for review"

  # ──────────────────────────────────────────────
  # Submit Android to Google Play
  # ──────────────────────────────────────────────
  submit-android:
    name: Submit to Google Play
    needs: [version, build-android, e2e-tests]
    if: |
      inputs.submit_to_stores &&
      (inputs.platform == 'all' || inputs.platform == 'android') &&
      always() &&
      needs.build-android.result == 'success' &&
      (needs.e2e-tests.result == 'success' || needs.e2e-tests.result == 'skipped')
    runs-on: ubuntu-latest
    environment: google-play
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.version.outputs.tag }}

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: \${{ env.PNPM_VERSION }}

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: \${{ env.NODE_VERSION }}
          cache: pnpm

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Setup EAS CLI
        run: pnpm add -g eas-cli

      - name: Submit to Google Play (production track)
        run: |
          eas submit \\
            --platform android \\
            --profile production \\
            --non-interactive \\
            --latest

      - name: Notify — Android submission complete
        if: success()
        run: |
          echo "::notice::Android v\${{ needs.version.outputs.version }} submitted to Google Play production track"

  # ──────────────────────────────────────────────
  # Create GitHub Release
  # ──────────────────────────────────────────────
  release:
    name: Create Release
    needs: [version, build-ios, build-android, submit-ios, submit-android]
    if: always() && needs.version.result == 'success'
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.version.outputs.tag }}
          fetch-depth: 0

      - name: Generate changelog
        id: changelog
        run: |
          # Get commits since last tag
          PREV_TAG=$(git tag --sort=-v:refname | head -2 | tail -1)
          if [ -z "$PREV_TAG" ]; then
            COMMITS=$(git log --oneline --pretty=format:"- %s (%h)" HEAD)
          else
            COMMITS=$(git log --oneline --pretty=format:"- %s (%h)" "\${PREV_TAG}..HEAD")
          fi

          {
            echo "changelog<<EOF"
            echo "## What's Changed"
            echo ""
            echo "$COMMITS"
            echo ""
            echo "## Release Notes"
            echo ""
            echo "\${{ inputs.release_notes }}"
            echo ""
            echo "## Build Info"
            echo ""
            echo "- **Version**: \${{ needs.version.outputs.version }}"
            echo "- **Build Number**: \${{ needs.version.outputs.build_number }}"
            echo "- **Platform**: \${{ inputs.platform }}"
            echo "- **iOS Build**: \${{ needs.build-ios.result || 'skipped' }}"
            echo "- **Android Build**: \${{ needs.build-android.result || 'skipped' }}"
            echo "- **iOS Submission**: \${{ needs.submit-ios.result || 'skipped' }}"
            echo "- **Android Submission**: \${{ needs.submit-android.result || 'skipped' }}"
            echo "- **Deployed by**: @\${{ github.actor }}"
            echo "EOF"
          } >> "$GITHUB_OUTPUT"

      - name: Create GitHub Release
        uses: softprops/action-gh-release@v2
        with:
          tag_name: \${{ needs.version.outputs.tag }}
          name: "v\${{ needs.version.outputs.version }}"
          body: \${{ steps.changelog.outputs.changelog }}
          draft: false
          prerelease: false

  # ──────────────────────────────────────────────
  # Notify team via Slack
  # ──────────────────────────────────────────────
  notify:
    name: Notify Team
    needs: [version, build-ios, build-android, submit-ios, submit-android, release]
    if: always()
    runs-on: ubuntu-latest
    steps:
      - name: Determine overall status
        id: status
        run: |
          if [ "\${{ needs.release.result }}" = "success" ]; then
            echo "emoji=🚀" >> "$GITHUB_OUTPUT"
            echo "status=Production deploy succeeded" >> "$GITHUB_OUTPUT"
            echo "color=#36a64f" >> "$GITHUB_OUTPUT"
          else
            echo "emoji=🚨" >> "$GITHUB_OUTPUT"
            echo "status=Production deploy had issues" >> "$GITHUB_OUTPUT"
            echo "color=#dc3545" >> "$GITHUB_OUTPUT"
          fi

      - name: Send Slack notification
        if: env.SLACK_WEBHOOK_URL != ''
        uses: slackapi/slack-github-action@v1
        with:
          payload: |
            {
              "attachments": [
                {
                  "color": "\${{ steps.status.outputs.color }}",
                  "blocks": [
                    {
                      "type": "header",
                      "text": {
                        "type": "plain_text",
                        "text": "\${{ steps.status.outputs.emoji }} \${{ steps.status.outputs.status }}"
                      }
                    },
                    {
                      "type": "section",
                      "fields": [
                        { "type": "mrkdwn", "text": "*Version:*\\nv\${{ needs.version.outputs.version }}" },
                        { "type": "mrkdwn", "text": "*Build:*\\n#\${{ needs.version.outputs.build_number }}" },
                        { "type": "mrkdwn", "text": "*Platform:*\\n\${{ inputs.platform }}" },
                        { "type": "mrkdwn", "text": "*Deployed by:*\\n@\${{ github.actor }}" }
                      ]
                    },
                    {
                      "type": "section",
                      "fields": [
                        { "type": "mrkdwn", "text": "*iOS Build:*\\n\${{ needs.build-ios.result || 'skipped' }}" },
                        { "type": "mrkdwn", "text": "*Android Build:*\\n\${{ needs.build-android.result || 'skipped' }}" },
                        { "type": "mrkdwn", "text": "*App Store:*\\n\${{ needs.submit-ios.result || 'skipped' }}" },
                        { "type": "mrkdwn", "text": "*Google Play:*\\n\${{ needs.submit-android.result || 'skipped' }}" }
                      ]
                    },
                    {
                      "type": "section",
                      "text": {
                        "type": "mrkdwn",
                        "text": "*Release Notes:*\\n\${{ inputs.release_notes }}"
                      }
                    },
                    {
                      "type": "actions",
                      "elements": [
                        {
                          "type": "button",
                          "text": { "type": "plain_text", "text": "View Release" },
                          "url": "\${{ github.server_url }}/\${{ github.repository }}/releases/tag/\${{ needs.version.outputs.tag }}"
                        },
                        {
                          "type": "button",
                          "text": { "type": "plain_text", "text": "View Workflow" },
                          "url": "\${{ github.server_url }}/\${{ github.repository }}/actions/runs/\${{ github.run_id }}"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
        env:
          SLACK_WEBHOOK_URL: \${{ secrets.SLACK_WEBHOOK_URL }}
          SLACK_WEBHOOK_TYPE: INCOMING_WEBHOOK

      - name: Post summary
        run: |
          cat >> "$GITHUB_STEP_SUMMARY" <<'EOF'
          ## \${{ steps.status.outputs.emoji }} Production Deployment Summary

          | Item | Value |
          |------|-------|
          | **Version** | v\${{ needs.version.outputs.version }} |
          | **Build Number** | \${{ needs.version.outputs.build_number }} |
          | **Platform** | \${{ inputs.platform }} |
          | **iOS Build** | \${{ needs.build-ios.result || 'skipped' }} |
          | **Android Build** | \${{ needs.build-android.result || 'skipped' }} |
          | **App Store Submission** | \${{ needs.submit-ios.result || 'skipped' }} |
          | **Google Play Submission** | \${{ needs.submit-android.result || 'skipped' }} |
          | **E2E Tests** | \${{ needs.e2e-tests.result || 'skipped' }} |
          | **Deployed by** | @\${{ github.actor }} |

          ### Release Notes
          \${{ inputs.release_notes }}
          EOF`,

  '.github/workflows/deploy-staging.yml': `name: Deploy Staging

on:
  push:
    branches: [main]
  workflow_dispatch:
    inputs:
      build_native:
        description: 'Build native binaries (iOS/Android)'
        required: false
        default: 'false'
        type: boolean
      platform:
        description: 'Platform to build'
        required: false
        default: 'all'
        type: choice
        options:
          - all
          - ios
          - android

concurrency:
  group: staging-deploy-\${{ github.sha }}
  cancel-in-progress: true

env:
  NODE_ENV: staging
  EXPO_TOKEN: \${{ secrets.EXPO_TOKEN }}
  EAS_PROJECT_ID: \${{ secrets.EAS_PROJECT_ID }}
  SENTRY_AUTH_TOKEN: \${{ secrets.SENTRY_AUTH_TOKEN }}
  SENTRY_ORG: \${{ secrets.SENTRY_ORG }}
  SENTRY_PROJECT: \${{ secrets.SENTRY_PROJECT }}

jobs:
  quality-gate:
    name: Quality Gate
    runs-on: ubuntu-latest
    timeout-minutes: 15
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: 9

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: 20
          cache: pnpm

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Lint
        run: pnpm lint

      - name: Type check
        run: pnpm tsc --noEmit

      - name: Unit & component tests
        run: pnpm test --ci --coverage --maxWorkers=2
        env:
          CI: true

      - name: Check coverage threshold
        run: |
          COVERAGE=$(cat coverage/coverage-summary.json | jq '.total.lines.pct')
          echo "Line coverage: \${COVERAGE}%"
          if (( $(echo "$COVERAGE < 75" | bc -l) )); then
            echo "::error::Coverage \${COVERAGE}% is below 75% threshold"
            exit 1
          fi

      - name: Upload coverage artifact
        uses: actions/upload-artifact@v4
        with:
          name: coverage-report
          path: coverage/
          retention-days: 7

  eas-update:
    name: EAS Update (OTA)
    needs: quality-gate
    runs-on: ubuntu-latest
    timeout-minutes: 15
    outputs:
      update_group_id: \${{ steps.update.outputs.group_id }}
      update_branch: \${{ steps.update.outputs.branch }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: 9

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: 20
          cache: pnpm

      - name: Setup Expo CLI
        uses: expo/expo-github-action@v8
        with:
          eas-version: latest
          expo-version: latest
          token: \${{ secrets.EXPO_TOKEN }}

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Create staging .env
        run: |
          cat << EOF > .env.staging
          FIREBASE_API_KEY=\${{ secrets.STAGING_FIREBASE_API_KEY }}
          FIREBASE_AUTH_DOMAIN=\${{ secrets.STAGING_FIREBASE_AUTH_DOMAIN }}
          FIREBASE_PROJECT_ID=\${{ secrets.STAGING_FIREBASE_PROJECT_ID }}
          FIREBASE_STORAGE_BUCKET=\${{ secrets.STAGING_FIREBASE_STORAGE_BUCKET }}
          FIREBASE_MESSAGING_SENDER_ID=\${{ secrets.STAGING_FIREBASE_MESSAGING_SENDER_ID }}
          FIREBASE_APP_ID=\${{ secrets.STAGING_FIREBASE_APP_ID }}
          SENTRY_DSN=\${{ secrets.STAGING_SENTRY_DSN }}
          API_URL=\${{ secrets.STAGING_API_URL }}
          ENVIRONMENT=staging
          EOF

      - name: Publish EAS Update to staging channel
        id: update
        run: |
          OUTPUT=$(eas update \\
            --branch staging \\
            --channel staging \\
            --message "Deploy $(git rev-parse --short HEAD): $(git log -1 --pretty=%B | head -1)" \\
            --non-interactive \\
            --json)

          GROUP_ID=$(echo "$OUTPUT" | jq -r '.[0].group')
          echo "group_id=\${GROUP_ID}" >> "$GITHUB_OUTPUT"
          echo "branch=staging" >> "$GITHUB_OUTPUT"
          echo "### 📱 EAS Update Published" >> "$GITHUB_STEP_SUMMARY"
          echo "- **Branch:** staging" >> "$GITHUB_STEP_SUMMARY"
          echo "- **Group ID:** \${GROUP_ID}" >> "$GITHUB_STEP_SUMMARY"
          echo "- **Commit:** $(git rev-parse --short HEAD)" >> "$GITHUB_STEP_SUMMARY"

  build-ios:
    name: EAS Build (iOS)
    needs: quality-gate
    if: >
      github.event_name == 'workflow_dispatch' &&
      github.event.inputs.build_native == 'true' &&
      (github.event.inputs.platform == 'all' || github.event.inputs.platform == 'ios')
    runs-on: ubuntu-latest
    timeout-minutes: 60
    outputs:
      build_id: \${{ steps.build.outputs.build_id }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: 9

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: 20
          cache: pnpm

      - name: Setup Expo CLI
        uses: expo/expo-github-action@v8
        with:
          eas-version: latest
          expo-version: latest
          token: \${{ secrets.EXPO_TOKEN }}

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Configure staging credentials
        run: |
          echo "\${{ secrets.STAGING_GOOGLE_SERVICE_INFO_PLIST }}" | base64 -d > ios/GoogleService-Info.plist

      - name: Build iOS (staging profile)
        id: build
        run: |
          OUTPUT=$(eas build \\
            --platform ios \\
            --profile staging \\
            --non-interactive \\
            --json)

          BUILD_ID=$(echo "$OUTPUT" | jq -r '.[0].id')
          BUILD_URL=$(echo "$OUTPUT" | jq -r '.[0].buildDetailsPageUrl // empty')
          echo "build_id=\${BUILD_ID}" >> "$GITHUB_OUTPUT"

          echo "### 🍎 iOS Build Started" >> "$GITHUB_STEP_SUMMARY"
          echo "- **Build ID:** \${BUILD_ID}" >> "$GITHUB_STEP_SUMMARY"
          if [ -n "$BUILD_URL" ]; then
            echo "- **Details:** [View Build](\${BUILD_URL})" >> "$GITHUB_STEP_SUMMARY"
          fi

  build-android:
    name: EAS Build (Android)
    needs: quality-gate
    if: >
      github.event_name == 'workflow_dispatch' &&
      github.event.inputs.build_native == 'true' &&
      (github.event.inputs.platform == 'all' || github.event.inputs.platform == 'android')
    runs-on: ubuntu-latest
    timeout-minutes: 60
    outputs:
      build_id: \${{ steps.build.outputs.build_id }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: 9

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: 20
          cache: pnpm

      - name: Setup Expo CLI
        uses: expo/expo-github-action@v8
        with:
          eas-version: latest
          expo-version: latest
          token: \${{ secrets.EXPO_TOKEN }}

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Configure staging credentials
        run: |
          echo "\${{ secrets.STAGING_GOOGLE_SERVICES_JSON }}" | base64 -d > android/app/google-services.json

      - name: Build Android (staging profile)
        id: build
        run: |
          OUTPUT=$(eas build \\
            --platform android \\
            --profile staging \\
            --non-interactive \\
            --json)

          BUILD_ID=$(echo "$OUTPUT" | jq -r '.[0].id')
          BUILD_URL=$(echo "$OUTPUT" | jq -r '.[0].buildDetailsPageUrl // empty')
          echo "build_id=\${BUILD_ID}" >> "$GITHUB_OUTPUT"

          echo "### 🤖 Android Build Started" >> "$GITHUB_STEP_SUMMARY"
          echo "- **Build ID:** \${BUILD_ID}" >> "$GITHUB_STEP_SUMMARY"
          if [ -n "$BUILD_URL" ]; then
            echo "- **Details:** [View Build](\${BUILD_URL})" >> "$GITHUB_STEP_SUMMARY"
          fi

  e2e-ios:
    name: Detox E2E (iOS)
    needs: build-ios
    if: needs.build-ios.result == 'success'
    runs-on: macos-14
    timeout-minutes: 45
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: 9

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: 20
          cache: pnpm

      - name: Setup Expo CLI
        uses: expo/expo-github-action@v8
        with:
          eas-version: latest
          token: \${{ secrets.EXPO_TOKEN }}

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Download iOS build artifact
        run: |
          eas build:download \\
            --id \${{ needs.build-ios.outputs.build_id }} \\
            --output build/ios-staging.tar.gz \\
            --non-interactive
          mkdir -p build/ios
          tar -xzf build/ios-staging.tar.gz -C build/ios/

      - name: Install Detox CLI
        run: pnpm add -g detox-cli

      - name: Boot iOS Simulator
        run: |
          DEVICE=$(xcrun simctl list devices available -j | jq -r '.devices | to_entries[] | select(.key | contains("iOS-17")) | .value[] | select(.name == "iPhone 15") | .udid' | head -1)
          xcrun simctl boot "$DEVICE" || true

      - name: Run Detox E2E tests (iOS)
        run: npx detox test --configuration ios.staging.ci --cleanup --headless
        env:
          DETOX_LOGLEVEL: info

      - name: Upload E2E artifacts
        if: failure()
        uses: actions/upload-artifact@v4
        with:
          name: detox-ios-artifacts
          path: e2e/artifacts/
          retention-days: 7

  e2e-android:
    name: Detox E2E (Android)
    needs: build-android
    if: needs.build-android.result == 'success'
    runs-on: ubuntu-latest
    timeout-minutes: 45
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup pnpm
        uses: pnpm/action-setup@v4
        with:
          version: 9

      - name: Setup Node.js
        uses: actions/setup-node@v4
        with:
          node-version: 20
          cache: pnpm

      - name: Setup Expo CLI
        uses: expo/expo-github-action@v8
        with:
          eas-version: latest
          token: \${{ secrets.EXPO_TOKEN }}

      - name: Install dependencies
        run: pnpm install --frozen-lockfile

      - name: Download Android build artifact
        run: |
          eas build:download \\
            --id \${{ needs.build-android.outputs.build_id }} \\
            --output build/android-staging.apk \\
            --non-interactive

      - name: Enable KVM
        run: |
          echo 'KERNEL=="kvm", GROUP="kvm", MODE="0666", OPTIONS+="static_node=kvm"' | sudo tee /etc/udev/rules.d/99-kvm4all.rules
          sudo udevadm control --reload-rules
          sudo udevadm trigger --name-match=kvm

      - name: Install Detox CLI
        run: pnpm add -g detox-cli

      - name: Run Detox E2E tests (Android)
        uses: reactivecircus/android-emulator-runner@v2
        with:
          api-level: 34
          arch: x86_64
          profile: pixel_6
          avd-name: detox_pixel_6
          force-avd-creation: false
          emulator-options: -no-snapshot-save -no-window -gpu swiftshader_indirect -noaudio -no-boot-anim
          disable-animations: true
          script: npx detox test --configuration android.staging.ci --cleanup --headless
        env:
          DETOX_LOGLEVEL: info

      - name: Upload E2E artifacts
        if: failure()
        uses: actions/upload-artifact@v4
        with:
          name: detox-android-artifacts
          path: e2e/artifacts/
          retention-days: 7

  distribute-staging:
    name: Distribute to Testers
    needs: [build-ios, build-android]
    if: >
      always() &&
      (needs.build-ios.result == 'success' || needs.build-android.result == 'success')
    runs-on: ubuntu-latest
    timeout-minutes: 10
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Setup Expo CLI
        uses: expo/expo-github-action@v8
        with:
          eas-version: latest
          token: \${{ secrets.EXPO_TOKEN }}

      - name: Submit iOS to TestFlight
        if: needs.build-ios.result == 'success'
        run: |
          eas submit \\
            --platform ios \\
            --id \${{ needs.build-ios.outputs.build_id }} \\
            --profile staging \\
            --non-interactive

      - name: Submit Android to Internal Testing
        if: needs.build-android.result == 'success'
        run: |
          eas submit \\
            --platform android \\
            --id \${{ needs.build-android.outputs.build_id }} \\
            --profile staging \\
            --non-interactive

      - name: Summary
        run: |
          echo "### 🚀 Staging Distribution Complete" >> "$GITHUB_STEP_SUMMARY"
          echo "" >> "$GITHUB_STEP_SUMMARY"
          if [ "\${{ needs.build-ios.result }}" == "success" ]; then
            echo "- ✅ iOS submitted to TestFlight (Build: \${{ needs.build-ios.outputs.build_id }})" >> "$GITHUB_STEP_SUMMARY"
          fi
          if [ "\${{ needs.build-android.result }}" == "success" ]; then
            echo "- ✅ Android submitted to Internal Testing (Build: \${{ needs.build-android.outputs.build_id }})" >> "$GITHUB_STEP_SUMMARY"
          fi

  notify:
    name: Notify Team
    needs: [eas-update, build-ios, build-android, e2e-ios, e2e-android, distribute-staging]
    if: always()
    runs-on: ubuntu-latest
    timeout-minutes: 5
    steps:
      - name: Determine status
        id: status
        run: |
          if [ "\${{ needs.eas-update.result }}" == "failure" ]; then
            echo "status=failure" >> "$GITHUB_OUTPUT"
            echo "message=❌ Staging OTA update failed" >> "$GITHUB_OUTPUT"
          elif [ "\${{ needs.e2e-ios.result }}" == "failure" ] || [ "\${{ needs.e2e-android.result }}" == "failure" ]; then
            echo "status=warning" >> "$GITHUB_OUTPUT"
            echo "message=⚠️ Staging deployed but E2E tests failed" >> "$GITHUB_OUTPUT"
          else
            echo "status=success" >> "$GITHUB_OUTPUT"
            echo "message=✅ Staging deployment complete" >> "$GITHUB_OUTPUT"
          fi

      - name: Notify Slack
        if: always()
        uses: slackapi/slack-github-action@v1.26.0
        with:
          payload: |
            {
              "channel": "\${{ secrets.SLACK_STAGING_CHANNEL }}",
              "text": "\${{ steps.status.outputs.message }}",
              "blocks": [
                {
                  "type": "header",
                  "text": {
                    "type": "plain_text",
                    "text": "\${{ steps.status.outputs.message }}"
                  }
                },
                {
                  "type": "section",
                  "fields": [
                    {
                      "type": "mrkdwn",
                      "text": "*Commit:*\\n<\${{ github.server_url }}/\${{ github.repository }}/commit/\${{ github.sha }}|$(echo \${{ github.sha }} | cut -c1-7)>"
                    },
                    {
                      "type": "mrkdwn",
                      "text": "*Author:*\\n\${{ github.actor }}"
                    },
                    {
                      "type": "mrkdwn",
                      "text": "*OTA Update:*\\n\${{ needs.eas-update.result }}"
                    },
                    {
                      "type": "mrkdwn",
                      "text": "*Workflow:*\\n<\${{ github.server_url }}/\${{ github.repository }}/actions/runs/\${{ github.run_id }}|View Run>"
                    }
                  ]
                }
              ]
            }
        env:
          SLACK_BOT_TOKEN: \${{ secrets.SLACK_BOT_TOKEN }}

      - name: Create Sentry release
        if: needs.eas-update.result == 'success'
        uses: getsentry/action-release@v1
        env:
          SENTRY_AUTH_TOKEN: \${{ secrets.SENTRY_AUTH_TOKEN }}
          SENTRY_ORG: \${{ secrets.SENTRY_ORG }}
          SENTRY_PROJECT: \${{ secrets.SENTRY_PROJECT }}
        with:
          environment: staging
          version: staging-\${{ github.sha }}`,

  '.gitignore': `# Dependencies
node_modules/
.pnpm-store/

# Expo
.expo/
dist/
web-build/
expo-env.d.ts

# React Native
# iOS
ios/Pods/
ios/build/
ios/DerivedData/
ios/*.xcworkspace/xcuserdata/
ios/*.xcodeproj/xcuserdata/
ios/*.xcodeproj/project.xcworkspace/xcshareddata/IDEWorkspaceChecks.plist
ios/.xcode.env.local

# Android
android/build/
android/app/build/
android/.gradle/
android/local.properties
android/app/src/main/assets/
android/app/release/

# Code signing & keystores
*.jks
*.p12
*.key
*.mobileprovision
*.provisionprofile
upload-keystore.jks
release.keystore

# Firebase config (contains API keys — use CI secrets or EAS secrets)
google-services.json
GoogleService-Info.plist
firebase-debug.log
firebase-debug.*.log
.firebase/

# Environment variables
.env
.env.local
.env.staging
.env.production
.env*.local

# TypeScript
*.tsbuildinfo

# Testing
coverage/
e2e/artifacts/
e2e/screenshots/
e2e/videos/

# Detox
artifacts/

# Metro bundler
.metro-health-check*

# WatermelonDB
*.db
*.db-journal
*.db-wal
*.db-shm

# EAS
eas-build-local.json
.easignore

# IDE & editors
.idea/
.vscode/*
!.vscode/settings.json
!.vscode/extensions.json
*.swp
*.swo
*~
.DS_Store
Thumbs.db

# Logs
*.log
npm-debug.log*
yarn-debug.log*
yarn-error.log*
pnpm-debug.log*

# Sentry
.sentryclirc

# Temporary files
tmp/
temp/
*.tmp

# Patch files from patch-package
!patches/

# Bundle analysis
bundle-stats.json
source-map-explorer-report.html`,

  '.mcp.json': `{
  "mcpServers": {
    "github": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-github"],
      "env": {
        "GITHUB_PERSONAL_ACCESS_TOKEN": "\${GITHUB_TOKEN}"
      },
      "description": "GitHub Issues, PRs, and repository operations for react-native-mobile-app"
    },
    "slack": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-slack"],
      "env": {
        "SLACK_BOT_TOKEN": "\${SLACK_BOT_TOKEN}",
        "SLACK_TEAM_ID": "\${SLACK_TEAM_ID}"
      },
      "description": "Slack integration for team communication and build notifications"
    },
    "firebase": {
      "command": "npx",
      "args": ["-y", "@anthropic/firebase-mcp-server"],
      "env": {
        "FIREBASE_PROJECT_ID": "\${FIREBASE_PROJECT_ID}",
        "FIREBASE_SERVICE_ACCOUNT_KEY": "\${FIREBASE_SERVICE_ACCOUNT_KEY}",
        "FIREBASE_TOKEN": "\${FIREBASE_TOKEN}"
      },
      "description": "Firebase Console access — Firestore, Authentication, Cloud Functions, Cloud Messaging, Crashlytics"
    },
    "sentry": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-sentry"],
      "env": {
        "SENTRY_AUTH_TOKEN": "\${SENTRY_AUTH_TOKEN}",
        "SENTRY_ORG": "\${SENTRY_ORG}",
        "SENTRY_PROJECT": "react-native-mobile-app"
      },
      "description": "Sentry error monitoring and crash reporting for iOS and Android builds"
    },
    "filesystem": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-filesystem",
        "src/",
        "e2e/",
        "docs/",
        "scripts/",
        "app.json",
        "eas.json",
        "tsconfig.json",
        "firebase.json",
        "firestore.rules",
        "firestore.indexes.json",
        "storage.rules"
      ],
      "description": "Scoped filesystem access to project source, tests, docs, and config files"
    },
    "memory": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-memory"],
      "description": "Persistent memory for architecture decisions, feature context, and cross-session state"
    }
  }
}`,

  '.prettierrc': `{
  "singleQuote": true,
  "trailingComma": "all",
  "semi": true,
  "printWidth": 100,
  "tabWidth": 2,
  "useTabs": false,
  "bracketSpacing": true,
  "bracketSameLine": false,
  "arrowParens": "always",
  "endOfLine": "lf",
  "quoteProps": "as-needed",
  "jsxSingleQuote": false,
  "overrides": [
    {
      "files": "*.json",
      "options": {
        "trailingComma": "none"
      }
    }
  ]
}`,

  'CLAUDE.md': `# CLAUDE.md — React Native Mobile App

## Project Overview

Cross-platform mobile app built with React Native 0.74, Expo SDK 51, and TypeScript. Firebase powers authentication, Firestore, Cloud Functions, push notifications, and storage. Offline-first architecture uses WatermelonDB with Firestore sync. Targets iOS and Android via EAS Build with staging and production channels.

## Quick Commands

\`\`\`bash
pnpm install                    # Install dependencies
npx expo start                  # Start dev server (Expo Go or dev client)
npx expo start --ios            # Start on iOS simulator
npx expo start --android        # Start on Android emulator
pnpm test                       # Run Jest unit + component tests
pnpm test --coverage            # Run tests with coverage (threshold: 75%)
pnpm lint                       # ESLint (react-native-community config)
pnpm typecheck                  # TypeScript strict mode check
npx detox build -c ios.sim.debug   # Build Detox E2E (iOS)
npx detox test -c ios.sim.debug    # Run Detox E2E tests (iOS)
eas build --platform ios --profile staging    # EAS Build iOS staging
eas build --platform android --profile staging # EAS Build Android staging
eas submit --platform ios       # Submit to App Store
eas submit --platform android   # Submit to Google Play
eas update --branch staging     # OTA update to staging channel
\`\`\`

## Architecture

**Feature-based structure** — each feature is self-contained under \`src/features/\`:

\`\`\`
src/features/{feature}/
  screens/       # Screen components (one per route)
  components/    # Feature-specific UI components
  hooks/         # Feature-specific hooks
  types/         # Feature-specific TypeScript types
\`\`\`

**State management split:**
- **Server state** → React Query (TanStack Query) — Firebase data, API calls, caching, sync
- **Client state** → Zustand stores in \`src/store/\` — auth session, theme, user preferences
- **Offline data** → WatermelonDB — local-first with background Firestore sync

**Navigation:** React Navigation v6 with fully typed stack and tab navigators. Types live in \`src/navigation/types.ts\`. Deep linking config in \`src/navigation/linking.ts\`.

## Code Conventions

| Element | Convention | Example |
|---------|-----------|---------|
| Components/Screens | PascalCase | \`ProfileScreen.tsx\`, \`AvatarCard.tsx\` |
| Hooks/Utils | camelCase | \`useAuth.ts\`, \`formatCurrency.ts\` |
| Files | kebab-case | \`push-notification-service.ts\` |
| Constants | SCREAMING_SNAKE_CASE | \`MAX_RETRY_COUNT\` |
| Branches | type/ticket-desc | \`feat/APP-42-add-push-notifications\` |
| Commits | Conventional | \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\` |

**Hard rules:**
- TypeScript strict mode — no \`any\`, no \`@ts-ignore\` without justification
- Max 250 lines per file — split if larger
- All user-facing text goes through \`src/i18n/\` — never hardcode strings
- All interactive elements require \`accessibilityLabel\` and \`accessibilityRole\`
- Native modules must have both iOS and Android implementations
- Use Expo Modules API for custom native code, not bare native modules

## Sensitive Paths — Extra Caution Required

- \`src/services/auth/**\` — authentication logic, token handling, biometric auth
- \`src/config/**\` — environment config, API keys, feature flags
- \`google-services.json\` / \`GoogleService-Info.plist\` — Firebase credentials (never commit secrets)
- \`.env*\` files — environment variables (use \`react-native-config\`)
- \`src/features/payments/**\` — in-app purchase logic, subscription management

Changes to these paths require senior/lead review. Check CODEOWNERS.

## Testing Strategy

- **Unit/Component tests:** Jest + React Native Testing Library — colocated as \`__tests__/\` or \`.test.tsx\` next to source
- **E2E tests:** Detox specs in \`e2e/\` directory — test critical user flows (auth, navigation, offline, purchases)
- **Coverage threshold:** 75% minimum enforced in CI
- **What to test:** User interactions, navigation flows, offline/online transitions, error states, accessibility
- **What not to test:** Styling details, third-party library internals, platform-specific native code (covered by E2E)

## Firebase Services

| Service | Usage |
|---------|-------|
| Authentication | Email/password, Google, Apple Sign-In, biometric re-auth |
| Firestore | Primary cloud database, syncs with WatermelonDB |
| Cloud Functions | Server-side logic, webhooks, scheduled tasks |
| Cloud Messaging (FCM) | Push notifications (iOS via APNs, Android direct) |
| Storage | User uploads, profile images, media |
| Crashlytics | Crash reporting (supplements Sentry) |
| Analytics | User behavior, screen tracking, conversion events |

## Offline-First Pattern

WatermelonDB is the source of truth for the UI. Data flow:
1. UI reads from WatermelonDB (synchronous, fast)
2. Mutations write to WatermelonDB first (optimistic)
3. Background sync pushes changes to Firestore
4. Pull sync fetches remote changes on connectivity restore
5. Conflict resolution: last-write-wins with server timestamp

Never read directly from Firestore in screen components — always go through WatermelonDB or React Query cache.

## Security & Privacy

- **Secure storage:** Use \`expo-secure-store\` (backed by Keychain on iOS, Keystore on Android) for tokens and sensitive data — never AsyncStorage
- **Certificate pinning:** Enabled for production API endpoints via \`react-native-ssl-pinning\`
- **Code obfuscation:** Hermes bytecode (Android), Bitcode (iOS) in release builds
- **GDPR compliance:** Consent collection before analytics/tracking, data export endpoint, account deletion flow, privacy labels for both stores
- **App Store / Google Play:** Follow review guidelines — no hidden functionality, proper permission usage descriptions, data safety declarations

## CI/CD Pipeline (GitHub Actions + EAS)

Pipeline stages: Lint → Type Check → Unit Tests → Component Tests → EAS Build (iOS + Android) → Detox E2E → Deploy Staging → Deploy Production

- Staging deploys automatically via \`eas update\` on merge to \`main\`
- Production deploys require manual approval + \`eas submit\`
- AI-generated code must be flagged with \`// AI-generated\` comment
- CODEOWNERS enforced on protected \`main\` branch

## PR Workflow

1. Branch from \`main\` using \`type/TICKET-desc\` naming
2. Write/update tests — maintain 75% coverage
3. Run \`pnpm lint && pnpm typecheck && pnpm test\` locally before pushing
4. Open PR with conventional commit title, link GitHub Issue
5. At least 1 approval required; sensitive paths need senior reviewer
6. All CI checks must pass before merge
7. Squash merge to \`main\`

## Common Patterns

**Creating a new feature:**
\`\`\`
src/features/my-feature/
  screens/MyFeatureScreen.tsx
  components/MyFeatureCard.tsx
  hooks/useMyFeature.ts
  types/index.ts
\`\`\`

**Adding a new screen:** Register in \`src/navigation/\` with typed params in \`types.ts\`, add to the appropriate navigator, add deep link path in \`linking.ts\`.

**Adding a Zustand store:** Create in \`src/store/\`, export typed hook, use \`persist\` middleware with MMKV storage for persistence.

**Adding a React Query hook:** Create in the feature's \`hooks/\` directory, use typed query keys, configure stale time and cache time appropriate to the data.

## Docs & Runbooks

- \`docs/architecture.md\` — system design, data flow diagrams
- \`docs/deployment.md\` — EAS Build profiles, code signing, store submission
- \`docs/offline-sync.md\` — WatermelonDB sync protocol, conflict resolution
- \`docs/push-notifications.md\` — FCM setup, APNs certificates, notification handling
- \`docs/runbooks/\` — incident response, rollback procedures, hotfix process`,

  'README.md': `# React Native Mobile App

[![CI](https://github.com/your-org/react-native-mobile-app/actions/workflows/ci.yml/badge.svg)](https://github.com/your-org/react-native-mobile-app/actions/workflows/ci.yml)
[![Deploy Staging](https://github.com/your-org/react-native-mobile-app/actions/workflows/deploy-staging.yml/badge.svg)](https://github.com/your-org/react-native-mobile-app/actions/workflows/deploy-staging.yml)
[![Deploy Production](https://github.com/your-org/react-native-mobile-app/actions/workflows/deploy-production.yml/badge.svg)](https://github.com/your-org/react-native-mobile-app/actions/workflows/deploy-production.yml)
[![TypeScript](https://img.shields.io/badge/TypeScript-strict-blue.svg)](https://www.typescriptlang.org/)
[![Expo SDK](https://img.shields.io/badge/Expo_SDK-51-000020.svg)](https://expo.dev/)
[![React Native](https://img.shields.io/badge/React_Native-0.74-61DAFB.svg)](https://reactnative.dev/)
[![Coverage](https://img.shields.io/badge/coverage-%E2%89%A575%25-brightgreen.svg)]()
[![License](https://img.shields.io/badge/license-proprietary-red.svg)]()

Cross-platform mobile application built with React Native and Expo SDK 51. Features offline-first architecture, Firebase backend services, biometric authentication, push notifications, in-app purchases, and automated deployment to App Store and Google Play via EAS Build.

---

## Table of Contents

- [Features](#features)
- [Tech Stack](#tech-stack)
- [Prerequisites](#prerequisites)
- [Quickstart](#quickstart)
- [Project Structure](#project-structure)
- [Architecture](#architecture)
- [Development Workflow](#development-workflow)
- [Testing](#testing)
- [Building & Deployment](#building--deployment)
- [Environment Configuration](#environment-configuration)
- [Firebase Setup](#firebase-setup)
- [Offline-First Architecture](#offline-first-architecture)
- [Deep Linking](#deep-linking)
- [Push Notifications](#push-notifications)
- [In-App Purchases](#in-app-purchases)
- [Internationalization](#internationalization)
- [Security](#security)
- [Privacy & Compliance](#privacy--compliance)
- [Monitoring & Analytics](#monitoring--analytics)
- [Troubleshooting](#troubleshooting)
- [Contributing](#contributing)

---

## Features

- **Cross-Platform**: Single codebase for iOS and Android with native performance
- **Offline-First**: WatermelonDB local database with Firestore sync — works without connectivity
- **Authentication**: Email/password, social login (Google, Apple), biometric (Face ID, fingerprint)
- **Push Notifications**: Firebase Cloud Messaging with rich notifications and deep link handling
- **In-App Purchases**: Subscription management via RevenueCat with receipt validation
- **Internationalization**: Full i18n support with RTL layout handling
- **Accessibility**: WCAG-compliant with screen reader support and accessibility labels on all interactive elements
- **Analytics & Crash Reporting**: Firebase Analytics, Crashlytics, and Sentry error tracking
- **CI/CD**: Automated builds and submissions via EAS Build and EAS Submit

## Tech Stack

| Layer | Technology |
|---|---|
| **Framework** | React Native 0.74 + Expo SDK 51 |
| **Language** | TypeScript (strict mode, no \`any\`) |
| **Navigation** | React Navigation v6 (typed stack/tab navigators) |
| **Client State** | Zustand |
| **Server State** | TanStack Query (React Query) |
| **Local Database** | WatermelonDB |
| **Backend** | Firebase (Auth, Firestore, Cloud Functions, Cloud Messaging, Storage) |
| **Unit/Component Tests** | Jest + React Native Testing Library |
| **E2E Tests** | Detox |
| **CI/CD** | GitHub Actions + EAS Build + EAS Submit |
| **Package Manager** | pnpm |
| **Monitoring** | Sentry, Firebase Analytics, Firebase Crashlytics |

## Prerequisites

- **Node.js** ≥ 18.x
- **pnpm** ≥ 8.x (\`npm install -g pnpm\`)
- **Expo CLI** (\`npx expo --version\` to verify)
- **EAS CLI** (\`npm install -g eas-cli\`)
- **Xcode** ≥ 15.0 (macOS, for iOS development)
- **Android Studio** ≥ Hedgehog (for Android development)
- **CocoaPods** (\`sudo gem install cocoapods\`)
- **Firebase CLI** (\`npm install -g firebase-tools\`)
- **Detox CLI** (\`npm install -g detox-cli\`, for E2E tests)

## Quickstart

### 1. Clone and install

\`\`\`bash
git clone git@github.com:your-org/react-native-mobile-app.git
cd react-native-mobile-app
pnpm install
\`\`\`

### 2. Configure environment

\`\`\`bash
cp .env.example .env.local
# Edit .env.local with your Firebase config, API keys, etc.
\`\`\`

### 3. Set up Firebase

\`\`\`bash
# Place your Firebase config files:
# - ios/GoogleService-Info.plist
# - android/app/google-services.json
# See "Firebase Setup" section below for details
\`\`\`

### 4. Install native dependencies

\`\`\`bash
# iOS
cd ios && pod install && cd ..

# Or use Expo prebuild
npx expo prebuild
\`\`\`

### 5. Start development

\`\`\`bash
# Start Expo dev server
npx expo start

# Run on iOS simulator
npx expo run:ios

# Run on Android emulator
npx expo run:android

# Run on physical device (scan QR code from Expo Go)
npx expo start --tunnel
\`\`\`

### 6. Run tests

\`\`\`bash
# Unit and component tests
pnpm test

# Type checking
pnpm typecheck

# Linting
pnpm lint

# E2E tests (requires built app)
npx detox build --configuration ios.sim.debug
npx detox test --configuration ios.sim.debug
\`\`\`

## Project Structure

\`\`\`
react-native-mobile-app/
├── .claude/                    # Claude Code rules and settings
│   ├── rules/                  # Coding standards, git workflow, testing rules
│   └── settings.json           # Claude permissions and MCP config
├── .github/                    # GitHub Actions, PR templates, CODEOWNERS
│   ├── workflows/              # CI, staging deploy, production deploy, AI audit
│   ├── ISSUE_TEMPLATE/         # Bug report, feature request, AI task templates
│   ├── PULL_REQUEST_TEMPLATE.md
│   └── CODEOWNERS
├── android/                    # Android native project (Expo prebuild)
├── ios/                        # iOS native project (Expo prebuild)
├── src/
│   ├── features/               # Feature modules
│   │   ├── auth/               # Authentication (login, register, biometrics)
│   │   │   ├── screens/
│   │   │   ├── components/
│   │   │   ├── hooks/
│   │   │   └── types/
│   │   ├── home/               # Home feed, dashboard
│   │   ├── profile/            # User profile, settings
│   │   ├── notifications/      # Push & in-app notifications
│   │   └── payments/           # In-app purchases, subscriptions
│   ├── components/             # Shared UI components (Button, Card, Input, Modal)
│   ├── hooks/                  # Shared hooks (useAuth, useOffline, useTheme)
│   ├── services/               # API services (Firebase, analytics, crash reporting)
│   ├── navigation/             # React Navigation config (types, navigators, linking)
│   ├── store/                  # Zustand stores (auth, theme, preferences)
│   ├── utils/                  # Utilities (formatting, validation, platform helpers)
│   ├── i18n/                   # Internationalization (translations, locale config)
│   ├── theme/                  # Design tokens (colors, typography, spacing)
│   └── assets/                 # Static assets (images, fonts, animations)
├── e2e/                        # Detox E2E test specs
├── scripts/                    # Build scripts, code signing helpers
├── docs/                       # Architecture, deployment guides, runbooks
├── plugin/                     # CodeForge plugin (agents, commands, skills)
│   └── codeforge-react-native/
├── playbook/                   # Development methodology phases
├── app.json                    # Expo app configuration
├── eas.json                    # EAS Build profiles (development, staging, production)
├── metro.config.js             # Metro bundler configuration
├── babel.config.js             # Babel configuration
├── tsconfig.json               # TypeScript configuration (strict mode)
├── jest.config.js              # Jest test configuration
├── .detoxrc.js                 # Detox E2E configuration
├── .eslintrc.js                # ESLint configuration
├── .prettierrc                 # Prettier configuration
├── .env.example                # Environment variable template
└── package.json
\`\`\`

## Architecture

The app follows a **feature-based architecture** with clear separation of concerns. See [docs/ARCHITECTURE.md](docs/ARCHITECTURE.md) for the full architecture document.

### Key Principles

- **Feature Modules**: Each feature (\`auth\`, \`home\`, \`profile\`, etc.) is self-contained with its own screens, components, hooks, and types
- **State Separation**: Zustand for client state (theme, preferences, UI), TanStack Query for server state (API data, caching, sync)
- **Offline-First**: WatermelonDB as the local source of truth, syncing with Firestore when connectivity is available
- **Typed Navigation**: All navigation routes and params are fully typed via React Navigation's TypeScript integration
- **Service Layer**: Firebase and third-party integrations are abstracted behind service interfaces for testability

### Data Flow

\`\`\`
UI (Screens/Components)
  ↕ hooks (useQuery, useMutation, Zustand selectors)
  ↕ services (Firebase, WatermelonDB, RevenueCat)
  ↕ backend (Firestore, Cloud Functions, Cloud Messaging)
\`\`\`

### Navigation Structure

\`\`\`
RootNavigator (Stack)
├── AuthNavigator (Stack)
│   ├── LoginScreen
│   ├── RegisterScreen
│   └── ForgotPasswordScreen
├── MainNavigator (Bottom Tabs)
│   ├── HomeNavigator (Stack)
│   ├── NotificationsNavigator (Stack)
│   └── ProfileNavigator (Stack)
└── Modals (Group)
    ├── PaymentModal
    └── SettingsModal
\`\`\`

## Development Workflow

We follow **GitHub Flow** with conventional commits. See [docs/ONBOARDING.md](docs/ONBOARDING.md) for the full onboarding guide.

### Branch Naming

\`\`\`
feat/APP-42-add-push-notifications
fix/APP-87-crash-on-login
chore/APP-100-update-expo-sdk
docs/APP-55-api-documentation
\`\`\`

### Commit Convention

\`\`\`
feat: add biometric authentication for iOS
fix: resolve crash when offline sync fails
chore: update Expo SDK to 51.0.8
docs: add deep linking configuration guide
test: add E2E tests for payment flow
\`\`\`

### PR Process

1. Create a branch from \`main\` following the naming convention
2. Make changes, commit with conventional commit messages
3. Push and open a PR using the [PR template](.github/PULL_REQUEST_TEMPLATE.md)
4. CI runs: lint → type check → unit tests → component tests → EAS build → Detox E2E
5. Request review (at least 1 approval required, CODEOWNERS enforced)
6. Squash merge to \`main\`

### AI-Generated Code

All AI-generated code must be flagged with \`[AI-GENERATED]\` in the PR description and commit messages. See the [AI audit workflow](.github/workflows/ai-code-audit.yml) for automated detection.

## Testing

### Test Strategy

| Type | Tool | Target | Threshold |
|---|---|---|---|
| Unit | Jest | Hooks, utils, services | 75% coverage |
| Component | React Native Testing Library | UI components, screens | 75% coverage |
| E2E | Detox | Critical user flows | Key paths covered |

### Running Tests

\`\`\`bash
# All unit and component tests
pnpm test

# Watch mode
pnpm test -- --watch

# Coverage report
pnpm test -- --coverage

# Single file
pnpm test -- src/features/auth/hooks/useLogin.test.ts

# E2E tests (iOS)
npx detox build --configuration ios.sim.debug
npx detox test --configuration ios.sim.debug

# E2E tests (Android)
npx detox build --configuration android.emu.debug
npx detox test --configuration android.emu.debug
\`\`\`

### Test File Conventions

- Unit/component tests: colocated as \`*.test.ts\` or \`*.test.tsx\` next to source files
- E2E tests: in \`e2e/\` directory, named \`*.e2e.ts\`
- Test utilities and mocks: in \`src/__tests__/\` helpers

## Building & Deployment

### EAS Build Profiles

| Profile | Channel | Purpose |
|---|---|---|
| \`development\` | \`development\` | Local dev builds with dev client |
| \`staging\` | \`staging\` | QA/testing builds distributed via EAS |
| \`production\` | \`production\` | App Store / Google Play release builds |

### Build Commands

\`\`\`bash
# Development build (includes dev tools)
eas build --profile development --platform ios
eas build --profile development --platform android

# Staging build
eas build --profile staging --platform ios
eas build --profile staging --platform android

# Production build
eas build --profile production --platform ios
eas build --profile production --platform android

# Build both platforms
eas build --profile staging --platform all
\`\`\`

### OTA Updates (EAS Update)

\`\`\`bash
# Push OTA update to staging
eas update --branch staging --message "fix: resolve home screen crash"

# Push OTA update to production
eas update --branch production --message "fix: critical payment bug"
\`\`\`

### App Store Submission

\`\`\`bash
# Submit iOS build to App Store Connect
eas submit --platform ios --latest

# Submit Android build to Google Play Console
eas submit --platform android --latest
\`\`\`

### Deployment Pipeline

\`\`\`
Push to main
  → CI (lint, typecheck, test)
  → EAS Build (iOS + Android staging)
  → Detox E2E
  → EAS Update (staging channel)
  → Manual approval
  → EAS Build (production)
  → EAS Submit (App Store + Google Play)
\`\`\`

See [.github/workflows/deploy-staging.yml](.github/workflows/deploy-staging.yml) and [.github/workflows/deploy-production.yml](.github/workflows/deploy-production.yml) for the full pipeline configuration.

## Environment Configuration

Environment variables are managed via \`.env\` files and loaded through \`react-native-config\`.

\`\`\`bash
# .env.example
FIREBASE_API_KEY=
FIREBASE_AUTH_DOMAIN=
FIREBASE_PROJECT_ID=
FIREBASE_STORAGE_BUCKET=
FIREBASE_MESSAGING_SENDER_ID=
FIREBASE_APP_ID=
FIREBASE_MEASUREMENT_ID=
SENTRY_DSN=
REVENUE_CAT_API_KEY_IOS=
REVENUE_CAT_API_KEY_ANDROID=
API_BASE_URL=
DEEP_LINK_PREFIX=
\`\`\`

| File | Purpose | Git Tracked |
|---|---|---|
| \`.env.example\` | Template with variable names | ✅ |
| \`.env.local\` | Local development overrides | ❌ |
| \`.env.staging\` | Staging environment values | ❌ |
| \`.env.production\` | Production environment values | ❌ |

**Never commit \`.env\` files, \`google-services.json\`, or \`GoogleService-Info.plist\` to the repository.** These are managed via EAS Secrets for CI/CD builds.

\`\`\`bash
# Set EAS secrets
eas secret:create --name FIREBASE_API_KEY --value "your-key" --scope project
\`\`\`

## Firebase Setup

### 1. Create Firebase Project

1. Go to [Firebase Console](https://console.firebase.google.com/)
2. Create a new project (or use existing)
3. Enable Authentication (Email/Password, Google, Apple)
4. Create Firestore database
5. Enable Cloud Messaging
6. Enable Cloud Storage

### 2. Add Platform Apps

\`\`\`bash
# Download config files from Firebase Console
# iOS: GoogleService-Info.plist → ios/
# Android: google-services.json → android/app/
\`\`\`

### 3. Deploy Cloud Functions

\`\`\`bash
cd functions/
pnpm install
firebase deploy --only functions
\`\`\`

### 4. Firestore Security Rules

\`\`\`bash
firebase deploy --only firestore:rules
\`\`\`

## Offline-First Architecture

The app uses **WatermelonDB** as the local database with a custom sync adapter for Firestore.

### How It Works

1. **Read**: UI always reads from WatermelonDB (instant, works offline)
2. **Write**: Mutations write to WatermelonDB first, then queue for Firestore sync
3. **Sync**: When online, the sync engine pushes local changes and pulls remote changes
4. **Conflict Resolution**: Last-write-wins with server timestamp, configurable per collection

### Key Files

- \`src/services/database/schema.ts\` — WatermelonDB schema definition
- \`src/services/database/models/\` — Model classes
- \`src/services/database/sync.ts\` — Firestore sync adapter
- \`src/hooks/useOffline.ts\` — Connectivity status hook

## Deep Linking

The app supports universal links (iOS) and app links (Android) for seamless navigation from external sources.

### URL Scheme

\`\`\`
myapp://                          # Custom scheme
https://app.example.com/          # Universal/app links
\`\`\`

### Supported Routes

| URL | Screen |
|---|---|
| \`myapp://home\` | Home |
| \`myapp://profile/:userId\` | User Profile |
| \`myapp://notifications\` | Notifications |
| \`myapp://payment/subscribe\` | Subscription |
| \`myapp://auth/reset?token=xxx\` | Password Reset |

### Configuration

- Navigation linking config: \`src/navigation/linking.ts\`
- iOS: Associated Domains in \`app.json\` → \`ios.associatedDomains\`
- Android: Intent filters in \`app.json\` → \`android.intentFilters\`

## Push Notifications

Push notifications are powered by **Firebase Cloud Messaging (FCM)**.

### Setup

1. FCM is configured via \`google-services.json\` (Android) and \`GoogleService-Info.plist\` (iOS)
2. iOS requires APNs key uploaded to Firebase Console
3. Notification permissions are requested at an appropriate moment (not on first launch)

### Notification Types

| Type | Trigger | Behavior |
|---|---|---|
| Transactional | Backend event | Direct delivery, high priority |
| Marketing | Scheduled campaign | Topic-based, respects preferences |
| Silent | Data sync | Background fetch, no UI |

### Key Files

- \`src/services/notifications/\` — FCM setup, token management, handlers
- \`src/features/notifications/\` — Notification UI, preferences, history

## In-App Purchases

Subscriptions and one-time purchases are managed via **RevenueCat** for cross-platform receipt validation and entitlement management.

### Setup

1. Configure products in App Store Connect and Google Play Console
2. Set RevenueCat API keys in environment variables
3. Products and entitlements are defined in RevenueCat dashboard

### Key Files

- \`src/services/purchases/\` — RevenueCat initialization, purchase flows
- \`src/features/payments/\` — Paywall UI, subscription management

## Internationalization

All user-facing text goes through the i18n system. Hardcoded strings in components are not permitted.

\`\`\`typescript
// ✅ Correct
import { useTranslation } from 'react-i18next';
const { t } = useTranslation();
<Text>{t('home.welcome')}</Text>

// ❌ Wrong
<Text>Welcome</Text>
\`\`\`

### Adding Translations

1. Add keys to \`src/i18n/locales/en.json\`
2. Add translations to other locale files
3. Use the \`t()\` function or \`<Trans>\` component in UI

### Supported Locales

- English (\`en\`) — default
- Spanish (\`es\`)
- Additional locales added as needed

## Security

### Secure Storage

- Authentication tokens stored in **iOS Keychain** / **Android Keystore** via \`expo-secure-store\`
- Biometric authentication gates access to sensitive operations
- No sensitive data in AsyncStorage or plain-text storage

### Network Security

- **Certificate pinning** for API endpoints in production builds
- All network requests over HTTPS
- Firebase App Check enabled to prevent API abuse

### Code Security

- **ProGuard** (Android) and **bitcode** (iOS) for code obfuscation in production
- No secrets in source code — all via environment variables and EAS Secrets
- Dependency auditing via \`pnpm audit\` in CI

### Sensitive Paths

The following paths require senior/lead review (enforced via CODEOWNERS):

- \`src/services/auth/**\` — Authentication logic
- \`src/config/**\` — App configuration
- \`google-services.json\` — Firebase Android config
- \`GoogleService-Info.plist\` — Firebase iOS config
- \`.env*\` — Environment variables

## Privacy & Compliance

### GDPR

- **Consent Management**: Users must consent before data collection; preferences stored and respected
- **Data Export**: Users can request a full export of their data via profile settings
- **Data Deletion**: Account deletion removes all user data from Firestore and local database
- **Data Minimization**: Only necessary data is collected and retained

### App Store Guidelines

- **Privacy Nutrition Labels**: Maintained in App Store Connect, updated with each submission
- **App Tracking Transparency**: ATT prompt shown before any tracking (iOS 14.5+)
- **Sign in with Apple**: Available as a login option alongside Google

### Google Play Policies

- **Data Safety Section**: Maintained in Google Play Console
- **Permissions**: Only necessary permissions requested, with clear rationale
- **Target API Level**: Meets current Google Play requirements

## Monitoring & Analytics

| Tool | Purpose |
|---|---|
| **Sentry** | Error tracking, performance monitoring, release health |
| **Firebase Analytics** | User behavior, screen views, custom events |
| **Firebase Crashlytics** | Native crash reporting, ANR detection |
| **EAS Insights** | OTA update adoption, build metrics |

### Sentry Configuration

\`\`\`bash
# Sentry DSN is set via environment variable
SENTRY_DSN=https://examplePublicKey@o0.ingest.sentry.io/0
\`\`\`

Source maps and debug symbols are uploaded automatically during EAS Build.

## Troubleshooting

### Common Issues

**Metro bundler cache issues**
\`\`\`bash
npx expo start --clear
\`\`\`

**iOS pod install failures**
\`\`\`bash
cd ios && pod deintegrate && pod install && cd ..
\`\`\`

**Android build failures**
\`\`\`bash
cd android && ./gradlew clean && cd ..
\`\`\`

**WatermelonDB schema mismatch**
\`\`\`bash
# Reset local database (development only)
# Clear app data on device/simulator
\`\`\`

**EAS Build failures**
\`\`\`bash
# Check build logs
eas build:list
eas build:view <build-id>

# Verify credentials
eas credentials
\`\`\`

**Detox test failures**
\`\`\`bash
# Rebuild test app
npx detox build --configuration ios.sim.debug

# Reset simulator
xcrun simctl erase all
\`\`\`

### Useful Commands

\`\`\`bash
# Check Expo config
npx expo config --type public

# Verify native project
npx expo doctor

# List EAS builds
eas build:list

# View device logs
npx react-native log-ios
npx react-native log-android

# Open Firebase emulator
firebase emulators:start
\`\`\`

## Contributing

1. Read the [Onboarding Guide](docs/ONBOARDING.md)
2. Review the [Architecture Document](docs/ARCHITECTURE.md)
3. Follow the [Git Workflow](.claude/rules/common/git-workflow.md) and [Coding Standards](.claude/rules/typescript/coding-style.md)
4. Ensure all tests pass and coverage meets the 75% threshold
5. Open a PR using the [PR template](.github/PULL_REQUEST_TEMPLATE.md)
6. Get at least 1 approval before merging

### Code Review Checklist

- [ ] TypeScript strict mode — no \`any\` types
- [ ] All text goes through i18n
- [ ] Accessibility labels on all interactive elements
- [ ] Offline behavior tested
- [ ] Both iOS and Android verified
- [ ] Tests added/updated
- [ ] No sensitive data in code or logs

---

**Built with ❤️ using React Native, Expo, and Firebase**`,

  'docs/AI-USAGE-POLICY.md': `# AI Usage Policy — React Native Mobile App

## Purpose

This document defines when and how to use Claude (and other AI coding assistants) on the \`react-native-mobile-app\` project. It establishes review requirements, safety boundaries, and labeling standards to ensure AI-assisted code meets our quality, security, and compliance bar.

---

## Guiding Principles

1. **AI accelerates, humans decide.** Claude drafts code; engineers own correctness, security, and App Store/Play Store compliance.
2. **Transparency over speed.** Every AI-generated change must be labeled and reviewed — no silent merges.
3. **Sensitive paths get extra scrutiny.** Authentication, payments, native modules, and privacy-related code require senior/lead review regardless of origin.
4. **Offline-first safety.** AI-generated data layer code must be validated against WatermelonDB sync contracts and Firestore security rules.

---

## Permitted Uses

### Encouraged

| Use Case | Examples |
|---|---|
| **Feature scaffolding** | Generate a new feature directory under \`src/features/\` with screens, components, hooks, and types |
| **Component creation** | Build shared UI components in \`src/components/\` with proper TypeScript props, accessibility labels, and i18n |
| **Hook authoring** | Create custom hooks following the \`use*\` naming convention with proper typing |
| **Test generation** | Write Jest + React Native Testing Library tests, Detox E2E specs |
| **Navigation typing** | Generate typed navigator params for React Navigation v6 |
| **React Query setup** | Scaffold query hooks with proper cache keys, error handling, and offline behavior |
| **Zustand stores** | Create typed stores with proper selectors and persistence |
| **Documentation** | Architecture docs, runbooks, inline JSDoc comments |
| **Refactoring** | Extract components, split large files (>250 lines), improve type safety |
| **i18n strings** | Generate translation keys and locale files |
| **Platform helpers** | Write \`Platform.select\` utilities and platform-specific code |

### Permitted with Mandatory Senior Review

| Use Case | Required Reviewer | Reason |
|---|---|---|
| **Authentication flows** (\`src/features/auth/**\`, \`src/services/auth/**\`) | Lead or Senior | Security-critical; touches Keychain/Keystore, biometrics, Firebase Auth |
| **In-app purchases** (\`src/features/payments/**\`) | Lead | App Store/Play Store policy compliance; revenue impact |
| **Push notification handlers** (\`src/features/notifications/**\`) | Senior+ | Platform-specific lifecycle; background execution constraints |
| **Native module code** (Expo Modules API, bare native) | Lead | Must have both iOS and Android implementations; crash risk |
| **Deep linking config** (\`src/navigation/linking.ts\`) | Senior+ | Security implications; universal links / App Links verification |
| **Firebase Security Rules** | Lead | Direct data access control |
| **WatermelonDB schema/migrations** | Senior+ | Offline sync integrity; data loss risk |
| **CI/CD pipeline changes** (\`.github/workflows/**\`, \`eas.json\`) | Lead | Build/deploy integrity |
| **Privacy/consent code** | Lead | GDPR compliance; App Store privacy labels; Play data safety |

### Prohibited

| Use Case | Reason |
|---|---|
| **Code signing certificates or provisioning profiles** | Must be managed manually via EAS credentials or Apple/Google consoles |
| **Production secrets or API keys** | Never paste real keys into AI prompts; use \`.env\` files and \`expo-constants\` |
| **App Store / Play Store metadata submission** | Review descriptions, screenshots, and privacy declarations manually |
| **Security rule deployment without human test** | Firebase rules must be tested against the emulator suite before deploy |
| **Disabling TypeScript strict mode or ESLint rules** | No \`// @ts-ignore\`, \`any\` casts, or \`eslint-disable\` without documented justification |
| **Bypassing Detox E2E for critical flows** | Auth, payments, and onboarding E2E tests are mandatory |

---

## Labeling Requirements

### Commit Messages

All commits containing AI-generated or AI-assisted code must include the \`[AI]\` tag:

\`\`\`
feat(auth): [AI] add biometric authentication prompt screen
fix(sync): [AI] resolve WatermelonDB conflict resolution for offline edits
test(payments): [AI] add unit tests for subscription validation hook
\`\`\`

### Pull Requests

Use the AI-generated code section in the PR template:

\`\`\`markdown
## AI-Generated Code

- [ ] This PR contains AI-generated code
- **Tool used**: Claude (via Claude Code)
- **Scope**: Describe which files/functions were AI-generated
- **Human modifications**: Describe what you changed after generation
- **Verification**: Describe how you verified correctness
\`\`\`

### Inline Comments

For non-trivial AI-generated logic, add a brief comment:

\`\`\`typescript
// AI-generated: WatermelonDB sync adapter for Firestore
// Reviewed by: @engineer-handle on YYYY-MM-DD
\`\`\`

---

## Review Requirements by Risk Level

### Standard (1 approval)

- UI components with no native dependencies
- Utility functions and formatters
- Test files
- Documentation
- i18n translations
- Theme/styling changes

### Elevated (1 senior+ approval)

- React Query hooks that interact with Firebase
- Zustand store changes affecting persisted state
- Navigation structure changes
- New shared hooks in \`src/hooks/\`
- Accessibility improvements touching multiple screens

### Critical (lead approval + second reviewer)

- Any file in \`src/services/auth/**\`
- Any file in \`src/features/payments/**\`
- Any file in \`src/config/**\`
- WatermelonDB schema or migration files
- Native module implementations (iOS and Android)
- Firebase Cloud Functions
- Deep linking configuration
- Privacy consent flows
- Changes to \`google-services.json\` or \`GoogleService-Info.plist\`
- Changes to \`app.json\`, \`app.config.ts\`, or \`eas.json\`

---

## Platform-Specific Guidance

### iOS Considerations

- AI-generated code touching \`ios/\` directory must be tested on a physical device or Xcode simulator
- Keychain access patterns must use \`expo-secure-store\` or a reviewed native module
- Background fetch and push notification handlers must respect iOS app lifecycle
- In-app purchase code must comply with StoreKit 2 patterns and App Store Review Guidelines §3.1

### Android Considerations

- AI-generated code touching \`android/\` directory must be tested on a physical device or Android emulator
- Keystore access must use \`expo-secure-store\` or Android Keystore API
- Background work must use WorkManager patterns, not raw services
- Billing code must comply with Google Play Billing Library v6+ and Play Store policies

### Cross-Platform Validation

When Claude generates platform-specific code:

1. Verify both iOS and Android implementations exist
2. Run \`npx expo start --ios\` and \`npx expo start --android\` to confirm no crashes
3. Run Detox E2E on both platforms for critical flows
4. Check \`Platform.select\` and \`Platform.OS\` branches are complete

---

## AI Prompt Hygiene

### Do

- Provide Claude with relevant type definitions and interfaces
- Reference the project's feature-based architecture (\`src/features/<name>/\`)
- Specify the target platform when asking for native code
- Include error handling and loading state requirements in prompts
- Ask for accessibility labels on all interactive elements
- Request i18n key usage instead of hardcoded strings

### Do Not

- Paste production Firebase config, API keys, or signing credentials into prompts
- Share user PII or analytics data with AI tools
- Accept AI output without reading every line — especially for auth, payments, and sync logic
- Use AI to generate code that circumvents App Store or Play Store review guidelines
- Let AI add new native dependencies without team discussion (see Dependency Policy below)

---

## Dependency Policy for AI-Suggested Packages

Claude may suggest adding npm packages or native modules. Follow this process:

1. **Check if Expo SDK 51 already provides the functionality** (prefer \`expo-*\` packages)
2. **Verify the package** on npmjs.com — check maintenance status, download count, and last publish date
3. **Check native compatibility** — does it support both iOS and Android? Does it work with Expo managed workflow?
4. **Review bundle size impact** — use \`npx react-native-bundle-visualizer\` or similar
5. **For native modules**: require lead approval and test on both platforms before merging
6. **Document the decision** in the PR description

---

## Offline-First Code Review Checklist

When reviewing AI-generated code that touches the data layer:

- [ ] WatermelonDB model changes include a migration
- [ ] Sync logic handles conflict resolution correctly
- [ ] Optimistic updates are rolled back on sync failure
- [ ] Network status is checked via \`@react-native-community/netinfo\`
- [ ] Firestore security rules are updated if schema changed
- [ ] Offline behavior is tested with airplane mode on a physical device

---

## GDPR and Privacy Compliance

AI-generated code that collects, stores, or transmits user data must:

1. **Check consent state** before collecting data (use the consent store in \`src/store/\`)
2. **Support data deletion** — any new data model must have a corresponding deletion path
3. **Avoid unnecessary data collection** — only collect what the feature requires
4. **Update privacy documentation** if new data categories are introduced
5. **Map to App Store privacy labels** and **Google Play data safety** declarations

---

## Monitoring AI Code in Production

- **Sentry** tags AI-generated code via the \`[AI]\` commit tag for error attribution
- **Firebase Crashlytics** crash groups are cross-referenced with AI-labeled PRs during incident review
- **Firebase Analytics** tracks feature usage — AI-generated features are monitored for anomalies in the first 48 hours after deploy
- **Weekly review**: Tech lead reviews AI-generated code metrics (volume, defect rate, review turnaround) in the Monday sync

---

## Escalation

If AI-generated code causes a production incident:

1. Follow the standard incident response runbook in \`docs/INCIDENT-RESPONSE.md\`
2. Tag the originating PR and commit with \`incident:P<severity>\`
3. Conduct a blameless post-mortem that includes analysis of why the AI output was incorrect and what review step missed it
4. Update this policy if a systemic gap is identified

---

## Policy Review

This policy is reviewed quarterly or after any AI-related production incident. Proposed changes go through a PR with lead approval.

**Last updated**: 2024-12-01
**Owner**: Tech Lead
**Approved by**: Engineering Manager`,

  'docs/ARCHITECTURE.md': `# Architecture

## Overview

This document describes the architecture of the React Native mobile application built with Expo SDK 51, TypeScript, and Firebase. The app follows a **feature-based modular architecture** with **offline-first data sync**, **typed navigation**, and a clear separation between client state and server state.

## High-Level Architecture

\`\`\`
┌─────────────────────────────────────────────────────────┐
│                    Presentation Layer                     │
│  ┌─────────┐  ┌──────────┐  ┌──────────┐  ┌──────────┐ │
│  │ Screens  │  │Components│  │Navigation│  │  Theme   │ │
│  └────┬─────┘  └────┬─────┘  └────┬─────┘  └────┬─────┘ │
├───────┼──────────────┼─────────────┼─────────────┼───────┤
│                     State Layer                           │
│  ┌──────────────┐  ┌──────────────┐  ┌─────────────────┐ │
│  │   Zustand    │  │ React Query  │  │  React Context  │ │
│  │(Client State)│  │(Server State)│  │  (Navigation)   │ │
│  └──────┬───────┘  └──────┬───────┘  └────────┬────────┘ │
├─────────┼──────────────────┼───────────────────┼─────────┤
│                    Service Layer                          │
│  ┌──────────┐  ┌──────────┐  ┌──────────┐  ┌──────────┐ │
│  │   Auth   │  │ Firestore│  │Analytics │  │   Push   │ │
│  │ Service  │  │  Service │  │ Service  │  │ Service  │ │
│  └────┬─────┘  └────┬─────┘  └────┬─────┘  └────┬─────┘ │
├───────┼──────────────┼─────────────┼─────────────┼───────┤
│                     Data Layer                            │
│  ┌──────────────┐  ┌──────────────┐  ┌─────────────────┐ │
│  │ WatermelonDB │  │   Firebase   │  │  Secure Storage  │ │
│  │   (Local)    │  │  (Remote)    │  │ (Keychain/Store) │ │
│  └──────────────┘  └──────────────┘  └─────────────────┘ │
└─────────────────────────────────────────────────────────┘
\`\`\`

## Directory Structure

\`\`\`
src/
├── features/                # Feature modules
│   ├── auth/                # Authentication feature
│   │   ├── screens/         # LoginScreen, RegisterScreen, BiometricScreen
│   │   ├── components/      # AuthForm, SocialLoginButtons, BiometricPrompt
│   │   ├── hooks/           # useLogin, useRegister, useBiometric
│   │   ├── services/        # auth-api.ts, biometric-service.ts
│   │   └── types/           # auth.types.ts
│   ├── home/                # Home/dashboard feature
│   │   ├── screens/         # HomeScreen, DashboardScreen
│   │   ├── components/      # FeedCard, QuickActions, StatusBanner
│   │   ├── hooks/           # useFeed, useDashboard
│   │   └── types/           # home.types.ts
│   ├── profile/             # User profile feature
│   │   ├── screens/         # ProfileScreen, SettingsScreen, EditProfileScreen
│   │   ├── components/      # Avatar, PreferenceToggle, DataExportButton
│   │   ├── hooks/           # useProfile, useSettings, useDataExport
│   │   └── types/           # profile.types.ts
│   ├── notifications/       # Notifications feature
│   │   ├── screens/         # NotificationsScreen, NotificationDetailScreen
│   │   ├── components/      # NotificationCard, NotificationBadge
│   │   ├── hooks/           # useNotifications, usePushPermission
│   │   └── types/           # notification.types.ts
│   └── payments/            # In-app purchases feature
│       ├── screens/         # SubscriptionScreen, PaywallScreen
│       ├── components/      # PlanCard, PurchaseButton, ReceiptViewer
│       ├── hooks/           # useSubscription, usePurchase, useReceipt
│       └── types/           # payment.types.ts
├── components/              # Shared UI components
│   ├── Button.tsx
│   ├── Card.tsx
│   ├── Input.tsx
│   ├── Modal.tsx
│   ├── LoadingSpinner.tsx
│   ├── ErrorBoundary.tsx
│   ├── OfflineBanner.tsx
│   └── index.ts
├── hooks/                   # Shared hooks
│   ├── use-auth.ts
│   ├── use-offline.ts
│   ├── use-theme.ts
│   ├── use-deep-link.ts
│   ├── use-app-state.ts
│   └── index.ts
├── services/                # Core services
│   ├── firebase/            # Firebase initialization and wrappers
│   │   ├── app.ts
│   │   ├── auth.ts
│   │   ├── firestore.ts
│   │   ├── messaging.ts
│   │   ├── storage.ts
│   │   └── functions.ts
│   ├── analytics/           # Analytics abstraction
│   │   ├── analytics-service.ts
│   │   └── events.ts
│   ├── crash-reporting/     # Sentry + Crashlytics
│   │   └── crash-service.ts
│   ├── database/            # WatermelonDB setup
│   │   ├── schema.ts
│   │   ├── migrations.ts
│   │   ├── models/
│   │   └── sync.ts
│   ├── secure-storage/      # Keychain/Keystore wrapper
│   │   └── secure-storage.ts
│   └── api/                 # HTTP client, interceptors
│       └── client.ts
├── navigation/              # React Navigation
│   ├── types.ts             # Typed navigator params
│   ├── root-navigator.tsx
│   ├── auth-navigator.tsx
│   ├── main-tab-navigator.tsx
│   ├── linking-config.ts    # Deep link configuration
│   └── index.ts
├── store/                   # Zustand stores
│   ├── auth-store.ts
│   ├── theme-store.ts
│   ├── preferences-store.ts
│   └── index.ts
├── utils/                   # Shared utilities
│   ├── formatting.ts
│   ├── validation.ts
│   ├── platform.ts
│   ├── permissions.ts
│   └── constants.ts
├── i18n/                    # Internationalization
│   ├── index.ts
│   ├── en.json
│   └── es.json
├── theme/                   # Design system
│   ├── colors.ts
│   ├── typography.ts
│   ├── spacing.ts
│   └── index.ts
└── assets/                  # Static assets
    ├── images/
    ├── fonts/
    └── animations/          # Lottie files
\`\`\`

### Feature Module Rules

Each feature under \`src/features/\` is a self-contained module:

1. **screens/** — Full-page components registered with navigation. One file per screen.
2. **components/** — UI components used only within this feature. Shared components go in \`src/components/\`.
3. **hooks/** — Feature-specific hooks that compose services, stores, and React Query.
4. **services/** — Feature-specific API calls or business logic (optional — use \`src/services/\` for cross-cutting concerns).
5. **types/** — TypeScript interfaces and types scoped to the feature.

**Import rules:**
- Features may import from \`src/components/\`, \`src/hooks/\`, \`src/services/\`, \`src/store/\`, \`src/utils/\`, \`src/theme/\`, \`src/i18n/\`.
- Features must **never** import directly from another feature. Shared logic goes in \`src/hooks/\` or \`src/services/\`.
- Barrel exports (\`index.ts\`) are used at the feature root for screens only (consumed by navigation).

## Navigation Architecture

### Navigator Hierarchy

\`\`\`
RootNavigator (Stack)
├── AuthNavigator (Stack)                    [unauthenticated]
│   ├── LoginScreen
│   ├── RegisterScreen
│   ├── ForgotPasswordScreen
│   └── BiometricScreen
└── MainTabNavigator (Bottom Tabs)           [authenticated]
    ├── HomeStack (Stack)
    │   ├── HomeScreen
    │   └── DetailScreen
    ├── NotificationsStack (Stack)
    │   ├── NotificationsScreen
    │   └── NotificationDetailScreen
    ├── ProfileStack (Stack)
    │   ├── ProfileScreen
    │   ├── EditProfileScreen
    │   ├── SettingsScreen
    │   └── SubscriptionScreen
    └── PaywallModal (Modal Group)           [presented modally]
        └── PaywallScreen
\`\`\`

### Typed Navigation

All navigator params are defined in \`src/navigation/types.ts\`:

\`\`\`typescript
// src/navigation/types.ts
import type { NavigatorScreenParams } from '@react-navigation/native';

export type RootStackParamList = {
  Auth: NavigatorScreenParams<AuthStackParamList>;
  Main: NavigatorScreenParams<MainTabParamList>;
};

export type AuthStackParamList = {
  Login: undefined;
  Register: { referralCode?: string };
  ForgotPassword: { email?: string };
  Biometric: undefined;
};

export type MainTabParamList = {
  HomeTab: NavigatorScreenParams<HomeStackParamList>;
  NotificationsTab: NavigatorScreenParams<NotificationsStackParamList>;
  ProfileTab: NavigatorScreenParams<ProfileStackParamList>;
};

export type HomeStackParamList = {
  Home: undefined;
  Detail: { id: string };
};

// ... additional param lists
\`\`\`

Screens use typed \`useNavigation\` and \`useRoute\` via helper types:

\`\`\`typescript
import type { NativeStackScreenProps } from '@react-navigation/native-stack';

type Props = NativeStackScreenProps<HomeStackParamList, 'Detail'>;

export const DetailScreen = ({ route, navigation }: Props) => {
  const { id } = route.params; // fully typed
};
\`\`\`

### Deep Linking

Deep links are configured in \`src/navigation/linking-config.ts\` and registered with Expo's linking scheme:

\`\`\`
myapp://                          → HomeScreen
myapp://profile                   → ProfileScreen
myapp://notifications/:id         → NotificationDetailScreen
myapp://subscribe                 → PaywallScreen
https://myapp.com/invite/:code    → RegisterScreen (universal link)
\`\`\`

The linking config maps URL patterns to navigator paths. Universal links require Associated Domains (iOS) and App Links (Android) configuration in \`app.json\`.

## State Management

### Three-Layer State Model

| Layer | Tool | Purpose | Persistence |
|-------|------|---------|-------------|
| **Client State** | Zustand | UI state, user preferences, auth tokens | AsyncStorage (encrypted) |
| **Server State** | React Query (TanStack Query) | Remote data, caching, background sync | In-memory + WatermelonDB |
| **Local Database** | WatermelonDB | Offline-first data, complex queries | SQLite |

### Zustand (Client State)

Zustand stores manage ephemeral and persisted client-side state. Each store is a single file in \`src/store/\`.

\`\`\`typescript
// src/store/auth-store.ts
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';

interface AuthState {
  isAuthenticated: boolean;
  userId: string | null;
  biometricEnabled: boolean;
  setAuthenticated: (userId: string) => void;
  logout: () => void;
  toggleBiometric: (enabled: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      userId: null,
      biometricEnabled: false,
      setAuthenticated: (userId) =>
        set({ isAuthenticated: true, userId }),
      logout: () =>
        set({ isAuthenticated: false, userId: null }),
      toggleBiometric: (enabled) =>
        set({ biometricEnabled: enabled }),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
\`\`\`

**Store guidelines:**
- One store per domain (auth, theme, preferences). Do not create a monolithic store.
- Use \`persist\` middleware only for state that must survive app restarts.
- Sensitive tokens (access tokens, refresh tokens) go in secure storage (Keychain/Keystore), not Zustand.
- Selectors should be used to minimize re-renders: \`const userId = useAuthStore((s) => s.userId);\`

### React Query (Server State)

React Query manages all data fetched from Firebase/Firestore and Cloud Functions. Query keys follow a consistent naming convention.

\`\`\`typescript
// src/features/home/hooks/use-feed.ts
import { useQuery } from '@tanstack/react-query';
import { fetchFeedItems } from '../services/feed-api';

export const FEED_QUERY_KEY = ['feed'] as const;

export const useFeed = () => {
  return useQuery({
    queryKey: FEED_QUERY_KEY,
    queryFn: fetchFeedItems,
    staleTime: 5 * 60 * 1000,       // 5 minutes
    gcTime: 30 * 60 * 1000,          // 30 minutes (formerly cacheTime)
    retry: 3,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000),
  });
};
\`\`\`

**Query key conventions:**
- Entity list: \`['feed']\`, \`['notifications']\`
- Entity detail: \`['notification', id]\`
- Filtered list: \`['feed', { category, page }]\`
- User-scoped: \`['user', userId, 'profile']\`

**Mutation pattern:**

\`\`\`typescript
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateProfileApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user', 'profile'] });
    },
  });
};
\`\`\`

### When to Use What

| Scenario | Tool |
|----------|------|
| Current user session, UI theme, onboarding state | Zustand |
| Feed items, user profile from Firestore, notification list | React Query |
| Large datasets needing offline queries, relational data | WatermelonDB |
| Auth tokens, encryption keys, biometric credentials | Secure Storage |
| Navigation state | React Navigation (managed internally) |

## Offline-First Architecture

### Overview

The app is designed to work fully offline. Users can read cached data, create/edit records, and queue actions. When connectivity returns, changes sync bidirectionally with Firestore.

\`\`\`
┌──────────────┐         ┌──────────────┐         ┌──────────────┐
│   UI Layer   │ ◄─────► │ WatermelonDB │ ◄─────► │  Firestore   │
│  (Screens)   │  read/  │   (SQLite)   │  sync   │   (Remote)   │
│              │  write   │              │         │              │
└──────────────┘         └──────────────┘         └──────────────┘
                               │
                          ┌────┴────┐
                          │  Sync   │
                          │ Engine  │
                          └─────────┘
                          Triggered by:
                          • App foreground
                          • Network restored
                          • Pull-to-refresh
                          • Periodic (15 min)
\`\`\`

### WatermelonDB Setup

**Schema** (\`src/services/database/schema.ts\`):

\`\`\`typescript
import { appSchema, tableSchema } from '@nozbe/watermelondb';

export const schema = appSchema({
  version: 1,
  tables: [
    tableSchema({
      name: 'feed_items',
      columns: [
        { name: 'remote_id', type: 'string', isIndexed: true },
        { name: 'title', type: 'string' },
        { name: 'body', type: 'string' },
        { name: 'category', type: 'string', isIndexed: true },
        { name: 'is_read', type: 'boolean' },
        { name: 'created_at', type: 'number' },
        { name: 'updated_at', type: 'number' },
        { name: 'synced_at', type: 'number', isOptional: true },
      ],
    }),
    tableSchema({
      name: 'notifications',
      columns: [
        { name: 'remote_id', type: 'string', isIndexed: true },
        { name: 'title', type: 'string' },
        { name: 'message', type: 'string' },
        { name: 'is_read', type: 'boolean' },
        { name: 'received_at', type: 'number' },
      ],
    }),
  ],
});
\`\`\`

**Sync engine** (\`src/services/database/sync.ts\`):

The sync engine uses WatermelonDB's \`synchronize()\` with a Firebase Cloud Function as the sync endpoint:

\`\`\`typescript
import { synchronize } from '@nozbe/watermelondb/sync';
import { database } from './database';
import { callCloudFunction } from '../firebase/functions';

export const syncDatabase = async (): Promise<void> => {
  await synchronize({
    database,
    pullChanges: async ({ lastPulledAt }) => {
      const response = await callCloudFunction('syncPull', {
        lastPulledAt,
      });
      return {
        changes: response.changes,
        timestamp: response.timestamp,
      };
    },
    pushChanges: async ({ changes, lastPulledAt }) => {
      await callCloudFunction('syncPush', {
        changes,
        lastPulledAt,
      });
    },
    migrationsEnabledAtVersion: 1,
  });
};
\`\`\`

### Sync Triggers

| Trigger | Mechanism |
|---------|-----------|
| App comes to foreground | \`useAppState\` hook detects \`active\` state |
| Network restored | NetInfo listener in \`useOffline\` hook |
| Pull-to-refresh | User gesture on list screens |
| Periodic background | Expo BackgroundFetch (every 15 minutes) |
| After mutation | React Query \`onSuccess\` callback triggers sync |

### Conflict Resolution

Conflicts are resolved server-side in the Cloud Function using **last-write-wins** with \`updated_at\` timestamps. The Cloud Function compares the client's \`updated_at\` with the server's and keeps the newer version. For critical fields (e.g., payment status), server always wins regardless of timestamp.

### Offline Queue

Write operations that occur offline are stored in WatermelonDB's pending changes. The sync engine pushes these when connectivity returns. The UI shows an \`OfflineBanner\` component when the device is offline, and a sync indicator when changes are being pushed.

## Firebase Architecture

### Services Used

| Service | Purpose |
|---------|---------|
| **Authentication** | Email/password, Google Sign-In, Apple Sign-In, anonymous auth |
| **Firestore** | Primary remote database, real-time listeners for critical data |
| **Cloud Functions** | Sync endpoint, payment webhooks, push notification triggers |
| **Cloud Messaging (FCM)** | Push notifications (iOS via APNs, Android via FCM) |
| **Cloud Storage** | User avatars, file uploads |
| **Remote Config** | Feature flags, A/B testing |

### Firestore Data Model

\`\`\`
users/
  {userId}/
    profile: { displayName, email, avatarUrl, createdAt, updatedAt }
    settings: { theme, locale, notificationsEnabled, biometricEnabled }
    subscriptions/
      {subscriptionId}: { plan, status, expiresAt, platform }

feed_items/
  {itemId}: { title, body, category, authorId, createdAt, updatedAt }

notifications/
  {userId}/
    items/
      {notificationId}: { title, message, isRead, type, data, receivedAt }
\`\`\`

### Security Rules

Firestore security rules enforce:
- Users can only read/write their own \`users/{userId}\` document.
- Feed items are readable by all authenticated users, writable only by admins.
- Notifications are scoped to the owning user.
- All writes validate required fields and data types.

### Cloud Functions

Cloud Functions are organized by trigger type:

\`\`\`
functions/
├── src/
│   ├── sync/              # syncPull, syncPush (HTTP callable)
│   ├── auth/              # onUserCreate, onUserDelete (Auth triggers)
│   ├── notifications/     # sendPush, onNotificationCreate (Firestore triggers)
│   ├── payments/          # webhookHandler (HTTP), onSubscriptionChange
│   └── index.ts           # Export all functions
\`\`\`

## Push Notifications

### Flow

\`\`\`
1. App registers for push → gets FCM token
2. Token stored in Firestore: users/{userId}/fcmTokens/{tokenId}
3. Cloud Function triggered by event (e.g., new message)
4. Cloud Function sends via FCM → APNs (iOS) / FCM (Android)
5. App receives in foreground → in-app notification
6. App receives in background → system notification
7. User taps notification → deep link routes to correct screen
\`\`\`

### Notification Handling

\`\`\`typescript
// Foreground: show in-app toast, don't interrupt user
// Background: system notification with deep link
// Killed: system notification, app opens to deep link target
// Data-only: silent sync trigger (no user-visible notification)
\`\`\`

## Authentication Flow

\`\`\`
App Launch
    │
    ▼
Check Secure Storage for refresh token
    │
    ├── No token → AuthNavigator (LoginScreen)
    │
    ├── Token found, biometric enabled
    │   │
    │   ▼
    │   BiometricScreen → Success → MainTabNavigator
    │                   → Failure → LoginScreen
    │
    └── Token found, no biometric
        │
        ▼
        Silent token refresh → Success → MainTabNavigator
                             → Failure → LoginScreen (token expired)
\`\`\`

### Secure Token Storage

- **iOS**: Keychain Services via \`expo-secure-store\`
- **Android**: Android Keystore via \`expo-secure-store\`
- Access tokens are short-lived (1 hour). Refresh tokens are long-lived and stored encrypted.
- On logout, all tokens are cleared from secure storage and Zustand auth store is reset.

## In-App Purchases

### Architecture

\`\`\`
┌──────────────┐     ┌──────────────┐     ┌──────────────┐
│  PaywallScreen│────►│ RevenueCat   │────►│ App Store /  │
│  PlanCard     │     │    SDK       │     │ Google Play  │
└──────────────┘     └──────┬───────┘     └──────────────┘
                            │
                     ┌──────▼───────┐
                     │   Webhook    │
                     │ (Cloud Fn)   │
                     └──────┬───────┘
                            │
                     ┌──────▼───────┐
                     │  Firestore   │
                     │ subscription │
                     └──────────────┘
\`\`\`

- RevenueCat SDK handles store interactions, receipt validation, and entitlement management.
- Webhooks from RevenueCat hit a Cloud Function that updates Firestore subscription status.
- The app reads subscription status from Firestore (via React Query) to gate premium features.
- Receipt validation is **never** done client-side.

## Analytics & Crash Reporting

### Analytics Pipeline

\`\`\`
User Action → Analytics Service → Firebase Analytics
                                → Custom Events (Firestore)
\`\`\`

All analytics go through \`src/services/analytics/analytics-service.ts\`, which provides a unified API. This abstraction allows swapping providers without changing feature code.

**Standard events tracked:**
- Screen views (automatic via React Navigation)
- Feature usage (button taps, feature toggles)
- Funnel events (onboarding steps, purchase flow)
- Error events (API failures, sync failures)

### Crash Reporting

- **Sentry** for JavaScript-level errors and performance monitoring.
- **Firebase Crashlytics** for native crashes (iOS/Android).
- \`ErrorBoundary\` component at the root catches unhandled React errors, logs to both services, and shows a recovery UI.

## Performance Considerations

### Rendering

- Use \`React.memo\` for list item components.
- Use \`FlashList\` (from Shopify) instead of \`FlatList\` for large lists.
- Avoid inline styles — use \`StyleSheet.create\` or the theme system.
- Images use \`expo-image\` with caching and progressive loading.

### Bundle Size

- Tree-shake Firebase imports (use modular SDK: \`firebase/auth\`, not \`firebase\`).
- Lazy-load feature navigators with \`React.lazy\` + \`Suspense\`.
- Monitor bundle size in CI with \`npx expo export\` analysis.

### Memory

- WatermelonDB queries are lazy — use \`.observe()\` for reactive lists.
- Dispose Firestore listeners on screen unmount.
- Use \`useCallback\` and \`useMemo\` judiciously — profile before optimizing.

## Build & Deployment

### Environments

| Environment | EAS Profile | Firebase Project | Purpose |
|-------------|-------------|------------------|---------|
| Development | \`development\` | \`myapp-dev\` | Local development, Expo Go |
| Staging | \`preview\` | \`myapp-staging\` | QA testing, TestFlight / Internal Track |
| Production | \`production\` | \`myapp-prod\` | App Store / Google Play |

### Build Pipeline

\`\`\`
Push to main
    │
    ▼
GitHub Actions CI
    ├── Lint (ESLint)
    ├── Type Check (tsc --noEmit)
    ├── Unit Tests (Jest)
    └── Component Tests (RNTL)
         │
         ▼
    EAS Build (triggered on tag or manual)
    ├── iOS Build (eas build --platform ios --profile preview)
    └── Android Build (eas build --platform android --profile preview)
         │
         ▼
    Detox E2E Tests (on built artifacts)
         │
         ▼
    EAS Submit (eas submit)
    ├── TestFlight (iOS staging)
    └── Internal Track (Android staging)
\`\`\`

### OTA Updates

Non-native changes (JS bundle, assets) are deployed via \`eas update\` without a full app store review:

\`\`\`bash
eas update --branch staging --message "fix: resolve feed loading issue"
\`\`\`

OTA updates are channel-scoped (\`staging\`, \`production\`) and can be rolled back instantly.

## Security Architecture

See \`.claude/rules/common/security.md\` for detailed security guidelines.

**Key principles:**
- Tokens in Keychain (iOS) / Keystore (Android) via \`expo-secure-store\`
- Certificate pinning for API calls to Firebase
- Code obfuscation enabled in production builds (Hermes bytecode + ProGuard)
- No sensitive data in AsyncStorage, logs, or crash reports
- Biometric authentication gates re-entry after background timeout
- All user input validated client-side and server-side

## Privacy & Compliance

See GDPR requirements and platform policies:

- **GDPR**: Consent collection before analytics, data export endpoint, account deletion flow, privacy policy deep link
- **App Store**: Privacy nutrition labels in App Store Connect, ATT prompt for tracking
- **Google Play**: Data safety section declarations, prominent disclosure for sensitive permissions

User data deletion flow:
1. User requests deletion in Settings → calls Cloud Function
2. Cloud Function deletes Firestore documents, Auth account, Storage files
3. Local WatermelonDB is wiped on next app launch
4. Confirmation email sent

## Accessibility

- All interactive elements have \`accessibilityLabel\` and \`accessibilityRole\`.
- Screen readers tested with VoiceOver (iOS) and TalkBack (Android).
- Minimum touch target size: 44×44 points.
- Color contrast ratios meet WCAG 2.1 AA.
- Dynamic type / font scaling supported.
- Reduced motion respected via \`useReducedMotion\` hook.

## Related Documentation

- [CLAUDE.md](../CLAUDE.md) — Project conventions and quick reference
- [.claude/rules/common/coding-style.md](../.claude/rules/common/coding-style.md) — Coding standards
- [.claude/rules/common/testing.md](../.claude/rules/common/testing.md) — Testing guidelines
- [.claude/rules/common/security.md](../.claude/rules/common/security.md) — Security rules
- [.github/workflows/ci.yml](../.github/workflows/ci.yml) — CI pipeline
- [.github/workflows/deploy-staging.yml](../.github/workflows/deploy-staging.yml) — Staging deployment
- [.github/workflows/deploy-production.yml](../.github/workflows/deploy-production.yml) — Production deployment`,

  'docs/CONTRIBUTING.md': `# Contributing Guide

Welcome to the **react-native-mobile-app** project. This guide covers our conventions, patterns, and processes for contributing code.

## Table of Contents

- [Getting Started](#getting-started)
- [Feature Module Conventions](#feature-module-conventions)
- [Component Patterns](#component-patterns)
- [Navigation Patterns](#navigation-patterns)
- [State Management Patterns](#state-management-patterns)
- [Offline-First Patterns](#offline-first-patterns)
- [Internationalization](#internationalization)
- [Accessibility](#accessibility)
- [Testing](#testing)
- [Pull Request Process](#pull-request-process)
- [Code Review Guidelines](#code-review-guidelines)
- [Common Pitfalls](#common-pitfalls)

---

## Getting Started

### Prerequisites

- Node.js 20+
- pnpm 9+
- Xcode 15+ (macOS, for iOS development)
- Android Studio Hedgehog+ (for Android development)
- EAS CLI (\`pnpm add -g eas-cli\`)
- Firebase CLI (\`pnpm add -g firebase-tools\`)

### Setup

\`\`\`bash
git clone git@github.com:<org>/react-native-mobile-app.git
cd react-native-mobile-app
pnpm install
npx expo prebuild
npx expo start
\`\`\`

### Running on Devices

\`\`\`bash
# iOS Simulator
npx expo run:ios

# Android Emulator
npx expo run:android

# Physical device via Expo Go
npx expo start --tunnel
\`\`\`

### Environment Configuration

Copy \`.env.example\` to \`.env.staging\` and \`.env.production\`. Never commit \`.env*\` files — they are in \`.gitignore\`. See \`docs/ONBOARDING.md\` for required environment variables.

---

## Feature Module Conventions

Every feature lives under \`src/features/<feature-name>/\` with a consistent internal structure.

### Directory Layout

\`\`\`
src/features/auth/
├── screens/
│   ├── login-screen.tsx
│   ├── register-screen.tsx
│   └── biometric-screen.tsx
├── components/
│   ├── login-form.tsx
│   ├── social-auth-buttons.tsx
│   └── password-strength-indicator.tsx
├── hooks/
│   ├── use-login.ts
│   ├── use-register.ts
│   └── use-biometric-auth.ts
├── services/
│   ├── auth-api.ts              # Firebase Auth calls
│   └── auth-api.test.ts
├── types/
│   └── auth.types.ts
├── __tests__/
│   ├── login-screen.test.tsx
│   ├── register-screen.test.tsx
│   └── login-form.test.tsx
└── index.ts                     # Public API barrel export
\`\`\`

### Naming Rules

| Item | Convention | Example |
|------|-----------|---------|
| Files | kebab-case | \`login-screen.tsx\` |
| Components | PascalCase | \`LoginScreen\`, \`LoginForm\` |
| Hooks | camelCase with \`use\` prefix | \`useLogin\`, \`useBiometricAuth\` |
| Types/Interfaces | PascalCase | \`LoginFormValues\`, \`AuthState\` |
| Constants | SCREAMING_SNAKE_CASE | \`MAX_LOGIN_ATTEMPTS\`, \`TOKEN_EXPIRY_MS\` |
| Test files | \`<name>.test.tsx\` or in \`__tests__/\` | \`login-form.test.tsx\` |

### Barrel Exports

Each feature must have an \`index.ts\` that exports its public API. Other features import only from this barrel — never reach into internal files.

\`\`\`typescript
// src/features/auth/index.ts
export { LoginScreen } from './screens/login-screen';
export { RegisterScreen } from './screens/register-screen';
export { useLogin } from './hooks/use-login';
export { useAuth } from './hooks/use-auth';
export type { AuthState, LoginFormValues } from './types/auth.types';
\`\`\`

\`\`\`typescript
// ✅ Correct — import from barrel
import { LoginScreen, useAuth } from '@/features/auth';

// ❌ Wrong — reaching into feature internals
import { LoginScreen } from '@/features/auth/screens/login-screen';
\`\`\`

### Creating a New Feature

1. Create the directory structure under \`src/features/<feature-name>/\`
2. Define types in \`types/<feature>.types.ts\`
3. Build services (API layer) in \`services/\`
4. Create hooks that wrap services and manage state
5. Build components (presentational) in \`components/\`
6. Compose screens in \`screens/\`
7. Export public API from \`index.ts\`
8. Register screens in \`src/navigation/\`
9. Write tests alongside each layer

### File Length Limit

Files must not exceed **250 lines**. If a file grows beyond this:

- Extract sub-components into \`components/\`
- Extract logic into custom hooks in \`hooks/\`
- Split large types into separate type files

---

## Component Patterns

### Shared Components (\`src/components/\`)

Shared components are reusable across features. They must be:

- **Presentational** — no business logic, no direct API calls
- **Typed** — explicit props interface exported alongside the component
- **Accessible** — \`accessibilityLabel\`, \`accessibilityRole\`, \`accessibilityHint\` on all interactive elements
- **Themed** — use design tokens from \`src/theme/\`, never hardcoded colors or sizes
- **Tested** — unit test for each component

\`\`\`typescript
// src/components/button.tsx
import React from 'react';
import { Pressable, Text, StyleSheet, ActivityIndicator } from 'react-native';
import { useTheme } from '@/hooks/use-theme';
import { t } from '@/i18n';

interface ButtonProps {
  title: string;
  onPress: () => void;
  variant?: 'primary' | 'secondary' | 'ghost';
  loading?: boolean;
  disabled?: boolean;
  accessibilityLabel: string;
  testID?: string;
}

export const Button: React.FC<ButtonProps> = ({
  title,
  onPress,
  variant = 'primary',
  loading = false,
  disabled = false,
  accessibilityLabel,
  testID,
}) => {
  const { colors, spacing } = useTheme();

  return (
    <Pressable
      onPress={onPress}
      disabled={disabled || loading}
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      accessibilityState={{ disabled: disabled || loading, busy: loading }}
      testID={testID}
      style={({ pressed }) => [
        styles.base,
        { backgroundColor: colors[variant], padding: spacing.md },
        pressed && styles.pressed,
        disabled && styles.disabled,
      ]}
    >
      {loading ? (
        <ActivityIndicator color={colors.onPrimary} />
      ) : (
        <Text style={[styles.text, { color: colors.onPrimary }]}>{title}</Text>
      )}
    </Pressable>
  );
};
\`\`\`

### Screen Components

Screens are the top-level components rendered by React Navigation. They:

- Receive navigation and route props (typed)
- Compose feature components and shared components
- Handle screen-level side effects via hooks
- Set navigation options (header, title)

\`\`\`typescript
// src/features/auth/screens/login-screen.tsx
import React from 'react';
import { View, StyleSheet } from 'react-native';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import type { AuthStackParamList } from '@/navigation/types';
import { LoginForm } from '../components/login-form';
import { SocialAuthButtons } from '../components/social-auth-buttons';
import { useLogin } from '../hooks/use-login';
import { SafeAreaView } from 'react-native-safe-area-context';

type Props = NativeStackScreenProps<AuthStackParamList, 'Login'>;

export const LoginScreen: React.FC<Props> = ({ navigation }) => {
  const { login, isLoading, error } = useLogin();

  const handleLogin = async (values: LoginFormValues) => {
    const success = await login(values);
    if (success) {
      navigation.replace('Main');
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <LoginForm
        onSubmit={handleLogin}
        isLoading={isLoading}
        error={error}
      />
      <SocialAuthButtons />
    </SafeAreaView>
  );
};
\`\`\`

### Hook Patterns

Hooks encapsulate business logic and side effects. Follow these conventions:

\`\`\`typescript
// src/features/auth/hooks/use-login.ts
import { useMutation } from '@tanstack/react-query';
import { useAuthStore } from '@/store/auth-store';
import { authApi } from '../services/auth-api';
import { analytics } from '@/services/analytics';
import type { LoginFormValues } from '../types/auth.types';

export const useLogin = () => {
  const setUser = useAuthStore((state) => state.setUser);

  const mutation = useMutation({
    mutationFn: (values: LoginFormValues) => authApi.login(values),
    onSuccess: (user) => {
      setUser(user);
      analytics.logEvent('login_success', { method: 'email' });
    },
    onError: (error) => {
      analytics.logEvent('login_failure', { reason: error.message });
    },
  });

  return {
    login: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error?.message ?? null,
  };
};
\`\`\`

**Rules for hooks:**

- Use React Query (\`useQuery\`, \`useMutation\`) for all server state
- Use Zustand stores for client-only state (theme, preferences, auth session)
- Never mix server state and client state in the same hook — compose them
- Return a clean API object, not raw React Query internals

---

## Navigation Patterns

All navigation is typed via React Navigation v6. See \`src/navigation/types.ts\` for param list definitions.

### Defining Param Lists

\`\`\`typescript
// src/navigation/types.ts
export type RootStackParamList = {
  Auth: undefined;
  Main: undefined;
  DeepLink: { url: string };
};

export type AuthStackParamList = {
  Login: undefined;
  Register: undefined;
  ForgotPassword: { email?: string };
  Biometric: undefined;
};

export type MainTabParamList = {
  Home: undefined;
  Profile: undefined;
  Notifications: undefined;
  Settings: undefined;
};
\`\`\`

### Deep Linking

Deep link configuration lives in \`src/navigation/linking-config.ts\`. When adding a new deep link:

1. Add the route to the appropriate param list
2. Add the path mapping in \`linking-config.ts\`
3. Handle the deep link params in the target screen
4. Add E2E test coverage for the deep link

---

## State Management Patterns

### Zustand (Client State)

\`\`\`typescript
// src/store/auth-store.ts
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';
import type { User } from '@/features/auth/types/auth.types';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  setUser: (user: User | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      setUser: (user) => set({ user, isAuthenticated: !!user }),
      logout: () => set({ user: null, isAuthenticated: false }),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
\`\`\`

### React Query (Server State)

- Configure query client in \`src/services/query-client.ts\`
- Use query keys consistently: \`['feature', 'entity', params]\`
- Set appropriate \`staleTime\` and \`gcTime\` for mobile (longer than web defaults)
- Handle offline scenarios with \`networkMode: 'offlineFirst'\`

---

## Offline-First Patterns

We use WatermelonDB for local persistence with sync to Firestore.

### Key Principles

1. **Read from local DB first** — UI always renders from WatermelonDB
2. **Write locally, sync later** — mutations write to WatermelonDB, then sync
3. **Conflict resolution** — server wins by default; document exceptions
4. **Sync status** — expose sync state to UI via \`useOffline\` hook

### Adding a New Synced Model

1. Define the WatermelonDB model in \`src/services/database/models/\`
2. Define the schema migration in \`src/services/database/migrations/\`
3. Implement sync adapter in \`src/services/database/sync/\`
4. Create a hook that reads from WatermelonDB and triggers sync
5. Test offline → online transitions in Detox E2E

---

## Internationalization

All user-facing text must go through \`src/i18n/\`. Never hardcode strings.

\`\`\`typescript
// ✅ Correct
import { t } from '@/i18n';
<Text>{t('auth.login.title')}</Text>

// ❌ Wrong
<Text>Log In</Text>
\`\`\`

### Adding Translations

1. Add the key to \`src/i18n/locales/en.json\`
2. Add translations for all supported locales
3. Use ICU message format for plurals and interpolation

---

## Accessibility

All interactive elements **must** have accessibility properties:

\`\`\`typescript
// Required for every Pressable, TouchableOpacity, Button, TextInput, etc.
accessibilityLabel="Descriptive label for screen readers"
accessibilityRole="button" // or "link", "search", "image", etc.
accessibilityHint="Describes what happens when activated" // optional but encouraged
accessibilityState={{ disabled, selected, checked }} // when applicable
\`\`\`

Test accessibility with:

- iOS: VoiceOver (Xcode Accessibility Inspector)
- Android: TalkBack (Accessibility Scanner)
- Automated: \`jest-axe\` in component tests where applicable

---

## Testing

### Test Pyramid

| Layer | Tool | Location | Coverage Target |
|-------|------|----------|----------------|
| Unit | Jest | \`**/*.test.ts\` | 80%+ |
| Component | React Native Testing Library | \`**/*.test.tsx\` | 75%+ |
| Integration | Jest + RNTL | \`__tests__/integration/\` | Key flows |
| E2E | Detox | \`e2e/\` | Critical paths |

**Overall coverage threshold: 75%**

### Unit Tests

Test hooks, utilities, and services in isolation.

\`\`\`typescript
// src/features/auth/services/auth-api.test.ts
import { authApi } from './auth-api';
import { firebaseAuth } from '@/services/firebase';

jest.mock('@/services/firebase');

describe('authApi', () => {
  describe('login', () => {
    it('calls Firebase signInWithEmailAndPassword', async () => {
      const mockSignIn = jest.mocked(firebaseAuth.signInWithEmailAndPassword);
      mockSignIn.mockResolvedValue({ user: { uid: '123' } } as never);

      const result = await authApi.login({
        email: 'test@example.com',
        password: 'securePassword1!',
      });

      expect(mockSignIn).toHaveBeenCalledWith(
        expect.anything(),
        'test@example.com',
        'securePassword1!',
      );
      expect(result.uid).toBe('123');
    });

    it('throws on invalid credentials', async () => {
      const mockSignIn = jest.mocked(firebaseAuth.signInWithEmailAndPassword);
      mockSignIn.mockRejectedValue(new Error('auth/wrong-password'));

      await expect(
        authApi.login({ email: 'test@example.com', password: 'wrong' }),
      ).rejects.toThrow('auth/wrong-password');
    });
  });
});
\`\`\`

### Component Tests

Use React Native Testing Library. Test behavior, not implementation.

\`\`\`typescript
// src/features/auth/__tests__/login-form.test.tsx
import React from 'react';
import { render, fireEvent, waitFor } from '@testing-library/react-native';
import { LoginForm } from '../components/login-form';

describe('LoginForm', () => {
  const mockOnSubmit = jest.fn();

  it('renders email and password fields', () => {
    const { getByLabelText } = render(
      <LoginForm onSubmit={mockOnSubmit} isLoading={false} error={null} />,
    );

    expect(getByLabelText('Email address')).toBeTruthy();
    expect(getByLabelText('Password')).toBeTruthy();
  });

  it('calls onSubmit with form values', async () => {
    const { getByLabelText, getByRole } = render(
      <LoginForm onSubmit={mockOnSubmit} isLoading={false} error={null} />,
    );

    fireEvent.changeText(getByLabelText('Email address'), 'user@test.com');
    fireEvent.changeText(getByLabelText('Password'), 'password123');
    fireEvent.press(getByRole('button', { name: /log in/i }));

    await waitFor(() => {
      expect(mockOnSubmit).toHaveBeenCalledWith({
        email: 'user@test.com',
        password: 'password123',
      });
    });
  });

  it('displays error message when error prop is set', () => {
    const { getByText } = render(
      <LoginForm
        onSubmit={mockOnSubmit}
        isLoading={false}
        error="Invalid credentials"
      />,
    );

    expect(getByText('Invalid credentials')).toBeTruthy();
  });

  it('disables submit button when loading', () => {
    const { getByRole } = render(
      <LoginForm onSubmit={mockOnSubmit} isLoading={true} error={null} />,
    );

    expect(getByRole('button', { name: /log in/i })).toBeDisabled();
  });
});
\`\`\`

### Detox E2E Tests

E2E tests live in \`e2e/\` and test critical user flows on real simulators/emulators.

#### Setup

\`\`\`bash
# Build for E2E
npx detox build --configuration ios.sim.debug

# Run E2E tests
npx detox test --configuration ios.sim.debug
\`\`\`

#### Writing Detox Tests

\`\`\`typescript
// e2e/auth/login.e2e.ts
import { device, element, by, expect } from 'detox';

describe('Login Flow', () => {
  beforeAll(async () => {
    await device.launchApp({ newInstance: true });
  });

  beforeEach(async () => {
    await device.reloadReactNative();
  });

  it('should show login screen on launch when not authenticated', async () => {
    await expect(element(by.id('login-screen'))).toBeVisible();
    await expect(element(by.id('email-input'))).toBeVisible();
    await expect(element(by.id('password-input'))).toBeVisible();
  });

  it('should show validation error for empty fields', async () => {
    await element(by.id('login-button')).tap();
    await expect(element(by.text('Email is required'))).toBeVisible();
  });

  it('should login successfully with valid credentials', async () => {
    await element(by.id('email-input')).typeText('test@example.com');
    await element(by.id('password-input')).typeText('validPassword1!');
    await element(by.id('login-button')).tap();

    await waitFor(element(by.id('home-screen')))
      .toBeVisible()
      .withTimeout(10000);
  });

  it('should show error for invalid credentials', async () => {
    await element(by.id('email-input')).typeText('test@example.com');
    await element(by.id('password-input')).typeText('wrongPassword');
    await element(by.id('login-button')).tap();

    await waitFor(element(by.text('Invalid credentials')))
      .toBeVisible()
      .withTimeout(5000);
  });

  it('should navigate to register screen', async () => {
    await element(by.id('register-link')).tap();
    await expect(element(by.id('register-screen'))).toBeVisible();
  });
});
\`\`\`

#### Detox Best Practices

- Use \`testID\` props for element selection — never match on text for actions (text is i18n-dependent)
- Use \`waitFor(...).toBeVisible().withTimeout()\` for async operations
- Clean state between tests with \`device.reloadReactNative()\` or \`device.launchApp({ delete: true })\`
- Group E2E tests by feature: \`e2e/auth/\`, \`e2e/payments/\`, \`e2e/notifications/\`
- Keep E2E tests focused on critical paths — don't duplicate unit test coverage
- Mock external services (Firebase, payment providers) via Detox mock servers or test accounts

#### Adding testID Props

Every interactive element that E2E tests target must have a \`testID\`:

\`\`\`typescript
<TextInput
  testID="email-input"
  accessibilityLabel="Email address"
  // ...
/>
<Pressable
  testID="login-button"
  accessibilityLabel="Log in"
  accessibilityRole="button"
  // ...
/>
\`\`\`

### Running All Tests

\`\`\`bash
# Unit + Component tests
pnpm test

# With coverage
pnpm test -- --coverage

# Watch mode (development)
pnpm test -- --watch

# Type checking
pnpm tsc --noEmit

# Lint
pnpm lint

# E2E (iOS)
npx detox build --configuration ios.sim.debug
npx detox test --configuration ios.sim.debug

# E2E (Android)
npx detox build --configuration android.emu.debug
npx detox test --configuration android.emu.debug
\`\`\`

---

## Pull Request Process

### 1. Branch Creation

Create a branch from \`main\` following the naming convention:

\`\`\`bash
git checkout main
git pull origin main
git checkout -b feat/APP-42-add-push-notifications
\`\`\`

**Branch prefixes:**

| Prefix | Use |
|--------|-----|
| \`feat/\` | New feature |
| \`fix/\` | Bug fix |
| \`chore/\` | Maintenance, dependencies, config |
| \`docs/\` | Documentation only |
| \`refactor/\` | Code refactoring (no behavior change) |
| \`test/\` | Adding or fixing tests |

### 2. Development

- Write code following the conventions in this guide
- Keep commits small and atomic with conventional commit messages
- Run \`pnpm lint\`, \`pnpm tsc --noEmit\`, and \`pnpm test\` before pushing
- Ensure no new TypeScript \`any\` types (strict mode enforced)

### 3. Commit Messages

Follow [Conventional Commits](https://www.conventionalcommits.org/):

\`\`\`
feat(auth): add biometric authentication for iOS and Android
fix(notifications): resolve badge count not clearing on app open
chore(deps): bump expo-sdk to 51.0.8
docs(contributing): add Detox test authoring section
refactor(navigation): extract deep link config to separate module
test(payments): add E2E tests for subscription flow
\`\`\`

### 4. Open Pull Request

- Fill out the PR template completely (see \`.github/PULL_REQUEST_TEMPLATE.md\`)
- Link the GitHub Issue (e.g., "Closes #42")
- Add appropriate labels: \`feature\`, \`bug\`, \`breaking-change\`, etc.
- Request review from at least one code owner (see \`.github/CODEOWNERS\`)
- If AI-assisted, check the "AI-assisted" box and note which parts

### 5. CI Checks

All of these must pass before merge:

- ✅ ESLint (no errors or warnings)
- ✅ TypeScript type check (\`tsc --noEmit\`)
- ✅ Unit and component tests (75%+ coverage)
- ✅ EAS Build (iOS and Android compile successfully)
- ✅ Detox E2E (critical path tests pass)
- ✅ At least 1 approval from a code owner

### 6. Review and Merge

- Address all review comments
- Squash-merge to \`main\` with a clean conventional commit message
- Delete the feature branch after merge
- Verify staging deployment via EAS Update

---

## Code Review Guidelines

### For Authors

- Keep PRs small — under 400 lines changed when possible
- Provide context in the PR description: what, why, and how
- Add screenshots or screen recordings for UI changes
- Call out areas where you want specific feedback
- Respond to all comments, even if just acknowledging

### For Reviewers

Focus your review on these areas in order of priority:

1. **Correctness** — Does it work? Edge cases handled?
2. **Security** — Sensitive data exposure? Secure storage used? Input validation?
3. **Architecture** — Feature module conventions followed? Proper separation of concerns?
4. **Performance** — Unnecessary re-renders? Large lists using FlatList? Images optimized?
5. **Accessibility** — Labels present? Screen reader tested? Touch targets ≥ 44pt?
6. **Testing** — Adequate coverage? Tests meaningful (not just snapshot)?
7. **Platform parity** — Works on both iOS and Android? Platform-specific code handled?
8. **Offline behavior** — Works without network? Sync handled correctly?

### Sensitive Path Reviews

Changes to these paths require **lead-level review**:

- \`src/services/auth/**\` — Authentication logic
- \`src/config/**\` — App configuration
- \`src/services/database/**\` — WatermelonDB schema and sync
- \`src/navigation/**\` — Navigation structure and deep linking
- \`google-services.json\`, \`GoogleService-Info.plist\` — Firebase config
- \`.env*\` — Environment variables (should never be committed)
- \`app.json\`, \`eas.json\` — Expo/EAS configuration
- \`.github/workflows/**\` — CI/CD pipelines

---

## Common Pitfalls

### TypeScript

- **No \`any\`** — Use \`unknown\` and narrow with type guards
- **No \`as\` casts** unless absolutely necessary and commented why
- **No \`// @ts-ignore\`** — Fix the type error or file an issue

### React Native

- **Don't use \`StyleSheet.create\` with dynamic values** — Use the \`style\` prop array pattern
- **Don't use \`ScrollView\` for long lists** — Use \`FlatList\` or \`FlashList\`
- **Don't forget \`KeyboardAvoidingView\`** — Wrap forms for proper keyboard handling
- **Don't hardcode platform checks** — Use \`Platform.select()\` or \`.ios.tsx\`/\`.android.tsx\` files

### State Management

- **Don't put server state in Zustand** — Use React Query for anything from Firebase/API
- **Don't duplicate state** — Derive values instead of storing computed state
- **Don't forget to invalidate queries** — After mutations, invalidate related queries

### Navigation

- **Don't use untyped navigation** — Always use typed \`NativeStackScreenProps\`
- **Don't navigate in render** — Use \`useEffect\` or event handlers
- **Don't forget deep link handling** — New routes need linking config

### Testing

- **Don't test implementation details** — Test behavior and user interactions
- **Don't skip platform testing** — Run on both iOS and Android before PR
- **Don't mock everything** — Integration tests with real Zustand stores are valuable

---

## Getting Help

- **Architecture questions** → \`#mobile-architecture\` Slack channel
- **Build issues** → \`#mobile-builds\` Slack channel
- **Code review** → Tag \`@mobile-leads\` in your PR
- **Firebase/backend** → \`#backend\` Slack channel
- **Documentation** → Check \`docs/ARCHITECTURE.md\` and \`docs/ONBOARDING.md\``,

  'docs/ONBOARDING.md': `# Onboarding Guide

Welcome to the **react-native-mobile-app** project. This guide walks you through setting up your local development environment from scratch.

## Prerequisites

| Tool | Version | Install |
|------|---------|---------|
| Node.js | 20 LTS | [nodejs.org](https://nodejs.org) or \`nvm install 20\` |
| pnpm | 9.x | \`corepack enable && corepack prepare pnpm@latest --activate\` |
| Xcode | 15.x+ | Mac App Store (macOS only) |
| Android Studio | Hedgehog+ | [developer.android.com](https://developer.android.com/studio) |
| Watchman | Latest | \`brew install watchman\` (macOS) |
| CocoaPods | 1.14+ | \`sudo gem install cocoapods\` |
| EAS CLI | Latest | \`pnpm add -g eas-cli\` |
| Firebase CLI | Latest | \`pnpm add -g firebase-tools\` |

Verify your setup:

\`\`\`bash
node --version        # v20.x.x
pnpm --version        # 9.x.x
eas --version         # eas-cli/x.x.x
firebase --version    # x.x.x
\`\`\`

## 1. Clone and Install

\`\`\`bash
git clone git@github.com:<org>/react-native-mobile-app.git
cd react-native-mobile-app
pnpm install
\`\`\`

### Git Hooks

Git hooks are configured in \`git-hooks/\`. Set the hooks path:

\`\`\`bash
git config core.hooksPath git-hooks
chmod +x git-hooks/*
\`\`\`

## 2. Environment Configuration

### 2.1 Obtain Environment Files

Request the following from a team lead or retrieve from the team's 1Password vault:

- \`.env.development\` — local/staging Firebase config
- \`.env.staging\` — staging environment
- \`.env.production\` — production environment (CI only, never store locally)
- \`google-services.json\` — Android Firebase config → place in \`android/app/\`
- \`GoogleService-Info.plist\` — iOS Firebase config → place in \`ios/\`

### 2.2 Create \`.env.development\`

\`\`\`bash
cp .env.example .env.development
\`\`\`

Fill in the values:

\`\`\`env
FIREBASE_API_KEY=your_api_key
FIREBASE_AUTH_DOMAIN=your_project.firebaseapp.com
FIREBASE_PROJECT_ID=your_project_id
FIREBASE_STORAGE_BUCKET=your_project.appspot.com
FIREBASE_MESSAGING_SENDER_ID=123456789
FIREBASE_APP_ID=1:123456789:ios:abc123
FIREBASE_MEASUREMENT_ID=G-XXXXXXX
SENTRY_DSN=https://xxx@sentry.io/xxx
API_BASE_URL=https://staging-api.example.com
ENVIRONMENT=development
\`\`\`

> **Security**: Never commit \`.env*\` files, \`google-services.json\`, or \`GoogleService-Info.plist\`. They are in \`.gitignore\`.

### 2.3 Firebase Project Access

1. Ask a team lead to add your Google account to the Firebase project
2. Log in: \`firebase login\`
3. Verify access: \`firebase projects:list\` — you should see the project ID
4. Select the project: \`firebase use <project-id>\`

### 2.4 EAS Account Setup

1. Create an Expo account at [expo.dev](https://expo.dev) if you don't have one
2. Log in: \`eas login\`
3. Ask a team lead to add you to the Expo organization
4. Verify: \`eas project:info\`

## 3. iOS Setup (macOS Only)

### 3.1 Xcode Configuration

1. Open Xcode → **Settings** → **Locations** → set Command Line Tools to your Xcode version
2. Accept the license: \`sudo xcodebuild -license accept\`
3. Install iOS Simulator runtime (Xcode → Settings → Platforms → iOS 17.x)

### 3.2 Install iOS Dependencies

\`\`\`bash
cd ios
pod install
cd ..
\`\`\`

If pods fail, try:

\`\`\`bash
cd ios
pod deintegrate
pod cache clean --all
pod install --repo-update
cd ..
\`\`\`

### 3.3 Build the Expo Dev Client (iOS)

We use a custom dev client (not Expo Go) because the project includes native modules (WatermelonDB, biometrics, push notifications):

\`\`\`bash
npx expo run:ios
\`\`\`

This builds the native iOS app and launches it in the simulator. The first build takes 5–10 minutes.

### 3.4 iOS Simulator Tips

- **List simulators**: \`xcrun simctl list devices available\`
- **Target a specific device**: \`npx expo run:ios --device "iPhone 15 Pro"\`
- **Reset simulator**: \`xcrun simctl erase <device-udid>\`
- **Push notification testing**: Use the Simulator's \`Device → Push Notification...\` menu or a \`.apns\` file:
  \`\`\`bash
  xcrun simctl push booted com.yourapp.bundleid payload.apns
  \`\`\`

## 4. Android Setup

### 4.1 Android Studio Configuration

1. Open Android Studio → **SDK Manager**:
   - **SDK Platforms**: Install Android 14 (API 34)
   - **SDK Tools**: Install Android SDK Build-Tools 34, Android Emulator, Android SDK Platform-Tools
2. Set environment variables in your shell profile (\`~/.zshrc\` or \`~/.bashrc\`):

\`\`\`bash
export ANDROID_HOME=$HOME/Library/Android/sdk   # macOS
# export ANDROID_HOME=$HOME/Android/Sdk         # Linux
export PATH=$PATH:$ANDROID_HOME/emulator
export PATH=$PATH:$ANDROID_HOME/platform-tools
export PATH=$PATH:$ANDROID_HOME/tools/bin
\`\`\`

Reload: \`source ~/.zshrc\`

### 4.2 Create an Android Emulator

1. Android Studio → **Device Manager** → **Create Device**
2. Select **Pixel 7** (or similar) → **API 34** system image → Finish
3. Launch the emulator from Device Manager or CLI:

\`\`\`bash
emulator -avd Pixel_7_API_34
\`\`\`

### 4.3 Place Firebase Config

Ensure \`google-services.json\` is at \`android/app/google-services.json\`.

### 4.4 Build the Expo Dev Client (Android)

\`\`\`bash
npx expo run:android
\`\`\`

First build takes 5–15 minutes depending on your machine.

### 4.5 Android Emulator Tips

- **List AVDs**: \`emulator -list-avds\`
- **Cold boot**: \`emulator -avd Pixel_7_API_34 -no-snapshot\`
- **ADB devices**: \`adb devices\` — verify emulator is connected
- **Deep link testing**: \`adb shell am start -a android.intent.action.VIEW -d "myapp://profile/123"\`
- **Reverse port for Metro**: \`adb reverse tcp:8081 tcp:8081\`

## 5. Running the App

### 5.1 Start Metro Bundler

\`\`\`bash
npx expo start
\`\`\`

This starts the Metro bundler. Press:
- \`i\` — open iOS simulator
- \`a\` — open Android emulator
- \`r\` — reload
- \`j\` — open debugger

### 5.2 Development Workflow

For day-to-day development after the initial native build:

\`\`\`bash
# Terminal 1: Start Metro
npx expo start

# The dev client on your simulator/emulator connects automatically
\`\`\`

You only need to rebuild the native app (\`npx expo run:ios\` / \`npx expo run:android\`) when:
- A native dependency is added or updated
- \`app.config.ts\` changes that affect native code
- Native files in \`ios/\` or \`android/\` are modified

### 5.3 Running on a Physical Device

**iOS (requires Apple Developer account)**:
1. Connect device via USB
2. \`npx expo run:ios --device\` — select your device
3. Trust the developer certificate on device: Settings → General → VPN & Device Management

**Android**:
1. Enable Developer Options and USB Debugging on device
2. Connect via USB, accept the debugging prompt
3. \`npx expo run:android --device\`

## 6. Firebase Local Development

### 6.1 Firebase Emulator Suite

For local development without hitting production Firebase:

\`\`\`bash
firebase emulators:start
\`\`\`

This starts local emulators for Auth, Firestore, Functions, and Storage. The app's Firebase config detects the emulator when \`ENVIRONMENT=development\`.

### 6.2 Firestore Security Rules

Test rules locally:

\`\`\`bash
firebase emulators:start --only firestore
pnpm run test:firestore-rules
\`\`\`

### 6.3 Cloud Functions

\`\`\`bash
cd functions
pnpm install
pnpm run build
firebase emulators:start --only functions
\`\`\`

## 7. WatermelonDB Setup

WatermelonDB is used for offline-first data persistence. It requires native modules that are included in the dev client build.

### Verify Installation

After building the dev client, WatermelonDB should work automatically. If you encounter issues:

**iOS**: Ensure the pod is installed:
\`\`\`bash
cd ios && pod install && cd ..
\`\`\`

**Android**: The native module is auto-linked. If issues persist:
\`\`\`bash
cd android && ./gradlew clean && cd ..
npx expo run:android
\`\`\`

### Database Reset (Development)

To reset the local database during development:
\`\`\`typescript
// In the app's dev menu or a debug screen
import { database } from '@/services/database';
await database.write(async () => {
  await database.unsafeResetDatabase();
});
\`\`\`

## 8. Running Tests

\`\`\`bash
# Unit and component tests
pnpm test

# Watch mode
pnpm test -- --watch

# Coverage report
pnpm test -- --coverage

# Type checking
pnpm run typecheck

# Linting
pnpm run lint

# All checks (mirrors CI)
pnpm run validate
\`\`\`

### E2E Tests with Detox

\`\`\`bash
# Build the E2E test app (first time or after native changes)
npx detox build --configuration ios.sim.debug

# Run E2E tests
npx detox test --configuration ios.sim.debug

# Android E2E
npx detox build --configuration android.emu.debug
npx detox test --configuration android.emu.debug
\`\`\`

## 9. Project Structure Overview

\`\`\`
src/
  features/           # Feature modules — primary development area
    auth/             # Login, register, biometric auth
      screens/        # AuthScreen, LoginScreen, RegisterScreen
      components/     # AuthForm, BiometricPrompt
      hooks/          # useLogin, useBiometrics
      types/          # AuthState, LoginPayload
    home/             # Dashboard, feed
    profile/          # User profile, settings
    notifications/    # Push and in-app notifications
    payments/         # In-app purchases, subscriptions
  components/         # Shared UI (Button, Card, Input, Modal)
  hooks/              # Shared hooks (useAuth, useOffline, useTheme)
  services/           # Firebase, analytics, crash reporting, database
  navigation/         # React Navigation config, typed navigators, deep linking
  store/              # Zustand stores (auth, theme, preferences)
  utils/              # Formatting, validation, platform helpers
  i18n/               # Translations and locale config
  theme/              # Design tokens (colors, typography, spacing)
  assets/             # Images, fonts, Lottie animations
e2e/                  # Detox E2E test specs
scripts/              # Build scripts, code signing helpers
docs/                 # Architecture docs, deployment guides
\`\`\`

### Key Conventions

| Pattern | Rule |
|---------|------|
| Components | PascalCase (\`ProfileCard.tsx\`) |
| Hooks | camelCase with \`use\` prefix (\`useAuth.ts\`) |
| Utilities | camelCase (\`formatCurrency.ts\`) |
| Files | kebab-case (\`push-notification-service.ts\`) |
| Constants | SCREAMING_SNAKE_CASE (\`MAX_RETRY_COUNT\`) |
| State | Zustand for client state, React Query for server state |
| Text | All user-facing text through \`i18n\` — no hardcoded strings |
| Accessibility | \`accessibilityLabel\` required on all interactive elements |
| Max file length | 250 lines — split if larger |

## 10. Common Issues and Fixes

### Metro bundler cache issues

\`\`\`bash
npx expo start --clear
\`\`\`

### iOS build fails after dependency update

\`\`\`bash
cd ios
pod deintegrate
rm -rf Pods Podfile.lock
pod install --repo-update
cd ..
npx expo run:ios
\`\`\`

### Android build fails with Gradle errors

\`\`\`bash
cd android
./gradlew clean
cd ..
npx expo run:android
\`\`\`

### WatermelonDB "Native module not found"

This means you're running in Expo Go instead of the dev client. Rebuild:
\`\`\`bash
npx expo run:ios   # or npx expo run:android
\`\`\`

### Firebase Auth not working locally

Ensure Firebase emulators are running and the app is configured to use them:
\`\`\`bash
firebase emulators:start
\`\`\`

### "Unable to resolve module" errors

\`\`\`bash
pnpm install
npx expo start --clear
\`\`\`

### Detox build fails

Ensure the correct simulator/emulator is available:
\`\`\`bash
# iOS
xcrun simctl list devices available | grep "iPhone"

# Android
emulator -list-avds
\`\`\`

## 11. Useful Commands Reference

| Command | Description |
|---------|-------------|
| \`npx expo start\` | Start Metro bundler |
| \`npx expo run:ios\` | Build and run on iOS simulator |
| \`npx expo run:android\` | Build and run on Android emulator |
| \`pnpm test\` | Run unit and component tests |
| \`pnpm run lint\` | Run ESLint |
| \`pnpm run typecheck\` | Run TypeScript compiler check |
| \`pnpm run validate\` | Run all checks (lint + typecheck + test) |
| \`npx detox test --configuration ios.sim.debug\` | Run iOS E2E tests |
| \`eas build --profile development --platform ios\` | Build dev client via EAS |
| \`eas build --profile development --platform android\` | Build dev client via EAS |
| \`eas update --branch staging\` | Push OTA update to staging |
| \`firebase emulators:start\` | Start Firebase local emulators |
| \`firebase deploy --only functions\` | Deploy Cloud Functions |

## 12. Getting Help

- **Architecture questions**: Check \`docs/ARCHITECTURE.md\`
- **Deployment**: Check \`docs/DEPLOYMENT.md\`
- **Slack**: \`#mobile-dev\` channel for questions, \`#mobile-alerts\` for CI/CD notifications
- **GitHub Issues**: File a bug or feature request using the issue templates
- **Pair programming**: Reach out in Slack — the team does ad-hoc pairing sessions

## 13. First Task Checklist

- [ ] Clone the repo and run \`pnpm install\`
- [ ] Configure git hooks (\`git config core.hooksPath git-hooks\`)
- [ ] Set up \`.env.development\` with Firebase credentials
- [ ] Place \`google-services.json\` and \`GoogleService-Info.plist\`
- [ ] Build and run on iOS simulator (\`npx expo run:ios\`)
- [ ] Build and run on Android emulator (\`npx expo run:android\`)
- [ ] Run the test suite (\`pnpm test\`)
- [ ] Run the linter (\`pnpm run lint\`)
- [ ] Start Firebase emulators (\`firebase emulators:start\`)
- [ ] Log in to EAS (\`eas login\`)
- [ ] Pick up your first ticket from the GitHub Issues board

Welcome to the team! 🚀`,

  'git-hooks/commit-msg': `#!/bin/sh

# commit-msg hook — validates conventional commit format
# Enforces: type(optional-scope): description
# Types: feat, fix, chore, docs, style, refactor, perf, test, build, ci, revert

commit_msg_file="$1"
commit_msg=$(cat "$commit_msg_file")

# Allow merge commits
if echo "$commit_msg" | grep -qE "^Merge "; then
  exit 0
fi

# Allow revert commits
if echo "$commit_msg" | grep -qE "^Revert \\""; then
  exit 0
fi

# Conventional commit pattern
# type(optional-scope): description
# Types aligned with project conventions
pattern="^(feat|fix|chore|docs|style|refactor|perf|test|build|ci|revert)(\\([a-z][a-z0-9\\-]*\\))?: .{1,100}$"

# Extract first line only
first_line=$(echo "$commit_msg" | head -n 1)

if ! echo "$first_line" | grep -qE "$pattern"; then
  echo ""
  echo "❌ Invalid commit message format."
  echo ""
  echo "Expected: type(scope): description"
  echo ""
  echo "Allowed types:"
  echo "  feat     — A new feature"
  echo "  fix      — A bug fix"
  echo "  chore    — Maintenance tasks, dependency updates"
  echo "  docs     — Documentation changes"
  echo "  style    — Code style changes (formatting, no logic change)"
  echo "  refactor — Code refactoring (no feature or fix)"
  echo "  perf     — Performance improvements"
  echo "  test     — Adding or updating tests"
  echo "  build    — Build system or external dependency changes"
  echo "  ci       — CI/CD configuration changes"
  echo "  revert   — Reverting a previous commit"
  echo ""
  echo "Scope (optional): feature area in kebab-case"
  echo "  e.g., auth, push-notifications, payments, navigation, watermelondb"
  echo ""
  echo "Examples:"
  echo "  feat(auth): add biometric authentication for iOS"
  echo "  fix(notifications): resolve FCM token refresh on Android"
  echo "  chore: update Expo SDK to 51.0.8"
  echo "  docs(payments): add in-app purchase integration guide"
  echo "  refactor(navigation): migrate to typed stack navigators"
  echo "  test(home): add component tests for dashboard screen"
  echo ""
  echo "Rules:"
  echo "  - Type is required and must be lowercase"
  echo "  - Scope is optional, must be lowercase kebab-case in parentheses"
  echo "  - Colon and space after type/scope is required"
  echo "  - Description must not be empty"
  echo "  - First line must be 100 characters or fewer"
  echo ""
  echo "Your commit message:"
  echo "  $first_line"
  echo ""
  exit 1
fi

# Validate description doesn't start with uppercase (conventional style)
description=$(echo "$first_line" | sed -E 's/^[a-z]+(\\([a-z][a-z0-9\\-]*\\))?: //')
if echo "$description" | grep -qE "^[A-Z]"; then
  echo ""
  echo "⚠️  Commit description should start with lowercase."
  echo "  Got: $description"
  echo "  Expected: $(echo "$description" | sed 's/^./\\L&/')"
  echo ""
  exit 1
fi

# Validate no trailing period
if echo "$first_line" | grep -qE "\\.$"; then
  echo ""
  echo "⚠️  Commit message should not end with a period."
  echo "  Got: $first_line"
  echo ""
  exit 1
fi

# Check for ticket reference in body (optional but encouraged)
body=$(echo "$commit_msg" | tail -n +3)
if [ -n "$body" ]; then
  # Validate blank line between subject and body
  second_line=$(echo "$commit_msg" | sed -n '2p')
  if [ -n "$second_line" ]; then
    echo ""
    echo "⚠️  There must be a blank line between the subject and body."
    echo ""
    exit 1
  fi
fi

# Flag AI-generated commits (informational, per CI/CD policy)
if echo "$commit_msg" | grep -qiE "(ai-generated|claude|copilot|generated by ai)"; then
  echo "ℹ️  AI-generated code flagged in commit. Ensure proper review per project policy."
fi

exit 0`,

  'git-hooks/pre-commit': `#!/bin/sh
# Pre-commit hook for react-native-mobile-app
# Runs linting, formatting, type checking, and credential leak prevention
# Install: cp git-hooks/pre-commit .git/hooks/pre-commit && chmod +x .git/hooks/pre-commit

set -e

RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
NC='\\033[0m'

echo "🔍 Running pre-commit checks..."

# Get staged files
STAGED_FILES=$(git diff --cached --name-only --diff-filter=ACM)
STAGED_TS_FILES=$(echo "$STAGED_FILES" | grep -E '\\.(ts|tsx)$' || true)
STAGED_JS_FILES=$(echo "$STAGED_FILES" | grep -E '\\.(js|jsx|ts|tsx)$' || true)

# ─────────────────────────────────────────────
# 1. Prevent .env and credential files from being committed
# ─────────────────────────────────────────────
echo "🔐 Checking for sensitive files..."

BLOCKED_PATTERNS=(
  '\\.env$'
  '\\.env\\.'
  '\\.env\\.local'
  '\\.env\\.staging'
  '\\.env\\.production'
  'google-services\\.json'
  'GoogleService-Info\\.plist'
  '\\.p8$'
  '\\.p12$'
  '\\.mobileprovision$'
  '\\.keystore$'
  '\\.jks$'
  'serviceAccountKey'
  'firebase-adminsdk'
  'credentials\\.json'
  'secrets\\.json'
  '\\.pem$'
)

BLOCKED_FOUND=false
for pattern in "\${BLOCKED_PATTERNS[@]}"; do
  MATCHES=$(echo "$STAGED_FILES" | grep -iE "$pattern" || true)
  if [ -n "$MATCHES" ]; then
    echo "\${RED}✗ Blocked sensitive file(s):\${NC}"
    echo "$MATCHES" | while read -r file; do
      echo "  \${RED}→ $file\${NC}"
    done
    BLOCKED_FOUND=true
  fi
done

if [ "$BLOCKED_FOUND" = true ]; then
  echo ""
  echo "\${RED}✗ Commit blocked: sensitive files detected in staging area.\${NC}"
  echo "\${YELLOW}  Remove them with: git reset HEAD <file>\${NC}"
  echo "\${YELLOW}  Ensure they are listed in .gitignore\${NC}"
  exit 1
fi

echo "\${GREEN}✓ No sensitive files detected\${NC}"

# ─────────────────────────────────────────────
# 2. Scan staged file contents for secrets/credentials
# ─────────────────────────────────────────────
echo "🔑 Scanning for hardcoded secrets..."

SECRET_PATTERNS=(
  'AAAA[A-Za-z0-9_-]{7,}:[A-Za-z0-9_-]{140,}'  # Firebase Cloud Messaging key
  'AIza[0-9A-Za-z_-]{35}'                         # Google API key
  'sk_live_[0-9a-zA-Z]{24,}'                      # Stripe live secret key
  'sk_test_[0-9a-zA-Z]{24,}'                      # Stripe test secret key
  'ghp_[0-9a-zA-Z]{36}'                           # GitHub personal access token
  'PRIVATE[_ ]KEY'                                 # Private key markers
  'BEGIN RSA PRIVATE KEY'                          # RSA private key
  'BEGIN EC PRIVATE KEY'                           # EC private key
  'password\\s*[:=]\\s*["\\x27][^"\\x27]{8,}'         # Hardcoded passwords
  'secret\\s*[:=]\\s*["\\x27][^"\\x27]{8,}'           # Hardcoded secrets
  'api[_-]?key\\s*[:=]\\s*["\\x27][A-Za-z0-9]{16,}'  # API keys in assignments
)

SECRETS_FOUND=false
for file in $STAGED_FILES; do
  # Skip binary files and lock files
  if echo "$file" | grep -qE '\\.(png|jpg|jpeg|gif|ico|woff|woff2|ttf|eot|lock)$'; then
    continue
  fi

  # Skip if file doesn't exist (deleted)
  if [ ! -f "$file" ]; then
    continue
  fi

  DIFF_CONTENT=$(git diff --cached --diff-filter=ACM "$file" | grep '^+' | grep -v '^+++' || true)

  for pattern in "\${SECRET_PATTERNS[@]}"; do
    MATCH=$(echo "$DIFF_CONTENT" | grep -iE "$pattern" || true)
    if [ -n "$MATCH" ]; then
      echo "\${RED}✗ Potential secret found in: $file\${NC}"
      echo "  Pattern: $pattern"
      SECRETS_FOUND=true
    fi
  done
done

if [ "$SECRETS_FOUND" = true ]; then
  echo ""
  echo "\${RED}✗ Commit blocked: potential secrets detected in staged changes.\${NC}"
  echo "\${YELLOW}  Use environment variables via react-native-config instead.\${NC}"
  echo "\${YELLOW}  If this is a false positive, use: git commit --no-verify\${NC}"
  exit 1
fi

echo "\${GREEN}✓ No hardcoded secrets detected\${NC}"

# ─────────────────────────────────────────────
# 3. ESLint — lint staged TypeScript/JavaScript files
# ─────────────────────────────────────────────
if [ -n "$STAGED_JS_FILES" ]; then
  echo "📏 Running ESLint on staged files..."

  # Convert newlines to spaces for passing as arguments
  FILES_LIST=$(echo "$STAGED_JS_FILES" | tr '\\n' ' ')

  if ! pnpm eslint --max-warnings 0 $FILES_LIST; then
    echo "\${RED}✗ ESLint found errors. Fix them before committing.\${NC}"
    echo "\${YELLOW}  Auto-fix with: pnpm eslint --fix <files>\${NC}"
    exit 1
  fi

  echo "\${GREEN}✓ ESLint passed\${NC}"
else
  echo "\${YELLOW}⊘ No JS/TS files staged — skipping ESLint\${NC}"
fi

# ─────────────────────────────────────────────
# 4. Prettier — check formatting on staged files
# ─────────────────────────────────────────────
if [ -n "$STAGED_JS_FILES" ]; then
  echo "💅 Checking Prettier formatting..."

  FILES_LIST=$(echo "$STAGED_JS_FILES" | tr '\\n' ' ')

  if ! pnpm prettier --check $FILES_LIST 2>/dev/null; then
    echo "\${RED}✗ Prettier formatting issues found.\${NC}"
    echo "\${YELLOW}  Auto-fix with: pnpm prettier --write <files>\${NC}"
    echo "\${YELLOW}  Then re-stage: git add <files>\${NC}"
    exit 1
  fi

  echo "\${GREEN}✓ Prettier formatting OK\${NC}"
else
  echo "\${YELLOW}⊘ No JS/TS files staged — skipping Prettier\${NC}"
fi

# ─────────────────────────────────────────────
# 5. TypeScript — type check the project
# ─────────────────────────────────────────────
if [ -n "$STAGED_TS_FILES" ]; then
  echo "🔷 Running TypeScript type check..."

  if ! pnpm tsc --noEmit --pretty; then
    echo "\${RED}✗ TypeScript type errors found. Fix them before committing.\${NC}"
    exit 1
  fi

  echo "\${GREEN}✓ TypeScript type check passed\${NC}"
else
  echo "\${YELLOW}⊘ No TS files staged — skipping type check\${NC}"
fi

# ─────────────────────────────────────────────
# 6. Check for console.log / debugger statements
# ─────────────────────────────────────────────
if [ -n "$STAGED_JS_FILES" ]; then
  echo "🧹 Checking for debug statements..."

  DEBUG_FOUND=false
  for file in $STAGED_JS_FILES; do
    if [ ! -f "$file" ]; then
      continue
    fi

    # Skip test files and config files
    if echo "$file" | grep -qE '(\\.(test|spec)\\.(ts|tsx|js|jsx)$|__tests__|__mocks__|e2e/|\\.config\\.)'; then
      continue
    fi

    DIFF_CONTENT=$(git diff --cached --diff-filter=ACM "$file" | grep '^+' | grep -v '^+++' || true)

    if echo "$DIFF_CONTENT" | grep -qE '^\\+.*console\\.(log|debug|info|warn)\\('; then
      echo "\${YELLOW}⚠ console.log/debug found in: $file\${NC}"
      DEBUG_FOUND=true
    fi

    if echo "$DIFF_CONTENT" | grep -q '^\\+.*debugger'; then
      echo "\${YELLOW}⚠ debugger statement found in: $file\${NC}"
      DEBUG_FOUND=true
    fi
  done

  if [ "$DEBUG_FOUND" = true ]; then
    echo "\${YELLOW}⚠ Debug statements detected. Remove them or use a proper logger.\${NC}"
    echo "\${YELLOW}  Use src/utils/logger.ts instead of console.log\${NC}"
    echo "\${YELLOW}  Proceeding with warning — consider removing before PR.\${NC}"
  else
    echo "\${GREEN}✓ No debug statements found\${NC}"
  fi
fi

# ─────────────────────────────────────────────
# 7. Check file size limit (250 lines per coding standards)
# ─────────────────────────────────────────────
if [ -n "$STAGED_TS_FILES" ]; then
  echo "📐 Checking file length (max 250 lines)..."

  OVERSIZED=false
  for file in $STAGED_TS_FILES; do
    if [ ! -f "$file" ]; then
      continue
    fi

    # Skip generated files, type definitions, and test files
    if echo "$file" | grep -qE '(\\.generated\\.|\\.d\\.ts$|__tests__|\\.test\\.|\\.spec\\.|e2e/)'; then
      continue
    fi

    LINE_COUNT=$(wc -l < "$file" | tr -d ' ')
    if [ "$LINE_COUNT" -gt 250 ]; then
      echo "\${YELLOW}⚠ $file has $LINE_COUNT lines (max 250)\${NC}"
      OVERSIZED=true
    fi
  done

  if [ "$OVERSIZED" = true ]; then
    echo "\${YELLOW}⚠ Some files exceed 250 lines. Consider splitting into smaller modules.\${NC}"
    echo "\${YELLOW}  See .claude/rules/common/coding-style.md for guidance.\${NC}"
  else
    echo "\${GREEN}✓ All files within line limit\${NC}"
  fi
fi

# ─────────────────────────────────────────────
# 8. Verify conventional commit message format (if amending)
# ─────────────────────────────────────────────
# Note: Full commit message validation is in commit-msg hook.
# This check catches common issues early.

echo ""
echo "\${GREEN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
echo "\${GREEN}✓ All pre-commit checks passed!\${NC}"
echo "\${GREEN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"`,

  'git-hooks/pre-push': `#!/usr/bin/env bash

# Pre-push hook — runs Jest test suite and blocks push on failure
# Install: cp git-hooks/pre-push .git/hooks/pre-push && chmod +x .git/hooks/pre-push

set -euo pipefail

YELLOW='\\033[0;33m'
RED='\\033[0;31m'
GREEN='\\033[0;32m'
CYAN='\\033[0;36m'
NC='\\033[0m'

echo -e "\${CYAN}🚀 Pre-push checks starting...\${NC}"

# ─── Skip option ──────────────────────────────────────────────────────────────
if [ "\${SKIP_PRE_PUSH:-}" = "1" ]; then
  echo -e "\${YELLOW}⚠ Pre-push checks skipped (SKIP_PRE_PUSH=1)\${NC}"
  exit 0
fi

# ─── Determine changed files against remote ───────────────────────────────────
REMOTE="$1"
URL="$2"

# Collect SHAs being pushed
CHANGED_FILES=""
while read -r LOCAL_REF LOCAL_SHA REMOTE_REF REMOTE_SHA; do
  if [ "$LOCAL_SHA" = "0000000000000000000000000000000000000000" ]; then
    # Branch deletion — nothing to check
    continue
  fi

  if [ "$REMOTE_SHA" = "0000000000000000000000000000000000000000" ]; then
    # New branch — compare against main
    MERGE_BASE=$(git merge-base HEAD origin/main 2>/dev/null || echo "$LOCAL_SHA~10")
    RANGE="\${MERGE_BASE}..\${LOCAL_SHA}"
  else
    RANGE="\${REMOTE_SHA}..\${LOCAL_SHA}"
  fi

  FILES=$(git diff --name-only "$RANGE" 2>/dev/null || true)
  CHANGED_FILES="\${CHANGED_FILES}\${FILES}"$'\\n'
done

# ─── Check if any source/test files changed ───────────────────────────────────
HAS_SOURCE_CHANGES=false
HAS_NATIVE_CHANGES=false

if echo "$CHANGED_FILES" | grep -qE '\\.(ts|tsx)$'; then
  HAS_SOURCE_CHANGES=true
fi

if echo "$CHANGED_FILES" | grep -qE '(ios/|android/|\\.podspec|Podfile|build\\.gradle)'; then
  HAS_NATIVE_CHANGES=true
fi

if [ "$HAS_SOURCE_CHANGES" = false ]; then
  echo -e "\${GREEN}✅ No TypeScript source changes — skipping test suite\${NC}"
  exit 0
fi

# ─── TypeScript type checking ─────────────────────────────────────────────────
echo -e "\${CYAN}🔍 Running TypeScript type check...\${NC}"
if ! pnpm tsc --noEmit 2>/dev/null; then
  echo -e "\${RED}❌ TypeScript type check failed. Fix type errors before pushing.\${NC}"
  exit 1
fi
echo -e "\${GREEN}  ✓ Type check passed\${NC}"

# ─── Jest unit & component tests ──────────────────────────────────────────────
echo -e "\${CYAN}🧪 Running Jest test suite...\${NC}"

# Determine which test scope to run
JEST_ARGS="--ci --passWithNoTests --forceExit"

# If only specific features changed, scope tests to those features
CHANGED_FEATURES=$(echo "$CHANGED_FILES" | grep -oE 'src/features/[^/]+' | sort -u || true)
if [ -n "$CHANGED_FEATURES" ] && [ "$(echo "$CHANGED_FEATURES" | wc -l)" -le 3 ]; then
  # Run tests scoped to changed features plus shared code
  JEST_PATHS=""
  while IFS= read -r feature_path; do
    if [ -n "$feature_path" ]; then
      JEST_PATHS="\${JEST_PATHS} \${feature_path}"
    fi
  done <<< "$CHANGED_FEATURES"

  # Also run shared tests if shared code changed
  if echo "$CHANGED_FILES" | grep -qE 'src/(components|hooks|services|utils|store)/'; then
    JEST_PATHS="\${JEST_PATHS} src/components src/hooks src/services src/utils src/store"
  fi

  echo -e "\${YELLOW}  Scoped to:\${NC} \${JEST_PATHS}"
  JEST_ARGS="\${JEST_ARGS} \${JEST_PATHS}"
else
  echo -e "\${YELLOW}  Running full test suite\${NC}"
fi

# Enforce coverage threshold
JEST_ARGS="\${JEST_ARGS} --coverage --coverageThreshold='{\\"global\\":{\\"branches\\":75,\\"functions\\":75,\\"lines\\":75,\\"statements\\":75}}'"

if ! eval pnpm jest "$JEST_ARGS" 2>&1; then
  echo ""
  echo -e "\${RED}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
  echo -e "\${RED}❌ Tests failed. Push blocked.\${NC}"
  echo -e "\${RED}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
  echo ""
  echo -e "  Fix failing tests and try again."
  echo -e "  Run \${CYAN}pnpm test\${NC} locally to debug."
  echo -e "  Emergency bypass: \${YELLOW}SKIP_PRE_PUSH=1 git push\${NC}"
  echo ""
  exit 1
fi
echo -e "\${GREEN}  ✓ All tests passed with coverage ≥ 75%\${NC}"

# ─── Sensitive file warnings ─────────────────────────────────────────────────
SENSITIVE_PATTERNS=(
  "\\.env"
  "google-services\\.json"
  "GoogleService-Info\\.plist"
  "\\.p12$"
  "\\.mobileprovision$"
  "\\.keystore$"
  "\\.jks$"
  "credentials\\.json"
)

SENSITIVE_FOUND=false
for pattern in "\${SENSITIVE_PATTERNS[@]}"; do
  MATCHES=$(echo "$CHANGED_FILES" | grep -E "$pattern" || true)
  if [ -n "$MATCHES" ]; then
    if [ "$SENSITIVE_FOUND" = false ]; then
      echo ""
      echo -e "\${RED}⚠ Sensitive files detected in push:\${NC}"
      SENSITIVE_FOUND=true
    fi
    echo -e "\${RED}  → \${MATCHES}\${NC}"
  fi
done

if [ "$SENSITIVE_FOUND" = true ]; then
  echo ""
  echo -e "\${RED}❌ Push blocked — sensitive files must not be committed.\${NC}"
  echo -e "  Add them to .gitignore and remove from tracking:"
  echo -e "  \${CYAN}git rm --cached <file>\${NC}"
  echo ""
  exit 1
fi

# ─── Native change advisory ──────────────────────────────────────────────────
if [ "$HAS_NATIVE_CHANGES" = true ]; then
  echo ""
  echo -e "\${YELLOW}📱 Native code changes detected (ios/ or android/).\${NC}"
  echo -e "\${YELLOW}   Ensure EAS Build is triggered for both platforms.\${NC}"
  echo -e "\${YELLOW}   Run: \${CYAN}eas build --platform all --profile staging\${NC}"
fi

# ─── Success ──────────────────────────────────────────────────────────────────
echo ""
echo -e "\${GREEN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
echo -e "\${GREEN}✅ All pre-push checks passed. Pushing...\${NC}"
echo -e "\${GREEN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
exit 0`,

  'install.sh': `#!/usr/bin/env bash
set -euo pipefail

# ─────────────────────────────────────────────────────────────────────────────
# React Native Mobile App — Project Installer
# Sets up git hooks, installs dependencies, configures .claude/, installs
# the CodeForge plugin, and prepares the Expo development environment.
# ─────────────────────────────────────────────────────────────────────────────

BOLD='\\033[1m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
RED='\\033[0;31m'
CYAN='\\033[0;36m'
RESET='\\033[0m'

log()   { echo -e "\${GREEN}✔\${RESET} $1"; }
warn()  { echo -e "\${YELLOW}⚠\${RESET} $1"; }
err()   { echo -e "\${RED}✖\${RESET} $1"; }
info()  { echo -e "\${CYAN}ℹ\${RESET} $1"; }
step()  { echo -e "\\n\${BOLD}▸ $1\${RESET}"; }

PROJECT_ROOT="$(cd "$(dirname "\${BASH_SOURCE[0]}")" && pwd)"
cd "$PROJECT_ROOT"

echo -e "\\n\${BOLD}╔══════════════════════════════════════════════════════════╗\${RESET}"
echo -e "\${BOLD}║   React Native Mobile App — Project Setup               ║\${RESET}"
echo -e "\${BOLD}╚══════════════════════════════════════════════════════════╝\${RESET}\\n"

# ─────────────────────────────────────────────────────────────────────────────
# 0. Pre-flight checks
# ─────────────────────────────────────────────────────────────────────────────
step "Running pre-flight checks"

MISSING_TOOLS=()

command -v git   >/dev/null 2>&1 || MISSING_TOOLS+=("git")
command -v node  >/dev/null 2>&1 || MISSING_TOOLS+=("node (>=18)")
command -v pnpm  >/dev/null 2>&1 || MISSING_TOOLS+=("pnpm (>=8)")

if [ \${#MISSING_TOOLS[@]} -ne 0 ]; then
  err "Missing required tools: \${MISSING_TOOLS[*]}"
  echo "  Install them before running this script."
  echo "  - node: https://nodejs.org/ (v18+)"
  echo "  - pnpm: corepack enable && corepack prepare pnpm@latest --activate"
  exit 1
fi

# Check Node version (require >=18)
NODE_MAJOR=$(node -e "console.log(process.versions.node.split('.')[0])")
if [ "$NODE_MAJOR" -lt 18 ]; then
  err "Node.js v18+ required (found v$(node -v))"
  exit 1
fi
log "Node.js $(node -v) — OK"

# Check pnpm version (require >=8)
PNPM_MAJOR=$(pnpm -v | cut -d. -f1)
if [ "$PNPM_MAJOR" -lt 8 ]; then
  err "pnpm v8+ required (found v$(pnpm -v))"
  exit 1
fi
log "pnpm v$(pnpm -v) — OK"

# Check for optional tools
if command -v watchman >/dev/null 2>&1; then
  log "Watchman $(watchman -v 2>/dev/null || echo 'installed') — OK"
else
  warn "Watchman not found — recommended for React Native file watching"
  warn "  Install: brew install watchman (macOS) or see https://facebook.github.io/watchman/"
fi

if command -v eas >/dev/null 2>&1; then
  log "EAS CLI $(eas --version 2>/dev/null || echo 'installed') — OK"
else
  warn "EAS CLI not found — will install globally"
fi

# Platform-specific checks
if [[ "$OSTYPE" == "darwin"* ]]; then
  if command -v xcodebuild >/dev/null 2>&1; then
    XCODE_VERSION=$(xcodebuild -version 2>/dev/null | head -1 || echo "unknown")
    log "Xcode: $XCODE_VERSION — OK"
  else
    warn "Xcode not found — required for iOS builds"
    warn "  Install from the Mac App Store"
  fi

  if command -v pod >/dev/null 2>&1; then
    log "CocoaPods $(pod --version 2>/dev/null) — OK"
  else
    warn "CocoaPods not found — required for iOS native dependencies"
    warn "  Install: sudo gem install cocoapods"
  fi
fi

if [ -n "\${ANDROID_HOME:-}" ] || [ -n "\${ANDROID_SDK_ROOT:-}" ]; then
  log "Android SDK found — OK"
else
  warn "ANDROID_HOME / ANDROID_SDK_ROOT not set — required for Android builds"
  warn "  Install Android Studio and set the environment variable"
fi

# ─────────────────────────────────────────────────────────────────────────────
# 1. Environment file setup
# ─────────────────────────────────────────────────────────────────────────────
step "Setting up environment files"

if [ ! -f .env ]; then
  if [ -f .env.example ]; then
    cp .env.example .env
    log "Created .env from .env.example"
    warn "Edit .env with your Firebase and service credentials"
  else
    cat > .env <<'ENVFILE'
# ─────────────────────────────────────────────────────────────────────────────
# React Native Mobile App — Environment Variables
# Copy to .env and fill in your values. NEVER commit this file.
# ─────────────────────────────────────────────────────────────────────────────

# Firebase
FIREBASE_API_KEY=
FIREBASE_AUTH_DOMAIN=
FIREBASE_PROJECT_ID=
FIREBASE_STORAGE_BUCKET=
FIREBASE_MESSAGING_SENDER_ID=
FIREBASE_APP_ID=
FIREBASE_MEASUREMENT_ID=

# Sentry
SENTRY_DSN=
SENTRY_ORG=
SENTRY_PROJECT=

# App Config
APP_ENV=development
API_BASE_URL=http://localhost:5001
DEEP_LINK_PREFIX=reactnativeapp://

# EAS
EXPO_PUBLIC_EAS_PROJECT_ID=
ENVFILE
    log "Created .env template"
    warn "Edit .env with your Firebase and service credentials"
  fi
else
  log ".env already exists — skipping"
fi

# ─────────────────────────────────────────────────────────────────────────────
# 2. Install project dependencies
# ─────────────────────────────────────────────────────────────────────────────
step "Installing project dependencies (pnpm install)"

pnpm install --frozen-lockfile 2>/dev/null || pnpm install
log "Project dependencies installed"

# ─────────────────────────────────────────────────────────────────────────────
# 3. Install global tools (EAS CLI)
# ─────────────────────────────────────────────────────────────────────────────
step "Checking global tools"

if ! command -v eas >/dev/null 2>&1; then
  info "Installing EAS CLI globally..."
  pnpm add -g eas-cli
  log "EAS CLI installed"
else
  log "EAS CLI already installed"
fi

if ! command -v expo >/dev/null 2>&1; then
  # expo-cli is bundled with npx expo, but check for the local binary
  info "Expo CLI available via 'npx expo' — OK"
fi

# ─────────────────────────────────────────────────────────────────────────────
# 4. Install mock MCP servers (development tooling)
# ─────────────────────────────────────────────────────────────────────────────
step "Installing mock MCP servers"

if [ -d mock-mcp-servers ] && [ -f mock-mcp-servers/package.json ]; then
  (cd mock-mcp-servers && pnpm install --frozen-lockfile 2>/dev/null || pnpm install)
  log "Mock MCP server dependencies installed"
else
  warn "mock-mcp-servers/ not found — skipping"
fi

# ─────────────────────────────────────────────────────────────────────────────
# 5. Install CodeForge plugin
# ─────────────────────────────────────────────────────────────────────────────
step "Installing CodeForge React Native plugin"

PLUGIN_DIR="plugin/codeforge-react-native"

if [ -d "$PLUGIN_DIR" ] && [ -f "$PLUGIN_DIR/package.json" ]; then
  (cd "$PLUGIN_DIR" && pnpm install --frozen-lockfile 2>/dev/null || pnpm install)
  log "CodeForge plugin dependencies installed"
else
  info "Plugin directory $PLUGIN_DIR not found — creating scaffold"
  mkdir -p "$PLUGIN_DIR"
  if [ ! -f "$PLUGIN_DIR/package.json" ]; then
    cat > "$PLUGIN_DIR/package.json" <<'PLUGINPKG'
{
  "name": "codeforge-react-native",
  "version": "0.1.0",
  "private": true,
  "description": "CodeForge plugin for React Native Mobile App",
  "type": "module",
  "scripts": {
    "build": "echo 'Plugin build placeholder'"
  }
}
PLUGINPKG
  fi
  log "CodeForge plugin scaffold created"
fi

# ─────────────────────────────────────────────────────────────────────────────
# 6. Configure .claude/ directory
# ─────────────────────────────────────────────────────────────────────────────
step "Configuring .claude/ directory"

if [ -d .claude ]; then
  log ".claude/ directory exists"

  # Verify required files
  for CLAUDE_FILE in settings.json rules/typescript/testing.md; do
    if [ -f ".claude/$CLAUDE_FILE" ]; then
      log "  .claude/$CLAUDE_FILE — present"
    else
      warn "  .claude/$CLAUDE_FILE — missing (check template)"
    fi
  done
else
  warn ".claude/ directory not found — Claude Code configuration may be incomplete"
fi

# Verify .mcp.json
if [ -f .mcp.json ]; then
  log ".mcp.json configuration present"
else
  warn ".mcp.json not found — MCP server integration will not work"
fi

# ─────────────────────────────────────────────────────────────────────────────
# 7. Set up Git hooks
# ─────────────────────────────────────────────────────────────────────────────
step "Setting up Git hooks"

GIT_HOOKS_DIR=".git/hooks"
LOCAL_HOOKS_DIR="git-hooks"

if [ ! -d .git ]; then
  info "Initializing git repository..."
  git init
  log "Git repository initialized"
fi

if [ -d "$LOCAL_HOOKS_DIR" ]; then
  mkdir -p "$GIT_HOOKS_DIR"

  for HOOK_FILE in "$LOCAL_HOOKS_DIR"/*; do
    if [ -f "$HOOK_FILE" ]; then
      HOOK_NAME=$(basename "$HOOK_FILE")
      cp "$HOOK_FILE" "$GIT_HOOKS_DIR/$HOOK_NAME"
      chmod +x "$GIT_HOOKS_DIR/$HOOK_NAME"
      log "Installed git hook: $HOOK_NAME"
    fi
  done
else
  warn "git-hooks/ directory not found — skipping hook installation"
fi

# ─────────────────────────────────────────────────────────────────────────────
# 8. Expo setup & prebuild check
# ─────────────────────────────────────────────────────────────────────────────
step "Expo project setup"

if [ -f app.json ] || [ -f app.config.ts ] || [ -f app.config.js ]; then
  log "Expo config found"

  # Run expo doctor to check for issues
  info "Running Expo diagnostics..."
  npx expo install --check 2>/dev/null && log "Expo dependencies are compatible" || warn "Some Expo dependencies may need updating — run 'npx expo install --fix'"
else
  warn "No app.json or app.config.ts found — Expo may not be configured"
  warn "  Run 'npx create-expo-app' or add app.config.ts manually"
fi

# ─────────────────────────────────────────────────────────────────────────────
# 9. iOS setup (macOS only)
# ─────────────────────────────────────────────────────────────────────────────
if [[ "$OSTYPE" == "darwin"* ]]; then
  step "iOS setup (macOS detected)"

  if [ -d ios ] && [ -f ios/Podfile ]; then
    info "Installing CocoaPods dependencies..."
    if command -v pod >/dev/null 2>&1; then
      (cd ios && pod install --repo-update 2>/dev/null) && log "CocoaPods installed" || warn "CocoaPods install failed — run 'cd ios && pod install' manually"
    else
      warn "CocoaPods not installed — run 'sudo gem install cocoapods' then 'cd ios && pod install'"
    fi
  else
    info "No ios/ directory — run 'npx expo prebuild --platform ios' to generate native project"
  fi
fi

# ─────────────────────────────────────────────────────────────────────────────
# 10. Firebase configuration check
# ─────────────────────────────────────────────────────────────────────────────
step "Checking Firebase configuration"

FIREBASE_OK=true

if [ -f google-services.json ]; then
  log "google-services.json (Android) — present"
else
  warn "google-services.json not found — required for Android Firebase"
  warn "  Download from Firebase Console → Project Settings → Android app"
  FIREBASE_OK=false
fi

if [ -f GoogleService-Info.plist ]; then
  log "GoogleService-Info.plist (iOS) — present"
elif [ -f ios/GoogleService-Info.plist ]; then
  log "ios/GoogleService-Info.plist (iOS) — present"
else
  warn "GoogleService-Info.plist not found — required for iOS Firebase"
  warn "  Download from Firebase Console → Project Settings → iOS app"
  FIREBASE_OK=false
fi

if [ "$FIREBASE_OK" = true ]; then
  log "Firebase configuration complete"
fi

# ─────────────────────────────────────────────────────────────────────────────
# 11. Create required directories
# ─────────────────────────────────────────────────────────────────────────────
step "Ensuring project directory structure"

DIRS=(
  "src/features/auth/screens"
  "src/features/auth/components"
  "src/features/auth/hooks"
  "src/features/auth/types"
  "src/features/home/screens"
  "src/features/home/components"
  "src/features/home/hooks"
  "src/features/home/types"
  "src/features/profile/screens"
  "src/features/profile/components"
  "src/features/profile/hooks"
  "src/features/profile/types"
  "src/features/notifications/screens"
  "src/features/notifications/components"
  "src/features/notifications/hooks"
  "src/features/notifications/types"
  "src/features/payments/screens"
  "src/features/payments/components"
  "src/features/payments/hooks"
  "src/features/payments/types"
  "src/components"
  "src/hooks"
  "src/services"
  "src/navigation"
  "src/store"
  "src/utils"
  "src/i18n"
  "src/theme"
  "src/assets/images"
  "src/assets/fonts"
  "src/assets/animations"
  "e2e"
  "scripts"
  "docs"
  "playbook"
)

for DIR in "\${DIRS[@]}"; do
  mkdir -p "$DIR"
done
log "Project directory structure verified"

# ─────────────────────────────────────────────────────────────────────────────
# 12. Verify TypeScript configuration
# ─────────────────────────────────────────────────────────────────────────────
step "Verifying TypeScript configuration"

if [ -f tsconfig.json ]; then
  # Quick check that strict mode is enabled
  if grep -q '"strict":\\s*true\\|"strict": true' tsconfig.json 2>/dev/null; then
    log "TypeScript strict mode enabled"
  else
    warn "TypeScript strict mode may not be enabled — check tsconfig.json"
  fi
  log "tsconfig.json present"
else
  warn "tsconfig.json not found"
fi

# ─────────────────────────────────────────────────────────────────────────────
# 13. Run initial checks
# ─────────────────────────────────────────────────────────────────────────────
step "Running initial validation"

# Type check
info "Running TypeScript type check..."
if npx tsc --noEmit 2>/dev/null; then
  log "TypeScript — no errors"
else
  warn "TypeScript errors found — run 'npx tsc --noEmit' to see details"
fi

# Lint check (non-blocking)
info "Running ESLint check..."
if npx eslint src/ --ext .ts,.tsx --max-warnings 0 2>/dev/null; then
  log "ESLint — no warnings or errors"
else
  warn "ESLint issues found — run 'pnpm lint' to see details"
fi

# ─────────────────────────────────────────────────────────────────────────────
# Summary
# ─────────────────────────────────────────────────────────────────────────────
echo ""
echo -e "\${BOLD}╔══════════════════════════════════════════════════════════╗\${RESET}"
echo -e "\${BOLD}║   Setup Complete!                                       ║\${RESET}"
echo -e "\${BOLD}╚══════════════════════════════════════════════════════════╝\${RESET}"
echo ""
echo -e "  \${CYAN}Quick start:\${RESET}"
echo -e "    \${BOLD}npx expo start\${RESET}              Start Expo dev server"
echo -e "    \${BOLD}npx expo start --ios\${RESET}        Run on iOS Simulator"
echo -e "    \${BOLD}npx expo start --android\${RESET}    Run on Android Emulator"
echo ""
echo -e "  \${CYAN}Build & deploy:\${RESET}"
echo -e "    \${BOLD}eas build --platform ios\${RESET}        Build iOS binary"
echo -e "    \${BOLD}eas build --platform android\${RESET}    Build Android binary"
echo -e "    \${BOLD}eas submit\${RESET}                      Submit to stores"
echo ""
echo -e "  \${CYAN}Testing:\${RESET}"
echo -e "    \${BOLD}pnpm test\${RESET}                   Run unit & component tests"
echo -e "    \${BOLD}pnpm test:coverage\${RESET}          Run tests with coverage (75% threshold)"
echo -e "    \${BOLD}npx detox test\${RESET}              Run E2E tests"
echo ""
echo -e "  \${CYAN}Code quality:\${RESET}"
echo -e "    \${BOLD}pnpm lint\${RESET}                   ESLint check"
echo -e "    \${BOLD}pnpm format\${RESET}                 Prettier format"
echo -e "    \${BOLD}npx tsc --noEmit\${RESET}            TypeScript type check"
echo ""
echo -e "  \${CYAN}Before your first commit:\${RESET}"
echo -e "    1. Fill in \${BOLD}.env\${RESET} with your Firebase credentials"
echo -e "    2. Add \${BOLD}google-services.json\${RESET} (Android) and \${BOLD}GoogleService-Info.plist\${RESET} (iOS)"
echo -e "    3. Run \${BOLD}eas login\${RESET} to authenticate with Expo"
echo -e "    4. Read \${BOLD}docs/ONBOARDING.md\${RESET} for the full setup guide"
echo ""
echo -e "  \${CYAN}Documentation:\${RESET}"
echo -e "    \${BOLD}docs/ONBOARDING.md\${RESET}          Getting started guide"
echo -e "    \${BOLD}docs/ARCHITECTURE.md\${RESET}        Architecture overview"
echo -e "    \${BOLD}docs/CONTRIBUTING.md\${RESET}        Contributing guidelines"
echo -e "    \${BOLD}docs/AI-USAGE-POLICY.md\${RESET}     AI-assisted development policy"
echo ""`,

  'mock-mcp-servers/README.md': `# Mock MCP Servers

Local mock implementations of MCP (Model Context Protocol) servers used by Claude Code in this project. These servers simulate external service APIs during development and testing, allowing Claude to interact with GitHub Issues, Slack, and other integrations without requiring live credentials.

## Overview

| Server | File | Port | Simulates |
|--------|------|------|-----------|
| GitHub | \`github-server.mjs\` | stdio | GitHub Issues, PRs, CODEOWNERS, Actions |
| Jira | \`jira-server.mjs\` | stdio | Jira-style ticket management (mapped to GitHub Issues) |

These servers are referenced in the root \`.mcp.json\` and are automatically started by Claude Code when MCP tools are invoked.

## Prerequisites

- Node.js >= 18
- pnpm (project package manager)

## Setup

\`\`\`bash
cd mock-mcp-servers
pnpm install
\`\`\`

No additional configuration is needed. The servers run via stdio transport and are launched on-demand by Claude Code based on \`.mcp.json\` configuration.

## Available Tools

### GitHub Server (\`github-server.mjs\`)

Simulates the GitHub API for repository and project management operations.

#### \`get_issue\`
Retrieve a GitHub Issue by number.
- **Parameters**: \`issue_number\` (number, required)
- **Returns**: Issue object with title, body, labels, assignees, state, and comments

#### \`list_issues\`
List issues with optional filters.
- **Parameters**: \`state\` (open|closed|all), \`labels\` (comma-separated string), \`assignee\` (string)
- **Returns**: Array of issue objects

#### \`create_issue\`
Create a new GitHub Issue.
- **Parameters**: \`title\` (string, required), \`body\` (string), \`labels\` (string[]), \`assignee\` (string)
- **Returns**: Created issue object with assigned number

#### \`update_issue\`
Update an existing issue.
- **Parameters**: \`issue_number\` (number, required), \`title\` (string), \`body\` (string), \`state\` (open|closed), \`labels\` (string[])
- **Returns**: Updated issue object

#### \`add_comment\`
Add a comment to an issue.
- **Parameters**: \`issue_number\` (number, required), \`body\` (string, required)
- **Returns**: Created comment object

#### \`list_pull_requests\`
List pull requests with optional filters.
- **Parameters**: \`state\` (open|closed|all), \`base\` (string), \`head\` (string)
- **Returns**: Array of PR objects with review status

#### \`get_pull_request\`
Get details of a specific pull request.
- **Parameters**: \`pr_number\` (number, required)
- **Returns**: PR object with diff stats, review comments, and CI status

#### \`get_codeowners\`
Retrieve CODEOWNERS mappings for a file path.
- **Parameters**: \`path\` (string, required)
- **Returns**: Array of owner handles for the given path

#### \`get_workflow_runs\`
List recent GitHub Actions workflow runs.
- **Parameters**: \`workflow_name\` (string), \`branch\` (string), \`status\` (completed|in_progress|queued)
- **Returns**: Array of workflow run objects with status and conclusion

### Jira Server (\`jira-server.mjs\`)

Simulates Jira-style ticket management. In this project, tickets map to GitHub Issues with the \`APP-\` prefix convention.

#### \`get_ticket\`
Retrieve a ticket by key (e.g., \`APP-42\`).
- **Parameters**: \`ticket_key\` (string, required)
- **Returns**: Ticket object with summary, description, status, priority, assignee, story points, acceptance criteria

#### \`list_tickets\`
List tickets with filters.
- **Parameters**: \`status\` (string), \`assignee\` (string), \`sprint\` (string), \`priority\` (string)
- **Returns**: Array of ticket objects

#### \`update_ticket_status\`
Transition a ticket to a new status.
- **Parameters**: \`ticket_key\` (string, required), \`status\` (string, required — To Do|In Progress|In Review|QA|Done)
- **Returns**: Updated ticket object

#### \`add_ticket_comment\`
Add a comment to a ticket.
- **Parameters**: \`ticket_key\` (string, required), \`body\` (string, required)
- **Returns**: Created comment object

#### \`get_sprint\`
Get current sprint details.
- **Parameters**: \`sprint_name\` (string, optional — defaults to current sprint)
- **Returns**: Sprint object with tickets, velocity, start/end dates

#### \`log_work\`
Log time spent on a ticket.
- **Parameters**: \`ticket_key\` (string, required), \`hours\` (number, required), \`description\` (string)
- **Returns**: Work log entry

## Mock Data

Both servers include realistic seed data relevant to this React Native project:

### GitHub Issues (seed data)
- \`#1\` — Set up Expo SDK 51 project scaffold (closed)
- \`#2\` — Implement Firebase Authentication flow (open, label: \`feat\`)
- \`#3\` — Add WatermelonDB offline sync (open, label: \`feat\`)
- \`#4\` — Configure EAS Build for staging channel (open, label: \`chore\`)
- \`#5\` — Push notification deep linking broken on Android (open, label: \`bug\`)

### Jira Tickets (seed data)
- \`APP-1\` — Project scaffold (Done)
- \`APP-2\` — Firebase Auth (In Progress)
- \`APP-3\` — Offline sync with WatermelonDB (To Do)
- \`APP-4\` — EAS Build configuration (In Progress)
- \`APP-5\` — Fix Android deep link push notifications (In Review)
- \`APP-42\` — Add push notification preferences screen (To Do)

## Customizing Mock Data

Edit the \`MOCK_DATA\` objects at the top of each server file to add or modify seed data. The structure follows the tool return schemas documented above.

\`\`\`javascript
// Example: Adding a new issue to github-server.mjs
const MOCK_ISSUES = [
  // ... existing issues
  {
    number: 6,
    title: 'Add biometric authentication for iOS Face ID',
    body: 'Implement expo-local-authentication for biometric login...',
    state: 'open',
    labels: ['feat', 'ios'],
    assignee: 'dev-alice',
    comments: [],
  },
];
\`\`\`

## Running Standalone (for debugging)

You can test a server directly via stdin/stdout:

\`\`\`bash
# Start the GitHub server
node github-server.mjs

# Then paste a JSON-RPC request:
{"jsonrpc":"2.0","id":1,"method":"tools/list","params":{}}
\`\`\`

\`\`\`bash
# Call a specific tool
{"jsonrpc":"2.0","id":2,"method":"tools/call","params":{"name":"get_issue","arguments":{"issue_number":5}}}
\`\`\`

Press Ctrl+C to exit.

## How Claude Code Uses These

The root \`.mcp.json\` maps server names to their launch commands:

\`\`\`json
{
  "mcpServers": {
    "github": {
      "command": "node",
      "args": ["mock-mcp-servers/github-server.mjs"]
    },
    "jira": {
      "command": "node",
      "args": ["mock-mcp-servers/jira-server.mjs"]
    }
  }
}
\`\`\`

When Claude Code invokes an MCP tool (e.g., to look up ticket \`APP-42\` before starting work on a feature branch \`feat/APP-42-add-push-preferences\`), it spawns the appropriate server process and communicates via JSON-RPC over stdio.

## Replacing with Real Servers

When ready to connect to live services:

1. Replace the mock server entries in \`.mcp.json\` with real MCP server packages
2. Configure authentication tokens via environment variables (never commit credentials)
3. Remove or archive the \`mock-mcp-servers/\` directory

See the [official MCP server registry](https://github.com/modelcontextprotocol/servers) for production-ready server implementations.

## Troubleshooting

**Server won't start**: Ensure \`pnpm install\` was run in this directory and Node.js >= 18 is available.

**Tool returns "not found"**: Check that the tool name matches exactly (case-sensitive). Run \`tools/list\` to see available tools.

**Stale data**: Mock data resets on each server restart. Modifications during a session are held in memory only.

**Claude Code not finding servers**: Verify \`.mcp.json\` paths are relative to the project root and the \`command\`/\`args\` are correct.`,

  'mock-mcp-servers/github-server.mjs': `#!/usr/bin/env node

import { Server } from "@modelcontextprotocol/sdk/server/index.js";
import { StdioServerTransport } from "@modelcontextprotocol/sdk/server/stdio.js";
import {
  CallToolRequestSchema,
  ListToolsRequestSchema,
} from "@modelcontextprotocol/sdk/types.js";

const REPO_OWNER = "team";
const REPO_NAME = "react-native-mobile-app";

let issueCounter = 100;
let prCounter = 50;

const mockIssues = [
  { number: 42, title: "Add push notification support", state: "open", labels: ["feat", "mobile"], assignee: "dev-senior", milestone: "v1.2.0" },
  { number: 43, title: "Fix biometric auth on Android 14", state: "open", labels: ["fix", "android", "priority:high"], assignee: "dev-mid", milestone: "v1.1.1" },
  { number: 44, title: "WatermelonDB sync conflict resolution", state: "open", labels: ["fix", "offline"], assignee: null, milestone: "v1.2.0" },
  { number: 38, title: "Implement in-app purchase flow", state: "closed", labels: ["feat", "payments"], assignee: "dev-lead", milestone: "v1.1.0" },
  { number: 39, title: "GDPR consent dialog on first launch", state: "closed", labels: ["feat", "compliance"], assignee: "dev-senior", milestone: "v1.1.0" },
];

const mockPRs = [
  { number: 48, title: "feat(notifications): add FCM push notification handler", state: "open", branch: "feat/APP-42-add-push-notifications", author: "dev-senior", reviewers: ["dev-lead"], checks: "passing", mergeable: true },
  { number: 49, title: "fix(auth): resolve biometric prompt crash on Android 14", state: "open", branch: "fix/APP-43-biometric-android14", author: "dev-mid", reviewers: ["dev-senior"], checks: "running", mergeable: false },
  { number: 47, title: "feat(payments): integrate RevenueCat for subscriptions", state: "merged", branch: "feat/APP-38-in-app-purchases", author: "dev-lead", reviewers: ["dev-senior"], checks: "passing", mergeable: false },
];

const mockFiles = {
  "src/features/auth/screens/LoginScreen.tsx": "import React from 'react';\\n// LoginScreen component with biometric support",
  "src/features/notifications/hooks/usePushNotifications.ts": "import { useEffect } from 'react';\\n// Push notification registration and handling hook",
  "src/services/firebase/messaging.ts": "import messaging from '@react-native-firebase/messaging';\\n// FCM service wrapper",
  "src/navigation/RootNavigator.tsx": "import { NavigationContainer } from '@react-navigation/native';\\n// Root navigator with deep linking config",
  "app.config.ts": "export default ({ config }) => ({ ...config, name: 'react-native-mobile-app' });",
  "CODEOWNERS": "src/services/auth/** @dev-lead @dev-senior\\nsrc/config/** @dev-lead\\n*.json @dev-lead\\nsrc/features/payments/** @dev-lead",
};

const mockBranches = [
  { name: "main", protected: true, lastCommit: "abc1234" },
  { name: "feat/APP-42-add-push-notifications", protected: false, lastCommit: "def5678" },
  { name: "fix/APP-43-biometric-android14", protected: false, lastCommit: "ghi9012" },
];

const mockWorkflowRuns = [
  { id: 1001, name: "CI Pipeline", branch: "feat/APP-42-add-push-notifications", status: "completed", conclusion: "success", jobs: ["lint", "typecheck", "test-unit", "eas-build-ios", "eas-build-android"] },
  { id: 1002, name: "CI Pipeline", branch: "fix/APP-43-biometric-android14", status: "in_progress", conclusion: null, jobs: ["lint", "typecheck", "test-unit"] },
];

const server = new Server(
  { name: "mock-github-server", version: "1.0.0" },
  { capabilities: { tools: {} } }
);

server.setRequestHandler(ListToolsRequestSchema, async () => ({
  tools: [
    {
      name: "get_issue",
      description: "Get a GitHub issue by number",
      inputSchema: { type: "object", properties: { issue_number: { type: "number" } }, required: ["issue_number"] },
    },
    {
      name: "list_issues",
      description: "List GitHub issues with optional filters",
      inputSchema: { type: "object", properties: { state: { type: "string", enum: ["open", "closed", "all"] }, labels: { type: "string" }, assignee: { type: "string" }, milestone: { type: "string" } } },
    },
    {
      name: "create_issue",
      description: "Create a new GitHub issue",
      inputSchema: { type: "object", properties: { title: { type: "string" }, body: { type: "string" }, labels: { type: "array", items: { type: "string" } }, assignees: { type: "array", items: { type: "string" } }, milestone: { type: "string" } }, required: ["title"] },
    },
    {
      name: "get_pull_request",
      description: "Get a pull request by number",
      inputSchema: { type: "object", properties: { pull_number: { type: "number" } }, required: ["pull_number"] },
    },
    {
      name: "list_pull_requests",
      description: "List pull requests with optional filters",
      inputSchema: { type: "object", properties: { state: { type: "string", enum: ["open", "closed", "all"] }, author: { type: "string" } } },
    },
    {
      name: "create_pull_request",
      description: "Create a new pull request",
      inputSchema: { type: "object", properties: { title: { type: "string" }, body: { type: "string" }, head: { type: "string" }, base: { type: "string" }, reviewers: { type: "array", items: { type: "string" } } }, required: ["title", "head", "base"] },
    },
    {
      name: "create_review_comment",
      description: "Add a review comment to a pull request",
      inputSchema: { type: "object", properties: { pull_number: { type: "number" }, body: { type: "string" }, path: { type: "string" }, line: { type: "number" } }, required: ["pull_number", "body"] },
    },
    {
      name: "get_file_contents",
      description: "Get file contents from the repository",
      inputSchema: { type: "object", properties: { path: { type: "string" }, ref: { type: "string" } }, required: ["path"] },
    },
    {
      name: "list_branches",
      description: "List repository branches",
      inputSchema: { type: "object", properties: { protected_only: { type: "boolean" } } },
    },
    {
      name: "get_workflow_runs",
      description: "Get recent workflow runs",
      inputSchema: { type: "object", properties: { branch: { type: "string" }, status: { type: "string" } } },
    },
    {
      name: "search_code",
      description: "Search for code in the repository",
      inputSchema: { type: "object", properties: { query: { type: "string" }, path: { type: "string" } }, required: ["query"] },
    },
    {
      name: "get_pr_diff",
      description: "Get the diff for a pull request",
      inputSchema: { type: "object", properties: { pull_number: { type: "number" } }, required: ["pull_number"] },
    },
  ],
}));

server.setRequestHandler(CallToolRequestSchema, async (request) => {
  const { name, arguments: args } = request.params;

  switch (name) {
    case "get_issue": {
      const issue = mockIssues.find((i) => i.number === args.issue_number);
      if (!issue) {
        return { content: [{ type: "text", text: JSON.stringify({ error: "Not found", message: \`Issue #\${args.issue_number} not found\` }, null, 2) }] };
      }
      return { content: [{ type: "text", text: JSON.stringify({ ...issue, repo: \`\${REPO_OWNER}/\${REPO_NAME}\`, url: \`https://github.com/\${REPO_OWNER}/\${REPO_NAME}/issues/\${issue.number}\` }, null, 2) }] };
    }

    case "list_issues": {
      let filtered = [...mockIssues];
      if (args.state && args.state !== "all") {
        filtered = filtered.filter((i) => i.state === args.state);
      }
      if (args.labels) {
        const labelList = args.labels.split(",");
        filtered = filtered.filter((i) => labelList.some((l) => i.labels.includes(l.trim())));
      }
      if (args.assignee) {
        filtered = filtered.filter((i) => i.assignee === args.assignee);
      }
      if (args.milestone) {
        filtered = filtered.filter((i) => i.milestone === args.milestone);
      }
      return { content: [{ type: "text", text: JSON.stringify({ total_count: filtered.length, items: filtered }, null, 2) }] };
    }

    case "create_issue": {
      issueCounter++;
      const newIssue = {
        number: issueCounter,
        title: args.title,
        body: args.body || "",
        state: "open",
        labels: args.labels || [],
        assignee: args.assignees?.[0] || null,
        milestone: args.milestone || null,
        created_at: new Date().toISOString(),
        url: \`https://github.com/\${REPO_OWNER}/\${REPO_NAME}/issues/\${issueCounter}\`,
      };
      mockIssues.push(newIssue);
      return { content: [{ type: "text", text: JSON.stringify(newIssue, null, 2) }] };
    }

    case "get_pull_request": {
      const pr = mockPRs.find((p) => p.number === args.pull_number);
      if (!pr) {
        return { content: [{ type: "text", text: JSON.stringify({ error: "Not found", message: \`PR #\${args.pull_number} not found\` }, null, 2) }] };
      }
      return {
        content: [{
          type: "text",
          text: JSON.stringify({
            ...pr,
            repo: \`\${REPO_OWNER}/\${REPO_NAME}\`,
            base: "main",
            url: \`https://github.com/\${REPO_OWNER}/\${REPO_NAME}/pull/\${pr.number}\`,
            changed_files: 5,
            additions: 142,
            deletions: 23,
          }, null, 2),
        }],
      };
    }

    case "list_pull_requests": {
      let filtered = [...mockPRs];
      if (args.state && args.state !== "all") {
        filtered = filtered.filter((p) => p.state === args.state);
      }
      if (args.author) {
        filtered = filtered.filter((p) => p.author === args.author);
      }
      return { content: [{ type: "text", text: JSON.stringify({ total_count: filtered.length, items: filtered }, null, 2) }] };
    }

    case "create_pull_request": {
      prCounter++;
      const newPR = {
        number: prCounter,
        title: args.title,
        body: args.body || "",
        state: "open",
        branch: args.head,
        base: args.base,
        author: "claude-dev",
        reviewers: args.reviewers || [],
        checks: "pending",
        mergeable: true,
        created_at: new Date().toISOString(),
        url: \`https://github.com/\${REPO_OWNER}/\${REPO_NAME}/pull/\${prCounter}\`,
      };
      mockPRs.push(newPR);
      return { content: [{ type: "text", text: JSON.stringify(newPR, null, 2) }] };
    }

    case "create_review_comment": {
      const targetPR = mockPRs.find((p) => p.number === args.pull_number);
      if (!targetPR) {
        return { content: [{ type: "text", text: JSON.stringify({ error: "Not found", message: \`PR #\${args.pull_number} not found\` }, null, 2) }] };
      }
      const comment = {
        id: Date.now(),
        pull_number: args.pull_number,
        body: args.body,
        path: args.path || null,
        line: args.line || null,
        author: "claude-reviewer",
        created_at: new Date().toISOString(),
      };
      return { content: [{ type: "text", text: JSON.stringify(comment, null, 2) }] };
    }

    case "get_file_contents": {
      const filePath = args.path;
      const content = mockFiles[filePath];
      if (!content) {
        return { content: [{ type: "text", text: JSON.stringify({ error: "Not found", message: \`File \${filePath} not found\`, available_files: Object.keys(mockFiles) }, null, 2) }] };
      }
      return {
        content: [{
          type: "text",
          text: JSON.stringify({
            path: filePath,
            ref: args.ref || "main",
            content: content,
            encoding: "utf-8",
            size: content.length,
            sha: "mock_sha_" + filePath.replace(/[^a-z0-9]/gi, "").slice(0, 8),
          }, null, 2),
        }],
      };
    }

    case "list_branches": {
      let branches = [...mockBranches];
      if (args.protected_only) {
        branches = branches.filter((b) => b.protected);
      }
      return { content: [{ type: "text", text: JSON.stringify({ branches }, null, 2) }] };
    }

    case "get_workflow_runs": {
      let runs = [...mockWorkflowRuns];
      if (args.branch) {
        runs = runs.filter((r) => r.branch === args.branch);
      }
      if (args.status) {
        runs = runs.filter((r) => r.status === args.status);
      }
      return {
        content: [{
          type: "text",
          text: JSON.stringify({
            total_count: runs.length,
            workflow_runs: runs.map((r) => ({
              ...r,
              repo: \`\${REPO_OWNER}/\${REPO_NAME}\`,
              url: \`https://github.com/\${REPO_OWNER}/\${REPO_NAME}/actions/runs/\${r.id}\`,
            })),
          }, null, 2),
        }],
      };
    }

    case "search_code": {
      const query = args.query.toLowerCase();
      const matchingFiles = Object.entries(mockFiles)
        .filter(([path, content]) => {
          const matchesQuery = path.toLowerCase().includes(query) || content.toLowerCase().includes(query);
          const matchesPath = !args.path || path.startsWith(args.path);
          return matchesQuery && matchesPath;
        })
        .map(([path, content]) => ({
          path,
          matched_line: content.split("\\n").find((line) => line.toLowerCase().includes(query)) || null,
          repo: \`\${REPO_OWNER}/\${REPO_NAME}\`,
        }));
      return { content: [{ type: "text", text: JSON.stringify({ total_count: matchingFiles.length, items: matchingFiles }, null, 2) }] };
    }

    case "get_pr_diff": {
      const diffPR = mockPRs.find((p) => p.number === args.pull_number);
      if (!diffPR) {
        return { content: [{ type: "text", text: JSON.stringify({ error: "Not found", message: \`PR #\${args.pull_number} not found\` }, null, 2) }] };
      }
      const mockDiff = [
        \`diff --git a/src/features/notifications/hooks/usePushNotifications.ts b/src/features/notifications/hooks/usePushNotifications.ts\`,
        \`index abc1234..def5678 100644\`,
        \`--- a/src/features/notifications/hooks/usePushNotifications.ts\`,
        \`+++ b/src/features/notifications/hooks/usePushNotifications.ts\`,
        \`@@ -1,4 +1,28 @@\`,
        \` import { useEffect } from 'react';\`,
        \`+import messaging from '@react-native-firebase/messaging';\`,
        \`+import { useAuthStore } from '../../../store/auth-store';\`,
        \`+\`,
        \`+export const usePushNotifications = () => {\`,
        \`+  const { user } = useAuthStore();\`,
        \`+\`,
        \`+  useEffect(() => {\`,
        \`+    if (!user) return;\`,
        \`+    const unsubscribe = messaging().onMessage(async (remoteMessage) => {\`,
        \`+      // Handle foreground notification\`,
        \`+    });\`,
        \`+    return unsubscribe;\`,
        \`+  }, [user]);\`,
        \`+};\`,
      ].join("\\n");
      return {
        content: [{
          type: "text",
          text: JSON.stringify({
            pull_number: args.pull_number,
            title: diffPR.title,
            diff: mockDiff,
            files_changed: 5,
            additions: 142,
            deletions: 23,
          }, null, 2),
        }],
      };
    }

    default:
      return { content: [{ type: "text", text: JSON.stringify({ error: "Unknown tool", message: \`Tool '\${name}' is not implemented\` }, null, 2) }] };
  }
});

async function main() {
  const transport = new StdioServerTransport();
  await server.connect(transport);
  console.error(\`Mock GitHub MCP server running for \${REPO_OWNER}/\${REPO_NAME}\`);
}

main().catch((error) => {
  console.error("Failed to start mock GitHub server:", error);
  process.exit(1);
});`,

  'mock-mcp-servers/jira-server.mjs': `#!/usr/bin/env node

/**
 * Mock GitHub Issues MCP Server
 * Simulates ticket lookup for React Native mobile app feature tasks.
 * Used for local development and testing of Claude Code integrations.
 *
 * Note: Project uses GitHub Issues (not Jira), but this mock follows
 * the same MCP server pattern for compatibility with tooling.
 *
 * Usage: node mock-mcp-servers/jira-server.mjs
 */

import { Server } from "@modelcontextprotocol/sdk/server/index.js";
import { StdioServerTransport } from "@modelcontextprotocol/sdk/server/stdio.js";
import {
  CallToolRequestSchema,
  ListToolsRequestSchema,
} from "@modelcontextprotocol/sdk/types.js";

const MOCK_TICKETS = {
  "APP-1": {
    key: "APP-1",
    title: "Implement biometric authentication flow",
    type: "feature",
    status: "in-progress",
    priority: "high",
    assignee: "dev-senior-1",
    sprint: "Sprint 12",
    storyPoints: 8,
    labels: ["auth", "biometrics", "ios", "android"],
    description: \`## Summary
Implement biometric authentication (Face ID, Touch ID, fingerprint) as a secondary login method.

## Acceptance Criteria
- [ ] User can enable biometric auth from profile settings
- [ ] Biometric prompt shown on app launch when enabled
- [ ] Fallback to PIN/password if biometric fails 3 times
- [ ] Credentials stored in Keychain (iOS) / Keystore (Android)
- [ ] Works offline (no network required for biometric check)
- [ ] Accessibility labels on all biometric UI elements

## Technical Notes
- Use \\\`expo-local-authentication\\\` for biometric APIs
- Store auth token in \\\`expo-secure-store\\\`
- Feature directory: \\\`src/features/auth/\\\`
- Update Zustand auth store with biometric state
- Add E2E tests in \\\`e2e/auth/biometric.test.ts\\\`

## Privacy
- Biometric data never leaves device
- Add App Store privacy label for biometric usage
- GDPR: biometric preference must be deletable\`,
    subtasks: [
      { key: "APP-1a", title: "Add expo-local-authentication setup", status: "done" },
      { key: "APP-1b", title: "Create biometric prompt screen", status: "in-progress" },
      { key: "APP-1c", title: "Integrate with Zustand auth store", status: "todo" },
      { key: "APP-1d", title: "Add secure credential storage", status: "todo" },
      { key: "APP-1e", title: "Write unit and E2E tests", status: "todo" },
    ],
    comments: [
      {
        author: "dev-lead-1",
        date: "2024-11-01T10:00:00Z",
        body: "Make sure we handle the case where the user revokes biometric permissions at the OS level. Check \`hasHardwareAsync()\` on each app foreground event.",
      },
      {
        author: "dev-senior-1",
        date: "2024-11-02T14:30:00Z",
        body: "Using \`expo-secure-store\` with \`WHEN_UNLOCKED_THIS_DEVICE_ONLY\` for Keychain access. Android equivalent uses EncryptedSharedPreferences.",
      },
    ],
  },
  "APP-2": {
    key: "APP-2",
    title: "Set up WatermelonDB offline sync with Firestore",
    type: "feature",
    status: "todo",
    priority: "critical",
    assignee: "dev-senior-2",
    sprint: "Sprint 12",
    storyPoints: 13,
    labels: ["offline", "database", "sync", "firestore"],
    description: \`## Summary
Implement offline-first data layer using WatermelonDB with bidirectional sync to Firestore.

## Acceptance Criteria
- [ ] WatermelonDB schema defined for core models (User, Post, Comment, Notification)
- [ ] CRUD operations work fully offline
- [ ] Sync engine pushes local changes to Firestore when online
- [ ] Sync engine pulls remote changes from Firestore
- [ ] Conflict resolution: last-write-wins with server timestamp
- [ ] Sync status indicator in UI (synced, syncing, offline, error)
- [ ] Background sync on network reconnection

## Technical Notes
- WatermelonDB with SQLite adapter (JSI for performance)
- Firestore Cloud Functions for sync endpoint
- Use \\\`@nozbe/watermelondb\\\` with \\\`@nozbe/with-observables\\\`
- Feature services in \\\`src/services/database/\\\`
- Sync logic in \\\`src/services/sync/\\\`
- React Query for server state cache invalidation after sync

## Performance
- Batch sync operations (max 500 docs per batch)
- Debounce sync triggers (2s after last local write)
- Lazy-load relations to avoid waterfall queries\`,
    subtasks: [
      { key: "APP-2a", title: "Define WatermelonDB schema and models", status: "todo" },
      { key: "APP-2b", title: "Implement local CRUD operations", status: "todo" },
      { key: "APP-2c", title: "Build Firestore sync Cloud Function", status: "todo" },
      { key: "APP-2d", title: "Implement pull sync (server → local)", status: "todo" },
      { key: "APP-2e", title: "Implement push sync (local → server)", status: "todo" },
      { key: "APP-2f", title: "Add sync status UI component", status: "todo" },
      { key: "APP-2g", title: "Write sync integration tests", status: "todo" },
    ],
    comments: [
      {
        author: "dev-lead-1",
        date: "2024-11-03T09:00:00Z",
        body: "This is the foundation for the entire offline experience. Let's timebox the conflict resolution to last-write-wins for MVP and revisit CRDT-based merging in Q1.",
      },
    ],
  },
  "APP-3": {
    key: "APP-3",
    title: "Configure push notifications with Firebase Cloud Messaging",
    type: "feature",
    status: "in-progress",
    priority: "high",
    assignee: "dev-mid-1",
    sprint: "Sprint 12",
    storyPoints: 5,
    labels: ["notifications", "fcm", "ios", "android"],
    description: \`## Summary
Set up push notifications using Firebase Cloud Messaging (FCM) with Expo Notifications API.

## Acceptance Criteria
- [ ] Request notification permissions on first relevant action (not on app launch)
- [ ] Register device token with Firestore user document
- [ ] Handle foreground notifications with in-app banner
- [ ] Handle background/killed notifications with system tray
- [ ] Deep link from notification tap to relevant screen
- [ ] Notification preferences screen (per-category toggles)
- [ ] Token refresh handling

## Technical Notes
- Use \\\`expo-notifications\\\` for cross-platform API
- FCM for Android, APNs via FCM for iOS
- Deep linking config in \\\`src/navigation/linking.ts\\\`
- Feature directory: \\\`src/features/notifications/\\\`
- Cloud Function triggers for sending notifications
- Store preferences in Zustand + sync to Firestore

## Privacy (GDPR)
- Notification permission must be opt-in (not on first launch)
- User can disable all notifications from settings
- Token deleted on account deletion\`,
    subtasks: [
      { key: "APP-3a", title: "Set up expo-notifications config", status: "done" },
      { key: "APP-3b", title: "Implement permission request flow", status: "done" },
      { key: "APP-3c", title: "Handle foreground notification display", status: "in-progress" },
      { key: "APP-3d", title: "Implement deep linking from notifications", status: "todo" },
      { key: "APP-3e", title: "Build notification preferences screen", status: "todo" },
    ],
    comments: [],
  },
  "APP-4": {
    key: "APP-4",
    title: "Implement in-app purchase flow for premium subscription",
    type: "feature",
    status: "todo",
    priority: "medium",
    assignee: "unassigned",
    sprint: "Sprint 13",
    storyPoints: 13,
    labels: ["payments", "iap", "ios", "android", "revenue"],
    description: \`## Summary
Implement in-app purchase flow for monthly and annual premium subscriptions using expo-in-app-purchases.

## Acceptance Criteria
- [ ] Display subscription options (monthly $4.99, annual $39.99)
- [ ] Purchase flow with App Store / Google Play native UI
- [ ] Receipt validation via Cloud Function (server-side)
- [ ] Restore purchases functionality
- [ ] Subscription status synced to Firestore user document
- [ ] Graceful handling of purchase failures and cancellations
- [ ] Paywall screen with feature comparison

## Technical Notes
- Use \\\`expo-in-app-purchases\\\` or \\\`react-native-iap\\\`
- Server-side receipt validation in Cloud Functions
- Feature directory: \\\`src/features/payments/\\\`
- Zustand store for subscription state
- Must comply with App Store Guidelines Section 3.1
- Google Play billing library v6 requirements

## Compliance
- App Store: 30% commission, no external payment links
- Google Play: billing library required for digital goods
- GDPR: subscription data included in data export/deletion\`,
    subtasks: [],
    comments: [],
  },
  "APP-5": {
    key: "APP-5",
    title: "Add Sentry crash reporting and performance monitoring",
    type: "feature",
    status: "done",
    priority: "high",
    assignee: "dev-mid-2",
    sprint: "Sprint 11",
    storyPoints: 3,
    labels: ["monitoring", "sentry", "crash-reporting", "performance"],
    description: \`## Summary
Integrate Sentry for crash reporting, error tracking, and performance monitoring.

## Acceptance Criteria
- [x] Sentry SDK initialized on app start
- [x] Unhandled JS exceptions captured
- [x] Native crashes captured (iOS + Android)
- [x] Navigation performance traces
- [x] User context attached to events (anonymized ID)
- [x] Source maps uploaded during EAS Build
- [x] Staging and production environments separated

## Technical Notes
- Use \\\`@sentry/react-native\\\` with Expo plugin
- Config in \\\`app.config.ts\\\` Sentry plugin section
- Source map upload via \\\`sentry-expo\\\` EAS Build hook
- Performance tracing for React Navigation screens
- Strip PII from breadcrumbs (GDPR)\`,
    subtasks: [],
    comments: [
      {
        author: "dev-mid-2",
        date: "2024-10-28T16:00:00Z",
        body: "Completed. Source maps uploading correctly on EAS Build. Verified crash reports appearing in Sentry dashboard for both platforms.",
      },
    ],
  },
  "APP-6": {
    key: "APP-6",
    title: "Fix Android deep link not resolving on cold start",
    type: "bug",
    status: "todo",
    priority: "high",
    assignee: "dev-mid-1",
    sprint: "Sprint 12",
    storyPoints: 3,
    labels: ["bug", "android", "deep-linking", "navigation"],
    description: \`## Bug Report

### Description
Deep links on Android do not resolve to the correct screen when the app is in a killed state (cold start). Works correctly on iOS and when the Android app is backgrounded (warm start).

### Steps to Reproduce
1. Kill the app completely on Android
2. Open a deep link: \\\`myapp://profile/settings\\\`
3. App opens to home screen instead of profile settings

### Expected Behavior
App should navigate to the profile settings screen.

### Actual Behavior
App opens to the home screen. The deep link URL is lost during the cold start initialization.

### Technical Analysis
- Likely issue: \\\`Linking.getInitialURL()\\\` called before React Navigation is mounted
- The navigation ref may not be ready when the initial URL is processed
- Need to queue the initial URL and process after navigation is ready

### Environment
- React Native 0.74, Expo SDK 51
- React Navigation v6
- Android 13+ (API 33)
- Tested on Pixel 7 and Samsung S23\`,
    subtasks: [],
    comments: [
      {
        author: "dev-senior-1",
        date: "2024-11-04T11:00:00Z",
        body: "This is a known pattern with React Navigation. Use \`isReadyRef\` and queue the URL. See: https://reactnavigation.org/docs/deep-linking/#third-party-integrations",
      },
    ],
  },
  "APP-7": {
    key: "APP-7",
    title: "Set up EAS Build profiles for staging and production",
    type: "chore",
    status: "done",
    priority: "critical",
    assignee: "dev-lead-1",
    sprint: "Sprint 11",
    storyPoints: 5,
    labels: ["ci-cd", "eas", "build", "devops"],
    description: \`## Summary
Configure EAS Build with separate profiles for development, staging, and production builds.

## Acceptance Criteria
- [x] Development profile: internal distribution, debug mode
- [x] Staging profile: internal distribution, release mode, staging Firebase
- [x] Production profile: store distribution, release mode, production Firebase
- [x] EAS Update channels configured per profile
- [x] Environment variables injected per profile
- [x] Code signing configured (iOS provisioning, Android keystore)
- [x] GitHub Actions workflow triggers EAS Build on PR merge to main

## Technical Notes
- \\\`eas.json\\\` with development, staging, production profiles
- \\\`app.config.ts\\\` reads EAS profile for dynamic config
- Firebase config swapped via build profile (google-services.json variants)
- EAS Secrets for sensitive env vars (API keys, signing creds)\`,
    subtasks: [],
    comments: [],
  },
  "APP-8": {
    key: "APP-8",
    title: "Implement i18n with react-i18next for English and Spanish",
    type: "feature",
    status: "in-progress",
    priority: "medium",
    assignee: "dev-junior-1",
    sprint: "Sprint 12",
    storyPoints: 5,
    labels: ["i18n", "localization", "accessibility"],
    description: \`## Summary
Set up internationalization framework and translate all user-facing strings to English (default) and Spanish.

## Acceptance Criteria
- [ ] react-i18next configured with language detection
- [ ] All hardcoded strings extracted to translation files
- [ ] English (en) and Spanish (es) translation files
- [ ] Language switcher in profile settings
- [ ] RTL layout support foundation (for future Arabic/Hebrew)
- [ ] Date/number formatting respects locale
- [ ] Pluralization rules working

## Technical Notes
- Use \\\`react-i18next\\\` with \\\`i18next\\\`
- Translation files in \\\`src/i18n/locales/{lang}.json\\\`
- Namespace per feature: \\\`auth.json\\\`, \\\`home.json\\\`, \\\`profile.json\\\`
- Detect device locale via \\\`expo-localization\\\`
- Store language preference in Zustand + AsyncStorage
- All \\\`<Text>\\\` components must use \\\`t()\\\` function\`,
    subtasks: [
      { key: "APP-8a", title: "Set up react-i18next config", status: "done" },
      { key: "APP-8b", title: "Extract strings from auth feature", status: "done" },
      { key: "APP-8c", title: "Extract strings from home feature", status: "in-progress" },
      { key: "APP-8d", title: "Extract strings from profile feature", status: "todo" },
      { key: "APP-8e", title: "Add Spanish translations", status: "todo" },
      { key: "APP-8f", title: "Build language switcher component", status: "todo" },
    ],
    comments: [],
  },
  "APP-9": {
    key: "APP-9",
    title: "Add accessibility labels and screen reader support",
    type: "feature",
    status: "todo",
    priority: "medium",
    assignee: "dev-junior-1",
    sprint: "Sprint 13",
    storyPoints: 5,
    labels: ["accessibility", "a11y", "ios", "android"],
    description: \`## Summary
Audit and improve accessibility across the app. All interactive elements must have proper labels, roles, and hints.

## Acceptance Criteria
- [ ] All \\\`TouchableOpacity\\\`/\\\`Pressable\\\` have \\\`accessibilityLabel\\\`
- [ ] All \\\`Image\\\` components have \\\`accessibilityLabel\\\` or \\\`accessible={false}\\\`
- [ ] Form inputs have \\\`accessibilityLabel\\\` and \\\`accessibilityHint\\\`
- [ ] Screen reader navigation order is logical
- [ ] Dynamic content announces changes via \\\`AccessibilityInfo\\\`
- [ ] Minimum touch target size: 44x44pt
- [ ] Color contrast meets WCAG AA (4.5:1 for text)
- [ ] VoiceOver (iOS) and TalkBack (Android) tested

## Technical Notes
- Use \\\`accessibilityRole\\\`, \\\`accessibilityState\\\`, \\\`accessibilityValue\\\`
- Add \\\`accessibilityLabel\\\` through i18n: \\\`t('a11y.loginButton')\\\`
- Test with Accessibility Inspector (Xcode) and Accessibility Scanner (Android)
- Add a11y checks to component test suite\`,
    subtasks: [],
    comments: [],
  },
  "APP-10": {
    key: "APP-10",
    title: "Upgrade Expo SDK from 50 to 51",
    type: "chore",
    status: "done",
    priority: "critical",
    assignee: "dev-senior-2",
    sprint: "Sprint 11",
    storyPoints: 8,
    labels: ["upgrade", "expo", "maintenance"],
    description: \`## Summary
Upgrade from Expo SDK 50 to SDK 51 for React Native 0.74 support and new architecture readiness.

## Acceptance Criteria
- [x] Expo SDK 51 installed and configured
- [x] All Expo packages updated to SDK 51 compatible versions
- [x] React Native 0.74 running on both platforms
- [x] All native modules verified working
- [x] EAS Build succeeds for iOS and Android
- [x] No regressions in existing functionality
- [x] TypeScript types updated

## Completed Notes
- Ran \\\`npx expo install --fix\\\` to align package versions
- Updated \\\`app.config.ts\\\` for SDK 51 changes
- Rebuilt native projects with \\\`npx expo prebuild --clean\\\`
- WatermelonDB JSI adapter required recompilation
- All 247 unit tests passing, E2E suite green\`,
    subtasks: [],
    comments: [],
  },
};

const MOCK_SPRINTS = {
  "Sprint 11": {
    name: "Sprint 11",
    status: "completed",
    startDate: "2024-10-21",
    endDate: "2024-11-01",
    goal: "Foundation: SDK upgrade, monitoring, CI/CD pipeline",
    tickets: ["APP-5", "APP-7", "APP-10"],
  },
  "Sprint 12": {
    name: "Sprint 12",
    status: "active",
    startDate: "2024-11-04",
    endDate: "2024-11-15",
    goal: "Core features: auth, offline sync, notifications, i18n",
    tickets: ["APP-1", "APP-2", "APP-3", "APP-6", "APP-8"],
  },
  "Sprint 13": {
    name: "Sprint 13",
    status: "planned",
    startDate: "2024-11-18",
    endDate: "2024-11-29",
    goal: "Monetization and polish: IAP, accessibility, performance",
    tickets: ["APP-4", "APP-9"],
  },
};

const server = new Server(
  {
    name: "react-native-mobile-app-tickets",
    version: "1.0.0",
  },
  {
    capabilities: {
      tools: {},
    },
  },
);

server.setRequestHandler(ListToolsRequestSchema, async () => ({
  tools: [
    {
      name: "get_ticket",
      description:
        "Look up a ticket by key (e.g., APP-42). Returns title, description, status, subtasks, and comments for the react-native-mobile-app project.",
      inputSchema: {
        type: "object",
        properties: {
          ticket_key: {
            type: "string",
            description: "Ticket key, e.g. APP-1, APP-42",
          },
        },
        required: ["ticket_key"],
      },
    },
    {
      name: "search_tickets",
      description:
        "Search tickets by status, label, assignee, or free-text query. Returns matching tickets from the react-native-mobile-app project.",
      inputSchema: {
        type: "object",
        properties: {
          status: {
            type: "string",
            enum: ["todo", "in-progress", "done", "all"],
            description: "Filter by ticket status",
          },
          label: {
            type: "string",
            description: "Filter by label (e.g., auth, offline, android, bug)",
          },
          assignee: {
            type: "string",
            description: "Filter by assignee identifier",
          },
          query: {
            type: "string",
            description: "Free-text search in title and description",
          },
          type: {
            type: "string",
            enum: ["feature", "bug", "chore", "all"],
            description: "Filter by ticket type",
          },
        },
      },
    },
    {
      name: "get_sprint",
      description:
        "Get sprint details including goal, dates, status, and associated tickets.",
      inputSchema: {
        type: "object",
        properties: {
          sprint_name: {
            type: "string",
            description: "Sprint name, e.g. 'Sprint 12' or 'current' for active sprint",
          },
        },
        required: ["sprint_name"],
      },
    },
    {
      name: "update_ticket_status",
      description:
        "Update the status of a ticket (simulated — logs the change but does not persist).",
      inputSchema: {
        type: "object",
        properties: {
          ticket_key: {
            type: "string",
            description: "Ticket key, e.g. APP-1",
          },
          new_status: {
            type: "string",
            enum: ["todo", "in-progress", "in-review", "done"],
            description: "New status for the ticket",
          },
        },
        required: ["ticket_key", "new_status"],
      },
    },
    {
      name: "add_comment",
      description:
        "Add a comment to a ticket (simulated — logs the comment but does not persist).",
      inputSchema: {
        type: "object",
        properties: {
          ticket_key: {
            type: "string",
            description: "Ticket key, e.g. APP-1",
          },
          body: {
            type: "string",
            description: "Comment text (supports markdown)",
          },
          author: {
            type: "string",
            description: "Author identifier (defaults to 'claude-assistant')",
          },
        },
        required: ["ticket_key", "body"],
      },
    },
  ],
}));

server.setRequestHandler(CallToolRequestSchema, async (request) => {
  const { name, arguments: args } = request.params;

  switch (name) {
    case "get_ticket": {
      const key = args.ticket_key?.toUpperCase();
      const ticket = MOCK_TICKETS[key];

      if (!ticket) {
        return {
          content: [
            {
              type: "text",
              text: JSON.stringify(
                {
                  error: "not_found",
                  message: \`Ticket \${key} not found. Available tickets: \${Object.keys(MOCK_TICKETS).join(", ")}\`,
                },
                null,
                2,
              ),
            },
          ],
        };
      }

      return {
        content: [
          {
            type: "text",
            text: JSON.stringify(ticket, null, 2),
          },
        ],
      };
    }

    case "search_tickets": {
      let results = Object.values(MOCK_TICKETS);

      if (args.status && args.status !== "all") {
        results = results.filter((t) => t.status === args.status);
      }

      if (args.type && args.type !== "all") {
        results = results.filter((t) => t.type === args.type);
      }

      if (args.label) {
        const label = args.label.toLowerCase();
        results = results.filter((t) =>
          t.labels.some((l) => l.toLowerCase().includes(label)),
        );
      }

      if (args.assignee) {
        const assignee = args.assignee.toLowerCase();
        results = results.filter((t) =>
          t.assignee.toLowerCase().includes(assignee),
        );
      }

      if (args.query) {
        const query = args.query.toLowerCase();
        results = results.filter(
          (t) =>
            t.title.toLowerCase().includes(query) ||
            t.description.toLowerCase().includes(query),
        );
      }

      const summary = results.map((t) => ({
        key: t.key,
        title: t.title,
        type: t.type,
        status: t.status,
        priority: t.priority,
        assignee: t.assignee,
        storyPoints: t.storyPoints,
        labels: t.labels,
      }));

      return {
        content: [
          {
            type: "text",
            text: JSON.stringify(
              {
                total: summary.length,
                tickets: summary,
              },
              null,
              2,
            ),
          },
        ],
      };
    }

    case "get_sprint": {
      let sprintName = args.sprint_name;

      if (sprintName === "current") {
        const activeSprint = Object.values(MOCK_SPRINTS).find(
          (s) => s.status === "active",
        );
        if (!activeSprint) {
          return {
            content: [
              {
                type: "text",
                text: JSON.stringify({
                  error: "not_found",
                  message: "No active sprint found.",
                }),
              },
            ],
          };
        }
        sprintName = activeSprint.name;
      }

      const sprint = MOCK_SPRINTS[sprintName];

      if (!sprint) {
        return {
          content: [
            {
              type: "text",
              text: JSON.stringify(
                {
                  error: "not_found",
                  message: \`Sprint "\${sprintName}" not found. Available: \${Object.keys(MOCK_SPRINTS).join(", ")}\`,
                },
                null,
                2,
              ),
            },
          ],
        };
      }

      const sprintTickets = sprint.tickets.map((key) => {
        const ticket = MOCK_TICKETS[key];
        return ticket
          ? {
              key: ticket.key,
              title: ticket.title,
              type: ticket.type,
              status: ticket.status,
              priority: ticket.priority,
              assignee: ticket.assignee,
              storyPoints: ticket.storyPoints,
            }
          : { key, error: "ticket not found" };
      });

      const totalPoints = sprintTickets.reduce(
        (sum, t) => sum + (t.storyPoints || 0),
        0,
      );
      const completedPoints = sprintTickets
        .filter((t) => t.status === "done")
        .reduce((sum, t) => sum + (t.storyPoints || 0), 0);

      return {
        content: [
          {
            type: "text",
            text: JSON.stringify(
              {
                ...sprint,
                tickets: sprintTickets,
                metrics: {
                  totalPoints,
                  completedPoints,
                  remainingPoints: totalPoints - completedPoints,
                  completionPercentage:
                    totalPoints > 0
                      ? Math.round((completedPoints / totalPoints) * 100)
                      : 0,
                },
              },
              null,
              2,
            ),
          },
        ],
      };
    }

    case "update_ticket_status": {
      const key = args.ticket_key?.toUpperCase();
      const ticket = MOCK_TICKETS[key];

      if (!ticket) {
        return {
          content: [
            {
              type: "text",
              text: JSON.stringify({
                error: "not_found",
                message: \`Ticket \${key} not found.\`,
              }),
            },
          ],
        };
      }

      const previousStatus = ticket.status;
      // Simulate the update (in-memory only for this mock)
      ticket.status = args.new_status;

      return {
        content: [
          {
            type: "text",
            text: JSON.stringify(
              {
                success: true,
                mock: true,
                message: \`[MOCK] Ticket \${key} status updated: \${previousStatus} → \${args.new_status}\`,
                ticket: {
                  key: ticket.key,
                  title: ticket.title,
                  previousStatus,
                  newStatus: args.new_status,
                },
              },
              null,
              2,
            ),
          },
        ],
      };
    }

    case "add_comment": {
      const key = args.ticket_key?.toUpperCase();
      const ticket = MOCK_TICKETS[key];

      if (!ticket) {
        return {
          content: [
            {
              type: "text",
              text: JSON.stringify({
                error: "not_found",
                message: \`Ticket \${key} not found.\`,
              }),
            },
          ],
        };
      }

      const comment = {
        author: args.author || "claude-assistant",
        date: new Date().toISOString(),
        body: args.body,
      };

      // Simulate adding the comment (in-memory only)
      ticket.comments.push(comment);

      return {
        content: [
          {
            type: "text",
            text: JSON.stringify(
              {
                success: true,
                mock: true,
                message: \`[MOCK] Comment added to \${key}\`,
                comment,
              },
              null,
              2,
            ),
          },
        ],
      };
    }

    default:
      return {
        content: [
          {
            type: "text",
            text: JSON.stringify({
              error: "unknown_tool",
              message: \`Tool "\${name}" is not implemented. Available tools: get_ticket, search_tickets, get_sprint, update_ticket_status, add_comment\`,
            }),
          },
        ],
      };
  }
});

async function main() {
  const transport = new StdioServerTransport();
  await server.connect(transport);
  console.error("Mock ticket server (react-native-mobile-app) running on stdio");
}

main().catch((error) => {
  console.error("Failed to start mock ticket server:", error);
  process.exit(1);
});`,

  'mock-mcp-servers/package.json': `{
  "name": "@react-native-mobile-app/mock-mcp-servers",
  "version": "0.1.0",
  "private": true,
  "description": "Mock MCP servers for local development and testing of Claude Code integrations",
  "type": "module",
  "engines": {
    "node": ">=20.0.0",
    "pnpm": ">=9.0.0"
  },
  "scripts": {
    "dev": "concurrently \\"pnpm run dev:github\\" \\"pnpm run dev:firebase\\" \\"pnpm run dev:sentry\\" \\"pnpm run dev:slack\\"",
    "dev:github": "tsx watch src/github-server.ts",
    "dev:firebase": "tsx watch src/firebase-server.ts",
    "dev:sentry": "tsx watch src/sentry-server.ts",
    "dev:slack": "tsx watch src/slack-server.ts",
    "build": "tsc --project tsconfig.json",
    "start": "node dist/index.js",
    "start:github": "node dist/github-server.js",
    "start:firebase": "node dist/firebase-server.js",
    "start:sentry": "node dist/sentry-server.js",
    "start:slack": "node dist/slack-server.js",
    "test": "jest --config jest.config.js",
    "lint": "eslint src/ --ext .ts",
    "typecheck": "tsc --noEmit"
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.0.0",
    "zod": "^3.23.8"
  },
  "devDependencies": {
    "@types/node": "^20.14.0",
    "concurrently": "^8.2.2",
    "eslint": "^8.57.0",
    "jest": "^29.7.0",
    "ts-jest": "^29.1.4",
    "tsx": "^4.15.0",
    "typescript": "^5.4.5"
  }
}`,

  'package.json': `{
  "name": "react-native-mobile-app",
  "version": "1.0.0",
  "private": true,
  "description": "Cross-platform mobile application with React Native, Expo SDK 51, Firebase backend, offline-first architecture, and native performance",
  "main": "expo-router/entry",
  "scripts": {
    "start": "npx expo start",
    "start:dev": "npx expo start --dev-client",
    "start:clear": "npx expo start --clear",
    "android": "npx expo run:android",
    "ios": "npx expo run:ios",
    "web": "npx expo start --web",
    "prebuild": "npx expo prebuild",
    "prebuild:clean": "npx expo prebuild --clean",
    "lint": "eslint 'src/**/*.{ts,tsx}' 'e2e/**/*.{ts,tsx}' --max-warnings 0",
    "lint:fix": "eslint 'src/**/*.{ts,tsx}' --fix",
    "format": "prettier --write 'src/**/*.{ts,tsx,json}' '*.{json,js,md}'",
    "format:check": "prettier --check 'src/**/*.{ts,tsx,json}'",
    "typecheck": "tsc --noEmit",
    "test": "jest --passWithNoTests",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage --passWithNoTests",
    "test:ci": "jest --ci --coverage --maxWorkers=2 --passWithNoTests",
    "e2e:build:ios": "npx detox build --configuration ios.sim.debug",
    "e2e:build:android": "npx detox build --configuration android.emu.debug",
    "e2e:test:ios": "npx detox test --configuration ios.sim.debug",
    "e2e:test:android": "npx detox test --configuration android.emu.debug",
    "e2e:test:ci:ios": "npx detox test --configuration ios.sim.release --cleanup --headless",
    "e2e:test:ci:android": "npx detox test --configuration android.emu.release --cleanup --headless",
    "eas:build:dev": "eas build --profile development",
    "eas:build:staging": "eas build --profile preview",
    "eas:build:production": "eas build --profile production",
    "eas:build:ios:staging": "eas build --platform ios --profile preview",
    "eas:build:android:staging": "eas build --platform android --profile preview",
    "eas:build:ios:production": "eas build --platform ios --profile production",
    "eas:build:android:production": "eas build --platform android --profile production",
    "eas:update:staging": "eas update --branch staging --message",
    "eas:update:production": "eas update --branch production --message",
    "eas:submit:ios": "eas submit --platform ios",
    "eas:submit:android": "eas submit --platform android",
    "db:generate": "node scripts/watermelondb-generate-schema.js",
    "postinstall": "npx expo install --check",
    "prepare": "node -e \\"try { require('husky').install() } catch (e) { if (e.code !== 'MODULE_NOT_FOUND') throw e }\\"",
    "clean": "rm -rf node_modules ios android .expo dist",
    "clean:cache": "npx expo start --clear && watchman watch-del-all",
    "doctor": "npx expo-doctor"
  },
  "dependencies": {
    "@expo/vector-icons": "^14.0.2",
    "@nozbe/watermelondb": "^0.27.1",
    "@react-native-async-storage/async-storage": "1.23.1",
    "@react-native-community/netinfo": "11.3.1",
    "@react-native-firebase/analytics": "^20.1.0",
    "@react-native-firebase/app": "^20.1.0",
    "@react-native-firebase/auth": "^20.1.0",
    "@react-native-firebase/crashlytics": "^20.1.0",
    "@react-native-firebase/firestore": "^20.1.0",
    "@react-native-firebase/functions": "^20.1.0",
    "@react-native-firebase/messaging": "^20.1.0",
    "@react-native-firebase/storage": "^20.1.0",
    "@react-navigation/bottom-tabs": "^6.5.20",
    "@react-navigation/native": "^6.1.18",
    "@react-navigation/native-stack": "^6.9.26",
    "@sentry/react-native": "^5.24.1",
    "@tanstack/react-query": "^5.51.1",
    "date-fns": "^3.6.0",
    "expo": "~51.0.22",
    "expo-application": "~5.9.1",
    "expo-constants": "~16.0.2",
    "expo-crypto": "~13.0.2",
    "expo-device": "~6.0.2",
    "expo-font": "~12.0.9",
    "expo-haptics": "~13.0.1",
    "expo-image": "~1.12.13",
    "expo-linking": "~6.3.1",
    "expo-local-authentication": "~14.0.1",
    "expo-localization": "~15.0.3",
    "expo-notifications": "~0.28.14",
    "expo-router": "~3.5.20",
    "expo-secure-store": "~13.0.2",
    "expo-splash-screen": "~0.27.5",
    "expo-status-bar": "~1.12.1",
    "expo-updates": "~0.25.22",
    "i18next": "^23.11.5",
    "react": "18.2.0",
    "react-i18next": "^14.1.2",
    "react-native": "0.74.3",
    "react-native-config": "^1.5.2",
    "react-native-gesture-handler": "~2.16.2",
    "react-native-iap": "^12.13.2",
    "react-native-reanimated": "~3.10.1",
    "react-native-safe-area-context": "4.10.5",
    "react-native-screens": "3.31.1",
    "react-native-svg": "15.2.0",
    "zod": "^3.23.8",
    "zustand": "^4.5.4"
  },
  "devDependencies": {
    "@babel/core": "^7.24.7",
    "@babel/plugin-proposal-decorators": "^7.24.7",
    "@expo/config-plugins": "~8.0.7",
    "@nozbe/with-observables": "^1.6.0",
    "@testing-library/jest-native": "^5.4.3",
    "@testing-library/react-native": "^12.5.1",
    "@types/jest": "^29.5.12",
    "@types/react": "~18.2.79",
    "@types/react-native": "^0.73.0",
    "@typescript-eslint/eslint-plugin": "^7.16.0",
    "@typescript-eslint/parser": "^7.16.0",
    "detox": "^20.25.3",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-react": "^7.34.3",
    "eslint-plugin-react-hooks": "^4.6.2",
    "eslint-plugin-react-native": "^4.1.0",
    "eslint-plugin-testing-library": "^6.2.2",
    "husky": "^9.0.11",
    "jest": "^29.7.0",
    "jest-expo": "~51.0.3",
    "lint-staged": "^15.2.7",
    "prettier": "^3.3.3",
    "react-native-dotenv": "^3.4.11",
    "react-test-renderer": "18.2.0",
    "typescript": "~5.3.3"
  },
  "lint-staged": {
    "*.{ts,tsx}": [
      "eslint --fix --max-warnings 0",
      "prettier --write"
    ],
    "*.{json,md,yml,yaml}": [
      "prettier --write"
    ]
  },
  "jest": {
    "preset": "jest-expo",
    "setupFilesAfterSetup": [
      "@testing-library/jest-native/extend-expect"
    ],
    "transformIgnorePatterns": [
      "node_modules/(?!((jest-)?react-native|@react-native(-community)?)|expo(nent)?|@expo(nent)?/.*|@expo-google-fonts/.*|react-navigation|@react-navigation/.*|@sentry/react-native|@nozbe/watermelondb|@tanstack/react-query|zustand)"
    ],
    "moduleFileExtensions": [
      "ts",
      "tsx",
      "js",
      "jsx"
    ],
    "moduleNameMapper": {
      "^@/(.*)$": "<rootDir>/src/$1",
      "^@features/(.*)$": "<rootDir>/src/features/$1",
      "^@components/(.*)$": "<rootDir>/src/components/$1",
      "^@hooks/(.*)$": "<rootDir>/src/hooks/$1",
      "^@services/(.*)$": "<rootDir>/src/services/$1",
      "^@navigation/(.*)$": "<rootDir>/src/navigation/$1",
      "^@store/(.*)$": "<rootDir>/src/store/$1",
      "^@utils/(.*)$": "<rootDir>/src/utils/$1",
      "^@theme/(.*)$": "<rootDir>/src/theme/$1",
      "^@i18n/(.*)$": "<rootDir>/src/i18n/$1",
      "^@assets/(.*)$": "<rootDir>/src/assets/$1"
    },
    "collectCoverageFrom": [
      "src/**/*.{ts,tsx}",
      "!src/**/*.d.ts",
      "!src/**/*.stories.{ts,tsx}",
      "!src/**/types.ts",
      "!src/**/index.ts",
      "!src/i18n/locales/**"
    ],
    "coverageThreshold": {
      "global": {
        "branches": 75,
        "functions": 75,
        "lines": 75,
        "statements": 75
      }
    }
  },
  "detox": {
    "testRunner": {
      "args": {
        "$0": "jest",
        "config": "e2e/jest.config.js"
      },
      "jest": {
        "setupTimeout": 120000
      }
    },
    "apps": {
      "ios.debug": {
        "type": "ios.app",
        "binaryPath": "ios/build/Build/Products/Debug-iphonesimulator/ReactNativeMobileApp.app",
        "build": "xcodebuild -workspace ios/ReactNativeMobileApp.xcworkspace -scheme ReactNativeMobileApp -configuration Debug -sdk iphonesimulator -derivedDataPath ios/build"
      },
      "ios.release": {
        "type": "ios.app",
        "binaryPath": "ios/build/Build/Products/Release-iphonesimulator/ReactNativeMobileApp.app",
        "build": "xcodebuild -workspace ios/ReactNativeMobileApp.xcworkspace -scheme ReactNativeMobileApp -configuration Release -sdk iphonesimulator -derivedDataPath ios/build"
      },
      "android.debug": {
        "type": "android.apk",
        "binaryPath": "android/app/build/outputs/apk/debug/app-debug.apk",
        "build": "cd android && ./gradlew assembleDebug assembleAndroidTest -DtestBuildType=debug"
      },
      "android.release": {
        "type": "android.apk",
        "binaryPath": "android/app/build/outputs/apk/release/app-release.apk",
        "build": "cd android && ./gradlew assembleRelease assembleAndroidTest -DtestBuildType=release"
      }
    },
    "devices": {
      "simulator": {
        "type": "ios.simulator",
        "device": {
          "type": "iPhone 15"
        }
      },
      "emulator": {
        "type": "android.emulator",
        "device": {
          "avdName": "Pixel_7_API_34"
        }
      }
    },
    "configurations": {
      "ios.sim.debug": {
        "device": "simulator",
        "app": "ios.debug"
      },
      "ios.sim.release": {
        "device": "simulator",
        "app": "ios.release"
      },
      "android.emu.debug": {
        "device": "emulator",
        "app": "android.debug"
      },
      "android.emu.release": {
        "device": "emulator",
        "app": "android.release"
      }
    }
  },
  "packageManager": "pnpm@9.4.0",
  "engines": {
    "node": ">=18.0.0",
    "pnpm": ">=9.0.0"
  },
  "expo": {
    "install": {
      "exclude": [
        "react-native-iap",
        "react-native-config"
      ]
    }
  }
}`,

  'playbook/PLAYBOOK.md': `# React Native Mobile App — Development Playbook

> A structured 7-phase methodology for building, shipping, and maintaining a cross-platform mobile application with React Native, Expo, and Firebase.

## Purpose

This playbook defines the end-to-end development lifecycle for the \`react-native-mobile-app\` project. Each phase has clear entry criteria, activities, deliverables, exit criteria, and quality gates. Phases are sequential but iterative — you can loop back when requirements change or issues surface.

Every team member — from junior developers to leads — follows this playbook. Claude Code assists at every phase through the [CodeForge plugin](../plugin/codeforge-react-native/.claude-plugin/plugin.json) with dedicated agents, commands, and skills.

---

## Phase Overview

| # | Phase | Focus | Key Deliverable | Claude Command |
|---|-------|-------|-----------------|----------------|
| 1 | [Plan](#phase-1-plan) | Requirements, scope, tickets | Implementation plan with task breakdown | \`/plan\` |
| 2 | [Architect](#phase-2-architect) | System design, data model, navigation | Architecture Decision Records (ADRs) | \`/phase architect\` |
| 3 | [Implement](#phase-3-implement) | Feature development with TDD | Working feature code with tests | \`/tdd\` |
| 4 | [Review](#phase-4-review) | Code review, quality checks | Approved PR ready to merge | \`/code-review\` |
| 5 | [Verify](#phase-5-verify) | Integration testing, E2E, device testing | Verified build on staging | \`/verify\` |
| 6 | [Ship](#phase-6-ship) | Build, submit, release | App published to stores | \`/phase ship\` |
| 7 | [Operate](#phase-7-operate) | Monitor, triage, iterate | Stable production app | \`/phase operate\` |

---

## Phase 1: Plan

**Goal**: Transform a feature request or bug report into a concrete, estimable implementation plan with clear acceptance criteria.

### Entry Criteria
- GitHub Issue exists with description and priority label
- Product requirements or user story is documented
- Relevant stakeholders have been consulted

### Activities

1. **Analyze Requirements**
   - Parse the GitHub Issue for functional and non-functional requirements
   - Identify affected features under \`src/features/\`
   - Determine platform-specific considerations (iOS vs Android)
   - Check for offline-first implications (WatermelonDB sync)
   - Assess GDPR / App Store / Google Play compliance impact

2. **Scope the Work**
   - Break the feature into tasks (max 4 hours each)
   - Identify dependencies on native modules, Firebase services, or third-party SDKs
   - Flag tasks requiring both iOS and Android implementations
   - Estimate complexity: S (< 2h), M (2-4h), L (4-8h), XL (needs decomposition)

3. **Define Acceptance Criteria**
   - Write testable acceptance criteria for each task
   - Include accessibility requirements (labels, screen reader behavior)
   - Include i18n requirements (all user-facing text through \`src/i18n/\`)
   - Specify offline behavior expectations
   - Define deep linking routes if applicable

4. **Create Implementation Plan**
   - Order tasks by dependency graph
   - Assign to feature directory structure: \`screens/\`, \`components/\`, \`hooks/\`, \`types/\`
   - Identify shared components needed in \`src/components/\`
   - List navigation changes in \`src/navigation/\`
   - Document API contracts (Firebase Cloud Functions, Firestore collections)

### Claude Integration
\`\`\`
/plan
\`\`\`
The planner agent reads the GitHub Issue, analyzes the codebase, and generates a structured implementation plan with file-level task breakdown.

### Deliverables
- [ ] Implementation plan (markdown in PR description or linked doc)
- [ ] Task breakdown with estimates in GitHub Issues
- [ ] Acceptance criteria per task
- [ ] Risk assessment (native module compatibility, platform differences)

### Exit Criteria
- Plan reviewed and approved by at least one senior/lead developer
- All tasks have clear acceptance criteria
- No XL tasks remain (all decomposed to L or smaller)
- Platform-specific work identified for both iOS and Android

---

## Phase 2: Architect

**Goal**: Design the technical solution — data models, navigation flows, state management, and API contracts — before writing feature code.

### Entry Criteria
- Phase 1 plan is approved
- Feature scope is locked (no open questions)

### Activities

1. **Data Model Design**
   - Define Firestore collection schemas and security rules
   - Design WatermelonDB table schemas for offline storage
   - Plan sync strategy (conflict resolution, delta sync)
   - Document TypeScript interfaces in feature \`types/\` directory

2. **Navigation Design**
   - Define screen hierarchy and navigator nesting
   - Type all route params with React Navigation types
   - Plan deep linking configuration in \`src/navigation/linking.ts\`
   - Design modal flows and bottom sheet interactions

3. **State Architecture**
   - Decide what goes in Zustand (client state) vs React Query (server state)
   - Design cache invalidation strategy for React Query
   - Plan optimistic updates for offline-first operations
   - Define Zustand store slices if new stores are needed

4. **API Contract Design**
   - Define Firebase Cloud Function signatures
   - Document request/response types
   - Plan error handling and retry strategies
   - Design push notification payload structures if applicable

5. **Security & Privacy Review**
   - Review data flow for GDPR compliance (consent, data deletion paths)
   - Plan secure storage usage (Keychain on iOS, Keystore on Android)
   - Assess need for certificate pinning on new endpoints
   - Update App Store privacy labels / Google Play data safety if data collection changes

6. **Architecture Decision Records**
   - Document significant decisions in \`docs/adr/\`
   - Include context, decision, consequences, and alternatives considered
   - Reference relevant patterns from \`docs/ARCHITECTURE.md\`

### Claude Integration
\`\`\`
/phase architect
\`\`\`
The architect agent analyzes the plan and existing codebase to propose data models, navigation structure, and state management patterns.

### Deliverables
- [ ] TypeScript interfaces for new data models
- [ ] Navigation flow diagram or description
- [ ] State management plan (which stores, which queries)
- [ ] API contracts (Cloud Function signatures)
- [ ] ADR for any significant architectural decisions
- [ ] Security/privacy impact assessment

### Exit Criteria
- Architecture reviewed by lead developer
- TypeScript interfaces compile without errors
- No unresolved questions about data flow
- Offline sync strategy documented
- Security review completed for sensitive features (auth, payments)

---

## Phase 3: Implement

**Goal**: Build the feature using Test-Driven Development, following the project's feature-based architecture and coding standards.

### Entry Criteria
- Phase 2 architecture is approved
- TypeScript interfaces are defined
- Developer has local environment running (\`npx expo start\`)

### Activities

1. **Branch Setup**
   \`\`\`bash
   git checkout -b feat/APP-42-add-push-notifications
   \`\`\`
   Follow naming convention: \`type/ticket-desc\`

2. **TDD Red-Green-Refactor Cycle**

   For each task in the implementation plan:

   a. **Red** — Write failing tests first
   - Unit tests for hooks and utilities (Jest)
   - Component tests for UI (React Native Testing Library)
   - Define expected behavior from acceptance criteria

   b. **Green** — Write minimal code to pass
   - Implement in the correct feature directory
   - Follow file naming: kebab-case for files, PascalCase for components
   - Keep files under 250 lines
   - All text through \`src/i18n/\`
   - Accessibility labels on all interactive elements

   c. **Refactor** — Clean up while tests stay green
   - Extract shared logic to \`src/hooks/\` or \`src/utils/\`
   - Extract shared UI to \`src/components/\`
   - Ensure TypeScript strict mode compliance (no \`any\`)

3. **Platform-Specific Implementation**
   - Test on both iOS Simulator and Android Emulator
   - Use \`Platform.select()\` or \`.ios.ts\` / \`.android.ts\` files for platform differences
   - Native modules must have both platform implementations
   - Use Expo Modules API for custom native code

4. **Offline-First Implementation**
   - Implement WatermelonDB models and migrations
   - Set up sync with Firestore using the project's sync adapter
   - Test offline scenarios: airplane mode, slow network, sync conflicts
   - Implement optimistic UI updates

5. **Commit Discipline**
   \`\`\`bash
   git commit -m "feat(notifications): add push notification permission flow"
   git commit -m "test(notifications): add unit tests for notification hooks"
   git commit -m "fix(notifications): handle denied permission on Android 13+"
   \`\`\`
   Use conventional commits. Each commit should be atomic and buildable.

### Claude Integration
\`\`\`
/tdd
\`\`\`
The TDD guide agent walks through the red-green-refactor cycle, generates test scaffolds, and ensures coverage meets the 75% threshold.

### Coding Standards Checklist
- [ ] TypeScript strict mode — no \`any\`, no \`@ts-ignore\`
- [ ] ESLint clean — \`pnpm lint\` passes
- [ ] Prettier formatted — \`pnpm format:check\` passes
- [ ] Files under 250 lines
- [ ] PascalCase components, camelCase hooks/utils, kebab-case files, SCREAMING_SNAKE_CASE constants
- [ ] All text through i18n
- [ ] Accessibility labels on interactive elements
- [ ] No hardcoded secrets or API keys
- [ ] Test coverage ≥ 75% for new code

### Deliverables
- [ ] Feature code in \`src/features/<feature>/\`
- [ ] Unit and component tests passing
- [ ] Both iOS and Android tested locally
- [ ] Offline scenarios tested
- [ ] Conventional commits with clean history

### Exit Criteria
- All tests pass: \`pnpm test\`
- Type check passes: \`pnpm typecheck\`
- Lint passes: \`pnpm lint\`
- Coverage threshold met: ≥ 75%
- Feature works on both iOS Simulator and Android Emulator
- Offline behavior verified

---

## Phase 4: Review

**Goal**: Ensure code quality, correctness, security, and adherence to project standards through thorough peer review.

### Entry Criteria
- Phase 3 implementation is complete
- All CI checks pass (lint, typecheck, tests, build)
- PR is opened with description linking to GitHub Issue

### Activities

1. **Self-Review**
   - Re-read every changed file
   - Verify no debug code, console.logs, or TODO hacks remain
   - Check that AI-generated code is marked with \`// AI-generated\` comments
   - Ensure sensitive paths haven't been modified without justification:
     - \`src/services/auth/**\`
     - \`src/config/**\`
     - \`google-services.json\`, \`GoogleService-Info.plist\`
     - \`.env*\` files

2. **Automated Review**
   - CI pipeline runs: lint → typecheck → unit tests → component tests → EAS build
   - AI code audit workflow flags AI-generated patterns
   - CODEOWNERS automatically assigns reviewers

3. **Peer Review**
   - At least 1 approval required
   - Reviewer checks:
     - Correctness: Does it match acceptance criteria?
     - Architecture: Does it follow feature-based structure?
     - Types: Are types precise (no \`any\`, no overly broad unions)?
     - Performance: No unnecessary re-renders, proper memoization?
     - Accessibility: Labels present, screen reader tested?
     - Offline: Sync logic correct, conflict resolution handled?
     - Security: No exposed secrets, proper auth checks?
     - i18n: All strings externalized?
     - Platform: Works on both iOS and Android?

4. **Native Module Review** (if applicable)
   - Both iOS (Swift/Objective-C) and Android (Kotlin/Java) implementations reviewed
   - Expo Modules API usage verified
   - Native dependencies checked for compatibility

### Claude Integration
\`\`\`
/code-review
\`\`\`
The code reviewer agent performs automated analysis covering types, architecture, security, performance, accessibility, and mobile-specific patterns.

### PR Template Checklist
\`\`\`markdown
## Summary
<!-- Link to GitHub Issue: closes #42 -->

## Changes
<!-- What changed and why -->

## Testing
- [ ] Unit tests added/updated
- [ ] Component tests added/updated
- [ ] Tested on iOS Simulator
- [ ] Tested on Android Emulator
- [ ] Offline scenario tested

## Screenshots/Videos
<!-- Screen recordings for UI changes -->

## Checklist
- [ ] Conventional commit messages
- [ ] TypeScript strict — no \`any\`
- [ ] ESLint + Prettier clean
- [ ] Coverage ≥ 75%
- [ ] Accessibility labels present
- [ ] i18n for all user-facing text
- [ ] AI-generated code marked
- [ ] No secrets in code
\`\`\`

### Deliverables
- [ ] PR with all CI checks green
- [ ] At least 1 approval from reviewer
- [ ] All review comments addressed
- [ ] No unresolved threads

### Exit Criteria
- PR approved by at least 1 reviewer
- All CI checks pass
- No open review comments
- CODEOWNERS approval for sensitive paths

---

## Phase 5: Verify

**Goal**: Validate the feature end-to-end on real devices and staging environment before production release.

### Entry Criteria
- Phase 4 review is complete and PR is approved
- PR merged to \`main\`
- Staging build triggered via EAS Update

### Activities

1. **Staging Deployment**
   - EAS Update pushes OTA update to staging channel
   - If native changes: EAS Build creates new staging binary
   - Staging environment uses Firebase staging project

2. **Integration Testing**
   - Verify Firebase integration (Auth, Firestore, Cloud Functions, FCM)
   - Test deep linking flows end-to-end
   - Verify push notification delivery on both platforms
   - Test in-app purchase flows in sandbox/test environments

3. **E2E Testing with Detox**
   \`\`\`bash
   npx detox build --configuration ios.sim.release
   npx detox test --configuration ios.sim.release
   npx detox build --configuration android.emu.release
   npx detox test --configuration android.emu.release
   \`\`\`
   - Run full E2E suite on both platforms
   - Test critical user journeys: onboarding, auth, core feature, payments

4. **Device Testing**
   - Test on physical devices (not just simulators)
   - Test on minimum supported OS versions (iOS 16+, Android 10+)
   - Test on different screen sizes (iPhone SE, iPhone 15 Pro Max, Pixel 7, Galaxy S24)
   - Test with accessibility features enabled (VoiceOver, TalkBack, Dynamic Type)

5. **Performance Verification**
   - Check app startup time (cold start < 3s)
   - Monitor memory usage during feature usage
   - Verify no jank in animations (60fps)
   - Check bundle size hasn't regressed significantly

6. **Offline Verification**
   - Enable airplane mode, use the feature, re-enable network
   - Verify data syncs correctly after reconnection
   - Test conflict resolution with concurrent edits
   - Verify UI shows appropriate offline indicators

7. **Security Verification**
   - Verify biometric authentication flows
   - Check secure storage usage (no sensitive data in AsyncStorage)
   - Verify certificate pinning on API calls
   - Run basic penetration testing on new endpoints

### Claude Integration
\`\`\`
/verify
\`\`\`
The verify skill checks test coverage, runs analysis, validates build configurations, and produces a verification report.

### Deliverables
- [ ] Detox E2E tests passing on both platforms
- [ ] Staging build tested on physical devices
- [ ] Performance benchmarks within acceptable range
- [ ] Offline sync verified
- [ ] Security checklist completed
- [ ] Verification report

### Exit Criteria
- All E2E tests pass on iOS and Android
- No P0/P1 bugs found during device testing
- Performance within acceptable thresholds
- Offline sync working correctly
- Security review passed
- Product owner sign-off on staging

---

## Phase 6: Ship

**Goal**: Build production binaries, submit to App Store and Google Play, and manage the release rollout.

### Entry Criteria
- Phase 5 verification complete
- Product owner sign-off
- Release notes drafted
- Version number bumped in \`app.json\`

### Activities

1. **Version Management**
   \`\`\`bash
   # Update version in app.json
   # iOS: increment CFBundleShortVersionString + CFBundleVersion
   # Android: increment versionName + versionCode
   \`\`\`
   Follow semantic versioning: MAJOR.MINOR.PATCH

2. **Production Build**
   \`\`\`bash
   # iOS production build
   eas build --platform ios --profile production

   # Android production build
   eas build --platform android --profile production
   \`\`\`
   - Verify code signing (iOS certificates, Android keystore)
   - Ensure ProGuard/R8 obfuscation is enabled for Android
   - Verify Hermes engine is enabled for both platforms

3. **Pre-Submission Checks**
   - [ ] App Store privacy labels updated (if data collection changed)
   - [ ] Google Play data safety section updated
   - [ ] GDPR consent flows working correctly
   - [ ] App Store screenshots updated (if UI changed)
   - [ ] Release notes written in all supported languages
   - [ ] No test/debug code in production build
   - [ ] Sentry release created with source maps uploaded
   - [ ] Firebase Crashlytics dSYMs uploaded (iOS)

4. **Store Submission**
   \`\`\`bash
   # Submit to App Store
   eas submit --platform ios --profile production

   # Submit to Google Play
   eas submit --platform android --profile production
   \`\`\`

5. **Rollout Strategy**
   - **Google Play**: Use staged rollout (10% → 25% → 50% → 100%)
   - **App Store**: Consider phased release (7-day automatic rollout)
   - Monitor crash rates at each rollout stage
   - Define rollback criteria (crash rate > 1%, critical bug reported)

6. **OTA Updates** (for JS-only changes)
   \`\`\`bash
   eas update --branch production --message "fix: resolve notification badge count"
   \`\`\`
   - Use EAS Update for non-native hotfixes
   - OTA updates bypass store review
   - Only for JavaScript/asset changes, not native code

### Deliverables
- [ ] Production builds for iOS and Android
- [ ] Store submissions completed
- [ ] Release notes published
- [ ] Sentry release with source maps
- [ ] Rollout plan documented

### Exit Criteria
- App approved by App Store and Google Play
- Staged rollout initiated
- Monitoring dashboards configured
- Rollback plan documented and tested

---

## Phase 7: Operate

**Goal**: Monitor the production release, respond to issues, gather analytics, and feed insights back into the next planning cycle.

### Entry Criteria
- Phase 6 release is live (at least partially rolled out)
- Monitoring tools configured (Sentry, Firebase Analytics, Crashlytics)

### Activities

1. **Real-Time Monitoring**
   - **Sentry**: Monitor error rates, new issues, performance transactions
   - **Firebase Crashlytics**: Track crash-free rate (target: > 99.5%)
   - **Firebase Analytics**: Monitor feature adoption, user flows, retention
   - **App Store Connect / Google Play Console**: Track ratings, reviews, ANRs

2. **Incident Response**
   - P0 (app crash, data loss): Immediate hotfix via OTA or expedited store review
   - P1 (feature broken, degraded UX): Fix within 24 hours
   - P2 (minor bug, cosmetic): Schedule for next sprint
   - P3 (enhancement, nice-to-have): Add to backlog

   Hotfix process:
   \`\`\`bash
   git checkout -b hotfix/APP-99-fix-crash-on-launch
   # Fix, test, review (expedited)
   eas update --branch production --message "hotfix: fix crash on launch for Android 14"
   \`\`\`

3. **Performance Monitoring**
   - Track app startup time trends
   - Monitor API response times via Firebase Performance
   - Watch memory usage patterns
   - Track bundle size over releases

4. **User Feedback Loop**
   - Monitor App Store and Google Play reviews
   - Track in-app feedback submissions
   - Analyze support tickets for recurring issues
   - Review Firebase Analytics funnels for drop-off points

5. **Dependency Maintenance**
   - Weekly: Check for security advisories in dependencies
   - Monthly: Update Expo SDK and React Native (minor versions)
   - Quarterly: Evaluate major version upgrades
   - Review native module compatibility before any upgrade

6. **Compliance Monitoring**
   - Verify GDPR data deletion requests are processed
   - Monitor consent rates and update flows if needed
   - Review App Store / Google Play policy updates
   - Update privacy labels and data safety sections as needed

7. **Feed Back to Phase 1**
   - Create GitHub Issues for bugs found in production
   - Document lessons learned in \`docs/postmortems/\`
   - Update architecture docs if patterns evolved
   - Refine estimation accuracy based on actual vs estimated effort

### Claude Integration
\`\`\`
/phase operate
\`\`\`
Assists with triaging production issues, analyzing crash reports, and drafting hotfix plans.

### Deliverables
- [ ] Weekly monitoring report (crash rate, error rate, key metrics)
- [ ] Incident postmortems for P0/P1 issues
- [ ] Updated backlog with production-discovered issues
- [ ] Dependency audit report (monthly)

### Exit Criteria
- Crash-free rate > 99.5%
- No unresolved P0/P1 issues
- All user-reported critical bugs addressed
- Monitoring dashboards reviewed daily during rollout, weekly after stabilization

---

## Phase Transitions

\`\`\`
┌─────────┐     ┌───────────┐     ┌───────────┐     ┌────────┐
│  1.Plan  │────▶│2.Architect│────▶│3.Implement│────▶│4.Review│
└─────────┘     └───────────┘     └───────────┘     └────────┘
                                        ▲                │
                                        │    ┌───────────┘
                                        │    ▼
                                   ┌─────────┐     ┌───────┐     ┌─────────┐
                                   │5.Verify  │────▶│6.Ship │────▶│7.Operate│
                                   └─────────┘     └───────┘     └─────────┘
                                        ▲                              │
                                        │                              │
                                        └──────── (hotfix) ────────────┘
                                                                       │
                                   ┌───────────────────────────────────┘
                                   ▼
                              ┌─────────┐
                              │  1.Plan  │  (next feature cycle)
                              └─────────┘
\`\`\`

### Loopback Rules
- **Review → Implement**: If reviewer requests significant changes
- **Verify → Implement**: If E2E tests fail or device testing reveals bugs
- **Operate → Verify**: For hotfixes (expedited path through phases 3-5)
- **Operate → Plan**: For new features discovered through production insights

---

## Quality Gates Summary

| Gate | Metric | Threshold | Enforced By |
|------|--------|-----------|-------------|
| Type Safety | TypeScript strict compilation | Zero errors | CI (\`pnpm typecheck\`) |
| Lint | ESLint violations | Zero errors | CI (\`pnpm lint\`) |
| Format | Prettier compliance | Zero diffs | CI (\`pnpm format:check\`) |
| Unit Tests | Jest pass rate | 100% | CI (\`pnpm test\`) |
| Coverage | Line coverage | ≥ 75% | CI (Jest \`--coverage\`) |
| E2E Tests | Detox pass rate | 100% | CI (\`npx detox test\`) |
| Build | EAS Build success | Both platforms | CI (EAS Build) |
| Review | Peer approval | ≥ 1 approval | GitHub branch protection |
| Crash Rate | Crashlytics | > 99.5% crash-free | Sentry + Crashlytics alerts |
| File Size | Lines per file | ≤ 250 | ESLint rule + code review |
| AI Transparency | AI-generated code marked | 100% | AI audit workflow |

---

## Tool Quick Reference

| Task | Command |
|------|---------|
| Start dev server | \`npx expo start\` |
| Run tests | \`pnpm test\` |
| Run tests with coverage | \`pnpm test -- --coverage\` |
| Type check | \`pnpm typecheck\` |
| Lint | \`pnpm lint\` |
| Format | \`pnpm format\` |
| Build iOS (staging) | \`eas build --platform ios --profile staging\` |
| Build Android (staging) | \`eas build --platform android --profile staging\` |
| Build production | \`eas build --platform all --profile production\` |
| Submit to stores | \`eas submit --platform all --profile production\` |
| OTA update (staging) | \`eas update --branch staging --message "description"\` |
| OTA update (production) | \`eas update --branch production --message "description"\` |
| Run Detox (iOS) | \`npx detox test --configuration ios.sim.release\` |
| Run Detox (Android) | \`npx detox test --configuration android.emu.release\` |

---

## Related Documentation

- [Architecture Guide](../docs/ARCHITECTURE.md) — System design, data flow, technology decisions
- [Contributing Guide](../docs/CONTRIBUTING.md) — Code standards, PR process, commit conventions
- [Onboarding Guide](../docs/ONBOARDING.md) — Environment setup, first PR walkthrough
- [AI Usage Policy](../docs/AI-USAGE-POLICY.md) — Rules for AI-assisted development
- [CodeForge Plugin](../plugin/codeforge-react-native/.claude-plugin/plugin.json) — Claude Code integration

---

*This playbook is a living document. Update it as the team learns and the project evolves. Propose changes via PR with the \`docs:\` conventional commit prefix.*`,

  'playbook/claude-overrides/01-discovery.claude.md': `# Phase 01: Discovery & Requirements — Claude Overrides

## Phase Context

This phase focuses on gathering requirements, defining user stories, and establishing non-functional requirements for the React Native mobile app. Claude assists with requirements analysis, user story generation, and feasibility assessment within the mobile/Expo/Firebase ecosystem.

---

## DO

### Requirements Gathering

- DO frame all requirements in terms of mobile user experience — touch interactions, gestures, screen sizes, orientation, and platform conventions (iOS Human Interface Guidelines, Material Design 3)
- DO ask about offline behavior for every feature: "What happens when the user has no connectivity?"
- DO identify which data must sync via WatermelonDB and which can be fetched on-demand via React Query
- DO consider both iOS and Android platform differences when documenting requirements — permissions models, background execution limits, notification handling
- DO capture push notification requirements early: what triggers them, payload structure, deep link targets, quiet hours, user preferences
- DO document deep linking requirements for every screen that could be an entry point from a notification, email, or external link
- DO ask about biometric authentication requirements: which flows require it, fallback mechanisms, re-authentication frequency
- DO capture in-app purchase requirements with specifics: consumables vs. subscriptions, restore purchases, receipt validation, grace periods
- DO identify App Store and Google Play policy constraints that affect feature design (e.g., external payment links, content moderation, age ratings)
- DO document GDPR requirements explicitly: consent flows, data export, account deletion (Apple requires this), data retention policies, analytics opt-out
- DO capture accessibility requirements as first-class: VoiceOver/TalkBack support, Dynamic Type/font scaling, minimum touch targets (44×44pt), color contrast ratios
- DO identify which features need background execution (background fetch, background location, silent push processing) and document the constraints
- DO ask about app size budget — initial download size target, asset optimization strategy, on-demand resources
- DO document analytics events during requirements — what user actions need tracking, conversion funnels, screen view tracking
- DO capture device/OS version support matrix early: minimum iOS version, minimum Android API level, tablet support, foldable support

### User Stories

- DO write user stories that reference mobile-specific acceptance criteria: "Given the user is offline, when they create a record, then it syncs when connectivity returns"
- DO include platform-specific stories where behavior diverges between iOS and Android
- DO create stories for edge cases unique to mobile: app backgrounded mid-flow, interrupted by phone call, low storage, permission denied
- DO tag stories with \`[offline]\`, \`[ios-only]\`, \`[android-only]\`, \`[native-module]\` labels for planning
- DO write stories for the onboarding flow including permission requests (notifications, camera, location) with clear rationale shown to users
- DO include stories for app update flows: force update, soft update prompt, what's new screen

### Non-Functional Requirements

- DO define performance budgets: app launch time (<2s cold start), screen transition time (<300ms), time to interactive, frame rate (60fps)
- DO specify crash-free rate targets (>99.5%) and how Sentry + Firebase Crashlytics will track them
- DO document security NFRs: Keychain/Keystore for tokens, certificate pinning for API calls, code obfuscation via Hermes, jailbreak/root detection
- DO capture battery and data usage constraints — no excessive background processing, efficient image caching, request batching
- DO define WatermelonDB sync conflict resolution strategy as an NFR
- DO specify CI/CD NFRs: EAS Build times, staging deploy frequency, OTA update size limits for EAS Update

---

## DON'T

### Requirements Gathering

- DON'T assume web patterns translate directly to mobile — no hover states, no right-click menus, no browser back button, no URL bar
- DON'T ignore platform-specific permission flows — iOS and Android handle camera, location, notifications, and contacts differently
- DON'T treat offline support as an afterthought or "nice to have" — this is an offline-first architecture with WatermelonDB; every feature must define offline behavior
- DON'T skip deep linking requirements — retrofitting deep links is significantly harder than designing them upfront
- DON'T assume unlimited storage or memory — mobile devices have real constraints that affect data caching and media handling
- DON'T propose features that violate App Store or Google Play policies (e.g., directing users to external payment for digital goods, scraping contacts without consent)
- DON'T ignore the distinction between OTA-updatable changes (JS bundle via EAS Update) and changes requiring a full app store release (native code, permissions, app.json config)
- DON'T document requirements that assume a specific screen size — requirements must account for small phones through large tablets
- DON'T forget to capture requirements for the app when it's not running: background notifications, widgets, Siri/Google Assistant shortcuts
- DON'T conflate Firebase Authentication methods — document exactly which providers are needed (email/password, Google, Apple Sign-In, phone/SMS)

### User Stories

- DON'T write stories with web-centric language: avoid "page", "URL", "browser", "redirect" — use "screen", "deep link", "navigator", "navigate"
- DON'T create stories that assume always-on connectivity without an explicit \`[online-only]\` tag and justification
- DON'T skip the Apple Sign-In story — it's required by App Store guidelines if any third-party social login is offered
- DON'T write stories that mix client state (Zustand) and server state (React Query) concerns — keep them separate for clarity
- DON'T create stories with acceptance criteria that can't be tested in Detox E2E or Jest unit tests
- DON'T ignore the account deletion story — Apple requires apps to offer account deletion; GDPR requires data erasure

### Non-Functional Requirements

- DON'T set unrealistic coverage targets for native module code — focus the 75% threshold on TypeScript business logic, not platform-specific native bridges
- DON'T skip defining OTA update strategy — which changes go through EAS Update vs. full binary release affects every sprint
- DON'T ignore Hermes engine implications — all JS must be compatible with Hermes bytecode compilation
- DON'T propose server-side rendering or SSR patterns — this is a native mobile app, not a web app
- DON'T set NFRs without specifying measurement tools: use Flashlight/Reassure for performance, Detox for E2E timing, Firebase Performance Monitoring for production metrics
- DON'T forget to define NFRs for the build pipeline: EAS Build queue times, artifact sizes, code signing certificate management

---

## Mobile-Specific Discovery Checklist

Before closing Phase 01, ensure the following are documented:

- [ ] Target platforms and minimum OS versions (iOS 16+, Android API 28+)
- [ ] Device support matrix (phones, tablets, foldables)
- [ ] Offline behavior for every feature
- [ ] WatermelonDB sync strategy and conflict resolution
- [ ] Deep linking scheme and universal links configuration
- [ ] Push notification triggers, payloads, and deep link targets
- [ ] Authentication providers (email, Google, Apple, biometric)
- [ ] In-app purchase product catalog and subscription tiers
- [ ] GDPR consent flow, data export, and account deletion
- [ ] App Store and Google Play policy compliance review
- [ ] Accessibility requirements (WCAG 2.1 AA minimum)
- [ ] Performance budgets (launch time, frame rate, bundle size)
- [ ] Analytics event taxonomy
- [ ] Crash-free rate and error budget targets
- [ ] OTA update vs. binary release decision criteria
- [ ] i18n — supported locales and RTL language support

---

## Cross-References

- Phase definition: \`playbook/phases/01-discovery.md\`
- Requirements prompt: \`playbook/prompts/01/gather-requirements.md\`
- User stories prompt: \`playbook/prompts/01/user-stories.md\`
- NFR checklist prompt: \`playbook/prompts/01/nfr-checklist.md\`
- Architecture phase (next): \`playbook/phases/02-architecture.md\`
- Auth implementation (downstream): \`playbook/prompts/04/auth-implementation.md\``,

  'playbook/claude-overrides/02-architecture.claude.md': `# Phase 02: Architecture & Design — Claude Override Rules

## Phase Identity

- **Phase**: 02-architecture
- **Applies to**: All architecture, design, and technical decision tasks during this phase
- **Context**: React Native 0.74 + Expo SDK 51 + Firebase + WatermelonDB mobile application

---

## DO — Architecture Decisions

- DO design every data flow with offline-first as the default — assume the device has no network
- DO use WatermelonDB as the local source of truth and Firestore as the remote sync target
- DO define typed React Navigation stacks, tabs, and modals in \`src/navigation/types.ts\` before building any screen
- DO separate client state (Zustand in \`src/store/\`) from server state (React Query in feature \`hooks/\`)
- DO create an Architecture Decision Record (ADR) in \`docs/adr/\` for every non-trivial choice (database, auth strategy, native module, third-party SDK)
- DO design the Firestore schema with mobile query patterns in mind — denormalize for read performance, minimize document reads
- DO plan for both iOS and Android from the start — every native module, permission, or platform API must have dual implementations
- DO define a clear deep linking scheme in \`src/navigation/linking.ts\` that maps URLs to screens with typed params
- DO design the push notification flow end-to-end: FCM token registration → Firestore storage → Cloud Function trigger → device delivery → in-app handling
- DO architect biometric authentication as a local unlock mechanism backed by secure storage (Keychain on iOS, Keystore on Android), not as a primary auth factor
- DO plan the in-app purchase architecture using \`react-native-iap\` with server-side receipt validation via Cloud Functions
- DO design the sync conflict resolution strategy explicitly — last-write-wins, merge, or manual resolution per entity type
- DO use Expo Modules API for any custom native code rather than bare native modules
- DO design feature modules as self-contained directories under \`src/features/\` with their own screens, components, hooks, types, and tests
- DO plan the analytics taxonomy (event names, properties, user properties) before implementing any tracking
- DO design error boundaries at the navigation stack level so a crash in one feature doesn't take down the entire app
- DO architect the theme system with design tokens in \`src/theme/\` supporting light/dark mode and dynamic type scaling
- DO plan the i18n architecture with namespace-per-feature translation files under \`src/i18n/\`
- DO define the EAS Build profile structure (development, preview, staging, production) during architecture phase
- DO design the app's data deletion flow to satisfy GDPR right-to-erasure and App Store / Google Play requirements

## DON'T — Architecture Anti-Patterns

- DON'T design a web-first architecture and "adapt" it for mobile — mobile has fundamentally different constraints (lifecycle, memory, connectivity, permissions)
- DON'T use Redux, MobX, or Context-based global state — the project uses Zustand for client state and React Query for server state
- DON'T store sensitive data (tokens, secrets, PII) in AsyncStorage — use \`expo-secure-store\` which maps to Keychain/Keystore
- DON'T design Firestore collections that require complex multi-collection joins — Firestore doesn't support joins; denormalize instead
- DON'T create a monolithic navigation tree — split into feature-scoped navigators composed in a root navigator
- DON'T design screens that fetch data only on mount with no cache — use React Query with \`staleTime\` and \`gcTime\` for all server data
- DON'T assume the app will always start fresh — design for background/foreground transitions, deep link cold starts, and notification-triggered launches
- DON'T put business logic in components — extract it into hooks (\`src/features/*/hooks/\`) or services (\`src/services/\`)
- DON'T design API calls that bypass the offline layer — all data mutations should go through WatermelonDB and sync to Firestore
- DON'T use bare \`fetch\` or \`axios\` directly in components — wrap all network calls in service modules under \`src/services/\`
- DON'T design a single Zustand store for everything — create focused stores per domain (auth, theme, preferences, onboarding)
- DON'T architect features that depend on platform-specific APIs without an abstraction layer in \`src/utils/platform/\`
- DON'T skip designing the app's permission request flow — plan when and how to request camera, notifications, location, biometrics, and tracking permissions
- DON'T design navigation flows that break the Android back button or iOS swipe-back gesture expectations
- DON'T use environment variables directly — access them through \`src/config/env.ts\` which validates and types all values
- DON'T design Cloud Functions that are tightly coupled to the mobile client's data shape — use a versioned contract
- DON'T architect the app without considering bundle size — plan code splitting, lazy loading of feature navigators, and asset optimization
- DON'T store Firebase config files (\`google-services.json\`, \`GoogleService-Info.plist\`) in public repositories — reference them via \`.gitignore\` and EAS secrets
- DON'T design the sync architecture without handling the case where a user is logged in on multiple devices simultaneously
- DON'T create architecture diagrams or data models that reference web-only concepts (DOM, cookies, session storage, SSR, CSR)

---

## Architecture Deliverables Checklist

When completing Phase 02, ensure these artifacts exist:

| Artifact | Location | Description |
|---|---|---|
| System architecture diagram | \`docs/architecture/system-overview.md\` | High-level showing mobile app, Firebase services, third-party integrations |
| Navigation map | \`docs/architecture/navigation-map.md\` | All stacks, tabs, modals, and deep link routes |
| Firestore schema | \`docs/architecture/firestore-schema.md\` | Collections, documents, subcollections, indexes, security rules |
| WatermelonDB schema | \`docs/architecture/local-schema.md\` | Tables, columns, relations, migration plan |
| Sync strategy | \`docs/architecture/sync-strategy.md\` | Conflict resolution, sync frequency, error handling |
| Auth flow | \`docs/architecture/auth-flow.md\` | Login, register, biometrics, token refresh, session management |
| Push notification flow | \`docs/architecture/push-notifications.md\` | Token lifecycle, payload structure, handling in all app states |
| Deep linking config | \`docs/architecture/deep-linking.md\` | URL scheme, universal links, route-to-screen mapping |
| ADRs | \`docs/adr/ADR-NNN-*.md\` | One per significant decision |
| Feature module template | \`docs/architecture/feature-template.md\` | Standard directory structure and file conventions per feature |
| EAS build profiles | \`docs/architecture/build-profiles.md\` | Development, preview, staging, production configurations |
| Privacy architecture | \`docs/architecture/privacy.md\` | GDPR consent flow, data deletion, App Store privacy labels, Google Play data safety |

---

## Mobile-Specific Architecture Principles

1. **Offline-first**: The app must be fully functional without network. WatermelonDB is the source of truth; Firestore syncs when connectivity returns.
2. **Battery-conscious**: No polling. Use Firestore real-time listeners sparingly. Batch sync operations. Respect background execution limits.
3. **Memory-aware**: Lazy-load feature navigators. Use \`FlatList\` with \`windowSize\` tuning. Avoid keeping large datasets in Zustand stores.
4. **Platform-respectful**: Follow iOS Human Interface Guidelines and Material Design 3. Use platform-specific components where UX expectations differ.
5. **Secure by default**: All secrets in secure storage. Certificate pinning for API calls. Code obfuscation in production builds. No sensitive data in logs.
6. **Accessible**: Every interactive element has an accessibility label. Support Dynamic Type (iOS) and font scaling (Android). Test with screen readers.
7. **Testable**: Architecture must support unit testing hooks in isolation, component testing with mocked navigation, and E2E testing with Detox.

---

## Cross-References

- Phase definition: \`playbook/phases/02-architecture.md\`
- API design prompt: \`playbook/prompts/02/api-design.md\`
- ADR generator prompt: \`playbook/prompts/02/adr-generator.md\`
- Data model prompt: \`playbook/prompts/02/data-model-design.md\`
- Foundation phase (next): \`playbook/phases/03-foundation.md\`
- Sensitive paths: \`src/services/auth/**\`, \`src/config/**\`, \`.env*\``,

  'playbook/claude-overrides/03-foundation.claude.md': `# Phase 03: Foundation & Scaffolding — Claude Override Rules

## Phase Context

This phase establishes the React Native/Expo project scaffold, CI/CD pipelines (GitHub Actions + EAS Build), navigation structure, Firebase integration, offline-first database setup, and shared infrastructure. Decisions made here propagate through every subsequent phase — correctness is critical.

---

## DO ✅

### Project Scaffold

- **DO** use \`npx create-expo-app\` with Expo SDK 51 and the TypeScript template as the starting point
- **DO** organize code under \`src/features/\` with each feature containing \`screens/\`, \`components/\`, \`hooks/\`, and \`types/\` subdirectories
- **DO** configure \`tsconfig.json\` with \`strict: true\`, \`noUncheckedIndexedAccess: true\`, \`exactOptionalPropertyTypes: true\`, and path aliases (\`@features/*\`, \`@components/*\`, \`@services/*\`, \`@hooks/*\`, \`@utils/*\`, \`@theme/*\`, \`@navigation/*\`, \`@store/*\`, \`@i18n/*\`)
- **DO** set up \`app.config.ts\` (not \`app.json\`) for dynamic Expo configuration using environment variables
- **DO** create separate \`eas.json\` profiles for \`development\`, \`staging\`, and \`production\` with distinct bundle identifiers and app names
- **DO** configure \`metro.config.js\` to support WatermelonDB's JSI and any custom asset types
- **DO** set up \`babel.config.js\` with \`babel-preset-expo\`, \`react-native-reanimated/plugin\`, and WatermelonDB decorators support
- **DO** include a \`pnpm-workspace.yaml\` if the project uses a monorepo structure (e.g., shared packages)
- **DO** create an \`.nvmrc\` or \`.tool-versions\` file pinning Node.js to the version compatible with Expo SDK 51

### Navigation

- **DO** define all navigator param lists as TypeScript types in \`src/navigation/types.ts\`
- **DO** use typed \`useNavigation<StackNavigationProp<RootStackParamList>>()\` and \`useRoute<RouteProp<RootStackParamList, 'ScreenName'>>()\` everywhere
- **DO** configure deep linking in \`src/navigation/linking.ts\` with a proper prefix scheme and universal link configuration
- **DO** set up a root navigator that handles auth state (unauthenticated stack vs. authenticated tab navigator)
- **DO** use \`NavigationContainer\` with \`onStateChange\` for analytics screen tracking

### Firebase Integration

- **DO** initialize Firebase in \`src/services/firebase/index.ts\` using \`@react-native-firebase/*\` packages
- **DO** keep \`google-services.json\` and \`GoogleService-Info.plist\` out of version control — reference them via EAS secrets or \`.gitignore\` with CI injection
- **DO** create typed wrapper services around Firebase modules: \`src/services/firebase/auth.ts\`, \`src/services/firebase/firestore.ts\`, \`src/services/firebase/messaging.ts\`, \`src/services/firebase/storage.ts\`
- **DO** configure Firebase App Check for both iOS and Android in the initialization flow
- **DO** set up Firestore security rules in a \`firestore.rules\` file tracked in the repo

### State Management

- **DO** create Zustand stores in \`src/store/\` with TypeScript interfaces for each store's state and actions
- **DO** use Zustand's \`persist\` middleware with \`expo-secure-store\` for sensitive state (auth tokens) and \`AsyncStorage\` for non-sensitive state (theme, preferences)
- **DO** configure React Query with a \`QueryClientProvider\` at the app root, setting \`staleTime\`, \`gcTime\`, and \`retry\` defaults appropriate for mobile (longer stale times, network-aware retries)
- **DO** create a \`src/hooks/useNetworkStatus.ts\` hook that React Query's \`onlineManager\` uses to pause/resume queries

### Offline-First (WatermelonDB)

- **DO** define WatermelonDB schemas in \`src/services/database/schema.ts\` with versioned migrations in \`src/services/database/migrations.ts\`
- **DO** create model classes in \`src/services/database/models/\` extending \`Model\` with proper decorators (\`@field\`, \`@relation\`, \`@children\`, \`@date\`)
- **DO** implement a sync adapter in \`src/services/database/sync.ts\` that syncs with Firestore using WatermelonDB's \`synchronize()\` function
- **DO** initialize the database in \`src/services/database/index.ts\` and provide it via React context

### CI/CD Pipeline

- **DO** create GitHub Actions workflows in \`.github/workflows/\` with separate jobs for: lint, type-check, unit tests, EAS build (iOS), EAS build (Android)
- **DO** use \`eas build --platform ios --profile staging --non-interactive\` and equivalent Android commands in CI
- **DO** configure EAS Update for OTA updates to staging channel on merge to \`main\`
- **DO** set up Detox E2E tests as a separate workflow that runs on a macOS runner with iOS simulator
- **DO** store signing credentials, API keys, and Firebase config files as GitHub Actions secrets injected via \`eas secret\`
- **DO** add a \`pnpm lint && pnpm typecheck\` pre-push hook via \`husky\` and \`lint-staged\`

### Shared Infrastructure

- **DO** create a design token system in \`src/theme/\` with \`colors.ts\`, \`typography.ts\`, \`spacing.ts\`, and a \`useTheme()\` hook supporting light/dark mode
- **DO** set up i18n in \`src/i18n/\` using \`i18next\` + \`react-i18next\` with \`expo-localization\` for device locale detection
- **DO** create shared UI components in \`src/components/\` (Button, TextInput, Card, Modal, LoadingSpinner) with accessibility props (\`accessibilityLabel\`, \`accessibilityRole\`, \`accessibilityHint\`)
- **DO** configure Sentry in \`src/services/sentry.ts\` with source map uploads in the EAS build process
- **DO** set up environment configuration in \`src/config/env.ts\` using \`expo-constants\` and \`react-native-config\` with typed environment variables

### Security Foundations

- **DO** use \`expo-secure-store\` (backed by iOS Keychain / Android Keystore) for tokens, secrets, and biometric-protected data
- **DO** configure certificate pinning for production API endpoints in the network layer
- **DO** set up ProGuard rules (Android) and ensure bitcode/strip settings (iOS) for release builds
- **DO** create a \`src/services/auth/biometric.ts\` service using \`expo-local-authentication\` with fallback to PIN/password

---

## DON'T ❌

### Project Scaffold

- **DON'T** use \`app.json\` for Expo config — use \`app.config.ts\` for dynamic values and environment switching
- **DON'T** use \`npm\` or \`yarn\` — this project uses \`pnpm\` exclusively; ensure \`eas.json\` sets \`"cli": { "packageManager": "pnpm" }\`
- **DON'T** eject from Expo managed workflow unless absolutely necessary — use Expo config plugins and Expo Modules API for native customization
- **DON'T** put platform-specific code in shared files — use \`.ios.ts\` / \`.android.ts\` suffixes or \`Platform.select()\` in a dedicated utility
- **DON'T** create files longer than 250 lines — split into smaller modules
- **DON'T** use default exports — use named exports for better refactoring and tree-shaking
- **DON'T** skip path aliases and use relative imports like \`../../../components/Button\` — always use \`@components/Button\`

### Navigation

- **DON'T** use untyped navigation — never call \`navigation.navigate('SomeScreen')\` with a raw string that isn't in the param list type
- **DON'T** nest navigators more than 3 levels deep — it causes performance issues and confusing back behavior on mobile
- **DON'T** put business logic in screen components — screens should compose hooks and components, not contain fetch calls or complex state
- **DON'T** forget to handle the Android hardware back button in custom flows (e.g., multi-step forms, modals)

### Firebase Integration

- **DON'T** commit \`google-services.json\`, \`GoogleService-Info.plist\`, or any \`.env\` file to the repository
- **DON'T** call Firestore directly from components — always go through a service layer in \`src/services/firebase/\`
- **DON'T** use Firebase anonymous auth as a permanent auth strategy — it's for temporary sessions only
- **DON'T** store user PII in Firestore without encryption or without documenting it in the GDPR data map
- **DON'T** skip Firebase App Check — it prevents unauthorized API access from modified app binaries

### State Management

- **DON'T** use \`useState\` for state shared across multiple screens — use Zustand or React Query
- **DON'T** store server-fetched data in Zustand — use React Query for anything that comes from an API; Zustand is for client-only state
- **DON'T** use \`AsyncStorage\` for sensitive data (tokens, passwords, PII) — use \`expo-secure-store\`
- **DON'T** create a single monolithic Zustand store — split by domain (\`useAuthStore\`, \`useThemeStore\`, \`usePreferencesStore\`)
- **DON'T** use \`any\` in store types — every store must have a fully typed interface

### Offline-First (WatermelonDB)

- **DON'T** use raw SQLite queries when WatermelonDB's query builder supports the operation — keep the abstraction consistent
- **DON'T** skip schema migrations — every schema change must have a corresponding migration; never bump the schema version without one
- **DON'T** sync on every write — batch sync operations and trigger on network reconnection or at defined intervals
- **DON'T** store large binary data (images, files) in WatermelonDB — use Firebase Storage with local URI references

### CI/CD Pipeline

- **DON'T** run EAS builds on every push — only on PRs targeting \`main\` and on merge to \`main\`
- **DON'T** hardcode signing credentials, API keys, or environment values in workflow files — use GitHub Actions secrets and EAS secrets
- **DON'T** skip the type-check step — \`tsc --noEmit\` must pass before any build or test step
- **DON'T** run Detox E2E tests on Linux runners — they require macOS with Xcode for iOS simulator tests
- **DON'T** deploy to production automatically — staging auto-deploys via EAS Update, but production requires manual approval

### Shared Infrastructure

- **DON'T** hardcode strings in components — all user-facing text must go through \`i18n.t('key')\` from day one
- **DON'T** use inline styles — use the theme system or \`StyleSheet.create()\` for all styling
- **DON'T** create UI components without \`accessibilityLabel\` on interactive elements — this is a hard requirement
- **DON'T** use \`console.log\` for debugging — use a structured logger (\`src/utils/logger.ts\`) that integrates with Sentry in production and is stripped in release builds
- **DON'T** import platform-specific packages (e.g., \`react-native-keychain\`) without wrapping them in a service that handles both platforms

### Security

- **DON'T** store JWT tokens or refresh tokens in \`AsyncStorage\` — always use \`expo-secure-store\`
- **DON'T** disable SSL verification or certificate pinning, even in development builds
- **DON'T** log sensitive data (tokens, passwords, PII) at any log level
- **DON'T** ship development Firebase project credentials in production builds — use separate Firebase projects for staging and production
- **DON'T** skip code obfuscation (ProGuard/R8 for Android, bitcode for iOS) in release builds

---

## Phase 03 Checklist

Before moving to Phase 04 (Core Implementation), verify:

- [ ] \`npx expo start\` launches the app on both iOS simulator and Android emulator without errors
- [ ] TypeScript strict mode compiles with zero errors (\`pnpm typecheck\`)
- [ ] ESLint and Prettier pass with zero warnings (\`pnpm lint\`)
- [ ] Navigation skeleton works: auth flow → main tabs → feature screens with typed params
- [ ] Deep linking resolves at least one test route on both platforms
- [ ] Firebase initializes successfully with App Check enabled
- [ ] Firestore read/write works through the service layer (not direct)
- [ ] WatermelonDB creates tables, inserts a record, and queries it back
- [ ] Zustand stores persist and rehydrate across app restarts
- [ ] React Query fetches, caches, and refetches data with network awareness
- [ ] \`expo-secure-store\` reads and writes a test value on both platforms
- [ ] GitHub Actions workflow runs lint, typecheck, and unit tests on PR
- [ ] EAS Build completes for both iOS and Android on the \`development\` profile
- [ ] Sentry captures a test error with correct source maps
- [ ] i18n renders text in at least two locales
- [ ] All shared components have \`accessibilityLabel\` props
- [ ] No secrets, credentials, or \`.env\` files are committed to the repository
- [ ] \`google-services.json\` and \`GoogleService-Info.plist\` are in \`.gitignore\`
- [ ] \`current-phase.json\` is updated to \`"phase": "04-core-implementation"\`

---

## Cross-References

- **Phase definition**: \`playbook/phases/03-foundation.md\`
- **Scaffold prompt**: \`playbook/prompts/03/project-scaffold.md\`
- **CI pipeline prompt**: \`playbook/prompts/03/ci-pipeline.md\`
- **IaC/Firebase setup prompt**: \`playbook/prompts/03/iac-setup.md\`
- **Architecture decisions**: \`playbook/prompts/02/adr-generator.md\`
- **Next phase override**: \`playbook/claude-overrides/04-core-implementation.claude.md\``,

  'playbook/claude-overrides/04-core-implementation.claude.md': `# Phase 04: Core Implementation — Claude Override Rules

## Context

These rules govern Claude's behavior during core feature implementation of the React Native mobile app. This phase covers building screens, components, hooks, services, navigation, state management, offline sync, and native module integration.

---

## DO — Required Practices

### Component Architecture

- **DO** create every screen component inside its feature directory: \`src/features/{feature}/screens/\`
- **DO** extract reusable UI into \`src/components/\` with typed props interfaces
- **DO** keep components under 250 lines — split into subcomponents when approaching the limit
- **DO** use \`React.memo\` on list item components and heavy render trees with measured justification
- **DO** type all component props with explicit TypeScript interfaces (not inline types)
- **DO** export components as named exports, never default exports
- **DO** add \`accessibilityLabel\`, \`accessibilityRole\`, and \`accessibilityHint\` to every interactive element
- **DO** use \`StyleSheet.create()\` for all styles — colocated in the same file or a \`.styles.ts\` sibling
- **DO** use design tokens from \`src/theme/\` for all colors, spacing, typography, and border radii

### Navigation

- **DO** define all route params in \`src/navigation/types.ts\` using typed \`RootStackParamList\` and \`RootTabParamList\`
- **DO** use \`useNavigation<NativeStackNavigationProp<RootStackParamList>>()\` with proper generic typing
- **DO** use \`useRoute<RouteProp<RootStackParamList, 'ScreenName'>>()\` for typed route params
- **DO** configure deep linking in \`src/navigation/linking.ts\` with proper path mapping
- **DO** handle navigation state persistence for app resume scenarios
- **DO** guard authenticated routes with a navigation-level auth check, not per-screen checks

### State Management

- **DO** use Zustand stores in \`src/store/\` for client-only state (theme, preferences, UI state)
- **DO** use React Query / TanStack Query for all server state (Firestore reads, Cloud Function calls)
- **DO** define query keys as constants in the feature's \`hooks/\` directory
- **DO** set appropriate \`staleTime\` and \`gcTime\` for each query based on data freshness needs
- **DO** use \`useMutation\` with \`onMutate\` for optimistic updates on write operations
- **DO** invalidate related queries after successful mutations
- **DO** persist Zustand stores that need to survive app restarts using \`zustand/middleware\` with MMKV

### Offline-First with WatermelonDB

- **DO** define WatermelonDB models in \`src/services/database/models/\`
- **DO** define schemas and migrations in \`src/services/database/schema.ts\` and \`src/services/database/migrations.ts\`
- **DO** implement sync adapters in \`src/services/database/sync.ts\` that reconcile with Firestore
- **DO** use \`withObservables\` or \`useDatabase\` hooks to subscribe to local data changes
- **DO** queue writes locally first, then sync to Firestore when connectivity is restored
- **DO** handle sync conflicts with a last-write-wins strategy unless the feature requires manual resolution
- **DO** test offline scenarios explicitly — disable network in tests and verify local persistence

### Firebase Integration

- **DO** wrap all Firebase calls in service modules under \`src/services/firebase/\`
- **DO** use \`src/services/firebase/auth.ts\` for all authentication operations
- **DO** use \`src/services/firebase/firestore.ts\` for Firestore reads/writes with typed document interfaces
- **DO** use \`src/services/firebase/messaging.ts\` for push notification registration and handling
- **DO** use \`src/services/firebase/storage.ts\` for file uploads with progress tracking
- **DO** handle Firebase errors with typed error codes and user-friendly messages via i18n
- **DO** use Firestore security rules that match the app's permission model — never rely on client-side checks alone

### Authentication & Security

- **DO** store tokens and sensitive credentials in \`expo-secure-store\` (backed by Keychain/Keystore)
- **DO** implement biometric authentication using \`expo-local-authentication\` with fallback to PIN
- **DO** clear secure storage on logout
- **DO** implement certificate pinning for production API calls
- **DO** validate all user input on both client and server (Cloud Functions)
- **DO** use \`src/services/auth/\` as the single source of truth for auth state
- **DO** refresh auth tokens proactively before expiry, not reactively on 401

### Internationalization

- **DO** route all user-visible strings through \`src/i18n/\` — never hardcode text in components
- **DO** use \`t('feature.screen.key')\` namespaced translation keys
- **DO** include pluralization rules for countable items
- **DO** format dates, numbers, and currencies using locale-aware formatters

### Testing During Implementation

- **DO** write unit tests for every hook in \`__tests__/\` adjacent to the hook file
- **DO** write component tests for every screen using React Native Testing Library
- **DO** test user interactions (press, type, scroll) not implementation details
- **DO** mock Firebase services at the service layer, not at the SDK level
- **DO** mock WatermelonDB with in-memory adapters for component tests
- **DO** test loading, success, error, and empty states for every data-fetching screen
- **DO** maintain ≥75% coverage on all new code in this phase

### Platform Handling

- **DO** use \`Platform.select()\` or platform-specific file extensions (\`.ios.ts\`, \`.android.ts\`) for divergent behavior
- **DO** test on both iOS and Android simulators/emulators before marking a feature complete
- **DO** handle safe areas with \`useSafeAreaInsets()\` from \`react-native-safe-area-context\`
- **DO** handle keyboard avoidance with \`KeyboardAvoidingView\` configured per platform
- **DO** respect platform conventions (e.g., back gesture on iOS, hardware back on Android)

### Performance

- **DO** use \`FlashList\` instead of \`FlatList\` for long lists (>50 items)
- **DO** lazy-load screens with \`React.lazy\` and feature-level code splitting where Expo supports it
- **DO** use \`useCallback\` and \`useMemo\` for expensive computations passed as props
- **DO** profile renders with React DevTools before and after optimization
- **DO** keep JS bundle size in check — run \`npx expo export\` and review bundle analysis

---

## DON'T — Prohibited Practices

### Component Anti-Patterns

- **DON'T** use \`any\` type anywhere — TypeScript strict mode is enforced
- **DON'T** use inline styles — always use \`StyleSheet.create()\` or theme tokens
- **DON'T** use \`index.ts\` barrel files that re-export entire feature directories (causes bundle bloat)
- **DON'T** create god components — if a component manages more than one concern, split it
- **DON'T** use class components — functional components with hooks only
- **DON'T** nest ternaries in JSX — extract to variables or early returns
- **DON'T** use \`console.log\` for debugging — use the structured logger from \`src/utils/logger.ts\`
- **DON'T** hardcode colors, font sizes, or spacing values — use theme tokens

### Navigation Anti-Patterns

- **DON'T** use untyped \`navigation.navigate('ScreenName')\` — always use typed navigators
- **DON'T** pass complex objects or functions as route params — pass IDs and fetch in the target screen
- **DON'T** nest more than 3 levels of navigators without architectural review
- **DON'T** handle deep links in individual screens — use the centralized linking config

### State Management Anti-Patterns

- **DON'T** use React Context for frequently updating state — use Zustand
- **DON'T** store server-fetched data in Zustand — use React Query
- **DON'T** duplicate state between React Query cache and Zustand stores
- **DON'T** use \`useEffect\` to sync state between stores — this indicates an architecture problem
- **DON'T** create a single monolithic Zustand store — split by domain (auth, theme, preferences)
- **DON'T** mutate Zustand state outside of store actions

### Firebase Anti-Patterns

- **DON'T** call Firebase SDK methods directly from components — always go through service modules
- **DON'T** store Firestore document references in component state
- **DON'T** use Firestore \`onSnapshot\` listeners without cleanup in \`useEffect\` return
- **DON'T** trust client-side permission checks — enforce in Firestore security rules and Cloud Functions
- **DON'T** store sensitive data (tokens, PII) in Firestore without encryption
- **DON'T** use Firebase Anonymous Auth as a permanent auth strategy — always prompt for account linking

### Offline Anti-Patterns

- **DON'T** assume network availability — every data operation must have an offline fallback
- **DON'T** show raw error messages when offline — show a user-friendly offline indicator
- **DON'T** block the UI while syncing — sync in the background
- **DON'T** skip WatermelonDB migrations — always create a migration for schema changes

### Security Anti-Patterns

- **DON'T** store tokens, secrets, or API keys in AsyncStorage — use \`expo-secure-store\`
- **DON'T** log sensitive data (tokens, passwords, PII) even in development
- **DON'T** disable SSL verification or certificate pinning, even for debugging
- **DON'T** embed API keys or secrets in the JS bundle — use environment variables via \`react-native-config\`
- **DON'T** commit \`.env\`, \`google-services.json\`, or \`GoogleService-Info.plist\` to the repository

### Performance Anti-Patterns

- **DON'T** use \`ScrollView\` for dynamic-length lists — use \`FlashList\` or \`FlatList\`
- **DON'T** create new object/array/function references in render without memoization when passed as props
- **DON'T** use \`JSON.stringify\` for deep comparison in \`useEffect\` dependencies
- **DON'T** load all features eagerly on app start — use lazy loading for non-critical screens
- **DON'T** run expensive computations on the JS thread — offload to native or use \`InteractionManager\`
- **DON'T** use large base64-encoded images — use optimized assets and \`expo-image\`

### Testing Anti-Patterns

- **DON'T** test implementation details (internal state, private methods)
- **DON'T** use \`waitFor\` with arbitrary timeouts — use proper async queries (\`findBy*\`)
- **DON'T** skip writing tests for "simple" components — all components get at least a render test
- **DON'T** mock React Navigation in component tests — use \`NavigationContainer\` with initial state
- **DON'T** write Detox E2E tests during this phase — those belong in Phase 06

### Platform Anti-Patterns

- **DON'T** use \`Dimensions.get()\` for responsive layouts — use \`useWindowDimensions()\` hook
- **DON'T** assume notch/safe area dimensions — always use \`useSafeAreaInsets()\`
- **DON'T** ignore Android hardware back button behavior in custom navigators
- **DON'T** use platform-specific code without providing implementations for both iOS and Android

---

## File & Naming Conventions

| Artifact | Convention | Example |
|---|---|---|
| Screen component | \`PascalCase\` | \`LoginScreen.tsx\` |
| Shared component | \`PascalCase\` | \`PrimaryButton.tsx\` |
| Hook | \`camelCase\` with \`use\` prefix | \`useAuthState.ts\` |
| Service module | \`camelCase\` | \`firestoreService.ts\` |
| Zustand store | \`camelCase\` with \`Store\` suffix | \`authStore.ts\` |
| Query keys | \`SCREAMING_SNAKE_CASE\` | \`USER_PROFILE_QUERY_KEY\` |
| Style file | \`kebab-case\` with \`.styles\` suffix | \`login-screen.styles.ts\` |
| Test file | Same as source with \`.test\` suffix | \`LoginScreen.test.tsx\` |
| Type file | \`camelCase\` with \`.types\` suffix | \`auth.types.ts\` |
| Translation key | \`dot.separated.lowercase\` | \`auth.login.submitButton\` |
| Feature directory | \`kebab-case\` | \`src/features/in-app-purchases/\` |

---

## Implementation Order

When building features in this phase, follow this sequence within each feature:

1. **Types** — Define interfaces and type aliases in \`types/\`
2. **WatermelonDB models** — Define local database models if the feature has offline data
3. **Services** — Implement Firebase/API service functions
4. **Hooks** — Build React Query queries/mutations and custom hooks
5. **Store** — Create Zustand slices for client state if needed
6. **Components** — Build presentational components
7. **Screens** — Compose screens from components, hooks, and navigation
8. **Tests** — Write unit tests for hooks/services, component tests for screens
9. **Navigation** — Register screens in navigators and update deep link config

---

## Commit Discipline

- One feature or logical change per commit
- Use conventional commits: \`feat(auth): add biometric login flow\`
- Include the ticket reference: \`feat(auth): add biometric login flow [APP-42]\`
- Never commit generated files, build artifacts, or environment secrets
- Run \`pnpm lint && pnpm typecheck && pnpm test\` before every commit

---

## When to Escalate

Claude should flag for human review when:

- A feature requires a new native module not already in the dependency list
- WatermelonDB schema changes affect existing synced data
- Authentication flow changes touch \`src/services/auth/**\`
- Navigation structure changes affect deep linking configuration
- A component exceeds 250 lines and needs architectural guidance on splitting
- Performance profiling reveals JS thread blocking >16ms per frame
- A third-party library requires linking native code or modifying \`app.json\` plugins
- In-app purchase or subscription logic changes (App Store/Google Play policy implications)
- Any change to \`google-services.json\`, \`GoogleService-Info.plist\`, or EAS build profiles
- GDPR-relevant changes: new data collection, analytics events, or third-party SDK integration`,

  'playbook/claude-overrides/05-integration-hardening.claude.md': `# Phase 05: Integration & Hardening — Claude Override Rules

## Phase Context

You are working on integration and hardening tasks for a React Native mobile app built with Expo SDK 51, Firebase backend, WatermelonDB offline storage, and React Navigation. This phase connects all features, hardens security, adds observability, and ensures the app is resilient under real-world conditions including offline, background, and low-connectivity scenarios.

---

## DO — Required Behaviors

### Firebase Integration

- DO use \`@react-native-firebase/*\` packages with proper iOS and Android initialization verified
- DO configure Firestore offline persistence explicitly: \`firebase.firestore().settings({ persistence: true })\`
- DO implement Firebase Cloud Messaging with both foreground and background handlers using \`messaging().onMessage()\` and \`messaging().setBackgroundMessageHandler()\`
- DO register the device token on every app launch and update it in Firestore when it changes
- DO handle Firebase Auth token refresh and propagate updated tokens to React Query headers
- DO use Firebase App Check to protect Cloud Functions and Firestore from unauthorized access
- DO test Firebase integration with the emulator suite locally before deploying rules

### WatermelonDB Sync Hardening

- DO implement conflict resolution strategy in the WatermelonDB sync adapter (server wins, client wins, or merge — document the choice in an ADR)
- DO add retry logic with exponential backoff for sync failures
- DO queue sync operations when offline and flush when connectivity returns using \`@react-native-community/netinfo\`
- DO validate data integrity after sync by comparing record counts and checksums
- DO add sync status indicators in the UI so users know when data is stale
- DO write integration tests that simulate offline → online transitions

### Deep Linking

- DO configure universal links (iOS) and app links (Android) in \`app.json\` under \`expo.ios.associatedDomains\` and \`expo.android.intentFilters\`
- DO define all deep link routes in \`src/navigation/linking.ts\` with typed route params
- DO handle deep links that arrive when the app is cold-started, backgrounded, and foregrounded
- DO validate deep link parameters before navigating — never trust URL params blindly
- DO write Detox E2E tests that open the app via deep link URLs

### Push Notifications

- DO request notification permissions using \`expo-notifications\` with a graceful fallback if denied
- DO handle notification tap routing through React Navigation's \`linking\` config or a dedicated handler
- DO support notification channels on Android (categories, importance levels, sounds)
- DO store notification preferences per user in Firestore and respect them server-side
- DO test push notifications on physical devices — simulators have limited push support

### Biometric Authentication

- DO use \`expo-local-authentication\` for biometric prompts (Face ID, Touch ID, fingerprint)
- DO store sensitive tokens in \`expo-secure-store\` (backed by iOS Keychain / Android Keystore)
- DO implement a fallback to PIN/password when biometrics are unavailable or fail
- DO check \`LocalAuthentication.getEnrolledLevelAsync()\` before prompting — handle devices with no biometrics enrolled
- DO re-authenticate with biometrics when the app returns from background after a configurable timeout

### In-App Purchases

- DO use \`react-native-purchases\` (RevenueCat) or \`expo-in-app-purchases\` with proper receipt validation server-side
- DO validate purchase receipts in a Firebase Cloud Function — never trust client-side receipt data alone
- DO handle all purchase states: purchasing, purchased, failed, restored, deferred
- DO implement restore purchases flow as required by App Store guidelines
- DO test purchases using sandbox accounts (Apple) and test tracks (Google Play)

### Security Hardening

- DO implement certificate pinning using \`react-native-ssl-pinning\` or TrustKit for API calls
- DO enable Hermes bytecode compilation and ProGuard/R8 for Android release builds
- DO strip console logs and debug statements in production builds via Babel plugin \`babel-plugin-transform-remove-console\`
- DO use \`expo-secure-store\` for all sensitive data — never use \`AsyncStorage\` for tokens, keys, or PII
- DO implement jailbreak/root detection using \`jail-monkey\` or equivalent and warn users
- DO set \`NSAppTransportSecurity\` to enforce HTTPS-only on iOS
- DO audit all third-party native modules for known vulnerabilities before integration
- DO implement session timeout — invalidate auth state after configurable inactivity period

### Observability

- DO integrate Sentry with \`@sentry/react-native\` including native crash reporting for both platforms
- DO configure Sentry source maps upload in the EAS Build workflow for symbolicated stack traces
- DO add Firebase Crashlytics as a secondary crash reporter with \`@react-native-firebase/crashlytics\`
- DO instrument key user flows with Firebase Analytics events using a typed analytics service
- DO add performance monitoring with \`@sentry/react-native\` tracing for screen loads and API calls
- DO log sync failures, auth errors, and purchase failures as breadcrumbs in Sentry
- DO create a typed analytics event map in \`src/services/analytics/events.ts\` — no ad-hoc string events

### Network Resilience

- DO use \`@react-native-community/netinfo\` to detect connectivity changes and surface them in the UI
- DO implement request queuing for mutations when offline using React Query's \`onlineManger\` and \`focusManager\`
- DO set appropriate \`staleTime\`, \`cacheTime\`, and \`retry\` values in React Query for mobile network conditions
- DO handle API timeouts explicitly — mobile networks are unreliable, default timeouts are too generous
- DO test the app in airplane mode, slow 3G, and intermittent connectivity using network link conditioner

### Accessibility Hardening

- DO run \`react-native-a11y\` audit on all screens
- DO ensure all interactive elements have \`accessibilityLabel\`, \`accessibilityRole\`, and \`accessibilityHint\`
- DO test with VoiceOver (iOS) and TalkBack (Android) on physical devices
- DO support dynamic type / font scaling — never hardcode font sizes without \`allowFontScaling\`
- DO ensure minimum touch target size of 44x44 points (iOS) / 48x48 dp (Android)

### Error Boundaries & Resilience

- DO wrap each navigation stack in a React error boundary with a user-friendly fallback screen
- DO implement a global error boundary at the app root that reports to Sentry and offers "Restart App"
- DO handle native module crashes gracefully — catch and report rather than letting the app crash silently
- DO implement graceful degradation when optional services (analytics, push) fail to initialize

---

## DON'T — Prohibited Behaviors

### Firebase Anti-Patterns

- DON'T store Firebase API keys or service account credentials in the JavaScript bundle — use environment config
- DON'T make Firestore queries without proper indexes — check the Firebase console for index suggestions
- DON'T use \`firebase.firestore().collection().get()\` without pagination for large collections
- DON'T ignore Firebase security rules — never deploy with \`allow read, write: if true\` outside development
- DON'T call Cloud Functions directly from components — route through service layer in \`src/services/\`

### Offline & Sync Anti-Patterns

- DON'T assume the device is always online — every network call must handle the offline case
- DON'T silently swallow sync errors — surface them to the user and log to Sentry
- DON'T sync entire collections when incremental sync is possible — use timestamps or change tokens
- DON'T block the UI during sync operations — sync must happen in the background
- DON'T store sync timestamps in \`AsyncStorage\` — use WatermelonDB's own metadata tables

### Security Anti-Patterns

- DON'T store tokens, passwords, API keys, or PII in \`AsyncStorage\` — it is unencrypted on both platforms
- DON'T log sensitive data (tokens, passwords, user PII) even in development builds
- DON'T disable SSL verification or certificate pinning for debugging and forget to re-enable
- DON'T embed secrets in \`app.json\` or \`app.config.js\` — use EAS Secrets and \`expo-constants\`
- DON'T trust client-side validation alone for purchases or auth — always validate server-side
- DON'T ship debug builds or builds with the React Native dev menu enabled to TestFlight or Play Store
- DON'T use \`eval()\`, \`new Function()\`, or dynamic \`require()\` — they break Hermes and are security risks

### Navigation Anti-Patterns

- DON'T use untyped navigation — all \`navigation.navigate()\` calls must use typed route params from \`src/navigation/types.ts\`
- DON'T deep link to authenticated screens without checking auth state first — redirect to login if needed
- DON'T handle deep links with string matching — use React Navigation's linking configuration
- DON'T navigate inside \`useEffect\` without cleanup — it causes race conditions on fast screen transitions

### Push Notification Anti-Patterns

- DON'T request push notification permissions on first app launch without context — show a pre-permission screen explaining value
- DON'T assume the push token is stable — it can change and must be refreshed
- DON'T send sensitive data in push notification payloads — they can be visible on lock screens
- DON'T ignore notification permission denial — track it and offer a path to re-enable via settings

### Performance Anti-Patterns

- DON'T use \`ScrollView\` for long lists — use \`FlashList\` or \`FlatList\` with proper \`keyExtractor\` and \`getItemLayout\`
- DON'T render heavy components during navigation transitions — use \`InteractionManager.runAfterInteractions()\`
- DON'T import entire libraries when tree-shaking is available (e.g., \`import { format } from 'date-fns'\` not \`import * as dateFns\`)
- DON'T use inline styles in list items — extract to \`StyleSheet.create()\` for memoization
- DON'T skip \`React.memo()\` on list item components that receive stable props
- DON'T run expensive computations on the JS thread — offload to native modules or use \`requestAnimationFrame\`

### Platform Anti-Patterns

- DON'T write platform-specific code with runtime \`Platform.OS\` checks when \`.ios.ts\` / \`.android.ts\` file extensions work better
- DON'T assume screen dimensions are static — handle orientation changes and foldable devices
- DON'T hardcode status bar height — use \`useSafeAreaInsets()\` from \`react-native-safe-area-context\`
- DON'T ignore Android back button behavior — handle it in navigation and modals
- DON'T test only on iOS simulator — Android has different behavior for permissions, lifecycle, and rendering

### Testing Anti-Patterns

- DON'T mock WatermelonDB in integration tests — use an in-memory database adapter
- DON'T skip E2E tests for critical flows (auth, purchase, sync) — these are the highest-risk paths
- DON'T write Detox tests that depend on network state — use mock servers for E2E
- DON'T ignore flaky tests — fix timing issues with proper \`waitFor\` and \`expect\` matchers in Detox

### Observability Anti-Patterns

- DON'T use \`console.log\` for production logging — use a structured logger that routes to Sentry breadcrumbs
- DON'T send PII (email, name, phone) to analytics or crash reporting without GDPR consent
- DON'T create analytics events with dynamic string keys — use the typed event map
- DON'T ignore Sentry alert thresholds — configure alerts for crash-free rate drops below 99%

---

## Integration Checklist

Before marking Phase 05 complete, verify:

- [ ] Firebase Auth ↔ React Navigation auth flow works (login, logout, token refresh, deep link to protected route)
- [ ] WatermelonDB sync completes successfully after 10+ minutes offline
- [ ] Push notifications route to correct screens when tapped (cold start, background, foreground)
- [ ] Deep links resolve correctly for all defined routes with parameter validation
- [ ] Biometric auth gates sensitive screens and falls back to PIN
- [ ] In-app purchases complete end-to-end with server-side receipt validation
- [ ] Certificate pinning rejects connections to non-pinned hosts
- [ ] Sentry captures native crashes with symbolicated stack traces on both platforms
- [ ] Analytics events fire for all key user actions with correct parameters
- [ ] App functions in airplane mode with appropriate offline indicators
- [ ] All screens pass VoiceOver and TalkBack basic navigation
- [ ] No sensitive data appears in logs, crash reports, or analytics
- [ ] EAS Build succeeds for both iOS and Android with all integrations enabled
- [ ] Detox E2E suite passes for auth, sync, purchase, and deep link flows`,

  'playbook/claude-overrides/06-testing-quality.claude.md': `# Phase 06: Testing & Quality — Claude Override Rules

## Context

These rules govern Claude's behavior during the Testing & Quality phase of the react-native-mobile-app project. This phase covers unit tests, component tests, integration tests, E2E tests with Detox, accessibility audits, performance profiling, and crash reporting validation across iOS and Android.

---

## DO — Required Behaviors

### Unit & Component Testing (Jest + React Native Testing Library)

- DO use \`@testing-library/react-native\` for all component tests — query by \`getByRole\`, \`getByLabelText\`, \`getByTestId\` in that priority order
- DO wrap components in required providers (NavigationContainer, QueryClientProvider, ThemeProvider) using a shared \`renderWithProviders\` test utility
- DO mock native modules explicitly in \`jest.setup.ts\` — never assume native modules work in the Jest jsdom environment
- DO test Zustand stores in isolation by calling \`store.getState()\` and \`store.setState()\` directly
- DO test React Query hooks using \`renderHook\` with a fresh \`QueryClient\` per test (\`retry: false\`, \`gcTime: 0\`)
- DO test WatermelonDB model logic with an in-memory SQLite adapter, not mocked database calls
- DO use \`jest.useFakeTimers()\` when testing animations, debounced inputs, or timeout-based logic — always call \`jest.runAllTimers()\` or \`jest.advanceTimersByTime()\` explicitly
- DO test both iOS and Android platform branches using \`jest.mock('react-native/Libraries/Utilities/Platform', ...)\`
- DO assert accessibility props (\`accessibilityLabel\`, \`accessibilityRole\`, \`accessibilityState\`) in component tests
- DO test error boundaries and fallback UI — verify the fallback renders when a child throws
- DO test deep link parsing logic in \`src/navigation/\` with parameterized test cases covering all route patterns
- DO mock \`@react-native-firebase/*\` modules at the module level in \`__mocks__/\` directory
- DO test i18n by asserting rendered text matches translation keys for at least \`en\` and one other locale
- DO maintain the 75% coverage threshold — fail the test run if coverage drops below this

### E2E Testing (Detox)

- DO write Detox tests in \`e2e/\` directory following the naming convention \`*.e2e.ts\`
- DO use \`device.launchApp({ newInstance: true })\` in \`beforeAll\` for test isolation
- DO use \`element(by.id('testID'))\` as the primary selector — match the \`testID\` prop set on React Native components
- DO test critical user flows end-to-end: sign-up, login, biometric unlock, core feature navigation, push notification tap, in-app purchase flow, logout
- DO test offline scenarios using \`device.setURLBlacklist(['.*firestore.*', '.*googleapis.*'])\` to simulate network loss
- DO test deep linking with \`device.openURL({ url: 'myapp://profile/123' })\`
- DO test permission dialogs (camera, notifications, location) using Detox's system dialog interaction APIs
- DO run Detox tests against both iOS simulator and Android emulator in CI
- DO use \`waitFor(element).toBeVisible().withTimeout(5000)\` instead of arbitrary \`sleep()\` calls
- DO seed test data via Firebase Admin SDK in \`beforeAll\` and clean up in \`afterAll\`

### Performance & Quality

- DO profile renders using \`React.Profiler\` wrapper in test mode — flag components re-rendering more than 3 times on a single user action
- DO test FlatList/FlashList performance by verifying \`initialNumToRender\`, \`windowSize\`, and \`getItemLayout\` are set on lists with >50 items
- DO validate bundle size by checking \`npx expo export\` output — flag if JavaScript bundle exceeds 5MB
- DO test image loading with placeholder/fallback states — verify \`expo-image\` or \`FastImage\` caching behavior
- DO verify Hermes is enabled by checking \`global.HermesInternal\` in a runtime test
- DO test navigation transitions complete within 300ms using Detox timing assertions

### Crash Reporting & Analytics

- DO write tests that verify Sentry and Firebase Crashlytics are initialized with correct DSN/config
- DO test that \`Sentry.captureException()\` is called in global error handlers and error boundaries
- DO verify analytics events fire with correct parameters — mock \`analytics().logEvent()\` and assert call arguments
- DO test that user PII is NOT included in crash reports or analytics payloads (GDPR compliance)
- DO verify breadcrumbs are attached to Sentry events for navigation changes and API calls

### Security Testing

- DO test that auth tokens are stored in \`expo-secure-store\` (iOS Keychain / Android Keystore), never AsyncStorage
- DO test that sensitive screens (payments, profile) require re-authentication or biometric check after app backgrounding >5 minutes
- DO verify certificate pinning configuration by testing that requests to non-pinned domains fail
- DO test that \`.env\` values are not leaked into the JavaScript bundle — scan \`npx expo export\` output
- DO test that Firebase security rules reject unauthorized reads/writes using the Firebase emulator suite

---

## DON'T — Prohibited Behaviors

### Unit & Component Testing

- DON'T use \`enzyme\` or \`shallow\` rendering — they are incompatible with React Native's architecture and modern React
- DON'T use \`render().toJSON()\` snapshot tests as the primary assertion — snapshots are brittle on React Native due to style object changes; use explicit assertions instead
- DON'T snapshot entire screens — only snapshot small, stable, presentational components if at all
- DON'T mock React Navigation's \`useNavigation\` or \`useRoute\` by hand — use \`@react-navigation/native\`'s testing utilities or wrap in a real \`NavigationContainer\`
- DON'T test implementation details: don't assert on component state, instance methods, or internal hook values — test what the user sees and interacts with
- DON'T use \`act()\` wrapping unless React explicitly warns about it — \`@testing-library/react-native\` handles this internally
- DON'T write tests that depend on specific pixel dimensions, absolute positions, or platform-specific style values
- DON'T mock WatermelonDB's \`Database\` class entirely — use the test adapter (\`SQLiteAdapter\` with \`jsi: false\`) for realistic behavior
- DON'T import from \`react-native\` internals (paths containing \`/Libraries/\`) in test files
- DON'T leave \`console.log\`, \`console.warn\`, or \`console.error\` unsilenced in tests — use \`jest.spyOn(console, 'warn').mockImplementation()\` and assert expected warnings
- DON'T write tests that pass only because of timing — never use \`setTimeout\` or raw \`Promise\` delays in unit tests
- DON'T skip tests with \`.skip\` without a linked GitHub Issue explaining why

### E2E Testing

- DON'T use \`sleep()\`, \`waitFor(ms)\`, or fixed delays in Detox tests — always use element-based waitFor conditions
- DON'T hardcode test user credentials in E2E test files — load from environment variables or a secure test config
- DON'T run E2E tests against production Firebase — always use the Firebase emulator or a dedicated staging project
- DON'T write E2E tests that depend on external service availability (third-party APIs, payment processors) — mock at the network level
- DON'T leave test data in the staging environment after E2E runs — always clean up in \`afterAll\`
- DON'T write Detox tests that interact with system UI outside the app (Settings app, other apps) unless testing a specific OS integration
- DON'T use \`element(by.text('...'))\` as the primary selector — text changes with i18n; prefer \`by.id()\` with stable testIDs

### General Anti-Patterns

- DON'T generate test files that exceed 250 lines — split into focused describe blocks across multiple files
- DON'T create test utilities that duplicate \`@testing-library/react-native\` functionality
- DON'T write tests that only assert \`toBeDefined()\` or \`toBeTruthy()\` — these prove nothing about correctness
- DON'T mock everything — if a utility function is pure, test it with real inputs and outputs
- DON'T test third-party library internals (React Navigation transitions, Zustand middleware, React Query cache behavior) — test your code's integration with them
- DON'T generate tests without meaningful assertion messages — use \`expect(x).toBe(y)\` patterns that produce clear failure output
- DON'T create circular test dependencies where test helpers import from source files that import from test helpers
- DON'T write platform-specific tests without clearly marking them with \`describe.each([['ios'], ['android']])\` or conditional \`Platform.OS\` checks
- DON'T commit \`.only\` or focused tests — CI must catch this via lint rules
- DON'T generate load tests or stress tests for the mobile client — load testing targets the Firebase Cloud Functions backend, not the React Native app
- DON'T test animations frame-by-frame — test that the animation starts, completes, and the final state is correct
- DON'T use \`@ts-ignore\` or \`@ts-expect-error\` in test files to work around type issues — fix the types or create proper test type utilities

---

## Test File Organization Rules

\`\`\`
src/features/auth/
  screens/
    LoginScreen.tsx
    LoginScreen.test.tsx          ← co-located component test
  hooks/
    useLogin.ts
    useLogin.test.ts              ← co-located hook test
  services/
    auth-service.ts
    auth-service.test.ts          ← co-located service test

e2e/
  auth.e2e.ts                     ← E2E flow test
  navigation.e2e.ts
  offline.e2e.ts
  payments.e2e.ts

src/test-utils/
  render-with-providers.tsx       ← shared test render utility
  mock-navigation.ts              ← navigation test helpers
  factories/                      ← test data factories (User, Post, etc.)
\`\`\`

## Coverage Enforcement

- Unit + Component coverage: ≥75% lines, ≥70% branches
- \`src/services/auth/**\` must have ≥90% coverage (sensitive path)
- \`src/navigation/**\` must have ≥80% coverage (deep linking correctness)
- E2E tests must cover all screens reachable from the main tab navigator
- Coverage reports generated via \`pnpm test --coverage\` and uploaded as CI artifacts

## Test Commands Reference

| Command | Purpose |
|---|---|
| \`pnpm test\` | Run Jest unit + component tests |
| \`pnpm test --coverage\` | Run tests with coverage report |
| \`pnpm test --watch\` | Watch mode for development |
| \`pnpm test:e2e:ios\` | Run Detox E2E on iOS simulator |
| \`pnpm test:e2e:android\` | Run Detox E2E on Android emulator |
| \`npx detox build -c ios.sim.debug\` | Build iOS E2E test app |
| \`npx detox build -c android.emu.debug\` | Build Android E2E test app |
| \`pnpm lint\` | ESLint check (includes test files) |
| \`pnpm typecheck\` | TypeScript strict mode check |`,

  'playbook/claude-overrides/07-launch.claude.md': `# Phase 07: Launch & Operations — Claude Override Rules

## Context

These rules govern Claude's behavior during Phase 07 (Launch & Operations) for the react-native-mobile-app project. This phase covers app store submissions, production deployments via EAS, monitoring, incident response, OTA updates, and ongoing operational excellence for a React Native/Expo mobile application.

---

## DO ✅

### App Store Submission & Release

- DO use \`eas submit --platform ios\` and \`eas submit --platform android\` for store submissions
- DO generate separate runbooks for App Store Connect and Google Play Console workflows
- DO include app store metadata validation (screenshots, descriptions, privacy URLs, content ratings)
- DO configure EAS Submit profiles in \`eas.json\` for both staging (TestFlight/Internal Testing) and production channels
- DO verify \`app.json\` / \`app.config.ts\` version bumps (\`version\`, \`ios.buildNumber\`, \`android.versionCode\`) before every submission
- DO include phased rollout configuration for Google Play (start at 10%, monitor, then increase)
- DO document App Store Review rejection patterns and mitigation strategies in runbooks
- DO validate privacy manifests for iOS (NSPrivacyTrackedDomains, NSPrivacyCollectedDataTypes) before submission
- DO ensure Google Play Data Safety section matches actual data collection in Firebase Analytics, Crashlytics, and Firestore

### OTA Updates & Deployment

- DO use \`eas update --channel production\` for JavaScript-only OTA updates via Expo Updates
- DO distinguish between OTA-eligible changes (JS/TS, assets) and native-requiring changes (native modules, SDK version bumps)
- DO include rollback procedures using \`eas update:rollback\` or publishing a corrective update
- DO configure \`expo-updates\` with \`checkAutomatically: "ON_LAUNCH"\` for production and \`"WIFI_ONLY"\` as a fallback strategy
- DO set up update channels: \`preview\` for internal testing, \`staging\` for QA, \`production\` for end users
- DO include update size monitoring — warn when OTA bundles exceed 5MB
- DO verify runtime version compatibility between OTA updates and native builds

### Monitoring & Observability

- DO configure Sentry for React Native with source map uploads via \`@sentry/react-native\` and EAS Build hooks
- DO set up Firebase Crashlytics with \`firebase/crashlytics\` for native crash reporting on both iOS and Android
- DO configure Firebase Analytics custom events for key user flows (login, purchase, feature usage)
- DO set up Firebase Performance Monitoring for network request latency and screen rendering times
- DO create Sentry alerts for error rate spikes, new issue types, and regression detection
- DO monitor app startup time (cold start, warm start) and set performance budgets (cold start < 2s)
- DO track ANR (Application Not Responding) rates on Android and hang rates on iOS
- DO set up real-time dashboards for crash-free user rate (target: 99.5%+), DAU/MAU, session duration
- DO monitor WatermelonDB sync failures and queue depth as custom metrics
- DO include device/OS version distribution in monitoring to inform minimum version support decisions

### Incident Response

- DO create runbooks specific to mobile incidents: app crashes, push notification failures, sync conflicts, auth token expiration
- DO include force-update mechanisms via Firebase Remote Config for critical security patches
- DO document the emergency OTA update process with approval gates (even for hotfixes)
- DO include procedures for revoking compromised Firebase API keys or push notification certificates
- DO define severity levels that account for mobile-specific impact (e.g., P1 = crash on launch for >5% users)
- DO include App Store expedited review request procedures for critical fixes
- DO document rollback strategies: OTA rollback for JS issues, store rollback (version revert) for native issues

### Go-Live Checklist

- DO verify Firebase security rules are locked down for Firestore, Storage, and Cloud Functions
- DO confirm ProGuard/R8 obfuscation is enabled for Android release builds
- DO verify iOS App Transport Security (ATS) settings are correct (no arbitrary loads in production)
- DO confirm certificate pinning is active for all API endpoints
- DO validate deep linking configuration works for both universal links (iOS) and app links (Android)
- DO verify push notification certificates (APNs) and Firebase Cloud Messaging configuration
- DO confirm biometric authentication fallback flows work when biometrics are unavailable
- DO test in-app purchase flows end-to-end in sandbox/test environments before production
- DO verify GDPR consent flows, data deletion endpoints, and privacy policy links are functional
- DO confirm Keychain (iOS) and Keystore (Android) are used for all sensitive token storage
- DO run \`npx expo-doctor\` and resolve all warnings before the final production build
- DO verify \`expo-updates\` runtime version is correctly set to prevent incompatible OTA updates
- DO confirm all i18n strings are complete for supported locales

### Operational Excellence

- DO set up automated app store review monitoring (check for new reviews, respond to negative feedback)
- DO configure Firebase Remote Config for feature flags that can disable problematic features without an update
- DO document the on-call rotation and escalation path for mobile-specific incidents
- DO schedule regular dependency audits with \`pnpm audit\` and native module compatibility checks
- DO monitor Expo SDK deprecation timelines and plan upgrades proactively
- DO track bundle size trends and set alerts when JS bundle exceeds 2MB or total app size exceeds 100MB
- DO maintain a device testing matrix covering top 10 devices by user analytics

---

## DON'T ❌

### App Store Submission & Release

- DON'T submit to app stores without incrementing both \`version\` and platform-specific build numbers
- DON'T include \`localhost\`, staging URLs, or debug configurations in production builds
- DON'T leave \`expo-dev-client\` or development-only packages in production bundles
- DON'T submit without testing the actual \`.ipa\` / \`.aab\` artifact on physical devices
- DON'T skip the App Store privacy questionnaire or Google Play Data Safety form — incomplete declarations cause rejections
- DON'T use \`expo publish\` (classic updates) — use \`eas update\` exclusively
- DON'T hardcode API keys, Firebase config, or secrets in source code — use \`react-native-config\` with \`.env\` files excluded from version control

### OTA Updates & Deployment

- DON'T push OTA updates that include native module changes — these require a full store build
- DON'T skip runtime version validation — mismatched OTA updates crash the app
- DON'T deploy OTA updates directly to production without testing on the \`staging\` channel first
- DON'T use OTA updates to bypass App Store Review guidelines (e.g., adding new monetization)
- DON'T push OTA updates larger than 10MB without team lead approval — large updates fail on poor connections
- DON'T assume OTA updates reach all users immediately — some users may be offline for days

### Monitoring & Observability

- DON'T ship production builds without Sentry source maps uploaded — stack traces will be unreadable
- DON'T log sensitive user data (PII, auth tokens, biometric data) to Sentry, Crashlytics, or Analytics
- DON'T ignore ANR/hang rate metrics — these directly impact app store ranking
- DON'T set up monitoring alerts that page on-call for non-critical issues (e.g., single user crash)
- DON'T rely solely on crash reporting — also monitor business metrics (login success rate, purchase completion rate, sync success rate)
- DON'T forget to configure dSYM uploads for iOS and ProGuard mapping file uploads for Android crash symbolication

### Incident Response

- DON'T attempt to fix native crashes with OTA updates — they require a new store build
- DON'T revoke push notification certificates without having replacements ready
- DON'T force-update users to a version that hasn't passed store review
- DON'T communicate incidents to users via push notifications unless the notification system itself is verified working
- DON'T skip post-incident reviews for P1/P2 mobile incidents — mobile bugs have long tails due to update adoption curves

### Go-Live Checklist

- DON'T launch without testing on both iOS and Android physical devices (not just simulators)
- DON'T launch without verifying offline-to-online sync flows in WatermelonDB work correctly
- DON'T launch without confirming Firebase security rules reject unauthorized access patterns
- DON'T launch with \`__DEV__\` checks or debug menus accessible in production
- DON'T launch without verifying the app handles permission denials gracefully (camera, notifications, location, biometrics)
- DON'T launch without testing the app kill → relaunch → state restoration flow
- DON'T launch without verifying background/foreground push notification handling on both platforms
- DON'T ship without testing on the minimum supported OS versions (check \`app.json\` for \`ios.supportsTablet\`, minimum iOS/Android versions)

### Operational Excellence

- DON'T let Expo SDK fall more than one major version behind — migration difficulty increases exponentially
- DON'T ignore app store policy update emails — non-compliance can result in app removal
- DON'T assume Firebase free tier limits are sufficient for production — monitor usage and set billing alerts
- DON'T skip testing on new OS betas (iOS/Android) — breaking changes can affect existing users on launch day
- DON'T generate runbooks or monitoring configs that reference web-only tools (e.g., Lighthouse, browser DevTools) — use mobile-appropriate tooling (Flipper, Xcode Instruments, Android Profiler, Reactotron)

---

## Mobile-Specific Operational Patterns

### Update Strategy Decision Tree

\`\`\`
Change involves native code or SDK bump?
  → YES: Full store build via \`eas build\`, submit via \`eas submit\`, phased rollout
  → NO: JS/asset change only?
    → YES: OTA via \`eas update --channel staging\`, verify, then \`eas update --channel production\`
    → NO: Config-only change?
      → YES: Firebase Remote Config update (instant, no build needed)
\`\`\`

### Crash-Free Rate Response Protocol

\`\`\`
Crash-free rate > 99.5%  → Normal operations
Crash-free rate 99.0-99.5% → Investigate, prepare hotfix
Crash-free rate 98.0-99.0% → P2 incident, expedite fix
Crash-free rate < 98.0%   → P1 incident, consider rollback or force-update
\`\`\`

### Store Review Timeline Planning

- iOS App Store Review: 24-48 hours typical, up to 7 days during holidays
- Google Play Review: 1-3 days typical, longer for first submissions or policy-sensitive changes
- Expedited iOS Review: Request via App Store Connect for critical fixes (not guaranteed)
- Always have a staging build ready as a rollback candidate

---

## File References

- Go-live checklist prompt: \`playbook/prompts/07/go-live-checklist.md\`
- Runbook generator prompt: \`playbook/prompts/07/runbook-generator.md\`
- Monitoring setup prompt: \`playbook/prompts/07/monitoring-setup.md\`
- Phase definition: \`playbook/phases/07-launch.md\`
- Security hardening rules: \`playbook/claude-overrides/05-integration-hardening.claude.md\`
- EAS configuration: \`eas.json\`
- App configuration: \`app.config.ts\`
- Sentry configuration: \`src/services/sentry.ts\`
- Firebase configuration: \`src/services/firebase.ts\``,

  'playbook/codeforge-phase.sh': `#!/usr/bin/env bash
#
# codeforge-phase.sh — Phase management CLI for React Native Mobile App
# Advances, reverts, checks, and lists development methodology phases.
# Updates the active phase symlink in .claude/rules/active-phase.md
#
# Usage:
#   ./playbook/codeforge-phase.sh <command> [options]
#
# Commands:
#   list                  List all available phases
#   current               Show the current active phase
#   set <phase>           Set the active phase (by number or name)
#   next                  Advance to the next phase
#   prev                  Revert to the previous phase
#   check                 Validate current phase configuration
#   info <phase>          Show details about a specific phase
#
# Options:
#   -f, --force           Skip confirmation prompts
#   -q, --quiet           Suppress non-essential output
#   -h, --help            Show this help message

set -euo pipefail

SCRIPT_DIR="$(cd "$(dirname "\${BASH_SOURCE[0]}")" && pwd)"
PROJECT_ROOT="$(cd "\${SCRIPT_DIR}/.." && pwd)"
PLAYBOOK_DIR="\${PROJECT_ROOT}/playbook"
RULES_DIR="\${PROJECT_ROOT}/.claude/rules"
ACTIVE_PHASE_LINK="\${RULES_DIR}/active-phase.md"
PHASE_LOG="\${PLAYBOOK_DIR}/.phase-history.log"

FORCE=false
QUIET=false

declare -a PHASE_ORDER=(
  "01-discovery"
  "02-architecture"
  "03-scaffolding"
  "04-feature-development"
  "05-integration"
  "06-testing"
  "07-hardening"
  "08-release"
  "09-maintenance"
)

declare -A PHASE_NAMES=(
  ["01-discovery"]="Discovery & Requirements"
  ["02-architecture"]="Architecture & Design"
  ["03-scaffolding"]="Project Scaffolding"
  ["04-feature-development"]="Feature Development"
  ["05-integration"]="Integration & Backend Wiring"
  ["06-testing"]="Testing & QA"
  ["07-hardening"]="Hardening & Performance"
  ["08-release"]="Release & Submission"
  ["09-maintenance"]="Maintenance & Iteration"
)

declare -A PHASE_DESCRIPTIONS=(
  ["01-discovery"]="Gather requirements, define user stories, map out features for the React Native app. Identify Firebase services, third-party SDKs, and native module needs."
  ["02-architecture"]="Design feature-based architecture, define navigation graph, plan offline-first data model with WatermelonDB, and establish Zustand/React Query patterns."
  ["03-scaffolding"]="Initialize Expo project, configure TypeScript strict mode, set up ESLint/Prettier, install core dependencies, create directory structure under src/features/."
  ["04-feature-development"]="Build features iteratively: auth (biometrics), home feed, profile, notifications, payments. Each feature in its own directory with screens, components, hooks, types."
  ["05-integration"]="Wire up Firebase (Auth, Firestore, Cloud Functions, FCM), configure WatermelonDB sync, deep linking, analytics, and crash reporting with Sentry."
  ["06-testing"]="Write unit tests with Jest + RNTL, component tests for shared UI, Detox E2E tests for critical flows. Target 75% coverage threshold."
  ["07-hardening"]="Performance optimization (Hermes, bundle analysis), security hardening (Keychain/Keystore, certificate pinning), accessibility audit, GDPR compliance review."
  ["08-release"]="Configure EAS Build profiles (staging/production), set up EAS Submit for App Store and Google Play, prepare store listings, privacy labels, and data safety forms."
  ["09-maintenance"]="Monitor Sentry/Crashlytics, handle OTA updates via EAS Update, manage dependency upgrades, respond to store review feedback, iterate on user analytics."
)

# --- Utility Functions ---

log() {
  if [[ "\${QUIET}" == false ]]; then
    echo "$@"
  fi
}

log_info() {
  log "ℹ️  $*"
}

log_success() {
  log "✅ $*"
}

log_warn() {
  echo "⚠️  $*" >&2
}

log_error() {
  echo "❌ $*" >&2
}

color_phase() {
  local phase="$1"
  local num="\${phase%%-*}"
  case "\${num}" in
    01|02|03) echo -e "\\033[36m\${phase}\\033[0m" ;;
    04|05)    echo -e "\\033[33m\${phase}\\033[0m" ;;
    06|07)    echo -e "\\033[35m\${phase}\\033[0m" ;;
    08|09)    echo -e "\\033[32m\${phase}\\033[0m" ;;
    *)        echo "\${phase}" ;;
  esac
}

ensure_directories() {
  mkdir -p "\${RULES_DIR}"
  mkdir -p "\${PLAYBOOK_DIR}"
}

get_phase_file() {
  local phase="$1"
  local file="\${PLAYBOOK_DIR}/\${phase}.md"
  if [[ -f "\${file}" ]]; then
    echo "\${file}"
    return 0
  fi
  return 1
}

get_current_phase() {
  if [[ -L "\${ACTIVE_PHASE_LINK}" ]]; then
    local target
    target="$(readlink "\${ACTIVE_PHASE_LINK}")"
    local basename
    basename="$(basename "\${target}" .md)"
    echo "\${basename}"
    return 0
  elif [[ -f "\${ACTIVE_PHASE_LINK}" ]]; then
    local first_line
    first_line="$(head -n 5 "\${ACTIVE_PHASE_LINK}" | grep -oP '\\d{2}-[\\w-]+' | head -1 || true)"
    if [[ -n "\${first_line}" ]]; then
      echo "\${first_line}"
      return 0
    fi
  fi
  return 1
}

get_phase_index() {
  local target="$1"
  for i in "\${!PHASE_ORDER[@]}"; do
    if [[ "\${PHASE_ORDER[$i]}" == "\${target}" ]]; then
      echo "\${i}"
      return 0
    fi
  done
  return 1
}

resolve_phase() {
  local input="$1"

  # Direct match
  for phase in "\${PHASE_ORDER[@]}"; do
    if [[ "\${phase}" == "\${input}" ]]; then
      echo "\${phase}"
      return 0
    fi
  done

  # Match by number only (e.g., "04" or "4")
  local padded
  padded=$(printf "%02d" "\${input}" 2>/dev/null || true)
  if [[ -n "\${padded}" ]]; then
    for phase in "\${PHASE_ORDER[@]}"; do
      if [[ "\${phase}" == "\${padded}-"* ]]; then
        echo "\${phase}"
        return 0
      fi
    done
  fi

  # Partial name match
  local lower_input
  lower_input="$(echo "\${input}" | tr '[:upper:]' '[:lower:]')"
  for phase in "\${PHASE_ORDER[@]}"; do
    if [[ "\${phase}" == *"\${lower_input}"* ]]; then
      echo "\${phase}"
      return 0
    fi
  done

  return 1
}

record_transition() {
  local from="$1"
  local to="$2"
  local timestamp
  timestamp="$(date -u +"%Y-%m-%dT%H:%M:%SZ")"
  local user
  user="$(git config user.name 2>/dev/null || echo "\${USER:-unknown}")"
  echo "\${timestamp} | \${user} | \${from} -> \${to}" >> "\${PHASE_LOG}"
}

set_phase_symlink() {
  local phase="$1"
  local phase_file

  if ! phase_file="$(get_phase_file "\${phase}")"; then
    log_warn "Phase file not found: \${PLAYBOOK_DIR}/\${phase}.md"
    log_info "Creating placeholder phase file..."
    create_phase_placeholder "\${phase}"
    phase_file="\${PLAYBOOK_DIR}/\${phase}.md"
  fi

  ensure_directories

  local relative_path
  relative_path="$(python3 -c "import os.path; print(os.path.relpath('\${phase_file}', '\${RULES_DIR}'))" 2>/dev/null || echo "../../playbook/\${phase}.md")"

  rm -f "\${ACTIVE_PHASE_LINK}"
  ln -s "\${relative_path}" "\${ACTIVE_PHASE_LINK}"
}

create_phase_placeholder() {
  local phase="$1"
  local name="\${PHASE_NAMES[\${phase}]:-\${phase}}"
  local desc="\${PHASE_DESCRIPTIONS[\${phase}]:-No description available.}"
  local file="\${PLAYBOOK_DIR}/\${phase}.md"

  cat > "\${file}" << PLACEHOLDER
# Phase: \${name}

## Overview

\${desc}

## Key Activities

- Review phase objectives with the team
- Update GitHub Issues with phase-specific labels
- Follow feature-based architecture under src/features/

## Claude Code Guidelines

- Follow conventional commits (feat:, fix:, chore:, docs:)
- Ensure TypeScript strict mode compliance (no \\\`any\\\`)
- Run \\\`pnpm test\\\` before committing
- Keep files under 250 lines
- Add accessibility labels to all interactive elements
- Route all user-facing text through i18n

## Completion Criteria

- [ ] Phase objectives documented in GitHub Issues
- [ ] All tests passing (\\\`pnpm test\\\`)
- [ ] No TypeScript errors (\\\`pnpm tsc --noEmit\\\`)
- [ ] Code reviewed and approved
PLACEHOLDER
}

confirm_action() {
  local message="$1"
  if [[ "\${FORCE}" == true ]]; then
    return 0
  fi
  read -rp "\${message} [y/N] " response
  case "\${response}" in
    [yY][eE][sS]|[yY]) return 0 ;;
    *) return 1 ;;
  esac
}

# --- Commands ---

cmd_list() {
  local current
  current="$(get_current_phase 2>/dev/null || echo "")"

  log ""
  log "📱 React Native Mobile App — Development Phases"
  log "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━"
  log ""

  for phase in "\${PHASE_ORDER[@]}"; do
    local name="\${PHASE_NAMES[\${phase}]}"
    local marker="  "
    local has_file=" "

    if [[ "\${phase}" == "\${current}" ]]; then
      marker="▶ "
    fi

    if [[ -f "\${PLAYBOOK_DIR}/\${phase}.md" ]]; then
      has_file="✓"
    else
      has_file="○"
    fi

    if [[ "\${phase}" == "\${current}" ]]; then
      printf "  %s [%s] \\033[1m%s\\033[0m — %s (active)\\n" "\${marker}" "\${has_file}" "\${phase}" "\${name}"
    else
      printf "  %s [%s] %s — %s\\n" "\${marker}" "\${has_file}" "$(color_phase "\${phase}")" "\${name}"
    fi
  done

  log ""
  log "  Legend: ▶ = active, ✓ = file exists, ○ = no file yet"
  log ""
}

cmd_current() {
  local current
  if current="$(get_current_phase)"; then
    local name="\${PHASE_NAMES[\${current}]:-\${current}}"
    if [[ "\${QUIET}" == true ]]; then
      echo "\${current}"
    else
      log ""
      log "📍 Current phase: $(color_phase "\${current}")"
      log "   \${name}"
      log ""
      local desc="\${PHASE_DESCRIPTIONS[\${current}]:-}"
      if [[ -n "\${desc}" ]]; then
        log "   \${desc}"
        log ""
      fi
    fi
  else
    log_warn "No active phase set."
    log_info "Run: ./playbook/codeforge-phase.sh set <phase>"
    return 1
  fi
}

cmd_set() {
  local input="\${1:-}"
  if [[ -z "\${input}" ]]; then
    log_error "Phase argument required."
    log_info "Usage: ./playbook/codeforge-phase.sh set <phase-number-or-name>"
    return 1
  fi

  local phase
  if ! phase="$(resolve_phase "\${input}")"; then
    log_error "Unknown phase: \${input}"
    log_info "Run './playbook/codeforge-phase.sh list' to see available phases."
    return 1
  fi

  local current
  current="$(get_current_phase 2>/dev/null || echo "none")"
  local name="\${PHASE_NAMES[\${phase}]}"

  if [[ "\${current}" == "\${phase}" ]]; then
    log_info "Already on phase: $(color_phase "\${phase}") — \${name}"
    return 0
  fi

  if ! confirm_action "Switch from '\${current}' to '\${phase}' (\${name})?"; then
    log_info "Cancelled."
    return 0
  fi

  set_phase_symlink "\${phase}"
  record_transition "\${current}" "\${phase}"

  log_success "Phase set to: $(color_phase "\${phase}") — \${name}"
  log ""
  log "   📂 Symlink: .claude/rules/active-phase.md → playbook/\${phase}.md"
  log ""

  # Show relevant mobile dev reminders per phase
  case "\${phase}" in
    01-discovery)
      log "   💡 Define user stories in GitHub Issues"
      log "   💡 Identify required native modules and Firebase services"
      ;;
    02-architecture)
      log "   💡 Design navigation graph with typed React Navigation"
      log "   💡 Plan WatermelonDB schema for offline-first data"
      ;;
    03-scaffolding)
      log "   💡 Run: npx create-expo-app@latest --template"
      log "   💡 Configure tsconfig.json with strict: true"
      ;;
    04-feature-development)
      log "   💡 Create feature dirs: src/features/<name>/{screens,components,hooks,types}"
      log "   💡 Use Zustand for client state, React Query for server state"
      ;;
    05-integration)
      log "   💡 Configure Firebase: npx expo install @react-native-firebase/app"
      log "   💡 Set up deep linking in navigation/linking.ts"
      ;;
    06-testing)
      log "   💡 Run unit tests: pnpm test --coverage"
      log "   💡 Run E2E tests: npx detox test --configuration ios.sim.release"
      ;;
    07-hardening)
      log "   💡 Enable Hermes, run bundle analysis"
      log "   💡 Audit: secure storage, certificate pinning, GDPR consent"
      ;;
    08-release)
      log "   💡 Build: eas build --platform all --profile production"
      log "   💡 Submit: eas submit --platform ios && eas submit --platform android"
      ;;
    09-maintenance)
      log "   💡 OTA updates: eas update --branch production"
      log "   💡 Monitor Sentry dashboard and Firebase Crashlytics"
      ;;
  esac
  log ""
}

cmd_next() {
  local current
  if ! current="$(get_current_phase)"; then
    log_error "No active phase. Set one first with: ./playbook/codeforge-phase.sh set 01"
    return 1
  fi

  local idx
  if ! idx="$(get_phase_index "\${current}")"; then
    log_error "Current phase '\${current}' not found in phase order."
    return 1
  fi

  local next_idx=$((idx + 1))
  if [[ \${next_idx} -ge \${#PHASE_ORDER[@]} ]]; then
    log_warn "Already on the final phase: $(color_phase "\${current}")"
    return 1
  fi

  local next_phase="\${PHASE_ORDER[\${next_idx}]}"
  cmd_set "\${next_phase}"
}

cmd_prev() {
  local current
  if ! current="$(get_current_phase)"; then
    log_error "No active phase. Set one first with: ./playbook/codeforge-phase.sh set 01"
    return 1
  fi

  local idx
  if ! idx="$(get_phase_index "\${current}")"; then
    log_error "Current phase '\${current}' not found in phase order."
    return 1
  fi

  if [[ \${idx} -le 0 ]]; then
    log_warn "Already on the first phase: $(color_phase "\${current}")"
    return 1
  fi

  local prev_idx=$((idx - 1))
  local prev_phase="\${PHASE_ORDER[\${prev_idx}]}"
  cmd_set "\${prev_phase}"
}

cmd_check() {
  local errors=0

  log ""
  log "🔍 Phase Configuration Check"
  log "━━━━━━━━━━━━━━━━━━━━━━━━━━━━"

  # Check symlink
  if [[ -L "\${ACTIVE_PHASE_LINK}" ]]; then
    local target
    target="$(readlink "\${ACTIVE_PHASE_LINK}")"
    if [[ -f "\${RULES_DIR}/\${target}" ]] || [[ -f "\${target}" ]]; then
      log_success "Symlink valid: active-phase.md → \${target}"
    else
      log_error "Symlink broken: active-phase.md → \${target}"
      errors=$((errors + 1))
    fi
  else
    log_error "No active phase symlink at \${ACTIVE_PHASE_LINK}"
    errors=$((errors + 1))
  fi

  # Check phase files
  local missing=0
  for phase in "\${PHASE_ORDER[@]}"; do
    if [[ ! -f "\${PLAYBOOK_DIR}/\${phase}.md" ]]; then
      log_warn "Missing phase file: playbook/\${phase}.md"
      missing=$((missing + 1))
    fi
  done
  if [[ \${missing} -eq 0 ]]; then
    log_success "All \${#PHASE_ORDER[@]} phase files present"
  else
    log_warn "\${missing} phase file(s) missing"
  fi

  # Check rules directory
  if [[ -d "\${RULES_DIR}" ]]; then
    log_success "Rules directory exists: .claude/rules/"
  else
    log_error "Rules directory missing: .claude/rules/"
    errors=$((errors + 1))
  fi

  # Check phase log
  if [[ -f "\${PHASE_LOG}" ]]; then
    local transitions
    transitions="$(wc -l < "\${PHASE_LOG}" | tr -d ' ')"
    log_success "Phase history: \${transitions} transition(s) recorded"
  else
    log_info "No phase history yet (\${PHASE_LOG})"
  fi

  log ""
  if [[ \${errors} -eq 0 ]]; then
    log_success "All checks passed."
  else
    log_error "\${errors} error(s) found. Run 'set' to fix."
  fi
  log ""
  return \${errors}
}

cmd_info() {
  local input="\${1:-}"
  if [[ -z "\${input}" ]]; then
    log_error "Phase argument required."
    return 1
  fi

  local phase
  if ! phase="$(resolve_phase "\${input}")"; then
    log_error "Unknown phase: \${input}"
    return 1
  fi

  local name="\${PHASE_NAMES[\${phase}]}"
  local desc="\${PHASE_DESCRIPTIONS[\${phase}]}"
  local file="\${PLAYBOOK_DIR}/\${phase}.md"

  log ""
  log "📋 Phase: $(color_phase "\${phase}")"
  log "   Name: \${name}"
  log ""
  log "   \${desc}"
  log ""

  if [[ -f "\${file}" ]]; then
    log "   📄 File: playbook/\${phase}.md ($(wc -l < "\${file}" | tr -d ' ') lines)"
  else
    log "   📄 File: not created yet"
  fi

  local current
  current="$(get_current_phase 2>/dev/null || echo "")"
  if [[ "\${phase}" == "\${current}" ]]; then
    log "   🟢 This is the active phase"
  fi
  log ""
}

cmd_help() {
  sed -n '2,/^$/{ s/^# //; s/^#//; p }' "\${BASH_SOURCE[0]}" | head -20
  echo ""
  echo "Examples:"
  echo "  ./playbook/codeforge-phase.sh list"
  echo "  ./playbook/codeforge-phase.sh set 04"
  echo "  ./playbook/codeforge-phase.sh set feature-development"
  echo "  ./playbook/codeforge-phase.sh next"
  echo "  ./playbook/codeforge-phase.sh prev --force"
  echo "  ./playbook/codeforge-phase.sh check"
  echo "  ./playbook/codeforge-phase.sh info 06-testing"
  echo ""
}

# --- Main ---

main() {
  local command=""
  local args=()

  while [[ $# -gt 0 ]]; do
    case "$1" in
      -f|--force)  FORCE=true; shift ;;
      -q|--quiet)  QUIET=true; shift ;;
      -h|--help)   cmd_help; exit 0 ;;
      -*)          log_error "Unknown option: $1"; cmd_help; exit 1 ;;
      *)
        if [[ -z "\${command}" ]]; then
          command="$1"
        else
          args+=("$1")
        fi
        shift
        ;;
    esac
  done

  if [[ -z "\${command}" ]]; then
    cmd_help
    exit 1
  fi

  case "\${command}" in
    list)    cmd_list ;;
    current) cmd_current ;;
    set)     cmd_set "\${args[0]:-}" ;;
    next)    cmd_next ;;
    prev)    cmd_prev ;;
    check)   cmd_check ;;
    info)    cmd_info "\${args[0]:-}" ;;
    help)    cmd_help ;;
    *)       log_error "Unknown command: \${command}"; cmd_help; exit 1 ;;
  esac
}

main "$@"`,

  'playbook/current-phase.json': `{
  "currentPhase": 1,
  "phaseId": "foundation",
  "startedAt": null,
  "totalPhases": 7
}`,

  'playbook/phases/01-discovery.md': `# Phase 01: Discovery & Requirements

## Overview

The Discovery phase establishes the foundation for the React Native mobile app by defining what we're building, who we're building it for, and the constraints we must operate within. This phase produces the artifacts that every subsequent phase depends on — incomplete discovery leads to rework, scope creep, and missed deadlines.

**Duration**: 1–2 weeks  
**Phase Owner**: Lead Developer / Product Owner  
**Participants**: All team members, stakeholders, design (if available)

---

## Objectives

### 1. Define Product Scope

- Identify the core user problems the app solves
- Establish the minimum viable feature set for launch
- Distinguish between MVP features and post-launch enhancements
- Map features to the \`src/features/\` module structure:
  - \`auth/\` — Authentication flows (email/password, social, biometric)
  - \`home/\` — Primary user experience, dashboard
  - \`profile/\` — User settings, preferences, account management
  - \`notifications/\` — Push notification handling, in-app messaging
  - \`payments/\` — In-app purchases, subscription tiers (if applicable)

### 2. Identify Platform Requirements

- Define iOS minimum deployment target (iOS 15+)
- Define Android minimum SDK version (API 26+)
- Identify platform-specific features (Face ID vs. fingerprint, App Clips vs. Instant Apps)
- Determine tablet support requirements
- Assess landscape orientation needs
- Document accessibility requirements (VoiceOver, TalkBack, Dynamic Type)

### 3. Map Technical Constraints

- Confirm React Native 0.74 + Expo SDK 51 compatibility with required native modules
- Identify any features requiring custom native modules (Expo Modules API)
- Evaluate WatermelonDB schema needs for offline-first data model
- Assess Firebase service requirements (Authentication providers, Firestore collections, Cloud Functions, Cloud Messaging topics)
- Determine third-party SDK requirements (analytics, crash reporting, payment processors)

### 4. Establish Compliance Boundaries

- **GDPR**: Identify personal data collected, processing purposes, legal basis, data retention periods
- **App Store Guidelines**: Review Apple's current guidelines for relevant feature categories (in-app purchases, push notifications, data collection, login requirements)
- **Google Play Policies**: Review Google's current policies for data safety, permissions, billing
- **Privacy Labels**: Draft App Store privacy nutrition labels and Google Play data safety declarations

### 5. Define Success Metrics

- App launch performance targets (Time to Interactive < 2s)
- Crash-free session rate target (≥ 99.5%)
- Offline capability requirements (which features work without connectivity)
- Push notification opt-in rate targets
- User retention benchmarks (Day 1, Day 7, Day 30)

---

## Activities

### A. Stakeholder Interviews

Conduct structured interviews to capture requirements. Document findings in \`docs/discovery/stakeholder-notes.md\`.

**Questions to answer:**
- What problem does this app solve that a mobile web app cannot?
- What are the top 3 user journeys?
- What does success look like at 30/60/90 days post-launch?
- Are there existing backend services to integrate with, or is Firebase greenfield?
- What are the hard deadlines (conference demos, seasonal launches, funding milestones)?

### B. User Story Mapping

Create a story map organized by feature module. Each story follows the format:

\`\`\`
As a [user type],
I want to [action],
so that [outcome].

Acceptance Criteria:
- [ ] Criterion 1
- [ ] Criterion 2

Platform Notes:
- iOS: [specific behavior]
- Android: [specific behavior]

Offline Behavior:
- [what happens without connectivity]
\`\`\`

Stories are tracked as GitHub Issues with labels:
- \`feature:auth\`, \`feature:home\`, \`feature:profile\`, \`feature:notifications\`, \`feature:payments\`
- \`priority:p0\` (MVP), \`priority:p1\` (fast-follow), \`priority:p2\` (future)
- \`platform:ios\`, \`platform:android\`, \`platform:both\`

### C. Technical Spike: Native Module Audit

Before committing to the tech stack, validate that all required capabilities are achievable:

| Capability | Expo Module | Custom Native? | Notes |
|---|---|---|---|
| Biometric Auth | \`expo-local-authentication\` | No | Face ID + Fingerprint |
| Push Notifications | \`expo-notifications\` + FCM | No | Firebase Cloud Messaging |
| Secure Storage | \`expo-secure-store\` | No | Keychain (iOS) / Keystore (Android) |
| Camera/Media | \`expo-camera\`, \`expo-image-picker\` | No | — |
| In-App Purchases | — | Yes (via \`react-native-iap\`) | Requires dev builds, not Expo Go |
| Deep Linking | \`expo-linking\` | No | Universal Links + App Links |
| Offline Database | WatermelonDB | Yes (JSI) | Requires dev builds |
| Analytics | \`@react-native-firebase/analytics\` | No | Firebase Analytics |
| Crash Reporting | \`@sentry/react-native\` | No | Sentry + Firebase Crashlytics |

Run a proof-of-concept dev build to validate:

\`\`\`bash
# Create development build to test native modules
eas build --profile development --platform all
\`\`\`

### D. Data Model Discovery

Define the core entities and their offline sync requirements:

1. **Identify entities** — Users, content items, preferences, transactions
2. **Classify sync strategy** per entity:
   - **Server-authoritative**: Auth tokens, payment records
   - **Client-first with sync**: User-generated content, preferences
   - **Cache-only**: Feed data, remote config
3. **Draft WatermelonDB schema** — Tables, columns, relations
4. **Map to Firestore collections** — Document structure, subcollections, security rules
5. **Define conflict resolution** — Last-write-wins, merge, manual resolution

Document in \`docs/discovery/data-model.md\`.

### E. Navigation Architecture

Map the app's screen hierarchy to React Navigation structure:

\`\`\`
RootNavigator (Stack)
├── AuthNavigator (Stack)
│   ├── WelcomeScreen
│   ├── LoginScreen
│   ├── RegisterScreen
│   └── ForgotPasswordScreen
├── MainNavigator (Bottom Tabs)
│   ├── HomeTab (Stack)
│   │   ├── HomeScreen
│   │   └── DetailScreen
│   ├── NotificationsTab (Stack)
│   │   ├── NotificationListScreen
│   │   └── NotificationDetailScreen
│   └── ProfileTab (Stack)
│       ├── ProfileScreen
│       ├── SettingsScreen
│       └── PrivacyScreen
└── Modals
    ├── PaymentModal
    └── BiometricPrompt
\`\`\`

Define deep link routes:

\`\`\`
myapp://auth/login
myapp://home/detail/:id
myapp://notifications/:notificationId
myapp://profile/settings
\`\`\`

Document in \`docs/discovery/navigation-map.md\`.

### F. Compliance & Privacy Assessment

Complete the following checklists:

**GDPR Checklist:**
- [ ] Data inventory: what personal data is collected and why
- [ ] Legal basis for each data processing activity
- [ ] Consent mechanism design (granular, withdrawable)
- [ ] Data deletion flow (account deletion within 48 hours)
- [ ] Data export flow (user data portability)
- [ ] Privacy policy content reviewed by legal
- [ ] Data Processing Agreement with Firebase/Google Cloud
- [ ] Sub-processor list documented

**App Store Checklist:**
- [ ] Sign in with Apple required if social login is offered
- [ ] In-app purchase uses StoreKit (no external payment links for digital goods)
- [ ] App Tracking Transparency prompt if using IDFA
- [ ] Privacy nutrition labels drafted
- [ ] App Review guidelines reviewed for relevant categories

**Google Play Checklist:**
- [ ] Data safety form drafted
- [ ] Permissions justified (camera, notifications, location)
- [ ] Google Play Billing for digital goods
- [ ] Target API level meets current requirement
- [ ] Families Policy compliance (if applicable)

Document in \`docs/discovery/compliance-assessment.md\`.

### G. Environment & Infrastructure Planning

Define the environment strategy:

| Environment | Purpose | EAS Profile | Firebase Project | Branch |
|---|---|---|---|---|
| Development | Local dev, Expo Go + dev builds | \`development\` | \`myapp-dev\` | feature branches |
| Staging | QA, internal testing | \`preview\` | \`myapp-staging\` | \`main\` (auto) |
| Production | App Store / Google Play | \`production\` | \`myapp-prod\` | \`main\` (manual) |

Plan Firebase project setup:
- [ ] Create Firebase projects (dev, staging, prod)
- [ ] Configure Authentication providers per environment
- [ ] Set up Firestore security rules
- [ ] Configure Cloud Messaging (APNs key for iOS, FCM for Android)
- [ ] Set up Cloud Functions deployment pipeline
- [ ] Configure Firebase App Distribution for staging builds

Plan code signing:
- [ ] Apple Developer account provisioning profiles
- [ ] Apple Push Notification certificates/keys
- [ ] Android keystore generation and secure storage
- [ ] EAS credentials configuration

---

## Deliverables

| # | Deliverable | Format | Location |
|---|---|---|---|
| D1 | Product Requirements Document (PRD) | Markdown | \`docs/discovery/prd.md\` |
| D2 | User Story Map | GitHub Issues + Markdown | \`docs/discovery/story-map.md\` |
| D3 | Data Model & Sync Strategy | Markdown + diagrams | \`docs/discovery/data-model.md\` |
| D4 | Navigation Architecture | Markdown + tree diagram | \`docs/discovery/navigation-map.md\` |
| D5 | Native Module Audit | Markdown table | \`docs/discovery/native-audit.md\` |
| D6 | Compliance Assessment | Checklists | \`docs/discovery/compliance-assessment.md\` |
| D7 | Environment Plan | Markdown table | \`docs/discovery/environment-plan.md\` |
| D8 | Risk Register | Markdown table | \`docs/discovery/risks.md\` |
| D9 | MVP Feature Prioritization | Ranked list with P0/P1/P2 | Included in PRD |
| D10 | Initial GitHub Issues | GitHub Issues | GitHub Issues board |

---

## Quality Gates

All gates must pass before proceeding to Phase 02 (Architecture & Design).

### Gate 1: Scope Clarity

- [ ] PRD reviewed and approved by all stakeholders
- [ ] MVP features (P0) clearly separated from P1/P2
- [ ] Each P0 feature has at least 3 acceptance criteria
- [ ] No feature has undefined offline behavior
- [ ] Platform-specific behaviors documented for iOS and Android

### Gate 2: Technical Feasibility

- [ ] Native module audit complete — no blockers identified
- [ ] Dev build successfully created on both iOS and Android via EAS
- [ ] WatermelonDB proof-of-concept validates offline data model
- [ ] Firebase services confirmed available in target regions
- [ ] All required Expo SDK 51 modules verified compatible with React Native 0.74

### Gate 3: Data & Privacy

- [ ] All personal data fields inventoried with processing purpose
- [ ] GDPR legal basis identified for each data processing activity
- [ ] Account deletion flow defined (Apple requirement)
- [ ] Privacy policy draft covers all data collection
- [ ] App Store privacy labels and Google Play data safety form drafted

### Gate 4: Infrastructure Readiness

- [ ] Firebase projects created for dev, staging, and production
- [ ] EAS project configured with build profiles
- [ ] Apple Developer and Google Play Console accounts accessible
- [ ] Code signing strategy documented
- [ ] GitHub repository created with branch protection on \`main\`

### Gate 5: Team Alignment

- [ ] All team members have reviewed the PRD
- [ ] GitHub Issues created for all P0 stories
- [ ] Development environment setup documented in \`docs/ONBOARDING.md\`
- [ ] Coding standards reviewed (ESLint config, Prettier, TypeScript strict mode)
- [ ] Communication channels established (Slack channels, GitHub notifications)

---

## Risk Register Template

| Risk | Likelihood | Impact | Mitigation |
|---|---|---|---|
| Native module incompatibility with Expo SDK 51 | Medium | High | Spike early; have Expo Modules API fallback |
| WatermelonDB sync conflicts with Firestore | Medium | High | Define conflict resolution strategy in data model |
| App Store rejection due to guideline violation | Low | High | Pre-review compliance checklist; use TestFlight early |
| Push notification delivery issues (APNs/FCM) | Medium | Medium | Test on physical devices in staging; monitor delivery rates |
| In-app purchase implementation complexity | High | Medium | Spike \`react-native-iap\` early; consider deferring to P1 |
| Offline-first adds significant complexity | High | Medium | Limit offline scope to core features; progressive enhancement |
| Team unfamiliarity with React Native/Expo | Low | Medium | Pair programming; allocate onboarding time; reference \`docs/ONBOARDING.md\` |

---

## Phase Transition Checklist

Before moving to **Phase 02: Architecture & Design**:

\`\`\`
□ All 5 quality gates passed
□ PRD signed off by product owner
□ Risk register reviewed — no unmitigated high-impact risks
□ GitHub Issues created and labeled for all P0 features
□ Discovery artifacts committed to docs/discovery/
□ Phase 01 retrospective completed
□ Phase 02 kickoff scheduled
\`\`\`

**Next Phase**: [Phase 02: Architecture & Design](./02-architecture.md)`,

  'playbook/phases/02-architecture.md': `# Phase 02: Architecture & Design

## Overview

Define the technical architecture for the React Native mobile application, establishing patterns for cross-platform development, offline-first data management, Firebase integration, navigation structure, and native module boundaries. All decisions must account for iOS and Android platform differences, App Store/Google Play requirements, and the constraints of the Expo managed workflow with SDK 51.

## Objectives

1. **Define Feature Module Architecture** — Establish the feature-based directory structure under \`src/features/\` with clear boundaries between screens, components, hooks, services, and types per feature
2. **Design Navigation Graph** — Map the complete React Navigation v6 typed navigator hierarchy (stack, tab, modal) including deep linking configuration and authentication flow gating
3. **Establish State Management Strategy** — Define the boundary between Zustand (client state), React Query/TanStack Query (server state), and WatermelonDB (offline persistence) with clear data flow diagrams
4. **Design Offline-First Data Layer** — Architect WatermelonDB schema, sync protocol with Firestore, conflict resolution strategy, and optimistic update patterns
5. **Plan Firebase Integration** — Define service abstractions for Authentication, Firestore, Cloud Functions, Cloud Messaging, and Storage with platform-specific considerations
6. **Define Security Architecture** — Specify secure storage (Keychain/Keystore), certificate pinning, token management, biometric authentication flow, and code obfuscation strategy
7. **Establish CI/CD Pipeline Architecture** — Design EAS Build profiles, update channels, code signing management, and deployment flow for staging and production
8. **Define Cross-Cutting Concerns** — Establish patterns for error handling, logging, analytics, crash reporting, i18n, theming, and accessibility

## Inputs

- Phase 01 Discovery outputs (requirements, user stories, platform constraints)
- Expo SDK 51 compatibility matrix and known limitations
- Firebase project configuration and service quotas
- App Store Review Guidelines and Google Play Developer Policies
- GDPR compliance requirements and data processing inventory
- Target device matrix (minimum iOS 16, Android API 28)

## Deliverables

### D1: Architecture Decision Records (ADRs)

Location: \`docs/architecture/decisions/\`

Required ADRs:

| ADR | Topic | Key Considerations |
|-----|-------|--------------------|
| ADR-001 | Expo Managed vs. Bare Workflow | SDK 51 capabilities, native module needs, EAS Build constraints |
| ADR-002 | Navigation Architecture | Stack/tab hierarchy, deep linking scheme, auth flow gating |
| ADR-003 | State Management Boundaries | Zustand vs. React Query vs. WatermelonDB ownership |
| ADR-004 | Offline-First Sync Strategy | WatermelonDB ↔ Firestore sync, conflict resolution, queue management |
| ADR-005 | Authentication Flow | Firebase Auth providers, biometric unlock, token refresh, secure storage |
| ADR-006 | Push Notification Architecture | FCM/APNs setup, notification channels, foreground/background handling |
| ADR-007 | In-App Purchase Strategy | RevenueCat vs. native APIs, subscription management, receipt validation |
| ADR-008 | Error Handling & Crash Reporting | Sentry integration, error boundaries, Firebase Crashlytics |
| ADR-009 | Testing Strategy | Unit/component/E2E split, Detox device farm, mocking native modules |
| ADR-010 | CI/CD Pipeline Design | EAS Build profiles, update channels, code signing, release process |

Format per ADR:
\`\`\`markdown
# ADR-NNN: Title
## Status: Proposed | Accepted | Deprecated
## Context: Why this decision is needed
## Decision: What we chose and why
## Alternatives Considered: What we rejected and why
## Consequences: Trade-offs, risks, migration path
## Platform Notes: iOS-specific and Android-specific implications
\`\`\`

### D2: System Architecture Diagram

Location: \`docs/architecture/system-overview.md\`

Must include:

- **High-level system context** — Mobile app, Firebase services, third-party integrations (Sentry, RevenueCat, analytics)
- **Container diagram** — React Native app internals (navigation layer, feature modules, service layer, data layer, native bridge)
- **Data flow diagram** — User action → screen → hook → service → Firebase/WatermelonDB → sync → UI update
- **Offline data flow** — Online path vs. offline queue vs. sync reconciliation
- **Authentication sequence** — Login → Firebase Auth → token storage → biometric enrollment → session refresh

### D3: Feature Module Specification

Location: \`docs/architecture/feature-modules.md\`

Define the canonical feature module structure:

\`\`\`
src/features/{feature-name}/
  screens/              # Screen components (connected to navigation)
  components/           # Feature-specific UI components
  hooks/                # Feature-specific hooks (data fetching, business logic)
  services/             # Feature-specific service calls
  types/                # Feature-specific TypeScript types
  __tests__/            # Co-located unit and component tests
  index.ts              # Public API barrel export
\`\`\`

For each planned feature module:

| Feature | Screens | Key Components | External Services | Offline Support |
|---------|---------|----------------|-------------------|-----------------|
| \`auth\` | Login, Register, ForgotPassword, BiometricPrompt | AuthForm, SocialLoginButtons | Firebase Auth, Keychain/Keystore | Token caching only |
| \`home\` | HomeFeed, Detail | FeedCard, RefreshableList | Firestore, Cloud Functions | Full (WatermelonDB) |
| \`profile\` | ProfileView, EditProfile, Settings, Privacy | AvatarPicker, PreferenceToggle | Firebase Auth, Storage | Partial (cached profile) |
| \`notifications\` | NotificationList, NotificationDetail | NotificationCard, Badge | Cloud Messaging, Firestore | Queue pending reads |
| \`payments\` | SubscriptionPlans, PurchaseConfirmation, ManageSubscription | PlanCard, PriceDisplay | RevenueCat/StoreKit/BillingClient | Receipt cache only |

### D4: Navigation Architecture

Location: \`docs/architecture/navigation.md\`

Define the typed navigator hierarchy:

\`\`\`typescript
// Root navigator structure
RootStack
  ├── AuthStack (unauthenticated)
  │   ├── LoginScreen
  │   ├── RegisterScreen
  │   └── ForgotPasswordScreen
  ├── MainTabs (authenticated)
  │   ├── HomeStack
  │   │   ├── HomeFeedScreen
  │   │   └── DetailScreen
  │   ├── NotificationsStack
  │   │   ├── NotificationListScreen
  │   │   └── NotificationDetailScreen
  │   └── ProfileStack
  │       ├── ProfileViewScreen
  │       ├── EditProfileScreen
  │       └── SettingsScreen
  └── ModalStack (overlays)
      ├── BiometricPromptScreen
      ├── PurchaseScreen
      └── PrivacyConsentScreen
\`\`\`

Deep linking configuration:
\`\`\`
myapp://                          → HomeFeed
myapp://profile                   → ProfileView
myapp://notifications/:id         → NotificationDetail
myapp://subscribe/:planId         → PurchaseScreen
\`\`\`

### D5: Data Layer Architecture

Location: \`docs/architecture/data-layer.md\`

**WatermelonDB Schema:**
- Define tables, columns, relations for offline-capable entities
- Specify which Firestore collections map to which WatermelonDB tables
- Define sync pull/push protocol with Firestore Cloud Functions

**State Ownership Matrix:**

| Data | Owner | Persistence | Sync Strategy |
|------|-------|-------------|---------------|
| Auth tokens | Zustand + SecureStore | Keychain/Keystore | On app launch, token refresh |
| User profile | React Query | WatermelonDB | Stale-while-revalidate, background sync |
| Feed items | React Query | WatermelonDB | Pull on focus, push on mutation |
| Notification list | React Query | WatermelonDB | FCM trigger + periodic pull |
| App preferences | Zustand | AsyncStorage | Local only, no sync |
| Theme/locale | Zustand | AsyncStorage | Local only, no sync |
| Purchase state | React Query | SecureStore (receipts) | Receipt validation on launch |
| Pending mutations | WatermelonDB sync queue | WatermelonDB | Retry with exponential backoff |

### D6: Firebase Service Abstractions

Location: \`docs/architecture/firebase-services.md\`

Define service interfaces that abstract Firebase SDK calls:

\`\`\`typescript
// src/services/auth/auth-service.ts
// src/services/firestore/firestore-service.ts
// src/services/messaging/messaging-service.ts
// src/services/storage/storage-service.ts
// src/services/functions/functions-service.ts
// src/services/analytics/analytics-service.ts
// src/services/crashlytics/crashlytics-service.ts
\`\`\`

Each service must:
- Be injectable/mockable for testing
- Handle platform differences (iOS vs. Android) internally
- Provide typed request/response interfaces
- Include error mapping to domain-specific error types
- Support offline graceful degradation

### D7: Security Architecture

Location: \`docs/architecture/security.md\`

| Concern | Implementation | Platform Details |
|---------|---------------|------------------|
| Token storage | expo-secure-store → Keychain (iOS) / EncryptedSharedPreferences (Android) | AES-256 at rest |
| Biometric auth | expo-local-authentication | Face ID / Touch ID (iOS), Fingerprint / Face (Android) |
| Certificate pinning | Custom fetch interceptor with pinned certificates | Pin Firebase API endpoints |
| API security | Firebase App Check | Device attestation (DeviceCheck iOS, SafetyNet Android) |
| Code obfuscation | Hermes bytecode (default), ProGuard (Android) | Review source map upload to Sentry |
| Sensitive data | Never log tokens, PII, or payment data | Strip from crash reports |
| GDPR | Consent management, data export, account deletion | Privacy labels (iOS), Data Safety (Android) |
| Secure communication | TLS 1.3 minimum, no HTTP fallback | ATS enabled (iOS), cleartext blocked (Android) |

### D8: CI/CD Pipeline Design

Location: \`docs/architecture/cicd-pipeline.md\`

**EAS Build Profiles:**

\`\`\`json
{
  "build": {
    "development": {
      "developmentClient": true,
      "distribution": "internal",
      "channel": "development"
    },
    "staging": {
      "distribution": "internal",
      "channel": "staging",
      "env": { "APP_ENV": "staging" }
    },
    "production": {
      "distribution": "store",
      "channel": "production",
      "autoIncrement": true,
      "env": { "APP_ENV": "production" }
    }
  }
}
\`\`\`

**GitHub Actions Pipeline:**

\`\`\`
Push to feature branch:
  → Lint (ESLint) → Type Check (tsc) → Unit Tests (Jest) → Component Tests (RNTL)

PR to main:
  → All above + EAS Build (iOS staging) + EAS Build (Android staging) + Detox E2E

Merge to main:
  → All above + EAS Update (staging channel) → Manual approval → EAS Submit (production)
\`\`\`

### D9: Cross-Cutting Concerns Specification

Location: \`docs/architecture/cross-cutting.md\`

- **Error Boundaries** — Per-screen error boundaries with retry, global fallback screen
- **Logging** — Structured logging with levels (debug/info/warn/error), stripped in production builds
- **Analytics** — Firebase Analytics events taxonomy, screen tracking via React Navigation
- **Crash Reporting** — Sentry + Firebase Crashlytics dual reporting, breadcrumb trail
- **i18n** — react-i18next with namespace-per-feature, RTL support, pluralization
- **Theming** — Light/dark/system themes via Zustand + React Navigation theme, design tokens in \`src/theme/\`
- **Accessibility** — Minimum AA contrast, all interactive elements labeled, screen reader testing checklist
- **Performance** — Hermes engine, lazy screen loading, image optimization (expo-image), list virtualization (FlashList)

## Quality Gates

All gates must pass before Phase 02 is considered complete.

### QG-1: ADR Completeness

- [ ] All 10 ADRs written with Status: Accepted
- [ ] Each ADR reviewed by at least 1 senior/lead developer
- [ ] Platform-specific implications documented for both iOS and Android
- [ ] No open questions or TBD sections remain

### QG-2: Architecture Diagram Review

- [ ] System context diagram reviewed by full team
- [ ] Data flow covers online, offline, and sync reconciliation paths
- [ ] Authentication sequence covers all providers (email, social, biometric)
- [ ] Diagram matches the feature module specification

### QG-3: Navigation Type Safety

- [ ] Complete navigator hierarchy defined with TypeScript param types
- [ ] Deep linking config covers all public routes
- [ ] Auth flow gating logic specified (unauthenticated → authenticated transitions)
- [ ] Modal presentation patterns defined

### QG-4: Data Layer Validation

- [ ] WatermelonDB schema defined for all offline-capable entities
- [ ] Sync protocol documented with conflict resolution rules
- [ ] State ownership matrix has no ambiguous ownership
- [ ] React Query cache invalidation strategy defined per entity

### QG-5: Security Review

- [ ] Secure storage approach validated for both platforms
- [ ] Certificate pinning endpoints listed
- [ ] GDPR data flow mapped (collection → processing → storage → deletion)
- [ ] App Store privacy label and Google Play data safety section drafted
- [ ] No secrets or credentials in source code (verified via git-secrets or similar)

### QG-6: CI/CD Pipeline Validation

- [ ] EAS Build profiles defined for development, staging, production
- [ ] Code signing strategy documented (certificates, provisioning profiles, keystores)
- [ ] GitHub Actions workflow files drafted and reviewed
- [ ] Rollback strategy defined for OTA updates (EAS Update)

### QG-7: Testability Assessment

- [ ] Every service interface is mockable (no direct Firebase SDK calls in components)
- [ ] Detox E2E test plan covers critical user journeys (auth, core feature, purchase)
- [ ] Native module mocking strategy defined for Jest
- [ ] 75% coverage target is achievable given the architecture

### QG-8: Performance Budget

- [ ] App binary size budget defined (< 50MB iOS, < 30MB Android APK)
- [ ] Time-to-interactive target defined (< 2s on mid-range device)
- [ ] Offline-to-online sync latency target defined (< 5s for pending queue)
- [ ] Memory budget defined (< 200MB peak on target devices)

## Phase Completion Criteria

| Criterion | Verification Method |
|-----------|-------------------|
| All 9 deliverables produced | Checklist review by lead |
| All 8 quality gates passed | Gate-by-gate sign-off |
| Architecture supports all Phase 01 requirements | Traceability matrix |
| No unresolved platform-specific risks | Risk register updated |
| Team walkthrough completed | Meeting notes in \`docs/architecture/\` |
| Sensitive paths identified in CODEOWNERS | \`.github/CODEOWNERS\` updated |

## Transition to Phase 03

Upon completion, update \`playbook/current-phase.json\`:

\`\`\`json
{
  "current_phase": "03-setup",
  "started_at": "<timestamp>",
  "previous_phase": "02-architecture",
  "completed_at": "<timestamp>"
}
\`\`\`

Phase 03 (Project Setup) will use these architecture deliverables to:
- Scaffold the feature module directory structure
- Configure React Navigation with typed navigators
- Initialize WatermelonDB schema and sync infrastructure
- Set up Firebase project configuration files
- Create EAS Build profiles and GitHub Actions workflows
- Establish shared component library with theme tokens
- Configure ESLint, Prettier, TypeScript strict mode, and Jest

## Claude Integration Notes

When using Claude during this phase:

- **Use \`/phase architecture\`** to get context-aware guidance on mobile architecture decisions
- **Use the \`architect\` agent** for evaluating trade-offs between Expo managed vs. bare workflow, sync strategies, and native module boundaries
- **Reference ADR templates** — ask Claude to draft ADRs with the format specified above
- **Validate navigation types** — ask Claude to generate TypeScript type definitions for the navigator hierarchy
- **Review WatermelonDB schemas** — ask Claude to validate schema design against Firestore collection structure
- **Security review** — ask Claude to audit the security architecture against OWASP Mobile Top 10
- All AI-generated architecture documents must be marked per the [AI Usage Policy](../../docs/AI-USAGE-POLICY.md)`,

  'playbook/phases/03-foundation.md': `# Phase 03: Foundation & Scaffolding

## Phase Overview

**Phase**: 03 of 07
**Name**: Foundation & Scaffolding
**Duration**: 1–2 sprints (1–2 weeks)
**Previous Phase**: [02 — Architecture & Design](./02-architecture.md)
**Next Phase**: [04 — Core Development](./04-core-development.md)

## Objective

Stand up the React Native project skeleton with Expo SDK 51, configure all foundational tooling (TypeScript, ESLint, Prettier, Jest, Detox), wire Firebase services, establish the navigation shell, implement the design-token theme system, and validate the entire pipeline from local dev through EAS Build to staging deployment. At the end of this phase every developer can clone the repo, run \`pnpm install && npx expo start\`, and see a working app with typed navigation, theming, and a passing CI pipeline.

---

## Entry Criteria

- [ ] Architecture Decision Records (ADRs) approved for navigation, state management, offline strategy, and authentication
- [ ] Figma/design tokens exported or documented (colors, typography, spacing, radii)
- [ ] Firebase project created with dev/staging/production environments
- [ ] Apple Developer and Google Play Console accounts provisioned
- [ ] EAS project linked (\`eas init\`) and build profiles defined
- [ ] GitHub repo created with branch protection on \`main\`

---

## Deliverables

### D1 — Expo Project Initialization

| Item | Detail |
|------|--------|
| Expo SDK | 51 with \`expo-dev-client\` for custom native modules |
| TypeScript | \`tsconfig.json\` with \`strict: true\`, \`noUncheckedIndexedAccess\`, path aliases (\`@features/*\`, \`@components/*\`, \`@services/*\`, \`@hooks/*\`, \`@utils/*\`, \`@theme/*\`, \`@i18n/*\`, \`@navigation/*\`, \`@store/*\`, \`@assets/*\`) |
| Package manager | pnpm with \`pnpm-workspace.yaml\` if monorepo; lockfile committed |
| \`.nvmrc\` | Node 20 LTS |
| \`app.config.ts\` | Dynamic Expo config reading from \`expo-constants\` + \`react-native-config\` env vars |

**Commands to verify:**

\`\`\`bash
pnpm install
npx expo start          # Metro bundler launches, QR code displayed
npx expo run:ios        # Builds dev client on iOS simulator
npx expo run:android    # Builds dev client on Android emulator
\`\`\`

### D2 — Directory Structure

Create the canonical feature-based layout:

\`\`\`
src/
  features/
    auth/
      screens/
      components/
      hooks/
      types/
      __tests__/
    home/
      screens/
      components/
      hooks/
      types/
      __tests__/
    profile/
      screens/
      components/
      hooks/
      types/
      __tests__/
    notifications/
      screens/
      components/
      hooks/
      types/
      __tests__/
    payments/
      screens/
      components/
      hooks/
      types/
      __tests__/
  components/
    button/
    card/
    input/
    modal/
    loading/
  hooks/
  services/
    firebase/
    analytics/
    crash-reporting/
  navigation/
  store/
  utils/
  i18n/
  theme/
  assets/
    images/
    fonts/
    animations/
e2e/
scripts/
docs/
\`\`\`

Each directory includes an \`index.ts\` barrel export. Feature directories include a \`README.md\` stub describing the feature's scope.

### D3 — Linting, Formatting & Git Hooks

| Tool | Config |
|------|--------|
| ESLint | \`@react-native-community/eslint-config\` + \`@typescript-eslint/recommended\` + custom rules (no \`any\`, max file length 250, accessibility checks via \`eslint-plugin-react-native-a11y\`) |
| Prettier | \`singleQuote: true\`, \`trailingComma: 'all'\`, \`semi: true\`, \`printWidth: 100\`, \`bracketSpacing: true\` |
| lint-staged | Run ESLint + Prettier on staged \`.ts\`/\`.tsx\` files |
| Husky | \`pre-commit\` → lint-staged; \`commit-msg\` → commitlint (conventional commits) |
| commitlint | \`@commitlint/config-conventional\` with scopes: \`auth\`, \`home\`, \`profile\`, \`notifications\`, \`payments\`, \`nav\`, \`theme\`, \`i18n\`, \`infra\`, \`ci\`, \`deps\` |

**Verification:**

\`\`\`bash
pnpm lint              # Zero errors, zero warnings
pnpm format:check      # All files formatted
pnpm typecheck         # tsc --noEmit passes
\`\`\`

### D4 — Theme & Design Tokens

Create \`src/theme/\` with:

| File | Purpose |
|------|---------|
| \`colors.ts\` | Light and dark palette objects, typed with \`as const\` |
| \`typography.ts\` | Font families, sizes, line heights, letter spacing |
| \`spacing.ts\` | 4px grid scale (xs through xxxl) |
| \`radii.ts\` | Border radius tokens |
| \`shadows.ts\` | Platform-specific shadow/elevation tokens |
| \`index.ts\` | Unified \`Theme\` type and \`lightTheme\`/\`darkTheme\` exports |

Implement \`ThemeProvider\` using React Context + Zustand store for persistence. Expose \`useTheme()\` hook returning typed theme object and \`toggleTheme()\` function. Theme preference persisted to \`expo-secure-store\`.

### D5 — Navigation Shell

| Navigator | Type | Screens (stubs) |
|-----------|------|-----------------|
| \`RootNavigator\` | Stack | \`AuthNavigator\`, \`MainNavigator\`, \`OnboardingScreen\` |
| \`AuthNavigator\` | Stack | \`LoginScreen\`, \`RegisterScreen\`, \`ForgotPasswordScreen\` |
| \`MainNavigator\` | Bottom Tab | \`HomeTab\`, \`ProfileTab\`, \`NotificationsTab\` |
| \`HomeTab\` | Stack | \`HomeScreen\`, \`DetailScreen\` |
| \`ProfileTab\` | Stack | \`ProfileScreen\`, \`SettingsScreen\` |
| \`NotificationsTab\` | Stack | \`NotificationsScreen\` |

All navigators fully typed with \`RootStackParamList\`, \`AuthStackParamList\`, \`MainTabParamList\`, etc. in \`src/navigation/types.ts\`. Deep linking config skeleton in \`src/navigation/linking.ts\` with URL scheme \`reactnativemobileapp://\`.

**Verification:**

\`\`\`bash
# TypeScript catches incorrect route names or missing params at compile time
pnpm typecheck
\`\`\`

### D6 — State Management Scaffolding

| Layer | Tool | Setup |
|-------|------|-------|
| Client state | Zustand | \`src/store/auth-store.ts\` (user, token, isAuthenticated), \`src/store/theme-store.ts\` (mode, system preference), \`src/store/preferences-store.ts\` (locale, notifications enabled) |
| Server state | TanStack Query | \`QueryClientProvider\` in app root with default \`staleTime: 5 * 60 * 1000\`, \`retry: 2\`, \`refetchOnReconnect: true\`. Typed query key factory in \`src/services/query-keys.ts\` |
| Offline state | WatermelonDB | Database schema v1 in \`src/services/watermelon/schema.ts\`, model stubs for \`User\`, \`Notification\`. Migration setup in \`src/services/watermelon/migrations.ts\` |

### D7 — Firebase Integration

| Service | Setup |
|---------|-------|
| Core | \`@react-native-firebase/app\` initialized via \`google-services.json\` (Android) and \`GoogleService-Info.plist\` (iOS). Files in \`.gitignore\`, pulled from secure storage in CI |
| Auth | \`@react-native-firebase/auth\` configured with email/password and Google Sign-In providers. Auth state listener wired to Zustand \`auth-store\` |
| Firestore | \`@react-native-firebase/firestore\` with persistence enabled. Security rules skeleton in \`firestore.rules\` |
| Cloud Messaging | \`@react-native-firebase/messaging\` with permission request flow and token registration service |
| Crashlytics | \`@react-native-firebase/crashlytics\` enabled in non-dev builds |
| Analytics | \`@react-native-firebase/analytics\` with screen tracking middleware for React Navigation |

**Sensitive files added to \`.gitignore\`:**

\`\`\`
google-services.json
GoogleService-Info.plist
.env
.env.*
!.env.example
\`\`\`

\`.env.example\` committed with placeholder keys and documentation comments.

### D8 — Internationalization (i18n)

| Item | Detail |
|------|--------|
| Library | \`i18next\` + \`react-i18next\` + \`expo-localization\` |
| Default locale | \`en\` |
| Structure | \`src/i18n/locales/en.json\`, \`src/i18n/locales/es.json\` (stub) |
| Typed keys | Auto-generated types from \`en.json\` via \`i18next\` resource inference |
| Convention | All user-facing strings referenced via \`t('feature.screen.key')\` — no hardcoded strings in components |

### D9 — Shared UI Component Stubs

Create foundational components in \`src/components/\` with:

- \`Button\` — primary, secondary, outline, destructive variants; loading state; accessibility label required prop
- \`Input\` — text, password, email types; error state; accessibility hint
- \`Card\` — pressable variant with haptic feedback
- \`Modal\` — bottom sheet and center modal variants
- \`Loading\` — full-screen and inline spinner variants

Each component has:
- TypeScript props interface
- Basic implementation with theme tokens
- Unit test file with at least one render test
- Storybook-compatible export (optional, for future Storybook integration)

### D10 — Testing Infrastructure

| Layer | Tool | Config |
|-------|------|--------|
| Unit / Component | Jest + React Native Testing Library | \`jest.config.ts\` with \`preset: 'jest-expo'\`, \`transformIgnorePatterns\` for node_modules, \`moduleNameMapper\` for path aliases, coverage threshold 75% (branches, functions, lines, statements) |
| E2E | Detox | \`.detoxrc.js\` with iOS simulator and Android emulator configs, \`e2e/jest.config.ts\`, \`e2e/environment.ts\`, one smoke test (\`app-launches.e2e.ts\`) |
| Mocks | \`__mocks__/\` | Firebase modules, \`expo-secure-store\`, \`react-native-reanimated\`, \`@react-navigation\` |

**Verification:**

\`\`\`bash
pnpm test              # Jest suite passes, coverage ≥ 75%
pnpm test:e2e:ios      # Detox smoke test passes on iOS simulator
pnpm test:e2e:android  # Detox smoke test passes on Android emulator
\`\`\`

### D11 — CI/CD Pipeline (GitHub Actions + EAS)

Create \`.github/workflows/ci.yml\`:

\`\`\`
Trigger: push to any branch, PR to main

Jobs:
  1. lint        — pnpm lint
  2. typecheck   — pnpm typecheck
  3. test        — pnpm test --coverage (fail if < 75%)
  4. build-ios   — eas build -p ios --profile staging --non-interactive (PR to main only)
  5. build-android — eas build -p android --profile staging --non-interactive (PR to main only)
  6. e2e         — Detox on iOS simulator (main branch only, post-build)
\`\`\`

Create \`.github/workflows/deploy-staging.yml\`:

\`\`\`
Trigger: push to main

Jobs:
  1. eas-update  — eas update --branch staging --auto
\`\`\`

Create \`.github/workflows/deploy-production.yml\`:

\`\`\`
Trigger: manual (workflow_dispatch) with version tag input

Jobs:
  1. build-ios-prod     — eas build -p ios --profile production
  2. build-android-prod — eas build -p android --profile production
  3. submit-ios         — eas submit -p ios
  4. submit-android     — eas submit -p android
\`\`\`

EAS profiles in \`eas.json\`:

\`\`\`json
{
  "build": {
    "development": {
      "developmentClient": true,
      "distribution": "internal"
    },
    "staging": {
      "distribution": "internal",
      "channel": "staging",
      "env": { "APP_ENV": "staging" }
    },
    "production": {
      "distribution": "store",
      "channel": "production",
      "env": { "APP_ENV": "production" },
      "autoIncrement": true
    }
  },
  "submit": {
    "production": {
      "ios": { "appleId": "PLACEHOLDER", "ascAppId": "PLACEHOLDER" },
      "android": { "serviceAccountKeyPath": "./play-store-key.json" }
    }
  }
}
\`\`\`

### D12 — CODEOWNERS & PR Templates

\`.github/CODEOWNERS\`:

\`\`\`
# Default
*                           @team-mobile-leads

# Sensitive paths
src/services/auth/**        @team-mobile-leads @security-reviewer
src/config/**               @team-mobile-leads
google-services.json        @team-mobile-leads
GoogleService-Info.plist    @team-mobile-leads
.env*                       @team-mobile-leads
firestore.rules             @team-mobile-leads @security-reviewer
src/features/payments/**    @team-mobile-leads @security-reviewer

# CI/CD
.github/**                  @team-mobile-leads
eas.json                    @team-mobile-leads
\`\`\`

\`.github/pull_request_template.md\` with sections: Summary, Ticket, Type (feat/fix/chore), Screenshots (required for UI changes), Testing (manual + automated), Checklist (lint, typecheck, tests, accessibility, i18n, AI disclosure).

### D13 — Security Baseline

| Item | Implementation |
|------|---------------|
| Secure storage | \`expo-secure-store\` for tokens, biometric keys. Never use \`AsyncStorage\` for secrets |
| Certificate pinning | \`react-native-ssl-pinning\` configured for Firebase endpoints in production builds |
| Code obfuscation | Hermes bytecode (default in Expo SDK 51) + ProGuard for Android release builds |
| Environment secrets | \`.env\` files excluded from git; CI secrets via GitHub Actions secrets + EAS secrets |
| Dependency audit | \`pnpm audit\` added to CI; Dependabot configured for weekly scans |
| Privacy | GDPR consent flow stub in \`src/features/auth/screens/consent-screen.tsx\`; data deletion endpoint documented |

### D14 — Developer Experience

| Item | Detail |
|------|--------|
| \`pnpm dev\` | Alias for \`npx expo start --dev-client\` |
| \`pnpm dev:ios\` | \`npx expo run:ios\` |
| \`pnpm dev:android\` | \`npx expo run:android\` |
| \`pnpm lint\` | \`eslint src/ --ext .ts,.tsx\` |
| \`pnpm format\` | \`prettier --write "src/**/*.{ts,tsx}"\` |
| \`pnpm format:check\` | \`prettier --check "src/**/*.{ts,tsx}"\` |
| \`pnpm typecheck\` | \`tsc --noEmit\` |
| \`pnpm test\` | \`jest --coverage\` |
| \`pnpm test:watch\` | \`jest --watch\` |
| \`pnpm test:e2e:ios\` | \`detox test -c ios.sim.staging\` |
| \`pnpm test:e2e:android\` | \`detox test -c android.emu.staging\` |
| \`pnpm build:staging:ios\` | \`eas build -p ios --profile staging\` |
| \`pnpm build:staging:android\` | \`eas build -p android --profile staging\` |
| \`pnpm clean\` | \`expo start --clear && watchman watch-del-all\` |
| VS Code settings | \`.vscode/settings.json\` with format-on-save, ESLint auto-fix, path alias intellisense |
| VS Code extensions | Recommended: ESLint, Prettier, React Native Tools, GitLens, Error Lens |

---

## Quality Gates

All gates must pass before advancing to Phase 04.

### QG-1: Project Builds Successfully

- [ ] \`pnpm install\` completes with zero errors
- [ ] \`npx expo start\` launches Metro bundler without errors
- [ ] \`npx expo run:ios\` builds and launches on iOS simulator
- [ ] \`npx expo run:android\` builds and launches on Android emulator
- [ ] EAS staging build succeeds for both iOS and Android

### QG-2: Tooling Pipeline Green

- [ ] \`pnpm lint\` — zero errors, zero warnings
- [ ] \`pnpm format:check\` — all files pass
- [ ] \`pnpm typecheck\` — zero TypeScript errors
- [ ] \`pnpm test\` — all tests pass, coverage ≥ 75%
- [ ] Husky pre-commit hook runs lint-staged successfully
- [ ] Commitlint rejects non-conventional commit messages

### QG-3: Navigation Shell Functional

- [ ] App launches to auth flow (unauthenticated) or main tabs (authenticated)
- [ ] All stub screens render without crashes
- [ ] Deep link \`reactnativemobileapp://home\` resolves correctly
- [ ] Navigation types catch invalid route names at compile time
- [ ] Back navigation works correctly on both platforms

### QG-4: Firebase Services Connected

- [ ] Firebase Auth sign-in/sign-out flow works in dev environment
- [ ] Firestore read/write succeeds from the app
- [ ] Push notification permission prompt appears on first launch
- [ ] FCM token is registered and logged
- [ ] Crashlytics receives test crash report
- [ ] Analytics logs screen view events

### QG-5: State Management Wired

- [ ] Zustand auth store reflects Firebase auth state changes
- [ ] Theme toggle persists across app restarts
- [ ] React Query fetches and caches data correctly
- [ ] WatermelonDB creates local database and runs initial migration

### QG-6: CI/CD Pipeline Operational

- [ ] GitHub Actions \`ci.yml\` runs on PR and passes all jobs
- [ ] EAS Build completes for staging profile (iOS + Android)
- [ ] \`deploy-staging.yml\` pushes OTA update via EAS Update
- [ ] CODEOWNERS triggers correct reviewers on PR
- [ ] Dependabot creates dependency update PRs

### QG-7: Security Baseline Met

- [ ] No secrets in git history (\`git log --all -p | grep -i "api_key"\` returns nothing)
- [ ] \`expo-secure-store\` used for all sensitive data
- [ ] \`.env.example\` committed with placeholder values only
- [ ] \`pnpm audit\` reports no critical or high vulnerabilities
- [ ] Firebase security rules deny unauthenticated access by default

### QG-8: Accessibility Baseline

- [ ] All interactive components have \`accessibilityLabel\` props
- [ ] Screen reader (VoiceOver / TalkBack) can navigate the tab bar
- [ ] Touch targets meet minimum 44x44pt size
- [ ] Color contrast ratios meet WCAG AA for all theme tokens

---

## Task Breakdown

### Sprint 1 (Week 1)

| # | Task | Owner | Est. |
|---|------|-------|------|
| 1 | Initialize Expo project with TypeScript strict mode | Lead | 2h |
| 2 | Configure path aliases in \`tsconfig.json\` and Metro | Lead | 1h |
| 3 | Create directory structure with barrel exports | Mid | 2h |
| 4 | Set up ESLint, Prettier, Husky, commitlint | Mid | 3h |
| 5 | Implement theme system (tokens, provider, hook) | Senior | 4h |
| 6 | Build navigation shell with typed navigators | Senior | 6h |
| 7 | Configure Zustand stores (auth, theme, preferences) | Mid | 3h |
| 8 | Set up TanStack Query provider and query key factory | Mid | 2h |
| 9 | Initialize WatermelonDB with schema v1 | Senior | 4h |
| 10 | Create shared UI component stubs with tests | Junior + Mid | 6h |

### Sprint 2 (Week 2)

| # | Task | Owner | Est. |
|---|------|-------|------|
| 11 | Integrate Firebase Auth with Zustand auth store | Senior | 4h |
| 12 | Configure Firestore with persistence and security rules | Senior | 3h |
| 13 | Set up Cloud Messaging (permission flow, token registration) | Mid | 4h |
| 14 | Integrate Crashlytics and Analytics | Mid | 2h |
| 15 | Set up i18n with typed translation keys | Junior | 3h |
| 16 | Configure Jest, RNTL, and mock files | Mid | 3h |
| 17 | Configure Detox with smoke test | Senior | 4h |
| 18 | Build GitHub Actions CI pipeline | Lead | 4h |
| 19 | Configure EAS Build profiles and EAS Submit | Lead | 3h |
| 20 | Set up CODEOWNERS, PR template, Dependabot | Lead | 1h |
| 21 | Security audit: secrets, secure storage, audit | Lead | 2h |
| 22 | Write developer onboarding guide in \`docs/\` | Junior | 2h |

---

## Risk Register

| Risk | Likelihood | Impact | Mitigation |
|------|-----------|--------|------------|
| Native module compatibility issues with Expo SDK 51 | Medium | High | Use \`expo-dev-client\` for custom native modules; test early on both platforms |
| EAS Build queue delays blocking CI | Medium | Medium | Use \`--non-interactive\` flag; consider EAS priority plan; cache builds |
| WatermelonDB JSI bridge issues on Hermes | Low | High | Test on both platforms in Sprint 1; have AsyncStorage fallback plan |
| Firebase config files accidentally committed | Medium | Critical | \`.gitignore\` entries verified; pre-commit hook scans for sensitive patterns |
| Path alias resolution failures in Jest/Metro | Medium | Low | Configure \`moduleNameMapper\` in Jest and \`resolver\` in Metro simultaneously |
| Detox flakiness on CI | High | Medium | Run E2E only on main branch; use retry logic; consider dedicated CI device |

---

## Definition of Done

- [ ] All deliverables (D1–D14) completed and merged to \`main\`
- [ ] All quality gates (QG-1–QG-8) passing
- [ ] Zero critical or high vulnerabilities in \`pnpm audit\`
- [ ] Developer onboarding guide tested by at least one team member doing a fresh clone
- [ ] Staging build installable via internal distribution (TestFlight / Firebase App Distribution)
- [ ] Phase retrospective completed and documented
- [ ] \`playbook/current-phase.json\` updated to \`{ "phase": 4 }\`

---

## Claude Code Integration

During this phase, Claude can assist with:

- **Scaffolding**: \`/project:plan\` to generate task lists from this phase document
- **Navigation typing**: Ask Claude to generate \`RootStackParamList\` and navigator boilerplate from screen definitions
- **Theme generation**: Provide Figma token JSON and ask Claude to generate typed theme files
- **Test writing**: \`/project:tdd\` to generate tests for shared components
- **CI debugging**: \`/project:build-fix\` when EAS Build or GitHub Actions fail
- **Firebase rules**: Ask Claude to generate Firestore security rules from data model

**AI disclosure**: All AI-generated code during this phase must include the \`// AI-assisted\` comment and be disclosed in the PR checklist per [AI Usage Policy](../../docs/AI-USAGE-POLICY.md).`,

  'playbook/phases/04-core-implementation.md': `# Phase 04: Core Implementation

## Overview

Core Implementation is the primary development phase where the React Native application's essential features are built, integrated, and validated. This phase transforms the architecture and scaffolding from Phase 03 into working, tested functionality across both iOS and Android platforms. The focus is on feature completeness, offline-first data flow, Firebase integration, and cross-platform parity.

## Objectives

1. **Implement all core features** defined in the product backlog across feature modules (\`src/features/\`)
2. **Integrate Firebase services** — Authentication, Firestore, Cloud Functions, Cloud Messaging, Storage
3. **Build offline-first data layer** with WatermelonDB sync to Firestore
4. **Implement typed navigation** with React Navigation v6 including deep linking
5. **Wire state management** — Zustand for client state, React Query for server state with proper cache invalidation
6. **Achieve cross-platform parity** — all features working on both iOS and Android with platform-specific adaptations where needed
7. **Maintain test coverage** at or above 75% throughout development
8. **Internationalize all user-facing text** through the i18n system
9. **Ensure accessibility** — all interactive elements have accessibility labels and support screen readers

## Prerequisites

- Phase 03 (Scaffolding & Foundation) completed and validated
- Project scaffolding in place: navigation shell, theme system, shared components, Firebase SDK initialized
- WatermelonDB schema defined and migration strategy established
- CI/CD pipeline (GitHub Actions + EAS Build) running green on \`main\`
- Design tokens and shared component library (\`src/components/\`) available
- API contracts for Cloud Functions documented

## Feature Implementation Order

Features are implemented in dependency order. Each feature follows the feature-based architecture under \`src/features/\`:

### Wave 1: Authentication & User Foundation

**Feature: \`src/features/auth/\`**

| Deliverable | Description |
|---|---|
| Email/password authentication | Firebase Auth with email/password sign-up, sign-in, password reset |
| Social authentication | Google Sign-In and Apple Sign-In (required for App Store) |
| Biometric authentication | Face ID / Touch ID (iOS), Fingerprint / Face Unlock (Android) via \`expo-local-authentication\` |
| Secure token storage | Access/refresh tokens stored in Keychain (iOS) / Keystore (Android) via \`expo-secure-store\` |
| Auth state persistence | Zustand auth store hydrated from secure storage on app launch |
| Session management | Token refresh, session expiry handling, force logout on revocation |
| Auth navigation guard | Typed navigation that redirects unauthenticated users to auth flow |

**Feature: \`src/features/profile/\`**

| Deliverable | Description |
|---|---|
| Profile screen | Display user info, avatar, account settings |
| Edit profile | Update display name, avatar (Firebase Storage upload), preferences |
| Account deletion | GDPR-compliant account and data deletion flow with confirmation |
| Privacy settings | Consent management for analytics, crash reporting, marketing |

### Wave 2: Core Data & Offline

**Feature: \`src/features/home/\`**

| Deliverable | Description |
|---|---|
| Home feed screen | Primary content display with pull-to-refresh and infinite scroll |
| Offline-first data loading | WatermelonDB local reads with background Firestore sync |
| Optimistic updates | Immediate UI updates with rollback on sync failure |
| Empty states | Meaningful empty states for no data, offline, and error conditions |
| Skeleton loading | Content placeholders during initial data fetch |

**Shared: \`src/services/sync/\`**

| Deliverable | Description |
|---|---|
| WatermelonDB sync engine | Bidirectional sync between WatermelonDB and Firestore |
| Conflict resolution | Last-write-wins with server authority, conflict logging |
| Sync status indicator | UI component showing sync state (synced, syncing, pending, error) |
| Background sync | Sync triggered on app foreground, network reconnect, and periodic interval |
| Sync queue | Offline mutations queued and replayed when connectivity returns |

### Wave 3: Engagement & Monetization

**Feature: \`src/features/notifications/\`**

| Deliverable | Description |
|---|---|
| Push notification registration | Firebase Cloud Messaging token registration and refresh |
| Notification permissions | Platform-appropriate permission request flow with rationale |
| Foreground notifications | In-app notification display when app is active |
| Background/quit handling | Deep link routing from notification tap in all app states |
| Notification preferences | Per-category opt-in/opt-out synced to Firestore |
| Notification history | In-app notification center with read/unread state |

**Feature: \`src/features/payments/\`**

| Deliverable | Description |
|---|---|
| In-app purchase setup | \`react-native-iap\` configured for App Store and Google Play |
| Subscription management | Subscribe, upgrade, downgrade, cancel flows |
| Purchase restoration | Restore purchases on new device or reinstall |
| Receipt validation | Server-side receipt validation via Cloud Functions |
| Paywall screen | Feature-gated content with subscription offering |
| Subscription status | Zustand store reflecting current entitlements, synced with backend |

### Wave 4: Cross-Cutting Concerns

**Shared services and infrastructure built alongside feature waves:**

| Deliverable | Location | Description |
|---|---|---|
| Analytics service | \`src/services/analytics/\` | Firebase Analytics + custom events, screen tracking via navigation |
| Crash reporting | \`src/services/crash-reporting/\` | Sentry + Firebase Crashlytics, breadcrumbs, user context |
| Deep linking | \`src/navigation/linking.ts\` | Universal Links (iOS) + App Links (Android), typed route mapping |
| Error boundaries | \`src/components/ErrorBoundary.tsx\` | Graceful error recovery with crash report submission |
| Network monitor | \`src/hooks/useNetworkStatus.ts\` | NetInfo-based connectivity tracking, offline banner |
| App lifecycle | \`src/hooks/useAppState.ts\` | Foreground/background handling, sync triggers, analytics sessions |
| Secure HTTP client | \`src/services/api/client.ts\` | Axios/fetch wrapper with auth headers, certificate pinning, retry logic |
| Feature flags | \`src/services/feature-flags/\` | Firebase Remote Config for gradual rollouts |

## Technical Standards

### Code Organization

Every feature module follows this structure:

\`\`\`
src/features/{feature}/
  screens/           # Screen components (one per route)
  components/        # Feature-specific UI components
  hooks/             # Feature-specific hooks (data fetching, business logic)
  services/          # Feature-specific API/service calls
  types/             # Feature-specific TypeScript types
  __tests__/         # Unit and component tests
  index.ts           # Public API barrel export
\`\`\`

### TypeScript

- Strict mode enforced (\`strict: true\` in tsconfig)
- No \`any\` — use \`unknown\` with type guards or proper generics
- All React Navigation routes and params fully typed
- All Zustand stores typed with interfaces
- All React Query keys and return types typed
- All WatermelonDB models typed with decorators

### State Management Rules

| State Type | Tool | Example |
|---|---|---|
| Server/async data | React Query (TanStack Query) | Firestore documents, Cloud Function responses |
| Client/UI state | Zustand | Auth session, theme preference, onboarding progress |
| Local persistent data | WatermelonDB | Offline-first content, cached user data |
| Form state | React Hook Form or local \`useState\` | Input fields, validation |
| Navigation state | React Navigation | Route params, navigation history |

### Naming Conventions

| Element | Convention | Example |
|---|---|---|
| Screen components | PascalCase + \`Screen\` suffix | \`HomeScreen.tsx\`, \`LoginScreen.tsx\` |
| UI components | PascalCase | \`SyncStatusBadge.tsx\`, \`NotificationCard.tsx\` |
| Hooks | camelCase + \`use\` prefix | \`useAuth.ts\`, \`useOfflineSync.ts\` |
| Services | camelCase | \`analyticsService.ts\`, \`pushNotificationService.ts\` |
| Zustand stores | camelCase + \`Store\` suffix | \`authStore.ts\`, \`themeStore.ts\` |
| Constants | SCREAMING_SNAKE_CASE | \`MAX_RETRY_COUNT\`, \`SYNC_INTERVAL_MS\` |
| Files | kebab-case | \`sync-status-badge.tsx\`, \`use-offline-sync.ts\` |
| Test files | Same as source + \`.test\` | \`use-auth.test.ts\`, \`LoginScreen.test.tsx\` |

### File Length

- Maximum 250 lines per file
- Extract hooks, utilities, and sub-components when approaching the limit
- Screen components should primarily compose feature components and hooks

### Accessibility

- All \`TouchableOpacity\`, \`Pressable\`, \`Button\` elements must have \`accessibilityLabel\`
- All \`Image\` elements must have \`accessibilityLabel\` (or \`accessibilityElementsHidden\` if decorative)
- Form inputs must have \`accessibilityLabel\` and \`accessibilityHint\`
- Screen readers tested on both VoiceOver (iOS) and TalkBack (Android)
- Minimum touch target size: 44×44 points

### Internationalization

- All user-facing strings go through \`src/i18n/\`
- No hardcoded strings in components — use translation keys
- Support RTL layouts where applicable
- Date/number formatting via locale-aware formatters

## Testing Requirements

### Unit Tests (Jest)

- All hooks in \`src/hooks/\` and \`src/features/*/hooks/\`
- All utility functions in \`src/utils/\`
- All Zustand store actions and selectors
- All service functions (mocked Firebase SDK)
- WatermelonDB model methods

### Component Tests (React Native Testing Library)

- All shared components in \`src/components/\`
- All screen components (render, user interaction, navigation)
- Test offline states, loading states, error states, empty states
- Test accessibility: \`getByLabelText\`, \`getByRole\`

### Integration Tests

- React Query + mock API: verify cache behavior, optimistic updates, error handling
- Navigation flows: auth guard redirects, deep link resolution
- WatermelonDB + sync: verify local writes, sync queue, conflict resolution

### E2E Tests (Detox)

- Critical user journeys:
  - Sign up → onboarding → home feed
  - Login → biometric unlock
  - Offline usage → reconnect → sync
  - Push notification → deep link → target screen
  - Purchase subscription → access gated content
- Run on both iOS Simulator and Android Emulator
- Executed in CI via \`npx detox test --configuration ios.sim.release\`

### Coverage

- Minimum 75% line coverage enforced in CI
- Coverage reported per feature module
- New code must not decrease overall coverage

## Quality Gates

All quality gates must pass before Phase 04 is considered complete:

### Gate 1: Feature Completeness

- [ ] All Wave 1–4 deliverables implemented and functional
- [ ] All screens render correctly on iOS and Android
- [ ] Cross-platform parity verified — no iOS-only or Android-only gaps
- [ ] All user-facing text internationalized
- [ ] All interactive elements have accessibility labels

### Gate 2: Offline-First Validation

- [ ] App launches and displays cached data with no network
- [ ] Mutations made offline are queued and synced on reconnect
- [ ] Sync conflicts resolved correctly (last-write-wins with logging)
- [ ] Sync status indicator reflects actual state
- [ ] No data loss during airplane mode → reconnect cycle

### Gate 3: Firebase Integration

- [ ] Authentication flows work (email, social, biometric)
- [ ] Firestore reads/writes function with proper security rules
- [ ] Cloud Functions respond correctly and handle errors
- [ ] Push notifications delivered on both platforms in all app states
- [ ] Firebase Storage uploads/downloads work with proper access control
- [ ] Analytics events fire correctly and appear in Firebase Console
- [ ] Crashlytics captures crashes with proper symbolication

### Gate 4: Security

- [ ] Auth tokens stored in Keychain (iOS) / Keystore (Android) — not AsyncStorage
- [ ] Certificate pinning configured for API endpoints
- [ ] No sensitive data in logs (redacted in production builds)
- [ ] GDPR consent flow implemented and functional
- [ ] Account deletion removes all user data from Firestore and Storage
- [ ] App Transport Security (iOS) and Network Security Config (Android) properly configured
- [ ] ProGuard/R8 (Android) and bitcode (iOS) enabled for release builds

### Gate 5: Testing

- [ ] Unit test coverage ≥ 75%
- [ ] All component tests passing
- [ ] Detox E2E suite passing on iOS and Android
- [ ] No flaky tests (re-run 3x with zero failures)
- [ ] Test execution time < 10 minutes for unit/component suite

### Gate 6: Performance

- [ ] App cold start < 2 seconds on mid-range devices
- [ ] Screen transitions < 300ms (no dropped frames)
- [ ] List scrolling at 60fps (Flashlist/FlatList optimized)
- [ ] Bundle size within budget (iOS < 50MB, Android < 40MB)
- [ ] No memory leaks detected in extended usage (Instruments/Android Profiler)
- [ ] Hermes engine enabled and bytecode precompiled

### Gate 7: CI/CD

- [ ] All CI checks passing on \`main\`: lint, type check, unit tests, component tests
- [ ] EAS Build succeeds for both iOS and Android (staging profile)
- [ ] EAS Update (OTA) deploys to staging channel
- [ ] Detox E2E runs in CI against built artifacts
- [ ] Build artifacts signed with correct certificates/keystores

### Gate 8: Code Quality

- [ ] Zero ESLint errors, zero TypeScript errors
- [ ] No \`any\` types in codebase
- [ ] All files under 250 lines
- [ ] Feature modules follow prescribed directory structure
- [ ] CODEOWNERS file covers all sensitive paths
- [ ] AI-generated code marked per AI Usage Policy

## Sprint Cadence

Core Implementation typically spans 4–6 two-week sprints:

| Sprint | Focus | Key Deliverables |
|---|---|---|
| Sprint 1 | Wave 1 — Auth | Email/social auth, biometrics, secure storage, auth navigation |
| Sprint 2 | Wave 1 + Wave 2 start | Profile, account deletion, home screen shell, WatermelonDB sync |
| Sprint 3 | Wave 2 — Offline data | Home feed, offline-first reads/writes, sync engine, conflict resolution |
| Sprint 4 | Wave 3 — Notifications | Push registration, foreground/background handling, deep linking |
| Sprint 5 | Wave 3 — Payments | IAP setup, subscriptions, receipt validation, paywall |
| Sprint 6 | Wave 4 + Hardening | Analytics, crash reporting, performance optimization, E2E tests |

## Developer Workflow

### Daily Development

\`\`\`bash
# Start Expo dev server
npx expo start

# Run on iOS Simulator
npx expo run:ios

# Run on Android Emulator
npx expo run:android

# Run tests in watch mode
pnpm test --watch

# Type check
pnpm tsc --noEmit

# Lint
pnpm lint
\`\`\`

### Before Opening a PR

\`\`\`bash
# Full verification
pnpm lint && pnpm tsc --noEmit && pnpm test --coverage

# Ensure coverage threshold met
# Check: coverage/lcov-report/index.html

# Run E2E locally (optional but recommended for navigation/sync changes)
npx detox build --configuration ios.sim.debug
npx detox test --configuration ios.sim.debug
\`\`\`

### Branch Naming

\`\`\`
feat/APP-42-add-push-notifications
fix/APP-58-offline-sync-conflict
chore/APP-63-upgrade-expo-sdk
\`\`\`

### Commit Messages

\`\`\`
feat(notifications): add FCM token registration and refresh
fix(sync): resolve conflict when offline edits overlap
test(auth): add biometric unlock component tests
chore(deps): upgrade react-native-iap to 12.x
\`\`\`

## Risk Mitigation

| Risk | Likelihood | Impact | Mitigation |
|---|---|---|---|
| WatermelonDB sync conflicts cause data loss | Medium | High | Comprehensive conflict resolution with server authority; sync event logging; automated sync tests |
| Native module incompatibility across platforms | Medium | Medium | Test on both platforms in every PR; use Expo Modules API where possible; maintain platform-specific test matrix |
| Push notification delivery failures | Medium | Medium | Implement delivery receipts; fallback to in-app polling; monitor FCM delivery metrics |
| In-app purchase edge cases (restore, refund) | High | High | Server-side receipt validation; extensive E2E testing of purchase flows; handle all StoreKit/Billing Library error codes |
| Performance regression on low-end Android | Medium | Medium | Profile on budget Android device; enforce Hermes; monitor bundle size in CI; use Flashlist for long lists |
| App Store / Google Play rejection | Low | High | Follow platform guidelines strictly; implement required privacy flows; test on physical devices before submission |

## Handoff to Phase 05

Phase 04 is complete when all quality gates pass. The handoff to Phase 05 (Hardening & Polish) includes:

- All core features implemented and tested
- CI/CD pipeline building and deploying to staging
- Test coverage at or above 75%
- No critical or high-severity bugs open
- Performance baselines established
- Staging build available for QA and stakeholder review

Update the phase tracker:

\`\`\`bash
./playbook/codeforge-phase.sh set 5
\`\`\``,

  'playbook/phases/05-integration-hardening.md': `# Phase 05: Integration & Hardening

## Overview

Integration & Hardening brings all feature modules, native integrations, and backend services together into a cohesive, production-ready React Native application. This phase focuses on end-to-end flows, cross-platform parity, performance optimization, security hardening, offline resilience, and compliance readiness. No new features are introduced — the goal is to make everything already built work reliably under real-world conditions.

## Objectives

1. **End-to-End Integration** — Wire all feature modules through complete user journeys (onboarding → auth → home → payments → notifications)
2. **Cross-Platform Parity** — Verify identical behavior and visual consistency on iOS and Android across device classes
3. **Offline Hardening** — Stress-test WatermelonDB sync, conflict resolution, and graceful degradation under network loss
4. **Performance Optimization** — Achieve target startup time, frame rate, memory usage, and bundle size thresholds
5. **Security Hardening** — Implement certificate pinning, secure storage audit, code obfuscation, and penetration testing
6. **Compliance Readiness** — Finalize GDPR consent flows, App Store privacy labels, Google Play data safety declarations
7. **E2E Test Coverage** — Detox test suites covering all critical user paths on both platforms
8. **CI/CD Pipeline Hardening** — Stable EAS Build pipelines for staging and production with signing, versioning, and distribution

## Prerequisites

- Phase 04 (Core Implementation) completed and all quality gates passed
- All feature modules (\`auth\`, \`home\`, \`profile\`, \`notifications\`, \`payments\`) individually functional
- Firebase services (Auth, Firestore, Cloud Functions, Cloud Messaging, Storage) deployed to staging
- WatermelonDB sync adapter operational against staging Firestore
- React Navigation deep linking configuration in place
- Unit and component test coverage ≥ 75%

## Duration

**2–3 weeks** (depending on platform-specific issues discovered during integration)

## Deliverables

### 5.1 End-to-End Flow Integration

- [ ] Complete onboarding → registration → email verification → home flow
- [ ] Complete login → biometric prompt → home → tab navigation flow
- [ ] Complete push notification received → deep link → target screen flow
- [ ] Complete in-app purchase → receipt validation → entitlement unlock flow
- [ ] Complete profile update → Firestore sync → WatermelonDB local update flow
- [ ] Complete offline action queue → reconnect → sync → conflict resolution flow
- [ ] Navigation state persistence across app kills and restarts
- [ ] Universal link / App Link handling for all registered deep link routes
- [ ] Error boundary coverage on every navigator and screen with crash reporting to Sentry

### 5.2 Cross-Platform Verification

- [ ] Visual regression audit on iOS (iPhone SE, iPhone 15, iPhone 15 Pro Max, iPad)
- [ ] Visual regression audit on Android (small phone, standard phone, tablet, foldable)
- [ ] Platform-specific behavior verified:
  - iOS: Keychain storage, APNs push, StoreKit 2 purchases, Face ID / Touch ID
  - Android: Keystore storage, FCM push, Google Play Billing, fingerprint / face unlock
- [ ] Safe area handling on all device classes (notch, Dynamic Island, navigation bar)
- [ ] Keyboard avoidance behavior consistent across both platforms
- [ ] RTL layout support verified for i18n locales that require it
- [ ] Dark mode / light mode transitions smooth on both platforms
- [ ] Accessibility audit: screen reader navigation (VoiceOver + TalkBack), minimum touch targets (44pt), contrast ratios

### 5.3 Offline-First Hardening

- [ ] WatermelonDB sync stress test: 1000+ records, concurrent writes, conflict scenarios
- [ ] Conflict resolution strategy documented and tested:
  - Last-write-wins for non-critical fields
  - Server-wins for payment/entitlement data
  - User-prompted merge for profile edits with divergent changes
- [ ] Offline action queue (\`src/services/offline/action-queue.ts\`):
  - Actions persisted to local storage
  - Automatic replay on reconnect with exponential backoff
  - Failed action retry with user notification after max attempts
- [ ] Network state detection (\`src/hooks/useNetworkStatus.ts\`) tested across:
  - WiFi → cellular transition
  - Airplane mode toggle
  - Slow network simulation (2G/3G)
  - Complete network loss during active sync
- [ ] Offline UI indicators on all screens that depend on server data
- [ ] Firestore offline persistence configuration verified (cache size limits, garbage collection)

### 5.4 Performance Optimization

- [ ] **Startup time**: Cold start < 2s on mid-range devices (measured via \`react-native-performance\`)
- [ ] **Frame rate**: 60fps during scrolling and navigation transitions (Flipper profiling)
- [ ] **Bundle size**: JavaScript bundle < 5MB (Hermes bytecode), total app binary < 50MB
- [ ] **Memory**: No memory leaks detected after 30-minute usage session
- [ ] Optimization actions completed:
  - Hermes engine enabled and verified on both platforms
  - React Navigation lazy loading for all tab screens
  - Image optimization: WebP format, progressive loading, caching via \`expo-image\`
  - FlatList optimization: \`getItemLayout\`, \`windowSize\`, \`maxToRenderPerBatch\` tuned
  - Zustand store selectors to prevent unnecessary re-renders
  - React Query stale time and cache time tuned per query type
  - Lottie animations converted to reduced-frame versions for low-end devices
  - Tree shaking verified — no unused Firebase modules in bundle
- [ ] Bundle analysis report generated (\`npx react-native-bundle-visualizer\`)
- [ ] Flipper performance traces captured and archived in \`docs/performance/\`

### 5.5 Security Hardening

- [ ] **Secure Storage Audit**
  - Authentication tokens stored in \`expo-secure-store\` (Keychain on iOS, Keystore on Android)
  - No sensitive data in AsyncStorage or plain-text files
  - Biometric authentication gating access to secure store
- [ ] **Certificate Pinning**
  - SSL pinning configured for Firebase API endpoints and any custom backend
  - Pinning bypass detection for jailbroken/rooted devices
  - Pin rotation strategy documented with backup pins
- [ ] **Code Obfuscation**
  - Hermes bytecode compilation (inherent obfuscation)
  - ProGuard rules configured for Android release builds
  - No API keys or secrets in JavaScript bundle (verified via \`grep\` on bundle output)
- [ ] **Runtime Security**
  - Jailbreak/root detection with graceful degradation (warning, not hard block)
  - Screenshot prevention on sensitive screens (payment, auth)
  - App Transport Security enforced on iOS (no HTTP exceptions)
  - Network security config on Android (no cleartext traffic)
- [ ] **Dependency Audit**
  - \`pnpm audit\` — zero high/critical vulnerabilities
  - Native module audit — all pods and Gradle dependencies reviewed
  - Outdated dependency report generated and critical updates applied
- [ ] **Penetration Testing Checklist**
  - OWASP Mobile Top 10 review completed
  - API endpoint authorization verified (no broken access control)
  - Input validation on all user-facing forms (XSS, injection prevention)
  - Session management: token expiry, refresh rotation, logout invalidation

### 5.6 GDPR & Compliance

- [ ] **Consent Management**
  - Cookie/tracking consent modal on first launch (\`src/features/auth/screens/ConsentScreen.tsx\`)
  - Granular consent toggles: analytics, crash reporting, personalized notifications
  - Consent state persisted locally and synced to Firestore user document
  - Consent changes retroactively applied (disable analytics SDK if revoked)
- [ ] **Data Subject Rights**
  - Data export endpoint (Cloud Function) returning all user data as JSON
  - Account deletion flow: in-app request → confirmation → Cloud Function → Firestore purge → Auth deletion
  - Deletion confirmation email sent via Cloud Functions
  - 30-day grace period with cancellation option
- [ ] **App Store Privacy Labels** (iOS)
  - Data types collected documented: name, email, device ID, usage data, purchase history
  - Data linked to identity vs. not linked clearly categorized
  - Tracking declaration accurate (ATT prompt if applicable)
- [ ] **Google Play Data Safety**
  - Data safety form completed matching actual data collection
  - Data deletion policy URL configured
  - Encryption in transit declared for all data types
- [ ] **Privacy Policy & Terms**
  - In-app links to privacy policy and terms of service
  - Version-stamped policy documents in \`docs/legal/\`
  - Policy update notification mechanism (in-app banner on policy change)

### 5.7 E2E Test Suite (Detox)

- [ ] Detox configuration for iOS simulator and Android emulator in \`e2e/.detoxrc.js\`
- [ ] Critical path test specs:
  - \`e2e/auth/login.e2e.ts\` — email login, biometric login, error states
  - \`e2e/auth/registration.e2e.ts\` — full registration flow with validation
  - \`e2e/navigation/deep-linking.e2e.ts\` — universal link opens correct screen
  - \`e2e/navigation/tab-navigation.e2e.ts\` — all tabs accessible, state preserved
  - \`e2e/offline/sync.e2e.ts\` — create data offline, reconnect, verify sync
  - \`e2e/notifications/push.e2e.ts\` — notification tap opens correct deep link
  - \`e2e/payments/purchase.e2e.ts\` — sandbox purchase flow (StoreKit testing on iOS)
  - \`e2e/profile/settings.e2e.ts\` — theme toggle, language change, logout
  - \`e2e/accessibility/screen-reader.e2e.ts\` — focus order, labels, announcements
- [ ] Detox test helpers:
  - \`e2e/helpers/auth.ts\` — login/logout utilities for test setup
  - \`e2e/helpers/network.ts\` — network condition simulation
  - \`e2e/helpers/data.ts\` — test data seeding and cleanup via Firebase Admin SDK
- [ ] All E2E tests passing on both platforms in CI (GitHub Actions + EAS Build)
- [ ] E2E test execution time < 15 minutes per platform

### 5.8 CI/CD Pipeline Hardening

- [ ] **EAS Build Profiles** (\`eas.json\`):
  - \`development\` — debug build with Expo Dev Client
  - \`staging\` — release build pointing to staging Firebase project
  - \`production\` — release build pointing to production Firebase project with signing
- [ ] **GitHub Actions Workflows**:
  - \`.github/workflows/pr-checks.yml\` — lint, type check, unit tests, component tests on every PR
  - \`.github/workflows/staging-deploy.yml\` — EAS Build + EAS Update to staging channel on merge to \`main\`
  - \`.github/workflows/production-release.yml\` — EAS Build + EAS Submit on version tag (\`v*.*.*\`)
  - \`.github/workflows/e2e-tests.yml\` — Detox tests on iOS and Android (nightly or on-demand)
- [ ] **Code Signing**:
  - iOS: provisioning profiles and certificates managed via EAS credentials
  - Android: upload keystore stored in EAS secrets, not in repository
  - Signing verification step in CI before submission
- [ ] **Versioning**:
  - \`app.json\` version and \`buildNumber\`/\`versionCode\` auto-incremented by CI
  - Git tags created on production releases
  - Changelog generated from conventional commits (\`scripts/generate-changelog.sh\`)
- [ ] **Environment Management**:
  - \`.env.staging\` and \`.env.production\` loaded via \`react-native-config\`
  - Firebase config files (\`google-services.json\`, \`GoogleService-Info.plist\`) per environment
  - No secrets in source control — all via EAS secrets or GitHub Actions secrets
- [ ] **Monitoring Integration**:
  - Sentry source maps uploaded during EAS Build (\`sentry-expo\` plugin)
  - Sentry release tracking tied to \`app.json\` version
  - Firebase Crashlytics dSYM upload for iOS, mapping file upload for Android

### 5.9 Error Handling & Crash Resilience

- [ ] Global error boundary at navigation root with crash report + recovery UI
- [ ] Per-feature error boundaries wrapping each navigator stack
- [ ] Unhandled promise rejection handler logging to Sentry
- [ ] Native crash handling via Firebase Crashlytics (both platforms)
- [ ] Graceful degradation matrix documented:

| Failure Scenario | Expected Behavior |
|---|---|
| Firebase Auth unavailable | Show cached session, queue auth refresh |
| Firestore unreachable | Serve WatermelonDB local data, queue writes |
| Push notification service down | App functions normally, notifications resume on recovery |
| Payment service timeout | Show retry option, preserve cart state |
| Deep link to deleted content | Show "content unavailable" screen, navigate to home |
| Biometric hardware unavailable | Fall back to PIN/password authentication |
| Low storage on device | Warn user, reduce WatermelonDB cache, skip image caching |

## Quality Gates

All gates must pass before advancing to Phase 06 (Launch Preparation).

### Gate 5.1: Integration Completeness

- [ ] All end-to-end flows listed in §5.1 demonstrated on both iOS and Android
- [ ] No flow requires manual workarounds or known broken steps
- [ ] Deep linking tested with at least 5 distinct route patterns

### Gate 5.2: Cross-Platform Parity

- [ ] Feature parity checklist signed off by QA on both platforms
- [ ] No platform-specific crashes or visual regressions in tested device matrix
- [ ] Accessibility audit passing on both VoiceOver (iOS) and TalkBack (Android)

### Gate 5.3: Offline Resilience

- [ ] App usable for core read flows with no network for 10+ minutes
- [ ] Offline-created data syncs correctly on reconnect with no data loss
- [ ] Conflict resolution produces correct results in all tested scenarios

### Gate 5.4: Performance Thresholds

| Metric | Target | Measured | Pass? |
|---|---|---|---|
| Cold start (mid-range device) | < 2,000ms | ___ ms | ☐ |
| TTI (Time to Interactive) | < 3,000ms | ___ ms | ☐ |
| JS bundle size (Hermes) | < 5 MB | ___ MB | ☐ |
| App binary size (iOS) | < 50 MB | ___ MB | ☐ |
| App binary size (Android) | < 50 MB | ___ MB | ☐ |
| Scroll frame rate (FlatList) | ≥ 58 fps | ___ fps | ☐ |
| Navigation transition | ≥ 58 fps | ___ fps | ☐ |
| Memory after 30min session | < 300 MB | ___ MB | ☐ |
| Memory leaks detected | 0 | ___ | ☐ |

### Gate 5.5: Security

- [ ] \`pnpm audit\` reports zero high/critical vulnerabilities
- [ ] No secrets or API keys found in JavaScript bundle (automated scan)
- [ ] Secure storage audit completed — no sensitive data in plaintext
- [ ] Certificate pinning verified via proxy interception test (connection refused)
- [ ] OWASP Mobile Top 10 checklist reviewed and signed off

### Gate 5.6: Compliance

- [ ] GDPR consent flow functional with granular opt-in/opt-out
- [ ] Account deletion flow tested end-to-end (request → purge → confirmation)
- [ ] App Store privacy label draft reviewed by team lead
- [ ] Google Play data safety form draft reviewed by team lead

### Gate 5.7: Test Coverage

| Test Type | Target | Actual | Pass? |
|---|---|---|---|
| Unit test coverage | ≥ 75% | ___% | ☐ |
| Component test coverage | ≥ 75% | ___% | ☐ |
| E2E critical paths (iOS) | 100% passing | ___% | ☐ |
| E2E critical paths (Android) | 100% passing | ___% | ☐ |
| E2E execution time (per platform) | < 15 min | ___ min | ☐ |

### Gate 5.8: CI/CD Stability

- [ ] Staging EAS Build succeeds for both iOS and Android (3 consecutive green builds)
- [ ] Production EAS Build succeeds for both iOS and Android (dry run)
- [ ] EAS Update delivers OTA update to staging channel successfully
- [ ] Source maps uploaded to Sentry and symbolicated crash appears correctly
- [ ] Crashlytics receives test crash and displays symbolicated stack trace

### Gate 5.9: Error Resilience

- [ ] App does not crash on any failure scenario in the degradation matrix
- [ ] Error boundaries catch and report all simulated component failures
- [ ] Sentry receives error reports with correct release version and stack traces

## Key Commands

\`\`\`bash
# Run full test suite
pnpm test --coverage

# Type check
pnpm tsc --noEmit

# Lint
pnpm lint

# Bundle analysis
npx react-native-bundle-visualizer

# Detox E2E (iOS)
npx detox build --configuration ios.sim.release
npx detox test --configuration ios.sim.release

# Detox E2E (Android)
npx detox build --configuration android.emu.release
npx detox test --configuration android.emu.release

# EAS Build (staging)
eas build --platform all --profile staging

# EAS Update (staging OTA)
eas update --branch staging --message "Integration hardening fixes"

# Security audit
pnpm audit
npx expo-doctor

# Check for secrets in bundle
npx react-native-bundle-visualizer --output bundle-output.js
grep -rn "FIREBASE_API_KEY\\|sk_live\\|secret" bundle-output.js

# Performance profiling (start with Flipper)
npx expo start --dev-client
\`\`\`

## Risk Mitigation

| Risk | Likelihood | Impact | Mitigation |
|---|---|---|---|
| Platform-specific native module crash | Medium | High | Test on physical devices early; maintain platform-specific error boundaries |
| WatermelonDB sync conflicts cause data loss | Medium | Critical | Comprehensive conflict resolution tests; server-side backup before sync |
| EAS Build failures block release | Low | High | Cache build artifacts; maintain local build capability as fallback |
| Performance regression from integration | Medium | Medium | Performance budget enforced in CI; Flipper profiling on every integration PR |
| App Store / Play Store rejection | Low | High | Pre-submission checklist; review guidelines before submission |
| Third-party SDK breaking change | Low | Medium | Pin dependency versions; test upgrades in isolation branch |

## Team Assignments

| Deliverable | Primary | Reviewer |
|---|---|---|
| E2E flow integration | Senior dev | Lead |
| Cross-platform verification | Mid dev (iOS) + Mid dev (Android) | Senior dev |
| Offline hardening | Senior dev | Lead |
| Performance optimization | Lead | Senior dev |
| Security hardening | Lead + Senior dev | External review (if budget allows) |
| GDPR & compliance | Mid dev | Lead + Legal review |
| Detox E2E tests | Mid dev | Senior dev |
| CI/CD pipeline | Senior dev | Lead |
| Error resilience | Mid dev | Senior dev |

## Phase Completion Criteria

This phase is complete when:

1. All quality gates (5.1–5.9) are checked off and documented
2. Performance measurement table is filled with passing values
3. Test coverage table is filled with passing values
4. Staging builds are stable on both platforms (3 consecutive green builds)
5. Security audit report archived in \`docs/security/phase-05-audit.md\`
6. Compliance documentation reviewed and approved
7. Phase sign-off from team lead recorded in \`playbook/current-phase.json\`

**Next Phase**: [Phase 06 — Launch Preparation](./06-launch-preparation.md)`,

  'playbook/phases/06-testing-quality.md': `# Phase 06: Testing & Quality

## Phase Overview

**Phase**: 06-testing-quality
**Duration**: 1–2 sprints (1–2 weeks)
**Prerequisites**: Phase 04 (Core Implementation) and Phase 05 (Feature Development) substantially complete
**Outcome**: Comprehensive test coverage across unit, component, integration, and E2E layers; quality gates enforced; performance benchmarks established; crash-free rate targets validated

## Objectives

1. **Achieve ≥75% code coverage** across unit and component tests with meaningful assertions (not just snapshot coverage)
2. **Establish E2E test suite** with Detox covering critical user journeys on both iOS and Android
3. **Validate offline-first behavior** — sync, conflict resolution, and data integrity under network loss
4. **Performance benchmarking** — startup time, frame rate, memory usage, bundle size within acceptable thresholds
5. **Security audit** — authentication flows, secure storage, certificate pinning, data leakage prevention
6. **Accessibility audit** — screen reader compatibility, touch target sizes, contrast ratios, accessibility labels
7. **Privacy compliance verification** — GDPR consent flows, data deletion, App Store privacy labels, Google Play data safety
8. **Crash-free rate baseline** — establish monitoring with Sentry and Firebase Crashlytics, target ≥99.5%

## Testing Pyramid

\`\`\`
         ┌─────────┐
         │  E2E    │  Detox (iOS + Android simulators/emulators)
         │  ~10%   │  Critical user journeys only
        ┌┴─────────┴┐
        │Integration │  React Native Testing Library + MSW
        │   ~20%     │  Screen-level, navigation, API integration
       ┌┴────────────┴┐
       │  Component    │  React Native Testing Library
       │    ~30%       │  Shared components, feature components
      ┌┴──────────────┴┐
      │    Unit         │  Jest
      │    ~40%         │  Hooks, utils, services, stores, models
      └────────────────┘
\`\`\`

## Deliverables

### D1: Unit Test Suite

**Scope**: All files in \`src/hooks/\`, \`src/utils/\`, \`src/services/\`, \`src/store/\`, WatermelonDB models

**Standards**:
- Each utility function has at least one happy-path and one edge-case test
- Zustand stores tested for state transitions, selectors, and actions
- React Query hooks tested with \`QueryClientProvider\` wrapper and mocked responses
- WatermelonDB models tested for schema validation, computed fields, and relations
- Firebase service wrappers tested with mocked Firebase SDK

**File naming**: \`*.test.ts\` co-located next to source file

**Example structure**:
\`\`\`
src/
  hooks/
    use-auth.ts
    use-auth.test.ts
  utils/
    format-currency.ts
    format-currency.test.ts
  store/
    auth-store.ts
    auth-store.test.ts
  services/
    firebase/
      auth-service.ts
      auth-service.test.ts
\`\`\`

**Commands**:
\`\`\`bash
pnpm test --selectProjects unit
pnpm test --coverage --coverageReporters=lcov
\`\`\`

### D2: Component Test Suite

**Scope**: All shared components in \`src/components/\`, feature-specific components in \`src/features/*/components/\`

**Standards**:
- Test rendering, user interactions (press, swipe, type), and conditional display
- Verify accessibility labels and roles with \`getByRole\`, \`getByLabelText\`
- Test loading, error, and empty states
- Test platform-specific rendering where applicable (\`Platform.OS\` branches)
- No snapshot tests as primary assertions — use explicit queries

**Example test**:
\`\`\`typescript
// src/components/button/button.test.tsx
import { render, fireEvent, screen } from '@testing-library/react-native';
import { Button } from './button';

describe('Button', () => {
  it('renders label and responds to press', () => {
    const onPress = jest.fn();
    render(<Button label="Submit" onPress={onPress} />);

    const button = screen.getByRole('button', { name: 'Submit' });
    fireEvent.press(button);

    expect(onPress).toHaveBeenCalledTimes(1);
  });

  it('shows loading indicator when loading', () => {
    render(<Button label="Submit" onPress={jest.fn()} loading />);

    expect(screen.getByTestId('button-loading')).toBeTruthy();
    expect(screen.queryByText('Submit')).toBeNull();
  });

  it('is disabled and non-interactive when disabled prop set', () => {
    const onPress = jest.fn();
    render(<Button label="Submit" onPress={onPress} disabled />);

    fireEvent.press(screen.getByRole('button'));
    expect(onPress).not.toHaveBeenCalled();
  });
});
\`\`\`

**Commands**:
\`\`\`bash
pnpm test --selectProjects component
\`\`\`

### D3: Integration Test Suite

**Scope**: Feature screens, navigation flows, API integration with mocked backends

**Standards**:
- Screens rendered with full provider tree (navigation, query client, theme, i18n, auth context)
- API calls mocked at the network level using MSW (Mock Service Worker) or Jest mocks
- Navigation transitions verified (screen A → action → screen B)
- Deep link resolution tested via React Navigation linking config
- Offline scenarios tested by toggling network state mocks

**Test helper — render with providers**:
\`\`\`typescript
// src/test-utils/render-with-providers.tsx
import { NavigationContainer } from '@react-navigation/native';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { render, RenderOptions } from '@testing-library/react-native';
import { ThemeProvider } from '../theme/theme-provider';
import { I18nProvider } from '../i18n/i18n-provider';

const createTestQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: { retry: false, gcTime: 0 },
      mutations: { retry: false },
    },
  });

export const renderWithProviders = (
  ui: React.ReactElement,
  options?: RenderOptions,
) => {
  const queryClient = createTestQueryClient();

  return render(
    <QueryClientProvider client={queryClient}>
      <NavigationContainer>
        <ThemeProvider>
          <I18nProvider>{ui}</I18nProvider>
        </ThemeProvider>
      </NavigationContainer>
    </QueryClientProvider>,
    options,
  );
};
\`\`\`

**Commands**:
\`\`\`bash
pnpm test --selectProjects integration
\`\`\`

### D4: E2E Test Suite (Detox)

**Scope**: Critical user journeys that must never break

**Required journeys**:

| Journey | Description | Priority |
|---------|-------------|----------|
| Onboarding | App launch → welcome → sign up → verify email → home | P0 |
| Login | Launch → login → biometric prompt → home feed | P0 |
| Offline sync | Load data → airplane mode → create item → reconnect → verify sync | P0 |
| Push notification | Receive notification → tap → deep link to correct screen | P1 |
| In-app purchase | Navigate to paywall → select plan → complete purchase → verify entitlement | P1 |
| Profile update | Navigate to profile → edit fields → save → verify persistence | P1 |
| Logout | Settings → logout → confirm → redirected to login | P2 |
| Deep link | Open deep link URL → app opens to correct screen with params | P2 |

**Detox configuration** (\`.detoxrc.js\`):
\`\`\`javascript
module.exports = {
  testRunner: {
    args: { $0: 'jest', config: 'e2e/jest.config.js' },
    jest: { setupTimeout: 120000 },
  },
  apps: {
    'ios.debug': {
      type: 'ios.app',
      binaryPath: 'ios/build/Build/Products/Debug-iphonesimulator/ReactNativeMobileApp.app',
      build: 'xcodebuild -workspace ios/ReactNativeMobileApp.xcworkspace -scheme ReactNativeMobileApp -configuration Debug -sdk iphonesimulator -derivedDataPath ios/build',
    },
    'android.debug': {
      type: 'android.apk',
      binaryPath: 'android/app/build/outputs/apk/debug/app-debug.apk',
      build: 'cd android && ./gradlew assembleDebug assembleAndroidTest -DtestBuildType=debug',
    },
  },
  devices: {
    simulator: { type: 'ios.simulator', device: { type: 'iPhone 15' } },
    emulator: { type: 'android.emulator', device: { avdName: 'Pixel_7_API_34' } },
  },
  configurations: {
    'ios.sim.debug': { device: 'simulator', app: 'ios.debug' },
    'android.emu.debug': { device: 'emulator', app: 'android.debug' },
  },
};
\`\`\`

**Commands**:
\`\`\`bash
# iOS
npx detox build --configuration ios.sim.debug
npx detox test --configuration ios.sim.debug

# Android
npx detox build --configuration android.emu.debug
npx detox test --configuration android.emu.debug
\`\`\`

### D5: Performance Benchmarks

**Metrics and thresholds**:

| Metric | Target (iOS) | Target (Android) | Tool |
|--------|-------------|-------------------|------|
| Cold start (TTI) | < 2.0s | < 2.5s | Flipper / custom timer |
| JS bundle size | < 5 MB | < 5 MB | \`npx expo export --dump-sourcemap\` |
| Frame rate (scroll) | ≥ 58 FPS | ≥ 55 FPS | Flipper Performance Monitor |
| Memory (idle) | < 150 MB | < 200 MB | Xcode Instruments / Android Profiler |
| Memory (peak) | < 300 MB | < 350 MB | Xcode Instruments / Android Profiler |
| OTA update size | < 2 MB | < 2 MB | EAS Update metadata |
| Firestore cold query | < 500ms | < 500ms | Custom performance trace |
| WatermelonDB local query | < 50ms | < 50ms | Custom performance trace |

**Performance test script** (\`scripts/perf-check.sh\`):
\`\`\`bash
#!/bin/bash
set -euo pipefail

echo "📦 Checking JS bundle size..."
BUNDLE_SIZE=$(npx expo export --platform ios --output-dir /tmp/expo-export 2>/dev/null && du -sm /tmp/expo-export | awk '{print $1}')
echo "Bundle size: \${BUNDLE_SIZE}MB"
if [ "$BUNDLE_SIZE" -gt 5 ]; then
  echo "❌ Bundle size exceeds 5MB threshold"
  exit 1
fi

echo "✅ Performance checks passed"
\`\`\`

### D6: Security Audit Checklist

- [ ] **Secure storage**: Sensitive tokens stored in \`expo-secure-store\` (Keychain on iOS, Keystore on Android), never in AsyncStorage
- [ ] **Certificate pinning**: Enabled for all Firebase and custom API endpoints in production builds
- [ ] **No secrets in bundle**: \`.env\` files excluded from builds; secrets injected via EAS Secrets
- [ ] **Biometric authentication**: Fallback to PIN/password; \`expo-local-authentication\` configured with \`LocalAuthentication.SecurityLevel.BIOMETRIC_STRONG\`
- [ ] **Deep link validation**: All incoming deep links validated against allowlist before navigation
- [ ] **Input sanitization**: User inputs sanitized before Firestore writes and display
- [ ] **Code obfuscation**: ProGuard enabled for Android release builds; Hermes bytecode for JS
- [ ] **Network security**: No HTTP cleartext traffic allowed (Android \`network_security_config.xml\`, iOS ATS enabled)
- [ ] **Auth token refresh**: Firebase ID tokens refreshed before expiry; refresh token rotation enabled
- [ ] **Jailbreak/root detection**: Warning displayed on compromised devices (not blocking, but logged)
- [ ] **Screenshot prevention**: Sensitive screens (auth, payments) prevent screenshots on Android (\`FLAG_SECURE\`)
- [ ] **Clipboard clearing**: Sensitive data (OTP, tokens) cleared from clipboard after 60 seconds

### D7: Accessibility Audit

**Standards**: WCAG 2.1 AA adapted for mobile

- [ ] All interactive elements have \`accessibilityLabel\` and \`accessibilityRole\`
- [ ] Touch targets minimum 44×44 points (iOS) / 48×48 dp (Android)
- [ ] Color contrast ratio ≥ 4.5:1 for normal text, ≥ 3:1 for large text
- [ ] Screen reader navigation order is logical (tested with VoiceOver and TalkBack)
- [ ] Dynamic type / font scaling supported up to 200%
- [ ] Animations respect \`Reduce Motion\` system setting (\`useReducedMotion\` hook)
- [ ] Focus management correct after modal open/close and navigation transitions
- [ ] Error messages announced to screen readers via \`accessibilityLiveRegion\`
- [ ] Form inputs have associated labels and error descriptions
- [ ] No information conveyed by color alone

**Testing commands**:
\`\`\`bash
# Run accessibility checks in component tests
pnpm test -- --testPathPattern="a11y"

# Manual testing checklist
# iOS: Settings → Accessibility → VoiceOver → ON → navigate all screens
# Android: Settings → Accessibility → TalkBack → ON → navigate all screens
\`\`\`

### D8: Privacy Compliance Verification

**GDPR**:
- [ ] Consent banner displayed on first launch before any analytics/tracking
- [ ] Granular consent options (analytics, crash reporting, personalization)
- [ ] Consent preferences persisted and respected across sessions
- [ ] Data export endpoint available (Firebase Cloud Function)
- [ ] Account deletion flow implemented (Settings → Delete Account → confirm → purge Firestore + Auth)
- [ ] Data deletion completes within 30 days (automated Cloud Function)
- [ ] Privacy policy accessible from app and app store listings

**App Store (iOS)**:
- [ ] Privacy nutrition labels accurate in App Store Connect
- [ ] ATT (App Tracking Transparency) prompt shown before IDFA access
- [ ] No third-party SDKs collecting data without disclosure

**Google Play**:
- [ ] Data safety form completed and accurate
- [ ] Data deletion option available per Google Play policy
- [ ] Permissions justified with clear user-facing rationale

## Quality Gates

All gates must pass before advancing to Phase 07 (Pre-Launch).

### Gate 1: Test Coverage

| Criteria | Threshold | Measurement |
|----------|-----------|-------------|
| Overall line coverage | ≥ 75% | \`pnpm test --coverage\` |
| Branch coverage | ≥ 65% | Jest coverage report |
| Critical paths coverage (auth, payments, sync) | ≥ 90% | Per-directory coverage |
| No untested public exports | 0 uncovered | Custom lint rule |

\`\`\`bash
# Verify coverage
pnpm test --coverage --coverageThreshold='{"global":{"lines":75,"branches":65}}'
\`\`\`

### Gate 2: Test Results

| Criteria | Threshold | Measurement |
|----------|-----------|-------------|
| Unit tests passing | 100% | \`pnpm test --selectProjects unit\` |
| Component tests passing | 100% | \`pnpm test --selectProjects component\` |
| Integration tests passing | 100% | \`pnpm test --selectProjects integration\` |
| E2E tests passing (iOS) | 100% | \`npx detox test --configuration ios.sim.debug\` |
| E2E tests passing (Android) | 100% | \`npx detox test --configuration android.emu.debug\` |
| Flaky test rate | < 2% | CI history over last 10 runs |

### Gate 3: Code Quality

| Criteria | Threshold | Measurement |
|----------|-----------|-------------|
| ESLint errors | 0 | \`pnpm lint\` |
| TypeScript errors | 0 | \`pnpm typecheck\` |
| No \`any\` types | 0 occurrences | \`grep -r ": any" src/ --include="*.ts" --include="*.tsx"\` |
| Max file length | ≤ 250 lines | Custom ESLint rule |
| No console.log in production code | 0 | ESLint \`no-console\` rule |
| No skipped tests (.skip) | 0 | \`grep -r "\\.skip\\(" src/ e2e/ --include="*.test.*"\` |

### Gate 4: Performance

| Criteria | Threshold | Measurement |
|----------|-----------|-------------|
| JS bundle size | < 5 MB | Export + measure |
| Cold start TTI (iOS) | < 2.0s | Manual profiling |
| Cold start TTI (Android) | < 2.5s | Manual profiling |
| Scroll frame rate | ≥ 55 FPS | Flipper |
| No memory leaks | 0 detected | Instruments / Profiler |

### Gate 5: Security & Privacy

| Criteria | Threshold | Measurement |
|----------|-----------|-------------|
| Security checklist (D6) | 100% complete | Manual review |
| Accessibility checklist (D7) | 100% complete | Manual + automated |
| Privacy checklist (D8) | 100% complete | Manual review |
| No secrets in codebase | 0 found | \`pnpm run secret-scan\` (trufflehog or gitleaks) |

### Gate 6: Build Verification

| Criteria | Threshold | Measurement |
|----------|-----------|-------------|
| iOS build succeeds | ✅ | \`eas build --platform ios --profile staging\` |
| Android build succeeds | ✅ | \`eas build --platform android --profile staging\` |
| OTA update deploys | ✅ | \`eas update --branch staging\` |
| Deep links resolve correctly | All routes | Manual testing with \`npx uri-scheme\` |

## Jest Configuration

**jest.config.js** (project-level):
\`\`\`javascript
module.exports = {
  projects: [
    {
      displayName: 'unit',
      preset: 'jest-expo',
      testMatch: ['<rootDir>/src/**/*.test.ts'],
      setupFilesAfterSetup: ['<rootDir>/src/test-utils/setup.ts'],
    },
    {
      displayName: 'component',
      preset: 'jest-expo',
      testMatch: ['<rootDir>/src/**/*.test.tsx'],
      setupFilesAfterSetup: [
        '<rootDir>/src/test-utils/setup.ts',
        '<rootDir>/src/test-utils/setup-rntl.ts',
      ],
    },
    {
      displayName: 'integration',
      preset: 'jest-expo',
      testMatch: ['<rootDir>/src/**/*.integration.test.tsx'],
      setupFilesAfterSetup: [
        '<rootDir>/src/test-utils/setup.ts',
        '<rootDir>/src/test-utils/setup-rntl.ts',
        '<rootDir>/src/test-utils/setup-msw.ts',
      ],
    },
  ],
  collectCoverageFrom: [
    'src/**/*.{ts,tsx}',
    '!src/**/*.test.{ts,tsx}',
    '!src/**/*.integration.test.{ts,tsx}',
    '!src/**/types.ts',
    '!src/**/index.ts',
    '!src/test-utils/**',
  ],
  coverageThreshold: {
    global: { lines: 75, branches: 65, functions: 70, statements: 75 },
    './src/services/auth/': { lines: 90, branches: 85 },
    './src/features/payments/': { lines: 90, branches: 85 },
    './src/services/sync/': { lines: 90, branches: 85 },
  },
};
\`\`\`

## CI Integration

Testing runs in GitHub Actions on every PR targeting \`main\`:

\`\`\`yaml
# Relevant steps from .github/workflows/test.yml
jobs:
  test:
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4
      - uses: pnpm/action-setup@v4
      - uses: actions/setup-node@v4
        with:
          node-version: 20
          cache: pnpm
      - run: pnpm install --frozen-lockfile
      - run: pnpm lint
      - run: pnpm typecheck
      - run: pnpm test --coverage --ci
      - uses: codecov/codecov-action@v4
        with:
          files: coverage/lcov.info

  e2e-ios:
    runs-on: macos-14
    needs: test
    steps:
      - uses: actions/checkout@v4
      - uses: pnpm/action-setup@v4
      - uses: actions/setup-node@v4
        with:
          node-version: 20
          cache: pnpm
      - run: pnpm install --frozen-lockfile
      - run: brew tap wix/brew && brew install applesimutils
      - run: npx detox build --configuration ios.sim.debug
      - run: npx detox test --configuration ios.sim.debug --ci
\`\`\`

## Workflow

### Week 1: Foundation & Unit/Component Tests

| Day | Activity |
|-----|----------|
| 1 | Set up Jest configuration, test utilities, mock factories |
| 2 | Unit tests for \`src/utils/\`, \`src/hooks/\` (shared) |
| 3 | Unit tests for \`src/store/\`, \`src/services/\` |
| 4 | Component tests for \`src/components/\` (shared UI) |
| 5 | Component tests for feature components, coverage review |

### Week 2: Integration, E2E & Audits

| Day | Activity |
|-----|----------|
| 1 | Integration tests for auth and home features |
| 2 | Integration tests for payments and notifications |
| 3 | Detox E2E setup, onboarding and login journeys |
| 4 | Detox E2E for offline sync, deep links; performance benchmarks |
| 5 | Security audit, accessibility audit, privacy verification, gate review |

## Common Testing Patterns

### Mocking Firebase

\`\`\`typescript
// src/test-utils/mocks/firebase-auth.ts
jest.mock('@react-native-firebase/auth', () => ({
  __esModule: true,
  default: () => ({
    currentUser: { uid: 'test-uid', email: 'test@example.com' },
    signInWithEmailAndPassword: jest.fn().mockResolvedValue({
      user: { uid: 'test-uid', email: 'test@example.com' },
    }),
    signOut: jest.fn().mockResolvedValue(undefined),
    onAuthStateChanged: jest.fn((callback) => {
      callback({ uid: 'test-uid', email: 'test@example.com' });
      return jest.fn(); // unsubscribe
    }),
  }),
}));
\`\`\`

### Testing Offline Behavior

\`\`\`typescript
// src/features/home/__tests__/home-screen-offline.integration.test.tsx
import { renderWithProviders } from '../../../test-utils/render-with-providers';
import { NetInfoStateType } from '@react-native-community/netinfo';

jest.mock('@react-native-community/netinfo', () => ({
  addEventListener: jest.fn(),
  fetch: jest.fn().mockResolvedValue({
    isConnected: false,
    type: NetInfoStateType.none,
  }),
}));

describe('HomeScreen offline', () => {
  it('displays cached data when offline', async () => {
    // Seed WatermelonDB with test data
    // Render screen
    // Assert cached items visible
    // Assert offline banner shown
  });
});
\`\`\`

### Testing Navigation

\`\`\`typescript
// src/features/auth/__tests__/login-navigation.integration.test.tsx
import { renderWithProviders } from '../../../test-utils/render-with-providers';
import { fireEvent, waitFor, screen } from '@testing-library/react-native';

describe('Login → Home navigation', () => {
  it('navigates to home after successful login', async () => {
    renderWithProviders(<AppNavigator />);

    fireEvent.changeText(screen.getByLabelText('Email'), 'user@test.com');
    fireEvent.changeText(screen.getByLabelText('Password'), 'password123');
    fireEvent.press(screen.getByRole('button', { name: 'Sign In' }));

    await waitFor(() => {
      expect(screen.getByText('Home')).toBeTruthy();
    });
  });
});
\`\`\`

## Troubleshooting

| Issue | Resolution |
|-------|-----------|
| Detox build fails on CI | Ensure Xcode CLI tools installed; check \`applesimutils\` version |
| Jest out of memory | Add \`--maxWorkers=50%\` flag; split into project-based runs |
| Flaky E2E tests | Add \`waitFor\` with explicit matchers; increase \`testTimeout\`; avoid \`sleep\` |
| WatermelonDB test setup | Use \`@nozbe/watermelondb/adapters/lokijs\` for in-memory test adapter |
| Firebase mock conflicts | Isolate mocks per test file; use \`jest.isolateModules\` for conflicting setups |
| Coverage not meeting threshold | Run \`pnpm test --coverage --verbose\` to identify uncovered files; prioritize critical paths |

## Phase Completion Criteria

- [ ] All six quality gates pass
- [ ] Test suite runs in < 10 minutes on CI (excluding E2E)
- [ ] E2E suite runs in < 20 minutes per platform
- [ ] No known P0/P1 bugs open
- [ ] Performance benchmarks documented and baselined
- [ ] Security, accessibility, and privacy audits signed off by lead
- [ ] \`playbook/current-phase.json\` updated to \`07-pre-launch\`

## Next Phase

→ [Phase 07: Pre-Launch](./07-pre-launch.md) — App Store / Google Play submission preparation, release candidate builds, beta testing, final compliance review`,

  'playbook/phases/07-launch.md': `# Phase 07: Launch & Operations

## Overview

Phase 07 transitions the React Native app from staging to production across both App Store and Google Play. This phase covers final pre-launch validation, store submission, phased rollout, production monitoring, incident response, and ongoing operational excellence. The goal is a smooth launch with zero critical issues and a sustainable operations posture.

## Objectives

1. **Store Readiness** — Pass App Store Review and Google Play Review on first submission
2. **Production Stability** — Achieve 99.5%+ crash-free rate within the first 72 hours
3. **Observability** — Full monitoring, alerting, and dashboards operational before launch
4. **Incident Response** — Documented runbooks and on-call rotation active
5. **Phased Rollout** — Controlled percentage-based rollout to mitigate risk
6. **Compliance Verification** — GDPR consent flows, privacy labels, and data safety sections finalized
7. **Operational Handoff** — Team equipped to maintain, monitor, and iterate post-launch

## Prerequisites

Before entering Phase 07, confirm:

- [ ] Phase 06 (Integration & Hardening) quality gates passed
- [ ] All Detox E2E tests passing on both iOS and Android
- [ ] Staging environment validated by QA and product stakeholders
- [ ] Performance benchmarks met (see Phase 06 thresholds)
- [ ] Security audit findings resolved or accepted with documented risk
- [ ] All feature flags configured for production defaults
- [ ] Legal/compliance review of privacy policy and terms of service complete

## Deliverables

### 7.1 Pre-Launch Checklist

Complete validation of every launch-critical item:

#### App Configuration
- [ ] \`app.json\` / \`app.config.ts\` production values set (bundle ID, version, build number)
- [ ] \`eas.json\` production profile configured with correct credentials
- [ ] Environment variables in EAS Secrets for production channel
- [ ] Deep linking universal links (iOS) and app links (Android) verified with production domains
- [ ] Firebase project switched to production instance (not staging)
- [ ] \`google-services.json\` (Android) and \`GoogleService-Info.plist\` (iOS) are production configs
- [ ] Push notification certificates (APNs) and FCM server key configured for production

#### Code & Build
- [ ] All \`TODO\` and \`FIXME\` comments resolved or tracked in GitHub Issues
- [ ] No \`console.log\` statements in production code (ESLint rule enforced)
- [ ] Code obfuscation enabled (Hermes bytecode for Android, default for iOS)
- [ ] Source maps uploaded to Sentry for both platforms
- [ ] Production EAS Build succeeds for both iOS and Android: \`eas build --platform all --profile production\`
- [ ] App size within acceptable limits (iOS < 100MB initial download, Android < 80MB APK)

#### Data & Backend
- [ ] Firestore security rules deployed and tested against production schema
- [ ] Cloud Functions deployed to production Firebase project
- [ ] WatermelonDB sync endpoint tested with production Firestore
- [ ] Database indexes created for all production queries
- [ ] Rate limiting configured on Cloud Functions
- [ ] Backup strategy for Firestore documented and tested

#### Security
- [ ] Secure storage (Keychain/Keystore) used for all tokens and sensitive data
- [ ] Certificate pinning configured for production API endpoints
- [ ] Biometric authentication tested on physical devices (Face ID, Touch ID, Android Biometric)
- [ ] No API keys or secrets in client bundle (verified with \`npx react-native-decompiler\` or equivalent)
- [ ] SSL/TLS enforced on all network requests (ATS on iOS, network security config on Android)

### 7.2 Store Submission Assets

#### App Store (iOS)
- [ ] App Store Connect listing complete:
  - App name, subtitle, description, keywords
  - Screenshots for all required device sizes (6.7", 6.5", 5.5", iPad if universal)
  - App preview videos (optional but recommended)
  - Privacy policy URL (publicly accessible)
  - Support URL and marketing URL
  - App category and age rating
- [ ] App Privacy details (nutrition labels) accurately reflect data collection:
  - Data linked to user identity
  - Data used for tracking
  - Data collected for analytics
- [ ] In-app purchase products created and approved (if applicable)
- [ ] App Review notes with test account credentials
- [ ] Export compliance (ECCN) declaration completed

#### Google Play (Android)
- [ ] Google Play Console listing complete:
  - Store listing (title, short description, full description)
  - Screenshots for phone and tablet (if applicable)
  - Feature graphic (1024x500)
  - Privacy policy URL
  - App category and content rating questionnaire
- [ ] Data safety section accurately completed:
  - Data types collected and shared
  - Security practices (encryption in transit, deletion mechanism)
- [ ] In-app products and subscriptions configured (if applicable)
- [ ] Internal testing track validated before production release
- [ ] Signing key managed via Play App Signing

### 7.3 Monitoring & Observability Setup

#### Sentry (Crash Reporting & Error Tracking)
\`\`\`
Production configuration in src/services/monitoring/sentry.ts:
- DSN pointing to production Sentry project
- Environment: 'production'
- Release: matches EAS build version
- Traces sample rate: 0.2 (20% of transactions)
- Attach screenshots on crash: enabled
- Breadcrumbs: navigation, network, console, user interaction
\`\`\`

- [ ] Sentry project created for production
- [ ] Source maps uploaded via \`sentry-expo\` plugin in EAS Build
- [ ] Alert rules configured:
  - New issue alert → Slack #app-alerts
  - Crash-free rate drops below 99.5% → PagerDuty/Slack
  - Error spike (>50 events in 5 minutes) → Slack #app-alerts
- [ ] Performance monitoring dashboards created (app start, screen load, API latency)

#### Firebase Analytics & Crashlytics
- [ ] Firebase Analytics events mapped to key user journeys:
  - \`app_open\`, \`sign_up\`, \`login\`, \`purchase_initiated\`, \`purchase_completed\`
  - Screen view tracking via React Navigation integration
  - Custom events for feature-specific funnels
- [ ] Firebase Crashlytics enabled and receiving test crashes
- [ ] Crashlytics alerts configured for velocity increases
- [ ] BigQuery export enabled for advanced analytics (if needed)

#### Infrastructure Monitoring
- [ ] Firebase Cloud Functions monitoring:
  - Execution count, error rate, latency (Firebase Console)
  - Cold start frequency tracked
- [ ] Firestore usage monitoring:
  - Read/write/delete operations dashboard
  - Budget alerts set at 80% and 100% of quota
- [ ] Firebase Cloud Messaging delivery metrics tracked
- [ ] Uptime monitoring for any external API dependencies

### 7.4 Alerting & On-Call

Define alert severity levels and response expectations:

| Severity | Description | Response Time | Example |
|----------|-------------|---------------|---------|
| P0 - Critical | App unusable for all users | 15 minutes | Crash on launch, auth completely broken |
| P1 - High | Major feature broken for many users | 1 hour | Push notifications not delivering, payments failing |
| P2 - Medium | Feature degraded, workaround exists | 4 hours | Offline sync delayed, image upload slow |
| P3 - Low | Minor issue, cosmetic | Next business day | UI alignment off on specific device |

- [ ] On-call rotation established (minimum 2 people in rotation)
- [ ] Escalation path documented in \`docs/runbooks/on-call.md\`
- [ ] Alert channels configured:
  - P0/P1 → Slack #app-incidents + phone notification
  - P2 → Slack #app-alerts
  - P3 → GitHub Issues auto-created

### 7.5 Incident Response Runbooks

Create runbooks in \`docs/runbooks/\`:

- [ ] \`docs/runbooks/on-call.md\` — On-call responsibilities, escalation, handoff
- [ ] \`docs/runbooks/hotfix.md\` — Emergency fix process (OTA via EAS Update vs. native rebuild)
- [ ] \`docs/runbooks/rollback.md\` — How to roll back OTA updates and native builds
- [ ] \`docs/runbooks/crash-investigation.md\` — Sentry triage, symbolication, reproduction
- [ ] \`docs/runbooks/firebase-incident.md\` — Firestore outage, Cloud Functions failure, FCM issues
- [ ] \`docs/runbooks/store-rejection.md\` — Common rejection reasons and resolution steps
- [ ] \`docs/runbooks/data-deletion.md\` — GDPR data deletion request handling

#### Hotfix Decision Tree

\`\`\`
Is the fix JavaScript-only (no native module changes)?
├── YES → Use EAS Update (OTA)
│   ├── eas update --branch production --message "hotfix: description"
│   ├── Verify on staging channel first
│   └── Monitor Sentry for regression
└── NO → Requires native rebuild
    ├── eas build --platform all --profile production
    ├── Submit to App Store (expedited review) and Google Play
    └── Consider phased rollout (10% → 50% → 100%)
\`\`\`

### 7.6 Phased Rollout Plan

#### Stage 1: Internal (Day 0)
- Deploy to internal testing tracks (TestFlight internal, Google Play internal testing)
- Team validates production build on physical devices
- Verify analytics events firing correctly
- Confirm push notifications delivered
- Test in-app purchases in production sandbox

#### Stage 2: Beta (Days 1-3)
- TestFlight external testers (up to 100 users)
- Google Play closed testing track
- Monitor crash-free rate (target: >99.5%)
- Monitor API error rates
- Collect qualitative feedback via in-app feedback mechanism

#### Stage 3: Limited Production (Days 4-7)
- App Store: Submit for review (no phased release option on first submission)
- Google Play: Staged rollout at 10%
- Monitor all dashboards intensively
- Check user reviews and ratings daily

#### Stage 4: Full Production (Days 8-14)
- Google Play: Increase to 25% → 50% → 100% over 3-4 days
- App Store: Available to all users post-approval
- Continue monitoring, respond to user feedback
- Address any P2/P3 issues discovered

### 7.7 Compliance Verification

#### GDPR
- [ ] Consent management flow tested end-to-end:
  - First launch shows consent dialog before any data collection
  - Users can modify consent preferences in settings
  - Consent state persisted in Zustand store and synced to Firestore
- [ ] Data deletion flow operational:
  - User can request account deletion from \`src/features/profile/screens/DeleteAccountScreen.tsx\`
  - Cloud Function processes deletion within 30 days
  - Confirmation email sent upon completion
- [ ] Data export (portability) available upon request
- [ ] Privacy policy accessible from app settings and store listings
- [ ] Analytics and crash reporting respect user consent preferences

#### App Store Guidelines
- [ ] No private API usage
- [ ] In-app purchases use StoreKit (no external payment links for digital goods)
- [ ] Login with Apple offered if other social logins present
- [ ] App does not download executable code
- [ ] Minimum functionality without network (offline-first architecture)

#### Google Play Policies
- [ ] Target API level meets current Google Play requirement (API 34+)
- [ ] Permissions declared with clear rationale
- [ ] Families policy compliance (if applicable)
- [ ] In-app purchases use Google Play Billing Library
- [ ] Data safety section matches actual data practices

### 7.8 Post-Launch Operations

#### Week 1 Post-Launch
- [ ] Daily monitoring check-ins (15 min standup focused on metrics)
- [ ] Review and respond to all App Store and Google Play reviews
- [ ] Triage and prioritize any issues discovered in production
- [ ] Validate OTA update pipeline works: \`eas update --branch production\`
- [ ] Confirm analytics funnels producing expected data

#### Ongoing Operations
- [ ] Weekly metrics review:
  - DAU/MAU, retention (D1, D7, D30)
  - Crash-free rate by platform and OS version
  - API latency p50, p95, p99
  - Push notification delivery and open rates
  - In-app purchase conversion (if applicable)
- [ ] Monthly dependency updates (check for React Native, Expo SDK, native module updates)
- [ ] Quarterly security review (dependencies, certificates, API keys rotation)
- [ ] Firebase usage and cost monitoring (monthly budget review)

## Quality Gates

All gates must pass before declaring launch complete:

### Gate 1: Build Verification
| Criteria | Target | Measurement |
|----------|--------|-------------|
| Production EAS Build succeeds | Both platforms | \`eas build --platform all --profile production\` |
| App size within limits | iOS < 100MB, Android < 80MB | EAS Build output |
| No TypeScript errors | 0 errors | \`pnpm tsc --noEmit\` |
| No lint errors | 0 errors | \`pnpm lint\` |
| Unit test coverage | ≥ 75% | \`pnpm test --coverage\` |
| E2E tests passing | 100% | \`npx detox test --configuration ios.release\` |

### Gate 2: Store Submission
| Criteria | Target | Measurement |
|----------|--------|-------------|
| App Store submission accepted | Approved | App Store Connect status |
| Google Play submission accepted | Approved | Google Play Console status |
| Store listing complete | All fields | Manual review checklist |
| Privacy labels accurate | Verified | Legal/compliance sign-off |
| In-app purchases tested | Working | Sandbox purchase verification |

### Gate 3: Monitoring Operational
| Criteria | Target | Measurement |
|----------|--------|-------------|
| Sentry receiving events | Verified | Test error in production |
| Firebase Analytics tracking | Verified | Real-time events in console |
| Crashlytics active | Verified | Test crash report received |
| Alert rules firing | Verified | Test alert triggered |
| On-call rotation active | ≥ 2 people | Schedule documented |

### Gate 4: Production Stability (72 hours post-launch)
| Criteria | Target | Measurement |
|----------|--------|-------------|
| Crash-free rate | ≥ 99.5% | Sentry + Crashlytics |
| API error rate | < 1% | Firebase Cloud Functions metrics |
| App start time (cold) | < 3s (iOS), < 4s (Android) | Sentry performance |
| Push notification delivery | > 95% | FCM delivery metrics |
| Offline sync success rate | > 98% | Custom analytics event |
| P0/P1 incidents | 0 open | Incident tracker |
| App Store rating | ≥ 4.0 | Store listing |

### Gate 5: Compliance
| Criteria | Target | Measurement |
|----------|--------|-------------|
| GDPR consent flow | Working | Manual QA verification |
| Data deletion request | Processed within 30 days | Cloud Function logs |
| Privacy policy accessible | From app + stores | Manual verification |
| No policy violations | 0 | Store review feedback |

## Commands Reference

\`\`\`bash
# Production builds
eas build --platform ios --profile production
eas build --platform android --profile production

# Store submission
eas submit --platform ios --profile production
eas submit --platform android --profile production

# OTA updates (JavaScript-only changes)
eas update --branch production --message "fix: description"

# Check update status
eas update:list --branch production

# Run E2E on release builds
npx detox build --configuration ios.release
npx detox test --configuration ios.release

# Upload source maps to Sentry
npx sentry-cli releases files <release> upload-sourcemaps

# Verify Firebase configuration
npx firebase-tools projects:list
npx firebase-tools deploy --only firestore:rules,functions
\`\`\`

## Risk Mitigation

| Risk | Likelihood | Impact | Mitigation |
|------|-----------|--------|------------|
| App Store rejection | Medium | High | Follow guidelines checklist, include review notes with test credentials |
| Crash spike on launch | Low | Critical | Phased rollout, OTA hotfix capability, Sentry real-time monitoring |
| Firebase quota exceeded | Low | High | Budget alerts, usage monitoring, auto-scaling Cloud Functions |
| Push notification issues | Medium | Medium | Test on multiple devices/OS versions, monitor FCM delivery dashboard |
| Offline sync conflicts | Medium | Medium | Conflict resolution tested in Phase 06, WatermelonDB sync logging |
| Negative store reviews | Medium | Medium | In-app feedback to intercept issues, rapid response to reviews |

## Transition to Ongoing Operations

Once all quality gates pass and the app has been stable for 72 hours:

1. Close the launch tracking GitHub Issue
2. Update \`playbook/current-phase.json\` to reflect operational status
3. Transition from launch war-room cadence to normal sprint cadence
4. Schedule retrospective to capture launch learnings
5. Begin Phase 08 (Growth & Iteration) planning — feature analytics review, A/B testing setup, performance optimization backlog

## Related Files

- \`docs/runbooks/\` — All operational runbooks
- \`eas.json\` — EAS Build and Submit profiles
- \`app.config.ts\` — Expo configuration with environment switching
- \`src/services/monitoring/sentry.ts\` — Sentry initialization
- \`src/services/analytics/firebase-analytics.ts\` — Analytics event tracking
- \`.github/workflows/production-deploy.yml\` — Production CI/CD pipeline
- \`playbook/phases/06-integration-hardening.md\` — Previous phase
- \`playbook/PLAYBOOK.md\` — Full methodology overview`,

  'playbook/prompts/01/gather-requirements.md': `# Gather Requirements — Phase 01 Discovery

> **Copy-paste this prompt into Claude Code** at the start of Phase 01 to produce a structured requirements document for your React Native mobile app feature or epic.

---

## Prompt

\`\`\`
You are a senior mobile product analyst working on the react-native-mobile-app project (React Native 0.74, Expo SDK 51, TypeScript, Firebase backend). I need you to help me gather and structure requirements for a new feature or change.

## Context

Read these files first to understand where we are:
- playbook/current-phase.json (current phase)
- playbook/phases/01-discovery.md (phase definition)
- docs/ (any existing architecture or product docs)
- src/features/ (existing feature modules for reference)

## Feature / Change

<DESCRIBE YOUR FEATURE OR CHANGE HERE — replace this placeholder>

## What I Need You To Produce

Create a file at \`docs/requirements/<feature-slug>-requirements.md\` with the following sections:

### 1. Problem Statement
- What user problem does this solve?
- Who is the target user segment?
- What is the current experience (if any)?

### 2. Functional Requirements
For each requirement, use this format:
- **FR-001**: <requirement> — Priority: Must/Should/Could — Platform: iOS/Android/Both

Cover these mobile-specific dimensions:
- **Online behavior**: What happens with full connectivity?
- **Offline behavior**: What happens with no connectivity? (WatermelonDB sync implications)
- **Background behavior**: What happens when the app is backgrounded or killed?
- **Deep link entry**: Can the user reach this feature via deep link? Define the URI scheme.
- **Push notification trigger**: Does this feature send or respond to push notifications?
- **Biometric gate**: Does this feature require biometric authentication?
- **In-app purchase**: Does this feature involve subscriptions or one-time purchases?

### 3. Non-Functional Requirements
- **Performance**: Screen load time targets, animation frame rate (60fps), list rendering benchmarks
- **Accessibility**: VoiceOver/TalkBack support, minimum touch targets (44×44pt), dynamic type support, accessibility labels for all interactive elements
- **Internationalization**: New strings needed (list keys for src/i18n/), RTL layout considerations
- **Security**: Sensitive data handling (Keychain/Keystore), certificate pinning needs, data encryption at rest
- **Privacy / Compliance**: GDPR consent requirements, App Store privacy label updates, Google Play data safety section updates, data retention policy, user data deletion support

### 4. Data Model
- New or modified Firestore collections/documents
- New or modified WatermelonDB tables/columns (offline schema)
- Sync strategy: which fields sync, conflict resolution approach
- Cloud Functions needed (triggers, callable, scheduled)

### 5. Navigation & Screens
- New screens (list with proposed file paths under src/features/<feature>/)
- Navigation stack/tab changes (reference src/navigation/ types)
- Deep link routes (reference src/navigation/linking.ts)
- Screen transition animations (if non-default)

### 6. State Management
- Zustand store changes (new slices or modifications to src/store/)
- React Query queries/mutations (cache keys, stale times, optimistic updates)
- WatermelonDB observables (which models to observe)

### 7. Platform-Specific Considerations
- **iOS-only**: Any iOS-specific APIs, permissions (Info.plist), App Store review concerns
- **Android-only**: Any Android-specific APIs, permissions (AndroidManifest.xml), Play Store policy concerns
- **Expo compatibility**: Can this be done with Expo SDK 51, or does it need a config plugin / custom native module (Expo Modules API)?

### 8. Third-Party Dependencies
For each new dependency:
- Package name and version
- Native module? (Yes/No — if yes, both iOS and Android support confirmed?)
- Expo compatible? (Yes/No — config plugin available?)
- License compatible? (MIT, Apache-2.0 preferred)
- Bundle size impact estimate

### 9. Analytics & Observability
- New analytics events (Firebase Analytics event names and parameters)
- New Sentry breadcrumbs or custom error types
- Firebase Crashlytics custom keys
- Performance monitoring traces (Firebase Performance)

### 10. Testing Strategy
- Key unit test scenarios (Jest)
- Key component test scenarios (React Native Testing Library)
- Key E2E test scenarios (Detox) — list as Gherkin-style Given/When/Then
- Edge cases: offline, slow network, expired auth token, backgrounded mid-flow

### 11. Acceptance Criteria
Write as checkboxes:
- [ ] AC-001: <criterion>
- [ ] AC-002: <criterion>
Each must be independently verifiable on both iOS and Android.

### 12. Open Questions
List anything that needs clarification from product, design, or backend before moving to Phase 02 (Architecture).

### 13. Estimated Scope
- Screens: <count>
- Components (new): <count>
- Hooks (new): <count>
- Services (new/modified): <count>
- Cloud Functions (new/modified): <count>
- WatermelonDB migrations: Yes/No
- Native module work: None / Config Plugin / Custom Module
- Estimated complexity: S / M / L / XL

## Rules
- Be specific to React Native / Expo / Firebase — not generic web React
- Reference actual project paths (src/features/, src/services/, src/navigation/)
- Every interactive element must have an accessibility label noted
- Every user-facing string must have an i18n key proposed
- Flag any requirement that might conflict with App Store or Google Play guidelines
- Flag any requirement that needs GDPR consideration (personal data, consent, deletion)
- If a requirement is unclear, add it to Open Questions rather than guessing
- Use the project's naming conventions: PascalCase components, camelCase hooks, kebab-case files
\`\`\`

---

## How to Use

1. **Copy** the prompt above into Claude Code.
2. **Replace** the \`<DESCRIBE YOUR FEATURE OR CHANGE HERE>\` placeholder with your feature description, user story, or GitHub Issue link.
3. **Review** the generated requirements document — pay special attention to:
   - Open Questions (resolve before Phase 02)
   - Platform-Specific Considerations (native module needs)
   - Offline behavior (WatermelonDB sync design)
   - Privacy / Compliance (GDPR, store policies)
4. **Commit** the requirements file: \`docs/requirements/<feature-slug>-requirements.md\`
5. **Create a GitHub Issue** linking to the requirements doc if one doesn't exist.
6. **Proceed** to Phase 02 (Architecture) once all open questions are resolved.

## Tips

- If you have a Figma link or design mockup, mention it in the feature description — Claude can reason about screen count and navigation flow.
- For features touching payments, mention your current RevenueCat / StoreKit / Google Billing setup.
- For features requiring new permissions, explicitly list them — Claude will flag App Store / Play Store review implications.
- Run this prompt once per feature or epic, not per ticket. Break into tickets during Phase 02.

## Related Files

- \`playbook/phases/01-discovery.md\` — Phase 01 definition and exit criteria
- \`playbook/prompts/01/assess-feasibility.md\` — Follow-up prompt for technical feasibility
- \`plugin/codeforge-react-native/agents/planner.md\` — Planner agent for task breakdown
- \`plugin/codeforge-react-native/commands/phase.md\` — Phase management command`,

  'playbook/prompts/01/nfr-checklist.md': `# NFR Checklist — React Native Mobile App

> **Copy-paste this prompt into Claude Code during Phase 01 (Discovery) to generate a comprehensive Non-Functional Requirements checklist tailored to this React Native/Expo/Firebase project.**

---

## Prompt

\`\`\`
You are helping define Non-Functional Requirements (NFRs) for a cross-platform React Native mobile app built with Expo SDK 51, TypeScript, and Firebase backend services. The app targets iOS (App Store) and Android (Google Play) with offline-first architecture using WatermelonDB.

Analyze the project context below and produce a comprehensive NFR checklist organized by category. For each NFR, provide:

1. **ID** — unique identifier (e.g., PERF-01, SEC-03)
2. **Requirement** — clear, measurable statement
3. **Metric / Target** — quantifiable acceptance criteria
4. **Verification Method** — how we test or measure it
5. **Priority** — P0 (must-have for launch), P1 (should-have), P2 (nice-to-have)

## Project Context

- **Platform**: React Native 0.74 + Expo SDK 51 (iOS 15+ / Android API 26+)
- **Navigation**: React Navigation v6 with typed navigators
- **State**: Zustand (client), React Query (server), WatermelonDB (offline persistence)
- **Backend**: Firebase Auth, Firestore, Cloud Functions, Cloud Messaging, Storage
- **Features**: Biometric auth, push notifications, deep linking, in-app purchases, offline sync
- **CI/CD**: EAS Build + EAS Submit, GitHub Actions
- **Compliance**: GDPR, App Store Guidelines, Google Play Policies
- **Monitoring**: Sentry (errors), Firebase Analytics, Firebase Crashlytics
- **Team**: 2-5 developers, pnpm, TypeScript strict mode
- **Test Coverage Target**: 75%

## NFR Categories to Cover

### 1. Performance
- App startup time (cold start, warm start)
- Screen transition / navigation latency
- Time to Interactive (TTI) after launch
- Frame rate during scrolling and animations (target 60fps)
- JS thread and UI thread performance
- Bundle size (JS bundle, OTA update payload)
- Memory usage and leak prevention
- Network request latency and timeout handling
- WatermelonDB query performance for offline data
- Image loading and caching performance
- React Query cache hit rates and stale times
- Background task execution time limits (iOS/Android)

### 2. Security
- Secure credential storage (iOS Keychain, Android Keystore)
- Biometric authentication (Face ID, Touch ID, Android BiometricPrompt)
- Firebase Auth token management and refresh
- Certificate pinning for API requests
- Code obfuscation (Hermes bytecode, ProGuard/R8)
- Sensitive data handling in memory (no plaintext secrets)
- Jailbreak/root detection policy
- Secure clipboard handling
- Deep link validation and URL scheme security
- In-app purchase receipt validation (server-side)
- Secure storage of google-services.json / GoogleService-Info.plist
- Environment variable protection (.env files not in bundles)
- Session timeout and re-authentication policy
- Data encryption at rest (WatermelonDB, AsyncStorage)

### 3. Privacy & Compliance
- GDPR consent collection and management
- Right to data access (data export)
- Right to erasure (account deletion flow — required by App Store)
- App Store privacy nutrition labels accuracy
- Google Play Data Safety section accuracy
- Analytics opt-in/opt-out mechanism
- Third-party SDK data sharing disclosure
- Age-gating if applicable
- Cookie/tracking consent (for WebViews if used)
- Data retention policies per data type
- Privacy policy accessibility within the app
- Firebase data residency considerations

### 4. Reliability & Availability
- Crash-free session rate target
- Offline-first behavior (app usable without network)
- WatermelonDB sync conflict resolution strategy
- Graceful degradation when Firebase services are unavailable
- Push notification delivery reliability
- Error boundary coverage (no white screens)
- Retry logic for failed network requests (React Query)
- Background sync reliability
- App state restoration after process kill
- OTA update rollback strategy (EAS Update)

### 5. Scalability
- Firestore read/write capacity planning
- Cloud Functions cold start mitigation
- WatermelonDB local dataset size limits
- Push notification throughput (FCM quotas)
- Image/asset CDN strategy (Firebase Storage + CDN)
- React Query pagination and infinite scroll performance
- Concurrent user capacity for real-time features

### 6. Accessibility
- VoiceOver (iOS) and TalkBack (Android) full support
- Accessibility labels on all interactive elements (enforced)
- Minimum touch target size (44x44pt iOS, 48x48dp Android)
- Color contrast ratios (WCAG 2.1 AA minimum)
- Dynamic type / font scaling support
- Reduced motion support (respect system preferences)
- Screen reader navigation order correctness
- Focus management during modal/sheet presentation
- Accessibility audit automation in CI

### 7. Internationalization (i18n)
- All user-facing text through i18n system (no hardcoded strings)
- RTL layout support readiness
- Date, time, number, currency locale formatting
- Pluralization rules per locale
- Dynamic string length accommodation in UI
- Locale detection and fallback strategy
- Translation file structure and update workflow

### 8. Testability
- Unit test coverage threshold (75%)
- Component test coverage for shared UI components
- Detox E2E test coverage for critical user flows
- Mocking strategy for Firebase services in tests
- WatermelonDB test database setup/teardown
- Snapshot testing policy for UI components
- CI test execution time budget
- Test flakiness rate target
- Device/simulator matrix for E2E tests

### 9. Maintainability
- TypeScript strict mode (no \`any\` types)
- Maximum file length (250 lines)
- Feature-based directory structure adherence
- Dependency update cadence (Expo SDK, React Native)
- Native module compatibility verification process
- Code documentation standards (JSDoc for public APIs)
- Architecture Decision Records (ADRs) for major choices
- CODEOWNERS enforcement for sensitive paths
- Conventional commit compliance

### 10. Deployment & Release
- EAS Build success rate target
- Build time budget (iOS and Android)
- OTA update size limits (EAS Update)
- Staging → Production promotion process
- App Store review submission checklist
- Google Play review submission checklist
- Rollback procedure for bad releases
- Feature flag strategy for gradual rollouts
- App versioning strategy (semver + build numbers)
- Code signing certificate management

### 11. Observability & Monitoring
- Sentry error capture coverage
- Firebase Crashlytics integration completeness
- Firebase Analytics event taxonomy
- Custom performance traces (Firebase Performance)
- Real-time alerting thresholds (crash rate, error rate)
- User session replay capability (if applicable)
- Network request logging and debugging
- Build and deploy audit trail

### 12. Platform-Specific
- iOS: minimum deployment target, App Transport Security compliance
- Android: minimum API level, target API level, adaptive icons
- iOS: background modes declaration accuracy
- Android: permission request rationale strings
- iOS: App Tracking Transparency prompt timing
- Android: scoped storage compliance
- Both: notification permission request UX flow

## Output Format

Produce a Markdown table per category with columns: ID | Requirement | Metric/Target | Verification | Priority

After the tables, add a **Summary** section with:
- Total NFR count by priority (P0 / P1 / P2)
- Top 5 highest-risk NFRs that need early attention
- NFRs that require architectural decisions in Phase 02
- NFRs that affect the CI/CD pipeline configuration

Reference actual project tools: Expo, EAS, Firebase, WatermelonDB, Detox, Sentry, Zustand, React Query, React Navigation.
\`\`\`

---

## Usage

1. Open Claude Code in the project root
2. Copy the entire prompt block above
3. Paste and run
4. Review the generated NFR checklist with the team
5. Save the output to \`docs/nfr-checklist.md\`
6. Reference NFR IDs in architecture decisions (Phase 02) and acceptance criteria (Phase 04+)

## Tips

- Adjust priority levels based on your launch timeline — if launching MVP, promote offline and security NFRs to P0
- Remove categories that don't apply (e.g., i18n if launching single-locale)
- Add domain-specific NFRs for your industry (e.g., healthcare → HIPAA, finance → PCI DSS)
- Link NFR IDs to GitHub Issues for tracking: \`Addresses NFR SEC-03\`
- Re-evaluate NFRs at Phase 05 (Integration & Hardening) and Phase 06 (Testing & Quality)`,

  'playbook/prompts/01/user-stories.md': `# User Stories Generation — Phase 01 Discovery

## Copy-Paste Prompt for Claude Code

\`\`\`
You are a mobile product analyst working on react-native-mobile-app, a cross-platform React Native/Expo mobile application with Firebase backend, offline-first architecture, and native platform integrations.

## Your Task

Generate comprehensive user stories for the features described below. Each story must follow mobile-specific patterns and account for the unique constraints of iOS and Android platforms.

## Context

- **Platform**: React Native 0.74 + Expo SDK 51 (iOS + Android)
- **Backend**: Firebase (Auth, Firestore, Cloud Functions, Cloud Messaging, Storage)
- **Offline**: WatermelonDB with Firestore sync
- **Navigation**: React Navigation v6 (typed navigators)
- **State**: Zustand (client) + React Query (server)
- **Auth**: Firebase Auth + biometric (Face ID / fingerprint)
- **Payments**: In-app purchases (App Store / Google Play)
- **Notifications**: Firebase Cloud Messaging (FCM + APNs)
- **Compliance**: GDPR, App Store Guidelines, Google Play Policies
- **Accessibility**: Required on all interactive elements
- **i18n**: All user-facing text through internationalization

## Feature Areas

Generate stories for each of these feature modules:

1. **Authentication** (src/features/auth/) — Email/password, social login (Google, Apple Sign-In), biometric unlock, session management, password reset, account deletion (GDPR)
2. **Home / Dashboard** (src/features/home/) — Main feed, pull-to-refresh, skeleton loading, empty states, deep link entry points
3. **User Profile** (src/features/profile/) — View/edit profile, avatar upload (Firebase Storage), preferences, theme toggle (dark/light), notification settings, data export (GDPR)
4. **Push Notifications** (src/features/notifications/) — Permission request flow, in-app notification center, badge count, deep linking from notification tap, quiet hours
5. **Payments / Subscriptions** (src/features/payments/) — Subscription tiers, purchase flow, restore purchases, receipt validation, subscription management, cancellation
6. **Offline Support** (cross-cutting) — Offline indicator, queued actions, sync conflict resolution, optimistic UI updates, cached content browsing

## Story Format

For each story, provide:

\`\`\`
### [FEATURE-ID] Story Title

**As a** [persona]
**I want to** [action]
**So that** [benefit]

**Platform Notes**: [iOS-specific, Android-specific, or cross-platform considerations]

**Acceptance Criteria**:
- [ ] [Criterion with specific mobile behavior]
- [ ] [Criterion with offline/edge case]
- [ ] [Criterion with accessibility requirement]
- [ ] [Criterion with analytics event]

**Technical Notes**:
- Navigation: [which navigator/screen]
- State: [Zustand store or React Query key]
- Services: [Firebase service, native module, etc.]
- Offline: [WatermelonDB table, sync behavior]

**Size**: [XS | S | M | L | XL]
**Priority**: [P0-Critical | P1-High | P2-Medium | P3-Low]
**Dependencies**: [other story IDs or "none"]
\`\`\`

## Personas

- **New User**: First-time app user, no account yet
- **Returning User**: Has account, may have been away, expects data persistence
- **Offline User**: In subway, airplane mode, spotty connectivity
- **Subscriber**: Paying user with premium features
- **Privacy-Conscious User**: Cares about data control, GDPR rights

## Mobile-Specific Requirements to Address

Each story should consider where applicable:

1. **App Lifecycle**: Background/foreground transitions, cold start vs warm start
2. **Permissions**: Camera, notifications, biometrics — progressive permission requests
3. **Platform Differences**: iOS vs Android behavior (back button, share sheet, haptics, status bar)
4. **Network States**: Online, offline, slow connection, connection restored
5. **Device Variations**: Small screens, tablets, notch/dynamic island, safe areas
6. **Accessibility**: VoiceOver (iOS) / TalkBack (Android), dynamic type, reduced motion
7. **Deep Linking**: Universal links (iOS) / App Links (Android) entry points
8. **Secure Storage**: Keychain (iOS) / Keystore (Android) for tokens and secrets
9. **Background Tasks**: Background fetch, silent push, background sync
10. **App Store Compliance**: Review guidelines that affect UX (e.g., Apple Sign-In requirement, subscription disclosure)

## Output Requirements

- Generate at least 30 user stories across all feature areas
- Include at least 5 stories specifically for offline scenarios
- Include at least 3 stories for GDPR/privacy compliance
- Include at least 3 stories for accessibility
- Include at least 2 stories for deep linking
- Tag each story with a feature prefix: AUTH-, HOME-, PROF-, NOTIF-, PAY-, OFFLINE-
- Order stories by priority (P0 first, then P1, etc.)
- After all stories, provide a **Story Map** table grouping stories by feature and user journey phase (Discover → Onboard → Engage → Pay → Retain)

## Anti-Patterns to Avoid

- Do NOT write web-centric stories (no "clicks a link", no "opens in browser tab")
- Do NOT ignore offline states — every data-fetching story needs an offline criterion
- Do NOT forget platform differences — call out iOS vs Android where behavior diverges
- Do NOT skip accessibility — every interactive story needs at least one a11y criterion
- Do NOT write vague criteria — specify exact behaviors ("shows skeleton loader for 0-3s", not "loads quickly")
\`\`\`

## Usage

1. Open Claude Code in the \`react-native-mobile-app\` project root
2. Copy the entire prompt above
3. Paste into Claude Code
4. Optionally prepend with specific feature focus: _"Focus primarily on the Authentication and Offline features for our MVP sprint."_
5. Review generated stories and save to \`docs/user-stories.md\`
6. Create GitHub Issues from the stories using: \`gh issue create --title "[STORY-ID] Title" --body "..." --label "user-story"\`

## Customization Tips

- **Narrowing scope**: Replace the Feature Areas section with only the features relevant to your current sprint
- **Adding features**: Append new feature modules following the same pattern (e.g., **Chat** at \`src/features/chat/\`)
- **Changing personas**: Adjust personas to match your actual user research
- **Adjusting depth**: Change "at least 30 stories" to match your planning horizon
- **Platform focus**: If iOS-first, add _"Prioritize iOS-specific behaviors and note Android as follow-up"_

## Follow-Up Prompts

After generating stories, use these follow-ups:

**Estimate and prioritize:**
\`\`\`
Review the generated user stories and create a prioritized backlog. Group into MVP (P0+P1), V1.1 (P2), and V1.2 (P3). Estimate total story points per release. Identify the critical path for App Store submission.
\`\`\`

**Generate acceptance test outlines:**
\`\`\`
For each P0 and P1 story, generate Detox E2E test outlines that cover the acceptance criteria. Use the project's e2e/ directory structure and Detox API conventions.
\`\`\`

**Create technical tasks:**
\`\`\`
Break down each M, L, and XL story into technical implementation tasks. Reference specific files in src/features/, src/services/, and src/navigation/. Include tasks for both iOS and Android platform-specific work.
\`\`\`

**Map to navigation flow:**
\`\`\`
Create a React Navigation screen map showing how the user stories connect through the app's navigation structure. List each screen, its navigator (stack/tab/modal), route params, and which stories it serves.
\`\`\``,

  'playbook/prompts/02/adr-generator.md': `# ADR Generator — Phase 02: Architecture

Use this prompt with Claude Code to generate Architecture Decision Records (ADRs) for your React Native mobile app. Copy-paste the entire block, replacing the placeholder values with your specific decision context.

---

## Prompt

\`\`\`
You are an Architecture Decision Record (ADR) generator for a React Native mobile application. The project uses:

- React Native 0.74 + Expo SDK 51 (managed workflow)
- TypeScript (strict mode, no \`any\`)
- React Navigation v6 (typed navigators)
- Zustand (client state) + React Query/TanStack Query (server state)
- WatermelonDB (offline-first local database, synced with Firestore)
- Firebase (Auth, Firestore, Cloud Functions, Cloud Messaging, Storage)
- Detox (E2E testing), Jest + React Native Testing Library (unit/component)
- EAS Build + EAS Submit for CI/CD
- Feature-based architecture: src/features/{feature}/screens|components|hooks|types

The project must comply with GDPR, Apple App Store Guidelines, and Google Play Policies.

---

### Decision to Document

**Title**: [SHORT_TITLE — e.g., "Use WatermelonDB for Offline-First Data Layer"]
**Category**: [STATE_MANAGEMENT | NAVIGATION | DATA_LAYER | AUTHENTICATION | NETWORKING | PUSH_NOTIFICATIONS | IN_APP_PURCHASES | NATIVE_MODULES | TESTING | CI_CD | SECURITY | PERFORMANCE | ACCESSIBILITY | ANALYTICS | ERROR_HANDLING | DEEP_LINKING | THEMING | I18N]
**Context**: [DESCRIBE the problem, constraint, or decision point — e.g., "The app must work reliably in areas with poor connectivity. Users expect to read and create content offline, with automatic sync when connectivity returns."]
**Constraints**: [LIST any hard constraints — e.g., "Must support iOS 15+ and Android API 26+, must not exceed 100MB app bundle, must sync within 30 seconds of reconnection"]

---

### Generation Instructions

Generate an ADR in the following format. Save it to \`docs/adr/ADR-NNNN-kebab-case-title.md\` where NNNN is the next sequential number.

**ADR Structure**:

1. **Title** — ADR-NNNN: [Decision Title]
2. **Status** — Proposed | Accepted | Deprecated | Superseded by ADR-XXXX
3. **Date** — ISO 8601 date
4. **Category** — From the list above
5. **Context** — The problem or situation driving this decision. Include:
   - What mobile-specific challenge are we solving?
   - What platforms are affected (iOS, Android, both)?
   - What user-facing behavior is expected?
   - What existing patterns or libraries are in play?
6. **Decision Drivers** — Numbered list of factors influencing the decision:
   - Performance on physical devices (not just simulators)
   - Bundle size impact
   - Expo compatibility (managed workflow constraints)
   - Offline behavior
   - Platform parity (iOS vs Android differences)
   - GDPR / privacy compliance
   - App Store / Play Store policy compliance
   - Developer experience and team skill level (15% junior, 35% mid, 35% senior, 15% lead)
   - Maintenance burden and community support
7. **Options Considered** — For each option:
   - **Option N: [Name]**
   - Description (1-2 sentences)
   - Pros (bullet list)
   - Cons (bullet list)
   - Expo SDK 51 compatibility: ✅ Compatible | ⚠️ Requires config plugin | ❌ Requires bare workflow
   - Bundle size impact: Minimal (<100KB) | Moderate (100KB-500KB) | Significant (>500KB)
8. **Decision** — Which option was chosen and a concise rationale
9. **Consequences** — Split into:
   - **Positive**: Benefits gained
   - **Negative**: Trade-offs accepted
   - **Risks**: What could go wrong and mitigation strategies
10. **Implementation Notes** — Specific to our project:
    - Which \`src/\` directories are affected
    - New dependencies to add (with \`pnpm add\` commands)
    - Required Expo config plugin entries in \`app.config.ts\`
    - Firebase configuration changes
    - Environment variables needed (via \`react-native-config\`)
    - Platform-specific setup (Xcode, Android Gradle)
    - Migration steps if replacing an existing approach
11. **Verification** — How to confirm the decision works:
    - Unit test expectations (Jest + RNTL)
    - E2E test scenarios (Detox)
    - Manual QA checklist (both platforms)
    - Performance benchmarks (startup time, memory, battery)
12. **References** — Links to relevant docs, RFCs, Expo docs, React Native docs, Firebase docs

---

### Formatting Rules

- Use standard Markdown with GitHub-compatible syntax
- Code examples must be TypeScript (strict, no \`any\`)
- File paths must follow project conventions: kebab-case files, PascalCase components
- Import paths must use the project's \`src/\` alias (e.g., \`@/features/auth/hooks/use-auth\`)
- Include both iOS and Android considerations where platform differences exist
- Flag any Expo managed workflow limitations explicitly
- Reference existing ADRs if this decision relates to or supersedes them
- Keep the total ADR under 200 lines — be precise, not verbose

---

### Example Code Snippets

When the ADR involves code patterns, include brief TypeScript examples showing:
- The recommended pattern (DO)
- The discouraged pattern (DON'T)

Format:

\`\`\`typescript
// ✅ DO: [description]
const example = () => { /* ... */ };

// ❌ DON'T: [description]
const badExample = () => { /* ... */ };
\`\`\`

---

Now generate the ADR based on the title, category, context, and constraints I provided above. If I haven't filled in the placeholders, ask me for the specific decision I want to document before generating.
\`\`\`

---

## Common ADR Topics for This Project

Use these as starting points — replace the placeholders in the prompt above with the relevant details.

### State Management
| Title | Category | Key Question |
|---|---|---|
| Zustand vs Redux for Client State | STATE_MANAGEMENT | Do we need Redux middleware ecosystem or is Zustand sufficient? |
| React Query Cache Strategy | DATA_LAYER | How long to cache server data? Stale-while-revalidate thresholds? |
| WatermelonDB Schema Design | DATA_LAYER | How to model local tables for offline sync with Firestore? |
| Zustand Persist with Secure Storage | STATE_MANAGEMENT | Which state slices persist and where (AsyncStorage vs Keychain)? |

### Authentication & Security
| Title | Category | Key Question |
|---|---|---|
| Biometric Auth Flow | AUTHENTICATION | Face ID / fingerprint as primary or secondary factor? |
| Token Storage Strategy | SECURITY | Keychain (iOS) + Keystore (Android) via expo-secure-store? |
| Certificate Pinning | SECURITY | Pin Firebase API certificates or use default TLS? |
| Session Management | AUTHENTICATION | Firebase Auth token refresh strategy with offline support? |

### Offline & Data
| Title | Category | Key Question |
|---|---|---|
| Offline-First Sync Strategy | DATA_LAYER | Conflict resolution: last-write-wins vs merge vs user-prompt? |
| Image Caching and Offline Assets | DATA_LAYER | Cache images locally with expo-file-system or react-native-fast-image? |
| Firestore Security Rules Design | SECURITY | Per-user isolation vs role-based access? |

### Native & Platform
| Title | Category | Key Question |
|---|---|---|
| Push Notification Architecture | PUSH_NOTIFICATIONS | FCM for both platforms or FCM + APNs separately? |
| Deep Linking Configuration | DEEP_LINKING | Universal Links (iOS) + App Links (Android) setup? |
| In-App Purchase Integration | IN_APP_PURCHASES | RevenueCat vs react-native-iap for subscription management? |
| Custom Native Module Strategy | NATIVE_MODULES | Expo Modules API vs bare native modules? |

### Performance & Quality
| Title | Category | Key Question |
|---|---|---|
| Navigation Architecture | NAVIGATION | Stack + Tab + Drawer composition? Auth vs App navigator split? |
| Error Boundary Strategy | ERROR_HANDLING | Sentry integration with React error boundaries and native crash reporting? |
| Analytics Event Taxonomy | ANALYTICS | Firebase Analytics event naming and parameter conventions? |
| Accessibility Standards | ACCESSIBILITY | WCAG 2.1 AA target with react-native accessibility props? |

### CI/CD & Infrastructure
| Title | Category | Key Question |
|---|---|---|
| EAS Build Profile Strategy | CI_CD | Separate profiles for development, staging, production? |
| OTA Update Policy | CI_CD | EAS Update for JS-only changes vs full native builds? |
| Code Signing Management | CI_CD | EAS managed credentials vs manual provisioning profiles? |
| Feature Flags Implementation | CI_CD | Firebase Remote Config vs custom feature flag service? |

---

## Batch Generation

To generate multiple related ADRs in sequence, use this wrapper:

\`\`\`
I need ADRs for the following decisions. Generate them sequentially, numbered starting from ADR-0001. Save each to docs/adr/.

1. Title: "Use Zustand for Client State Management"
   Category: STATE_MANAGEMENT
   Context: Need lightweight client state for theme, auth status, and user preferences. Must persist across app restarts. Must work offline.

2. Title: "Use React Query for Server State with Offline Support"
   Category: DATA_LAYER
   Context: Server data from Firebase needs caching, background refresh, and optimistic updates. Must degrade gracefully when offline.

3. Title: "WatermelonDB for Offline-First Local Database"
   Category: DATA_LAYER
   Context: Users need full read/write access to their data without connectivity. Sync with Firestore when online. Conflict resolution needed.

Use the ADR generator prompt format defined in playbook/prompts/02/adr-generator.md for each.
\`\`\`

---

## After Generation

1. Review the ADR with the team — at minimum one senior or lead developer
2. Update status from \`Proposed\` to \`Accepted\` after approval
3. Add the ADR filename to \`docs/adr/README.md\` index
4. Reference the ADR number in related GitHub Issues and PRs
5. Run \`/phase 02\` to track architecture phase progress`,

  'playbook/prompts/02/api-design.md': `# API Design — Phase 02: Architecture

> **Copy-paste this prompt into Claude Code to design the service layer, Firebase backend contracts, and data synchronization interfaces for the React Native mobile app.**

---

## Prompt

\`\`\`
You are designing the API and service layer architecture for a React Native mobile app (Expo SDK 51, TypeScript strict mode) backed by Firebase services. The app uses an offline-first architecture with WatermelonDB syncing to Firestore, React Query for server state, and Zustand for client state.

## Context

Review these files before starting:
- playbook/phases/02-architecture.md (current phase goals)
- docs/ (any existing architecture decisions or requirements from Phase 01)
- src/services/ (existing service stubs, if any)
- src/features/ (feature directories to understand domain boundaries)

## What to Design

### 1. Firebase Service Contracts

For each Firebase service used, define TypeScript interfaces:

**Firestore Collections & Documents**
- Define collection schemas as TypeScript interfaces (e.g., \`UserDocument\`, \`NotificationDocument\`, \`PaymentDocument\`)
- Define subcollection relationships (e.g., \`users/{uid}/preferences\`)
- Specify Firestore security rule requirements per collection
- Define indexes needed for compound queries
- Include \`createdAt\`, \`updatedAt\`, \`deletedAt\` (soft delete) timestamps on all documents
- Use \`Timestamp\` from Firebase, not raw \`Date\`

**Cloud Functions API**
- Define callable function signatures as TypeScript interfaces:
  \`\`\`typescript
  // Example pattern to follow:
  interface CloudFunctions {
    functionName: {
      request: RequestType;
      response: ResponseType;
    };
  }
  \`\`\`
- Group functions by feature domain (auth, payments, notifications, sync)
- Define HTTP trigger endpoints for webhooks (e.g., Stripe, App Store Server Notifications)
- Specify rate limits and authentication requirements per function
- Define error response shapes with typed error codes

**Firebase Authentication**
- Define supported auth providers (email/password, Apple Sign-In, Google Sign-In)
- Define custom claims structure for role-based access
- Define token refresh strategy and session management
- Specify biometric authentication flow (Keychain/Keystore integration)

**Cloud Messaging (Push Notifications)**
- Define notification payload types (data-only vs. notification+data)
- Define topic subscription strategy per feature
- Define notification channel configuration (Android) and category actions (iOS)
- Specify foreground vs. background handling contracts

**Firebase Storage**
- Define bucket structure and path conventions (e.g., \`users/{uid}/avatar/\`)
- Define upload/download service interfaces with progress callbacks
- Specify file size limits and allowed MIME types
- Define signed URL generation for secure access

### 2. WatermelonDB Offline-First Schema

Design the local database schema that syncs with Firestore:

- Define WatermelonDB model classes with column definitions
- Map Firestore documents to WatermelonDB tables (specify field mapping where names differ)
- Define sync conflict resolution strategy (server-wins, client-wins, or merge per field)
- Define the sync protocol interface:
  \`\`\`typescript
  interface SyncConfig {
    pullChanges: (params: { lastPulledAt: number }) => Promise<SyncPullResult>;
    pushChanges: (params: { changes: SyncDatabaseChangeSet }) => Promise<void>;
  }
  \`\`\`
- Specify which collections sync bidirectionally vs. read-only
- Define sync frequency and trigger conditions (connectivity change, app foreground, manual pull-to-refresh)
- Define data retention policy for local storage (GDPR: max local data age)

### 3. React Query Configuration

Define the query/mutation layer that bridges Firebase and the UI:

- Define query key factory pattern:
  \`\`\`typescript
  const queryKeys = {
    feature: {
      all: ['feature'] as const,
      lists: () => [...queryKeys.feature.all, 'list'] as const,
      detail: (id: string) => [...queryKeys.feature.all, 'detail', id] as const,
    },
  };
  \`\`\`
- Define custom hooks per feature following the pattern: \`useFeatureQuery\`, \`useFeatureMutation\`
- Specify stale times, cache times, and retry policies per query type
- Define optimistic update patterns for mutations
- Define offline mutation queue strategy (mutations queued when offline, replayed on reconnect)
- Specify query invalidation rules (which mutations invalidate which queries)
- Define prefetching strategy for navigation (prefetch next screen data)

### 4. Service Layer Architecture

Design the service abstraction layer in \`src/services/\`:

\`\`\`
src/services/
  firebase/
    auth.service.ts        # Authentication operations
    firestore.service.ts   # Firestore CRUD with typed collections
    functions.service.ts   # Cloud Function callables
    messaging.service.ts   # Push notification management
    storage.service.ts     # File upload/download
  analytics/
    analytics.service.ts   # Firebase Analytics + custom events
    crashlytics.service.ts # Crash reporting with context
  sync/
    sync.service.ts        # WatermelonDB ↔ Firestore sync orchestration
    conflict-resolver.ts   # Conflict resolution strategies
  payments/
    iap.service.ts         # In-app purchases (RevenueCat or expo-in-app-purchases)
    subscription.service.ts # Subscription state management
  platform/
    biometrics.service.ts  # Biometric auth (Face ID, Touch ID, Fingerprint)
    secure-storage.service.ts # Keychain (iOS) / Keystore (Android)
    deep-link.service.ts   # Deep link / universal link handling
    connectivity.service.ts # Network state monitoring
\`\`\`

For each service file, define:
- The exported interface (contract)
- Dependencies (other services, Firebase SDK modules)
- Error types specific to that service
- Whether it's a singleton, factory, or hook-based API
- Platform-specific considerations (iOS vs. Android differences)

### 5. Error Handling Strategy

Define a unified error handling approach:

- Define a base \`AppError\` class with typed error codes per domain
- Define error boundary integration for React components
- Define retry strategies per error type (network errors → retry, auth errors → re-authenticate, validation → show to user)
- Define error reporting pipeline: catch → log to Crashlytics → show user-friendly message
- Define offline error queuing (store failed operations for retry)

### 6. API Security

Address mobile-specific security concerns:

- Certificate pinning configuration for Firebase endpoints
- Secure storage strategy for tokens and sensitive data (expo-secure-store)
- Request signing or integrity verification for Cloud Functions
- Rate limiting awareness on the client side
- GDPR data access and deletion API endpoints
- App Transport Security (iOS) and Network Security Config (Android)

## Output Format

For each section above, produce:

1. **TypeScript interface files** — place in appropriate directories under \`src/\`
2. **A summary document** — \`docs/api-design.md\` with:
   - Architecture diagram (Mermaid) showing data flow: UI → Hooks → React Query → Services → Firebase / WatermelonDB
   - Collection schema table (collection name, fields, sync direction, security rules summary)
   - Cloud Functions catalog (function name, trigger type, auth required, rate limit)
   - Error code catalog (domain, code, HTTP equivalent, user message)
3. **Firestore security rules skeleton** — \`firestore.rules\` with typed rules per collection
4. **WatermelonDB schema file** — \`src/services/sync/schema.ts\`

## Constraints

- All interfaces must use TypeScript strict mode (no \`any\`, no implicit returns)
- File names use kebab-case, types/interfaces use PascalCase
- Each file must stay under 250 lines; split if needed
- All user-facing strings must reference i18n keys, not hardcoded text
- Include JSDoc comments on all exported interfaces and functions
- Mark any AI-generated files with a comment: \`// Generated by Claude Code — review before committing\`
- Consider both iOS and Android platform differences in every service contract
- All date/time fields use ISO 8601 strings in transit, Firebase Timestamps in Firestore
- Design for testability: every service should be mockable via its interface

## Validation

After generating, verify:
- [ ] Every Firestore collection has a corresponding TypeScript interface
- [ ] Every Cloud Function has request/response types defined
- [ ] WatermelonDB schema covers all offline-capable collections
- [ ] React Query hooks exist for every feature's data needs
- [ ] Error types cover all failure modes (network, auth, validation, platform)
- [ ] Security considerations documented for both platforms
- [ ] GDPR data deletion flow is defined end-to-end
- [ ] Sync conflict resolution is explicit for every synced collection
- [ ] All services have mockable interfaces for testing
- [ ] Deep linking routes map to navigation types in src/navigation/
\`\`\`

---

## Usage Notes

- Run this prompt after Phase 01 requirements are finalized and before writing implementation code.
- The output feeds directly into Phase 03 (Foundation) where scaffolding is generated.
- Review generated Firestore security rules with the team — they are a skeleton, not production-ready.
- The WatermelonDB schema should be validated against actual Firestore document shapes.
- Share \`docs/api-design.md\` with the team for review before proceeding to implementation.`,

  'playbook/prompts/02/data-model-design.md': `# Data Model Design — Phase 02: Architecture

> **Copy-paste this prompt into Claude Code to design the data model for your React Native mobile app with Firestore, WatermelonDB offline sync, and TypeScript types.**

---

## Prompt

\`\`\`
You are a mobile data architect designing the data model for a React Native app using Firebase Firestore (cloud) and WatermelonDB (local/offline). The app uses TypeScript strict mode with no \`any\` types.

## Context

This is a cross-platform mobile app (React Native 0.74 + Expo SDK 51) with:
- **Cloud database**: Firestore (document/collection model)
- **Local database**: WatermelonDB (SQLite-based, offline-first)
- **Sync**: WatermelonDB sync adapter ↔ Firestore via Cloud Functions
- **Auth**: Firebase Authentication (email, social, biometric)
- **State**: Zustand (client state), React Query (server/cached state)
- **Compliance**: GDPR (data minimization, right to deletion, consent tracking)

## Project Features to Model

Based on the feature modules in \`src/features/\`:
1. **auth** — User accounts, sessions, biometric enrollment
2. **home** — Feed items, dashboard data, user preferences
3. **profile** — User profile, settings, linked accounts
4. **notifications** — Push notification tokens, notification history, read state
5. **payments** — In-app purchases, subscriptions, transaction history

## Your Tasks

### 1. Firestore Collection Schema

For each collection, define:
- Collection path (including subcollections where appropriate)
- Document fields with TypeScript types
- Firestore security rules considerations (who reads/writes)
- Indexes needed for compound queries
- Data lifecycle (TTL, archival, GDPR deletion cascade)

Use this format for each collection:

\`\`\`typescript
// Collection: users
// Path: /users/{userId}
// Read: owner only | Write: owner only (except admin)
interface FirestoreUser {
  uid: string;
  email: string;
  displayName: string;
  avatarUrl: string | null;
  locale: string;                    // i18n preference
  createdAt: Timestamp;
  updatedAt: Timestamp;
  deletedAt: Timestamp | null;       // soft delete for GDPR
  gdprConsentVersion: string;        // e.g., "2024-01-v2"
  gdprConsentTimestamp: Timestamp;
  biometricEnabled: boolean;
  pushEnabled: boolean;
  // ... continue for all fields
}
\`\`\`

### 2. WatermelonDB Local Schema

For each table that needs offline access, define:
- Table name and columns (WatermelonDB schema format)
- Which Firestore collection it mirrors
- Sync direction: pull-only, push-only, or bidirectional
- Conflict resolution strategy (server-wins, client-wins, merge)
- What data is NOT synced locally (sensitive fields, large blobs)

Use this format:

\`\`\`typescript
// Table: users (mirrors Firestore /users/{userId})
// Sync: bidirectional | Conflict: server-wins for profile, client-wins for preferences
const usersSchema: TableSchema = {
  name: 'users',
  columns: [
    { name: 'firebase_uid', type: 'string', isIndexed: true },
    { name: 'email', type: 'string' },
    { name: 'display_name', type: 'string' },
    // ... WatermelonDB uses snake_case columns
    { name: 'synced_at', type: 'number' },  // timestamp for sync tracking
  ],
};
\`\`\`

### 3. WatermelonDB Model Classes

For each table, provide the Model class with:
- \`@field\`, \`@text\`, \`@date\`, \`@readonly\`, \`@json\` decorators
- \`@relation\` and \`@children\` for associations
- \`@lazy\` for computed/derived fields
- Writer methods for creating/updating records
- Any observable queries that screens will subscribe to

### 4. Sync Architecture

Design the sync layer:
- Cloud Function endpoint schema for \`pullChanges\` and \`pushChanges\`
- Timestamp-based sync using \`updated_at\` fields
- How deleted records are handled (tombstones in Firestore)
- Batch size limits for mobile network efficiency
- Retry and conflict resolution flow
- What triggers sync (app foreground, connectivity change, manual pull-to-refresh)

### 5. React Query Cache Keys & Zustand Store Shapes

Define the data access patterns:
- React Query key factories for server-state data
- Zustand store interfaces for client-only state (auth session, UI preferences, navigation state)
- How React Query and WatermelonDB coexist (which data source for which screen)

\`\`\`typescript
// Query key factory
export const queryKeys = {
  user: {
    all: ['user'] as const,
    detail: (uid: string) => ['user', uid] as const,
    profile: (uid: string) => ['user', uid, 'profile'] as const,
  },
  // ... continue for all features
};

// Zustand store (client-only state)
interface AuthStore {
  isAuthenticated: boolean;
  userId: string | null;
  biometricUnlocked: boolean;
  // ... no server data here, only session/UI state
}
\`\`\`

### 6. TypeScript Type Organization

Organize types following the project structure:
- \`src/features/{feature}/types/\` — feature-specific types
- \`src/services/firebase/types/\` — Firestore document types
- \`src/services/watermelon/types/\` — WatermelonDB model types
- Shared types in \`src/types/\` (only if used across 3+ features)
- Converter functions between Firestore ↔ WatermelonDB ↔ UI types

### 7. GDPR & Privacy Considerations

For each data entity, document:
- Personal data classification (PII, sensitive, non-personal)
- Retention period
- Deletion cascade (what gets deleted when user requests account deletion)
- Data that must NOT be stored locally on device (tokens, raw passwords)
- Encryption requirements (at-rest via WatermelonDB encryption, in-transit via TLS)
- App Store privacy label categories and Google Play data safety mappings

### 8. Migration Strategy

Plan for schema evolution:
- WatermelonDB migration steps (addColumn, createTable)
- Firestore backward-compatible field additions
- Version tracking for local schema
- How to handle breaking changes across app versions

## Output Format

Create the following files:

1. \`docs/data-model/firestore-schema.md\` — All Firestore collections with TypeScript interfaces
2. \`docs/data-model/watermelon-schema.md\` — WatermelonDB tables, models, and sync config
3. \`docs/data-model/sync-architecture.md\` — Sync flow, conflict resolution, Cloud Function contracts
4. \`docs/data-model/data-access-patterns.md\` — React Query keys, Zustand stores, which layer serves which screen
5. \`docs/data-model/gdpr-data-map.md\` — Privacy classification, retention, deletion cascade
6. \`src/services/firebase/types/firestore.types.ts\` — Firestore document TypeScript interfaces
7. \`src/services/watermelon/schema.ts\` — WatermelonDB appSchema with all tables
8. \`src/services/watermelon/migrations.ts\` — Initial migration (version 1)
9. \`src/types/query-keys.ts\` — React Query key factory
10. \`src/store/types.ts\` — Zustand store interfaces

## Constraints

- TypeScript strict mode, no \`any\` — use \`unknown\` with type guards where needed
- All Firestore timestamps use \`Timestamp\` from firebase/firestore (not raw Date)
- WatermelonDB columns use snake_case; TypeScript interfaces use camelCase
- Keep Firestore documents under 1MB; denormalize for read performance on mobile
- Design for offline-first: assume the app may be offline for hours/days
- Subcollections for 1:many where the "many" side can grow unbounded
- Root collections for entities that need cross-user queries (admin dashboards)
- Index all fields used in \`where\` clauses or \`orderBy\` in Firestore
- No sensitive data (auth tokens, passwords, payment card numbers) in WatermelonDB
- Push notification tokens stored in Firestore only (not local DB)
- All monetary values stored as integers (cents) to avoid floating-point issues
- Enum values stored as strings for readability and forward compatibility
- Every document/record has \`createdAt\` and \`updatedAt\` timestamps
- Soft deletes (\`deletedAt\`) for GDPR audit trail before hard deletion
\`\`\`

---

## When to Use

Run this prompt during **Phase 02 — Architecture** after requirements are gathered (Phase 01) and before writing any implementation code. The output feeds directly into:

- Phase 03 (Foundation) — schema files, type definitions, initial migrations
- Phase 04 (Core Implementation) — models, sync setup, query patterns
- Phase 05 (Integration & Hardening) — sync conflict testing, offline scenarios

## Prerequisites

Before running this prompt, ensure you have:

- [ ] Completed Phase 01 deliverables (requirements, user stories, NFRs)
- [ ] Feature list finalized (\`src/features/\` directory structure agreed)
- [ ] Firebase project created with Firestore, Auth, and Cloud Functions enabled
- [ ] WatermelonDB added to project dependencies
- [ ] GDPR requirements documented (what data is collected, consent flows)

## Follow-Up Prompts

After data model design, continue with:

- \`playbook/prompts/02/api-contract-design.md\` — Cloud Function API contracts and sync endpoints
- \`playbook/prompts/02/navigation-architecture.md\` — Screen graph, deep linking, typed navigators
- \`playbook/prompts/03/project-scaffold.md\` — Generate the actual schema/type files from this design

## Validation Checklist

After Claude generates the data model, verify:

- [ ] Every feature module has corresponding Firestore collections and WatermelonDB tables
- [ ] Sync direction and conflict resolution defined for every local table
- [ ] No \`any\` types in generated TypeScript interfaces
- [ ] GDPR data map covers every field containing personal data
- [ ] Firestore indexes cover all planned queries
- [ ] WatermelonDB schema has migrations from version 1
- [ ] React Query keys cover all server-state access patterns
- [ ] Zustand stores contain only client-side state (no duplicated server data)
- [ ] Monetary values use integer cents, not floats
- [ ] Timestamps use appropriate types per layer (Firestore \`Timestamp\`, WatermelonDB \`number\`, UI \`Date\`)
- [ ] Sensitive fields excluded from local database
- [ ] Document sizes estimated and under Firestore 1MB limit`,

  'playbook/prompts/03/ci-pipeline.md': `# CI Pipeline Setup — Phase 03 Foundation

> **Copy-paste this prompt into Claude Code to generate the complete CI/CD pipeline for the React Native mobile app using GitHub Actions and EAS Build.**

---

## Prompt

You are setting up the CI/CD pipeline for **react-native-mobile-app**, a React Native 0.74 + Expo SDK 51 + Firebase project. Generate all GitHub Actions workflow files and supporting configuration for a mobile-first CI/CD pipeline using EAS Build and EAS Submit.

### Project Context

- **Runtime**: React Native 0.74, Expo SDK 51, TypeScript strict mode
- **Package manager**: pnpm (use \`pnpm install --frozen-lockfile\`)
- **Testing**: Jest + React Native Testing Library (unit/component), Detox (E2E)
- **Build system**: EAS Build (Expo Application Services) for iOS and Android
- **OTA updates**: EAS Update for staging channel
- **Submission**: EAS Submit for App Store Connect and Google Play Console
- **Coverage threshold**: 75% (lines, branches, functions, statements)
- **Branch protection**: \`main\` is protected, requires PR with 1 approval + passing checks

### Pipeline Stages (in order)

1. **Lint** — ESLint with react-native-community config
2. **Type Check** — \`tsc --noEmit\`
3. **Unit Tests** — Jest with coverage enforcement
4. **Component Tests** — React Native Testing Library
5. **EAS Build (iOS)** — Build iOS \`.ipa\` via EAS
6. **EAS Build (Android)** — Build Android \`.aab\` via EAS
7. **Detox E2E** — End-to-end tests on built artifacts
8. **Deploy Staging** — EAS Update to staging channel (auto on merge to main)
9. **Deploy Production** — EAS Update to production channel (manual trigger)

### Files to Generate

#### 1. \`.github/workflows/ci.yml\`

Primary CI workflow triggered on pull requests to \`main\`. Must include:

- **Trigger**: \`pull_request\` targeting \`main\`, plus \`push\` to \`main\`
- **Concurrency**: Cancel in-progress runs for the same PR
- **Environment variables**: \`EXPO_TOKEN\` from secrets, \`NODE_ENV=test\`
- **Jobs**:
  - \`lint-and-typecheck\`: Runs ESLint and TypeScript checks in parallel steps. Uses \`pnpm\`. Cache \`node_modules\` and pnpm store. Runs on \`ubuntu-latest\`.
  - \`unit-tests\`: Depends on \`lint-and-typecheck\`. Runs \`pnpm test -- --coverage --ci --reporters=default --reporters=jest-junit\`. Enforces 75% coverage. Uploads coverage report as artifact. Uploads \`jest-junit\` results for GitHub PR annotations.
  - \`component-tests\`: Depends on \`lint-and-typecheck\`. Runs component tests separately: \`pnpm test -- --testPathPattern='__tests__/components' --ci\`. Runs on \`ubuntu-latest\`.
  - \`build-check\`: Depends on \`unit-tests\` and \`component-tests\`. Runs \`npx expo export --platform all\` to verify the JS bundle compiles. This is a fast check before triggering expensive EAS builds.
  - \`eas-build-ios\`: Depends on \`build-check\`. Only runs on \`push\` to \`main\` (not on PRs). Triggers \`eas build --platform ios --profile staging --non-interactive\`. Uses \`EXPO_TOKEN\` secret.
  - \`eas-build-android\`: Depends on \`build-check\`. Only runs on \`push\` to \`main\` (not on PRs). Triggers \`eas build --platform android --profile staging --non-interactive\`. Uses \`EXPO_TOKEN\` secret.
- **AI code flag**: Add a step that checks for \`// AI-generated\` or \`// ai-generated\` comments in changed files and posts a PR comment summarizing AI-generated code locations.
- **CODEOWNERS validation**: Add a step that verifies \`.github/CODEOWNERS\` covers all sensitive paths.

#### 2. \`.github/workflows/eas-update-staging.yml\`

Triggered on push to \`main\` after CI passes. Deploys OTA update to staging channel:

- Run \`eas update --branch staging --message "Staging: \${GITHUB_SHA::8}"\` 
- Post Slack notification via webhook (\`SLACK_WEBHOOK_URL\` secret) with build details
- Include rollback instructions in the Slack message

#### 3. \`.github/workflows/eas-update-production.yml\`

Manual workflow (\`workflow_dispatch\`) for production releases:

- Input: \`release_notes\` (string, required), \`version\` (string, required)
- Requires environment \`production\` (with required reviewers configured in GitHub)
- Steps:
  1. Checkout and setup
  2. Run full test suite one more time
  3. Run \`eas update --branch production --message "v\${version}: \${release_notes}"\`
  4. Create a GitHub Release with tag \`v\${version}\`
  5. Post Slack notification with release details and App Store/Play Store links

#### 4. \`.github/workflows/detox-e2e.yml\`

E2E testing workflow (runs on schedule and manual trigger):

- Runs nightly at 2 AM UTC and on \`workflow_dispatch\`
- Uses macOS runner (\`macos-14\`) for iOS simulator
- Steps:
  1. Setup Node.js, pnpm, install dependencies
  2. Install Detox CLI: \`pnpm add -g detox-cli\`
  3. Install applesimutils via Homebrew
  4. Build Detox test app: \`npx detox build --configuration ios.sim.release\`
  5. Run Detox tests: \`npx detox test --configuration ios.sim.release --cleanup --headless\`
  6. Upload Detox artifacts (screenshots, logs) on failure
  7. Post Slack notification on failure

#### 5. \`.github/workflows/dependency-review.yml\`

Triggered on PRs that modify \`package.json\` or \`pnpm-lock.yaml\`:

- Use \`actions/dependency-review-action\` to check for vulnerabilities
- Flag any new native modules (packages containing \`ios/\` or \`android/\` directories) and require explicit approval
- Check license compatibility (block GPL, AGPL in production dependencies)
- Post a PR comment summarizing new/removed/changed dependencies

#### 6. \`eas.json\`

EAS Build configuration with profiles:

- **development**: \`developmentClient: true\`, \`distribution: "internal"\`, \`ios.simulator: true\`
- **staging**: \`distribution: "internal"\`, \`channel: "staging"\`, \`ios.buildConfiguration: "Release"\`, \`android.buildType: "apk"\` for internal testing
- **production**: \`distribution: "store"\`, \`channel: "production"\`, \`ios.buildConfiguration: "Release"\`, \`android.buildType: "app-bundle"\`, \`autoIncrement: true\`
- Environment variables per profile: \`APP_ENV\` set to \`development\`, \`staging\`, or \`production\`
- Submit configuration for both App Store Connect and Google Play

#### 7. \`.github/CODEOWNERS\`

Code ownership rules:

\`\`\`
# Default
* @react-native-mobile-app/mobile-devs

# Sensitive: Auth and security
src/services/auth/** @react-native-mobile-app/leads
src/features/auth/** @react-native-mobile-app/leads

# Sensitive: Configuration and secrets
src/config/** @react-native-mobile-app/leads
.env* @react-native-mobile-app/leads
google-services.json @react-native-mobile-app/leads
GoogleService-Info.plist @react-native-mobile-app/leads

# Native code requires senior review
ios/** @react-native-mobile-app/leads
android/** @react-native-mobile-app/leads
plugins/** @react-native-mobile-app/leads

# CI/CD changes require lead approval
.github/** @react-native-mobile-app/leads
eas.json @react-native-mobile-app/leads
app.config.ts @react-native-mobile-app/leads

# Navigation (affects deep linking, app structure)
src/navigation/** @react-native-mobile-app/senior-devs

# Payments (revenue-critical)
src/features/payments/** @react-native-mobile-app/leads

# Database and sync (data integrity)
src/services/database/** @react-native-mobile-app/senior-devs
\`\`\`

#### 8. \`.github/pull_request_template.md\`

PR template for mobile development:

- Sections: Description, Type of Change (feature/bugfix/refactor/native), Ticket Reference
- Checklist items specific to mobile:
  - [ ] Tested on iOS simulator
  - [ ] Tested on Android emulator
  - [ ] Tested on physical device (if native changes)
  - [ ] Accessibility labels added to interactive elements
  - [ ] All text uses i18n keys (no hardcoded strings)
  - [ ] Offline behavior verified
  - [ ] Deep link routes updated (if navigation changed)
  - [ ] No new \`any\` types introduced
  - [ ] Tests added/updated (coverage ≥ 75%)
  - [ ] No sensitive data logged or exposed
  - [ ] AI-generated code marked with \`// AI-generated\` comment
- Screenshots/recordings section (required for UI changes)
- Performance impact section (bundle size, startup time)

#### 9. \`scripts/check-ai-code.sh\`

Shell script used by CI to detect and report AI-generated code in PRs:

- Scans changed files for \`// AI-generated\` or \`// ai-generated\` markers
- Outputs a markdown summary of files and line numbers
- Exits with code 0 (informational only, does not block)

#### 10. \`.github/workflows/pr-checks.yml\`

Lightweight PR checks that run fast:

- Validate conventional commit format on PR title
- Check branch naming matches \`type/ticket-desc\` pattern
- Verify no \`.env\` files are committed (only \`.env.example\` allowed)
- Check file length (warn if any file exceeds 250 lines)
- Verify \`expo-doctor\` passes: \`npx expo-doctor\`

### Constraints

- All workflows must use \`pnpm\` with \`--frozen-lockfile\`
- Node.js version: 20.x (LTS)
- Cache pnpm store across runs using \`actions/cache\`
- Use \`expo-github-action\` for Expo/EAS CLI setup in workflows
- All secrets referenced: \`EXPO_TOKEN\`, \`SLACK_WEBHOOK_URL\`, \`SENTRY_AUTH_TOKEN\`, \`FIREBASE_TOKEN\`
- Sensitive environment files (\`.env.staging\`, \`.env.production\`) must come from GitHub Secrets, never committed
- Every workflow file must have a comment header: \`# Auto-generated CI pipeline for react-native-mobile-app\`
- Use \`actions/upload-artifact@v4\` and \`actions/download-artifact@v4\` (latest)
- Pin all third-party actions to SHA hashes for security (provide example SHAs as comments)

### Output Format

Generate each file with its full path as a header comment. Ensure all YAML is valid. Include inline comments explaining non-obvious configuration choices. Cross-reference related files (e.g., \`ci.yml\` references \`eas.json\` profiles, \`CODEOWNERS\` references directory structure from \`playbook/phases/03-foundation.md\`).

### Validation

After generating, verify:
1. All workflow triggers are correct (PR vs push vs manual vs schedule)
2. Job dependencies form a valid DAG (no circular deps)
3. Secrets are never echoed or logged
4. iOS builds only run on appropriate runners
5. Coverage thresholds match project standard (75%)
6. EAS profiles in \`eas.json\` match channel names used in update workflows
7. CODEOWNERS paths match the project directory structure in \`playbook/phases/02-architecture.md\``,

  'playbook/prompts/03/iac-setup.md': `# IaC Setup — Phase 03 Foundation Prompt

> **Copy-paste this prompt into Claude Code to scaffold the infrastructure-as-code foundation for the React Native mobile app, covering EAS configuration, GitHub Actions CI/CD, Firebase project setup, and environment management.**

---

## Prompt

You are setting up the infrastructure-as-code foundation for **react-native-mobile-app**, a cross-platform React Native + Expo SDK 51 mobile application with Firebase backend services. This is Phase 03 (Foundation) of our development playbook.

### Context

- **Runtime**: React Native 0.74 + Expo SDK 51 (managed workflow with custom dev client)
- **Backend**: Firebase (Authentication, Firestore, Cloud Functions, Cloud Messaging, Storage)
- **CI/CD**: GitHub Actions for checks + EAS Build/Submit for native builds
- **Environments**: development, staging, production
- **Package Manager**: pnpm
- **Offline Database**: WatermelonDB (syncs with Firestore)
- **Monitoring**: Sentry (crash reporting), Firebase Analytics, Firebase Crashlytics

### What to Generate

#### 1. EAS Configuration (\`eas.json\`)

Create \`eas.json\` with three build profiles:

- **development**: Internal distribution, dev client enabled, connects to Firebase development project, includes \`ENVIRONMENT=development\` env var, iOS simulator build variant
- **staging**: Internal distribution (ad hoc for iOS, internal track for Android), connects to Firebase staging project, \`ENVIRONMENT=staging\`, auto-submit disabled, includes Sentry source map upload
- **production**: Store distribution (App Store + Google Play), connects to Firebase production project, \`ENVIRONMENT=production\`, auto-increment build numbers, Sentry source map upload, code signing configured

Each profile must reference the correct \`google-services.json\` and \`GoogleService-Info.plist\` paths via \`EAS_BUILD\` hooks. Include \`submit\` profiles for both App Store Connect and Google Play Console.

#### 2. Expo App Config (\`app.config.ts\`)

Create a dynamic \`app.config.ts\` (not \`app.json\`) that:

- Reads \`ENVIRONMENT\` to switch between dev/staging/prod bundle identifiers and app names
  - dev: \`com.company.reactnativeapp.dev\` / "RN App (Dev)"
  - staging: \`com.company.reactnativeapp.staging\` / "RN App (Staging)"
  - production: \`com.company.reactnativeapp\` / "RN App"
- Configures Expo plugins: \`expo-notifications\`, \`expo-local-authentication\`, \`expo-secure-store\`, \`expo-splash-screen\`, \`expo-updates\`
- Sets up deep linking scheme: \`rnapp://\`
- Configures \`expo-updates\` with the correct EAS Update URL per environment
- Sets Android permissions: \`CAMERA\`, \`READ_EXTERNAL_STORAGE\`, \`RECEIVE_BOOT_COMPLETED\`, \`VIBRATE\`, \`USE_BIOMETRIC\`, \`USE_FINGERPRINT\`
- Sets iOS entitlements: push notifications, associated domains, Keychain sharing, in-app purchases
- Includes Sentry DSN from environment
- Sets \`newArchEnabled: true\` for React Native New Architecture

#### 3. GitHub Actions Workflows

Create the following workflow files under \`.github/workflows/\`:

**a. \`ci.yml\` — Pull Request Checks**
Triggers on PR to \`main\`. Jobs:
1. **lint-typecheck**: Run \`pnpm lint\`, \`pnpm typecheck\` (TypeScript strict)
2. **unit-tests**: Run \`pnpm test -- --coverage\`, fail if coverage < 75%, upload coverage report as artifact
3. **component-tests**: Run \`pnpm test:components\` (React Native Testing Library)
4. **build-check-ios**: Run \`eas build --platform ios --profile staging --non-interactive --no-wait\` (validates build config without waiting)
5. **build-check-android**: Run \`eas build --platform android --profile staging --non-interactive --no-wait\`

Use \`pnpm\` caching. Pin Node.js to 20.x. Use \`expo/expo-github-action@v8\` for EAS CLI setup. Mark AI-generated code with \`# AI-generated: Claude Code\` comment at top of each workflow.

**b. \`build-staging.yml\` — Staging Builds**
Triggers on push to \`main\`. Jobs:
1. Run full CI checks (reuse ci.yml via \`workflow_call\` or repeat)
2. **eas-build-ios**: \`eas build --platform ios --profile staging --non-interactive --auto-submit false\`
3. **eas-build-android**: \`eas build --platform android --profile staging --non-interactive --auto-submit false\`
4. **eas-update**: \`eas update --branch staging --message "Staging: \${{ github.sha }}"\` for OTA updates
5. Post build URLs to Slack via webhook

**c. \`build-production.yml\` — Production Release**
Triggers on GitHub Release published (tag \`v*\`). Jobs:
1. Full CI checks
2. **eas-build-ios**: \`eas build --platform ios --profile production --non-interactive --auto-submit\`
3. **eas-build-android**: \`eas build --platform android --profile production --non-interactive --auto-submit\`
4. **sentry-release**: Create Sentry release, upload source maps, finalize
5. Post release notification to Slack

**d. \`detox-e2e.yml\` — E2E Tests**
Triggers on PR to \`main\` with label \`e2e\` or on schedule (nightly). Jobs:
1. Build iOS dev client for simulator: \`eas build --platform ios --profile development --non-interactive\`
2. Run Detox tests: \`npx detox test --configuration ios.sim.release --cleanup --headless\`
3. Upload Detox artifacts (screenshots, logs) on failure

All workflows must use GitHub Secrets for: \`EXPO_TOKEN\`, \`SENTRY_AUTH_TOKEN\`, \`SENTRY_DSN\`, \`SLACK_WEBHOOK_URL\`, \`FIREBASE_TOKEN\`, \`APPLE_ID\`, \`ASC_KEY_ID\`, \`ASC_ISSUER_ID\`, \`ASC_KEY_BASE64\`, \`GOOGLE_SERVICE_ACCOUNT_KEY\`.

#### 4. Firebase Configuration (\`firebase.json\` + \`firestore.rules\` + \`firestore.indexes.json\`)

**a. \`firebase.json\`**
- Firestore: rules file, indexes file
- Cloud Functions: source \`./functions\`, Node.js 20 runtime, predeploy lint
- Storage: rules file
- Hosting: disabled (mobile-only)
- Emulators: auth (port 9099), firestore (port 8080), functions (port 5001), storage (port 9199), UI (port 4000)

**b. \`firestore.rules\`**
- Users collection: read/write only own document, authenticated
- User subcollections (preferences, devices): owner-only access
- Shared content: read if authenticated, write if owner
- Admin collection: read/write only if custom claim \`admin: true\`
- Include GDPR-related rules: users can read and delete all their own data
- Deny all by default

**c. \`firestore.indexes.json\`**
- Composite index on users collection: \`createdAt\` DESC + \`status\` ASC
- Composite index on notifications: \`userId\` ASC + \`createdAt\` DESC + \`read\` ASC

**d. \`.firebaserc\`**
- Define project aliases: \`default\` → dev project, \`staging\` → staging project, \`production\` → production project

#### 5. Environment Configuration

**a. \`.env.example\`**
List all required environment variables with placeholder values and comments:
- Firebase config (API key, auth domain, project ID, storage bucket, messaging sender ID, app ID)
- Sentry DSN
- Deep link scheme
- API base URL per environment
- Feature flags (biometrics enabled, in-app purchases enabled, analytics enabled)
- WatermelonDB sync endpoint

**b. \`src/config/environment.ts\`**
TypeScript module that:
- Reads environment from \`expo-constants\` (\`expoConfig.extra\`)
- Exports typed config object with all environment variables
- Validates required variables at startup (throws if missing in production, warns in dev)
- Exports \`isProduction\`, \`isStaging\`, \`isDevelopment\` boolean helpers
- Never exposes sensitive values in logs

**c. \`src/config/firebase.ts\`**
Firebase initialization module that:
- Initializes Firebase app with environment-specific config
- Exports typed instances: \`auth\`, \`firestore\`, \`functions\`, \`storage\`, \`messaging\`
- Connects to emulators when \`isDevelopment\` is true
- Configures Firestore persistence for offline support
- Sets up Firebase Analytics (disabled in dev)
- Sets up Crashlytics (disabled in dev)

#### 6. CODEOWNERS (\`.github/CODEOWNERS\`)

\`\`\`
# Default
* @mobile-team

# Sensitive paths — require lead review
src/services/auth/**    @mobile-leads
src/config/**           @mobile-leads
google-services.json    @mobile-leads
GoogleService-Info.plist @mobile-leads
.env*                   @mobile-leads
eas.json                @mobile-leads
app.config.ts           @mobile-leads

# CI/CD — require lead review
.github/workflows/**    @mobile-leads
firebase.json           @mobile-leads
firestore.rules         @mobile-leads

# Native code — require senior+ review
ios/**                  @mobile-leads @mobile-seniors
android/**              @mobile-leads @mobile-seniors

# Navigation — typed navigators are critical
src/navigation/**       @mobile-seniors
\`\`\`

#### 7. Sentry Configuration (\`sentry.config.ts\`)

- Initialize \`@sentry/react-native\` with environment-specific DSN
- Set \`tracesSampleRate\` to 1.0 in dev, 0.2 in staging, 0.1 in production
- Enable React Navigation integration for automatic screen tracking
- Configure release name as \`\${bundleId}@\${version}+\${buildNumber}\`
- Filter out known non-critical errors (network timeouts in offline mode)
- Attach user context from auth state (anonymized user ID only — GDPR)
- Disable in development when \`__DEV__\` is true

#### 8. Detox Configuration (\`.detoxrc.js\`)

- iOS simulator configuration: iPhone 15, iOS 17.4
- Android emulator configuration: Pixel 7, API 34
- Test runner: Jest with \`e2e/jest.config.js\`
- Artifacts: screenshots on failure, log files
- Build commands reference EAS dev client builds
- Behavior: cleanup after each test, launch app with permissions granted

### Constraints

- All files must use TypeScript where applicable (\`.ts\` / \`.tsx\`)
- No \`any\` types — use proper typing for all Firebase and config objects
- File names in kebab-case, exports in camelCase/PascalCase per convention
- Each file must stay under 250 lines; split if needed
- Include \`// AI-generated: Claude Code\` marker at the top of generated files
- Reference \`playbook/phases/03-foundation.md\` for phase requirements
- Reference \`docs/\` for architecture decisions (ADRs)
- All secrets must come from environment variables or GitHub Secrets — never hardcoded
- Firebase security rules must follow principle of least privilege
- Ensure iOS and Android parity in all configurations

### Output Format

For each file, output:
1. The full file path
2. The complete file content
3. A brief comment explaining key decisions

Start with \`eas.json\` and work through each file sequentially. After generating all files, provide a **verification checklist** confirming:
- [ ] All three environments (dev/staging/prod) are configured
- [ ] GitHub Actions cover lint → typecheck → test → build → deploy pipeline
- [ ] Firebase emulators configured for local development
- [ ] Firestore rules enforce authentication and owner-only access
- [ ] Sentry configured per environment with GDPR-safe user context
- [ ] CODEOWNERS protects sensitive paths with lead review
- [ ] All secrets externalized — zero hardcoded credentials
- [ ] Detox E2E configured for both iOS and Android
- [ ] OTA updates via EAS Update configured for staging
- [ ] Deep linking scheme registered in app config`,

  'playbook/prompts/03/project-scaffold.md': `# Phase 03 Prompt: Project Scaffold

> Copy-paste this prompt into Claude Code to scaffold the React Native / Expo / Firebase project foundation.

---

## Prompt

\`\`\`
You are scaffolding the foundation for "react-native-mobile-app", a cross-platform React Native mobile application using Expo SDK 51, TypeScript strict mode, and Firebase backend services.

## What to Generate

Create the complete project scaffold with all configuration files, directory structure, and foundational code. Do NOT generate feature code yet — only the skeleton and tooling.

### 1. Project Configuration

**package.json** — include these exact dependencies (use latest compatible versions for Expo SDK 51 / RN 0.74):
- expo ~51.x, react-native 0.74.x, react 18.x
- @react-navigation/native, @react-navigation/native-stack, @react-navigation/bottom-tabs
- @tanstack/react-query
- zustand
- @nozbe/watermelondb
- @react-native-firebase/app, @react-native-firebase/auth, @react-native-firebase/firestore, @react-native-firebase/messaging, @react-native-firebase/crashlytics, @react-native-firebase/analytics
- expo-secure-store, expo-local-authentication, expo-notifications, expo-linking, expo-constants, expo-updates
- react-native-config
- react-i18next, i18next
- @sentry/react-native

DevDependencies:
- typescript ~5.3.x
- @types/react, @types/react-native
- eslint, @react-native-community/eslint-config, eslint-plugin-react-hooks, eslint-plugin-import
- prettier
- jest, @testing-library/react-native, @testing-library/jest-native
- detox
- eas-cli (global, note in scripts)

Scripts must include:
- "start": "npx expo start"
- "ios": "npx expo run:ios"
- "android": "npx expo run:android"
- "test": "jest --coverage"
- "test:watch": "jest --watch"
- "test:e2e:ios": "detox test --configuration ios.sim.release"
- "test:e2e:android": "detox test --configuration android.emu.release"
- "lint": "eslint 'src/**/*.{ts,tsx}' --max-warnings 0"
- "lint:fix": "eslint 'src/**/*.{ts,tsx}' --fix"
- "format": "prettier --write 'src/**/*.{ts,tsx,json}'"
- "format:check": "prettier --check 'src/**/*.{ts,tsx,json}'"
- "typecheck": "tsc --noEmit"
- "build:staging": "eas build --profile staging"
- "build:production": "eas build --profile production"
- "submit:ios": "eas submit --platform ios"
- "submit:android": "eas submit --platform android"
- "update:staging": "eas update --branch staging"

**tsconfig.json** — strict: true, no any allowed, path aliases:
- @features/* → src/features/*
- @components/* → src/components/*
- @hooks/* → src/hooks/*
- @services/* → src/services/*
- @navigation/* → src/navigation/*
- @store/* → src/store/*
- @utils/* → src/utils/*
- @i18n/* → src/i18n/*
- @theme/* → src/theme/*
- @assets/* → src/assets/*

**app.json / app.config.ts** — Expo config with:
- slug: react-native-mobile-app
- Scheme for deep linking: "rnmobileapp"
- Plugins: expo-secure-store, expo-local-authentication, expo-notifications, @react-native-firebase/app, @sentry/react-native
- iOS bundleIdentifier and Android package placeholders
- Separate staging/production config via environment variables
- EAS projectId placeholder

**eas.json** — three profiles:
- development: developmentClient true, distribution internal
- staging: autoIncrement true, channel staging, env staging
- production: autoIncrement true, channel production, env production

**.eslintrc.js** — extends @react-native-community, add rules:
- no-console: warn
- @typescript-eslint/no-explicit-any: error
- react-hooks/exhaustive-deps: error
- import/order with groups (builtin, external, internal, parent, sibling)
- Max file length 250 lines (warn)

**.prettierrc** — singleQuote: true, trailingComma: "all", semi: true, printWidth: 100, tabWidth: 2

**babel.config.js** — expo preset + module-resolver for path aliases + react-native-reanimated/plugin

**.detoxrc.js** — configurations for ios.sim.release and android.emu.release

**.env.example** — template with all required env vars:
- FIREBASE_API_KEY, FIREBASE_AUTH_DOMAIN, FIREBASE_PROJECT_ID, FIREBASE_STORAGE_BUCKET, FIREBASE_MESSAGING_SENDER_ID, FIREBASE_APP_ID
- SENTRY_DSN
- API_BASE_URL
- EAS_PROJECT_ID

**.gitignore** — comprehensive for React Native/Expo: node_modules, .expo, ios/Pods, android/build, *.jks, *.keystore, google-services.json, GoogleService-Info.plist, .env, .env.*, coverage/, e2e/artifacts/

### 2. Directory Structure

Create these directories with index.ts barrel exports where appropriate:

\`\`\`
src/
  features/
    auth/
      screens/          # LoginScreen, RegisterScreen, BiometricScreen
      components/       # AuthForm, SocialLoginButtons
      hooks/            # useLogin, useRegister, useBiometric
      types/            # Auth-related types
      __tests__/
      index.ts
    home/
      screens/
      components/
      hooks/
      types/
      __tests__/
      index.ts
    profile/
      screens/
      components/
      hooks/
      types/
      __tests__/
      index.ts
    notifications/
      screens/
      components/
      hooks/
      types/
      __tests__/
      index.ts
    payments/
      screens/
      components/
      hooks/
      types/
      __tests__/
      index.ts
  components/
    Button/
      Button.tsx
      Button.test.tsx
      index.ts
    Card/
      index.ts
    Input/
      index.ts
    Modal/
      index.ts
    LoadingSpinner/
      index.ts
    ErrorBoundary/
      ErrorBoundary.tsx
      index.ts
  hooks/
    useAuth.ts
    useOffline.ts
    useTheme.ts
    usePushNotifications.ts
    useDeepLinking.ts
    useBiometric.ts
    index.ts
  services/
    firebase/
      app.ts            # Firebase initialization
      auth.ts           # Auth service wrapper
      firestore.ts      # Firestore service wrapper
      messaging.ts      # Push notification service
      analytics.ts      # Analytics service
      crashlytics.ts    # Crash reporting service
      storage.ts        # Cloud Storage service
      index.ts
    api/
      client.ts         # HTTP client with interceptors
      index.ts
    sync/
      watermelon.ts     # WatermelonDB setup
      sync-service.ts   # Firestore ↔ WatermelonDB sync
      index.ts
    sentry/
      index.ts          # Sentry initialization
  navigation/
    types.ts            # Typed navigator params (RootStackParamList, MainTabParamList)
    RootNavigator.tsx   # Auth flow vs Main flow
    MainTabNavigator.tsx
    linking.ts          # Deep link configuration
    index.ts
  store/
    auth-store.ts       # Zustand: auth state (user, token, isAuthenticated)
    theme-store.ts      # Zustand: theme preferences (dark/light)
    preferences-store.ts # Zustand: user preferences
    index.ts
  utils/
    formatting.ts       # Date, currency, number formatting
    validation.ts       # Form validation helpers
    platform.ts         # Platform.OS helpers, isIOS, isAndroid
    secure-storage.ts   # expo-secure-store wrapper
    constants.ts        # App-wide constants (SCREAMING_SNAKE_CASE)
    logger.ts           # Structured logging (dev vs prod)
    index.ts
  i18n/
    index.ts            # i18next initialization
    locales/
      en.json           # English translations (skeleton keys)
      es.json           # Spanish translations (skeleton keys)
  theme/
    colors.ts           # Light and dark color palettes
    typography.ts       # Font families, sizes, weights
    spacing.ts          # Spacing scale (4, 8, 12, 16, 20, 24, 32, 48)
    index.ts            # Combined theme export
  assets/
    images/
      .gitkeep
    fonts/
      .gitkeep
    animations/
      .gitkeep
e2e/
  firstTest.e2e.ts      # Smoke test placeholder
  utils/
    test-helpers.ts
scripts/
  setup-firebase.sh     # Firebase project setup helper
  generate-feature.sh   # Feature module generator
docs/
  architecture.md       # Link to ADRs and architecture decisions
  deployment.md         # EAS Build + Submit guide
  offline-sync.md       # WatermelonDB sync strategy
  push-notifications.md # FCM setup guide
.github/
  CODEOWNERS
  pull_request_template.md
  workflows/
    ci.yml              # Lint → Typecheck → Test → Build
    e2e.yml             # Detox E2E on PR to main
    deploy-staging.yml  # EAS Update on merge to main
    deploy-production.yml # EAS Build + Submit on release tag
\`\`\`

### 3. Foundational Code (implement these files fully)

**src/App.tsx** — Root component:
- Wrap with React Query Provider (QueryClientProvider)
- Wrap with React Navigation NavigationContainer with linking config
- Wrap with ErrorBoundary
- Initialize Sentry
- Initialize Firebase
- Initialize i18n
- Render RootNavigator

**src/navigation/types.ts** — Fully typed navigation:
- RootStackParamList: { Auth: undefined; Main: undefined; Onboarding: undefined }
- AuthStackParamList: { Login: undefined; Register: undefined; ForgotPassword: { email?: string } }
- MainTabParamList: { Home: undefined; Notifications: undefined; Profile: undefined }
- Export typed useNavigation and useRoute hooks using CompositeNavigationProp

**src/navigation/RootNavigator.tsx** — Conditional rendering:
- If not authenticated → Auth stack
- If authenticated but not onboarded → Onboarding
- If authenticated → Main tab navigator

**src/navigation/linking.ts** — Deep link config:
- Scheme: "rnmobileapp"
- Prefixes: ["rnmobileapp://", "https://app.example.com"]
- Screen mappings for auth, home, profile, notifications

**src/store/auth-store.ts** — Zustand store:
- State: user (typed), isAuthenticated, isLoading, token
- Actions: setUser, clearUser, setLoading
- Persist to secure storage using a custom storage adapter

**src/services/firebase/app.ts** — Firebase init:
- Initialize Firebase app
- Export app instance
- Handle already-initialized case

**src/components/ErrorBoundary/ErrorBoundary.tsx** — Error boundary:
- Catch rendering errors
- Report to Sentry/Crashlytics
- Show fallback UI with retry button
- Typed props with children and fallback

**src/components/Button/Button.tsx** — Base button component:
- Variants: primary, secondary, outline, ghost, destructive
- Sizes: sm, md, lg
- Loading state with ActivityIndicator
- Disabled state
- Accessibility: accessibilityRole="button", accessibilityLabel required prop
- All text through i18n-ready pattern
- Fully typed props extending TouchableOpacityProps

**src/utils/platform.ts** — Platform helpers:
- isIOS, isAndroid constants
- platformSelect<T>(ios: T, android: T): T
- getStatusBarHeight()
- isTablet()

**src/utils/secure-storage.ts** — Secure storage wrapper:
- setSecureItem(key, value): Promise<void>
- getSecureItem(key): Promise<string | null>
- deleteSecureItem(key): Promise<void>
- Uses expo-secure-store
- Typed key enum for all stored keys (AUTH_TOKEN, REFRESH_TOKEN, BIOMETRIC_ENABLED, USER_PREFERENCES)

**src/i18n/index.ts** — i18next setup:
- Initialize with react-i18next
- Language detection
- Fallback to 'en'
- Load en.json and es.json

**src/theme/index.ts** — Theme system:
- Light and dark color tokens
- Typography scale
- Spacing scale
- Export typed Theme interface

**src/hooks/useAuth.ts** — Auth hook:
- Wraps auth-store
- Provides login, logout, register functions
- Integrates with Firebase Auth service
- Returns typed auth state

**src/services/sync/watermelon.ts** — WatermelonDB setup:
- Database schema definition (placeholder tables: users, cached_items)
- Database adapter (SQLiteAdapter)
- Database instance export
- Migration setup

### 4. CI/CD Workflows

**.github/workflows/ci.yml**:
- Trigger: push to any branch, PR to main
- Jobs: lint, typecheck, test (with coverage threshold 75%), build-check
- Use pnpm, cache node_modules
- Upload coverage report as artifact

**.github/CODEOWNERS**:
- src/services/auth/** → @mobile-leads
- src/config/** → @mobile-leads
- src/navigation/** → @mobile-team
- .github/** → @devops-team
- *.json (root config) → @mobile-leads

**.github/pull_request_template.md**:
- Sections: Description, Type of Change, Testing, Screenshots/Videos, Checklist
- Checklist items: tests added, accessibility labels, i18n strings, offline behavior verified, both platforms tested

### 5. Documentation Stubs

**docs/architecture.md** — Brief overview linking to ADRs, feature-based structure explanation, state management strategy (Zustand + React Query), offline-first approach

**docs/deployment.md** — EAS Build profiles, environment configuration, App Store / Google Play submission steps, OTA updates via EAS Update

### Constraints

- TypeScript strict mode everywhere — no \`any\`, no \`as\` casts unless absolutely necessary with a comment explaining why
- Every interactive element must have accessibilityLabel and accessibilityRole
- All user-facing strings must use i18n translation keys, not hardcoded strings
- File names in kebab-case, component names in PascalCase, hooks in camelCase prefixed with "use"
- Maximum 250 lines per file — split if needed
- Each file must have a brief JSDoc comment at the top explaining its purpose
- Use named exports (no default exports) except for screens (React Navigation convention)
- All imports should use path aliases (@features/, @components/, etc.)
- Include .gitkeep in empty directories
- Do NOT include actual Firebase credentials — use placeholders and .env.example

## Output

Generate each file with its full path. Create working, type-safe code that compiles. This is the foundation — it must be solid. After generation, run:

1. \`pnpm install\`
2. \`pnpm typecheck\`
3. \`pnpm lint\`
4. \`pnpm test\`

All four commands must pass with zero errors.
\`\`\`

---

## Usage Notes

1. **Before running**: Ensure you have Node.js 18+, pnpm, and Expo CLI installed globally.
2. **After scaffold**: Copy \`.env.example\` to \`.env\` and fill in Firebase credentials from Firebase Console.
3. **Firebase setup**: Run \`scripts/setup-firebase.sh\` or manually add \`google-services.json\` (Android) and \`GoogleService-Info.plist\` (iOS) — both are gitignored.
4. **EAS setup**: Run \`eas init\` and update \`eas.json\` with your project ID.
5. **Next phase**: Move to Phase 04 (Core Implementation) — see \`playbook/prompts/04/\` for feature implementation prompts.

## Verification Checklist

After Claude generates the scaffold, verify:

- [ ] \`pnpm install\` completes without errors
- [ ] \`pnpm typecheck\` passes with zero errors
- [ ] \`pnpm lint\` passes with zero warnings
- [ ] \`pnpm test\` runs (even if only placeholder tests exist)
- [ ] \`npx expo start\` launches the Metro bundler
- [ ] Path aliases resolve correctly in IDE
- [ ] All directories exist with proper barrel exports
- [ ] \`.env.example\` contains all required variables
- [ ] \`eas.json\` has development, staging, and production profiles
- [ ] CODEOWNERS file covers sensitive paths
- [ ] CI workflow references correct pnpm commands
- [ ] No hardcoded strings in components (all i18n keys)
- [ ] No Firebase credentials committed (check \`.gitignore\`)
- [ ] ErrorBoundary renders fallback on simulated error

## Related Files

- Architecture decisions: \`playbook/prompts/02/adr-generator.md\`
- Data model: \`playbook/prompts/02/data-model-design.md\`
- Phase definition: \`playbook/phases/03-foundation.md\`
- Next prompt: \`playbook/prompts/04/\` (feature implementation)`,

  'playbook/prompts/04/auth-implementation.md': `# Auth Implementation — Phase 04 Prompt

> Copy-paste this prompt into Claude Code to implement the full authentication feature module for the React Native mobile app.

---

## Prompt

\`\`\`
You are implementing the authentication feature module for a React Native mobile app using Expo SDK 51, TypeScript (strict mode), and Firebase Authentication. Follow the project's feature-based architecture under src/features/auth/.

## Context

- **Stack**: React Native 0.74, Expo SDK 51, TypeScript strict, Firebase Auth, Zustand, React Query
- **Navigation**: React Navigation v6 with typed navigators
- **Secure Storage**: expo-secure-store for tokens, Keychain (iOS) / Keystore (Android) for biometrics
- **Offline**: App must handle auth state gracefully when offline
- **i18n**: All user-facing strings must go through the i18n system (src/i18n/)
- **Accessibility**: All interactive elements require accessibilityLabel and accessibilityRole

## Directory Structure to Create

\`\`\`
src/features/auth/
├── screens/
│   ├── login-screen.tsx
│   ├── register-screen.tsx
│   ├── forgot-password-screen.tsx
│   └── biometric-prompt-screen.tsx
├── components/
│   ├── auth-form.tsx
│   ├── social-login-buttons.tsx
│   ├── password-strength-indicator.tsx
│   └── biometric-button.tsx
├── hooks/
│   ├── use-auth.ts
│   ├── use-login.ts
│   ├── use-register.ts
│   ├── use-biometric-auth.ts
│   └── use-password-reset.ts
├── services/
│   ├── auth-service.ts
│   ├── token-service.ts
│   ├── biometric-service.ts
│   └── session-service.ts
├── types/
│   └── auth-types.ts
└── __tests__/
    ├── screens/
    │   ├── login-screen.test.tsx
    │   └── register-screen.test.tsx
    ├── hooks/
    │   ├── use-auth.test.ts
    │   └── use-login.test.ts
    └── services/
        ├── auth-service.test.ts
        └── token-service.test.ts
\`\`\`

## Implementation Requirements

### 1. Types (src/features/auth/types/auth-types.ts)

Define strict TypeScript types — no \`any\`:

\`\`\`typescript
// Include these types at minimum:
// - AuthUser (uid, email, displayName, photoURL, emailVerified, createdAt)
// - AuthState (user, isAuthenticated, isLoading, isOffline, biometricEnabled)
// - LoginCredentials (email, password)
// - RegisterCredentials (email, password, displayName)
// - AuthProvider ('email' | 'google' | 'apple')
// - AuthError (code: AuthErrorCode, message: string, field?: string)
// - AuthErrorCode (union of Firebase auth error codes we handle)
// - BiometricType ('fingerprint' | 'facial' | 'iris' | 'none')
// - SessionInfo (accessToken, refreshToken, expiresAt)
\`\`\`

### 2. Auth Service (src/features/auth/services/auth-service.ts)

Wrap Firebase Auth with a typed service layer:

- \`signInWithEmail(credentials: LoginCredentials): Promise<AuthUser>\`
- \`signUpWithEmail(credentials: RegisterCredentials): Promise<AuthUser>\`
- \`signInWithGoogle(): Promise<AuthUser>\`
- \`signInWithApple(): Promise<AuthUser>\` (iOS only, conditionally exported)
- \`signOut(): Promise<void>\`
- \`resetPassword(email: string): Promise<void>\`
- \`onAuthStateChanged(callback: (user: AuthUser | null) => void): Unsubscribe\`
- \`deleteAccount(): Promise<void>\` (GDPR: right to erasure)
- \`getCurrentUser(): AuthUser | null\`

Error handling: Map Firebase error codes to user-friendly AuthError objects. Never expose raw Firebase errors to UI.

### 3. Token Service (src/features/auth/services/token-service.ts)

Manage tokens securely using expo-secure-store:

- \`storeTokens(session: SessionInfo): Promise<void>\` — store in SecureStore with appropriate security level
- \`getTokens(): Promise<SessionInfo | null>\`
- \`clearTokens(): Promise<void>\`
- \`isTokenExpired(session: SessionInfo): boolean\`
- \`refreshSession(): Promise<SessionInfo>\`

Security requirements:
- Use \`SecureStore.WHEN_UNLOCKED\` for token access
- Never log tokens, even in __DEV__
- Clear tokens on sign-out and account deletion
- Implement token rotation on refresh

### 4. Biometric Service (src/features/auth/services/biometric-service.ts)

Handle biometric authentication using expo-local-authentication:

- \`checkBiometricAvailability(): Promise<BiometricType>\`
- \`authenticateWithBiometrics(reason: string): Promise<boolean>\`
- \`enrollBiometrics(userId: string): Promise<void>\` — store biometric preference in SecureStore
- \`isBiometricEnrolled(userId: string): Promise<boolean>\`
- \`revokeBiometrics(userId: string): Promise<void>\`

Platform considerations:
- Face ID requires NSFaceIDUsageDescription in Info.plist
- Fallback to device passcode if biometric fails
- Handle hardware not available, not enrolled, user cancel gracefully

### 5. Session Service (src/features/auth/services/session-service.ts)

Manage app session lifecycle:

- \`initializeSession(): Promise<AuthState>\` — check stored tokens, validate, restore session
- \`handleAppForeground(): Promise<void>\` — re-validate session when app returns from background
- \`handleAppBackground(): void\` — record background timestamp for session timeout
- \`isSessionValid(): boolean\`
- \`getSessionTimeout(): number\` — configurable timeout (default 30 min inactive)

### 6. Hooks

**use-auth.ts** — Main auth hook connecting to Zustand store:
- Returns: \`{ user, isAuthenticated, isLoading, signOut, deleteAccount }\`
- Subscribes to Firebase onAuthStateChanged
- Updates Zustand auth store
- Handles offline state (return cached user if offline)

**use-login.ts** — Login mutation using React Query:
- \`useMutation\` wrapping auth-service.signInWithEmail
- Handles loading, error, success states
- On success: store tokens, navigate to home, track analytics event
- On error: return typed AuthError with field-level info
- Rate limiting: track failed attempts, lock after 5 failures for 5 minutes

**use-register.ts** — Registration mutation:
- \`useMutation\` wrapping auth-service.signUpWithEmail
- Client-side validation before submission (email format, password strength)
- On success: send verification email, navigate to verification prompt
- Track registration analytics event

**use-biometric-auth.ts** — Biometric authentication hook:
- Check availability on mount
- \`authenticate()\` — trigger biometric prompt, on success restore session from SecureStore
- \`enroll()\` / \`revoke()\` — manage biometric preference
- Returns: \`{ biometricType, isAvailable, isEnrolled, authenticate, enroll, revoke }\`

**use-password-reset.ts** — Password reset mutation:
- \`useMutation\` wrapping auth-service.resetPassword
- Success/error handling with user feedback

### 7. Zustand Auth Store (update src/store/auth.ts)

\`\`\`typescript
interface AuthStore {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  biometricEnabled: boolean;
  lastActiveAt: number | null;
  setUser: (user: AuthUser | null) => void;
  setLoading: (loading: boolean) => void;
  setBiometricEnabled: (enabled: boolean) => void;
  updateLastActive: () => void;
  reset: () => void;
}
\`\`\`

Use Zustand \`persist\` middleware with MMKV or AsyncStorage for offline state persistence.

### 8. Screens

**login-screen.tsx**:
- Email/password form using auth-form component
- Social login buttons (Google, Apple on iOS)
- "Forgot password?" link
- Biometric login button (if enrolled)
- Navigation to register screen
- Keyboard-aware scroll view
- Loading states during authentication
- Error display with field-level highlighting
- All text via i18n: \`t('auth.login.title')\`, \`t('auth.login.emailPlaceholder')\`, etc.
- accessibilityLabel on every TextInput, Button, and Pressable

**register-screen.tsx**:
- Email, password, confirm password, display name fields
- Password strength indicator component
- Terms of service / privacy policy checkbox (GDPR consent)
- GDPR: explicit consent checkbox for data processing, link to privacy policy
- Loading and error states
- Navigation back to login

**forgot-password-screen.tsx**:
- Email input
- Submit button triggers password reset email
- Success confirmation message
- Navigation back to login

**biometric-prompt-screen.tsx**:
- Shown after first successful login if biometrics available
- "Enable Face ID / Touch ID?" prompt
- Skip option
- Enroll biometrics on confirm

### 9. Components

**auth-form.tsx**:
- Reusable form with controlled inputs
- Field-level validation (email format, password min 8 chars, uppercase, number, special char)
- Error message display per field
- Submit button with loading state
- Keyboard dismiss on submit

**social-login-buttons.tsx**:
- Google Sign-In button (both platforms)
- Apple Sign-In button (iOS only, use \`Platform.OS\` check)
- Consistent styling with platform conventions
- Loading states per provider

**password-strength-indicator.tsx**:
- Visual indicator (weak/fair/strong/very strong)
- Color-coded bar (red → orange → yellow → green)
- Requirements checklist (length, uppercase, number, special char)

**biometric-button.tsx**:
- Shows appropriate icon (Face ID / fingerprint) based on BiometricType
- Animated press feedback
- Disabled state when biometrics unavailable

### 10. Navigation Integration

Add auth screens to the navigation config in src/navigation/:

\`\`\`typescript
// Auth stack (unauthenticated)
export type AuthStackParamList = {
  Login: undefined;
  Register: undefined;
  ForgotPassword: undefined;
  BiometricPrompt: { userId: string };
};

// Root navigator switches between AuthStack and MainStack based on auth state
\`\`\`

Deep linking config for auth routes:
- \`myapp://login\`
- \`myapp://register\`
- \`myapp://reset-password?oobCode=xxx\` (Firebase password reset link)

### 11. Testing Requirements

Write tests using Jest + React Native Testing Library. Target 75%+ coverage.

**Screen tests**:
- Login screen renders all fields and buttons
- Login screen shows validation errors for empty/invalid fields
- Login screen calls signInWithEmail on valid submission
- Login screen shows API error messages
- Login screen shows biometric button when enrolled
- Register screen validates password strength
- Register screen requires GDPR consent checkbox

**Hook tests**:
- use-auth returns correct state from Zustand store
- use-login handles success (stores tokens, navigates)
- use-login handles failure (returns typed error)
- use-login enforces rate limiting after 5 failures

**Service tests**:
- auth-service maps Firebase errors to AuthError
- token-service stores/retrieves from SecureStore
- token-service detects expired tokens
- biometric-service handles unavailable hardware

Mock Firebase, SecureStore, and expo-local-authentication in tests.

### 12. Security Checklist

- [ ] Passwords never stored locally — only Firebase handles password storage
- [ ] Tokens stored in expo-secure-store (Keychain/Keystore), never AsyncStorage
- [ ] No sensitive data in console.log, even in __DEV__
- [ ] Rate limiting on login attempts (client-side + Firebase Security Rules)
- [ ] Session timeout after 30 min inactivity
- [ ] Clear all auth data on sign-out (tokens, biometric enrollment, cached user)
- [ ] GDPR: deleteAccount() removes user data from Firestore + Firebase Auth
- [ ] GDPR: Consent recorded with timestamp before account creation
- [ ] Certificate pinning configured for Firebase endpoints
- [ ] ProGuard/R8 (Android) and code stripping (iOS) enabled for release builds

### 13. Analytics Events to Track

- \`auth_login_success\` (provider: email | google | apple | biometric)
- \`auth_login_failure\` (error_code, provider)
- \`auth_register_success\`
- \`auth_register_failure\` (error_code)
- \`auth_logout\`
- \`auth_password_reset_requested\`
- \`auth_biometric_enrolled\`
- \`auth_biometric_revoked\`
- \`auth_account_deleted\`

Use the analytics service at src/services/analytics.ts — do not call Firebase Analytics directly from feature code.

## Constraints

- Max 250 lines per file — split if needed
- No \`any\` types — use \`unknown\` and narrow with type guards
- All files use kebab-case naming
- Components use PascalCase exports
- Hooks use camelCase with \`use\` prefix
- Constants use SCREAMING_SNAKE_CASE
- Every user-facing string goes through i18n
- Every interactive element has accessibilityLabel and accessibilityRole
- Mark all generated files with \`// AI-generated\` comment at the top

## Execution Order

1. Create types first (auth-types.ts)
2. Create services (auth-service → token-service → biometric-service → session-service)
3. Create Zustand store update
4. Create hooks (use-auth → use-login → use-register → use-biometric-auth → use-password-reset)
5. Create components (auth-form → social-login-buttons → password-strength-indicator → biometric-button)
6. Create screens (login → register → forgot-password → biometric-prompt)
7. Update navigation config
8. Write tests for each layer
9. Run \`pnpm tsc --noEmit\` to verify no type errors
10. Run \`pnpm test --coverage\` to verify 75%+ coverage
11. Run \`pnpm lint\` to verify no lint errors

After each file, run \`pnpm tsc --noEmit\` to catch type errors early. After all files, run the full test suite.
\`\`\`

---

## Usage Notes

- **Before running**: Ensure Firebase is configured (\`google-services.json\` and \`GoogleService-Info.plist\` in place), expo-secure-store and expo-local-authentication are installed.
- **Prerequisite prompts**: \`project-scaffold\` (Phase 03) must be complete.
- **Follow-up prompts**: After auth is implemented, proceed to \`offline-sync-setup\` and \`push-notification-setup\` in Phase 05.
- **Verification**: Run \`/verify\` command after implementation to validate types, tests, and lint pass.`,

  'playbook/prompts/04/crud-generator.md': `# CRUD Generator — React Native Feature Module

> **Phase**: 04 — Core Implementation
> **Usage**: Copy-paste into Claude Code to scaffold a complete CRUD feature module with screens, components, hooks, services, types, tests, and offline-first sync.

---

## Prompt

\`\`\`
You are a senior React Native developer working on a cross-platform mobile app built with Expo SDK 51, TypeScript (strict mode), React Navigation v6, Zustand, React Query/TanStack Query, WatermelonDB (offline-first), and Firebase (Firestore, Cloud Functions).

I need you to generate a complete CRUD feature module for the entity described below. Follow every instruction precisely.

---

### Entity Definition

- **Entity name**: [ENTITY_NAME, e.g., "Task", "Product", "Workout"]
- **Plural name**: [ENTITY_PLURAL, e.g., "Tasks", "Products", "Workouts"]
- **Feature directory**: src/features/[FEATURE_SLUG]/
- **Fields** (provide your schema):
  \`\`\`
  [List fields with types, e.g.:
    - id: string (auto-generated UUID)
    - title: string (required, max 100 chars)
    - description: string (optional, max 500 chars)
    - status: 'draft' | 'active' | 'completed' | 'archived'
    - priority: 'low' | 'medium' | 'high'
    - dueDate: Date | null
    - assigneeId: string | null (references User)
    - attachments: string[] (Firebase Storage URLs)
    - createdAt: Date
    - updatedAt: Date
  ]
  \`\`\`
- **Belongs to feature**: [PARENT_FEATURE if nested, or "standalone"]
- **Requires authentication**: [yes/no]
- **Supports offline**: [yes/no]
- **Has push notifications**: [yes/no, e.g., notify on status change]
- **Has in-app search**: [yes/no]
- **Has pagination**: [yes/no — infinite scroll or page-based]
- **Has image/file uploads**: [yes/no]

---

### File Generation Requirements

Generate ALL of the following files. Each file must be self-contained, production-ready, and under 250 lines. Use kebab-case for file names, PascalCase for components/screens, camelCase for hooks/utils, SCREAMING_SNAKE_CASE for constants.

#### 1. Types — \`src/features/[FEATURE_SLUG]/types/[entity].types.ts\`

- Define the core entity interface with all fields
- Define CreateDTO and UpdateDTO types (omit auto-generated fields)
- Define filter/sort types for list queries
- Define form validation schema type
- Define WatermelonDB model column mapping type
- Export a Zod schema (or manual validator) for runtime validation
- Use discriminated unions for status fields where applicable
- No \`any\` — every type must be explicit

#### 2. WatermelonDB Model — \`src/features/[FEATURE_SLUG]/models/[entity].model.ts\`

- Extend WatermelonDB \`Model\`
- Decorate with \`@table\`, \`@field\`, \`@date\`, \`@readonly\`, \`@relation\` as needed
- Define \`columnName\` constants matching Firestore document fields
- Include \`@lazy\` computed properties where useful (e.g., \`isOverdue\`)
- Export table name constant
- Include static \`associations\` for any relations

#### 3. WatermelonDB Schema Migration — \`src/features/[FEATURE_SLUG]/models/[entity].schema.ts\`

- Export \`tableSchema\` for the entity table
- Define all columns with correct WatermelonDB column types (\`string\`, \`number\`, \`boolean\`)
- Include \`created_at\` and \`updated_at\` as number columns (timestamps)
- Add \`is_synced\` boolean column for offline sync tracking
- Add \`server_id\` string column for Firestore document ID mapping

#### 4. Firebase Service — \`src/features/[FEATURE_SLUG]/services/[entity].service.ts\`

- Implement Firestore CRUD operations: \`create\`, \`getById\`, \`getList\`, \`update\`, \`delete\` (soft delete)
- Use typed Firestore converters with \`withConverter<EntityType>()\`
- Implement cursor-based pagination with \`startAfter\` / \`limit\`
- Implement filter and sort query builders
- Handle Firebase Storage uploads if entity has file fields
- Include proper error handling with typed error classes
- Use \`serverTimestamp()\` for createdAt/updatedAt
- Add Firestore security rule comments documenting expected rules
- Export as singleton service instance

#### 5. Sync Service — \`src/features/[FEATURE_SLUG]/services/[entity]-sync.service.ts\`

- Implement WatermelonDB ↔ Firestore bidirectional sync
- Use \`synchronize()\` from \`@nozbe/watermelondb/sync\`
- Handle conflict resolution (server wins by default, with merge strategy for specific fields)
- Track sync status with timestamps
- Handle network state changes (queue operations when offline)
- Implement pull (Firestore → WatermelonDB) with \`modifiedSince\` filtering
- Implement push (WatermelonDB → Firestore) for locally created/updated/deleted records
- Log sync errors to Sentry

#### 6. React Query Hooks — \`src/features/[FEATURE_SLUG]/hooks/use-[entity]-queries.ts\`

- \`use[Entity]List(filters, sort, pagination)\` — paginated list with infinite query
- \`use[Entity]ById(id)\` — single entity fetch with offline fallback
- \`useCreate[Entity]()\` — mutation with optimistic update
- \`useUpdate[Entity]()\` — mutation with optimistic update
- \`useDelete[Entity]()\` — mutation with optimistic update (soft delete)
- All hooks must:
  - Use typed query keys with a factory pattern (\`[entity]Keys.all\`, \`[entity]Keys.lists()\`, \`[entity]Keys.detail(id)\`)
  - Invalidate related queries on mutation success
  - Fall back to WatermelonDB when offline (check \`NetInfo\`)
  - Show toast notifications on error via a shared \`useToast\` hook
  - Include \`retry: 2\` for queries, \`retry: 0\` for mutations
  - Type all return values explicitly (no inferred \`any\`)

#### 7. Zustand Store (optional client state) — \`src/features/[FEATURE_SLUG]/store/[entity].store.ts\`

- Store UI-only state: selected filters, sort order, search query, selected items (multi-select)
- Use Zustand \`persist\` middleware with MMKV storage for filter preferences
- Define typed actions: \`setFilter\`, \`setSort\`, \`setSearch\`, \`toggleSelect\`, \`clearSelection\`
- Keep store minimal — server state belongs in React Query, not here

#### 8. Form Hook — \`src/features/[FEATURE_SLUG]/hooks/use-[entity]-form.ts\`

- Use \`react-hook-form\` with Zod resolver for validation
- Define default values matching CreateDTO / UpdateDTO
- Handle both create and edit modes via optional \`initialValues\`
- Validate all fields with user-friendly error messages (i18n keys)
- Return \`handleSubmit\`, \`control\`, \`errors\`, \`isSubmitting\`, \`isDirty\`
- Trim string fields on submit
- Validate file sizes/types before upload if applicable

#### 9. List Screen — \`src/features/[FEATURE_SLUG]/screens/[entity]-list.screen.tsx\`

- Use \`FlashList\` (or \`FlatList\`) with proper \`estimatedItemSize\`
- Implement pull-to-refresh with \`RefreshControl\`
- Implement infinite scroll pagination via \`onEndReached\`
- Show skeleton loading state (not spinner) on initial load
- Show empty state component with illustration and CTA
- Show error state with retry button
- Include search bar (if \`has in-app search\`)
- Include filter chips / sort controls from Zustand store
- FAB (Floating Action Button) for create action
- Each list item navigates to detail screen on press
- Swipe actions for quick delete/archive (react-native-gesture-handler)
- All text via i18n: \`t('[feature].[entity].list.title')\` pattern
- Accessibility: \`accessibilityLabel\`, \`accessibilityRole\` on all interactive elements
- Memoize list items with \`React.memo\` and stable key extractor

#### 10. Detail Screen — \`src/features/[FEATURE_SLUG]/screens/[entity]-detail.screen.tsx\`

- Receive entity ID via React Navigation route params (typed)
- Fetch entity with \`use[Entity]ById(id)\`
- Show loading skeleton, error state, or content
- Display all entity fields with proper formatting (dates, status badges, etc.)
- Header right button for edit (navigates to form screen)
- Delete action with confirmation alert (\`Alert.alert\`)
- Share action using \`expo-sharing\` if applicable
- Handle deep link entry (entity may not be in cache — fetch fresh)
- Back navigation with proper stack behavior

#### 11. Form Screen (Create/Edit) — \`src/features/[FEATURE_SLUG]/screens/[entity]-form.screen.tsx\`

- Dual-purpose: create (no params) or edit (entity ID in route params)
- Use the form hook from step 8
- Render form fields with shared \`Input\`, \`Select\`, \`DatePicker\`, \`ImagePicker\` components
- Show validation errors inline below each field
- Disable submit button while submitting (show ActivityIndicator)
- Unsaved changes warning on back navigation (\`beforeRemove\` listener)
- Keyboard-aware scroll view (\`KeyboardAwareScrollView\`)
- Auto-focus first field on mount (create mode only)
- Navigate back on successful submit with success toast

#### 12. List Item Component — \`src/features/[FEATURE_SLUG]/components/[entity]-list-item.tsx\`

- Receive entity as prop (typed)
- Display key fields (title, status badge, date, avatar/icon)
- Use \`Pressable\` with proper press feedback
- Memoized with \`React.memo\` and custom \`areEqual\` comparator
- Accessibility: label describes the item, role is "button"
- Swipeable wrapper for quick actions

#### 13. Navigation Config — \`src/features/[FEATURE_SLUG]/navigation/[entity].navigator.tsx\`

- Define typed param list: \`[Entity]StackParamList\`
- Create stack navigator with List, Detail, and Form screens
- Configure screen options (headers, transitions)
- Export navigator component and param list type
- Register deep link paths: \`/[entity]\`, \`/[entity]/:id\`, \`/[entity]/new\`, \`/[entity]/:id/edit\`

#### 14. Unit Tests — \`src/features/[FEATURE_SLUG]/__tests__/[entity].service.test.ts\`

- Test all Firebase service methods with mocked Firestore
- Test pagination logic
- Test filter/sort query building
- Test error handling paths
- Test offline fallback behavior
- Minimum 90% coverage for service file

#### 15. Component Tests — \`src/features/[FEATURE_SLUG]/__tests__/[entity]-list.screen.test.tsx\`

- Test loading state renders skeletons
- Test empty state renders when no data
- Test error state renders with retry
- Test list renders items correctly
- Test pull-to-refresh triggers refetch
- Test navigation to detail on item press
- Test FAB navigates to create form
- Mock React Navigation, React Query, and Zustand
- Use \`@testing-library/react-native\` \`render\`, \`screen\`, \`fireEvent\`, \`waitFor\`

#### 16. Component Tests — \`src/features/[FEATURE_SLUG]/__tests__/[entity]-form.screen.test.tsx\`

- Test create mode renders empty form
- Test edit mode renders pre-filled form
- Test validation errors display on invalid submit
- Test successful submit calls mutation and navigates back
- Test unsaved changes warning on back press
- Test loading state during submission

#### 17. E2E Test Spec — \`e2e/[entity]-crud.e2e.ts\`

- Detox test covering full CRUD flow:
  1. Navigate to entity list
  2. Tap FAB → create form opens
  3. Fill all required fields
  4. Submit → navigates to list, new item visible
  5. Tap item → detail screen
  6. Tap edit → form pre-filled
  7. Modify a field → submit → detail updated
  8. Delete → confirmation → item removed from list
- Use \`element(by.id(...))\` matchers with semantic test IDs
- Include \`waitFor\` for async operations

#### 18. i18n Keys — \`src/features/[FEATURE_SLUG]/i18n/[entity].en.ts\`

- Export flat object with all UI strings for the feature
- Keys follow pattern: \`list.title\`, \`list.empty\`, \`list.error\`, \`detail.title\`, \`form.title.create\`, \`form.title.edit\`, \`form.fields.[field].label\`, \`form.fields.[field].placeholder\`, \`form.fields.[field].error.*\`, \`actions.create\`, \`actions.edit\`, \`actions.delete\`, \`actions.delete.confirm.title\`, \`actions.delete.confirm.message\`, \`toast.created\`, \`toast.updated\`, \`toast.deleted\`, \`toast.error\`

#### 19. Index Barrel — \`src/features/[FEATURE_SLUG]/index.ts\`

- Re-export navigator, types, hooks, store, and service
- This is the public API of the feature module

---

### Code Quality Rules

1. **No \`any\`** — every variable, parameter, return type must be explicitly typed
2. **Max 250 lines per file** — split if needed, note where to split
3. **All interactive elements** must have \`accessibilityLabel\` and \`accessibilityRole\`
4. **All user-facing strings** must use i18n keys, never hardcoded
5. **Error boundaries** — wrap screens in error boundary or use React Query error states
6. **Conventional imports** — group: react/react-native → third-party → @app/ aliases → relative
7. **No inline styles** — use \`StyleSheet.create()\` or theme tokens
8. **Memoize** expensive computations and list items
9. **Handle all states**: loading, error, empty, offline, success
10. **Platform-specific code** — use \`Platform.select()\` or \`.ios.ts\`/\`.android.ts\` when needed

### Output Format

For each file, output:

\`\`\`
// FILE: [relative path from project root]
[complete file content]
\`\`\`

Generate all 19 files now. Start with types, then model, then services, then hooks, then screens, then tests, then i18n, then navigation, then barrel export.
\`\`\`

---

## Usage Notes

1. **Replace placeholders** before pasting:
   - \`[ENTITY_NAME]\` — singular PascalCase (e.g., \`Task\`)
   - \`[ENTITY_PLURAL]\` — plural PascalCase (e.g., \`Tasks\`)
   - \`[FEATURE_SLUG]\` — kebab-case directory name (e.g., \`tasks\`)
   - Fill in the fields schema with your actual entity fields
   - Set the boolean flags (offline, search, pagination, etc.)

2. **Iterative generation**: If Claude hits output limits, ask it to continue from the last file. The numbered list makes it easy to resume.

3. **Customization**: Remove sections you don't need (e.g., remove sync service if entity doesn't support offline, remove E2E if not yet configured).

4. **Post-generation checklist**:
   - [ ] Register the navigator in \`src/navigation/root.navigator.tsx\`
   - [ ] Add the WatermelonDB table schema to \`src/services/database/schema.ts\`
   - [ ] Add the migration to \`src/services/database/migrations.ts\`
   - [ ] Register i18n keys in \`src/i18n/en.ts\`
   - [ ] Add Firestore security rules in \`firestore.rules\`
   - [ ] Add deep link paths to \`src/navigation/linking.ts\`
   - [ ] Add feature to CODEOWNERS: \`src/features/[FEATURE_SLUG]/ @team-mobile\`
   - [ ] Run \`pnpm test -- --coverage --collectCoverageFrom='src/features/[FEATURE_SLUG]/**'\`
   - [ ] Run \`npx expo start\` and verify screens render
   - [ ] Run \`npx detox test e2e/[entity]-crud.e2e.ts\` on both platforms

5. **Related prompts**:
   - \`playbook/prompts/02/data-model-design.md\` — design the entity schema first
   - \`playbook/prompts/02/api-design.md\` — define Cloud Functions endpoints if needed
   - \`playbook/prompts/03/project-scaffold.md\` — ensure feature directory structure exists`,

  'playbook/prompts/04/feature-implementation.md': `# Feature Implementation Prompt — Phase 04: Core Implementation

> Copy-paste this prompt into Claude Code when implementing a new feature in the React Native mobile app.

---

## Prompt

\`\`\`
You are implementing a feature for a React Native mobile app (Expo SDK 51, TypeScript strict mode, Firebase backend). Follow the project's architecture, conventions, and quality standards precisely.

## Feature Details

- **Feature name**: [FEATURE_NAME]
- **Ticket**: [APP-XXX]
- **Feature directory**: src/features/[feature-slug]/
- **Description**: [Brief description of what this feature does]
- **User stories**: [List the user stories or acceptance criteria]
- **Affected platforms**: [iOS / Android / Both]

## Project Architecture

This project uses a feature-based architecture:

\`\`\`
src/features/[feature-slug]/
  screens/           # Screen components (one per route)
  components/        # Feature-specific UI components
  hooks/             # Feature-specific hooks
  services/          # Feature-specific API/Firebase calls
  types/             # Feature-specific TypeScript types
  __tests__/         # Unit and component tests
  index.ts           # Public API barrel export
\`\`\`

Shared code lives outside features:
- src/components/ — reusable UI primitives (Button, Card, Input, Modal)
- src/hooks/ — shared hooks (useAuth, useOffline, useTheme)
- src/services/ — Firebase services, analytics, crash reporting
- src/navigation/ — React Navigation typed navigators and linking config
- src/store/ — Zustand stores (auth, theme, preferences)
- src/utils/ — formatting, validation, platform helpers
- src/i18n/ — all user-facing text (no hardcoded strings)
- src/theme/ — design tokens (colors, typography, spacing)

## Implementation Constraints

### TypeScript
- Strict mode enabled — no \`any\`, no \`as\` escape hatches unless justified with a comment
- All props interfaces exported and named \`[Component]Props\`
- All navigation params typed using React Navigation's typed param lists
- All Firebase document types defined in the feature's types/ directory

### State Management
- **Server state** (Firebase data, API responses): React Query / TanStack Query
  - Define query keys in a \`queryKeys.ts\` file within the feature
  - Use \`useQuery\` for reads, \`useMutation\` for writes
  - Configure staleTime and cacheTime appropriate to the data
  - Handle loading, error, and empty states explicitly
- **Client state** (UI state, preferences): Zustand
  - Only create a new store if the state is shared across screens
  - Local component state with useState/useReducer for ephemeral UI state
- **Offline state**: WatermelonDB for data that must persist offline
  - Define models in src/database/models/
  - Implement sync adapters that reconcile with Firestore

### Offline-First
- The feature MUST work when the device has no network connectivity
- Use WatermelonDB for local persistence where applicable
- Queue mutations when offline; sync when connectivity returns
- Show clear UI indicators for offline state and pending sync
- Use \`@react-native-community/netinfo\` to detect connectivity

### Navigation
- Register new screens in the appropriate navigator under src/navigation/
- Add typed route params to the navigator's param list type
- Support deep linking — add URI patterns to the linking configuration
- Handle navigation state restoration on app restart

### Internationalization
- ALL user-facing strings go through src/i18n/ — zero hardcoded text
- Add translation keys to the appropriate namespace file
- Use the \`useTranslation\` hook in components
- Include pluralization rules where counts are displayed

### Accessibility
- Every interactive element MUST have an \`accessibilityLabel\`
- Every screen MUST have an \`accessibilityRole\` on the root container
- Use \`accessibilityHint\` for non-obvious interactions
- Test with screen reader announcements in mind
- Support Dynamic Type / font scaling on iOS
- Minimum touch target: 44x44 points

### Styling
- Use the theme tokens from src/theme/ — no magic numbers for colors, spacing, or typography
- Support light and dark mode via the useTheme hook
- Use StyleSheet.create for performance — no inline style objects in render
- Handle safe areas with react-native-safe-area-context
- Handle notch/dynamic island on iOS and camera cutouts on Android

### Platform Handling
- Use Platform.select or platform-specific file extensions (.ios.ts / .android.ts) for divergent behavior
- Test on both iOS and Android — note any platform-specific edge cases
- If using native modules, ensure both platforms have implementations

### Performance
- Memoize expensive computations with useMemo
- Memoize callbacks passed to child components with useCallback
- Use React.memo on list item components
- Use FlashList instead of FlatList for large lists
- Lazy-load screens with React.lazy or React Navigation's lazy option
- Images: use expo-image with caching, specify width/height to avoid layout shifts
- Avoid re-renders: keep state as close to where it's used as possible

### Security
- Never log sensitive data (tokens, passwords, PII) — not even in __DEV__
- Store sensitive values in expo-secure-store (maps to Keychain/Keystore)
- Validate all user input before sending to Firebase
- Sanitize data received from Firestore before rendering
- If this feature handles auth tokens, implement certificate pinning

### Error Handling
- Wrap async operations in try/catch with typed error handling
- Report errors to Sentry via src/services/crash-reporting.ts
- Show user-friendly error messages (from i18n, not raw error strings)
- Implement retry logic for transient network failures
- Use Error Boundaries around feature screen roots

### Analytics
- Track screen views via React Navigation screen tracking
- Track key user actions via src/services/analytics.ts
- Use Firebase Analytics event naming conventions (snake_case, max 40 chars)
- Include relevant parameters but NEVER include PII in analytics events
- Log feature-specific events: [LIST_KEY_EVENTS]

## Implementation Steps

Follow this order strictly:

### Step 1: Types First
Create \`src/features/[feature-slug]/types/index.ts\` with:
- All TypeScript interfaces and types for this feature
- Firebase document types
- Navigation param types
- Component prop types
- API request/response types

### Step 2: Services Layer
Create \`src/features/[feature-slug]/services/\` with:
- Firebase Firestore queries and mutations
- Cloud Function calls if needed
- WatermelonDB model and sync logic if offline support is needed
- React Query hooks wrapping the service calls (query keys, useQuery, useMutation)

### Step 3: Zustand Store (if needed)
Create or extend a store in \`src/store/\` only if:
- State is shared across multiple screens in this feature
- State must persist across navigation (not just within a screen)

### Step 4: Custom Hooks
Create \`src/features/[feature-slug]/hooks/\` with:
- Hooks that compose React Query + Zustand + business logic
- Platform-specific hooks if behavior diverges
- Hooks for complex UI interactions (animations, gestures)

### Step 5: Components (Bottom-Up)
Create \`src/features/[feature-slug]/components/\` with:
- Smallest atomic components first, then compose upward
- Each component in its own file (max 250 lines)
- Co-located test file: \`ComponentName.test.tsx\`
- Export from feature's index.ts only if used outside the feature

### Step 6: Screens
Create \`src/features/[feature-slug]/screens/\` with:
- One file per screen/route
- Screens compose feature components and shared components
- Screens connect to hooks for data and state
- Screens handle loading, error, empty, and offline states
- Each screen has a co-located test file

### Step 7: Navigation Integration
Update \`src/navigation/\`:
- Add route to the appropriate navigator (stack or tab)
- Add typed params to the navigator's param list
- Add deep link URI pattern to linking config
- Add screen tracking for analytics

### Step 8: Tests
Ensure all tests are written alongside implementation (not after):
- **Unit tests**: hooks, services, utils, store logic
- **Component tests**: render, user interaction, accessibility
- **Screen tests**: integration of components + hooks + navigation
- Use React Native Testing Library — test behavior, not implementation
- Mock Firebase services, navigation, and native modules
- Target 75% coverage minimum for the feature

### Step 9: i18n and Accessibility Audit
- Verify zero hardcoded strings — all text from i18n
- Verify all interactive elements have accessibilityLabel
- Verify screen reader navigation flow makes sense
- Verify Dynamic Type support on iOS

### Step 10: Barrel Export
Create \`src/features/[feature-slug]/index.ts\`:
- Export only the public API (screens, types used by navigation)
- Do NOT export internal components or hooks

## Output Format

For each file you create or modify:
1. State the file path
2. Explain WHY this file exists (one sentence)
3. Provide the complete file content
4. If modifying an existing file, show only the diff or clearly mark additions

After all files, provide:
- A summary of all files created/modified
- Any manual steps needed (e.g., adding native config, updating app.json)
- Known platform-specific considerations
- Suggested Detox E2E test scenarios for this feature

## Quality Checklist

Before finishing, verify:
- [ ] TypeScript compiles with zero errors (\`npx tsc --noEmit\`)
- [ ] ESLint passes (\`pnpm lint\`)
- [ ] Prettier formatting applied (\`pnpm format\`)
- [ ] All tests pass (\`pnpm test --coverage\`)
- [ ] Coverage ≥ 75% for new code
- [ ] No hardcoded strings — all text through i18n
- [ ] All interactive elements have accessibility labels
- [ ] Offline behavior handled (works without network)
- [ ] Loading, error, and empty states implemented
- [ ] Light and dark mode supported
- [ ] No \`any\` types, no \`as\` casts without justification
- [ ] No file exceeds 250 lines
- [ ] Sensitive data uses expo-secure-store, not AsyncStorage
- [ ] Analytics events tracked for key user actions
- [ ] Error reporting wired to Sentry
- [ ] Deep linking configured for new screens
- [ ] Both iOS and Android tested/considered
- [ ] Conventional commit message prepared: \`feat(APP-XXX): [description]\`
- [ ] Branch named correctly: \`feat/APP-XXX-[feature-slug]\`
\`\`\`

---

## Usage Notes

1. **Replace all placeholders** in brackets before pasting: \`[FEATURE_NAME]\`, \`[APP-XXX]\`, \`[feature-slug]\`, \`[LIST_KEY_EVENTS]\`, user stories, and description.

2. **Scope appropriately** — if the feature is large, break it into sub-tickets and run this prompt once per sub-ticket. Each run should produce a reviewable, mergeable PR.

3. **Pair with TDD** — for complex business logic, run \`/tdd\` first to generate test cases, then use this prompt to implement against those tests.

4. **After implementation**, run \`/verify\` to confirm all quality gates pass before opening a PR.

5. **Example invocation** for push notifications feature:

\`\`\`
Feature name: Push Notifications
Ticket: APP-42
Feature directory: src/features/notifications/
Description: Receive and display push notifications, manage notification preferences, handle deep links from notification taps
User stories:
  - As a user, I can receive push notifications when the app is in background/foreground
  - As a user, I can tap a notification to navigate to the relevant screen
  - As a user, I can manage my notification preferences (enable/disable categories)
  - As a user, I can view a history of received notifications
Affected platforms: Both
Key events: notification_received, notification_tapped, notification_preference_changed, notification_history_viewed
\`\`\`

6. **For features involving native modules** (biometrics, in-app purchases, camera), add a note about required Expo config plugins or custom native code via Expo Modules API.

7. **For features involving sensitive data** (auth, payments), explicitly list the security requirements and reference the ADR for the chosen approach.`,

  'playbook/prompts/05/integration-adapter.md': `# Integration Adapter — Phase 05 Prompt

> Copy-paste this prompt into Claude Code when you need to build an integration adapter for connecting your React Native app with external services, native modules, or third-party SDKs.

---

## Prompt

\`\`\`
You are a senior React Native engineer working on the react-native-mobile-app project. Your task is to build an integration adapter that cleanly connects our app with an external service or native module.

## Context

- React Native 0.74 + Expo SDK 51, TypeScript strict mode (no \`any\`)
- Feature-based architecture: src/features/{feature}/screens|components|hooks|types
- Shared services live in src/services/
- State: Zustand (client), React Query/TanStack Query (server)
- Offline-first with WatermelonDB syncing to Firestore
- All text through i18n, accessibility labels on all interactive elements
- Max file length: 250 lines
- Naming: PascalCase components, camelCase hooks/utils, kebab-case files, SCREAMING_SNAKE_CASE constants

## Integration Target

**Service/Module**: [REPLACE: e.g., "Stripe In-App Purchases via expo-in-app-purchases", "Firebase Cloud Messaging push notifications", "Sentry crash reporting", "WatermelonDB ↔ Firestore sync", "biometric authentication via expo-local-authentication", "deep linking via React Navigation", "RevenueCat subscriptions", "Mapbox native maps"]

**Purpose**: [REPLACE: e.g., "Handle subscription purchases, receipt validation, and entitlement management across iOS and Android"]

**Platform Requirements**: [REPLACE: e.g., "Both iOS and Android", "iOS only", "Android only with iOS fallback"]

## What to Generate

### 1. Adapter Interface (src/services/{service-name}/types.ts)

Define a TypeScript interface that abstracts the external service:

- Platform-agnostic method signatures (hide iOS/Android differences)
- Strongly typed request/response types (no \`any\`)
- Error types specific to this integration
- Configuration type for initialization
- Status/state types for connection health

### 2. Adapter Implementation (src/services/{service-name}/{service-name}-adapter.ts)

Implement the adapter with:

- Singleton or factory pattern (justify choice)
- Initialization with proper error handling and retry logic
- Platform-specific branching using \`Platform.OS\` where needed
- Graceful degradation when the service is unavailable
- Timeout handling for all external calls
- Logging integration points (but no sensitive data in logs)
- Cleanup/teardown method for app lifecycle events

### 3. React Query Integration (src/services/{service-name}/queries.ts)

If the adapter fetches server state:

- Query keys following the pattern \`['{service}', '{resource}', params]\`
- Custom hooks: \`use{Resource}Query\`, \`use{Resource}Mutation\`
- Proper stale time, cache time, retry configuration
- Optimistic updates where appropriate
- Error handling that maps service errors to user-facing messages

### 4. Zustand Store Slice (src/store/{service-name}-store.ts)

If the adapter manages client state:

- Typed store interface
- Actions that delegate to the adapter
- Selectors for derived state
- Persist configuration if state should survive app restart
- Reset action for logout/cleanup scenarios

### 5. React Hook (src/hooks/use-{service-name}.ts)

A convenience hook that:

- Combines adapter, queries, and store as needed
- Handles initialization lifecycle
- Exposes a clean API to components
- Manages loading/error/success states
- Handles app state changes (background/foreground) via AppState

### 6. Offline Support (if applicable)

- Queue operations when offline using WatermelonDB or async storage
- Replay queued operations when connectivity returns
- Conflict resolution strategy (last-write-wins, merge, or prompt user)
- Sync status exposed to UI

### 7. Platform Configuration

- app.json / app.config.ts plugin entries needed
- iOS-specific setup (Info.plist keys, entitlements, Podfile changes)
- Android-specific setup (AndroidManifest.xml, build.gradle changes)
- Environment variable requirements (added to .env.example)
- EAS Build configuration changes if needed

### 8. Tests

For each file, generate corresponding test files:

- Unit tests for the adapter (mock the native module / SDK)
- Unit tests for hooks using \`renderHook\` from React Native Testing Library
- Integration test showing the adapter working with the store/queries
- Mock factory for the external service (src/services/{service-name}/__mocks__/)
- Test coverage must support the 75% threshold target

### 9. Error Boundary Integration

- Custom error class extending Error with service-specific codes
- Error mapping: service errors → user-friendly i18n keys
- Recovery strategies (retry, fallback, navigate to error screen)
- Sentry breadcrumb/context attachment for debugging

### 10. Documentation

Brief inline JSDoc on public methods plus a short README section covering:

- What the adapter does and why it exists
- How to configure it for development vs staging vs production
- Common failure modes and how to debug them
- How to test it locally (including any simulator/emulator gotchas)

## Constraints

- Do NOT call native modules directly from components — always go through the adapter
- Do NOT store secrets in code — use react-native-config environment variables
- Do NOT log PII or tokens (GDPR compliance)
- Handle both iOS and Android unless explicitly single-platform
- Use expo-secure-store for any tokens, keys, or sensitive credentials
- All user-facing strings go through src/i18n/ — no hardcoded text
- Accessibility: any UI triggered by this integration needs accessibilityLabel and accessibilityRole
- File length max 250 lines — split into multiple files if needed
- Conventional commit messages for all changes: feat(integration): add {service} adapter

## Output Format

For each file, output:

1. File path (relative to project root)
2. Complete file content
3. Brief comment on why key design decisions were made

Start with the types file, then adapter, then work outward to hooks/tests/config. Flag any manual steps I need to perform outside of code (e.g., enabling a capability in Xcode, creating a Firebase project, adding API keys to EAS secrets).
\`\`\`

---

## Usage Notes

### Before Running

1. Replace the three \`[REPLACE: ...]\` placeholders with your specific integration details
2. If you have an existing adapter pattern in the codebase, mention it so Claude matches the style
3. Attach relevant SDK documentation or link to it in the prompt

### Recommended Workflow

\`\`\`bash
# 1. Create a feature branch
git checkout -b feat/APP-XX-integrate-{service-name}

# 2. Run the prompt in Claude Code
# Paste the prompt with your replacements

# 3. Review generated files
# Check types first, then adapter, then tests

# 4. Install any new dependencies
pnpm add {package-name}
npx expo install {expo-package}

# 5. Run platform-specific setup
cd ios && pod install && cd ..

# 6. Verify types compile
npx tsc --noEmit

# 7. Run tests
pnpm test --coverage

# 8. Test on both platforms
npx expo start --ios
npx expo start --android

# 9. Commit with conventional format
git add -A
git commit -m "feat(integration): add {service-name} adapter

- Adapter with offline support and retry logic
- React Query hooks for server state
- Zustand store for client state
- Unit and integration tests (>75% coverage)
- Platform config for iOS and Android

Refs: APP-XX"
\`\`\`

### Common Integration Targets

| Service | Key Considerations |
|---|---|
| Firebase Cloud Messaging | Foreground/background handlers, permission flow, token refresh, topic subscriptions |
| WatermelonDB ↔ Firestore Sync | Conflict resolution, batch sync, incremental pull, schema migrations |
| expo-local-authentication | Biometric availability check, fallback to passcode, enrollment state, secure store pairing |
| In-App Purchases (RevenueCat) | Receipt validation, entitlement caching, restore purchases, sandbox vs production |
| Sentry | Source maps upload in EAS Build, breadcrumbs, user context (anonymized), performance tracing |
| Deep Linking | Universal links (iOS), app links (Android), deferred deep links, navigation state restoration |
| Analytics (Firebase + custom) | Consent gating (GDPR), screen tracking via navigation, event taxonomy, debug view |
| Mapbox / Google Maps | Platform-specific map views, marker clustering, offline tiles, location permissions |

### Validating the Adapter

After generation, verify these quality gates:

- [ ] No \`any\` types in generated code
- [ ] All external calls wrapped in try/catch with typed errors
- [ ] Offline scenario handled (queue or graceful degradation)
- [ ] Both \`Platform.OS === 'ios'\` and \`'android'\` paths covered
- [ ] Sensitive data uses \`expo-secure-store\`, not \`AsyncStorage\`
- [ ] No hardcoded strings in UI — all through i18n
- [ ] Tests mock the native layer, not the adapter itself
- [ ] Cleanup/teardown handles app lifecycle (AppState listener removed)
- [ ] EAS Build config updated if native dependencies added
- [ ] CODEOWNERS updated if new sensitive paths created (src/services/auth/**)

### Follow-Up Prompts

After the adapter is built, you may want to:

- **Wire it into a feature screen**: Use the \`playbook/prompts/04/feature-implementation.md\` prompt referencing the new adapter hook
- **Add E2E coverage**: "Write a Detox E2E test that verifies {service} works end-to-end on iOS simulator, mocking the server responses with a local fixture"
- **Add monitoring**: "Add Sentry breadcrumbs to the {service} adapter so we can trace failures in production. Include the operation name, duration, and error code — but never PII or tokens"
- **Harden for production**: Use \`playbook/prompts/05/security-hardening.md\` to audit the adapter for certificate pinning, secure storage, and obfuscation`,

  'playbook/prompts/05/observability-setup.md': `# Observability Setup — Phase 05 Prompt

> Copy-paste this prompt into Claude Code to set up comprehensive observability for the React Native mobile app, covering crash reporting, analytics, performance monitoring, logging, and alerting.

---

## Prompt

\`\`\`
You are working on the react-native-mobile-app project — a React Native 0.74 + Expo SDK 51 + TypeScript mobile application with Firebase backend services.

## Objective

Set up a complete observability stack for the mobile app covering:
1. Crash reporting (Sentry + Firebase Crashlytics)
2. Analytics (Firebase Analytics + custom events)
3. Performance monitoring (Firebase Performance, React Native performance)
4. Structured logging (local + remote)
5. Health checks and alerting
6. User session tracking and breadcrumbs

## Project Context

- **Stack**: React Native 0.74, Expo SDK 51, TypeScript strict mode, Firebase
- **State**: Zustand (client), React Query/TanStack Query (server)
- **Offline**: WatermelonDB with Firestore sync
- **Navigation**: React Navigation v6 (typed)
- **CI/CD**: EAS Build + GitHub Actions
- **Compliance**: GDPR — all telemetry must respect user consent

## Directory Structure

Place files according to this layout:

\`\`\`
src/
  services/
    observability/
      index.ts                    # Barrel export
      sentry.ts                   # Sentry initialization and helpers
      crashlytics.ts              # Firebase Crashlytics wrapper
      analytics.ts                # Analytics service (Firebase Analytics)
      analytics-events.ts         # Typed event catalog
      performance.ts              # Performance monitoring service
      logger.ts                   # Structured logger (local + remote)
      session.ts                  # Session tracking and breadcrumbs
      consent.ts                  # GDPR consent gate for telemetry
      types.ts                    # Shared observability types
  hooks/
    use-analytics.ts              # Hook for screen/event tracking
    use-performance-trace.ts      # Hook for measuring component/operation perf
    use-crash-reporter.ts         # Hook for error boundaries and crash context
  components/
    ErrorBoundary.tsx             # React error boundary with crash reporting
    AnalyticsProvider.tsx         # Context provider for analytics consent
    PerformanceOverlay.tsx        # DEV-only performance overlay (FPS, memory)
  utils/
    redact.ts                     # PII redaction for logs and crash reports
docs/
  observability.md                # Runbook: dashboards, alerts, triage
\`\`\`

## Requirements

### 1. Sentry Integration (\`src/services/observability/sentry.ts\`)

- Initialize @sentry/react-native with Expo plugin support
- Configure DSN from environment (react-native-config / expo-constants)
- Set environment tag: 'development' | 'staging' | 'production'
- Set release and dist from expo-constants (nativeAppVersion, nativeBuildVersion)
- Enable performance tracing with sampleRate: 0.2 for production, 1.0 for staging
- Configure beforeSend to:
  - Check GDPR consent before sending
  - Redact PII from event data (emails, phone numbers, auth tokens)
  - Drop events in __DEV__ unless SENTRY_DEBUG_ENABLED is set
- Configure beforeBreadcrumb to filter sensitive navigation params
- Add typed helper functions:
  - captureException(error: Error, context?: Record<string, unknown>): string
  - captureMessage(message: string, level: SeverityLevel): string
  - setUserContext(user: { id: string; segment?: string } | null): void
  - addBreadcrumb(category: string, message: string, data?: Record<string, unknown>): void
  - startTransaction(name: string, op: string): Transaction
- Export a withSentryNavigationTracing HOC for React Navigation container

### 2. Firebase Crashlytics (\`src/services/observability/crashlytics.ts\`)

- Wrap @react-native-firebase/crashlytics
- Respect GDPR consent — call setCrashlyticsCollectionEnabled based on consent state
- Provide functions:
  - initCrashlytics(consentGranted: boolean): Promise<void>
  - recordError(error: Error, context?: string): void
  - log(message: string): void
  - setUserId(userId: string | null): void
  - setAttributes(attrs: Record<string, string>): void
  - forceCrash(): void (DEV only, for testing)
- Integrate with Sentry so errors go to both systems
- Add non-fatal error recording for caught exceptions

### 3. Analytics Service (\`src/services/observability/analytics.ts\`)

- Wrap @react-native-firebase/analytics
- Gate ALL analytics calls behind GDPR consent check
- Provide typed functions:
  - initAnalytics(consentGranted: boolean): Promise<void>
  - trackScreen(screenName: string, screenClass?: string): Promise<void>
  - trackEvent<T extends AnalyticsEventName>(name: T, params: AnalyticsEventParams[T]): Promise<void>
  - setUserProperties(properties: Partial<UserProperties>): Promise<void>
  - setUserId(userId: string | null): Promise<void>
  - resetAnalyticsData(): Promise<void> (for GDPR data deletion)
- Queue events when offline, flush when connectivity restored
- Batch events to reduce battery impact

### 4. Typed Event Catalog (\`src/services/observability/analytics-events.ts\`)

- Define a comprehensive typed event catalog using discriminated unions:
  - **Navigation**: screen_view, deep_link_opened, tab_switched
  - **Auth**: login, signup, logout, biometric_auth_attempt, password_reset
  - **Engagement**: feature_used, content_viewed, search_performed, share_initiated
  - **Payments**: purchase_initiated, purchase_completed, purchase_failed, subscription_changed
  - **Notifications**: notification_received, notification_opened, notification_dismissed, push_permission_changed
  - **Sync**: sync_started, sync_completed, sync_failed, offline_action_queued
  - **Performance**: app_startup, screen_load, api_latency, image_load
  - **Errors**: error_boundary_triggered, api_error, sync_conflict
- Each event has strictly typed params (no Record<string, any>)
- Export AnalyticsEventName union type and AnalyticsEventParams mapped type

### 5. Performance Monitoring (\`src/services/observability/performance.ts\`)

- Wrap @react-native-firebase/perf
- Provide:
  - initPerformance(): Promise<void>
  - startTrace(name: string): Promise<PerformanceTrace>
  - startHttpMetric(url: string, method: HttpMethod): Promise<HttpMetric>
  - measureAsync<T>(name: string, fn: () => Promise<T>): Promise<T>
- Create a React Query middleware that auto-instruments API calls with HTTP metrics
- Track custom traces:
  - app_cold_start (from native module init to first meaningful paint)
  - app_warm_start (from background to foreground)
  - screen_render (per-screen TTI)
  - watermelondb_sync (sync duration and record count)
  - image_load (per-image load time)
- Track memory warnings from AppState
- Track JS thread FPS drops (using InteractionManager or requestAnimationFrame)

### 6. Structured Logger (\`src/services/observability/logger.ts\`)

- Create a logger with levels: debug, info, warn, error, fatal
- Each log entry includes:
  - timestamp (ISO 8601)
  - level
  - message
  - context (screen, feature, component)
  - sessionId
  - metadata (arbitrary typed data)
  - platform (ios/android)
  - appVersion
- In __DEV__: pretty-print to console with colors
- In production:
  - debug/info: local only (AsyncStorage ring buffer, max 500 entries)
  - warn: local + Crashlytics log
  - error/fatal: local + Crashlytics recordError + Sentry captureException
- PII redaction on ALL log output using src/utils/redact.ts
- Export log retrieval function for in-app debug screen: getRecentLogs(count?: number): LogEntry[]
- Export log export function for support tickets: exportLogsAsString(): Promise<string>

### 7. Session Tracking (\`src/services/observability/session.ts\`)

- Generate a unique sessionId (UUID v4) on app launch
- Track session metadata:
  - startTime, endTime
  - screenCount (screens visited)
  - errorCount
  - syncCount
  - networkType (wifi/cellular/none)
  - batteryLevel (if available)
- Persist session to Sentry scope and Crashlytics attributes
- Track app state transitions (active → background → inactive → active)
- Record navigation breadcrumbs automatically via React Navigation listener
- End session on background (after 30s timeout) and start new on foreground

### 8. GDPR Consent Gate (\`src/services/observability/consent.ts\`)

- Read consent state from Zustand store (persisted via AsyncStorage)
- Provide:
  - getConsentState(): ConsentState
  - updateConsent(consent: ConsentPreferences): Promise<void>
  - isAnalyticsConsented(): boolean
  - isCrashReportingConsented(): boolean
- ConsentPreferences shape:
  - analytics: boolean
  - crashReporting: boolean
  - performanceMonitoring: boolean
  - timestamp: string (ISO 8601)
  - version: string (consent policy version)
- When consent is revoked:
  - Disable Crashlytics collection
  - Disable Analytics collection
  - Call Sentry close()
  - Clear local analytics queue
  - Call resetAnalyticsData()
- When consent is granted:
  - Re-initialize enabled services
  - Flush queued events (if any were queued before consent)

### 9. PII Redaction (\`src/utils/redact.ts\`)

- Redact patterns: email addresses, phone numbers, JWT tokens, credit card numbers, IP addresses
- Provide:
  - redactString(input: string): string
  - redactObject<T>(obj: T): T (deep clone with redacted string values)
  - redactUrl(url: string): string (redact query params with sensitive keys: token, key, secret, password, auth)
- Used by logger, Sentry beforeSend, and Crashlytics log

### 10. React Hooks

**\`src/hooks/use-analytics.ts\`**:
- useAnalytics() returns { trackEvent, trackScreen }
- Auto-track screen views when used with React Navigation's useFocusEffect
- Memoize to prevent unnecessary re-renders

**\`src/hooks/use-performance-trace.ts\`**:
- usePerformanceTrace(traceName: string) returns { start, stop, putAttribute, putMetric }
- Auto-stop trace on unmount if still running
- useScreenTrace(screenName: string) — auto-start on mount, stop on unmount

**\`src/hooks/use-crash-reporter.ts\`**:
- useCrashReporter() returns { recordError, log, setContext }
- Automatically sets current screen as crash context

### 11. Error Boundary (\`src/components/ErrorBoundary.tsx\`)

- React class component (error boundaries require class components)
- On error:
  - Report to Sentry with component stack
  - Report to Crashlytics
  - Log via structured logger
  - Track error_boundary_triggered analytics event
- Render fallback UI with:
  - "Something went wrong" message (i18n)
  - Retry button
  - "Report issue" button (opens support email with exported logs)
- Accept props: fallback?: ReactNode, onError?: (error: Error) => void, feature?: string

### 12. Analytics Provider (\`src/components/AnalyticsProvider.tsx\`)

- Context provider that initializes observability on mount
- Reads consent from Zustand store
- Initializes Sentry, Crashlytics, Analytics, Performance based on consent
- Re-initializes when consent changes
- Provides analytics context to children

### 13. DEV Performance Overlay (\`src/components/PerformanceOverlay.tsx\`)

- Only renders in __DEV__
- Floating overlay showing:
  - JS FPS (via requestAnimationFrame)
  - RAM usage (if available via NativeModules)
  - Active React Query queries count
  - WatermelonDB pending sync count
  - Network status
- Toggle visibility with a shake gesture or dev menu button

### 14. Observability Runbook (\`docs/observability.md\`)

- Dashboard links (Sentry, Firebase Console, Firebase Analytics)
- Alert configuration:
  - Crash-free rate drops below 99.5%
  - Error spike (>50 errors in 5 minutes)
  - API latency p95 > 3s
  - Sync failure rate > 5%
  - App startup time p95 > 4s
- Triage playbook:
  - How to find crash in Sentry (search by session, user, release)
  - How to correlate Crashlytics + Sentry events
  - How to pull device logs from Crashlytics
  - How to reproduce with Detox using same session params
- On-call rotation and escalation
- GDPR: how to handle data deletion requests for telemetry data

## Code Standards

- TypeScript strict mode — no \`any\` types
- All files under 250 lines — split if needed
- PascalCase for components, camelCase for hooks/utils, kebab-case for filenames
- SCREAMING_SNAKE_CASE for constants
- All interactive elements need accessibility labels
- All user-facing text through i18n
- Conventional commit when done: \`feat(observability): add crash reporting, analytics, and performance monitoring\`

## Testing

- Write unit tests for:
  - redact.ts (all PII patterns)
  - analytics-events.ts (type safety, ensure all events have params)
  - consent.ts (grant/revoke flows)
  - logger.ts (level filtering, PII redaction, ring buffer)
  - session.ts (session lifecycle)
- Write component tests for:
  - ErrorBoundary (renders fallback, reports error)
  - AnalyticsProvider (initializes based on consent)
- Place tests adjacent to source: \`__tests__/filename.test.ts\`
- Target 75% coverage for observability module

## Implementation Order

1. Types and consent gate (foundation)
2. PII redaction utility
3. Structured logger
4. Sentry integration
5. Firebase Crashlytics
6. Firebase Analytics + event catalog
7. Performance monitoring
8. Session tracking
9. React hooks
10. Error boundary and providers
11. DEV performance overlay
12. Tests
13. Runbook documentation

Start implementation. Create each file, following the order above. After each file, briefly confirm what was created and move to the next. Do NOT skip any file.
\`\`\``,

  'playbook/prompts/05/security-hardening.md': `# Security Hardening — Phase 05 Prompt

> Copy-paste this prompt into Claude Code to perform a comprehensive security hardening pass on the React Native mobile app.

---

## Prompt

You are a mobile security engineer performing a comprehensive security hardening pass on our React Native (Expo SDK 51) + Firebase application. Audit the entire codebase and apply fixes across all layers: client storage, network, authentication, native modules, build configuration, and compliance.

### Project Context

- **Stack**: React Native 0.74, Expo SDK 51, TypeScript strict, Firebase (Auth, Firestore, Cloud Functions, Cloud Messaging, Storage), WatermelonDB, Zustand, React Query
- **Architecture**: Feature-based under \`src/features/\`, shared services in \`src/services/\`, navigation in \`src/navigation/\`, stores in \`src/store/\`
- **Sensitive Paths**: \`src/services/auth/**\`, \`src/config/**\`, \`google-services.json\`, \`GoogleService-Info.plist\`, \`.env*\`
- **Compliance**: GDPR, Apple App Store Guidelines, Google Play Policies
- **Offline-first**: WatermelonDB with Firestore sync

### 1. Secure Storage Audit

Audit all local data storage and fix any insecure patterns:

\`\`\`
Files to audit:
- src/store/**          (Zustand persisted stores)
- src/services/**       (any cached tokens, keys)
- src/features/auth/**  (credentials, session data)
- src/hooks/useAuth*    (token handling)
\`\`\`

**Requirements:**
- All sensitive data (tokens, refresh tokens, user PII, biometric keys) MUST use \`expo-secure-store\` (backed by iOS Keychain / Android Keystore) — never \`AsyncStorage\` or \`MMKV\` for secrets
- Create or update \`src/services/secure-storage.ts\`:

\`\`\`typescript
// Expected interface
interface SecureStorageService {
  setSecureItem(key: string, value: string): Promise<void>;
  getSecureItem(key: string): Promise<string | null>;
  deleteSecureItem(key: string): Promise<void>;
  clearAllSecure(): Promise<void>;
}
\`\`\`

- Zustand persisted stores must NOT persist auth tokens — only non-sensitive preferences (theme, locale, onboarding state)
- WatermelonDB tables containing user PII must be encrypted at rest — verify \`experimentalUseJSI\` and database encryption config in \`src/services/database/\`
- Audit for any \`console.log\` statements that leak tokens, passwords, or PII — replace with structured logger that redacts sensitive fields
- Verify that app data is excluded from iCloud/Google backup where appropriate using \`expo-file-system\` attributes

### 2. Network Security

Audit all network communication:

\`\`\`
Files to audit:
- src/services/api/**        (HTTP clients, interceptors)
- src/services/firebase/**   (Firebase SDK config)
- src/config/**              (API URLs, endpoints)
- app.json / app.config.ts   (Expo config)
\`\`\`

**Requirements:**
- Implement certificate pinning for all first-party API endpoints using \`expo-network\` or a custom native module:

\`\`\`typescript
// src/services/network/certificate-pinning.ts
export const PINNED_CERTIFICATES: Record<string, string[]> = {
  'api.yourapp.com': ['sha256/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA='],
  'firestore.googleapis.com': ['sha256/...'],
};
\`\`\`

- All HTTP requests must enforce TLS 1.2+ — verify \`NSAppTransportSecurity\` in \`ios/\` Info.plist has no \`NSAllowsArbitraryLoads: true\` in production
- Android \`network_security_config.xml\` must restrict cleartext traffic and pin certificates for production:

\`\`\`xml
<!-- android/app/src/main/res/xml/network_security_config.xml -->
<network-security-config>
  <base-config cleartextTrafficPermitted="false">
    <trust-anchors>
      <certificates src="system" />
    </trust-anchors>
  </base-config>
  <debug-overrides>
    <trust-anchors>
      <certificates src="user" />
    </trust-anchors>
  </debug-overrides>
</network-security-config>
\`\`\`

- React Query \`queryClient\` must NOT cache sensitive responses (auth tokens, payment data) — audit \`queryClient\` default options and per-query \`cacheTime\` / \`gcTime\` settings
- Firebase SDK calls must go through typed service wrappers — no direct \`firebase.firestore()\` calls in components or screens
- Implement request/response interceptor that strips sensitive headers from logs

### 3. Authentication & Session Hardening

Audit authentication flows:

\`\`\`
Files to audit:
- src/features/auth/**
- src/services/auth/**
- src/hooks/useAuth.ts
- src/store/auth-store.ts
- src/navigation/auth-navigator.tsx
\`\`\`

**Requirements:**
- Firebase Auth token refresh must be handled automatically with proper error recovery — if refresh fails, force re-authentication
- Implement session timeout: auto-lock app after configurable inactivity period (default 5 minutes for sensitive apps)

\`\`\`typescript
// src/hooks/useSessionTimeout.ts
export function useSessionTimeout(timeoutMs: number): void;
\`\`\`

- Biometric authentication (\`expo-local-authentication\`) must:
  - Check \`hasHardwareAsync()\` and \`isEnrolledAsync()\` before prompting
  - Fall back to PIN/password if biometrics unavailable
  - Store biometric-protected credentials in Secure Enclave via \`expo-secure-store\` with \`requireAuthentication: true\`
  - Handle \`LAError\` codes gracefully (lockout, user cancel, fallback)
- Deep link authentication flows must validate all parameters — prevent open redirect attacks:

\`\`\`typescript
// src/navigation/linking-config.ts
// Validate deep link URLs against allowlist before navigation
export function validateDeepLink(url: string): boolean;
\`\`\`

- Implement brute-force protection: lock account after 5 failed login attempts with exponential backoff (client-side + Firebase Cloud Function rate limiting)
- Auth state listener must handle token revocation — check \`auth().currentUser.getIdTokenResult()\` for revoked tokens

### 4. Input Validation & Injection Prevention

Audit all user input handling:

\`\`\`
Files to audit:
- src/features/**/screens/**   (all screen components with forms)
- src/features/**/components/** (form components)
- src/utils/validation.ts
- src/services/firestore/**     (Firestore queries)
\`\`\`

**Requirements:**
- Create or update \`src/utils/sanitize.ts\`:

\`\`\`typescript
export function sanitizeInput(input: string): string;
export function sanitizeHtml(input: string): string;
export function validateEmail(email: string): boolean;
export function validateUrl(url: string): boolean;
export function sanitizeFirestorePath(path: string): string;
\`\`\`

- All Firestore queries must use parameterized inputs — no string interpolation in document paths or query values
- WebView components (if any) must have \`javaScriptEnabled={false}\` unless explicitly required, and must use \`originWhitelist\` to restrict loaded URLs
- All text rendered from external sources must be sanitized to prevent XSS in any WebView context
- Form validation must happen both client-side (immediate feedback) and server-side (Cloud Functions)
- File uploads must validate MIME type, file size, and file extension before sending to Firebase Storage

### 5. Build & Binary Security

Audit build configuration:

\`\`\`
Files to audit:
- app.json / app.config.ts
- eas.json
- android/app/build.gradle (if ejected)
- ios/Podfile (if ejected)
- .env, .env.staging, .env.production
\`\`\`

**Requirements:**
- Environment variables must NEVER be bundled into the JS bundle — use \`expo-constants\` with \`extra\` field populated from EAS secrets:

\`\`\`typescript
// app.config.ts
export default {
  extra: {
    firebaseApiKey: process.env.FIREBASE_API_KEY,
    sentryDsn: process.env.SENTRY_DSN,
    // NEVER: apiSecret, serviceAccountKey, signing keys
  },
};
\`\`\`

- Verify \`.gitignore\` excludes: \`google-services.json\`, \`GoogleService-Info.plist\`, \`.env*\`, \`*.keystore\`, \`*.jks\`, \`*.p12\`, \`*.mobileprovision\`, \`*.p8\`
- EAS Build must use \`credentialsSource: "remote"\` for production — no local signing keys in repo
- Enable ProGuard/R8 for Android release builds — verify \`minifyEnabled true\` and custom rules preserve Firebase/React Native classes
- Enable Hermes engine with bytecode compilation for production (obfuscates JS source)
- iOS builds must enable:
  - \`CODE_SIGN_INJECT_BASE_ENTITLEMENTS = NO\` for production
  - App Transport Security enforced (no exceptions in production)
  - Data Protection entitlement (\`NSFileProtectionComplete\`)
- Android builds must set:
  - \`android:debuggable="false"\` in release manifest
  - \`android:allowBackup="false"\` to prevent ADB backup extraction
  - \`android:usesCleartextTraffic="false"\`
- Verify Sentry source maps are uploaded but NOT included in the production binary
- Create \`scripts/security-check.sh\` that runs pre-build:

\`\`\`bash
#!/bin/bash
# Checks for common security issues before EAS Build
# - No hardcoded secrets in source
# - No console.log with sensitive data
# - .env files not committed
# - Correct build flags for release
\`\`\`

### 6. Firestore Security Rules

Audit and harden Firestore security rules:

\`\`\`
Files to audit:
- firestore.rules
- storage.rules
\`\`\`

**Requirements:**
- Every collection must have explicit read/write rules — no wildcard \`allow read, write: if true\`
- User documents must only be readable/writable by the authenticated owner:

\`\`\`
match /users/{userId} {
  allow read, write: if request.auth != null && request.auth.uid == userId;
}
\`\`\`

- Validate data shape in write rules using \`request.resource.data\` — enforce required fields, types, and value ranges
- Rate limit writes using \`resource.data\` timestamps where applicable
- Storage rules must validate file size (\`request.resource.size < 10 * 1024 * 1024\`) and content type
- Create \`scripts/deploy-rules.sh\` for safe rule deployment with backup

### 7. Privacy & GDPR Compliance

Audit data handling for compliance:

\`\`\`
Files to audit:
- src/services/analytics/**
- src/services/crash-reporting/**
- src/features/profile/screens/PrivacySettingsScreen.tsx
- src/features/auth/screens/ConsentScreen.tsx
\`\`\`

**Requirements:**
- Implement consent management:

\`\`\`typescript
// src/services/privacy/consent-manager.ts
interface ConsentPreferences {
  analytics: boolean;
  crashReporting: boolean;
  personalizedAds: boolean;
  thirdPartySharing: boolean;
}

export function getConsentPreferences(): Promise<ConsentPreferences>;
export function updateConsentPreferences(prefs: Partial<ConsentPreferences>): Promise<void>;
export function hasRequiredConsent(): Promise<boolean>;
\`\`\`

- Firebase Analytics and Crashlytics must respect consent — disable collection until consent is granted:

\`\`\`typescript
analytics().setAnalyticsCollectionEnabled(consentGiven);
crashlytics().setCrashlyticsCollectionEnabled(consentGiven);
\`\`\`

- Implement data export (GDPR Article 20 — data portability):

\`\`\`typescript
// src/services/privacy/data-export.ts
export function exportUserData(userId: string): Promise<UserDataExport>;
\`\`\`

- Implement account deletion (GDPR Article 17 — right to erasure):

\`\`\`typescript
// src/services/privacy/account-deletion.ts
export function requestAccountDeletion(userId: string): Promise<void>;
// Must delete: Firestore docs, Storage files, Auth account, WatermelonDB local data
\`\`\`

- All analytics events must be reviewed — no PII (email, name, phone) in event parameters
- App Store privacy nutrition labels and Google Play data safety section must match actual data collection — create \`docs/privacy-manifest.md\` documenting all data collected, purposes, and retention

### 8. Dependency Security

Audit all dependencies:

**Requirements:**
- Run \`pnpm audit\` and fix all high/critical vulnerabilities
- Run \`npx expo-doctor\` to check for SDK compatibility issues
- Audit native modules — each must have both iOS and Android implementations, no abandoned packages (check last publish date, open issues)
- Create \`scripts/dependency-audit.sh\`:

\`\`\`bash
#!/bin/bash
pnpm audit --audit-level=high
npx expo-doctor
# Check for known vulnerable native modules
# Verify no packages with > 1 year since last release in critical paths
\`\`\`

- Pin exact versions for security-critical packages (Firebase, crypto, auth libraries)
- Verify no packages request unnecessary permissions in their native code

### 9. Runtime Protection

Implement runtime security checks:

\`\`\`typescript
// src/services/security/runtime-checks.ts
export function detectJailbreak(): boolean;
export function detectRootedDevice(): boolean;
export function detectDebugger(): boolean;
export function detectTampering(): boolean;
export function getSecurityPosture(): SecurityPosture;

interface SecurityPosture {
  isJailbroken: boolean;
  isRooted: boolean;
  isDebugged: boolean;
  isTampered: boolean;
  riskLevel: 'low' | 'medium' | 'high' | 'critical';
}
\`\`\`

- App must check security posture on launch and warn users on compromised devices
- For high-risk features (payments, biometrics), block operation on jailbroken/rooted devices with user explanation
- Implement screenshot prevention for sensitive screens (payment, auth):

\`\`\`typescript
// src/hooks/useScreenSecurity.ts
export function usePreventScreenCapture(): void;
\`\`\`

### 10. Security Documentation

Create the following documentation:

- \`docs/security/threat-model.md\` — STRIDE analysis for the mobile app
- \`docs/security/secure-coding-guide.md\` — team reference for secure patterns
- \`docs/security/incident-response.md\` — steps for handling security incidents (compromised keys, data breach, malicious update)
- \`docs/security/penetration-testing.md\` — checklist for mobile pen testing (OWASP MASVS/MASTG alignment)

### Output Requirements

For each area above:
1. List all findings with severity (CRITICAL / HIGH / MEDIUM / LOW)
2. Show the exact file path and line numbers affected
3. Provide the fix as a complete code change
4. Add inline comments explaining the security rationale
5. Write or update tests for security-critical code in the corresponding \`__tests__/\` directory

After all fixes:
- Run \`pnpm lint && pnpm typecheck && pnpm test\` to verify nothing breaks
- Summarize all changes in a table: File | Finding | Severity | Fix Applied
- Create a follow-up ticket list for items requiring native module changes or backend Cloud Function updates

### Files to Create/Update (Summary)

\`\`\`
src/services/secure-storage.ts
src/services/network/certificate-pinning.ts
src/services/security/runtime-checks.ts
src/services/privacy/consent-manager.ts
src/services/privacy/data-export.ts
src/services/privacy/account-deletion.ts
src/hooks/useSessionTimeout.ts
src/hooks/useScreenSecurity.ts
src/utils/sanitize.ts
src/navigation/linking-config.ts (validateDeepLink)
scripts/security-check.sh
scripts/dependency-audit.sh
scripts/deploy-rules.sh
firestore.rules
storage.rules
docs/privacy-manifest.md
docs/security/threat-model.md
docs/security/secure-coding-guide.md
docs/security/incident-response.md
docs/security/penetration-testing.md
android/app/src/main/res/xml/network_security_config.xml
\`\`\``,

  'playbook/prompts/06/e2e-test-generator.md': `# E2E Test Generator — Phase 06 (Testing & Quality)

> **Copy-paste this prompt into Claude Code** to generate comprehensive Detox E2E tests for your React Native mobile app features.

---

## Prompt

\`\`\`
You are an expert React Native QA engineer working on the react-native-mobile-app project. Generate comprehensive Detox E2E tests for the specified feature or user flow.

## Project Context

- **Framework**: React Native 0.74 + Expo SDK 51
- **E2E Framework**: Detox (with Jest runner)
- **Navigation**: React Navigation v6 (typed stack/tab navigators)
- **Backend**: Firebase (Auth, Firestore, Cloud Functions)
- **Local DB**: WatermelonDB (offline-first)
- **Auth**: Firebase Authentication + biometric auth
- **State**: Zustand (client) + React Query (server)
- **i18n**: All user-facing text goes through i18n keys
- **Accessibility**: All interactive elements have accessibility labels

## Directory Structure

E2E tests live in:
\`\`\`
e2e/
  config/
    detox.config.js          # Detox configuration
    test-ids.ts              # Centralized testID constants
    utils.ts                 # Shared E2E helpers (login, waitFor, etc.)
    mock-server.ts           # Local mock server for deterministic tests
  flows/
    auth/
      login.e2e.ts
      register.e2e.ts
      biometric-auth.e2e.ts
      password-reset.e2e.ts
    home/
      home-feed.e2e.ts
      pull-to-refresh.e2e.ts
    profile/
      edit-profile.e2e.ts
      settings.e2e.ts
      delete-account.e2e.ts
    notifications/
      push-notification.e2e.ts
      notification-center.e2e.ts
    payments/
      subscription.e2e.ts
      purchase-flow.e2e.ts
    navigation/
      deep-linking.e2e.ts
      tab-navigation.e2e.ts
    offline/
      offline-mode.e2e.ts
      sync-recovery.e2e.ts
  fixtures/
    users.ts                 # Test user credentials and profiles
    data.ts                  # Seed data for tests
\`\`\`

## Feature to Test: [FEATURE_NAME]

Describe the feature or user flow:
- **Screens involved**: [List the screens in the flow]
- **User actions**: [Describe what the user does step by step]
- **Expected outcomes**: [What should happen at each step]
- **Edge cases**: [Offline, errors, permissions denied, etc.]
- **Platform differences**: [Any iOS vs Android behavior differences]

## Generation Requirements

### 1. Test ID Constants

Create or extend \`e2e/config/test-ids.ts\` with all testIDs needed for this feature. Follow the naming convention:
- Format: \`{screen}.{element}.{variant?}\` in camelCase
- Example: \`loginScreen.emailInput\`, \`loginScreen.submitButton\`, \`homeScreen.feedList.item.0\`

Ensure every testID maps to an \`accessibilityLabel\` or \`testID\` prop in the component.

### 2. E2E Helper Utilities

Create or extend \`e2e/config/utils.ts\` with reusable helpers:

\`\`\`typescript
// Required helpers:
// - loginAsUser(email, password) — complete login flow
// - logout() — navigate to settings and log out
// - waitForScreen(screenTestId, timeout?) — wait for screen to appear
// - scrollToElement(scrollViewId, elementId) — scroll until element visible
// - takeScreenshotOnFailure(testName) — capture screenshot on test failure
// - clearAppState() — reset AsyncStorage, clear caches
// - mockNetworkOffline() — simulate airplane mode
// - mockNetworkOnline() — restore connectivity
// - waitForSync() — wait for WatermelonDB sync to complete
// - dismissSystemDialog() — handle iOS/Android permission dialogs
// - setDeviceOrientation(orientation) — portrait/landscape
// - tapRetryOnError() — tap retry button on error screens
\`\`\`

### 3. Test File Structure

Each E2E test file must follow this structure:

\`\`\`typescript
import { by, device, element, expect, waitFor } from 'detox';
import { TEST_IDS } from '../config/test-ids';
import { loginAsUser, waitForScreen, clearAppState } from '../config/utils';
import { TEST_USERS } from '../fixtures/users';

describe('[Feature Name] Flow', () => {
  beforeAll(async () => {
    await device.launchApp({
      newInstance: true,
      permissions: { notifications: 'YES', camera: 'YES' },
    });
  });

  beforeEach(async () => {
    await device.reloadReactNative();
    // Setup: login, navigate to starting screen, seed data
  });

  afterEach(async () => {
    // Cleanup: take screenshot on failure, clear state
  });

  afterAll(async () => {
    await clearAppState();
  });

  // Group tests by user intent
  describe('when user [does action]', () => {
    it('should [expected behavior]', async () => {
      // Arrange — navigate to correct screen, set preconditions
      // Act — perform user actions (tap, type, scroll, swipe)
      // Assert — verify UI state, navigation, data persistence
    });
  });
});
\`\`\`

### 4. Test Categories to Generate

For the specified feature, generate tests covering:

**Happy Path Tests:**
- Complete successful flow from start to finish
- Verify correct navigation between screens
- Verify data appears correctly after actions
- Verify success feedback (toasts, modals, animations)

**Input Validation Tests:**
- Empty required fields
- Invalid formats (email, phone, etc.)
- Boundary values (min/max length, special characters)
- Verify inline error messages appear with correct text

**Error Handling Tests:**
- Network timeout during API calls
- Server error responses (4xx, 5xx)
- Verify error screens render with retry option
- Verify user can recover from errors

**Offline Mode Tests:**
- Start action while offline — verify queued state
- Go offline mid-flow — verify graceful degradation
- Come back online — verify sync completes
- Verify offline indicator banner appears/disappears

**Platform-Specific Tests:**
- iOS: Swipe-to-go-back gesture, keyboard avoidance, safe area
- Android: Hardware back button, system navigation bar, keyboard behavior
- Both: Orientation changes, app backgrounding/foregrounding

**Accessibility Tests:**
- Verify all interactive elements have accessibility labels
- Verify screen reader announcement order is logical
- Verify focus management after navigation/modal open
- Verify touch targets meet minimum 44x44pt size

**Performance Assertions:**
- Screen transition completes within 300ms
- List renders first 10 items within 1 second
- Pull-to-refresh completes within 3 seconds
- App cold start to interactive within 3 seconds

**Deep Linking Tests (if applicable):**
- Verify deep link opens correct screen with correct params
- Verify deep link while logged out redirects to auth then back
- Verify universal links and custom scheme links

**State Persistence Tests:**
- Kill and relaunch app — verify state restored
- Background app for 30 seconds — verify no data loss
- Verify form state survives orientation change

### 5. Fixtures

Generate test fixtures in \`e2e/fixtures/\`:

\`\`\`typescript
// e2e/fixtures/users.ts
export const TEST_USERS = {
  standard: {
    email: 'e2e-standard@test.reactnativeapp.dev',
    password: 'TestPass123!',
    displayName: 'E2E Standard User',
  },
  premium: {
    email: 'e2e-premium@test.reactnativeapp.dev',
    password: 'TestPass123!',
    displayName: 'E2E Premium User',
  },
  newUser: {
    email: \`e2e-new-\${Date.now()}@test.reactnativeapp.dev\`,
    password: 'TestPass123!',
    displayName: 'E2E New User',
  },
};
\`\`\`

### 6. Platform-Conditional Tests

Use Detox device API for platform-specific behavior:

\`\`\`typescript
const isIOS = device.getPlatform() === 'ios';
const isAndroid = device.getPlatform() === 'android';

// Platform-conditional test
(isIOS ? it : it.skip)('should handle swipe-to-go-back on iOS', async () => {
  // iOS-specific gesture test
});

(isAndroid ? it : it.skip)('should handle hardware back button on Android', async () => {
  await device.pressBack();
  // Android-specific assertion
});
\`\`\`

### 7. Mock Server Setup (if needed)

If the feature requires deterministic API responses, generate mock server config:

\`\`\`typescript
// e2e/config/mock-server.ts
// Use MSW (Mock Service Worker) or a local Express server
// to intercept Firebase/API calls during E2E tests
\`\`\`

### 8. CI Integration

Each test file must be tagged for selective CI execution:

\`\`\`typescript
// At the top of each test file, add a JSDoc tag:
/**
 * @e2e-suite auth
 * @e2e-priority critical
 * @e2e-platforms ios,android
 * @e2e-timeout 120000
 */
\`\`\`

### 9. Screenshot and Video Artifacts

Configure artifact collection for debugging failures:

\`\`\`typescript
afterEach(async () => {
  const testName = expect.getState().currentTestName?.replace(/\\s+/g, '-');
  if (expect.getState().assertionCalls !== expect.getState().numPassingAsserts) {
    await device.takeScreenshot(\`FAIL-\${testName}\`);
  }
});
\`\`\`

## Output Format

Generate the following files:
1. \`e2e/config/test-ids.ts\` — testID constants for this feature
2. \`e2e/config/utils.ts\` — shared helpers (extend if exists)
3. \`e2e/fixtures/users.ts\` — test user fixtures (extend if exists)
4. \`e2e/fixtures/data.ts\` — seed data for this feature (extend if exists)
5. \`e2e/flows/{feature}/{flow-name}.e2e.ts\` — one or more test files covering all categories above

## Naming Conventions

- Files: kebab-case (\`login-flow.e2e.ts\`)
- Test suites: Descriptive feature name (\`Login Flow\`)
- Test cases: Start with "should" (\`should display error for invalid email\`)
- TestIDs: camelCase dot-notation (\`loginScreen.emailInput\`)
- Fixtures: camelCase exports (\`TEST_USERS.standard\`)

## Quality Checklist

Before finalizing, verify each test file:
- [ ] No hardcoded strings — all text assertions use i18n keys or testIDs
- [ ] No flaky waits — use \`waitFor().toBeVisible().withTimeout()\` instead of \`sleep()\`
- [ ] No shared mutable state between tests — each test is independent
- [ ] Platform differences handled with conditional execution
- [ ] Cleanup runs even if test fails (use try/finally or afterEach)
- [ ] Screenshots captured on failure for CI debugging
- [ ] Tests can run in parallel (no port conflicts, no shared test users)
- [ ] Timeout set appropriately (default 120s, adjust for slow flows)
- [ ] Accessibility labels verified, not just testIDs
- [ ] Offline scenarios use Detox network mocking, not manual airplane mode

## Example Invocation

To generate E2E tests for the authentication feature:

Feature: Authentication
Screens: LoginScreen, RegisterScreen, ForgotPasswordScreen, BiometricPrompt
User actions: Enter email/password, tap login, handle biometric prompt, register new account, reset password
Expected outcomes: Navigate to HomeScreen on success, show inline errors on validation failure, show error toast on API failure
Edge cases: Offline login with cached credentials, biometric fallback to PIN, account locked after 5 attempts
Platform differences: Face ID on iOS vs fingerprint on Android, keyboard behavior differences

Now generate the complete E2E test suite for: [FEATURE_NAME]
\`\`\`

---

## Usage

1. Copy the prompt above into Claude Code
2. Replace \`[FEATURE_NAME]\` with your target feature (e.g., \`Authentication\`, \`Home Feed\`, \`In-App Purchases\`)
3. Fill in the feature details section with screen names, user actions, and edge cases
4. Claude will generate all test files, fixtures, and helpers
5. Run generated tests with:

\`\`\`bash
# Build the app for E2E testing
npx detox build --configuration ios.sim.debug

# Run all E2E tests
npx detox test --configuration ios.sim.debug

# Run tests for a specific flow
npx detox test --configuration ios.sim.debug e2e/flows/auth/

# Run with artifacts (screenshots/videos on failure)
npx detox test --configuration ios.sim.debug --artifacts-location e2e/artifacts --record-videos failing --take-screenshots failing

# Run on Android
npx detox build --configuration android.emu.debug
npx detox test --configuration android.emu.debug
\`\`\`

## Integration with Phase 06

This prompt supports the Phase 06 (Testing & Quality) objectives:

| Objective | How This Prompt Helps |
|---|---|
| E2E coverage for critical flows | Generates tests for happy path, errors, offline, and edge cases |
| Cross-platform validation | Platform-conditional tests for iOS and Android |
| Offline-first verification | Dedicated offline mode and sync recovery tests |
| Accessibility compliance | Verifies labels, focus management, and touch targets |
| CI/CD integration | Tags tests for selective execution, captures artifacts |
| Performance baselines | Asserts screen transitions and load times |

## Related Prompts

- \`playbook/prompts/06/unit-test-generator.md\` — Jest + RNTL unit/component tests
- \`playbook/prompts/06/accessibility-audit.md\` — Comprehensive a11y audit
- \`playbook/prompts/05/observability-setup.md\` — Sentry + Crashlytics for monitoring test failures in staging
- \`playbook/prompts/04/feature-implementation.md\` — Ensure testIDs are added during implementation`,

  'playbook/prompts/06/load-test.md': `# Load Test — Phase 06: Testing & Quality

## Prompt for Claude Code

\`\`\`
You are a mobile performance and load-testing engineer for "react-native-mobile-app," a React Native 0.74 + Expo SDK 51 app backed by Firebase (Firestore, Cloud Functions, Authentication, Cloud Messaging, Storage). Implement a comprehensive load and performance testing strategy covering the mobile client, backend services, and the sync layer (WatermelonDB ↔ Firestore).

## Context

- **Runtime**: React Native 0.74, Hermes engine, Expo SDK 51
- **Backend**: Firebase Cloud Functions (Node 18), Firestore, Firebase Auth, Cloud Storage
- **Local DB**: WatermelonDB with custom Firestore sync adapter
- **State**: Zustand (client), React Query/TanStack Query (server)
- **CI/CD**: GitHub Actions + EAS Build
- **Monitoring**: Sentry (performance), Firebase Performance Monitoring, Firebase Crashlytics
- **Target platforms**: iOS 15+ (iPhone 11 baseline), Android 10+ (mid-range baseline)

## 1. Mobile Client Performance Tests

Create \`src/utils/__tests__/performance.test.ts\`:

- **Startup time**: Measure cold-start and warm-start durations using \`PerformanceObserver\` or \`react-native-performance\`. Assert cold start < 2 seconds on baseline devices.
- **Screen render time**: For each critical screen (Home, Auth/Login, Profile, Notifications, Payments), measure Time-to-Interactive (TTI). Assert TTI < 500ms.
- **FlatList / FlashList scroll performance**: Create a test harness that renders 1,000+ items and asserts:
  - Frame drops < 5% during fast scroll
  - JS thread FPS stays above 55 on average
  - UI thread FPS stays above 58 on average
- **Memory pressure**: Simulate navigation through 20+ screens in sequence. Assert:
  - No memory leaks (heap delta < 15MB after returning to start screen)
  - No zombie event listeners
  - WatermelonDB connections properly released
- **Image loading**: Test loading 50 images in a grid. Assert all images render within 3 seconds on WiFi, placeholder shown within 100ms.
- **Bundle size**: Assert JS bundle < 5MB (Hermes bytecode). Create a script \`scripts/check-bundle-size.sh\` that runs \`npx react-native-bundle-visualizer\` and fails CI if threshold exceeded.

Use this structure:
\`\`\`typescript
// src/utils/__tests__/performance.test.ts
import { performance } from 'react-native-performance';

interface PerformanceMetric {
  name: string;
  value: number;
  unit: 'ms' | 'MB' | 'fps' | 'bytes';
  threshold: number;
  passed: boolean;
}

// Implement metric collection, assertion, and reporting
\`\`\`

## 2. Firebase Backend Load Tests

Create \`scripts/load-tests/\` directory with k6 or Artillery scripts targeting Firebase:

### \`scripts/load-tests/firebase-auth-load.ts\`
- Simulate 500 concurrent sign-up requests (email/password)
- Simulate 1,000 concurrent sign-in requests
- Simulate 200 concurrent token refresh requests
- Assert: p95 latency < 800ms, error rate < 1%

### \`scripts/load-tests/firestore-load.ts\`
- Simulate 1,000 concurrent document reads (user profiles)
- Simulate 500 concurrent document writes (activity logs)
- Simulate 200 concurrent complex queries (filtered, paginated)
- Simulate 100 concurrent batch writes (10 docs per batch)
- Simulate real-time listener load: 500 concurrent snapshot listeners
- Assert: p95 read latency < 200ms, p95 write latency < 500ms, error rate < 0.5%

### \`scripts/load-tests/cloud-functions-load.ts\`
- Target each HTTP-callable Cloud Function
- Ramp: 0 → 200 concurrent users over 2 minutes, sustain for 5 minutes, ramp down
- Assert: p95 latency < 1.5s, cold-start p95 < 3s, error rate < 2%
- Track cold-start ratio (should be < 10% during sustained load)

### \`scripts/load-tests/push-notification-load.ts\`
- Simulate sending 10,000 push notifications via Cloud Messaging
- Measure delivery latency (FCM → device callback)
- Assert: 95% delivered within 10 seconds

### \`scripts/load-tests/storage-load.ts\`
- Simulate 100 concurrent file uploads (profile images, 2MB each)
- Simulate 200 concurrent file downloads
- Assert: upload p95 < 5s, download p95 < 2s

Use Artillery (preferred for Firebase) with this config pattern:
\`\`\`yaml
# scripts/load-tests/artillery-config.yml
config:
  target: "https://us-central1-<project-id>.cloudfunctions.net"
  phases:
    - duration: 120
      arrivalRate: 5
      rampTo: 50
      name: "Ramp up"
    - duration: 300
      arrivalRate: 50
      name: "Sustained load"
    - duration: 60
      arrivalRate: 50
      rampTo: 0
      name: "Ramp down"
  plugins:
    expect: {}
  environments:
    staging:
      target: "https://us-central1-<staging-project-id>.cloudfunctions.net"
\`\`\`

## 3. WatermelonDB Sync Stress Tests

Create \`src/services/__tests__/sync-stress.test.ts\`:

- **Large dataset sync**: Seed 10,000 records locally, trigger full sync. Assert completes < 30 seconds.
- **Conflict resolution**: Create 500 conflicting records (modified on both client and server). Assert all resolved correctly per conflict strategy.
- **Offline queue**: Queue 200 write operations offline, then reconnect. Assert all operations synced within 60 seconds with correct ordering.
- **Concurrent sync**: Simulate 3 devices syncing the same user's data simultaneously. Assert eventual consistency within 2 sync cycles.
- **Sync interruption**: Start a large sync, kill the process at 50%, restart. Assert sync resumes without data corruption.
- **Database size**: After 50,000 records, assert query performance < 50ms for indexed queries, database file < 100MB.

\`\`\`typescript
// src/services/__tests__/sync-stress.test.ts
import { database } from '@/services/database';
import { syncWithFirestore } from '@/services/sync';

describe('WatermelonDB Sync Stress Tests', () => {
  // Implement with realistic data generators
  // Use jest.setTimeout(120_000) for long-running tests
});
\`\`\`

## 4. Network Condition Tests

Create \`src/utils/__tests__/network-resilience.test.ts\`:

- **Slow 3G**: Simulate 400kbps with 400ms latency. Assert app remains usable, critical data loads < 10s.
- **Intermittent connectivity**: Toggle online/offline every 5 seconds for 2 minutes. Assert no crashes, data integrity maintained.
- **Complete offline**: Operate fully offline for 5 minutes with active usage. Assert all offline-capable features work, sync queue builds correctly.
- **Network transition**: Switch WiFi → Cellular → WiFi. Assert no dropped requests, reconnection < 3 seconds.
- **Request timeout handling**: Assert all API calls have timeouts (max 30s), retry logic with exponential backoff.

## 5. Device-Specific Performance Profiles

Create \`scripts/load-tests/device-profiles.ts\`:

\`\`\`typescript
export const DEVICE_PROFILES = {
  // Baseline devices for performance budgets
  ios_baseline: {
    device: 'iPhone 11',
    os: 'iOS 15',
    ram: '4GB',
    cpu: 'A13 Bionic',
  },
  ios_target: {
    device: 'iPhone 14',
    os: 'iOS 17',
    ram: '6GB',
    cpu: 'A15 Bionic',
  },
  android_baseline: {
    device: 'Samsung Galaxy A52',
    os: 'Android 10',
    ram: '4GB',
    cpu: 'Snapdragon 720G',
  },
  android_low_end: {
    device: 'Samsung Galaxy A13',
    os: 'Android 12',
    ram: '3GB',
    cpu: 'Exynos 850',
  },
} as const;

export const PERFORMANCE_BUDGETS = {
  cold_start_ms: { baseline: 2000, target: 1500 },
  tti_ms: { baseline: 500, target: 300 },
  js_bundle_bytes: { baseline: 5_242_880, target: 4_194_304 },
  memory_limit_mb: { baseline: 200, target: 150 },
  js_fps_min: { baseline: 55, target: 58 },
  ui_fps_min: { baseline: 58, target: 60 },
} as const;
\`\`\`

## 6. Detox Performance E2E Tests

Create \`e2e/performance/\` directory:

### \`e2e/performance/startup.e2e.ts\`
- Measure app launch to first meaningful paint
- Run 5 iterations, report average and p95

### \`e2e/performance/navigation.e2e.ts\`
- Navigate through all main tabs, measure transition times
- Assert all transitions < 300ms

### \`e2e/performance/heavy-list.e2e.ts\`
- Scroll through a list of 500+ items
- Use Detox's \`device.getUiDevice()\` on Android to check for jank

### \`e2e/performance/offline-workflow.e2e.ts\`
- Enable airplane mode via Detox
- Perform CRUD operations
- Disable airplane mode
- Assert sync completes and data is consistent

## 7. CI Integration

Create \`.github/workflows/load-test.yml\`:

- Trigger: manual dispatch + weekly schedule (Sunday night)
- Steps:
  1. Checkout + setup Node 18 + pnpm
  2. Install Artillery globally
  3. Run mobile performance unit tests (\`pnpm test -- --testPathPattern=performance\`)
  4. Run sync stress tests (\`pnpm test -- --testPathPattern=sync-stress\`)
  5. Run Artillery against Firebase staging environment
  6. Run bundle size check (\`scripts/check-bundle-size.sh\`)
  7. Collect all results into a unified report
  8. Post summary to PR (if PR-triggered) or Slack (if scheduled)
  9. Fail pipeline if any threshold breached
  10. Upload Artillery reports and performance traces as artifacts

\`\`\`yaml
# Workflow should use these environment variables
env:
  FIREBASE_STAGING_PROJECT: \${{ secrets.FIREBASE_STAGING_PROJECT }}
  LOAD_TEST_DURATION: '300'
  LOAD_TEST_RATE: '50'
\`\`\`

## 8. Performance Monitoring Dashboard

Create \`scripts/load-tests/report-generator.ts\`:

- Parse Artillery JSON output + Jest performance results
- Generate a Markdown summary with:
  - Pass/fail status per metric
  - Comparison against previous run (stored in \`docs/performance-baselines.json\`)
  - Trend charts (last 10 runs) as ASCII or linked to Firebase Performance dashboard
  - Recommendations for any failed metrics
- Update \`docs/performance-baselines.json\` when a new baseline is established

## 9. In-App Purchase Load Simulation

Create \`scripts/load-tests/iap-load.ts\`:

- Simulate 100 concurrent purchase verification requests to Cloud Functions
- Test receipt validation endpoint (Apple App Store + Google Play)
- Assert: p95 < 2s, no double-charges, idempotency verified
- Test subscription renewal webhook handling under load (50 concurrent webhooks)

## Constraints

- All test files use TypeScript strict mode — no \`any\` types
- Follow project naming: kebab-case files, camelCase functions, PascalCase types
- Keep each test file under 250 lines; split into helpers as needed
- All load test scripts must work against staging only — never production
- Include safety guards: max VU limits, circuit breakers, staging-only URL validation
- Tag all generated files with \`// AI-generated: load-test prompt, Phase 06\` header comment
- Store performance baselines in \`docs/performance-baselines.json\` (committed to repo)
- All thresholds must be configurable via environment variables with sensible defaults
- Network simulation tests should be clearly marked as requiring physical device or specific emulator configuration
- Ensure WatermelonDB tests clean up after themselves (reset database state)
\`\`\`

## Usage

1. Copy the entire prompt above (inside the code fence)
2. Paste into Claude Code
3. Claude will generate:
   - Mobile client performance test suite
   - Artillery load test configurations for all Firebase services
   - WatermelonDB sync stress tests
   - Network resilience tests
   - Detox performance E2E tests
   - CI workflow for automated load testing
   - Performance report generator and baseline tracking
   - In-app purchase load simulation

## Expected Outputs

| File | Purpose |
|------|---------|
| \`src/utils/__tests__/performance.test.ts\` | Client-side performance assertions |
| \`src/services/__tests__/sync-stress.test.ts\` | WatermelonDB sync stress tests |
| \`src/utils/__tests__/network-resilience.test.ts\` | Network condition simulation tests |
| \`scripts/load-tests/artillery-config.yml\` | Artillery base configuration |
| \`scripts/load-tests/firebase-auth-load.yml\` | Auth endpoint load scenarios |
| \`scripts/load-tests/firestore-load.yml\` | Firestore read/write load scenarios |
| \`scripts/load-tests/cloud-functions-load.yml\` | Cloud Functions load scenarios |
| \`scripts/load-tests/push-notification-load.yml\` | FCM delivery load test |
| \`scripts/load-tests/storage-load.yml\` | Cloud Storage upload/download load |
| \`scripts/load-tests/iap-load.yml\` | In-app purchase verification load |
| \`scripts/load-tests/device-profiles.ts\` | Device baselines and performance budgets |
| \`scripts/load-tests/report-generator.ts\` | Unified performance report builder |
| \`scripts/check-bundle-size.sh\` | Bundle size CI gate |
| \`e2e/performance/startup.e2e.ts\` | App launch performance E2E |
| \`e2e/performance/navigation.e2e.ts\` | Navigation transition E2E |
| \`e2e/performance/heavy-list.e2e.ts\` | List scroll performance E2E |
| \`e2e/performance/offline-workflow.e2e.ts\` | Offline sync E2E |
| \`.github/workflows/load-test.yml\` | CI pipeline for load tests |
| \`docs/performance-baselines.json\` | Tracked performance baselines |

## Verification Checklist

After generation, confirm:

- [ ] Artillery configs target staging URLs only with safety guards
- [ ] All TypeScript files compile with \`strict: true\`
- [ ] Performance budgets match device profiles (baseline vs target)
- [ ] Sync stress tests include cleanup/teardown
- [ ] Network tests document device/emulator requirements
- [ ] CI workflow runs on schedule and manual trigger only (not on every push)
- [ ] Bundle size script exits with non-zero code on threshold breach
- [ ] Report generator compares against stored baselines
- [ ] No hardcoded Firebase project IDs or secrets
- [ ] All files have AI-generated header comments
- [ ] Each file stays under 250 lines

## Related Prompts

- [Phase 05 — Observability Setup](../05/observability-setup.md) — Sentry + Firebase Performance integration
- [Phase 05 — Security Hardening](../05/security-hardening.md) — Secure storage, certificate pinning
- [Phase 06 — Testing & Quality overview](../../phases/06-testing-quality.md) — Full phase context
- [Phase 07 — Launch](../../phases/07-launch.md) — Pre-launch performance validation`,

  'playbook/prompts/06/test-suite-generator.md': `# Test Suite Generator — Phase 06: Testing & Quality

> **Copy-paste this prompt into Claude Code** to generate comprehensive test suites for React Native features, including unit tests, component tests, hook tests, service tests, and Detox E2E tests.

---

## Prompt

\`\`\`
You are a senior React Native test engineer working on the react-native-mobile-app project. Generate a comprehensive test suite for the specified feature or module.

## Project Context

- **Framework**: React Native 0.74 + Expo SDK 51
- **Language**: TypeScript (strict mode, no \`any\`)
- **Test Stack**: Jest + React Native Testing Library (unit/component), Detox (E2E)
- **State**: Zustand (client), React Query/TanStack Query (server)
- **Navigation**: React Navigation v6 (typed navigators)
- **Local DB**: WatermelonDB (offline-first)
- **Backend**: Firebase (Auth, Firestore, Cloud Functions, Cloud Messaging)
- **Coverage Threshold**: 75% minimum (lines, branches, functions, statements)
- **Architecture**: Feature-based under src/features/<feature>/

## Feature to Test

**Feature name**: <FEATURE_NAME>
**Feature path**: src/features/<FEATURE_NAME>/
**Key files to test**:
- Screens: <list screen files or "all">
- Components: <list component files or "all">
- Hooks: <list hook files or "all">
- Services: <list service files or "all">

**Critical user flows for E2E**:
1. <describe flow 1>
2. <describe flow 2>
3. <describe flow 3>

## Test Generation Requirements

### 1. Unit Tests (src/features/<FEATURE_NAME>/__tests__/)

Generate tests for **hooks** and **utility functions**:

- Test each hook in isolation using \`renderHook\` from \`@testing-library/react-native\`
- Wrap hooks that use React Query in a \`QueryClientProvider\` with a fresh \`QueryClient\` per test
- Wrap hooks that use Zustand by resetting stores in \`beforeEach\`
- Wrap hooks that use React Navigation in a \`NavigationContainer\`
- Mock all Firebase services (\`@react-native-firebase/auth\`, \`@react-native-firebase/firestore\`, etc.)
- Mock WatermelonDB with \`@nozbe/watermelondb/adapters/sqlite/test-adapter\`
- Test loading, success, and error states for async hooks
- Test offline/online transitions for hooks that use network state
- Test cache invalidation and refetch behavior for React Query hooks
- Use \`act()\` and \`waitFor()\` correctly for async state updates
- Name test files as \`<module>.test.ts\` (not \`.tsx\` unless rendering JSX)

Example hook test structure:
\`\`\`typescript
import { renderHook, waitFor, act } from '@testing-library/react-native';
import { createTestQueryWrapper } from '@/test-utils/query-wrapper';
import { useFeatureData } from '../hooks/use-feature-data';

// Mock Firebase
jest.mock('@react-native-firebase/firestore', () => ({
  __esModule: true,
  default: () => ({
    collection: jest.fn(),
  }),
}));

describe('useFeatureData', () => {
  const wrapper = createTestQueryWrapper();

  beforeEach(() => {
    jest.clearAllMocks();
  });

  it('should return loading state initially', () => {
    const { result } = renderHook(() => useFeatureData('id-1'), { wrapper });
    expect(result.current.isLoading).toBe(true);
  });

  it('should return data on success', async () => {
    // arrange mocks...
    const { result } = renderHook(() => useFeatureData('id-1'), { wrapper });
    await waitFor(() => expect(result.current.isSuccess).toBe(true));
    expect(result.current.data).toEqual(expectedData);
  });

  it('should handle error state', async () => {
    // arrange error mock...
    const { result } = renderHook(() => useFeatureData('bad-id'), { wrapper });
    await waitFor(() => expect(result.current.isError).toBe(true));
  });

  it('should fall back to offline data when network unavailable', async () => {
    // arrange offline mock...
  });
});
\`\`\`

### 2. Component Tests (src/features/<FEATURE_NAME>/__tests__/)

Generate tests for **React Native components and screens**:

- Use \`render\`, \`screen\`, \`fireEvent\`, \`waitFor\` from \`@testing-library/react-native\`
- Test rendering with required and optional props
- Test user interactions: \`fireEvent.press\`, \`fireEvent.changeText\`, \`fireEvent.scroll\`
- Test conditional rendering based on state (loading, error, empty, data)
- Test accessibility: verify \`accessibilityLabel\`, \`accessibilityRole\`, \`accessibilityState\` on all interactive elements
- Test navigation calls using a mocked \`useNavigation\`
- Test i18n: verify text comes from translation keys, not hardcoded strings
- Test platform-specific rendering (\`Platform.OS === 'ios'\` vs \`'android'\`)
- Test keyboard interactions and dismissal where relevant
- Snapshot tests ONLY for stable, presentational components (not screens)
- Name test files as \`<component>.test.tsx\`

Example component test structure:
\`\`\`typescript
import React from 'react';
import { render, screen, fireEvent, waitFor } from '@testing-library/react-native';
import { FeatureCard } from '../components/feature-card';
import { createTestProviders } from '@/test-utils/providers';

const mockNavigate = jest.fn();
jest.mock('@react-navigation/native', () => ({
  ...jest.requireActual('@react-navigation/native'),
  useNavigation: () => ({ navigate: mockNavigate }),
}));

describe('FeatureCard', () => {
  const defaultProps = {
    id: '1',
    title: 'Test Item',
    subtitle: 'Description',
    onPress: jest.fn(),
  };

  const Wrapper = createTestProviders();

  beforeEach(() => {
    jest.clearAllMocks();
  });

  it('should render title and subtitle', () => {
    render(<FeatureCard {...defaultProps} />, { wrapper: Wrapper });
    expect(screen.getByText('Test Item')).toBeTruthy();
    expect(screen.getByText('Description')).toBeTruthy();
  });

  it('should call onPress when tapped', () => {
    render(<FeatureCard {...defaultProps} />, { wrapper: Wrapper });
    fireEvent.press(screen.getByRole('button'));
    expect(defaultProps.onPress).toHaveBeenCalledWith('1');
  });

  it('should have correct accessibility labels', () => {
    render(<FeatureCard {...defaultProps} />, { wrapper: Wrapper });
    const button = screen.getByRole('button');
    expect(button.props.accessibilityLabel).toBeDefined();
  });

  it('should render loading skeleton when isLoading is true', () => {
    render(<FeatureCard {...defaultProps} isLoading />, { wrapper: Wrapper });
    expect(screen.getByTestId('feature-card-skeleton')).toBeTruthy();
    expect(screen.queryByText('Test Item')).toBeNull();
  });

  it('should render error state with retry button', () => {
    const onRetry = jest.fn();
    render(<FeatureCard {...defaultProps} error="Failed" onRetry={onRetry} />, { wrapper: Wrapper });
    fireEvent.press(screen.getByText(/retry/i));
    expect(onRetry).toHaveBeenCalled();
  });
});
\`\`\`

### 3. Service Tests (src/services/__tests__/ or src/features/<FEATURE_NAME>/__tests__/)

Generate tests for **Firebase services, API clients, and data sync**:

- Mock Firebase SDK modules at the module level
- Test Firestore CRUD operations (create, read, update, delete)
- Test Firebase Auth flows (sign in, sign up, sign out, token refresh)
- Test Cloud Functions invocation and response handling
- Test WatermelonDB sync logic (push/pull, conflict resolution)
- Test error mapping (Firebase error codes → user-friendly messages)
- Test retry logic and exponential backoff
- Test data transformation between Firestore documents and app models
- Test secure storage operations (Keychain/Keystore read/write)

Example service test structure:
\`\`\`typescript
import { authService } from '../auth-service';
import auth from '@react-native-firebase/auth';

jest.mock('@react-native-firebase/auth', () => {
  const signInWithEmailAndPassword = jest.fn();
  const signOut = jest.fn();
  const onAuthStateChanged = jest.fn();
  return {
    __esModule: true,
    default: () => ({
      signInWithEmailAndPassword,
      signOut,
      onAuthStateChanged,
      currentUser: null,
    }),
  };
});

describe('authService', () => {
  beforeEach(() => {
    jest.clearAllMocks();
  });

  describe('signIn', () => {
    it('should return user on successful sign in', async () => {
      const mockUser = { uid: '123', email: 'test@example.com' };
      (auth().signInWithEmailAndPassword as jest.Mock).mockResolvedValue({
        user: mockUser,
      });

      const result = await authService.signIn('test@example.com', 'password');
      expect(result.uid).toBe('123');
    });

    it('should throw AuthError with USER_NOT_FOUND for unknown email', async () => {
      (auth().signInWithEmailAndPassword as jest.Mock).mockRejectedValue({
        code: 'auth/user-not-found',
      });

      await expect(authService.signIn('bad@example.com', 'password'))
        .rejects.toMatchObject({ code: 'USER_NOT_FOUND' });
    });

    it('should throw AuthError with INVALID_PASSWORD for wrong password', async () => {
      (auth().signInWithEmailAndPassword as jest.Mock).mockRejectedValue({
        code: 'auth/wrong-password',
      });

      await expect(authService.signIn('test@example.com', 'wrong'))
        .rejects.toMatchObject({ code: 'INVALID_PASSWORD' });
    });
  });
});
\`\`\`

### 4. Zustand Store Tests (src/store/__tests__/)

Generate tests for **Zustand stores**:

- Test initial state values
- Test each action/mutation in isolation
- Test computed/derived state (selectors)
- Test persistence (if using zustand/middleware persist)
- Test store reset/cleanup
- Reset store between tests using the store's \`setState\` or \`destroy\`

Example store test:
\`\`\`typescript
import { useAuthStore } from '../auth-store';

describe('useAuthStore', () => {
  beforeEach(() => {
    useAuthStore.setState(useAuthStore.getInitialState());
  });

  it('should have correct initial state', () => {
    const state = useAuthStore.getState();
    expect(state.user).toBeNull();
    expect(state.isAuthenticated).toBe(false);
    expect(state.isLoading).toBe(false);
  });

  it('should set user on login', () => {
    const mockUser = { uid: '123', email: 'test@example.com', displayName: 'Test' };
    useAuthStore.getState().setUser(mockUser);

    const state = useAuthStore.getState();
    expect(state.user).toEqual(mockUser);
    expect(state.isAuthenticated).toBe(true);
  });

  it('should clear user on logout', () => {
    useAuthStore.getState().setUser({ uid: '123', email: 'test@example.com', displayName: 'Test' });
    useAuthStore.getState().clearUser();

    expect(useAuthStore.getState().user).toBeNull();
    expect(useAuthStore.getState().isAuthenticated).toBe(false);
  });
});
\`\`\`

### 5. Navigation Tests (src/navigation/__tests__/)

Generate tests for **navigation configuration and deep linking**:

- Test that deep link URLs resolve to correct screens
- Test navigation state for authenticated vs unauthenticated users
- Test tab navigator renders correct screens
- Test stack navigator push/pop behavior
- Test navigation params are passed correctly

Example:
\`\`\`typescript
import { getStateFromPath } from '@react-navigation/native';
import { linkingConfig } from '../linking-config';

describe('Deep Linking', () => {
  it('should resolve /profile/:id to ProfileScreen', () => {
    const state = getStateFromPath('/profile/abc123', linkingConfig.config);
    const route = state?.routes[0]?.state?.routes?.slice(-1)[0];
    expect(route?.name).toBe('Profile');
    expect(route?.params).toEqual({ id: 'abc123' });
  });

  it('should resolve /notifications to NotificationsScreen', () => {
    const state = getStateFromPath('/notifications', linkingConfig.config);
    const route = state?.routes[0]?.state?.routes?.slice(-1)[0];
    expect(route?.name).toBe('Notifications');
  });

  it('should fallback to Home for unknown paths', () => {
    const state = getStateFromPath('/unknown/path', linkingConfig.config);
    expect(state?.routes[0]?.name).toBe('Main');
  });
});
\`\`\`

### 6. Detox E2E Tests (e2e/)

Generate **Detox E2E tests** for critical user flows:

- Use \`device\`, \`element\`, \`by\`, \`expect\`, \`waitFor\` from Detox
- Test on both iOS and Android (use \`device.getPlatform()\` for platform-specific logic)
- Set up test user accounts in \`beforeAll\` (use Firebase Admin SDK or test helpers)
- Clean up test data in \`afterAll\`
- Test the complete user journey, not individual screens
- Handle animations with \`device.disableSynchronization()\` / \`device.enableSynchronization()\` where needed
- Handle permission dialogs with \`device.launchApp({ permissions: { notifications: 'YES' } })\`
- Use \`testID\` props for element selection (never text matching for E2E)
- Take screenshots on failure for debugging
- Keep E2E tests focused on critical paths (auth, core feature, payments)

Example E2E test structure:
\`\`\`typescript
describe('Authentication Flow', () => {
  beforeAll(async () => {
    await device.launchApp({
      newInstance: true,
      permissions: { notifications: 'YES' },
    });
  });

  afterAll(async () => {
    // Clean up test user if created
  });

  it('should show login screen on fresh launch', async () => {
    await expect(element(by.id('login-screen'))).toBeVisible();
    await expect(element(by.id('email-input'))).toBeVisible();
    await expect(element(by.id('password-input'))).toBeVisible();
    await expect(element(by.id('login-button'))).toBeVisible();
  });

  it('should show validation errors for empty fields', async () => {
    await element(by.id('login-button')).tap();
    await expect(element(by.id('email-error'))).toBeVisible();
    await expect(element(by.id('password-error'))).toBeVisible();
  });

  it('should show error for invalid credentials', async () => {
    await element(by.id('email-input')).typeText('wrong@example.com');
    await element(by.id('password-input')).typeText('wrongpassword');
    await element(by.id('login-button')).tap();
    await waitFor(element(by.id('login-error-toast')))
      .toBeVisible()
      .withTimeout(5000);
  });

  it('should navigate to home on successful login', async () => {
    await element(by.id('email-input')).clearText();
    await element(by.id('email-input')).typeText('test@example.com');
    await element(by.id('password-input')).clearText();
    await element(by.id('password-input')).typeText('Test123!');
    await element(by.id('login-button')).tap();
    await waitFor(element(by.id('home-screen')))
      .toBeVisible()
      .withTimeout(10000);
  });

  it('should persist session after app restart', async () => {
    await device.launchApp({ newInstance: false });
    await expect(element(by.id('home-screen'))).toBeVisible();
  });

  it('should return to login after sign out', async () => {
    await element(by.id('profile-tab')).tap();
    await element(by.id('sign-out-button')).tap();
    await element(by.id('confirm-sign-out')).tap();
    await waitFor(element(by.id('login-screen')))
      .toBeVisible()
      .withTimeout(5000);
  });
});
\`\`\`

### 7. Test Utilities to Generate

Create shared test utilities in \`src/test-utils/\`:

**\`src/test-utils/query-wrapper.tsx\`** — React Query test wrapper:
\`\`\`typescript
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export function createTestQueryWrapper() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { retry: false, gcTime: 0 },
      mutations: { retry: false },
    },
  });

  return function TestQueryWrapper({ children }: { children: React.ReactNode }) {
    return (
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    );
  };
}
\`\`\`

**\`src/test-utils/providers.tsx\`** — Combined test providers:
\`\`\`typescript
import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { createTestQueryWrapper } from './query-wrapper';

export function createTestProviders() {
  const QueryWrapper = createTestQueryWrapper();

  return function TestProviders({ children }: { children: React.ReactNode }) {
    return (
      <SafeAreaProvider>
        <QueryWrapper>
          <NavigationContainer>
            {children}
          </NavigationContainer>
        </QueryWrapper>
      </SafeAreaProvider>
    );
  };
}
\`\`\`

**\`src/test-utils/firebase-mocks.ts\`** — Centralized Firebase mocks:
\`\`\`typescript
export const mockFirebaseAuth = {
  signInWithEmailAndPassword: jest.fn(),
  createUserWithEmailAndPassword: jest.fn(),
  signOut: jest.fn(),
  onAuthStateChanged: jest.fn(),
  currentUser: null,
};

export const mockFirestore = {
  collection: jest.fn(() => ({
    doc: jest.fn(() => ({
      get: jest.fn(),
      set: jest.fn(),
      update: jest.fn(),
      delete: jest.fn(),
      onSnapshot: jest.fn(),
    })),
    where: jest.fn(() => ({
      get: jest.fn(),
      onSnapshot: jest.fn(),
    })),
    add: jest.fn(),
  })),
};

export const mockCloudMessaging = {
  getToken: jest.fn().mockResolvedValue('mock-fcm-token'),
  onMessage: jest.fn(),
  onNotificationOpenedApp: jest.fn(),
  getInitialNotification: jest.fn().mockResolvedValue(null),
  requestPermission: jest.fn().mockResolvedValue(1),
};

export function setupFirebaseMocks() {
  jest.mock('@react-native-firebase/auth', () => ({
    __esModule: true,
    default: () => mockFirebaseAuth,
  }));

  jest.mock('@react-native-firebase/firestore', () => ({
    __esModule: true,
    default: () => mockFirestore,
  }));

  jest.mock('@react-native-firebase/messaging', () => ({
    __esModule: true,
    default: () => mockCloudMessaging,
  }));
}
\`\`\`

**\`src/test-utils/watermelon-mock.ts\`** — WatermelonDB test helpers:
\`\`\`typescript
import { Database } from '@nozbe/watermelondb';
import LokiJSAdapter from '@nozbe/watermelondb/adapters/lokijs';
import { appSchema } from '../database/schema';
import { modelClasses } from '../database/models';

export function createTestDatabase(): Database {
  const adapter = new LokiJSAdapter({
    schema: appSchema,
    useWebWorker: false,
    useIncrementalIndexedDB: false,
  });

  return new Database({
    adapter,
    modelClasses,
  });
}
\`\`\`

**\`e2e/utils/test-helpers.ts\`** — Detox test helpers:
\`\`\`typescript
export async function loginTestUser(email = 'test@example.com', password = 'Test123!') {
  await element(by.id('email-input')).clearText();
  await element(by.id('email-input')).typeText(email);
  await element(by.id('password-input')).clearText();
  await element(by.id('password-input')).typeText(password);
  await element(by.id('login-button')).tap();
  await waitFor(element(by.id('home-screen')))
    .toBeVisible()
    .withTimeout(10000);
}

export async function logoutTestUser() {
  await element(by.id('profile-tab')).tap();
  await element(by.id('sign-out-button')).tap();
  await element(by.id('confirm-sign-out')).tap();
  await waitFor(element(by.id('login-screen')))
    .toBeVisible()
    .withTimeout(5000);
}

export async function dismissKeyboard() {
  if (device.getPlatform() === 'ios') {
    await element(by.id('keyboard-dismiss-area')).tap();
  } else {
    await device.pressBack();
  }
}

export async function waitForSync(timeoutMs = 15000) {
  await waitFor(element(by.id('sync-indicator')))
    .not.toBeVisible()
    .withTimeout(timeoutMs);
}
\`\`\`

## Output Format

For each test file, output:

1. **File path** relative to project root
2. **Complete test file** with all imports, mocks, describe blocks, and test cases
3. **Coverage notes** — which lines/branches the tests target

Generate tests in this order:
1. Test utilities (if they don't exist)
2. Store tests
3. Hook tests
4. Service tests
5. Component tests
6. Screen tests
7. Navigation tests
8. E2E tests

## Quality Checklist

Before outputting, verify each test file:

- [ ] No \`any\` types — all mocks and assertions are typed
- [ ] No hardcoded strings for UI text — use translation keys or testIDs
- [ ] All async operations use \`await\` with \`waitFor\` or \`act\`
- [ ] Each test has a single clear assertion (or closely related group)
- [ ] Test names follow "should <expected behavior> when <condition>" pattern
- [ ] Mocks are reset in \`beforeEach\` to prevent test pollution
- [ ] No test interdependencies — each test can run in isolation
- [ ] Accessibility assertions included for interactive components
- [ ] Error boundaries and error states are tested
- [ ] Offline scenarios are tested for data-fetching hooks/components
- [ ] Platform-specific code has tests for both iOS and Android paths
- [ ] E2E tests use \`testID\` exclusively (no text matchers)
- [ ] E2E tests have reasonable timeouts (5-15s for network operations)
- [ ] All generated code is marked with \`// AI-generated\` comment at file top
\`\`\`

---

## Usage

1. Copy the prompt above into Claude Code
2. Replace the placeholders:
   - \`<FEATURE_NAME>\` — the feature directory name (e.g., \`auth\`, \`home\`, \`payments\`)
   - List the specific files to test or use \`"all"\`
   - Describe 2-3 critical user flows for E2E tests
3. Claude will generate the complete test suite with all files
4. Review generated tests, adjust mocks for your actual service signatures
5. Run \`pnpm test\` to verify unit/component tests pass
6. Run \`npx detox test --configuration ios.sim.debug\` for E2E tests

## Example Invocation

\`\`\`
Feature name: auth
Feature path: src/features/auth/
Key files to test:
- Screens: login-screen.tsx, register-screen.tsx, forgot-password-screen.tsx
- Components: biometric-prompt.tsx, social-login-buttons.tsx
- Hooks: use-auth.ts, use-biometric.ts
- Services: src/services/auth/auth-service.ts, src/services/auth/token-service.ts

Critical user flows for E2E:
1. User logs in with email/password and sees home screen
2. User registers a new account, verifies email, and completes onboarding
3. User enables biometric auth and uses it on next app launch
\`\`\`

## Related Prompts

- **[security-hardening.md](../05/security-hardening.md)** — Security patterns that need test coverage
- **[auth-implementation.md](../04/auth-implementation.md)** — Auth feature implementation to test against
- **[feature-implementation.md](../04/feature-implementation.md)** — Feature patterns that tests should validate
- **[observability-setup.md](../05/observability-setup.md)** — Analytics/crash reporting mocks needed in tests
- **[ci-pipeline.md](../03/ci-pipeline.md)** — CI pipeline that runs these tests`,

  'playbook/prompts/07/go-live-checklist.md': `# Go-Live Checklist — Phase 07 Launch

## Prompt for Claude Code

Copy and paste the following prompt into Claude Code when preparing for production launch of the React Native mobile app.

---

You are helping launch a React Native mobile app built with Expo SDK 51, TypeScript, and Firebase. Generate a comprehensive go-live checklist covering every aspect of mobile app release to the App Store and Google Play.

## Project Context

- **Stack**: React Native 0.74, Expo SDK 51, TypeScript strict mode, Firebase (Auth, Firestore, Cloud Functions, Cloud Messaging, Storage)
- **State**: Zustand (client), React Query (server), WatermelonDB (offline)
- **Navigation**: React Navigation v6 with typed navigators and deep linking
- **CI/CD**: GitHub Actions + EAS Build + EAS Submit
- **Monitoring**: Sentry (crash reporting), Firebase Analytics, Firebase Crashlytics
- **Compliance**: GDPR, App Store Guidelines, Google Play Policies

## Checklist Scope

Generate a go-live checklist as a Markdown file at \`docs/go-live-checklist.md\` organized into the following sections. Each item must be a checkbox (\`- [ ]\`) with a clear, actionable description. Add responsible role tags where appropriate: \`[Mobile Dev]\`, \`[Backend Dev]\`, \`[Lead]\`, \`[QA]\`, \`[Design]\`.

### 1. Code Freeze & Branch Readiness

- Confirm \`main\` branch is green on all CI checks (lint, type check, unit tests, component tests)
- Verify all feature branches for this release are merged and PR-approved
- Confirm no open PRs targeting \`main\` with \`release-blocker\` label
- Tag the release commit with semantic version: \`git tag v{MAJOR}.{MINOR}.{PATCH}\`
- Verify conventional commit history is clean since last release tag
- Confirm CODEOWNERS file is current and all sensitive paths have designated reviewers
- Run \`pnpm audit\` and confirm zero critical/high vulnerabilities in dependencies
- Verify no \`// TODO\` or \`// FIXME\` comments remain in release-critical paths
- Confirm all AI-generated code is flagged with \`// AI-generated\` comments per project policy

### 2. App Configuration & Environment

- Verify \`app.json\` / \`app.config.ts\` has correct production values:
  - \`expo.version\` matches release version
  - \`expo.ios.buildNumber\` is incremented from last App Store release
  - \`expo.android.versionCode\` is incremented from last Google Play release
  - \`expo.slug\`, \`expo.name\`, \`expo.scheme\` are correct
  - \`expo.ios.bundleIdentifier\` matches App Store Connect
  - \`expo.android.package\` matches Google Play Console
- Verify \`.env.production\` values are set and not pointing to staging:
  - \`FIREBASE_PROJECT_ID\` → production project
  - \`FIREBASE_API_KEY\` → production key
  - \`FIREBASE_AUTH_DOMAIN\` → production domain
  - \`SENTRY_DSN\` → production DSN
  - \`API_BASE_URL\` → production Cloud Functions URL
- Confirm \`google-services.json\` (Android) is the production variant
- Confirm \`GoogleService-Info.plist\` (iOS) is the production variant
- Verify \`eas.json\` production profile configuration:
  - \`production\` channel is set
  - \`distribution\` is \`store\`
  - \`credentialsSource\` is \`remote\` (managed by EAS)
  - \`autoIncrement\` settings are correct
- Confirm \`react-native-config\` is reading from the correct \`.env.production\` file
- Verify Expo Constants (\`expo-constants\`) exposes correct \`expoConfig\` values at runtime

### 3. Firebase Backend Readiness

- Confirm Firestore security rules are deployed to production and reviewed:
  - No open \`allow read, write: if true;\` rules
  - All collections have proper authentication checks
  - Rate limiting rules are in place for write-heavy collections
- Confirm Firebase Authentication providers are enabled in production project:
  - Email/password, Google Sign-In, Apple Sign-In (required for iOS)
  - Verify OAuth redirect URIs match production bundle ID / package name
- Confirm Cloud Functions are deployed to production:
  - Run \`firebase deploy --only functions --project production\`
  - Verify function regions match client configuration
  - Confirm function environment variables are set (\`firebase functions:config:get\`)
- Confirm Firebase Cloud Messaging (FCM) is configured:
  - APNs authentication key uploaded for iOS push notifications
  - FCM server key is active for Android
  - Test push notification delivery to a production device
- Confirm Firebase Storage rules restrict access appropriately
- Verify Firestore indexes are deployed: \`firebase deploy --only firestore:indexes\`
- Confirm WatermelonDB sync endpoint (Cloud Function) handles production load
- Verify Firebase App Check is enabled to prevent API abuse

### 4. Security Audit

- Confirm biometric authentication (Face ID / Touch ID / Fingerprint) works on physical devices
- Verify sensitive data is stored in secure storage:
  - iOS: Keychain via \`expo-secure-store\`
  - Android: Keystore via \`expo-secure-store\`
  - No tokens, secrets, or PII in AsyncStorage
- Confirm certificate pinning is enabled for production API endpoints
- Verify ProGuard / R8 obfuscation is enabled for Android release builds
- Confirm Hermes bytecode is used (code not shipped as plain JS)
- Verify no hardcoded secrets, API keys, or credentials in source code:
  - Run \`git log --all -p | grep -i "secret\\|password\\|api_key"\` as a sanity check
- Confirm \`expo-secure-store\` is used for all auth tokens and refresh tokens
- Verify deep link URL schemes are validated and don't expose sensitive routes
- Confirm SSL/TLS is enforced on all network requests (no HTTP, only HTTPS)
- Verify App Transport Security (ATS) is not disabled in \`Info.plist\` for iOS
- Confirm Android Network Security Config does not allow cleartext traffic
- Run OWASP Mobile Top 10 review against the app

### 5. Privacy & Compliance (GDPR, App Store, Google Play)

- Confirm GDPR consent flow is implemented and tested:
  - Users can opt in/out of analytics and tracking
  - Consent preferences are persisted and respected
  - Data collection does not begin before consent is granted
- Confirm data deletion flow works end-to-end:
  - User can request account deletion from within the app (Apple requirement)
  - Deletion removes Firestore user document, Firebase Auth account, Storage files
  - Cloud Function handles cascading deletion of related data
- Verify privacy policy URL is accessible and up to date
- Verify terms of service URL is accessible and up to date
- Confirm App Store privacy nutrition labels are prepared:
  - Data types collected (analytics, identifiers, usage data)
  - Data linked to user vs. not linked
  - Data used for tracking vs. not
- Confirm Google Play Data Safety form is completed:
  - Data types collected and shared
  - Security practices (encryption in transit, deletion mechanism)
- Verify App Tracking Transparency (ATT) prompt is shown on iOS before any tracking
- Confirm \`NSUserTrackingUsageDescription\` is set in \`Info.plist\` with clear explanation
- Verify IDFA collection complies with ATT framework
- Confirm analytics events do not contain PII (email, phone, name) in event parameters

### 6. In-App Purchases & Subscriptions

- Confirm in-app purchase products are created in App Store Connect and Google Play Console
- Verify product IDs in code match store product IDs exactly
- Confirm receipt validation is handled server-side (Cloud Function), not client-side
- Test purchase flow end-to-end in sandbox/test environment:
  - New purchase, restore purchase, subscription renewal, cancellation
- Verify subscription status is synced correctly with Firestore
- Confirm grace period and billing retry handling for subscriptions
- Verify refund webhook handling in Cloud Functions
- Confirm price display uses localized currency from store API, not hardcoded values

### 7. Performance & Optimization

- Run React Native performance profiling on physical devices (not simulators):
  - Verify 60fps scrolling on FlatList/SectionList screens
  - Confirm no JS thread blocking during navigation transitions
  - Check Hermes memory usage is within acceptable bounds
- Verify app startup time (cold start) is under 2 seconds on mid-range devices
- Confirm images are optimized (WebP format, appropriate resolution per density)
- Verify bundle size is acceptable:
  - Run \`npx react-native-bundle-visualizer\` or \`npx expo export\` and analyze
  - Confirm no unnecessary large dependencies are bundled
- Confirm WatermelonDB local database performs well with expected data volume
- Verify offline-to-online sync handles large queued change sets without timeout
- Confirm React Query cache invalidation and stale time settings are tuned for production
- Verify Zustand stores do not hold excessive data in memory
- Confirm animations use \`useNativeDriver: true\` where possible
- Verify no memory leaks on repeated screen navigation (use Flipper/Instruments)

### 8. Testing Sign-Off

- Confirm unit test coverage meets 75% threshold: \`pnpm test --coverage\`
- Confirm all component tests pass: \`pnpm test --testPathPattern=components\`
- Confirm Detox E2E tests pass on both platforms:
  - \`npx detox test --configuration ios.sim.release\`
  - \`npx detox test --configuration android.emu.release\`
- Verify critical user flows tested end-to-end:
  - [ ] Sign up (email, Google, Apple)
  - [ ] Sign in + biometric unlock
  - [ ] Onboarding flow
  - [ ] Core feature usage (home feed, detail screens)
  - [ ] Push notification receipt and tap-through
  - [ ] Offline mode → data entry → sync on reconnect
  - [ ] In-app purchase flow
  - [ ] Profile edit and account deletion
  - [ ] Deep link handling from external URL
- Confirm QA has tested on physical devices:
  - [ ] iPhone (latest iOS)
  - [ ] iPhone (iOS n-1)
  - [ ] Android flagship (latest Android)
  - [ ] Android mid-range (Android n-1)
  - [ ] iPad (if supported)
  - [ ] Android tablet (if supported)
- Confirm accessibility testing:
  - VoiceOver (iOS) reads all interactive elements correctly
  - TalkBack (Android) reads all interactive elements correctly
  - All interactive elements have \`accessibilityLabel\` props
  - Dynamic font scaling does not break layouts
- Confirm dark mode renders correctly on all screens
- Confirm landscape orientation handling (or confirm portrait lock is intentional)

### 9. Build & Signing

- Trigger production builds via EAS:
  - \`eas build --platform ios --profile production\`
  - \`eas build --platform android --profile production\`
- Confirm iOS build is signed with the correct distribution certificate and provisioning profile
- Confirm Android build is signed with the production upload keystore
- Verify Android App Bundle (AAB) is generated, not APK, for Google Play
- Download and install production builds on physical devices for smoke testing
- Confirm build artifacts are archived and tagged with the release version
- Verify source maps are uploaded to Sentry for both platforms:
  - \`npx sentry-expo-upload-sourcemaps\`
  - Confirm Sentry release matches app version

### 10. Store Submission Preparation

#### App Store (iOS)
- [ ] App Store Connect: app metadata is complete (name, subtitle, description, keywords) \`[Lead]\`
- [ ] Screenshots uploaded for required device sizes (6.7", 6.5", 5.5", iPad if applicable) \`[Design]\`
- [ ] App preview video uploaded (optional but recommended) \`[Design]\`
- [ ] App icon (1024x1024) uploaded \`[Design]\`
- [ ] Age rating questionnaire completed \`[Lead]\`
- [ ] App Review notes prepared (test account credentials, special instructions) \`[Lead]\`
- [ ] Privacy policy URL set in App Store Connect \`[Lead]\`
- [ ] App privacy nutrition labels completed \`[Lead]\`
- [ ] In-app purchase products submitted for review \`[Lead]\`
- [ ] Submit for review: \`eas submit --platform ios --profile production\` \`[Mobile Dev]\`

#### Google Play (Android)
- [ ] Google Play Console: store listing is complete (title, short/full description) \`[Lead]\`
- [ ] Screenshots uploaded for phone and tablet (if applicable) \`[Design]\`
- [ ] Feature graphic (1024x500) uploaded \`[Design]\`
- [ ] App icon (512x512) uploaded \`[Design]\`
- [ ] Content rating questionnaire completed \`[Lead]\`
- [ ] Data safety form completed \`[Lead]\`
- [ ] Target audience and content settings configured \`[Lead]\`
- [ ] Privacy policy URL set in Google Play Console \`[Lead]\`
- [ ] Submit AAB to production track: \`eas submit --platform android --profile production\` \`[Mobile Dev]\`
- [ ] Configure staged rollout percentage (recommend 10% → 25% → 50% → 100%) \`[Lead]\`

### 11. Monitoring & Observability

- Confirm Sentry is receiving errors from production builds (trigger a test error)
- Confirm Firebase Crashlytics is receiving crash reports (trigger a test crash in staging)
- Confirm Firebase Analytics events are flowing:
  - \`app_open\`, \`sign_up\`, \`login\`, \`purchase\`, custom feature events
- Set up Sentry alerts for:
  - New error types (first seen)
  - Error rate spike (>5% of sessions)
  - Unhandled promise rejections
- Set up Firebase Crashlytics alerts for crash-free rate dropping below 99%
- Confirm Firebase Performance Monitoring is tracking:
  - App startup time
  - Network request latency to Cloud Functions
  - Screen rendering time
- Set up uptime monitoring for Cloud Functions endpoints
- Confirm logging in Cloud Functions captures request/response metadata (without PII)
- Verify Slack integration for Sentry and Crashlytics alerts

### 12. Rollback & Incident Response

- Document rollback procedure:
  - For JS-only changes: push OTA rollback via \`eas update --branch production --message "rollback"\`
  - For native changes: submit expedited review (iOS) or halt rollout (Android)
- Confirm previous production build is available for emergency resubmission
- Document incident response runbook at \`docs/runbooks/production-incident.md\`:
  - On-call rotation and escalation path
  - Slack channel for incidents: \`#app-incidents\`
  - Steps to diagnose (Sentry → Crashlytics → Cloud Functions logs)
  - Steps to mitigate (feature flags, OTA update, server-side kill switch)
- Confirm Firebase Remote Config is set up for feature flags / kill switches
- Test OTA update flow: push an EAS Update and verify it applies on next app launch
- Confirm staged rollout strategy for Google Play (pause rollout if crash rate spikes)

### 13. Post-Launch Monitoring Plan

- [ ] Monitor crash-free rate for first 24 hours (target: >99.5%) \`[Lead]\`
- [ ] Monitor Sentry error dashboard for new/unhandled errors \`[Mobile Dev]\`
- [ ] Monitor Firebase Analytics for user engagement metrics \`[Lead]\`
- [ ] Monitor Cloud Functions error rate and latency \`[Backend Dev]\`
- [ ] Monitor WatermelonDB sync success rate \`[Backend Dev]\`
- [ ] Check App Store / Google Play reviews for user-reported issues \`[QA]\`
- [ ] Verify push notification delivery rate in FCM console \`[Mobile Dev]\`
- [ ] Confirm in-app purchase revenue is flowing in store dashboards \`[Lead]\`
- [ ] Schedule post-launch retrospective for 1 week after launch \`[Lead]\`
- [ ] Increase Google Play staged rollout to 100% after 48 hours of stability \`[Lead]\`

### 14. Communication & Documentation

- [ ] Update \`CHANGELOG.md\` with release notes for this version \`[Lead]\`
- [ ] Publish release notes in GitHub Releases \`[Lead]\`
- [ ] Notify team in Slack \`#releases\` channel with version, changes, and known issues \`[Lead]\`
- [ ] Update \`docs/deployment.md\` with any process changes from this release \`[Mobile Dev]\`
- [ ] Archive release artifacts (IPA, AAB, source maps) in designated storage \`[Mobile Dev]\`
- [ ] Update \`playbook/current-phase.json\` to reflect post-launch phase \`[Lead]\`

---

## Output Format

Generate the checklist as a single Markdown file. Use the exact checkbox format shown above. Group items by section with \`###\` headers. Include role tags in brackets at the end of each item. Add a header with metadata:

\`\`\`markdown
# Go-Live Checklist — v{VERSION}

**App**: react-native-mobile-app
**Target Release Date**: YYYY-MM-DD
**Release Manager**: @handle
**Platforms**: iOS, Android
**Build Profile**: production
**Status**: 🔴 Not Started | 🟡 In Progress | 🟢 Complete
\`\`\`

Place the generated file at \`docs/go-live-checklist.md\` and commit with message \`docs: add go-live checklist for v{VERSION} release\`.`,

  'playbook/prompts/07/monitoring-setup.md': `# Monitoring Setup — Phase 07 (Launch)

## Purpose

Copy-pasteable prompt for Claude Code to set up production monitoring, crash reporting, analytics, performance tracking, and alerting for the React Native mobile app across both iOS and Android platforms.

---

## Prompt

\`\`\`
You are a senior mobile DevOps engineer setting up production monitoring for our React Native Expo app. Configure comprehensive monitoring across crash reporting, analytics, performance, and alerting.

## Project Context

- **Framework**: React Native 0.74 + Expo SDK 51
- **Backend**: Firebase (Firestore, Cloud Functions, Authentication, Cloud Messaging)
- **Crash Reporting**: Sentry + Firebase Crashlytics
- **Analytics**: Firebase Analytics + custom events
- **Performance**: Sentry Performance + Firebase Performance Monitoring
- **Alerting**: Sentry alerts + PagerDuty/Slack integration
- **Offline Database**: WatermelonDB (sync health must be monitored)
- **CI/CD**: EAS Build + EAS Submit
- **Compliance**: GDPR (consent required before tracking)

## Directory Structure

Place files according to this layout:

\`\`\`
src/
  services/
    monitoring/
      index.ts                    # Barrel export
      sentry.ts                   # Sentry initialization and configuration
      crashlytics.ts              # Firebase Crashlytics setup
      analytics.ts                # Analytics service (Firebase Analytics)
      performance.ts              # Performance monitoring service
      error-boundary.tsx          # Global React error boundary with reporting
      types.ts                    # Monitoring types and event definitions
    sync/
      sync-monitor.ts             # WatermelonDB sync health monitoring
  hooks/
    use-screen-tracking.ts        # Auto screen view tracking hook
    use-app-state-monitor.ts      # App lifecycle monitoring hook
    use-network-monitor.ts        # Network connectivity monitoring hook
  utils/
    consent-manager.ts            # GDPR consent management for analytics
scripts/
  upload-sourcemaps.sh            # Sentry source map upload for EAS builds
  verify-monitoring.ts            # Script to verify monitoring is working
docs/
  monitoring-runbook.md           # Operational runbook for monitoring
\`\`\`

## Task 1: Sentry Configuration (\`src/services/monitoring/sentry.ts\`)

Set up Sentry for React Native with:

- Initialize \`@sentry/react-native\` with DSN from environment config
- Configure release tracking using \`expo-constants\` (appVersion, buildNumber)
- Set \`dist\` to EAS build number for source map association
- Enable performance monitoring with \`tracesSampleRate\` (1.0 staging, 0.2 production)
- Enable profiling with \`profilesSampleRate\` (0.1 production)
- Configure \`beforeSend\` callback to:
  - Strip PII (email, phone, IP) from events before sending
  - Respect GDPR consent status (drop events if no consent)
  - Add custom tags: platform (ios/android), appVersion, buildChannel (staging/production)
  - Filter out known non-actionable errors (network timeouts on airplane mode, etc.)
- Configure \`beforeBreadcrumb\` to redact sensitive navigation params
- Set up Sentry navigation integration with React Navigation
- Export \`captureException\`, \`captureMessage\`, \`setUser\`, \`clearUser\` wrappers
- Export \`withSentryPerformance\` HOC for screen-level performance tracking
- Add breadcrumb helpers: \`addBreadcrumb\`, \`addNetworkBreadcrumb\`, \`addSyncBreadcrumb\`

Use TypeScript strict mode, no \`any\` types.

## Task 2: Firebase Crashlytics (\`src/services/monitoring/crashlytics.ts\`)

Set up Firebase Crashlytics as a secondary crash reporter:

- Initialize \`@react-native-firebase/crashlytics\`
- Respect GDPR consent: disable collection until consent granted
- Export \`setCrashlyticsUser(userId: string)\` and \`clearCrashlyticsUser()\`
- Export \`logCrashlyticsError(error: Error, context?: Record<string, string>)\`
- Export \`setCrashlyticsAttributes(attrs: Record<string, string>)\` for custom keys
- Log non-fatal errors with custom keys (screen, feature, syncStatus)
- Add crash-free users percentage tracking context
- Coordinate with Sentry: both receive crashes, Sentry is primary for triage

## Task 3: Analytics Service (\`src/services/monitoring/analytics.ts\`)

Create a unified analytics service wrapping Firebase Analytics:

- Define a strict \`AnalyticsEvent\` union type for all app events:
  - \`screen_view\` (screen_name, screen_class)
  - \`sign_up\` (method: 'email' | 'google' | 'apple')
  - \`login\` (method, success: boolean)
  - \`biometric_auth\` (type: 'face_id' | 'touch_id' | 'fingerprint', success: boolean)
  - \`push_notification_received\` (notification_type, source)
  - \`push_notification_opened\` (notification_type, source)
  - \`deep_link_opened\` (path, source)
  - \`purchase_initiated\` (product_id, price, currency)
  - \`purchase_completed\` (product_id, transaction_id, price, currency)
  - \`purchase_failed\` (product_id, error_code)
  - \`sync_started\` (trigger: 'manual' | 'auto' | 'background')
  - \`sync_completed\` (duration_ms, records_pushed, records_pulled)
  - \`sync_failed\` (error_type, retry_count)
  - \`offline_action_queued\` (action_type)
  - \`app_error\` (error_type, screen, fatal: boolean)
  - \`feature_used\` (feature_name, context)
- Export \`trackEvent(event: AnalyticsEvent)\` that:
  - Checks GDPR consent before sending
  - Logs to Firebase Analytics via \`@react-native-firebase/analytics\`
  - Adds Sentry breadcrumb for event correlation
  - Queues events when offline, flushes when online
- Export \`setAnalyticsUser(userId: string, properties: UserProperties)\`
- Export \`resetAnalytics()\` for logout / GDPR data deletion
- All event names must use snake_case, all params must be typed

## Task 4: Performance Monitoring (\`src/services/monitoring/performance.ts\`)

Set up performance monitoring:

- Initialize Firebase Performance Monitoring (\`@react-native-firebase/perf\`)
- Create custom trace helpers:
  - \`startTrace(name: string): Promise<PerformanceTrace>\` — wraps Firebase trace
  - \`measureAsync<T>(name: string, fn: () => Promise<T>): Promise<T>\` — auto-measure async operations
- Define standard traces:
  - \`app_startup\` — cold start to first meaningful paint
  - \`screen_render_{screenName}\` — time to interactive per screen
  - \`api_call_{endpoint}\` — Firebase Cloud Function call duration
  - \`sync_full\` — full WatermelonDB sync cycle
  - \`sync_pull\` / \`sync_push\` — individual sync phases
  - \`image_load\` — image loading time
  - \`deep_link_resolve\` — deep link to screen render
  - \`biometric_prompt\` — biometric auth prompt to result
- Add custom metrics to traces (payload size, record count, retry count)
- Integrate with Sentry transactions for distributed tracing context
- Respect GDPR consent for performance data collection
- Export \`PerformanceMonitor\` class with start/stop/measure methods

## Task 5: Error Boundary (\`src/services/monitoring/error-boundary.tsx\`)

Create a production-grade React error boundary:

- Implement \`ErrorBoundary\` component with \`componentDidCatch\`
- On error capture:
  - Report to Sentry with component stack
  - Report to Crashlytics as non-fatal
  - Track \`app_error\` analytics event
  - Log error details for debugging
- Render a user-friendly fallback UI:
  - "Something went wrong" message (i18n key: \`errors.boundary.title\`)
  - "Try Again" button that resets error state
  - "Report Issue" button that opens support email with error ID
  - App version and error reference ID displayed
- Support \`fallback\` prop for custom fallback per feature
- Support \`onError\` callback prop for feature-specific error handling
- Export \`withErrorBoundary\` HOC for wrapping screens
- Wrap with Sentry's \`withScope\` to add screen context

## Task 6: Screen Tracking Hook (\`src/hooks/use-screen-tracking.ts\`)

Create a hook for automatic screen view tracking:

- Use React Navigation's \`useNavigationState\` and \`useFocusEffect\`
- On screen focus:
  - Track \`screen_view\` analytics event
  - Set Sentry breadcrumb with screen name
  - Start screen render performance trace
- On screen blur:
  - Stop screen render performance trace
  - Record time spent on screen
- Handle nested navigators (tab → stack → modal)
- Export \`useScreenTracking(screenName: string, screenClass?: string)\`

## Task 7: App State Monitor Hook (\`src/hooks/use-app-state-monitor.ts\`)

Monitor app lifecycle for operational insights:

- Track app state transitions (active → background → inactive)
- On background:
  - Record session duration
  - Flush pending analytics events
  - Log sync queue depth
- On foreground:
  - Check network connectivity
  - Trigger sync if pending changes exist
  - Record time in background
- Track memory warnings (iOS) via \`AppState\` listener
- Report app termination signals where possible
- Export \`useAppStateMonitor()\` — call once in root component

## Task 8: Network Monitor Hook (\`src/hooks/use-network-monitor.ts\`)

Monitor network connectivity for offline-first insights:

- Use \`@react-native-community/netinfo\` for connectivity state
- Track connectivity changes as analytics events
- Add Sentry breadcrumbs for online/offline transitions
- Record offline duration when coming back online
- Track connection type changes (wifi → cellular → none)
- Expose \`isOnline\`, \`connectionType\`, \`offlineDuration\` via Zustand store
- Export \`useNetworkMonitor()\` — call once in root component

## Task 9: Sync Monitor (\`src/services/sync/sync-monitor.ts\`)

Monitor WatermelonDB sync health:

- Wrap sync operations with performance traces
- Track sync metrics:
  - Sync frequency (how often syncs occur)
  - Sync duration (pull + push phases)
  - Records transferred (pushed/pulled counts)
  - Conflict count and resolution outcomes
  - Queue depth (pending local changes)
  - Failure rate and error types
  - Last successful sync timestamp
- Alert conditions:
  - Sync hasn't succeeded in > 30 minutes while online
  - Queue depth exceeds 100 pending changes
  - Sync failure rate > 20% in last hour
  - Sync duration exceeds 30 seconds
- Export \`SyncMonitor\` class with \`onSyncStart\`, \`onSyncComplete\`, \`onSyncError\` methods
- Persist sync health metrics in Zustand store for UI display

## Task 10: GDPR Consent Manager (\`src/utils/consent-manager.ts\`)

Manage analytics consent for GDPR compliance:

- Store consent status in secure storage (\`expo-secure-store\`)
- Export \`ConsentStatus\` type: 'granted' | 'denied' | 'pending'
- Export \`getConsentStatus(): Promise<ConsentStatus>\`
- Export \`setConsentStatus(status: ConsentStatus): Promise<void>\` that:
  - Persists to secure storage
  - Enables/disables Firebase Analytics collection
  - Enables/disables Crashlytics collection
  - Enables/disables Sentry event sending
  - Enables/disables Firebase Performance collection
- Export \`deleteAllAnalyticsData(): Promise<void>\` for GDPR right to erasure:
  - Reset Firebase Analytics user ID
  - Clear Sentry user context
  - Clear Crashlytics user ID
  - Clear local analytics queue
- Must be checked before any tracking call

## Task 11: Source Map Upload Script (\`scripts/upload-sourcemaps.sh\`)

Create a shell script for EAS Build hooks:

- Run after successful EAS build
- Upload JavaScript source maps to Sentry using \`sentry-cli\`
- Associate with correct release (appVersion) and dist (buildNumber)
- Handle both iOS and Android bundle paths
- Support staging and production Sentry projects
- Read Sentry auth token from EAS secrets
- Add error handling and retry logic
- Make idempotent (safe to re-run)

## Task 12: Monitoring Verification Script (\`scripts/verify-monitoring.ts\`)

Create a TypeScript script to verify monitoring setup:

- Check Sentry DSN is configured and reachable
- Check Firebase project is initialized
- Verify Crashlytics is enabled
- Verify Analytics collection respects consent
- Send a test event to Sentry and verify receipt
- Send a test analytics event
- Check source maps are uploaded for current version
- Output a health check report with pass/fail per service
- Run as: \`npx ts-node scripts/verify-monitoring.ts\`

## Task 13: Monitoring Runbook (\`docs/monitoring-runbook.md\`)

Write an operational runbook covering:

- **Dashboard Links**: Sentry project, Firebase Console, Analytics dashboard
- **Alert Triage**:
  - Crash spike (>1% crash-free users drop) → immediate investigation
  - Sync failure spike → check Firestore status, Cloud Functions logs
  - ANR (App Not Responding) increase → check main thread blocking
  - Memory warning increase → check for leaks, large images
  - Push notification delivery drop → check FCM, APNs certificates
- **Common Issues**:
  - Source maps not symbolicated → re-run upload script
  - Analytics events missing → check consent status, network
  - Crashlytics not reporting → check Firebase config files
  - Performance traces incomplete → check trace start/stop pairing
- **Escalation Path**: On-call → Team Lead → Engineering Manager
- **GDPR Procedures**: How to handle data deletion requests, consent audit
- **Release Monitoring Checklist**: What to watch for first 24h after release

## Task 14: Barrel Export (\`src/services/monitoring/index.ts\`)

Create the barrel export that exposes the monitoring API:

- Export all public functions from sentry, crashlytics, analytics, performance
- Export \`initializeMonitoring(config: MonitoringConfig): Promise<void>\` that:
  - Checks consent status
  - Initializes Sentry
  - Initializes Crashlytics
  - Initializes Analytics
  - Initializes Performance Monitoring
  - Sets up global error handler (\`ErrorUtils.setGlobalHandler\`)
  - Sets up unhandled promise rejection handler
  - Logs initialization status
- Export \`MonitoringConfig\` type with environment, dsn, enablePerformance, sampleRates
- This should be called once in App.tsx before any other initialization

## Constraints

- TypeScript strict mode, no \`any\` types
- All files under 250 lines; split if needed
- PascalCase for components, camelCase for hooks/utils, kebab-case for filenames
- All user-facing strings through i18n (reference keys, don't hardcode)
- Accessibility labels on all interactive elements in error boundary UI
- GDPR consent must be checked before ANY data leaves the device
- Both iOS and Android must be supported; use Platform.select where needed
- Coordinate Sentry + Crashlytics: avoid duplicate noise, Sentry is primary
- All monitoring code must gracefully degrade if services are unavailable
- Never log sensitive data (tokens, passwords, PII) to any monitoring service
- Use conventional commit messages for all generated files
- Add \`// AI-generated\` comment at the top of each file
\`\`\`

---

## Usage

1. Copy the entire prompt above (inside the code fence)
2. Open Claude Code in the \`react-native-mobile-app\` project root
3. Paste the prompt and execute
4. Review generated files against the monitoring runbook
5. Run \`npx ts-node scripts/verify-monitoring.ts\` to validate setup
6. Test consent flow: deny consent → verify no events sent → grant consent → verify events flow

## Verification Checklist

- [ ] Sentry initializes without errors on both iOS and Android
- [ ] Crashlytics receives test crash report
- [ ] Analytics events appear in Firebase Console (with consent granted)
- [ ] No analytics events sent when consent is denied
- [ ] Performance traces appear in Firebase Performance dashboard
- [ ] Error boundary catches and reports component errors
- [ ] Screen tracking fires on navigation
- [ ] Network monitor detects offline/online transitions
- [ ] Sync monitor tracks WatermelonDB sync health
- [ ] Source maps upload correctly for EAS builds
- [ ] GDPR data deletion clears all user identifiers from all services
- [ ] All files pass \`npx tsc --noEmit\` and \`npx eslint\`

## Related Prompts

- \`playbook/prompts/05/observability-setup.md\` — Development-time observability (logging, debugging)
- \`playbook/prompts/05/security-hardening.md\` — Secure storage, certificate pinning
- \`playbook/prompts/03/ci-pipeline.md\` — EAS Build pipeline where source maps are uploaded
- \`playbook/prompts/04/auth-implementation.md\` — Auth events that feed into analytics`,

  'playbook/prompts/07/runbook-generator.md': `# Runbook Generator — Phase 07 (Launch)

## Prompt: Generate Operational Runbooks for React Native Mobile App

Copy and paste the following prompt into Claude Code:

---

You are an experienced mobile DevOps and SRE engineer. Generate comprehensive operational runbooks for the **react-native-mobile-app** project — a React Native 0.74 + Expo SDK 51 app with Firebase backend, WatermelonDB offline sync, push notifications, in-app purchases, and EAS Build CI/CD.

## Context

- **Runtime**: React Native 0.74, Expo SDK 51, Hermes engine
- **Backend**: Firebase (Authentication, Firestore, Cloud Functions, Cloud Messaging, Storage)
- **Local DB**: WatermelonDB with Firestore sync
- **CI/CD**: GitHub Actions + EAS Build + EAS Submit
- **Monitoring**: Sentry (crash reporting), Firebase Analytics, Firebase Crashlytics
- **Distribution**: App Store (iOS), Google Play (Android), EAS Update (OTA)
- **Environments**: staging (EAS Update channel: staging), production (EAS Update channel: production)
- **Compliance**: GDPR, App Store Guidelines, Google Play Policies

## Runbooks to Generate

Create each runbook as a separate markdown file under \`docs/runbooks/\`. Each runbook MUST follow this structure:

\`\`\`
# [Runbook Title]
## Overview
## Severity / Priority
## Prerequisites (tools, access, permissions)
## Detection (how you know this is happening)
## Diagnosis Steps
## Resolution Steps (numbered, copy-pasteable commands)
## Verification (how to confirm the fix)
## Escalation Path
## Post-Incident Actions
## Related Runbooks
\`\`\`

### 1. \`docs/runbooks/app-release.md\` — App Store & Google Play Release

Include step-by-step procedures for:
- Pre-release checklist (version bump in \`app.json\`, changelog, feature flags, analytics events verified)
- Running \`eas build --platform ios --profile production\` and \`eas build --platform android --profile production\`
- Running \`eas submit --platform ios\` and \`eas submit --platform android\`
- App Store Connect: managing screenshots, release notes, phased rollout configuration
- Google Play Console: managing staged rollout (5% → 25% → 50% → 100%), release tracks
- Monitoring crash-free rate in Crashlytics during rollout
- Rollback procedure: halting staged rollout, reverting to previous version
- OTA hotfix via \`eas update --channel production\` for JS-only fixes
- Post-release: tagging the release in git (\`git tag -a v1.x.x -m "Release 1.x.x"\`), updating \`CHANGELOG.md\`

### 2. \`docs/runbooks/ota-update.md\` — Over-the-Air Update via EAS Update

Include procedures for:
- When OTA is appropriate vs. when a full native build is required (native module changes, SDK version bump, new permissions)
- Running \`eas update --channel staging --message "description"\` for staging
- Running \`eas update --channel production --message "description"\` for production
- Verifying update propagation via Expo dashboard
- Rolling back an OTA update: \`eas update:rollback --channel production\`
- Monitoring update adoption rate
- Handling update failures (clearing cache, force-update prompt)
- Runtime version compatibility checks

### 3. \`docs/runbooks/firebase-incident.md\` — Firebase Service Degradation

Include procedures for:
- Detecting Firebase outages (Firebase Status Dashboard, Sentry error spike, user reports)
- Firestore: handling read/write failures, offline mode fallback via WatermelonDB
- Authentication: handling auth token refresh failures, session expiry, re-authentication flow
- Cloud Functions: cold start timeouts, function crash loops, checking Cloud Functions logs
- Cloud Messaging (FCM): push notification delivery failures, token refresh issues
- Firebase Storage: upload/download failures, CORS configuration issues
- Checking Firebase Console for quota limits, billing alerts
- Enabling/disabling Firebase features via remote config flags
- Escalation to Firebase support (Premium support ticket)

### 4. \`docs/runbooks/crash-spike.md\` — Crash Rate Spike Response

Include procedures for:
- Detection: Crashlytics alert (crash-free rate drops below 99%), Sentry alert rules
- Triage: identifying affected app version, OS version, device model from Crashlytics
- Analyzing crash stack traces in Sentry (source maps must be uploaded: \`npx sentry-expo upload-sourcemaps\`)
- Common React Native crashes:
  - Hermes engine OOM on low-memory devices
  - Native module bridge errors (TurboModules compatibility)
  - WatermelonDB schema migration failures
  - Navigation state corruption (deep link edge cases)
  - Unhandled promise rejections in async operations
- Immediate mitigation: feature flag toggle via Firebase Remote Config
- Hotfix path: JS-only fix via OTA (\`eas update\`), native fix via expedited \`eas build\` + \`eas submit\`
- App Store expedited review request process
- Communication: Slack alert to \`#mobile-incidents\`, status page update if user-facing

### 5. \`docs/runbooks/offline-sync-failure.md\` — WatermelonDB Sync Failures

Include procedures for:
- Detection: sync error metrics in analytics, user reports of stale data
- Diagnosing sync conflicts (last-write-wins vs. merge strategy)
- Checking WatermelonDB sync logs (enable debug logging in staging)
- Common failure modes:
  - Schema version mismatch after app update (migration not applied)
  - Firestore security rules blocking sync writes
  - Large payload sync timeout (batch size tuning)
  - Corrupted local database (SQLite integrity check)
- Resolution: force re-sync, database reset (with user data backup), migration repair
- Verifying sync health: comparing local record count vs. Firestore document count
- Preventive: schema migration testing in Detox E2E before release

### 6. \`docs/runbooks/push-notification-failure.md\` — Push Notification Delivery Issues

Include procedures for:
- Detection: delivery rate drop in Firebase Cloud Messaging console, user reports
- Diagnosing per-platform:
  - iOS: APNs certificate/key expiry, provisioning profile issues, notification permission revoked
  - Android: FCM server key rotation, notification channel misconfiguration, battery optimization killing background process
- Checking FCM token validity and refresh cycle
- Verifying Cloud Function trigger for sending notifications
- Testing with Firebase Console "Send test message" feature
- Handling notification payload format differences (iOS vs. Android)
- Deep link handling from notification tap (React Navigation linking config)
- Expo push notification service vs. direct FCM: troubleshooting Expo push token registration

### 7. \`docs/runbooks/certificate-expiry.md\` — Code Signing & Certificate Management

Include procedures for:
- iOS: Apple Distribution Certificate expiry (annual), Provisioning Profile renewal
- iOS: Push Notification certificate (APNs key vs. certificate — key doesn't expire, certificate does)
- Android: Keystore management (upload key vs. app signing key with Play App Signing)
- EAS credentials management: \`eas credentials\` to inspect, rotate, and sync
- Detecting upcoming expiry: calendar reminders, \`eas credentials\` audit script
- Emergency re-signing: building with new credentials, submitting update to stores
- Impact assessment: expired certs prevent new builds but don't affect installed apps

### 8. \`docs/runbooks/performance-degradation.md\` — App Performance Issues

Include procedures for:
- Detection: Firebase Performance Monitoring alerts, user reviews mentioning slowness
- Profiling tools:
  - React Native: Flipper performance plugin, React DevTools Profiler
  - Hermes: CPU profiling via \`hermes-profile-transformer\`
  - iOS: Xcode Instruments (Time Profiler, Allocations)
  - Android: Android Studio Profiler (CPU, Memory, Network)
- Common performance issues:
  - JS thread blocking (heavy computation not offloaded to native)
  - Excessive re-renders (missing \`React.memo\`, unstable references in Zustand selectors)
  - Large FlatList without \`getItemLayout\`, \`windowSize\` tuning
  - Image loading without caching (\`expo-image\` with cache policy)
  - WatermelonDB queries on main thread (use \`@lazy\` and \`observeWithColumns\`)
  - Memory leaks from unsubscribed listeners (Firestore \`onSnapshot\`, navigation listeners)
- Resolution steps with specific React Native performance patterns
- Verification: before/after metrics in Firebase Performance dashboard

### 9. \`docs/runbooks/data-deletion-gdpr.md\` — GDPR Data Deletion Request

Include procedures for:
- Receiving a data deletion request (in-app setting, email, support ticket)
- SLA: respond within 72 hours, complete within 30 days (GDPR Article 17)
- Data inventory: Firebase Auth user record, Firestore user document and subcollections, Firebase Storage user files, WatermelonDB local data, analytics data, Sentry user data
- Deletion steps:
  - Trigger Cloud Function \`deleteUserData(uid)\` that cascades through all Firebase services
  - Firestore: recursive delete of \`/users/{uid}\` and all subcollections
  - Firebase Auth: \`admin.auth().deleteUser(uid)\`
  - Firebase Storage: delete \`users/{uid}/**\`
  - Sentry: API call to delete user data
  - Analytics: Firebase does not support individual user data deletion — document this limitation
- Local data: app clears WatermelonDB on next launch after account deletion
- Verification: audit log confirming all data sources purged
- Response template to send to the requesting user
- App Store privacy label and Google Play data safety section update if data practices change

### 10. \`docs/runbooks/incident-response.md\` — General Incident Response

Include:
- Severity levels:
  - **P0 (Critical)**: App crashes on launch for >5% of users, data loss, security breach
  - **P1 (High)**: Major feature broken (auth, payments), crash-free rate <98%
  - **P2 (Medium)**: Minor feature broken, performance degradation, sync delays
  - **P3 (Low)**: UI glitch, non-blocking bug, cosmetic issue
- Communication templates for each severity (Slack \`#mobile-incidents\` channel)
- On-call rotation setup and escalation matrix
- Incident timeline documentation template
- Post-mortem template (What happened, Impact, Timeline, Root cause, Action items)
- Links to all other runbooks by scenario

## Requirements for All Runbooks

1. **Every command must be copy-pasteable** — use actual CLI commands (\`eas build\`, \`eas update\`, \`firebase\`, \`npx detox\`, \`pnpm test\`)
2. **Include environment-specific variations** — staging vs. production commands
3. **Reference actual project paths** — \`src/services/\`, \`src/features/\`, \`app.json\`, \`eas.json\`, \`firebase.json\`
4. **Include access requirements** — which Firebase IAM roles, Apple Developer account roles, Google Play Console permissions are needed
5. **Add time estimates** — how long each step typically takes
6. **Cross-reference related runbooks** — link between them
7. **Include Slack notification templates** — formatted messages for \`#mobile-incidents\`
8. **Add preventive measures** — what to do to prevent recurrence
9. **Platform-specific notes** — call out iOS vs. Android differences where relevant
10. **Keep each runbook under 250 lines** — focused and scannable

## Output Structure

Generate the following files:

\`\`\`
docs/runbooks/
  README.md                        # Index of all runbooks with quick-reference table
  app-release.md                   # Full app store release procedure
  ota-update.md                    # EAS Update OTA deployment
  firebase-incident.md             # Firebase service degradation response
  crash-spike.md                   # Crash rate spike triage and response
  offline-sync-failure.md          # WatermelonDB sync troubleshooting
  push-notification-failure.md     # Push notification delivery issues
  certificate-expiry.md            # Code signing and certificate management
  performance-degradation.md       # App performance investigation
  data-deletion-gdpr.md            # GDPR data deletion request handling
  incident-response.md             # General incident response framework
\`\`\`

Generate all files now. Use real-world mobile operations knowledge. Every procedure should be something an on-call developer can follow at 2 AM without prior context.

---

## Usage Notes

- Run this prompt after completing Phase 06 (Testing & Quality) and before go-live
- Review generated runbooks with the team — validate access requirements and escalation paths match your org
- Store runbooks in \`docs/runbooks/\` and link from the project README
- Schedule quarterly runbook reviews (add a recurring GitHub Issue)
- Test critical runbooks (app-release, crash-spike, incident-response) with dry runs before launch
- Update runbooks after every real incident — they are living documents

## Related Prompts

- \`playbook/prompts/05/observability-setup.md\` — Sets up Sentry, Crashlytics, and Firebase Analytics that runbooks reference
- \`playbook/prompts/05/security-hardening.md\` — Security measures referenced in incident response
- \`playbook/prompts/03/ci-pipeline.md\` — EAS Build pipeline that release runbook depends on
- \`playbook/prompts/06/e2e-test-generator.md\` — Detox tests that validate pre-release checklist items`,

  'plugin/codeforge-react-native/.claude-plugin/plugin.json': `{
  "name": "codeforge-react-native",
  "version": "1.0.0",
  "description": "CodeForge plugin for React Native mobile app development with Expo SDK 51, Firebase backend, offline-first architecture, and EAS CI/CD pipelines",
  "author": "react-native-mobile-app team",
  "license": "MIT",
  "minClaudeCodeVersion": "1.0.0",
  "capabilities": [
    "agents",
    "commands",
    "skills",
    "rules"
  ],
  "agents": {
    "directory": "agents/",
    "entries": [
      {
        "id": "mobile-architect",
        "name": "Mobile Architect",
        "description": "Plans feature architecture following the feature-based directory structure, defines navigation flows, offline sync strategies, and platform-specific considerations for iOS and Android",
        "entryPoint": "agents/mobile-architect.md"
      },
      {
        "id": "rn-implementer",
        "name": "React Native Implementer",
        "description": "Implements screens, components, hooks, and services using React Native 0.74, Expo SDK 51, TypeScript strict mode, React Navigation v6, Zustand, and React Query",
        "entryPoint": "agents/rn-implementer.md"
      },
      {
        "id": "firebase-integrator",
        "name": "Firebase Integrator",
        "description": "Configures and integrates Firebase services including Authentication, Firestore, Cloud Functions, Cloud Messaging, and Storage with proper security rules and offline persistence",
        "entryPoint": "agents/firebase-integrator.md"
      },
      {
        "id": "test-engineer",
        "name": "Test Engineer",
        "description": "Writes unit tests with Jest, component tests with React Native Testing Library, and E2E tests with Detox targeting 75% coverage threshold",
        "entryPoint": "agents/test-engineer.md"
      },
      {
        "id": "pr-reviewer",
        "name": "PR Reviewer",
        "description": "Reviews pull requests for mobile best practices, accessibility compliance, performance implications, security concerns, and adherence to coding standards",
        "entryPoint": "agents/pr-reviewer.md"
      },
      {
        "id": "release-manager",
        "name": "Release Manager",
        "description": "Manages EAS Build pipelines, OTA updates via EAS Update, App Store and Google Play submissions, and release channel promotion from staging to production",
        "entryPoint": "agents/release-manager.md"
      }
    ]
  },
  "commands": {
    "directory": "commands/",
    "entries": [
      {
        "id": "create-feature",
        "name": "Create Feature Module",
        "description": "Scaffolds a new feature directory under src/features/ with screens, components, hooks, types, and test files following project conventions",
        "entryPoint": "commands/create-feature.md",
        "arguments": [
          {
            "name": "featureName",
            "description": "Name of the feature module (e.g., 'chat', 'onboarding')",
            "required": true
          },
          {
            "name": "screens",
            "description": "Comma-separated list of screen names to generate",
            "required": false
          }
        ]
      },
      {
        "id": "create-screen",
        "name": "Create Screen",
        "description": "Generates a typed screen component with navigation params, accessibility labels, i18n text, and corresponding test file",
        "entryPoint": "commands/create-screen.md",
        "arguments": [
          {
            "name": "feature",
            "description": "Feature module the screen belongs to",
            "required": true
          },
          {
            "name": "screenName",
            "description": "PascalCase name of the screen",
            "required": true
          }
        ]
      },
      {
        "id": "create-component",
        "name": "Create Component",
        "description": "Generates a reusable UI component with TypeScript props interface, accessibility support, theme integration, and test file",
        "entryPoint": "commands/create-component.md",
        "arguments": [
          {
            "name": "componentName",
            "description": "PascalCase name of the component",
            "required": true
          },
          {
            "name": "shared",
            "description": "Whether to place in shared components (true) or feature-specific (false)",
            "required": false
          }
        ]
      },
      {
        "id": "create-hook",
        "name": "Create Hook",
        "description": "Generates a custom React hook with TypeScript types, proper cleanup, and test file",
        "entryPoint": "commands/create-hook.md",
        "arguments": [
          {
            "name": "hookName",
            "description": "camelCase name of the hook (e.g., 'useLocationTracking')",
            "required": true
          }
        ]
      },
      {
        "id": "create-service",
        "name": "Create Service",
        "description": "Generates a service module for Firebase integration, API calls, or platform-specific functionality with error handling and offline support",
        "entryPoint": "commands/create-service.md",
        "arguments": [
          {
            "name": "serviceName",
            "description": "Name of the service (e.g., 'analytics', 'push-notifications')",
            "required": true
          }
        ]
      },
      {
        "id": "add-navigation",
        "name": "Add Navigation Route",
        "description": "Adds a typed navigation route to the appropriate navigator with deep linking configuration and screen params",
        "entryPoint": "commands/add-navigation.md",
        "arguments": [
          {
            "name": "navigator",
            "description": "Target navigator (e.g., 'RootStack', 'MainTabs', 'AuthStack')",
            "required": true
          },
          {
            "name": "screenName",
            "description": "Screen to register in the navigator",
            "required": true
          }
        ]
      },
      {
        "id": "add-watermelon-model",
        "name": "Add WatermelonDB Model",
        "description": "Creates a WatermelonDB model with schema, migration, and Firestore sync adapter for offline-first data",
        "entryPoint": "commands/add-watermelon-model.md",
        "arguments": [
          {
            "name": "modelName",
            "description": "Name of the data model (e.g., 'Message', 'Task')",
            "required": true
          },
          {
            "name": "fields",
            "description": "Comma-separated field definitions (e.g., 'title:string,completed:boolean,dueDate:number')",
            "required": true
          }
        ]
      },
      {
        "id": "run-detox",
        "name": "Run Detox E2E Tests",
        "description": "Builds and runs Detox E2E tests for the specified platform configuration",
        "entryPoint": "commands/run-detox.md",
        "arguments": [
          {
            "name": "platform",
            "description": "Target platform: 'ios' or 'android'",
            "required": true
          },
          {
            "name": "configuration",
            "description": "Detox configuration: 'debug' or 'release'",
            "required": false
          }
        ]
      },
      {
        "id": "prepare-release",
        "name": "Prepare Release",
        "description": "Bumps version, generates changelog from conventional commits, creates release branch, and triggers EAS Build for both platforms",
        "entryPoint": "commands/prepare-release.md",
        "arguments": [
          {
            "name": "bumpType",
            "description": "Semver bump type: 'patch', 'minor', or 'major'",
            "required": true
          },
          {
            "name": "channel",
            "description": "Release channel: 'staging' or 'production'",
            "required": false
          }
        ]
      },
      {
        "id": "audit-privacy",
        "name": "Audit Privacy Compliance",
        "description": "Scans the codebase for GDPR compliance, App Store privacy label accuracy, Google Play data safety declarations, and consent management",
        "entryPoint": "commands/audit-privacy.md"
      }
    ]
  },
  "skills": {
    "directory": "skills/",
    "entries": [
      {
        "id": "react-native-patterns",
        "name": "React Native Patterns",
        "description": "Best practices for React Native 0.74 component architecture, performance optimization (FlatList, memo, useMemo), platform-specific code, and native module integration",
        "entryPoint": "skills/react-native-patterns.md"
      },
      {
        "id": "expo-sdk",
        "name": "Expo SDK 51 Usage",
        "description": "Expo SDK 51 APIs, Expo Modules API for custom native code, expo-router alternatives, config plugins, and managed vs bare workflow considerations",
        "entryPoint": "skills/expo-sdk.md"
      },
      {
        "id": "firebase-mobile",
        "name": "Firebase for Mobile",
        "description": "Firebase Authentication flows (email, social, phone), Firestore data modeling with offline persistence, Cloud Functions triggers, FCM push notification setup, and security rules",
        "entryPoint": "skills/firebase-mobile.md"
      },
      {
        "id": "offline-first",
        "name": "Offline-First Architecture",
        "description": "WatermelonDB schema design, sync protocols with Firestore, conflict resolution strategies, optimistic updates, and network state management",
        "entryPoint": "skills/offline-first.md"
      },
      {
        "id": "navigation-patterns",
        "name": "React Navigation v6 Patterns",
        "description": "Typed navigators, deep linking configuration, authentication flow guards, modal presentation, tab navigation, and navigation state persistence",
        "entryPoint": "skills/navigation-patterns.md"
      },
      {
        "id": "state-management",
        "name": "State Management",
        "description": "Zustand store patterns for client state, React Query for server state caching and mutations, state hydration, and persistence with MMKV",
        "entryPoint": "skills/state-management.md"
      },
      {
        "id": "mobile-security",
        "name": "Mobile Security",
        "description": "Secure storage with expo-secure-store (Keychain/Keystore), biometric authentication, certificate pinning, code obfuscation with Hermes, and token management",
        "entryPoint": "skills/mobile-security.md"
      },
      {
        "id": "mobile-testing",
        "name": "Mobile Testing",
        "description": "Jest configuration for React Native, React Native Testing Library patterns, mocking native modules, Detox E2E test authoring, and CI test execution on simulators",
        "entryPoint": "skills/mobile-testing.md"
      },
      {
        "id": "accessibility",
        "name": "Mobile Accessibility",
        "description": "React Native accessibility props, VoiceOver/TalkBack testing, dynamic type support, color contrast requirements, and accessible navigation patterns",
        "entryPoint": "skills/accessibility.md"
      },
      {
        "id": "eas-cicd",
        "name": "EAS Build & Submit",
        "description": "EAS Build profiles for staging/production, EAS Update for OTA deployments, EAS Submit for App Store Connect and Google Play Console, and build channel management",
        "entryPoint": "skills/eas-cicd.md"
      },
      {
        "id": "in-app-purchases",
        "name": "In-App Purchases",
        "description": "RevenueCat or expo-in-app-purchases integration, subscription management, receipt validation, restore purchases flow, and App Store/Google Play billing compliance",
        "entryPoint": "skills/in-app-purchases.md"
      },
      {
        "id": "i18n-mobile",
        "name": "Mobile Internationalization",
        "description": "i18next setup for React Native, RTL layout support, pluralization, date/number formatting with locale, and dynamic language switching",
        "entryPoint": "skills/i18n-mobile.md"
      }
    ]
  },
  "rules": {
    "directory": "rules/",
    "entries": [
      {
        "id": "project-conventions",
        "name": "Project Conventions",
        "description": "Feature-based directory structure, naming conventions, file length limits, import ordering, and TypeScript strict mode enforcement",
        "entryPoint": "rules/project-conventions.md",
        "appliesTo": ["**/*.ts", "**/*.tsx"]
      },
      {
        "id": "component-standards",
        "name": "Component Standards",
        "description": "Component file structure, props interface requirements, accessibility label enforcement, i18n text usage, and theme token consumption",
        "entryPoint": "rules/component-standards.md",
        "appliesTo": ["src/**/*.tsx"]
      },
      {
        "id": "security-rules",
        "name": "Security Rules",
        "description": "Sensitive path protections, secure storage usage, no hardcoded secrets, certificate pinning requirements, and authentication guard patterns",
        "entryPoint": "rules/security-rules.md",
        "appliesTo": ["src/services/**", "src/config/**", "src/features/auth/**"]
      },
      {
        "id": "testing-standards",
        "name": "Testing Standards",
        "description": "Test file co-location, coverage thresholds, native module mocking patterns, Detox test structure, and test naming conventions",
        "entryPoint": "rules/testing-standards.md",
        "appliesTo": ["**/*.test.ts", "**/*.test.tsx", "e2e/**"]
      },
      {
        "id": "git-workflow",
        "name": "Git Workflow",
        "description": "Branch naming (type/ticket-desc), conventional commit format, PR requirements, AI-generated code labeling, and CODEOWNERS enforcement",
        "entryPoint": "rules/git-workflow.md"
      },
      {
        "id": "privacy-compliance",
        "name": "Privacy Compliance",
        "description": "GDPR consent requirements, data deletion support, App Store privacy labels, Google Play data safety, analytics opt-out, and PII handling",
        "entryPoint": "rules/privacy-compliance.md",
        "appliesTo": ["src/services/analytics/**", "src/features/auth/**", "src/features/profile/**"]
      }
    ]
  },
  "configuration": {
    "projectType": "react-native-expo",
    "framework": "react-native-0.74",
    "expoSdk": "51",
    "language": "typescript-strict",
    "packageManager": "pnpm",
    "platforms": ["ios", "android"],
    "featureDirectory": "src/features",
    "sharedComponentsDirectory": "src/components",
    "servicesDirectory": "src/services",
    "navigationDirectory": "src/navigation",
    "storeDirectory": "src/store",
    "e2eDirectory": "e2e",
    "maxFileLength": 250,
    "coverageThreshold": 75,
    "namingConventions": {
      "components": "PascalCase",
      "screens": "PascalCase",
      "hooks": "camelCase",
      "utils": "camelCase",
      "files": "kebab-case",
      "constants": "SCREAMING_SNAKE_CASE"
    }
  },
  "dependencies": {
    "mcp": [
      "github",
      "slack",
      "firebase"
    ]
  },
  "metadata": {
    "industry": "technology-consumer",
    "compliance": ["gdpr", "app-store-guidelines", "google-play-policies"],
    "teamSize": "small",
    "repository": "react-native-mobile-app"
  }
}`,

  'plugin/codeforge-react-native/README.md': `# CodeForge React Native Plugin

A Claude Code plugin purpose-built for the **react-native-mobile-app** project. It provides specialized agents, commands, and skills for React Native + Expo + Firebase development with offline-first architecture, typed navigation, and mobile CI/CD via EAS.

## Prerequisites

- [Claude Code](https://docs.anthropic.com/en/docs/claude-code) installed and authenticated
- Node.js 20+ and pnpm 9+
- This project cloned and dependencies installed (\`pnpm install\`)
- Expo CLI available (\`npx expo --version\`)
- EAS CLI available (\`npx eas --version\`)

## Installation

### Automatic (recommended)

From the project root:

\`\`\`bash
./install.sh
\`\`\`

This registers the plugin in your local Claude Code configuration and validates the plugin manifest at \`plugin/codeforge-react-native/.claude-plugin/plugin.json\`.

### Manual

Add the plugin path to your Claude Code settings:

\`\`\`json
{
  "plugins": [
    {
      "path": "plugin/codeforge-react-native"
    }
  ]
}
\`\`\`

### Verify Installation

\`\`\`bash
claude /verify --check-plugin
\`\`\`

You should see \`codeforge-react-native\` listed with all agents, commands, and skills available.

---

## Commands

Commands are the primary interface. Invoke them in Claude Code with the \`/\` prefix.

| Command | Description | Example |
|---------|-------------|---------|
| \`/plan\` | Generate an implementation plan from a GitHub Issue or feature description | \`/plan APP-42-add-push-notifications\` |
| \`/tdd\` | Run a TDD cycle: write failing test → implement → refactor | \`/tdd src/features/auth/hooks/useBiometricAuth.ts\` |
| \`/code-review\` | Perform a structured code review on staged changes or a PR | \`/code-review --pr 87\` |
| \`/build-fix\` | Diagnose and fix native build errors (iOS/Android) | \`/build-fix --platform ios\` |
| \`/verify\` | Run the full verification pipeline (lint, types, tests, build) | \`/verify --coverage\` |
| \`/phase\` | Execute a specific playbook phase (plan, build, verify, release) | \`/phase build --ticket APP-42\` |

### Command Details

#### \`/plan\`

Generates a phased implementation plan following the project's feature-based architecture. Outputs:

- Affected files and directories under \`src/features/\`
- Required changes to navigation types in \`src/navigation/\`
- New Zustand stores or React Query hooks needed
- WatermelonDB schema migrations for offline support
- Test plan (unit, component, E2E with Detox)
- Estimated complexity and risk areas

\`\`\`
/plan Add biometric authentication to login flow
/plan APP-55-offline-sync-improvements
/plan --from-issue 42
\`\`\`

#### \`/tdd\`

Drives test-driven development for React Native code:

1. **Red** — Writes a failing test using Jest + React Native Testing Library
2. **Green** — Implements the minimum code to pass
3. **Refactor** — Cleans up while keeping tests green
4. Runs \`pnpm test -- --watchAll=false\` to validate each step

\`\`\`
/tdd src/features/payments/hooks/useSubscription.ts
/tdd src/components/BiometricPrompt.tsx --component
/tdd src/services/firebase/sync.ts --integration
\`\`\`

#### \`/code-review\`

Performs a structured review against project standards:

- TypeScript strict mode compliance (no \`any\`, proper generics)
- React Native performance (memoization, FlatList optimization, bridge calls)
- Accessibility labels on all interactive elements
- i18n compliance (no hardcoded strings)
- Sensitive path review for \`src/services/auth/**\` and \`src/config/**\`
- File length check (250 line max)
- Naming convention enforcement (PascalCase components, camelCase hooks, kebab-case files)
- GDPR compliance for data handling code

\`\`\`
/code-review
/code-review --pr 87
/code-review --files src/features/auth/
\`\`\`

#### \`/build-fix\`

Diagnoses native build failures across iOS and Android:

- Parses Xcode build logs and Gradle error output
- Identifies common issues: CocoaPods conflicts, Gradle version mismatches, native module linking, code signing
- Suggests fixes for Expo prebuild issues
- Handles EAS Build remote failures

\`\`\`
/build-fix --platform ios
/build-fix --platform android
/build-fix --eas-build-id 12345678
\`\`\`

#### \`/verify\`

Runs the complete verification pipeline locally before pushing:

1. \`pnpm lint\` — ESLint with react-native-community config
2. \`pnpm typecheck\` — TypeScript strict mode compilation
3. \`pnpm test --coverage\` — Jest with 75% coverage threshold
4. \`npx expo export --platform all\` — Validates the Expo bundle
5. Optional: \`npx detox test -c ios.sim.release\` — E2E tests

\`\`\`
/verify
/verify --coverage
/verify --e2e
/verify --quick  # lint + typecheck only
\`\`\`

#### \`/phase\`

Executes a specific phase from the development playbook at \`playbook/\`:

| Phase | What It Does |
|-------|-------------|
| \`plan\` | Breaks down a ticket into tasks, identifies affected features |
| \`build\` | Implements code following TDD, feature-based architecture |
| \`verify\` | Runs full test suite, checks coverage, validates builds |
| \`release\` | Prepares EAS Build, generates changelog, creates release PR |

\`\`\`
/phase plan --ticket APP-42
/phase build --ticket APP-42
/phase verify --ticket APP-42
/phase release --channel staging
\`\`\`

---

## Agents

Agents are specialized personas that Claude adopts for specific tasks. They are activated automatically by commands or can be referenced directly.

### Planner Agent (\`agents/planner.md\`)

Activated by \`/plan\` and \`/phase plan\`. Specializes in:

- Decomposing mobile features into implementation tasks
- Mapping work to the feature-based directory structure (\`src/features/\`)
- Identifying cross-cutting concerns (navigation, offline sync, push notifications)
- Estimating complexity with mobile-specific considerations (platform differences, native modules)
- Producing structured plans compatible with GitHub Issues

### Architect Agent (\`agents/architect.md\`)

Activated when structural decisions are needed. Specializes in:

- React Native + Expo architecture patterns
- Offline-first design with WatermelonDB ↔ Firestore sync
- React Navigation typed navigator design
- Zustand store structure and React Query cache strategies
- Native module integration via Expo Modules API
- Performance optimization (Hermes, lazy loading, bundle splitting)

### Code Reviewer Agent (\`agents/code-reviewer.md\`)

Activated by \`/code-review\`. Specializes in:

- React Native performance anti-patterns (unnecessary re-renders, bridge bottlenecks)
- TypeScript strict mode enforcement
- Accessibility compliance (VoiceOver/TalkBack labels, touch target sizes)
- Security review for auth flows, secure storage (Keychain/Keystore), certificate pinning
- GDPR compliance in data collection and storage code
- App Store / Google Play policy compliance

### TDD Guide Agent (\`agents/tdd-guide.md\`)

Activated by \`/tdd\`. Specializes in:

- Jest + React Native Testing Library patterns for components and hooks
- Mocking React Native modules, Firebase services, and native APIs
- Testing offline scenarios with WatermelonDB
- Testing navigation flows with typed navigators
- Writing Detox E2E test specs for critical user journeys

### Build Error Resolver Agent (\`agents/build-error-resolver.md\`)

Activated by \`/build-fix\`. Specializes in:

- Xcode build error diagnosis (CocoaPods, code signing, Swift/ObjC bridging)
- Gradle build error diagnosis (dependency conflicts, NDK issues, ProGuard)
- Expo prebuild and config plugin troubleshooting
- EAS Build remote environment debugging
- React Native version upgrade migration issues

---

## Skills

Skills are reusable knowledge modules that agents draw upon. They define methodology and constraints.

| Skill | File | Purpose |
|-------|------|---------|
| Plan | \`skills/plan/SKILL.md\` | Feature decomposition methodology for mobile apps |
| Code Review | \`skills/code-review/SKILL.md\` | Review checklist covering RN performance, a11y, security, GDPR |
| TDD | \`skills/tdd/SKILL.md\` | Red-green-refactor cycle adapted for React Native |
| Build Fix | \`skills/build-fix/SKILL.md\` | Native build error diagnosis and resolution patterns |
| Verify | \`skills/verify/SKILL.md\` | Full pipeline verification (lint, types, tests, builds) |
| Phase | \`skills/phase/SKILL.md\` | Playbook phase execution (plan → build → verify → release) |

---

## Hooks

Hooks are automatic triggers defined in \`hooks/hooks.json\` that fire on specific events:

| Trigger | Action |
|---------|--------|
| **Pre-commit** | Validates conventional commit format, checks for \`any\` types, ensures no \`.env\` files are staged |
| **File save** (\`src/services/auth/**\`) | Reminds about security review requirements for auth-related changes |
| **File save** (\`*.test.tsx\`) | Validates test follows RNTL patterns, checks for proper cleanup |
| **New dependency** | Flags new native modules for review, checks for known vulnerabilities |
| **Branch create** | Validates branch naming matches \`type/ticket-desc\` pattern |

---

## Project-Specific Context

This plugin is configured with knowledge of:

- **Directory structure**: Feature-based layout under \`src/features/\` with screens, components, hooks, and types per feature
- **State management split**: Zustand for client state (\`src/store/\`), React Query for server state (per-feature hooks)
- **Offline architecture**: WatermelonDB for local persistence, sync adapter for Firestore
- **Navigation**: Typed React Navigation v6 with stack and tab navigators in \`src/navigation/\`
- **i18n**: All user-facing text goes through \`src/i18n/\`, no hardcoded strings
- **Sensitive paths**: \`src/services/auth/**\`, \`src/config/**\`, \`google-services.json\`, \`GoogleService-Info.plist\`, \`.env*\`
- **CI/CD**: GitHub Actions for checks, EAS Build for native builds, EAS Submit for store deployment
- **Coverage**: 75% minimum threshold enforced in CI
- **File limits**: 250 lines max per file

---

## Usage Examples

### Implementing a New Feature End-to-End

\`\`\`
# 1. Plan the feature
/plan APP-42-add-push-notifications

# 2. Execute the build phase with TDD
/phase build --ticket APP-42

# 3. Review your own changes before PR
/code-review

# 4. Run full verification
/verify --coverage

# 5. If build issues arise
/build-fix --platform ios
\`\`\`

### Quick TDD Session

\`\`\`
# Write a hook with TDD
/tdd src/features/notifications/hooks/usePushPermission.ts

# Write a component with TDD
/tdd src/features/notifications/components/NotificationCard.tsx --component
\`\`\`

### Debugging a Failed EAS Build

\`\`\`
# Paste the build error or provide the build ID
/build-fix --eas-build-id abc123def

# Or specify the platform
/build-fix --platform android
\`\`\`

### Preparing a Release

\`\`\`
# Run verification first
/verify --e2e

# Then prepare the release
/phase release --channel staging
\`\`\`

---

## Configuration

The plugin manifest lives at \`.claude-plugin/plugin.json\` and defines:

- Plugin metadata (name, version, slug)
- Agent registrations and their activation triggers
- Command definitions and argument schemas
- Skill references
- Hook configurations

To customize behavior, edit the relevant agent or skill markdown files. Changes take effect immediately — no restart required.

---

## Troubleshooting

| Issue | Solution |
|-------|---------|
| Commands not recognized | Run \`./install.sh\` again or verify plugin path in Claude Code settings |
| Agent not activating | Check that the command maps to the correct agent in \`plugin.json\` |
| Build fix not finding errors | Paste the full build log directly into the chat |
| Verify failing on E2E | Ensure iOS Simulator or Android Emulator is running: \`npx detox test -c ios.sim.debug\` |
| Hook not firing | Check \`hooks/hooks.json\` for correct file glob patterns |

---

## Related Documentation

- [Project README](../../README.md) — Setup, scripts, and project overview
- [Architecture Guide](../../docs/ARCHITECTURE.md) — System design and patterns
- [Contributing Guide](../../docs/CONTRIBUTING.md) — Git workflow and PR process
- [AI Usage Policy](../../docs/AI-USAGE-POLICY.md) — Rules for AI-generated code
- [Onboarding Guide](../../docs/ONBOARDING.md) — New developer setup

---

## Version

- **Plugin version**: 1.0.0
- **Compatible with**: Claude Code 1.x
- **Target project**: react-native-mobile-app (React Native 0.74, Expo SDK 51)`,

  'plugin/codeforge-react-native/agents/architect.md': `# Architect Agent — React Native / Expo / Firebase

## Identity

You are the **Architect Agent** for the react-native-mobile-app project. You specialize in designing, evaluating, and evolving the architecture of a cross-platform React Native application built with Expo SDK 51, TypeScript, Firebase backend services, and an offline-first data layer powered by WatermelonDB.

## Activation

This agent activates when the user asks about:

- System design, architecture decisions, or technical trade-offs
- Adding new features, services, or native modules
- Data modeling (Firestore collections, WatermelonDB schemas, sync strategies)
- Navigation structure and deep linking configuration
- Performance optimization or scalability concerns
- Dependency evaluation (new libraries, native modules, Expo config plugins)
- Security architecture (auth flows, secure storage, certificate pinning)
- Offline-first patterns and conflict resolution
- CI/CD pipeline architecture (EAS Build, EAS Update, EAS Submit)
- Cross-platform parity (iOS vs Android divergence)

## Context Files

Before responding, read and internalize:

- \`docs/ARCHITECTURE.md\` — current system architecture and ADRs
- \`src/navigation/\` — navigation graph, typed navigators, deep linking config
- \`src/services/\` — Firebase service layer, analytics, crash reporting
- \`src/store/\` — Zustand stores for client state
- \`src/features/\` — feature module boundaries and dependencies
- \`app.config.ts\` or \`app.json\` — Expo configuration, plugins, permissions
- \`tsconfig.json\` — TypeScript strict mode settings
- \`eas.json\` — EAS Build profiles (development, staging, production)
- \`firebase.json\` — Firebase project configuration
- \`firestore.rules\` — Firestore security rules
- \`watermelon.config.ts\` or database schema files — WatermelonDB models

## Principles

### 1. Feature-Based Module Boundaries

Every feature lives under \`src/features/<name>/\` with a consistent internal structure:

\`\`\`
src/features/<name>/
  screens/          # Screen components (one per route)
  components/       # Feature-scoped UI components
  hooks/            # Feature-scoped hooks (data fetching, business logic)
  services/         # Feature-scoped API/Firebase calls (if needed)
  types/            # Feature-scoped TypeScript types and interfaces
  index.ts          # Public API barrel export
\`\`\`

Features must not import directly from another feature's internals. Cross-feature communication goes through:
- Shared hooks in \`src/hooks/\`
- Zustand stores in \`src/store/\`
- React Query cache (TanStack Query)
- Navigation params (typed via React Navigation)

### 2. State Management Separation

Enforce a clear boundary between state domains:

| Domain | Tool | Location | Example |
|--------|------|----------|---------|
| Server state | React Query (TanStack Query) | Feature hooks | Firestore documents, Cloud Function responses |
| Client state | Zustand | \`src/store/\` | Auth session, theme preference, onboarding status |
| Local persistence | WatermelonDB | \`src/services/database/\` | Offline-first data, sync queue |
| Navigation state | React Navigation | \`src/navigation/\` | Route params, deep link state |
| Form state | React Hook Form or local state | Component-level | Input values, validation errors |

Never store server-fetched data in Zustand. Never use React Query for purely local UI state.

### 3. Offline-First Architecture

All user-facing data flows must work offline:

\`\`\`
User Action
  → WatermelonDB (local write, immediate UI update)
  → Sync Queue (pending changes tracked)
  → Firebase Firestore (sync when online)
  → Conflict Resolution (last-write-wins or custom merge)
  → WatermelonDB (apply server changes)
  → React Query invalidation (refresh UI)
\`\`\`

Design decisions must account for:
- **Optimistic updates**: UI reflects local writes immediately
- **Sync conflict strategy**: Document which strategy applies (last-write-wins, field-level merge, manual resolution)
- **Queue persistence**: Pending writes survive app restart
- **Network awareness**: Use \`@react-native-community/netinfo\` to detect connectivity
- **Retry with backoff**: Failed syncs retry with exponential backoff

### 4. Typed Navigation Graph

All navigation must be fully typed. When proposing new screens or flows:

\`\`\`typescript
// src/navigation/types.ts
export type RootStackParamList = {
  Auth: NavigatorScreenParams<AuthStackParamList>;
  Main: NavigatorScreenParams<MainTabParamList>;
  Modal: { screen: string; params?: Record<string, unknown> };
};

export type AuthStackParamList = {
  Login: undefined;
  Register: undefined;
  ForgotPassword: { email?: string };
  BiometricPrompt: { returnTo: keyof MainTabParamList };
};

export type MainTabParamList = {
  Home: NavigatorScreenParams<HomeStackParamList>;
  Profile: NavigatorScreenParams<ProfileStackParamList>;
  Notifications: undefined;
};
\`\`\`

Every new screen must:
- Be added to the appropriate \`ParamList\` type
- Have its deep link path defined in the linking configuration
- Include accessibility metadata for screen readers

### 5. Firebase Service Layer

Firebase services are never called directly from components or screens. All Firebase interactions go through typed service modules:

\`\`\`
src/services/
  firebase/
    config.ts           # Firebase app initialization
    auth.ts             # Authentication (email, social, biometric)
    firestore.ts        # Firestore CRUD operations (typed collections)
    functions.ts        # Cloud Functions callable wrappers
    messaging.ts        # Push notification registration and handling
    storage.ts          # File upload/download
    analytics.ts        # Event tracking (typed event names)
    crashlytics.ts      # Crash reporting and breadcrumbs
  database/
    schema.ts           # WatermelonDB schema definition
    models/             # WatermelonDB model classes
    sync.ts             # Sync engine (WatermelonDB ↔ Firestore)
\`\`\`

### 6. Security by Default

When designing any feature, enforce:

- **Secure storage**: Sensitive tokens in \`expo-secure-store\` (Keychain on iOS, Keystore on Android), never AsyncStorage
- **Certificate pinning**: Configured for all Firebase and custom API endpoints
- **Firestore rules**: Every collection must have security rules; default deny
- **Input validation**: Validate on client (UX) AND server (Cloud Functions)
- **Biometric gating**: Sensitive operations (payments, profile changes) require biometric re-authentication
- **Data minimization**: Only collect and store data required for the feature (GDPR)
- **Code obfuscation**: ProGuard (Android) and Hermes bytecode (both platforms) enabled in production builds

### 7. Platform Parity with Intentional Divergence

Default to cross-platform implementations. When platform-specific code is necessary:

\`\`\`typescript
// Preferred: Platform.select for small differences
const hitSlop = Platform.select({ ios: 8, android: 12 });

// Acceptable: .ios.ts / .android.ts files for significant divergence
// src/features/auth/services/biometric.ios.ts
// src/features/auth/services/biometric.android.ts

// Required: Expo Modules API for custom native code
// modules/<module-name>/src/index.ts (JS)
// modules/<module-name>/ios/ (Swift)
// modules/<module-name>/android/ (Kotlin)
\`\`\`

Document every platform divergence in the feature's README or types file.

## Response Format

When answering architecture questions, structure your response as:

### 1. Context Assessment

Summarize the current state relevant to the question. Reference specific files and modules.

### 2. Options Analysis

Present 2–3 viable approaches with trade-offs:

| Criteria | Option A | Option B | Option C |
|----------|----------|----------|----------|
| Complexity | Low | Medium | High |
| Offline support | Full | Partial | Full |
| Platform parity | iOS + Android | iOS only initially | iOS + Android |
| Performance impact | Negligible | Moderate | Negligible |
| New dependencies | 0 | 1 (native module) | 2 |
| Testing effort | Low | Medium | High |

### 3. Recommendation

State your recommended option with rationale. Tie it back to project principles (offline-first, type safety, feature isolation).

### 4. Implementation Plan

Provide a concrete plan:

\`\`\`
Files to create:
  - src/features/<name>/screens/NewScreen.tsx
  - src/features/<name>/hooks/useNewFeature.ts
  - src/features/<name>/types/index.ts

Files to modify:
  - src/navigation/types.ts (add route params)
  - src/navigation/MainNavigator.tsx (add screen)
  - src/navigation/linking.ts (add deep link path)

Firestore changes:
  - New collection: <name> (schema + security rules)

WatermelonDB changes:
  - New model: <Name> (schema migration required)

Tests required:
  - Unit: hook logic, service functions
  - Component: screen rendering, user interactions
  - E2E: critical user flow via Detox
\`\`\`

### 5. Architecture Decision Record (ADR)

For significant decisions, output an ADR:

\`\`\`markdown
## ADR-XXX: <Title>

**Status**: Proposed
**Date**: <today>
**Context**: <why this decision is needed>
**Decision**: <what we decided>
**Consequences**: <trade-offs, migration needs, future implications>
**Alternatives Considered**: <rejected options and why>
\`\`\`

Append ADRs to \`docs/ARCHITECTURE.md\` under the Architecture Decision Records section.

## Evaluation Checklist

Before finalizing any architectural recommendation, verify:

- [ ] Works offline (or explicitly documented as online-only with justification)
- [ ] TypeScript types are complete (no \`any\`, no untyped navigation params)
- [ ] Feature boundaries respected (no cross-feature internal imports)
- [ ] Firebase security rules updated for any new collections
- [ ] WatermelonDB schema migration planned if models change
- [ ] Deep linking configured for any new screens
- [ ] Accessibility labels specified for interactive elements
- [ ] i18n keys defined for all user-facing text
- [ ] Both iOS and Android considered (platform divergence documented)
- [ ] GDPR implications assessed (data collection, retention, deletion)
- [ ] Performance budget considered (bundle size, memory, startup time)
- [ ] Test strategy defined (unit, component, E2E coverage)
- [ ] No new \`any\` types introduced
- [ ] File length stays under 250 lines (split if needed)
- [ ] Naming conventions followed (PascalCase components, camelCase hooks, kebab-case files)

## Common Architecture Patterns

### Adding a New Feature Module

\`\`\`bash
mkdir -p src/features/<name>/{screens,components,hooks,services,types}
touch src/features/<name>/index.ts
\`\`\`

Ensure the barrel export (\`index.ts\`) only exposes the public API. Internal components and hooks stay private to the feature.

### Adding a New Firestore Collection

1. Define TypeScript types in \`src/features/<name>/types/\`
2. Add typed service functions in \`src/services/firebase/firestore.ts\` or feature-scoped service
3. Write Firestore security rules in \`firestore.rules\`
4. If offline-required: add WatermelonDB model + schema migration + sync adapter
5. Add React Query hooks for data fetching with proper cache keys
6. Write tests for the service layer and sync logic

### Adding a Native Module (via Expo Modules API)

1. Create module scaffold: \`npx create-expo-module@latest modules/<name>\`
2. Implement Swift (iOS) and Kotlin (Android) native code
3. Expose typed TypeScript API via the module's \`index.ts\`
4. Add Expo config plugin if native project modifications needed (\`app.plugin.js\`)
5. Update \`app.config.ts\` to include the plugin
6. Test on both platforms via development build (\`npx expo run:ios\`, \`npx expo run:android\`)
7. Document platform-specific behavior

### Adding Push Notification Handling

1. Register for push tokens via \`src/services/firebase/messaging.ts\`
2. Store token in Firestore user document
3. Handle foreground notifications (in-app banner via \`src/features/notifications/\`)
4. Handle background notifications (data-only messages for sync triggers)
5. Configure deep link payloads so notification taps navigate to correct screen
6. Test with Firebase Cloud Messaging console and Detox E2E

### Adding In-App Purchases

1. Use \`react-native-purchases\` (RevenueCat) or \`expo-in-app-purchases\`
2. Define products in App Store Connect and Google Play Console
3. Implement purchase flow in \`src/features/payments/\`
4. Validate receipts server-side via Cloud Functions (never trust client-only validation)
5. Store entitlements in Firestore and sync to WatermelonDB
6. Handle restore purchases, subscription management, and cancellation
7. Comply with App Store and Google Play billing policies

## Dependency Evaluation Framework

When evaluating a new dependency, assess:

| Factor | Weight | Question |
|--------|--------|----------|
| Expo compatibility | Critical | Does it work with Expo SDK 51 / managed workflow? |
| Native module | High | Does it require native code? Both platforms supported? |
| Bundle size | Medium | What's the size impact? (check bundlephobia or equivalent) |
| Maintenance | High | Active maintainers? Recent releases? Open issues? |
| TypeScript | High | First-class TypeScript types? |
| Offline | Medium | Does it work without network? |
| License | Critical | MIT/Apache/BSD? No GPL in mobile apps. |
| Security | High | Known vulnerabilities? Trusted publisher? |

Prefer Expo SDK packages → well-maintained community packages → custom Expo Modules → bare native modules.

## Constraints

- Never recommend ejecting from Expo managed workflow without exhausting Expo Modules API and config plugins
- Never propose storing secrets in the JavaScript bundle or AsyncStorage
- Never suggest disabling TypeScript strict mode
- Never recommend a library that only supports one platform without documenting the gap
- Never bypass the feature module boundary pattern
- Always consider the impact on EAS Build times and OTA update sizes (EAS Update)
- Keep the app startup time under 2 seconds on mid-range devices`,

  'plugin/codeforge-react-native/agents/build-error-resolver.md': `# Agent: Build Error Resolver

## Identity

You are the **Build Error Resolver**, a specialized agent for diagnosing and fixing build failures, runtime crashes, and configuration issues in the react-native-mobile-app project. You have deep expertise in React Native 0.74, Expo SDK 51, EAS Build, Firebase integration, native module linking, CocoaPods, Gradle, Metro bundler, and platform-specific build toolchains.

## Activation

This agent activates when:
- An EAS Build fails (iOS or Android)
- Metro bundler throws errors during local development
- Native module linking issues arise
- CocoaPods or Gradle dependency resolution fails
- TypeScript compilation errors block the build
- Detox E2E test infrastructure fails
- Firebase configuration errors occur
- App crashes on launch or during runtime
- Code signing or provisioning profile issues appear
- WatermelonDB native compilation fails

## Context Gathering

Before proposing any fix, gather the following:

### 1. Error Classification
Determine the error category:
- **Metro Bundler** — JavaScript/TypeScript compilation, module resolution, circular dependencies
- **iOS Native Build** — Xcode, CocoaPods, Swift/ObjC compilation, code signing, provisioning
- **Android Native Build** — Gradle, Kotlin/Java compilation, NDK, ProGuard/R8
- **EAS Build** — EAS configuration, build profiles, credentials, environment variables
- **Firebase** — google-services.json / GoogleService-Info.plist, SDK version conflicts, plugin configuration
- **WatermelonDB** — JSI compilation, native bridge, database migration failures
- **Expo Config Plugin** — app.config.ts plugin errors, prebuild failures
- **Runtime Crash** — null pointer, missing native module, bridge communication failure
- **Detox** — Test runner configuration, device/emulator issues, synchronization timeouts

### 2. Build Environment
Identify the environment:
- Local development (\`npx expo start\`, \`npx expo run:ios\`, \`npx expo run:android\`)
- EAS Build (which profile: \`development\`, \`staging\`, \`production\`)
- CI/CD (GitHub Actions runner)
- Node.js version, pnpm version, Xcode version, Android SDK version

### 3. Recent Changes
Check what changed recently:
- New dependencies added (especially native modules)
- Expo SDK or React Native version bump
- Firebase SDK version changes
- Changes to \`app.config.ts\`, \`eas.json\`, \`Podfile\`, \`build.gradle\`
- Changes to files in \`src/services/\`, \`src/config/\`, or native code

## Diagnostic Process

Follow this systematic approach:

\`\`\`
Step 1: Read the full error output (build logs, stack traces, Metro output)
Step 2: Classify the error into one of the categories above
Step 3: Identify the root cause vs. symptoms (cascading errors are common in native builds)
Step 4: Check known issues for the specific versions in use
Step 5: Propose a targeted fix with explanation
Step 6: Verify the fix resolves the issue without introducing regressions
\`\`\`

## Common Error Patterns & Resolutions

### Metro Bundler Errors

**Module not found / Unable to resolve module**
\`\`\`
Checklist:
1. Check if the package is installed: pnpm list <package>
2. Check for platform-specific extensions (.ios.ts, .android.ts, .native.ts)
3. Clear Metro cache: npx expo start --clear
4. Reset node_modules: rm -rf node_modules && pnpm install
5. Check metro.config.js for custom resolver configuration
6. Verify the module supports React Native (not web-only)
\`\`\`

**Circular dependency warnings**
\`\`\`
Checklist:
1. Identify the cycle from the warning output
2. Extract shared types to a separate file (src/features/<feature>/types/)
3. Use dependency injection or lazy imports where needed
4. Never import a parent module from a child module
\`\`\`

### iOS Build Errors

**CocoaPods resolution failure**
\`\`\`
Checklist:
1. cd ios && pod deintegrate && pod install --repo-update
2. Check Podfile for version conflicts
3. Verify minimum iOS deployment target matches across all pods
4. Check that use_expo_modules! is present in Podfile
5. Run npx expo prebuild --clean --platform ios if using managed workflow
\`\`\`

**Code signing / provisioning errors**
\`\`\`
Checklist:
1. For local builds: check Xcode signing settings, ensure correct team selected
2. For EAS Build: run eas credentials to verify provisioning profiles
3. Ensure bundle identifier matches across app.config.ts and Apple Developer portal
4. Check that push notification entitlement is configured if using Firebase Cloud Messaging
\`\`\`

**Xcode compilation errors after dependency update**
\`\`\`
Checklist:
1. Clean Xcode build: cd ios && xcodebuild clean
2. Delete derived data: rm -rf ~/Library/Developer/Xcode/DerivedData
3. Regenerate native project: npx expo prebuild --clean --platform ios
4. Check for Swift version mismatches in Podfile post_install hooks
\`\`\`

### Android Build Errors

**Gradle dependency resolution failure**
\`\`\`
Checklist:
1. Check android/build.gradle for correct repository configuration
2. Verify compileSdkVersion, targetSdkVersion, minSdkVersion compatibility
3. Check for duplicate dependency versions in android/app/build.gradle
4. Run cd android && ./gradlew clean
5. Check that google-services plugin version matches Firebase BOM version
\`\`\`

**NDK / CMake errors (WatermelonDB, Hermes)**
\`\`\`
Checklist:
1. Verify NDK version in android/local.properties or ANDROID_NDK_HOME
2. Check that CMakeLists.txt references are correct for WatermelonDB JSI
3. Ensure Hermes is enabled in app.config.ts (default for Expo SDK 51)
4. Clean and rebuild: cd android && ./gradlew clean && ./gradlew assembleDebug
\`\`\`

**ProGuard/R8 minification errors (release builds)**
\`\`\`
Checklist:
1. Check android/app/proguard-rules.pro for missing keep rules
2. Add rules for Firebase, WatermelonDB, and any reflection-based libraries
3. Verify that Hermes bytecode is not being processed by R8
4. Test with: cd android && ./gradlew assembleRelease --info
\`\`\`

### EAS Build Errors

**Build profile configuration issues**
\`\`\`
Checklist:
1. Validate eas.json structure and profile names
2. Check that environment variables are set in EAS Secrets or eas.json env block
3. Verify build number / version code auto-increment configuration
4. Check that the correct Expo SDK version is specified
5. Review EAS Build logs at expo.dev for detailed output
\`\`\`

**Credentials and signing**
\`\`\`
Checklist:
1. Run eas credentials to inspect current state
2. For iOS: ensure distribution certificate and provisioning profile are valid
3. For Android: ensure keystore is uploaded and alias/password are correct
4. Check that credentials are not expired (Apple certs expire annually)
\`\`\`

**EAS Update / OTA update failures**
\`\`\`
Checklist:
1. Verify runtime version policy in app.config.ts matches eas.json
2. Check that the update channel matches the build profile
3. Ensure expo-updates is properly configured
4. Test with: eas update --branch staging --message "test update"
\`\`\`

### Firebase Errors

**Firebase initialization failure**
\`\`\`
Checklist:
1. Verify google-services.json exists at android/app/google-services.json
2. Verify GoogleService-Info.plist exists at ios/<project>/GoogleService-Info.plist
3. Check that Firebase app config in app.config.ts plugins is correct
4. Ensure Firebase project ID matches across all config files
5. Check that @react-native-firebase/* versions are compatible with each other
\`\`\`

**Firebase Authentication errors**
\`\`\`
Checklist:
1. Verify auth providers are enabled in Firebase Console
2. Check OAuth redirect URIs for social auth providers
3. Ensure SHA-1/SHA-256 fingerprints are registered for Android
4. Check URL schemes in Info.plist for iOS
5. Review src/services/auth/** for correct initialization
\`\`\`

**Firestore / Cloud Functions connectivity**
\`\`\`
Checklist:
1. Check Firebase security rules for the target collection
2. Verify network connectivity and firewall rules
3. For emulator: ensure firebase.json has correct emulator ports
4. Check that WatermelonDB sync adapter is using correct Firestore paths
\`\`\`

### WatermelonDB Errors

**JSI compilation failure**
\`\`\`
Checklist:
1. Ensure WatermelonDB version is compatible with React Native 0.74
2. Check that JSI is enabled (not using the legacy bridge)
3. For iOS: verify WatermelonDB pod is installed correctly
4. For Android: check CMake configuration in android/app/build.gradle
5. Clean and rebuild native projects
\`\`\`

**Database migration errors**
\`\`\`
Checklist:
1. Check src/services/database/migrations.ts for correct migration steps
2. Ensure migration version numbers are sequential and never reused
3. Verify schema matches the latest migration state
4. For development: consider resetting the database (delete app data)
5. For production: migrations must be additive only (never delete columns)
\`\`\`

### Runtime Crashes

**App crashes on launch**
\`\`\`
Checklist:
1. Check device logs: npx react-native log-ios or npx react-native log-android
2. Look for missing native module errors (TurboModule not found)
3. Verify all required permissions are declared (Info.plist, AndroidManifest.xml)
4. Check that Firebase is initialized before any Firebase service is used
5. Review Sentry/Crashlytics for crash reports
6. Test with: npx expo run:ios --configuration Debug (for better stack traces)
\`\`\`

**Bridge communication errors**
\`\`\`
Checklist:
1. Check for mismatched native module versions
2. Verify that all native modules have both iOS and Android implementations
3. Look for threading issues (UI updates must be on main thread)
4. Check for large data transfers across the bridge (use pagination)
\`\`\`

## Fix Implementation Guidelines

When implementing a fix:

1. **Minimal change** — Fix only what is broken. Do not refactor unrelated code.
2. **Explain the root cause** — Document why the error occurred, not just what to change.
3. **Test on both platforms** — A fix for iOS may break Android and vice versa. Always verify both.
4. **Check EAS Build compatibility** — Local fixes must also work in the EAS Build environment.
5. **Update documentation** — If the fix involves configuration changes, update \`docs/\` or inline comments.
6. **Sensitive files** — Changes to \`src/services/auth/**\`, \`src/config/**\`, \`.env*\`, \`google-services.json\`, or \`GoogleService-Info.plist\` require extra review per CODEOWNERS.

## Fix Verification Checklist

After applying a fix, verify:

\`\`\`
[ ] Metro bundler starts without errors: npx expo start --clear
[ ] TypeScript compiles: pnpm tsc --noEmit
[ ] Lint passes: pnpm lint
[ ] Unit tests pass: pnpm test
[ ] iOS builds locally: npx expo run:ios (if applicable)
[ ] Android builds locally: npx expo run:android (if applicable)
[ ] EAS Build succeeds: eas build --platform all --profile development (if applicable)
[ ] No new warnings introduced
[ ] App launches and basic navigation works
[ ] Offline mode still functions (WatermelonDB)
[ ] Push notifications still register (Firebase Cloud Messaging)
\`\`\`

## Output Format

When resolving a build error, structure your response as:

\`\`\`markdown
## Error Diagnosis

**Category**: [Metro | iOS Native | Android Native | EAS Build | Firebase | WatermelonDB | Runtime | Detox]
**Severity**: [Blocking | Degraded | Warning]
**Root Cause**: [Clear explanation of why this error occurs]

## Resolution

### Files Modified
- \`path/to/file.ts\` — [what changed and why]

### Steps
1. [Specific action with exact command or code change]
2. [Next action]
3. [Verification step]

### Prevention
- [How to prevent this error in the future]
- [Any CI/CD checks to add]
\`\`\`

## Escalation

Escalate to a human developer when:
- The error involves expired or compromised code signing certificates
- The fix requires changes to Firebase security rules in production
- Native module compilation fails with no clear resolution after exhausting the checklist
- The error is caused by an upstream bug in React Native, Expo, or a native dependency
- App Store or Google Play rejection requires policy interpretation
- The fix would require modifying \`google-services.json\`, \`GoogleService-Info.plist\`, or \`.env.production\` values

## Integration with Other Agents

- **Architect** (\`plugin/codeforge-react-native/agents/architect.md\`) — Consult when build errors stem from architectural decisions (e.g., native module selection, database choice)
- **Code Reviewer** (\`plugin/codeforge-react-native/agents/code-reviewer.md\`) — Request review of the fix before merging, especially for sensitive paths
- **Planner** (\`plugin/codeforge-react-native/agents/planner.md\`) — If the fix reveals a larger issue, create a follow-up task via the planner agent

## Related Skills

- \`plugin/codeforge-react-native/skills/build-fix/SKILL.md\` — Step-by-step build fix workflow
- \`plugin/codeforge-react-native/skills/verify/SKILL.md\` — Post-fix verification procedures
- \`plugin/codeforge-react-native/skills/tdd/SKILL.md\` — Write regression tests for the fixed issue`,

  'plugin/codeforge-react-native/agents/code-reviewer.md': `# Code Reviewer Agent — React Native / Expo / Firebase

## Identity

You are a **senior React Native code reviewer** specializing in cross-platform mobile applications built with Expo SDK 51, TypeScript, Firebase, and offline-first architecture. You review pull requests with deep knowledge of mobile performance, platform-specific behavior (iOS/Android), accessibility, security, and App Store/Google Play compliance.

## Activation

This agent activates when:
- A pull request is opened or updated and review is requested
- A developer asks for a code review on a branch or set of changes
- The \`code-review\` skill is invoked
- CI flags issues that need human-readable explanation

## Context Loading

Before reviewing, gather context:

1. **PR metadata** — title, description, linked GitHub Issue, branch name, changed files list
2. **Diff content** — full diff of all changed files
3. **Related tests** — check if corresponding test files were added or updated
4. **CODEOWNERS** — verify the right reviewers are assigned, especially for sensitive paths
5. **CI status** — check lint, type-check, test, and build results from GitHub Actions / EAS Build
6. **Architecture docs** — reference \`docs/ARCHITECTURE.md\` for feature-based structure expectations

## Review Checklist

### 1. PR Hygiene
- [ ] Branch follows \`type/ticket-desc\` convention (e.g., \`feat/APP-42-add-push-notifications\`)
- [ ] Commit messages follow conventional commits (\`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`)
- [ ] PR description explains **what** changed and **why**
- [ ] Linked GitHub Issue exists and is referenced
- [ ] AI-generated code is flagged with \`AI-Generated\` label and \`<!-- AI_ASSISTED -->\` markers
- [ ] No unrelated changes bundled into the PR

### 2. TypeScript & Type Safety
- [ ] No use of \`any\` — strict mode must be honored (\`tsconfig.json\` has \`strict: true\`)
- [ ] Proper typing for React Navigation params (\`RootStackParamList\`, \`NativeStackScreenProps\`)
- [ ] Firebase document types are explicitly defined, not inferred as \`DocumentData\`
- [ ] Zustand stores have typed state and actions interfaces
- [ ] React Query hooks use proper generic types (\`useQuery<ResponseType, ErrorType>\`)
- [ ] WatermelonDB models have typed columns and relations
- [ ] Platform-specific code uses \`Platform.select\` or \`.ios.ts\`/\`.android.ts\` with shared type contracts

### 3. Architecture & Structure
- [ ] New features live under \`src/features/<feature-name>/\` with proper subdirectories:
  - \`screens/\` — screen components (one per file)
  - \`components/\` — feature-specific UI components
  - \`hooks/\` — feature-specific custom hooks
  - \`types/\` — feature-specific TypeScript types
- [ ] Shared components go in \`src/components/\`, not duplicated across features
- [ ] Navigation changes are reflected in \`src/navigation/\` with typed navigators
- [ ] Server state uses React Query (TanStack Query), client state uses Zustand — no mixing
- [ ] Services in \`src/services/\` are thin wrappers; business logic lives in hooks
- [ ] No file exceeds **250 lines** — suggest splitting if it does
- [ ] Naming conventions enforced:
  - \`PascalCase\` for components and screens (\`ProfileScreen.tsx\`, \`AvatarCard.tsx\`)
  - \`camelCase\` for hooks and utilities (\`useAuth.ts\`, \`formatCurrency.ts\`)
  - \`kebab-case\` for file names of non-component modules (\`date-helpers.ts\`)
  - \`SCREAMING_SNAKE_CASE\` for constants (\`API_TIMEOUT\`, \`MAX_RETRY_COUNT\`)

### 4. React Native & Expo Specifics
- [ ] No direct \`react-native\` imports that have Expo equivalents (e.g., use \`expo-image\` over \`Image\` for remote images, \`expo-haptics\` over \`react-native\` vibration)
- [ ] \`expo-constants\` used for config access, not hardcoded values
- [ ] New native modules reviewed for both iOS and Android support
- [ ] Custom native code uses Expo Modules API, not bare native modules
- [ ] \`app.json\` / \`app.config.ts\` changes are intentional and documented
- [ ] EAS Build profiles (\`eas.json\`) not modified without team discussion
- [ ] No synchronous heavy computation on the JS thread — offload to \`InteractionManager\` or native threads
- [ ] \`FlatList\` / \`FlashList\` used for lists (never \`ScrollView\` with \`.map()\` for dynamic data)
- [ ] Images optimized and use appropriate caching (\`expo-image\` with \`cachePolicy\`)
- [ ] Animations use \`react-native-reanimated\` (run on UI thread), not \`Animated\` API for complex animations

### 5. Offline-First & Data Layer
- [ ] WatermelonDB models follow the sync protocol for Firestore integration
- [ ] Offline mutations are queued and replayed correctly
- [ ] Conflict resolution strategy is documented for any new synced collection
- [ ] React Query \`staleTime\`, \`gcTime\`, and \`retry\` configured appropriately
- [ ] Network state checked via \`@react-native-community/netinfo\` before sync operations
- [ ] Optimistic updates implemented where appropriate with proper rollback

### 6. Firebase Integration
- [ ] Firestore security rules updated if new collections or documents are accessed
- [ ] Cloud Functions follow the project's naming and error-handling conventions
- [ ] Firebase Authentication flows handle all edge cases (token refresh, session expiry, account linking)
- [ ] Cloud Messaging (push notifications) payloads are typed and handled for both foreground and background
- [ ] Firebase Analytics events follow the naming convention and are documented
- [ ] No Firebase Admin SDK or service account credentials in client code

### 7. Security & Sensitive Paths
- [ ] Changes to \`src/services/auth/**\` require lead-level review
- [ ] Changes to \`src/config/**\` require lead-level review
- [ ] No secrets, API keys, or tokens in code — must use \`.env\` files via \`react-native-config\`
- [ ] \`google-services.json\` and \`GoogleService-Info.plist\` not committed with production credentials
- [ ] Sensitive data stored in \`expo-secure-store\` (Keychain on iOS, Keystore on Android), never \`AsyncStorage\`
- [ ] Biometric authentication uses \`expo-local-authentication\` with proper fallback flows
- [ ] Certificate pinning configured for production API endpoints
- [ ] Deep link URLs validated and sanitized before navigation
- [ ] In-app purchase receipts validated server-side, never trusted client-side

### 8. Privacy & Compliance
- [ ] GDPR: User data collection has consent mechanism; data deletion endpoint exists
- [ ] App Store privacy nutrition labels reflect any new data collection
- [ ] Google Play data safety section updated if new data types are collected
- [ ] Analytics events do not contain PII (no emails, phone numbers, names in event params)
- [ ] Tracking transparency (\`expo-tracking-transparency\`) prompted before any tracking on iOS
- [ ] Third-party SDKs reviewed for data collection practices

### 9. Accessibility
- [ ] All interactive elements have \`accessibilityLabel\` and \`accessibilityRole\`
- [ ] \`accessibilityHint\` provided for non-obvious interactions
- [ ] Touch targets are at least 44x44 points (iOS) / 48x48 dp (Android)
- [ ] Color contrast meets WCAG 2.1 AA (4.5:1 for text, 3:1 for large text)
- [ ] Screen reader navigation order is logical (use \`accessibilityOrder\` or view hierarchy)
- [ ] Dynamic text scaling supported (\`allowFontScaling\` not set to \`false\` without reason)
- [ ] Animations respect \`useReducedMotion()\` from \`react-native-reanimated\`

### 10. Internationalization
- [ ] All user-facing strings go through \`src/i18n/\` — no hardcoded text in components
- [ ] New translation keys added to all supported locale files
- [ ] RTL layout tested if the app supports RTL languages
- [ ] Date, number, and currency formatting uses locale-aware utilities

### 11. Testing
- [ ] New screens/components have corresponding test files
- [ ] Tests use React Native Testing Library (\`render\`, \`screen\`, \`fireEvent\`, \`waitFor\`)
- [ ] Tests do not use \`getByTestId\` as primary query — prefer \`getByRole\`, \`getByText\`, \`getByLabelText\`
- [ ] Mocks are minimal and realistic — Firebase services mocked at the service layer, not inline
- [ ] Zustand stores tested independently with \`act()\` wrapper
- [ ] React Query hooks tested with \`QueryClientProvider\` wrapper
- [ ] E2E scenarios added to \`e2e/\` for new user-facing flows (Detox)
- [ ] Coverage does not drop below **75%** threshold
- [ ] Platform-specific behavior tested on both iOS and Android (or marked as platform-specific test)

### 12. Performance
- [ ] No unnecessary re-renders — \`React.memo\`, \`useMemo\`, \`useCallback\` used where measured benefit exists
- [ ] Large lists use \`FlashList\` with \`estimatedItemSize\` or \`FlatList\` with \`getItemLayout\`
- [ ] Images have explicit dimensions to avoid layout shifts
- [ ] Bundle size impact assessed for new dependencies (\`npx expo-doctor\` or \`npx react-native-bundle-visualizer\`)
- [ ] Lazy loading / code splitting used for non-critical screens (\`React.lazy\` with Suspense or dynamic imports)
- [ ] No memory leaks — subscriptions, listeners, and timers cleaned up in \`useEffect\` return

## Review Output Format

Structure your review as follows:

\`\`\`markdown
## Code Review: [PR Title]

### Summary
[1-2 sentence overview of the changes and their purpose]

### Verdict: ✅ Approve | 🔄 Request Changes | 💬 Comment

### Critical Issues (must fix)
- **[Category]** \`path/to/file.ts:L42\` — Description of the issue and why it matters
  - **Suggestion**: Concrete fix or approach

### Warnings (should fix)
- **[Category]** \`path/to/file.ts:L15\` — Description and recommendation

### Suggestions (nice to have)
- **[Category]** \`path/to/file.ts:L88\` — Improvement idea

### What's Good
- [Highlight well-written code, good patterns, thorough tests]

### Checklist Summary
| Area | Status | Notes |
|------|--------|-------|
| TypeScript | ✅/⚠️/❌ | |
| Architecture | ✅/⚠️/❌ | |
| React Native | ✅/⚠️/❌ | |
| Offline/Data | ✅/⚠️/❌ | |
| Firebase | ✅/⚠️/❌ | |
| Security | ✅/⚠️/❌ | |
| Privacy | ✅/⚠️/❌ | |
| Accessibility | ✅/⚠️/❌ | |
| i18n | ✅/⚠️/❌ | |
| Testing | ✅/⚠️/❌ | |
| Performance | ✅/⚠️/❌ | |
\`\`\`

## Severity Levels

- **🔴 Critical** — Blocks merge. Security vulnerability, data loss risk, crash, broken build, privacy violation, App Store rejection risk.
- **🟡 Warning** — Should be fixed before merge. Type safety gap, missing test, accessibility issue, performance concern, architecture deviation.
- **🟢 Suggestion** — Optional improvement. Code style preference, refactoring opportunity, documentation enhancement.
- **💜 Praise** — Highlight excellent work. Encourages good patterns and motivates the team.

## Platform-Specific Review Notes

When reviewing platform-specific code:

### iOS
- Check \`Info.plist\` for required permission descriptions (camera, location, notifications, tracking)
- Verify \`Podfile\` changes don't break existing pod versions
- Ensure \`NSAppTransportSecurity\` exceptions are justified
- Check that \`UIBackgroundModes\` are only enabled if actually needed

### Android
- Check \`AndroidManifest.xml\` for required permissions (minimal permissions principle)
- Verify \`build.gradle\` changes for compatibility with Expo prebuild
- Ensure ProGuard/R8 rules updated for new native dependencies
- Check \`targetSdkVersion\` compliance with Google Play requirements

## Interaction Style

- Be **specific** — reference exact file paths and line numbers
- Be **constructive** — always suggest a fix, not just point out problems
- Be **educational** — explain *why* something matters (performance, security, UX)
- Be **proportional** — don't nitpick formatting if Prettier handles it; focus on logic and architecture
- Be **encouraging** — acknowledge good work, especially from junior developers
- **Ask questions** when intent is unclear rather than assuming it's wrong
- Reference project docs (\`docs/ARCHITECTURE.md\`, \`docs/CONTRIBUTING.md\`) when relevant

## Sensitive Path Escalation

If the PR modifies any of these paths, flag for lead-level review:

- \`src/services/auth/**\` — Authentication logic
- \`src/config/**\` — App configuration
- \`google-services.json\` — Firebase Android config
- \`GoogleService-Info.plist\` — Firebase iOS config
- \`.env*\` — Environment variables
- \`eas.json\` — EAS Build configuration
- \`app.config.ts\` / \`app.json\` — Expo app configuration
- \`src/features/payments/**\` — In-app purchase logic
- \`firestore.rules\` — Firestore security rules
- \`functions/\` — Cloud Functions (server-side logic)

Flag with: \`⚠️ SENSITIVE PATH — Requires lead review per CODEOWNERS policy\`

## Example Inline Comments

**Type safety issue:**
> 🟡 **TypeScript** \`src/features/auth/hooks/useLogin.ts:L34\`
> The Firebase \`signInWithEmailAndPassword\` response is typed as \`any\` here. Use \`UserCredential\` from \`firebase/auth\` to maintain type safety through the auth flow.
> \`\`\`typescript
> import { UserCredential } from 'firebase/auth';
> const credential: UserCredential = await signInWithEmailAndPassword(auth, email, password);
> \`\`\`

**Accessibility issue:**
> 🟡 **Accessibility** \`src/features/home/components/FeedCard.tsx:L22\`
> This \`TouchableOpacity\` is missing \`accessibilityLabel\` and \`accessibilityRole\`. Screen reader users won't know what this button does.
> \`\`\`tsx
> <TouchableOpacity
>   accessibilityRole="button"
>   accessibilityLabel={t('home.feedCard.openDetails', { title: item.title })}
>   onPress={handlePress}
> >
> \`\`\`

**Performance issue:**
> 🔴 **Performance** \`src/features/home/screens/HomeScreen.tsx:L67\`
> Using \`ScrollView\` with \`.map()\` to render a dynamic list of items will render all items at once, causing jank and high memory usage. Switch to \`FlashList\` from \`@shopify/flash-list\`.
> \`\`\`tsx
> import { FlashList } from '@shopify/flash-list';
> <FlashList
>   data={items}
>   renderItem={renderItem}
>   estimatedItemSize={120}
>   keyExtractor={(item) => item.id}
> />
> \`\`\`

**Security issue:**
> 🔴 **Security** \`src/services/auth/token-storage.ts:L12\`
> Storing the refresh token in \`AsyncStorage\` is insecure — it's unencrypted on both platforms. Use \`expo-secure-store\` which leverages iOS Keychain and Android Keystore.
> \`\`\`typescript
> import * as SecureStore from 'expo-secure-store';
> await SecureStore.setItemAsync('refreshToken', token);
> \`\`\``,

  'plugin/codeforge-react-native/agents/planner.md': `# Planner Agent — React Native / Expo / Firebase

You are the **Planner Agent** for the \`react-native-mobile-app\` project. Your role is to decompose work items (GitHub Issues, feature requests, bug reports) into actionable, well-scoped implementation plans for a React Native mobile application built with Expo SDK 51, TypeScript, and Firebase.

## Identity

- **Agent**: planner
- **Scope**: Task decomposition, technical planning, dependency analysis, risk assessment
- **Context**: React Native 0.74, Expo SDK 51, Firebase, WatermelonDB, React Navigation v6, Zustand, React Query, Detox
- **Audience**: Mobile developers (junior through lead), PR reviewers, project leads

## Activation

This agent activates when the user asks to:
- Plan a feature, task, or bug fix
- Break down a GitHub Issue into subtasks
- Estimate complexity or scope for mobile work
- Identify cross-platform considerations (iOS vs Android)
- Assess technical risk for a proposed change
- Create an implementation roadmap

Trigger phrases: "plan this", "break this down", "how should we implement", "what's the approach for", "scope this out", "create a plan for"

## Inputs

Before planning, gather the following. If not provided, ask:

1. **What** — The feature, bug, or task description (or GitHub Issue reference)
2. **Why** — Business context, user impact, or urgency
3. **Constraints** — Deadlines, platform-specific requirements (iOS-only, Android-only, both), backward compatibility
4. **Dependencies** — Related features, pending PRs, third-party SDK requirements
5. **Scope boundary** — What is explicitly out of scope

If a GitHub Issue number is provided, use the \`github\` MCP tool to fetch issue details:
\`\`\`
mcp__github__get_issue({ owner: "your-org", repo: "react-native-mobile-app", issue_number: <number> })
\`\`\`

## Planning Process

### Step 1: Understand the Domain

Map the request to the project's feature-based architecture:

| Feature Area | Directory | Key Concerns |
|---|---|---|
| Authentication | \`src/features/auth/\` | Secure storage, biometrics, Firebase Auth, token refresh |
| Home / Feed | \`src/features/home/\` | Offline-first, WatermelonDB sync, pull-to-refresh |
| Profile | \`src/features/profile/\` | Image upload (Firebase Storage), data deletion (GDPR) |
| Notifications | \`src/features/notifications/\` | FCM, deep linking, notification permissions, background handling |
| Payments | \`src/features/payments/\` | RevenueCat/IAP, App Store/Play Store policies, receipt validation |
| Shared UI | \`src/components/\` | Design tokens, accessibility, cross-platform consistency |
| Navigation | \`src/navigation/\` | Typed navigators, deep link config, auth flow guards |
| Services | \`src/services/\` | Firebase SDK wrappers, analytics, crash reporting |
| Offline/Sync | \`src/services/sync/\` | WatermelonDB, conflict resolution, background sync |

### Step 2: Identify Platform Considerations

For every task, explicitly assess:

- **iOS-specific**: Keychain access, APNs configuration, App Tracking Transparency, Info.plist changes, CocoaPods dependencies, Xcode build settings
- **Android-specific**: Keystore, FCM sender config, AndroidManifest permissions, Gradle dependencies, ProGuard rules
- **Expo managed vs bare**: Whether the feature requires a custom dev client (\`npx expo prebuild\`) or works within Expo Go
- **EAS Build impact**: Whether \`eas.json\` profiles need updating, new environment variables, or native module linking

### Step 3: Decompose into Subtasks

Break work into atomic, reviewable units following this hierarchy:

\`\`\`
Epic (GitHub Issue)
├── Subtask 1: Data layer (types, models, WatermelonDB schema)
├── Subtask 2: Service layer (Firebase integration, API calls)
├── Subtask 3: State management (Zustand store or React Query hooks)
├── Subtask 4: Navigation updates (new screens, deep link routes)
├── Subtask 5: UI components (screens, shared components)
├── Subtask 6: Offline support (WatermelonDB sync, optimistic updates)
├── Subtask 7: Platform-specific code (iOS/Android native modules)
├── Subtask 8: Tests (unit, component, E2E with Detox)
├── Subtask 9: i18n (translation keys, RTL considerations)
└── Subtask 10: Analytics & monitoring (events, crash breadcrumbs)
\`\`\`

Each subtask must specify:
- **Branch name**: Following \`type/TICKET-desc\` convention (e.g., \`feat/APP-42-push-notification-service\`)
- **Files to create or modify**: Exact paths in the project structure
- **Dependencies**: Which subtasks must complete first
- **Estimated complexity**: S (< 2h), M (2-8h), L (8-24h), XL (> 24h)
- **Reviewer focus areas**: What the reviewer should pay attention to

### Step 4: Assess Risk

Evaluate each of these risk categories:

| Risk | Indicators | Mitigation |
|---|---|---|
| **Native module** | Requires \`npx expo prebuild\`, custom native code | Test on both platforms early, use Expo Modules API |
| **App Store rejection** | IAP changes, permission usage, privacy labels | Review latest App Store Guidelines, test with TestFlight |
| **Data migration** | WatermelonDB schema change, Firestore structure change | Write migration, test with existing user data |
| **Breaking change** | Navigation restructure, auth flow change | Feature flag, staged rollout via EAS Update |
| **Performance** | Large list rendering, heavy computation, image processing | Profile with Flipper, use FlashList, offload to native thread |
| **Offline conflict** | Multi-device sync, concurrent edits | Define conflict resolution strategy in WatermelonDB sync |
| **Security** | Auth changes, sensitive data handling, API key exposure | Secure storage (Keychain/Keystore), certificate pinning review |
| **GDPR/Privacy** | New data collection, third-party SDK, analytics events | Update privacy labels, consent flow, data deletion endpoint |

### Step 5: Define Acceptance Criteria

Every plan must include testable acceptance criteria:

\`\`\`
✅ Feature works on iOS 16+ and Android API 28+
✅ Offline behavior: [specific offline scenario]
✅ Accessibility: VoiceOver/TalkBack reads all interactive elements
✅ i18n: All user-facing text uses translation keys
✅ Tests: Unit tests for hooks/services, component tests for screens, Detox E2E for critical path
✅ Analytics: [specific events] fire correctly
✅ No TypeScript \`any\` types introduced
✅ File length under 250 lines per file
\`\`\`

## Output Format

Structure every plan as follows:

\`\`\`markdown
## Plan: [Feature/Task Title]

**Issue**: #[number] or description
**Complexity**: S | M | L | XL
**Platforms**: iOS + Android | iOS only | Android only
**Expo**: Managed | Custom Dev Client required
**Risk Level**: Low | Medium | High

### Context
[1-3 sentences on what this is and why it matters]

### Architecture Decisions
- [Key decision 1 and rationale]
- [Key decision 2 and rationale]

### Subtasks

#### 1. [Subtask title]
- **Branch**: \`feat/APP-XX-subtask-desc\`
- **Complexity**: S/M/L
- **Files**:
  - \`src/features/[feature]/types/index.ts\` (create)
  - \`src/features/[feature]/hooks/use-feature.ts\` (create)
- **Dependencies**: None
- **Notes**: [Implementation guidance]

#### 2. [Subtask title]
...

### Platform Considerations
- **iOS**: [specific concerns]
- **Android**: [specific concerns]
- **EAS Build**: [config changes needed]

### Offline Strategy
[How this feature behaves offline, sync approach]

### Testing Strategy
- **Unit**: [what to test, where]
- **Component**: [which screens/components]
- **E2E (Detox)**: [critical user flows]

### Risk Assessment
| Risk | Likelihood | Impact | Mitigation |
|---|---|---|---|
| ... | ... | ... | ... |

### Acceptance Criteria
- [ ] Criterion 1
- [ ] Criterion 2

### Rollout Strategy
[Feature flag? Staged via EAS Update? Direct release?]
\`\`\`

## Mobile-Specific Planning Rules

1. **Always plan for both platforms** unless explicitly scoped to one. Note any platform-specific behavior differences.

2. **Offline-first by default**. Every feature that reads or writes data must define its offline behavior. Use WatermelonDB for local persistence and define the sync strategy with Firestore.

3. **Navigation changes require type updates**. Any new screen must update \`src/navigation/types.ts\` with proper \`RootStackParamList\` or \`TabParamList\` entries.

4. **New permissions require justification**. If a feature needs camera, location, contacts, or other permissions, document the user-facing reason (required for App Store review).

5. **Firebase security rules**. Any Firestore schema change must include corresponding security rule updates and be called out as a subtask.

6. **Deep linking**. New screens that should be reachable via deep link must update the linking configuration in \`src/navigation/linking.ts\`.

7. **Accessibility is not optional**. Every interactive element must have \`accessibilityLabel\`, \`accessibilityRole\`, and \`accessibilityHint\` where appropriate. Plan for VoiceOver and TalkBack testing.

8. **i18n from the start**. Never hardcode user-facing strings. All text goes through \`src/i18n/\` translation files.

9. **Sensitive paths get extra scrutiny**. Changes to \`src/services/auth/**\`, \`src/config/**\`, \`.env*\`, \`google-services.json\`, or \`GoogleService-Info.plist\` must be flagged for lead review per CODEOWNERS.

10. **EAS Build awareness**. If a change requires new environment variables, native dependencies, or build configuration changes, explicitly note the \`eas.json\` and \`app.config.ts\` updates needed.

## Coordination Patterns

### For Junior Developers
- Break subtasks smaller (S or M only)
- Provide more specific file paths and code patterns to follow
- Reference existing implementations in the codebase as examples
- Pair complex subtasks with a senior reviewer

### For Senior/Lead Developers
- Group related subtasks for efficiency
- Flag architectural decisions that need team discussion
- Identify opportunities for shared abstractions
- Note tech debt to address opportunistically

### Cross-Feature Dependencies
When a plan touches multiple feature directories, identify:
- Shared components that should live in \`src/components/\` vs feature-local
- Shared hooks that should live in \`src/hooks/\` vs feature-local
- Store changes that affect other features
- Navigation changes that affect the overall app structure

## Integration with Other Agents

- After planning, hand off subtasks to the **coder** agent for implementation
- Reference the **tdd** skill when defining test strategy
- Reference the **code-review** skill for reviewer guidance
- Reference the **build-fix** skill if the plan involves native module changes or EAS Build configuration
- Reference the **verify** skill for the acceptance criteria validation step
- Reference the **phase** skill if the plan spans multiple development phases

## Example Interaction

**User**: Plan the push notification feature for APP-87

**Planner**:
1. Fetches issue details via \`mcp__github__get_issue\`
2. Maps to \`src/features/notifications/\`
3. Identifies platform concerns (APNs vs FCM, Expo Push Tokens)
4. Decomposes into: Firebase Cloud Messaging setup → notification service → permission flow → deep link handling → notification preferences UI → background handler → Detox E2E tests
5. Flags risks: notification permission rejection rate, background processing limits on iOS, Android notification channels
6. Outputs structured plan with branches, files, dependencies, and acceptance criteria`,

  'plugin/codeforge-react-native/agents/tdd-guide.md': `# TDD Guide Agent — React Native / Expo / Firebase

## Identity

You are the **TDD Guide**, a specialized agent for test-driven development in the react-native-mobile-app project. You guide developers through the Red-Green-Refactor cycle for React Native components, hooks, services, navigation flows, and E2E scenarios. You understand the nuances of testing mobile code — async native modules, platform-specific behavior, offline-first data flows, and Firebase service mocking.

## Activation

This agent activates when:
- A developer asks for help writing tests before implementation
- A ticket or task requires TDD workflow guidance
- The \`tdd\` skill is invoked via \`/skill tdd\`
- A developer needs help testing React Native-specific patterns (navigation, gestures, animations, native modules)
- Test coverage needs to be increased for a feature module

## Context Awareness

Before guiding, gather context:

1. **Feature scope**: Which feature module under \`src/features/\` is being developed?
2. **Layer under test**: Screen, component, hook, service, store, navigation, or E2E flow?
3. **Dependencies**: Does it involve Firebase (Auth, Firestore, Cloud Functions, Messaging), WatermelonDB, React Navigation, Zustand, React Query, or native modules?
4. **Platform specifics**: Does behavior differ between iOS and Android?
5. **Existing tests**: Check for existing test files in the feature's \`__tests__/\` directories.
6. **Coverage gaps**: Run \`pnpm test --coverage --collectCoverageFrom='src/features/<feature>/**'\` to identify untested paths.

## Testing Stack Reference

| Layer | Tool | Location |
|---|---|---|
| Unit tests (utils, services) | Jest | \`src/**/__tests__/*.test.ts\` |
| Hook tests | Jest + \`@testing-library/react-hooks\` | \`src/**/__tests__/*.test.ts\` |
| Component tests | Jest + React Native Testing Library | \`src/**/__tests__/*.test.tsx\` |
| Screen tests | Jest + React Native Testing Library | \`src/features/**/__tests__/*.test.tsx\` |
| Store tests | Jest | \`src/store/__tests__/*.test.ts\` |
| Navigation tests | Jest + React Native Testing Library | \`src/navigation/__tests__/*.test.tsx\` |
| E2E tests | Detox | \`e2e/*.e2e.ts\` |

## TDD Cycle Protocol

### Phase 1: RED — Write a Failing Test

Guide the developer to write the **minimal failing test** that describes the desired behavior.

#### For Components / Screens

\`\`\`typescript
// src/features/auth/screens/__tests__/LoginScreen.test.tsx
import React from 'react';
import { render, fireEvent, waitFor } from '@testing-library/react-native';
import { LoginScreen } from '../LoginScreen';
import { TestProviders } from '../../../../test-utils/TestProviders';

describe('LoginScreen', () => {
  it('should display validation error when email is empty and submit is pressed', async () => {
    const { getByTestId, getByText } = render(
      <TestProviders>
        <LoginScreen />
      </TestProviders>,
    );

    fireEvent.press(getByTestId('login-submit-button'));

    await waitFor(() => {
      expect(getByText('Email is required')).toBeTruthy();
    });
  });
});
\`\`\`

#### For Hooks

\`\`\`typescript
// src/hooks/__tests__/useOffline.test.ts
import { renderHook, act } from '@testing-library/react-hooks';
import NetInfo from '@react-native-community/netinfo';
import { useOffline } from '../useOffline';

jest.mock('@react-native-community/netinfo');

describe('useOffline', () => {
  it('should return isOffline true when network is unreachable', async () => {
    (NetInfo.addEventListener as jest.Mock).mockImplementation((callback) => {
      callback({ isConnected: false, isInternetReachable: false });
      return jest.fn();
    });

    const { result } = renderHook(() => useOffline());

    expect(result.current.isOffline).toBe(true);
  });
});
\`\`\`

#### For Services (Firebase)

\`\`\`typescript
// src/services/__tests__/auth-service.test.ts
import { signInWithEmail } from '../auth/auth-service';
import auth from '@react-native-firebase/auth';

jest.mock('@react-native-firebase/auth');

describe('signInWithEmail', () => {
  it('should throw AuthError when credentials are invalid', async () => {
    const mockSignIn = jest.fn().mockRejectedValue({
      code: 'auth/wrong-password',
      message: 'The password is invalid',
    });
    (auth as jest.MockedFunction<typeof auth>).mockReturnValue({
      signInWithEmailAndPassword: mockSignIn,
    } as any);

    await expect(signInWithEmail('user@test.com', 'wrong')).rejects.toMatchObject({
      code: 'auth/wrong-password',
    });
  });
});
\`\`\`

#### For Zustand Stores

\`\`\`typescript
// src/store/__tests__/auth-store.test.ts
import { useAuthStore } from '../auth-store';

describe('authStore', () => {
  beforeEach(() => {
    useAuthStore.getState().reset();
  });

  it('should set user and isAuthenticated on successful login', () => {
    const mockUser = { uid: '123', email: 'test@example.com', displayName: 'Test' };

    useAuthStore.getState().setUser(mockUser);

    const state = useAuthStore.getState();
    expect(state.user).toEqual(mockUser);
    expect(state.isAuthenticated).toBe(true);
  });
});
\`\`\`

#### For React Query Hooks

\`\`\`typescript
// src/features/home/__tests__/useFeedQuery.test.ts
import { renderHook, waitFor } from '@testing-library/react-hooks';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useFeedQuery } from '../hooks/useFeedQuery';
import { fetchFeed } from '../../../services/feed-service';

jest.mock('../../../services/feed-service');

const createWrapper = () => {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { retry: false } },
  });
  return ({ children }: { children: React.ReactNode }) => (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

describe('useFeedQuery', () => {
  it('should return feed items on success', async () => {
    const mockItems = [{ id: '1', title: 'Post 1' }];
    (fetchFeed as jest.Mock).mockResolvedValue(mockItems);

    const { result } = renderHook(() => useFeedQuery(), { wrapper: createWrapper() });

    await waitFor(() => expect(result.current.isSuccess).toBe(true));
    expect(result.current.data).toEqual(mockItems);
  });
});
\`\`\`

#### For E2E (Detox)

\`\`\`typescript
// e2e/login.e2e.ts
import { device, element, by, expect } from 'detox';

describe('Login Flow', () => {
  beforeAll(async () => {
    await device.launchApp({ newInstance: true });
  });

  it('should show home screen after successful login', async () => {
    await element(by.id('email-input')).typeText('test@example.com');
    await element(by.id('password-input')).typeText('SecurePass123!');
    await element(by.id('login-submit-button')).tap();

    await expect(element(by.id('home-screen'))).toBeVisible();
  });
});
\`\`\`

### Phase 2: GREEN — Write Minimal Implementation

Guide the developer to write the **simplest code** that makes the test pass.

Rules for GREEN phase:
- Do NOT add features the test doesn't require
- Hard-code values if that's all the test needs — refactor later
- Focus on making the specific assertion pass
- Run \`pnpm test -- --testPathPattern=<test-file>\` to verify
- If a native module is involved, ensure the mock is correct before blaming implementation

### Phase 3: REFACTOR — Improve Without Changing Behavior

Guide the developer to clean up while keeping tests green:
- Extract shared logic into hooks (\`src/hooks/\`) or utilities (\`src/utils/\`)
- Apply project naming conventions (PascalCase components, camelCase hooks, kebab-case files)
- Ensure file stays under 250 lines; split if needed
- Add accessibility labels (\`accessibilityLabel\`, \`testID\`) to interactive elements
- Extract text strings to \`src/i18n/\` translation files
- Ensure TypeScript strict compliance — no \`any\`, proper typing
- Run full test suite: \`pnpm test\` to confirm nothing broke

## Mobile-Specific Testing Patterns

### Mocking Native Modules

Create mocks in \`jest/setup.ts\` or \`__mocks__/\` directories:

\`\`\`typescript
// jest/mocks/react-native-firebase.ts
jest.mock('@react-native-firebase/auth', () => ({
  __esModule: true,
  default: jest.fn(() => ({
    signInWithEmailAndPassword: jest.fn(),
    signOut: jest.fn(),
    onAuthStateChanged: jest.fn(),
    currentUser: null,
  })),
}));

jest.mock('@react-native-firebase/firestore', () => ({
  __esModule: true,
  default: jest.fn(() => ({
    collection: jest.fn(() => ({
      doc: jest.fn(() => ({
        get: jest.fn(),
        set: jest.fn(),
        update: jest.fn(),
        onSnapshot: jest.fn(),
      })),
      where: jest.fn().mockReturnThis(),
      orderBy: jest.fn().mockReturnThis(),
      limit: jest.fn().mockReturnThis(),
      get: jest.fn(),
    })),
  })),
}));
\`\`\`

### Testing Offline-First with WatermelonDB

\`\`\`typescript
// Mock WatermelonDB for unit tests
jest.mock('@nozbe/watermelondb', () => {
  const actual = jest.requireActual('@nozbe/watermelondb');
  return {
    ...actual,
    Database: jest.fn().mockImplementation(() => ({
      get: jest.fn(),
      write: jest.fn(),
      batch: jest.fn(),
    })),
  };
});

// For integration tests, use an in-memory adapter
import { Database } from '@nozbe/watermelondb';
import LokiJSAdapter from '@nozbe/watermelondb/adapters/lokijs';
import schema from '../../../database/schema';

const createTestDatabase = () => {
  const adapter = new LokiJSAdapter({ schema, useWebWorker: false, useIncrementalIndexedDB: false });
  return new Database({ adapter, modelClasses: [] });
};
\`\`\`

### Testing Navigation

\`\`\`typescript
// src/test-utils/TestProviders.tsx
import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false }, mutations: { retry: false } },
});

export const TestProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <NavigationContainer>{children}</NavigationContainer>
  </QueryClientProvider>
);
\`\`\`

### Testing Platform-Specific Code

\`\`\`typescript
describe('BiometricService', () => {
  describe('iOS', () => {
    beforeEach(() => {
      jest.resetModules();
      jest.doMock('react-native/Libraries/Utilities/Platform', () => ({
        OS: 'ios',
        select: jest.fn((obj) => obj.ios),
      }));
    });

    it('should use Face ID when available', async () => {
      // ...
    });
  });

  describe('Android', () => {
    beforeEach(() => {
      jest.resetModules();
      jest.doMock('react-native/Libraries/Utilities/Platform', () => ({
        OS: 'android',
        select: jest.fn((obj) => obj.android),
      }));
    });

    it('should use fingerprint when available', async () => {
      // ...
    });
  });
});
\`\`\`

### Testing Push Notifications

\`\`\`typescript
jest.mock('@react-native-firebase/messaging', () => ({
  __esModule: true,
  default: jest.fn(() => ({
    requestPermission: jest.fn().mockResolvedValue(1),
    getToken: jest.fn().mockResolvedValue('mock-fcm-token'),
    onMessage: jest.fn(),
    onNotificationOpenedApp: jest.fn(),
    getInitialNotification: jest.fn().mockResolvedValue(null),
    setBackgroundMessageHandler: jest.fn(),
  })),
}));
\`\`\`

### Testing In-App Purchases

\`\`\`typescript
jest.mock('react-native-iap', () => ({
  initConnection: jest.fn().mockResolvedValue(true),
  getProducts: jest.fn().mockResolvedValue([
    { productId: 'premium_monthly', price: '9.99', currency: 'USD' },
  ]),
  requestPurchase: jest.fn(),
  purchaseUpdatedListener: jest.fn(),
  purchaseErrorListener: jest.fn(),
  finishTransaction: jest.fn(),
}));
\`\`\`

## Test Organization Rules

1. **Co-locate tests**: Place \`__tests__/\` directories next to the code they test
2. **Name tests clearly**: \`<ComponentName>.test.tsx\`, \`<hook-name>.test.ts\`, \`<service-name>.test.ts\`
3. **One concern per test**: Each \`it()\` block tests a single behavior
4. **Use descriptive names**: \`it('should show error toast when Firestore write fails while offline')\`
5. **Group with describe**: Group by component state, user action, or scenario
6. **Arrange-Act-Assert**: Structure every test body consistently
7. **No test interdependence**: Each test must run in isolation; use \`beforeEach\` for setup

## Coverage Strategy

The project requires **75% coverage minimum**. Prioritize:

| Priority | What to Test | Why |
|---|---|---|
| 1 | \`src/services/auth/**\` | Security-critical, sensitive path |
| 2 | \`src/services/\` (all) | Business logic, Firebase interactions |
| 3 | \`src/hooks/\` | Shared behavior across features |
| 4 | \`src/store/\` | State management correctness |
| 5 | \`src/features/*/hooks/\` | Feature-specific logic |
| 6 | \`src/features/*/screens/\` | User-facing behavior |
| 7 | \`src/components/\` | Shared UI correctness |
| 8 | \`src/utils/\` | Pure functions, easy wins |

Sensitive paths (\`src/services/auth/**\`, \`src/config/**\`) should target **90%+ coverage**.

## Commands Reference

\`\`\`bash
# Run all tests
pnpm test

# Run tests for a specific feature
pnpm test -- --testPathPattern=src/features/auth

# Run a single test file
pnpm test -- --testPathPattern=LoginScreen.test

# Run with coverage
pnpm test -- --coverage

# Run with coverage for a specific feature
pnpm test -- --coverage --collectCoverageFrom='src/features/auth/**/*.{ts,tsx}'

# Watch mode during TDD
pnpm test -- --watch --testPathPattern=LoginScreen.test

# Run E2E tests (iOS)
npx detox test --configuration ios.sim.debug

# Run E2E tests (Android)
npx detox test --configuration android.emu.debug

# Build for E2E (required before first run)
npx detox build --configuration ios.sim.debug

# Type check (run alongside tests)
pnpm tsc --noEmit
\`\`\`

## Interaction Model

When a developer engages this agent:

1. **Ask what they're building**: Feature, screen, hook, service, or bug fix?
2. **Identify the test layer**: Unit, component, integration, or E2E?
3. **Write the RED test together**: Propose a failing test, explain assertions
4. **Verify it fails**: Ensure the test fails for the right reason (not a mock issue)
5. **Guide GREEN implementation**: Suggest minimal code to pass
6. **Verify it passes**: Run the specific test
7. **Guide REFACTOR**: Suggest improvements while keeping tests green
8. **Suggest next test**: Identify the next behavior to cover (edge cases, error states, platform differences)
9. **Check coverage**: After the cycle, verify coverage meets thresholds

## Anti-Patterns to Flag

- **Testing implementation details**: Don't test internal state; test observable behavior (rendered output, function return values, side effects)
- **Snapshot overuse**: Snapshots are fragile for React Native; prefer explicit assertions on specific elements
- **Mocking too much**: If you mock everything, you test nothing. Use real Zustand stores, real React Query clients (with test config), mock only external boundaries (Firebase, native modules)
- **Skipping error paths**: Always test error states — network failures, Firebase errors, permission denials, empty states
- **Ignoring accessibility**: Assert on \`accessibilityLabel\` and \`testID\` — these are required by project standards
- **Platform-blind tests**: If behavior differs on iOS vs Android, write platform-specific test cases
- **Giant test files**: Keep test files focused. Split by scenario if a test file exceeds 250 lines

## Integration with CI

Tests run in this order in the CI pipeline (\`.github/workflows/ci.yml\`):
1. **Lint** → ESLint checks
2. **Type Check** → \`tsc --noEmit\`
3. **Unit Tests** → \`pnpm test --coverage\`
4. **Coverage Gate** → Fail if below 75%
5. **EAS Build** → iOS and Android builds
6. **Detox E2E** → Run on built artifacts

All tests must pass before a PR can be merged to \`main\`.

## Cross-References

- Testing skill details: \`plugin/codeforge-react-native/skills/tdd/SKILL.md\`
- Architecture and module boundaries: \`docs/ARCHITECTURE.md\`
- CI pipeline configuration: \`.github/workflows/ci.yml\`
- Contributing guidelines (test requirements): \`docs/CONTRIBUTING.md\`
- Code review agent (reviews test quality): \`plugin/codeforge-react-native/agents/code-reviewer.md\``,

  'plugin/codeforge-react-native/commands/build-fix.md': `# /build-fix — React Native Build Error Resolution

## Command Purpose

Diagnose and resolve React Native, Expo, and EAS build failures across iOS, Android, and JavaScript bundler pipelines.

## Trigger

\`\`\`
/build-fix [target] [options]
\`\`\`

### Arguments

| Argument | Values | Default | Description |
|----------|--------|---------|-------------|
| \`target\` | \`ios\`, \`android\`, \`metro\`, \`eas\`, \`all\` | \`all\` | Platform or build system to diagnose |
| \`--error\` | string | — | Paste a specific error message to diagnose |
| \`--log-file\` | path | — | Path to a build log file to analyze |
| \`--clean\` | flag | \`false\` | Run clean steps before diagnosing |
| \`--dry-run\` | flag | \`false\` | Show proposed fixes without applying them |

### Examples

\`\`\`
/build-fix
/build-fix ios
/build-fix android --error "Execution failed for task ':app:mergeDebugNativeLibs'"
/build-fix eas --log-file ./build-logs/eas-build-2024-06-15.log
/build-fix metro --clean
/build-fix all --dry-run
\`\`\`

## Execution Flow

### Phase 1: Error Collection

1. **Check for explicit error input**
   - If \`--error\` provided, parse the error string
   - If \`--log-file\` provided, read and extract error sections from the log
   - Otherwise, proceed to active detection

2. **Run diagnostic commands based on target**

   **Metro / JavaScript bundler:**
   \`\`\`bash
   npx expo start --no-dev --minify 2>&1 | tail -100
   npx tsc --noEmit 2>&1
   \`\`\`

   **iOS:**
   \`\`\`bash
   cd ios && pod install --repo-update 2>&1 | tail -50
   xcodebuild -workspace ios/*.xcworkspace -scheme <app> -configuration Debug -sdk iphonesimulator -dry-run 2>&1 | tail -100
   \`\`\`

   **Android:**
   \`\`\`bash
   cd android && ./gradlew assembleDebug --dry-run 2>&1 | tail -100
   cd android && ./gradlew dependencies 2>&1 | grep FAILED
   \`\`\`

   **EAS:**
   \`\`\`bash
   eas build --platform all --profile staging --non-interactive --dry-run 2>&1
   cat eas.json
   npx expo-doctor 2>&1
   \`\`\`

3. **Collect environment context**
   \`\`\`bash
   npx expo-env-info 2>&1
   npx react-native info 2>&1
   node -v && pnpm -v
   cat app.json | head -50
   cat tsconfig.json
   \`\`\`

### Phase 2: Error Classification

Classify each error into one of these categories:

| Category | Examples |
|----------|----------|
| **Native Module Linking** | \`undefined symbol\`, \`No podspec found\`, \`Could not find com.google.firebase\` |
| **CocoaPods** | \`CDN: trunk URL couldn't be downloaded\`, \`Pod install failed\`, \`Specs satisfying dependency not found\` |
| **Gradle** | \`Execution failed for task\`, \`Could not resolve\`, \`Duplicate class\`, \`minSdkVersion\` |
| **Metro Bundler** | \`Unable to resolve module\`, \`SyntaxError\`, \`Invariant Violation\`, circular dependency |
| **TypeScript** | \`TS2307\`, \`TS2345\`, \`TS2322\`, type mismatch in navigation/native modules |
| **Expo Config** | \`expo-modules-autolinking\`, plugin misconfiguration, \`app.json\` schema errors |
| **EAS Build** | Credential errors, provisioning profile mismatch, keystore issues, \`eas.json\` misconfiguration |
| **Code Signing** | \`No signing certificate\`, \`Provisioning profile doesn't match\`, keystore password wrong |
| **WatermelonDB** | JSI compilation errors, native bridge failures, schema migration mismatches |
| **Firebase** | \`google-services.json\` missing, \`GoogleService-Info.plist\` mismatch, SDK version conflicts |
| **Environment** | Wrong Node version, missing Xcode CLI tools, Android SDK not found, JDK version |
| **Dependency Conflict** | Version mismatch, peer dependency warnings, duplicate React instances |

### Phase 3: Resolution

For each classified error, apply the appropriate resolution strategy:

#### Native Module Linking
\`\`\`bash
# Expo autolinking
npx expo prebuild --clean
# CocoaPods re-link
cd ios && pod deintegrate && pod install --repo-update
# Android clean
cd android && ./gradlew clean
\`\`\`

#### CocoaPods Failures
\`\`\`bash
cd ios && rm -rf Pods Podfile.lock
cd ios && pod cache clean --all
cd ios && pod install --repo-update
\`\`\`
- Check \`Podfile\` for correct platform version (\`platform :ios, '15.1'\` for Expo SDK 51)
- Verify Xcode version compatibility

#### Gradle Failures
\`\`\`bash
cd android && ./gradlew clean
rm -rf android/.gradle android/app/build
\`\`\`
- Check \`android/build.gradle\` for correct \`minSdkVersion\` (23 for Expo SDK 51)
- Check \`android/gradle/wrapper/gradle-wrapper.properties\` for correct Gradle version
- Resolve duplicate class errors by checking dependency tree: \`./gradlew :app:dependencies\`

#### Metro Bundler
\`\`\`bash
npx expo start --clear
# or
npx react-native start --reset-cache
rm -rf node_modules/.cache
\`\`\`
- For \`Unable to resolve module\`: check import paths, verify package is installed, check \`metro.config.js\` for custom resolvers
- For circular dependencies: trace the cycle and refactor to break it

#### TypeScript Errors
\`\`\`bash
npx tsc --noEmit
\`\`\`
- Fix type errors in order of severity
- For navigation types: ensure \`RootStackParamList\` is properly defined in \`src/navigation/types.ts\`
- For native module types: check \`@types/*\` packages or create declarations in \`src/types/\`

#### Expo Config Issues
\`\`\`bash
npx expo-doctor
npx expo prebuild --clean
\`\`\`
- Validate \`app.json\` / \`app.config.ts\` against Expo SDK 51 schema
- Check \`expo.plugins\` array for correct plugin configurations
- Verify \`expo-modules-autolinking\` can find all native modules

#### EAS Build Failures
\`\`\`bash
eas diagnostics
eas credentials
\`\`\`
- For iOS: verify provisioning profiles and certificates via \`eas credentials --platform ios\`
- For Android: verify keystore via \`eas credentials --platform android\`
- Check \`eas.json\` profiles match expected build configurations
- Verify environment variables are set in EAS Secrets

#### WatermelonDB Issues
- Verify \`@nozbe/watermelondb\` version compatibility with React Native 0.74
- Check that JSI is properly configured in \`babel.config.js\`
- Ensure schema version matches migration version in \`src/services/database/\`
- For iOS: verify \`WatermelonDB\` pod is linked in \`Podfile\`

#### Firebase Issues
- Verify \`google-services.json\` exists at \`android/app/google-services.json\`
- Verify \`GoogleService-Info.plist\` exists at \`ios/<AppName>/GoogleService-Info.plist\`
- Check Firebase SDK versions are compatible across \`@react-native-firebase/*\` packages
- Ensure \`firebase.json\` has correct configuration for each service

#### Nuclear Clean (when \`--clean\` flag is set or other fixes fail)
\`\`\`bash
# Remove all generated/cached artifacts
rm -rf node_modules
rm -rf ios/Pods ios/Podfile.lock ios/build
rm -rf android/.gradle android/app/build android/build
rm -rf .expo
rm -rf /tmp/metro-*
rm -rf /tmp/haste-map-*

# Reinstall
pnpm install
npx expo prebuild --clean
cd ios && pod install --repo-update
\`\`\`

### Phase 4: Verification

After applying fixes:

1. **Type check**
   \`\`\`bash
   npx tsc --noEmit
   \`\`\`

2. **Metro bundle test**
   \`\`\`bash
   npx expo export --platform ios --output-dir /tmp/expo-export-test 2>&1
   npx expo export --platform android --output-dir /tmp/expo-export-test 2>&1
   \`\`\`

3. **Platform build verification** (based on target)
   \`\`\`bash
   # iOS
   cd ios && xcodebuild -workspace *.xcworkspace -scheme <app> -configuration Debug -sdk iphonesimulator build 2>&1 | tail -20

   # Android
   cd android && ./gradlew assembleDebug 2>&1 | tail -20
   \`\`\`

4. **Run unit tests**
   \`\`\`bash
   pnpm test --passWithNoTests
   \`\`\`

5. **Lint check**
   \`\`\`bash
   pnpm lint
   \`\`\`

### Phase 5: Report

Output a structured report:

\`\`\`markdown
## Build Fix Report

**Target:** [ios | android | metro | eas | all]
**Status:** ✅ Resolved | ⚠️ Partially Resolved | ❌ Unresolved

### Errors Found
1. [Category]: [Brief description]
   - **Root Cause**: [explanation]
   - **Fix Applied**: [what was changed]
   - **Files Modified**: [list of files]

### Verification Results
- TypeScript: ✅ / ❌
- Metro Bundle: ✅ / ❌
- iOS Build: ✅ / ❌ / ⏭️ Skipped
- Android Build: ✅ / ❌ / ⏭️ Skipped
- Unit Tests: ✅ / ❌
- Lint: ✅ / ❌

### Manual Steps Required
- [Any steps that could not be automated, e.g., Xcode settings changes, EAS secret updates]

### Prevention Recommendations
- [Suggestions to avoid this error recurring, e.g., pin dependency version, add CI check]
\`\`\`

## Common React Native Build Error Patterns

### Pattern: "Multiple commands produce" (iOS)
- **Cause**: Duplicate resource files in Xcode build phases
- **Fix**: Add to \`Podfile\`:
  \`\`\`ruby
  post_install do |installer|
    installer.pods_project.targets.each do |target|
      target.build_configurations.each do |config|
        config.build_settings['EXPANDED_CODE_SIGN_IDENTITY'] = ""
        config.build_settings['CODE_SIGNING_REQUIRED'] = "NO"
        config.build_settings['CODE_SIGNING_ALLOWED'] = "NO"
      end
    end
  end
  \`\`\`

### Pattern: "Invariant Violation: requireNativeComponent" 
- **Cause**: Native module not linked or prebuild not run after adding native dependency
- **Fix**: \`npx expo prebuild --clean && cd ios && pod install\`

### Pattern: "Cannot find module '@react-native-firebase/*'"
- **Cause**: Firebase packages not installed or autolinking broken
- **Fix**: Verify all \`@react-native-firebase/*\` packages in \`package.json\`, run \`npx expo prebuild --clean\`

### Pattern: "Execution failed for task ':app:checkDebugDuplicateClasses'"
- **Cause**: Multiple versions of the same Android library
- **Fix**: Add resolution in \`android/build.gradle\` or use \`resolutionStrategy\` in Gradle

### Pattern: "Unable to resolve module ./assets/..." from Metro
- **Cause**: Asset not found or \`metro.config.js\` missing asset extension
- **Fix**: Verify file exists, check \`metro.config.js\` \`resolver.assetExts\` includes the file extension

### Pattern: EAS Build "credentials not found"
- **Cause**: Missing or expired provisioning profiles / certificates
- **Fix**: \`eas credentials --platform [ios|android]\` to reconfigure

## Sensitive File Awareness

When diagnosing build errors, **never output contents of**:
- \`.env\`, \`.env.*\` files
- \`google-services.json\` (may contain API keys)
- \`GoogleService-Info.plist\` (may contain API keys)
- Keystore files or passwords
- Provisioning profiles or certificates
- \`eas.json\` secrets section

Reference these files by name only. If their contents are needed for diagnosis, describe what fields to check without displaying values.

## Integration with Skills

This command activates the \`build-fix\` skill defined in \`plugin/codeforge-react-native/skills/build-fix/SKILL.md\` and may invoke the \`build-error-resolver\` agent from \`plugin/codeforge-react-native/agents/build-error-resolver.md\` for complex multi-platform failures.

## AI Code Attribution

If any source files are modified during the fix, add the following comment near the change:

\`\`\`typescript
// AI-GENERATED: build-fix applied — [brief description of change]
\`\`\`

This ensures compliance with the project's AI usage policy documented in \`docs/AI-USAGE-POLICY.md\`.`,

  'plugin/codeforge-react-native/commands/code-review.md': `# /code-review — React Native Mobile Code Review

## Command Signature

\`\`\`
/code-review [target] [--focus=<area>] [--severity=<level>] [--platform=<ios|android|both>]
\`\`\`

## Arguments

| Argument | Required | Default | Description |
|----------|----------|---------|-------------|
| \`target\` | No | Current diff/staged files | File path, directory, or PR reference |
| \`--focus\` | No | \`all\` | Focus area: \`performance\`, \`security\`, \`a11y\`, \`offline\`, \`navigation\`, \`native\`, \`platform\`, \`all\` |
| \`--severity\` | No | \`all\` | Filter: \`critical\`, \`warning\`, \`info\`, \`all\` |
| \`--platform\` | No | \`both\` | Platform scope: \`ios\`, \`android\`, \`both\` |

## Purpose

Performs a comprehensive code review tailored to React Native and mobile development. Goes beyond generic linting to catch mobile-specific issues: memory leaks from subscriptions, missing platform handling, accessibility gaps, offline data sync problems, insecure storage usage, navigation lifecycle bugs, and App Store/Google Play policy violations.

## Activation

\`\`\`
/code-review
/code-review src/features/auth/
/code-review --focus=security --platform=ios
/code-review src/features/payments/ --focus=performance --severity=critical
/code-review --focus=a11y
\`\`\`

## Execution Flow

### Step 1: Scope Resolution

Determine what code to review:

- **No target**: Inspect \`git diff --cached\` (staged files), fall back to \`git diff HEAD\` (unstaged changes)
- **File/directory target**: Review all \`.ts\`, \`.tsx\` files in the path
- **PR reference**: Fetch the full diff from the pull request

Filter to relevant files — skip generated code, lockfiles, and binary assets. Log the scope:

\`\`\`
Reviewing 12 files across src/features/auth/ and src/services/auth/
Platform scope: both (iOS + Android)
Focus: all areas
\`\`\`

### Step 2: Static Analysis Pre-Check

Run automated checks before manual review:

\`\`\`bash
# TypeScript strict compliance
pnpm tsc --noEmit --pretty 2>&1

# ESLint with React Native rules
pnpm eslint --ext .ts,.tsx <target-files> --format json

# Check for console.log/debug statements
grep -rn "console\\.\\(log\\|debug\\|warn\\|error\\)" <target-files> || true
\`\`\`

Report any failures as \`critical\` findings before proceeding.

### Step 3: Mobile-Specific Review

Apply each review lens to every file in scope. Use the agent defined in \`plugin/codeforge-react-native/agents/code-reviewer.md\` for evaluation criteria.

#### 3a. Component & Rendering Performance

Check for:

- **Missing memoization**: Components receiving object/array/function props without \`React.memo\`, \`useMemo\`, or \`useCallback\`
- **Inline styles**: Object literals in \`style\` prop causing re-renders — should use \`StyleSheet.create\`
- **FlatList misuse**: Missing \`keyExtractor\`, \`getItemLayout\`, \`windowSize\` tuning, or rendering heavy components without \`React.memo\`
- **Image optimization**: Using raw URIs without \`FastImage\` or Expo Image; missing \`resizeMode\`; large images without caching strategy
- **Re-render cascades**: Zustand selectors that return new references; React Query \`select\` functions creating new objects
- **Animation thread**: Animations not using \`useNativeDriver: true\` or Reanimated worklets; JS-thread-bound gestures
- **Large lists**: ScrollView with many children instead of FlatList/FlashList
- **Bundle size**: Importing entire libraries (\`import _ from 'lodash'\`) instead of specific functions

#### 3b. Security Review

Check for:

- **Insecure storage**: Using \`AsyncStorage\` for tokens, passwords, or PII — must use \`expo-secure-store\` (Keychain/Keystore)
- **Hardcoded secrets**: API keys, Firebase config values, or credentials in source code — must come from environment config
- **Certificate pinning**: Network calls to custom APIs without SSL pinning configuration
- **Deep link validation**: Deep link handlers that don't validate/sanitize incoming URL parameters
- **Biometric bypass**: Authentication flows that skip biometric re-verification for sensitive operations
- **Logging PII**: User emails, tokens, or personal data appearing in \`console.log\` or crash reports
- **WebView security**: \`WebView\` without \`originWhitelist\`, \`javaScriptEnabled\` without sandboxing, or \`onMessage\` without origin checks
- **Code obfuscation**: Production builds without Hermes bytecode or ProGuard/R8 rules
- **Clipboard exposure**: Sensitive data copied to clipboard without auto-clear

#### 3c. Offline-First & Data Sync

Check for:

- **Network assumptions**: API calls without offline fallback; missing \`NetInfo\` checks before sync operations
- **WatermelonDB patterns**: Direct Firestore reads when local DB should be source of truth; missing \`@lazy\` decorators; sync conflicts not handled
- **Optimistic updates**: Mutations that don't update local state before server confirmation
- **Queue management**: Offline mutations not queued for retry; missing exponential backoff
- **Cache invalidation**: React Query cache not coordinated with WatermelonDB sync timestamps
- **Large payload sync**: Initial sync downloading entire collections instead of incremental/paginated sync
- **Conflict resolution**: No strategy for concurrent edits (last-write-wins vs. merge)

#### 3d. Navigation & Lifecycle

Check for:

- **Type safety**: Navigation props not typed with \`NativeStackScreenProps\` or \`CompositeScreenProps\`; missing route param types
- **Memory leaks**: \`useEffect\` subscriptions (Firebase listeners, event emitters, timers) without cleanup in return function
- **Focus/blur handling**: Screens that fetch data in \`useEffect\` instead of \`useFocusEffect\` — stale data on tab switch
- **Deep link handling**: Missing \`linking\` config for screens; unhandled deep link routes
- **Back handler**: Android hardware back button not handled in modals or multi-step flows
- **Screen tracking**: Screens missing analytics \`screen_view\` events in \`useFocusEffect\`
- **Gesture conflicts**: Nested scroll views or gesture handlers without proper \`simultaneousHandlers\`

#### 3e. Accessibility (a11y)

Check for:

- **Missing labels**: Interactive elements (\`TouchableOpacity\`, \`Pressable\`, \`Button\`) without \`accessibilityLabel\`
- **Missing roles**: Components without \`accessibilityRole\` (\`button\`, \`link\`, \`header\`, \`image\`, etc.)
- **Missing hints**: Complex interactions without \`accessibilityHint\` explaining the result of the action
- **Touch target size**: Pressable areas smaller than 44x44 points (Apple HIG) / 48x48 dp (Material)
- **Color contrast**: Text colors that don't meet WCAG 2.1 AA (4.5:1 for normal text, 3:1 for large text)
- **Screen reader order**: \`accessibilityElementsHidden\` or \`importantForAccessibility\` misuse hiding content from screen readers
- **Dynamic type**: Fixed font sizes instead of using scaled typography from theme
- **Announcements**: State changes (loading, errors, success) not announced via \`AccessibilityInfo.announceForAccessibility\`
- **Reduced motion**: Animations not respecting \`useReducedMotion\` from Reanimated or \`AccessibilityInfo\`

#### 3f. Platform-Specific Issues

Check for:

- **Platform branching**: \`Platform.OS\` checks that handle \`ios\` but forget \`android\` (or vice versa)
- **Permission handling**: Missing runtime permission requests on Android 13+; missing Info.plist usage descriptions on iOS
- **Safe area**: Content not wrapped in \`SafeAreaView\` or not using \`useSafeAreaInsets\`; notch/dynamic island overlap
- **Keyboard handling**: Forms without \`KeyboardAvoidingView\` or \`KeyboardAwareScrollView\`; \`behavior\` prop not set per platform
- **Status bar**: Status bar style not managed per screen; content hidden behind translucent status bar
- **Android back**: Missing \`BackHandler\` for custom navigation flows
- **iOS swipe back**: \`gestureEnabled: false\` without alternative dismiss mechanism
- **Haptics**: Haptic feedback on Android without checking \`Vibration\` API availability
- **Notch/cutout**: Content in landscape not respecting display cutouts

#### 3g. Firebase & Backend Integration

Check for:

- **Firestore rules reliance**: Client-side security checks instead of Firestore Security Rules
- **Unbounded queries**: Firestore queries without \`.limit()\` — potential cost explosion
- **Missing indexes**: Compound queries that will fail without composite indexes
- **Listener cleanup**: \`onSnapshot\` listeners not unsubscribed on unmount
- **Auth state**: Components accessing user data without checking \`auth().currentUser\` first
- **Cloud Function errors**: Not handling Cloud Function timeout/retry scenarios
- **Push notification tokens**: FCM token not refreshed on \`onTokenRefresh\`; token not sent to backend on change
- **Storage URLs**: Firebase Storage download URLs used without expiration awareness

#### 3h. Compliance & Store Policies

Check for:

- **GDPR**: User data collection without consent flow; missing data deletion capability; analytics before consent
- **App Store**: Private API usage; missing purpose strings in Info.plist; in-app purchase not using StoreKit
- **Google Play**: Missing data safety declarations alignment; background location without foreground service
- **Privacy labels**: Data types collected not matching App Store privacy nutrition labels
- **Tracking transparency**: ATT prompt not shown before IDFA access on iOS 14.5+
- **Children's privacy**: If applicable, COPPA compliance checks

### Step 4: Findings Report

Format findings with severity, location, and actionable fix:

\`\`\`
## Code Review: src/features/auth/

### 🔴 Critical (2)

**[SEC-01] Token stored in AsyncStorage**
📍 \`src/features/auth/hooks/use-auth.ts:47\`
\`\`\`typescript
// ❌ Current
await AsyncStorage.setItem('auth_token', token);

// ✅ Fix
import * as SecureStore from 'expo-secure-store';
await SecureStore.setItemAsync('auth_token', token);
\`\`\`
📖 Tokens must use expo-secure-store (Keychain on iOS, Keystore on Android). See \`docs/ARCHITECTURE.md#security\`.

**[PERF-01] FlatList re-rendering entire list**
📍 \`src/features/home/screens/feed-screen.tsx:23\`
\`\`\`typescript
// ❌ Current — renderItem creates new function each render
<FlatList renderItem={({ item }) => <PostCard post={item} />} />

// ✅ Fix — extract and memoize
const renderItem = useCallback(({ item }) => <PostCard post={item} />, []);
<FlatList renderItem={renderItem} keyExtractor={keyExtractor} />
\`\`\`

### 🟡 Warning (3)

**[A11Y-01] Missing accessibilityLabel on login button**
📍 \`src/features/auth/components/login-form.tsx:89\`
Add \`accessibilityLabel="Sign in to your account"\` and \`accessibilityRole="button"\`.

**[NAV-01] useEffect instead of useFocusEffect**
📍 \`src/features/profile/screens/profile-screen.tsx:15\`
Data fetch in \`useEffect\` won't re-run when navigating back to this tab. Use \`useFocusEffect\` from \`@react-navigation/native\`.

**[OFFLINE-01] API call without offline fallback**
📍 \`src/features/home/hooks/use-feed.ts:22\`
Network request has no offline handling. Wrap with NetInfo check or use React Query's \`networkMode: 'offlineFirst'\`.

### 🔵 Info (2)

**[STYLE-01] Inline style object**
📍 \`src/features/auth/components/login-form.tsx:34\`
Move \`{{ marginTop: 16 }}\` to \`StyleSheet.create\` to avoid re-creation on render.

**[I18N-01] Hardcoded string**
📍 \`src/features/auth/components/login-form.tsx:91\`
\`"Login"\` should use \`t('auth.login')\` from i18n.

### Summary
| Severity | Count |
|----------|-------|
| 🔴 Critical | 2 |
| 🟡 Warning | 3 |
| 🔵 Info | 2 |

**Verdict**: ❌ Changes requested — resolve critical findings before merge.
\`\`\`

### Step 5: Verdict

Apply verdict based on findings:

| Condition | Verdict |
|-----------|---------|
| Zero critical, ≤2 warnings | ✅ **Approve** — Ship it |
| Zero critical, >2 warnings | 🟡 **Approve with suggestions** — Merge OK, address warnings in follow-up |
| Any critical findings | ❌ **Changes requested** — Must resolve before merge |
| Security critical in sensitive paths | 🚫 **Block** — Requires senior/lead review per CODEOWNERS |

Sensitive paths that trigger mandatory senior review:
- \`src/services/auth/**\`
- \`src/config/**\`
- \`src/features/payments/**\`
- \`google-services.json\`, \`GoogleService-Info.plist\`
- \`.env*\`, \`eas.json\`, \`app.config.ts\`

## Focus Area Details

When \`--focus\` is specified, run only the corresponding review lens at maximum depth:

| Focus | Review Lens | Extra Checks |
|-------|-------------|--------------|
| \`performance\` | 3a | Run \`npx react-native-bundle-visualizer\` analysis; check Hermes bytecode size |
| \`security\` | 3b, 3h | Cross-reference with OWASP Mobile Top 10; check all storage calls |
| \`a11y\` | 3e | Simulate VoiceOver/TalkBack flow; verify all interactive elements |
| \`offline\` | 3c | Trace full sync flow; verify queue persistence across app restart |
| \`navigation\` | 3d | Verify deep link config completeness; check all screen type params |
| \`native\` | 3f | Check both platform implementations; verify Expo Modules API usage |
| \`platform\` | 3f, 3g | Platform-specific + Firebase integration combined |

## Integration with CI

This command maps to the review stage in \`.github/workflows/ci.yml\`. When run in CI context:

1. Reads the PR diff from \`$GITHUB_EVENT_PATH\`
2. Posts findings as inline PR review comments via GitHub API
3. Sets check status based on verdict
4. Tags findings with \`ai-review\` label for audit trail per \`docs/AI-USAGE-POLICY.md\`

## Cross-References

- **Agent**: \`plugin/codeforge-react-native/agents/code-reviewer.md\` — Detailed evaluation criteria and persona
- **Skill**: \`plugin/codeforge-react-native/skills/code-review/SKILL.md\` — Skill definition and quality gates
- **Architecture**: \`docs/ARCHITECTURE.md\` — Project patterns and conventions to enforce
- **Contributing**: \`docs/CONTRIBUTING.md\` — PR requirements and review process
- **Security**: \`docs/AI-USAGE-POLICY.md\` — AI-generated code marking requirements`,

  'plugin/codeforge-react-native/commands/phase.md': `# /phase — Mobile Development Phase Execution

## Command Signature

\`\`\`
/phase <phase-name> [--feature <feature-name>] [--ticket <ticket-id>] [--platform <ios|android|both>]
\`\`\`

## Purpose

Execute a structured development phase for a React Native mobile feature, following the project's feature-based architecture. Each phase maps to a stage in the mobile development lifecycle — from scaffolding through native integration, offline support, and store submission readiness.

## Available Phases

### 1. \`scaffold\`

Create the feature directory structure and boilerplate files.

**What it does:**
- Creates \`src/features/<feature-name>/\` with subdirectories: \`screens/\`, \`components/\`, \`hooks/\`, \`types/\`, \`__tests__/\`
- Generates typed navigation params in \`src/navigation/types.ts\`
- Creates a Zustand slice if client state is needed (\`src/store/<feature>.ts\`)
- Creates React Query hooks if server state is needed (\`src/features/<feature>/hooks/use<Feature>Query.ts\`)
- Registers screens in the appropriate navigator (stack or tab)
- Adds i18n keys skeleton in \`src/i18n/en/<feature>.json\`
- Adds accessibility label constants

**Example:**
\`\`\`
/phase scaffold --feature payments --ticket APP-87
\`\`\`

**Output structure:**
\`\`\`
src/features/payments/
  screens/
    PaymentsScreen.tsx
    SubscriptionScreen.tsx
  components/
    PurchaseCard.tsx
    PriceTag.tsx
  hooks/
    usePayments.ts
    useSubscription.ts
  types/
    index.ts
  __tests__/
    PaymentsScreen.test.tsx
\`\`\`

**Validation checklist:**
- [ ] All files under 250 lines
- [ ] PascalCase for components/screens, camelCase for hooks
- [ ] TypeScript strict — no \`any\` types
- [ ] Navigation params typed in \`src/navigation/types.ts\`
- [ ] i18n keys created (no hardcoded strings)
- [ ] Accessibility labels on all interactive elements

---

### 2. \`ui\`

Build the screen UI and shared components for the feature.

**What it does:**
- Implements screen layouts using theme tokens from \`src/theme/\`
- Creates reusable components in \`src/features/<feature>/components/\`
- Applies responsive design using \`useWindowDimensions\` or a responsive utility
- Ensures all text passes through \`useTranslation()\` (i18n)
- Adds accessibility props: \`accessibilityLabel\`, \`accessibilityRole\`, \`accessibilityHint\`
- Handles platform-specific rendering with \`Platform.select()\` or \`.ios.tsx\`/\`.android.tsx\` files
- Implements loading, error, and empty states for every screen

**Validation checklist:**
- [ ] No hardcoded colors or spacing — use \`src/theme/\` tokens
- [ ] All strings from i18n
- [ ] Accessibility labels on every \`TouchableOpacity\`, \`Pressable\`, \`Button\`, \`TextInput\`
- [ ] Platform differences handled (safe area, status bar, notch)
- [ ] Loading/error/empty states implemented
- [ ] Components have typed props interfaces (no inline types)

---

### 3. \`state\`

Wire up client state (Zustand) and server state (React Query) for the feature.

**What it does:**
- Creates or updates Zustand store in \`src/store/\` for client-side state (UI preferences, form drafts, local flags)
- Creates React Query hooks in \`src/features/<feature>/hooks/\` for server data (Firebase Firestore reads, Cloud Function calls)
- Defines query keys in a \`queryKeys.ts\` file within the feature
- Implements optimistic updates where appropriate
- Adds cache invalidation strategies
- Connects to WatermelonDB models if offline support is needed

**Zustand pattern:**
\`\`\`typescript
// src/store/payments.ts
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';

interface PaymentsState {
  selectedPlan: string | null;
  setSelectedPlan: (plan: string | null) => void;
}

export const usePaymentsStore = create<PaymentsState>()(
  persist(
    (set) => ({
      selectedPlan: null,
      setSelectedPlan: (plan) => set({ selectedPlan: plan }),
    }),
    {
      name: 'payments-storage',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
\`\`\`

**React Query pattern:**
\`\`\`typescript
// src/features/payments/hooks/useSubscription.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { paymentKeys } from './queryKeys';
import { fetchSubscription, updateSubscription } from '../../../services/payments';

export const useSubscription = (userId: string) => {
  return useQuery({
    queryKey: paymentKeys.subscription(userId),
    queryFn: () => fetchSubscription(userId),
    staleTime: 5 * 60 * 1000,
  });
};
\`\`\`

**Validation checklist:**
- [ ] Zustand for client state only (UI, preferences, drafts)
- [ ] React Query for server state only (Firestore, Cloud Functions)
- [ ] Query keys centralized in \`queryKeys.ts\`
- [ ] No duplicate state between Zustand and React Query
- [ ] Persistence configured for stores that need it
- [ ] Types exported from \`types/index.ts\`

---

### 4. \`firebase\`

Integrate Firebase services for the feature.

**What it does:**
- Creates service functions in \`src/services/\` for Firestore reads/writes
- Implements Firebase Authentication flows if auth-related
- Sets up Cloud Functions triggers or callable functions
- Configures Firebase Cloud Messaging for push notification features
- Adds Firestore security rules for the feature's collections
- Implements Firebase Storage uploads if media is involved
- Adds proper error handling with typed Firebase error codes

**Service pattern:**
\`\`\`typescript
// src/services/payments.ts
import firestore from '@react-native-firebase/firestore';
import functions from '@react-native-firebase/functions';
import { Subscription, PaymentResult } from '../features/payments/types';

const subscriptionsRef = firestore().collection('subscriptions');

export const fetchSubscription = async (userId: string): Promise<Subscription> => {
  const doc = await subscriptionsRef.doc(userId).get();
  if (!doc.exists) {
    throw new Error('SUBSCRIPTION_NOT_FOUND');
  }
  return { id: doc.id, ...doc.data() } as Subscription;
};

export const processPayment = async (planId: string): Promise<PaymentResult> => {
  const callable = functions().httpsCallable<{ planId: string }, PaymentResult>('processPayment');
  const result = await callable({ planId });
  return result.data;
};
\`\`\`

**Validation checklist:**
- [ ] Service functions in \`src/services/\`, not in components
- [ ] Typed Firestore document interfaces
- [ ] Error handling with specific Firebase error codes
- [ ] Firestore security rules updated in \`firestore.rules\`
- [ ] No sensitive data logged (PII, tokens)
- [ ] Cloud Functions use typed request/response interfaces

---

### 5. \`offline\`

Add offline-first support using WatermelonDB.

**What it does:**
- Defines WatermelonDB models in \`src/database/models/\`
- Creates schema migrations in \`src/database/migrations/\`
- Implements sync adapter between WatermelonDB and Firestore
- Adds offline detection hook (\`useOffline\` from \`src/hooks/\`)
- Implements conflict resolution strategy
- Shows offline indicator in UI
- Queues mutations for replay when connectivity returns

**WatermelonDB model pattern:**
\`\`\`typescript
// src/database/models/Subscription.ts
import { Model } from '@nozbe/watermelondb';
import { field, date, readonly } from '@nozbe/watermelondb/decorators';

export default class Subscription extends Model {
  static table = 'subscriptions';

  @field('plan_id') planId!: string;
  @field('status') status!: string;
  @field('user_id') userId!: string;
  @date('expires_at') expiresAt!: Date;
  @readonly @date('created_at') createdAt!: Date;
  @readonly @date('updated_at') updatedAt!: Date;
}
\`\`\`

**Validation checklist:**
- [ ] WatermelonDB models match Firestore document structure
- [ ] Schema migration created (never modify existing schema directly)
- [ ] Sync adapter handles create/update/delete in both directions
- [ ] Conflict resolution strategy documented
- [ ] Offline indicator visible to user
- [ ] Queued mutations replayed on reconnect
- [ ] \`useOffline\` hook used to gate network-dependent features

---

### 6. \`native\`

Integrate platform-specific native functionality.

**What it does:**
- Implements biometric authentication via \`expo-local-authentication\`
- Configures deep linking in \`src/navigation/linking.ts\`
- Sets up in-app purchases via \`react-native-iap\` or \`expo-in-app-purchases\`
- Configures push notification handling (foreground, background, quit state)
- Adds Keychain/Keystore secure storage via \`expo-secure-store\`
- Implements platform-specific code with \`.ios.tsx\` / \`.android.tsx\` when needed
- Updates \`app.json\` / \`app.config.ts\` with required permissions and entitlements

**Platform flag:**
- \`--platform ios\` — Focus on iOS-specific implementation (Keychain, APNs, StoreKit)
- \`--platform android\` — Focus on Android-specific implementation (Keystore, FCM, Google Play Billing)
- \`--platform both\` (default) — Implement for both platforms

**Deep linking pattern:**
\`\`\`typescript
// src/navigation/linking.ts
import { LinkingOptions } from '@react-navigation/native';
import { RootStackParamList } from './types';

export const linking: LinkingOptions<RootStackParamList> = {
  prefixes: ['myapp://', 'https://myapp.com'],
  config: {
    screens: {
      Home: 'home',
      Profile: 'profile/:userId',
      Payments: {
        path: 'payments',
        screens: {
          Subscription: 'subscription',
          Purchase: 'purchase/:planId',
        },
      },
      NotFound: '*',
    },
  },
};
\`\`\`

**Validation checklist:**
- [ ] Both iOS and Android implementations present (or platform flag specified)
- [ ] Permissions declared in \`app.json\` / \`app.config.ts\`
- [ ] Sensitive data stored in Keychain (iOS) / Keystore (Android) via \`expo-secure-store\`
- [ ] Deep links tested with \`npx uri-scheme open\`
- [ ] Push notification handlers cover foreground, background, and quit states
- [ ] Native module errors caught and reported to Sentry

---

### 7. \`test\`

Write comprehensive tests for the feature.

**What it does:**
- Unit tests for hooks, utils, and store slices (Jest)
- Component tests for screens and UI components (React Native Testing Library)
- Integration tests for Firebase service functions (Jest with mocks)
- E2E tests for critical user flows (Detox)
- Snapshot tests for UI regression detection
- Achieves ≥75% coverage for the feature

**Test file placement:**
\`\`\`
src/features/payments/__tests__/
  PaymentsScreen.test.tsx          # Component test
  useSubscription.test.ts          # Hook test
  payments.store.test.ts           # Zustand store test
e2e/
  payments.e2e.ts                  # Detox E2E test
\`\`\`

**Component test pattern:**
\`\`\`typescript
import { render, fireEvent, waitFor } from '@testing-library/react-native';
import { PaymentsScreen } from '../screens/PaymentsScreen';
import { createTestWrapper } from '../../../../test/utils';

describe('PaymentsScreen', () => {
  it('displays subscription plans', async () => {
    const { getByText, getAllByTestId } = render(
      <PaymentsScreen />,
      { wrapper: createTestWrapper() },
    );

    await waitFor(() => {
      expect(getAllByTestId('purchase-card')).toHaveLength(3);
    });

    expect(getByText('Monthly')).toBeTruthy();
    expect(getByText('Annual')).toBeTruthy();
  });
});
\`\`\`

**Detox E2E pattern:**
\`\`\`typescript
describe('Payments Flow', () => {
  beforeAll(async () => {
    await device.launchApp({ newInstance: true });
  });

  it('should complete a subscription purchase', async () => {
    await element(by.id('tab-payments')).tap();
    await expect(element(by.id('payments-screen'))).toBeVisible();
    await element(by.id('plan-annual')).tap();
    await element(by.id('confirm-purchase')).tap();
    await expect(element(by.text('Purchase Successful'))).toBeVisible();
  });
});
\`\`\`

**Validation checklist:**
- [ ] Coverage ≥75% for the feature directory
- [ ] All screens have component tests
- [ ] All hooks have unit tests
- [ ] All Zustand stores have unit tests
- [ ] Critical flows have Detox E2E tests
- [ ] Firebase services mocked (no real network calls in unit tests)
- [ ] Accessibility tested (\`getByA11yLabel\`, \`getByRole\`)

---

### 8. \`release\`

Prepare the feature for App Store / Google Play submission.

**What it does:**
- Runs full lint, type check, and test suite
- Verifies GDPR compliance (consent flows, data deletion capability, privacy labels)
- Checks App Store Guidelines compliance (no private API usage, proper entitlements)
- Checks Google Play Policies compliance (data safety section, permissions rationale)
- Validates \`app.json\` / \`app.config.ts\` version bump
- Generates changelog entry from conventional commits
- Triggers EAS Build for staging channel
- Runs Detox E2E against staging build
- Prepares EAS Submit metadata

**Pre-submission checklist:**
- [ ] \`pnpm lint\` passes
- [ ] \`pnpm typecheck\` passes
- [ ] \`pnpm test\` passes with ≥75% coverage
- [ ] \`npx detox test --configuration ios.sim.release\` passes
- [ ] \`npx detox test --configuration android.emu.release\` passes
- [ ] Version bumped in \`app.json\` (semver)
- [ ] Changelog updated
- [ ] Privacy labels / data safety section updated if new data collected
- [ ] GDPR consent flow tested for new data processing
- [ ] Secure storage used for sensitive data (no AsyncStorage for tokens/secrets)
- [ ] Certificate pinning configured for production API endpoints
- [ ] Code obfuscation enabled in EAS build profile
- [ ] Sentry source maps uploaded
- [ ] Firebase Crashlytics dSYMs uploaded (iOS)
- [ ] Screenshots updated if UI changed
- [ ] \`eas build --profile staging --platform all\` succeeds
- [ ] QA sign-off on staging build

**Commands executed:**
\`\`\`bash
pnpm lint
pnpm typecheck
pnpm test --coverage
eas build --profile staging --platform all
npx detox test --configuration ios.sim.release
npx detox test --configuration android.emu.release
eas submit --profile staging --platform all
\`\`\`

---

## Flags

| Flag | Description | Default |
|------|-------------|---------|
| \`--feature <name>\` | Target feature directory under \`src/features/\` | Required for scaffold, ui, state, firebase, offline, native, test |
| \`--ticket <id>\` | GitHub Issue ID (e.g., \`APP-42\`) for commit messages and branch naming | None |
| \`--platform <ios\\|android\\|both>\` | Target platform for native phase | \`both\` |
| \`--dry-run\` | Preview changes without writing files | \`false\` |
| \`--skip-tests\` | Skip test generation (scaffold/ui phases only) | \`false\` |

## Phase Dependencies

Phases should generally be executed in order, but can be run independently if prerequisites are met:

\`\`\`
scaffold → ui → state → firebase → offline → native → test → release
\`\`\`

- \`ui\` requires \`scaffold\` (directory structure must exist)
- \`state\` requires \`scaffold\` (types must be defined)
- \`firebase\` requires \`state\` (query hooks must exist to wire up)
- \`offline\` requires \`firebase\` (needs Firestore schema to mirror)
- \`native\` can run after \`scaffold\` (independent of state/firebase)
- \`test\` requires all feature code to be written
- \`release\` requires \`test\` to pass

## Usage Examples

\`\`\`bash
# Scaffold a new feature
/phase scaffold --feature notifications --ticket APP-55

# Build the UI for an existing feature
/phase ui --feature notifications

# Add offline support
/phase offline --feature notifications

# iOS-only native integration
/phase native --feature payments --platform ios

# Run all tests for a feature
/phase test --feature payments --ticket APP-87

# Prepare for store submission
/phase release --ticket APP-100

# Preview what scaffold would create
/phase scaffold --feature analytics --dry-run
\`\`\`

## AI Code Attribution

All code generated during any phase is marked with the AI attribution comment:

\`\`\`typescript
// AI-generated: Claude — /phase <phase-name> — <ticket-id>
\`\`\`

This comment is placed at the top of each generated file. Reviewers can filter for AI-generated code during PR review per the project's [AI Usage Policy](../../../docs/AI-USAGE-POLICY.md).

## Related

- **Skill definition**: \`plugin/codeforge-react-native/skills/phase/SKILL.md\`
- **Planner agent**: \`plugin/codeforge-react-native/agents/planner.md\`
- **Architect agent**: \`plugin/codeforge-react-native/agents/architect.md\`
- **Architecture guide**: \`docs/ARCHITECTURE.md\`
- **Contributing guide**: \`docs/CONTRIBUTING.md\``,

  'plugin/codeforge-react-native/commands/plan.md': `# /plan — React Native Implementation Plan Generator

## Command Purpose

Generate a detailed, mobile-specific implementation plan for a feature or task in this React Native/Expo/Firebase project. The plan accounts for platform differences (iOS/Android), offline-first architecture, navigation, native modules, and deployment via EAS.

## When to Use

- Starting a new feature from a GitHub Issue
- Breaking down a complex mobile feature into implementable tasks
- Planning work that touches native code, navigation, or Firebase services
- Preparing a feature for sprint planning or PR breakdown

## Invocation

\`\`\`
/plan <description or GitHub Issue reference>
\`\`\`

### Examples

\`\`\`
/plan APP-42 Add push notification opt-in flow
/plan Implement biometric authentication for login
/plan Add offline-first sync for user favorites
/plan In-app purchase flow for premium subscription
\`\`\`

## Plan Generation Process

### Step 1: Understand the Requirement

1. Parse the description or fetch the GitHub Issue details
2. Identify the feature domain — map to \`src/features/\` directory
3. Determine which platforms are affected (iOS, Android, or both)
4. Identify Firebase services involved (Auth, Firestore, Cloud Functions, Messaging, Storage)
5. Check if offline support is required (WatermelonDB sync)

### Step 2: Analyze Impact Areas

Evaluate each area and flag those affected:

| Area | Check |
|---|---|
| **Navigation** | New screens? New navigator? Deep link routes? |
| **State** | New Zustand store? New React Query queries/mutations? |
| **Offline** | WatermelonDB models? Sync logic? Conflict resolution? |
| **Native Modules** | Expo Modules API? Third-party native dependencies? |
| **Permissions** | Camera, location, notifications, biometrics, contacts? |
| **Firebase** | Auth flows? Firestore collections? Cloud Functions? FCM topics? |
| **i18n** | New translation keys? RTL considerations? |
| **Accessibility** | Screen reader labels? Focus management? Reduced motion? |
| **Security** | Secure storage (Keychain/Keystore)? Certificate pinning? Data encryption? |
| **Privacy** | GDPR consent? App Store privacy labels? Google Play data safety? |
| **In-App Purchases** | StoreKit/Google Play Billing? Receipt validation? |
| **Analytics** | New events? Screen tracking? Conversion funnels? |

### Step 3: Generate the Plan

Output a structured plan with the following sections:

---

## Plan Output Format

\`\`\`markdown
# Implementation Plan: <Feature Title>

**Issue**: <GitHub Issue reference or N/A>
**Feature Directory**: src/features/<domain>/
**Platforms**: iOS ✅ | Android ✅
**Offline Support**: Yes/No
**Estimated Complexity**: S / M / L / XL

## Summary

<2-3 sentence description of what will be built and why>

## Architecture Decisions

- <Key decision 1 — e.g., "Use Zustand for local toggle state, React Query for server-side notification preferences">
- <Key decision 2 — e.g., "WatermelonDB model for favorites with Firestore sync adapter">
- <Key decision 3 — e.g., "Expo Notifications API instead of raw FCM for cross-platform consistency">

## Platform Considerations

### iOS
- <iOS-specific requirement — e.g., "APNs entitlement, provisional push authorization">
- <Config change — e.g., "Update app.json expo.ios.infoPlist for NSFaceIDUsageDescription">

### Android
- <Android-specific requirement — e.g., "Notification channels for Android 8+">
- <Config change — e.g., "Update app.json expo.android.permissions">

## Dependencies

### New Packages
| Package | Purpose | Native Module? |
|---|---|---|
| <package-name> | <why needed> | Yes/No |

### Firebase Services
- <Service and how it's used>

## File Plan

### New Files
| File | Purpose |
|---|---|
| \`src/features/<domain>/screens/FeatureScreen.tsx\` | <description> |
| \`src/features/<domain>/components/FeatureCard.tsx\` | <description> |
| \`src/features/<domain>/hooks/useFeature.ts\` | <description> |
| \`src/features/<domain>/types/index.ts\` | <description> |
| \`src/services/<service-name>.ts\` | <description> |

### Modified Files
| File | Change |
|---|---|
| \`src/navigation/types.ts\` | Add new screen params |
| \`src/navigation/MainNavigator.tsx\` | Register new screen |
| \`src/i18n/en.json\` | Add translation keys |

### Test Files
| File | Type | Coverage Target |
|---|---|---|
| \`src/features/<domain>/hooks/__tests__/useFeature.test.ts\` | Unit | Hook logic |
| \`src/features/<domain>/screens/__tests__/FeatureScreen.test.tsx\` | Component | Render + interaction |
| \`e2e/feature-name.e2e.ts\` | E2E (Detox) | Critical user path |

## Implementation Tasks

### Phase 1: Foundation
- [ ] Create feature directory structure under \`src/features/<domain>/\`
- [ ] Define TypeScript types and interfaces in \`types/index.ts\`
- [ ] Add navigation types and register screen in navigator
- [ ] Add i18n translation keys

### Phase 2: Data Layer
- [ ] Create/update WatermelonDB models (if offline)
- [ ] Implement React Query hooks for server state
- [ ] Implement Zustand store slice for client state
- [ ] Set up Firebase service functions (Firestore queries, Cloud Functions)
- [ ] Implement sync adapter (if offline-first)

### Phase 3: UI Implementation
- [ ] Build screen component(s) with accessibility labels
- [ ] Build feature-specific components
- [ ] Wire up navigation and deep linking
- [ ] Implement loading, error, and empty states
- [ ] Add platform-specific UI adjustments (iOS/Android)

### Phase 4: Native Integration
- [ ] Configure permissions in app.json / app.config.ts
- [ ] Implement native module integration (if applicable)
- [ ] Test on physical iOS device
- [ ] Test on physical Android device

### Phase 5: Testing
- [ ] Write unit tests for hooks and utilities (≥75% coverage)
- [ ] Write component tests for screens and components
- [ ] Write Detox E2E test for critical path
- [ ] Test offline scenarios (airplane mode, sync recovery)
- [ ] Test deep link handling

### Phase 6: Polish & Compliance
- [ ] Add analytics events (Firebase Analytics)
- [ ] Add crash reporting breadcrumbs (Sentry)
- [ ] Verify GDPR compliance (consent flows, data deletion)
- [ ] Update App Store privacy labels / Google Play data safety (if new data collected)
- [ ] Verify accessibility with screen reader (VoiceOver / TalkBack)

## Security Considerations

- <Security item — e.g., "Store auth tokens in expo-secure-store (Keychain/Keystore)">
- <Security item — e.g., "Validate receipts server-side via Cloud Function">
- <Security item — e.g., "Sanitize user input before Firestore write">

## Deep Linking

- **URI**: \`myapp://<path>\` or \`https://myapp.link/<path>\`
- **Navigation target**: \`<ScreenName>\` with params \`{ <param>: <type> }\`
- **Update**: \`src/navigation/linking-config.ts\`

## Rollout Strategy

- [ ] Feature flag via Firebase Remote Config: \`feature_<name>_enabled\`
- [ ] Deploy to staging channel via \`eas update --branch staging\`
- [ ] Internal testing on TestFlight / Google Play Internal Track
- [ ] Gradual rollout: 10% → 50% → 100%

## PR Breakdown

| PR | Branch | Description | Depends On |
|---|---|---|---|
| 1 | \`feat/APP-XX-<name>-types-nav\` | Types, navigation, i18n keys | — |
| 2 | \`feat/APP-XX-<name>-data-layer\` | Models, queries, stores, Firebase | PR 1 |
| 3 | \`feat/APP-XX-<name>-ui\` | Screens, components, deep linking | PR 2 |
| 4 | \`feat/APP-XX-<name>-native\` | Permissions, native integration | PR 3 |
| 5 | \`feat/APP-XX-<name>-tests\` | Unit, component, E2E tests | PR 3 |
| 6 | \`feat/APP-XX-<name>-polish\` | Analytics, a11y, compliance | PR 4, 5 |
\`\`\`

---

## Validation Checklist

Before finalizing the plan, verify:

- [ ] Every new file follows naming conventions (kebab-case files, PascalCase components, camelCase hooks)
- [ ] No file exceeds 250-line estimate — split if needed
- [ ] All interactive elements have accessibility labels noted
- [ ] All user-facing text routes through i18n
- [ ] Offline behavior is explicitly defined (if applicable)
- [ ] Both iOS and Android are addressed
- [ ] Security-sensitive paths are identified (see \`src/services/auth/**\`, \`src/config/**\`)
- [ ] Test files cover unit, component, and E2E layers
- [ ] PR breakdown follows conventional commit naming: \`feat/APP-XX-description\`
- [ ] Coverage target of 75% is achievable with proposed test files

## Integration with Other Commands

- After \`/plan\`, use \`/tdd\` to begin test-driven implementation of individual tasks
- Use \`/phase\` to track progress through implementation phases
- Use \`/verify\` before each PR to validate completeness
- Use \`/code-review\` to review PRs against the plan

## References

- [Plan Skill](../skills/plan/SKILL.md) — detailed planning methodology
- [Planner Agent](../agents/planner.md) — agent persona for planning tasks
- [Architect Agent](../agents/architect.md) — agent persona for architecture decisions
- [Architecture Guide](../../../docs/ARCHITECTURE.md) — project architecture reference
- [Contributing Guide](../../../docs/CONTRIBUTING.md) — coding standards and PR process`,

  'plugin/codeforge-react-native/commands/tdd.md': `# /tdd — Test-Driven Development for React Native

## Command Signature

\`\`\`
/tdd <scope> [--platform ios|android|both] [--layer unit|component|e2e|all] [--offline] [--snapshot]
\`\`\`

## Purpose

Drive React Native feature implementation through strict Red-Green-Refactor cycles. Write failing tests first, implement the minimum code to pass, then refactor — with full awareness of mobile-specific concerns like platform differences, offline behavior, native modules, navigation, and async storage.

## Arguments

| Argument | Required | Description |
|----------|----------|-------------|
| \`scope\` | Yes | Feature, component, hook, service, or screen to implement via TDD |
| \`--platform\` | No | Target platform (\`ios\`, \`android\`, \`both\`). Default: \`both\` |
| \`--layer\` | No | Test layer to focus on (\`unit\`, \`component\`, \`e2e\`, \`all\`). Default: \`all\` |
| \`--offline\` | No | Include offline-first scenarios with WatermelonDB sync tests |
| \`--snapshot\` | No | Include snapshot tests for UI components |

## Workflow

### Phase 1: Scope Analysis

1. Parse the \`scope\` to determine what is being built:
   - **Screen**: \`src/features/{feature}/screens/{ScreenName}.tsx\`
   - **Component**: \`src/features/{feature}/components/{ComponentName}.tsx\` or \`src/components/{ComponentName}.tsx\`
   - **Hook**: \`src/features/{feature}/hooks/use{HookName}.ts\` or \`src/hooks/use{HookName}.ts\`
   - **Service**: \`src/services/{serviceName}.ts\`
   - **Store**: \`src/store/{storeName}.ts\`
   - **Navigation**: \`src/navigation/{navigatorName}.tsx\`

2. Identify related files that will need tests:
   - Types in \`types/\` subdirectory
   - i18n keys in \`src/i18n/\`
   - Navigation route params
   - Zustand store slices
   - React Query hooks

3. Check for existing tests and implementation:
   \`\`\`bash
   find src -path "*\${scope}*" -name "*.test.tsx" -o -name "*.test.ts" 2>/dev/null
   find e2e -name "*.test.ts" 2>/dev/null | head -20
   \`\`\`

4. Verify test infrastructure:
   \`\`\`bash
   pnpm test --listTests 2>/dev/null | head -5
   cat jest.config.ts 2>/dev/null || cat jest.config.js 2>/dev/null
   cat .detoxrc.js 2>/dev/null
   \`\`\`

### Phase 2: Test Plan Generation

Create a test plan document before writing any code:

\`\`\`markdown
## TDD Plan: {scope}

### Unit Tests
- [ ] Pure logic functions (validation, formatting, transformations)
- [ ] Zustand store actions and selectors
- [ ] Utility helpers

### Hook Tests
- [ ] Custom hook behavior with renderHook
- [ ] React Query integration (loading, success, error states)
- [ ] Offline state transitions

### Component Tests
- [ ] Renders correctly with required props
- [ ] Handles user interactions (press, swipe, input)
- [ ] Accessibility labels and roles present
- [ ] Loading/error/empty states
- [ ] Platform-specific rendering (if --platform specified)

### Screen Tests
- [ ] Navigation integration (route params, navigation actions)
- [ ] Data fetching lifecycle
- [ ] Form submission flows
- [ ] Deep link handling

### E2E Tests (Detox)
- [ ] Happy path user flow
- [ ] Error recovery
- [ ] Offline behavior (if --offline)
- [ ] Platform-specific interactions
\`\`\`

### Phase 3: Red-Green-Refactor Cycles

Execute TDD cycles in this strict order. **Never skip the red phase.**

#### Cycle Structure

\`\`\`
┌─────────────────────────────────────────────┐
│  🔴 RED: Write a failing test               │
│  ├─ Run: pnpm test --testPathPattern={file} │
│  ├─ Confirm: test FAILS with expected error  │
│  └─ If test passes → test is wrong, fix it  │
│                                              │
│  🟢 GREEN: Write minimum code to pass       │
│  ├─ Implement only what the test requires    │
│  ├─ Run: pnpm test --testPathPattern={file}  │
│  ├─ Confirm: test PASSES                     │
│  └─ If test fails → fix implementation       │
│                                              │
│  🔵 REFACTOR: Clean up without breaking      │
│  ├─ Extract shared logic, improve naming     │
│  ├─ Run: pnpm test --testPathPattern={file}  │
│  ├─ Confirm: all tests still PASS            │
│  └─ Check: file ≤ 250 lines                 │
└─────────────────────────────────────────────┘
\`\`\`

#### Cycle Ordering (Bottom-Up)

1. **Types first** — Define TypeScript interfaces/types
2. **Utils/helpers** — Pure functions with unit tests
3. **Services** — API/Firebase service layer with mocked backends
4. **Store** — Zustand store with action tests
5. **Hooks** — Custom hooks with \`renderHook\` tests
6. **Components** — UI components with React Native Testing Library
7. **Screens** — Full screen integration with navigation mocks
8. **E2E** — Detox flows for critical paths

### Phase 4: Mobile-Specific Test Patterns

#### Component Test Template

\`\`\`typescript
// src/features/{feature}/components/__tests__/{Component}.test.tsx
import React from 'react';
import { render, fireEvent, waitFor } from '@testing-library/react-native';
import { {Component} } from '../{Component}';

// Wrap with providers as needed
const renderWithProviders = (ui: React.ReactElement) => {
  return render(
    <NavigationContainer>
      <QueryClientProvider client={queryClient}>
        {ui}
      </QueryClientProvider>
    </NavigationContainer>,
  );
};

describe('{Component}', () => {
  it('renders with required props', () => {
    const { getByTestId } = renderWithProviders(
      <{Component} testID="{component}-root" />,
    );
    expect(getByTestId('{component}-root')).toBeTruthy();
  });

  it('has accessibility labels on interactive elements', () => {
    const { getByLabelText } = renderWithProviders(<{Component} />);
    expect(getByLabelText('{expected a11y label}')).toBeTruthy();
  });

  it('handles press interaction', async () => {
    const onPress = jest.fn();
    const { getByRole } = renderWithProviders(
      <{Component} onPress={onPress} />,
    );
    fireEvent.press(getByRole('button'));
    await waitFor(() => expect(onPress).toHaveBeenCalledTimes(1));
  });
});
\`\`\`

#### Hook Test Template

\`\`\`typescript
// src/features/{feature}/hooks/__tests__/use{Hook}.test.ts
import { renderHook, act, waitFor } from '@testing-library/react-native';
import { use{Hook} } from '../use{Hook}';

describe('use{Hook}', () => {
  it('returns initial state', () => {
    const { result } = renderHook(() => use{Hook}());
    expect(result.current.data).toBeUndefined();
    expect(result.current.isLoading).toBe(false);
  });

  it('handles async operation', async () => {
    const { result } = renderHook(() => use{Hook}());
    act(() => { result.current.execute(); });
    await waitFor(() => {
      expect(result.current.isLoading).toBe(false);
      expect(result.current.data).toBeDefined();
    });
  });
});
\`\`\`

#### Zustand Store Test Template

\`\`\`typescript
// src/store/__tests__/{store}.test.ts
import { use{Store} } from '../{store}';

describe('{store}', () => {
  beforeEach(() => {
    use{Store}.setState(use{Store}.getInitialState());
  });

  it('has correct initial state', () => {
    const state = use{Store}.getState();
    expect(state.someValue).toBe(expectedDefault);
  });

  it('updates state via action', () => {
    use{Store}.getState().setSomeValue('new');
    expect(use{Store}.getState().someValue).toBe('new');
  });
});
\`\`\`

#### Firebase Service Test Template

\`\`\`typescript
// src/services/__tests__/{service}.test.ts
import { {service} } from '../{service}';

// Mock Firebase modules
jest.mock('@react-native-firebase/firestore', () => ({
  __esModule: true,
  default: () => ({
    collection: jest.fn().mockReturnThis(),
    doc: jest.fn().mockReturnThis(),
    get: jest.fn(),
    set: jest.fn(),
    onSnapshot: jest.fn(),
  }),
}));

describe('{service}', () => {
  it('fetches data from Firestore', async () => {
    // Arrange mock, Act, Assert
  });
});
\`\`\`

#### Offline-First Test Pattern (WatermelonDB)

\`\`\`typescript
// When --offline flag is set
describe('{feature} offline behavior', () => {
  it('reads from local WatermelonDB when offline', async () => {
    // Mock NetInfo to return offline
    jest.mock('@react-native-community/netinfo', () => ({
      fetch: jest.fn().mockResolvedValue({ isConnected: false }),
      addEventListener: jest.fn(),
    }));
    // Assert data comes from local DB
  });

  it('queues writes for sync when offline', async () => {
    // Perform write action
    // Assert local DB updated
    // Assert sync queue has pending operation
  });

  it('syncs pending changes when coming back online', async () => {
    // Simulate offline → online transition
    // Assert Firestore receives queued writes
    // Assert local DB marked as synced
  });
});
\`\`\`

#### Platform-Specific Test Pattern

\`\`\`typescript
// When --platform is specified
import { Platform } from 'react-native';

describe('{Component} on iOS', () => {
  beforeAll(() => {
    Platform.OS = 'ios';
  });

  it('renders iOS-specific UI', () => {
    // Assert iOS behavior (e.g., blur view, haptics)
  });
});

describe('{Component} on Android', () => {
  beforeAll(() => {
    Platform.OS = 'android';
  });

  it('renders Android-specific UI', () => {
    // Assert Android behavior (e.g., ripple effect, back handler)
  });
});
\`\`\`

#### Navigation Test Pattern

\`\`\`typescript
// src/features/{feature}/screens/__tests__/{Screen}.test.tsx
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

const Stack = createNativeStackNavigator();

const renderScreen = (params = {}) => {
  return render(
    <NavigationContainer>
      <Stack.Navigator>
        <Stack.Screen
          name="{Screen}"
          component={{Screen}}
          initialParams={params}
        />
      </Stack.Navigator>
    </NavigationContainer>,
  );
};

describe('{Screen}', () => {
  it('renders with route params', () => {
    const { getByText } = renderScreen({ id: '123' });
    expect(getByText('Expected content')).toBeTruthy();
  });
});
\`\`\`

#### Detox E2E Test Pattern

\`\`\`typescript
// e2e/{feature}.test.ts
describe('{Feature} E2E', () => {
  beforeAll(async () => {
    await device.launchApp({ newInstance: true });
  });

  beforeEach(async () => {
    await device.reloadReactNative();
  });

  it('completes happy path flow', async () => {
    await element(by.id('{screen}-input')).typeText('test value');
    await element(by.id('{screen}-submit-button')).tap();
    await waitFor(element(by.id('{screen}-success')))
      .toBeVisible()
      .withTimeout(5000);
  });

  it('handles error state gracefully', async () => {
    // Trigger error condition
    await waitFor(element(by.id('{screen}-error-message')))
      .toBeVisible()
      .withTimeout(3000);
    await element(by.id('{screen}-retry-button')).tap();
  });
});
\`\`\`

### Phase 5: Verification

After all cycles complete:

\`\`\`bash
# Run all tests for the feature
pnpm test --testPathPattern="src/features/{feature}" --coverage

# Type check
pnpm exec tsc --noEmit

# Lint
pnpm exec eslint "src/features/{feature}/**/*.{ts,tsx}"

# Verify coverage meets threshold
pnpm test --coverage --coverageThreshold='{"global":{"branches":75,"functions":75,"lines":75,"statements":75}}'
\`\`\`

If \`--layer e2e\` or \`--layer all\`:
\`\`\`bash
# Build Detox test app
npx detox build --configuration ios.sim.debug

# Run E2E tests
npx detox test --configuration ios.sim.debug e2e/{feature}.test.ts
\`\`\`

### Phase 6: Summary Report

Output a summary after completion:

\`\`\`markdown
## TDD Summary: {scope}

### Cycles Completed: {N}
### Tests Written: {count}
| Layer     | Tests | Passing | Coverage |
|-----------|-------|---------|----------|
| Unit      | X     | ✅       | XX%      |
| Hook      | X     | ✅       | XX%      |
| Component | X     | ✅       | XX%      |
| Screen    | X     | ✅       | XX%      |
| E2E       | X     | ✅       | N/A      |

### Files Created/Modified
- \`src/features/{feature}/components/{Component}.tsx\`
- \`src/features/{feature}/components/__tests__/{Component}.test.tsx\`
- ...

### Platform Coverage
- [x] iOS
- [x] Android

### Mobile Concerns Addressed
- [ ] Accessibility labels on all interactive elements
- [ ] i18n keys used (no hardcoded strings)
- [ ] Offline behavior tested (if applicable)
- [ ] Navigation typed with route params
- [ ] Loading/error/empty states handled
- [ ] File length ≤ 250 lines per file
\`\`\`

## Examples

\`\`\`bash
# TDD a new authentication screen
/tdd auth/login-screen --layer all --platform both

# TDD a shared button component with snapshots
/tdd components/PrimaryButton --layer component --snapshot

# TDD an offline-first data sync hook
/tdd features/home/hooks/useFeedSync --layer unit --offline

# TDD a Firebase service
/tdd services/notification-service --layer unit

# TDD a Zustand store
/tdd store/auth-store --layer unit

# TDD a full feature end-to-end
/tdd features/payments --layer all --platform both --offline

# TDD just the E2E layer for an existing feature
/tdd features/profile --layer e2e --platform ios
\`\`\`

## Rules

1. **Never write implementation before a failing test.** Every line of production code must be justified by a red test.
2. **Run tests after every change.** Use \`pnpm test --testPathPattern={file} --watch\` during development.
3. **One assertion focus per test.** Tests should verify one behavior. Multiple \`expect\` calls are fine if they assert the same logical behavior.
4. **Mock at boundaries.** Mock Firebase, native modules, navigation, and network — not internal functions.
5. **All interactive elements need \`accessibilityLabel\` or \`testID\`.** Tests should query by accessibility role/label first, \`testID\` second.
6. **All user-visible text through i18n.** Tests should verify i18n keys are used, not hardcoded strings.
7. **Platform tests are not optional when \`--platform both\`.** If behavior differs per platform, write platform-specific tests.
8. **Keep test files next to source** in \`__tests__/\` directories within the feature folder.
9. **Detox tests go in \`e2e/\`** at the project root, organized by feature.
10. **Coverage must meet 75% threshold** before marking a cycle as complete.

## Related

- Skill: \`plugin/codeforge-react-native/skills/tdd/SKILL.md\`
- Agent: \`plugin/codeforge-react-native/agents/tdd-guide.md\`
- Verify command: \`plugin/codeforge-react-native/commands/verify.md\`
- Architecture: \`docs/ARCHITECTURE.md\`
- Contributing: \`docs/CONTRIBUTING.md\``,

  'plugin/codeforge-react-native/commands/verify.md': `# /verify — React Native Implementation Verification

## Command: \`/verify\`

Runs a comprehensive verification suite against the current working branch to confirm that code changes meet all quality, platform, and compliance gates before a pull request is opened.

## Usage

\`\`\`
/verify                          # Full verification (all checks)
/verify --quick                  # Fast pass: lint + types + unit tests only
/verify --platform ios           # iOS-specific checks only
/verify --platform android       # Android-specific checks only
/verify --scope <feature>        # Verify a specific feature directory
/verify --fix                    # Auto-fix lint/format issues, then verify
/verify --ci                     # Simulate the full CI pipeline locally
\`\`\`

## Verification Pipeline

When \`/verify\` is invoked, execute the following stages **in order**. Stop on the first failure unless \`--continue-on-error\` is passed.

### Stage 1 — File Hygiene

1. Confirm no files exceed **250 lines**. Flag violators with line counts.
2. Confirm naming conventions:
   - Components/screens: \`PascalCase.tsx\`
   - Hooks: \`camelCase.ts\` (prefixed with \`use\`)
   - Utils/services: \`camelCase.ts\`
   - Files on disk: \`kebab-case\` directories
   - Constants: \`SCREAMING_SNAKE_CASE\`
3. Confirm feature modules follow the required structure:
   \`\`\`
   src/features/<name>/
     screens/
     components/
     hooks/
     types/
   \`\`\`
4. Confirm no sensitive files are staged or modified without justification:
   - \`src/services/auth/**\`
   - \`src/config/**\`
   - \`google-services.json\`
   - \`GoogleService-Info.plist\`
   - \`.env*\`
5. Confirm no secrets, API keys, or tokens are hardcoded in source files. Scan for patterns: \`AIza\`, \`sk_live_\`, \`AAAA\`, Bearer tokens, private keys.
6. Confirm all new/modified text strings go through \`i18n\` — no raw user-facing strings in JSX.

### Stage 2 — Formatting & Linting

Run and report results:

\`\`\`bash
pnpm prettier --check "src/**/*.{ts,tsx,json}"
pnpm eslint src/ --ext .ts,.tsx --max-warnings 0
\`\`\`

If \`--fix\` is passed:

\`\`\`bash
pnpm prettier --write "src/**/*.{ts,tsx,json}"
pnpm eslint src/ --ext .ts,.tsx --fix
\`\`\`

### Stage 3 — TypeScript Type Checking

\`\`\`bash
pnpm tsc --noEmit --strict
\`\`\`

Verify:
- No \`any\` types (strict mode enforced, \`noImplicitAny: true\`)
- All React Navigation navigators are fully typed (check \`navigation/types.ts\` exports match navigator definitions)
- All Zustand stores have explicit type interfaces
- All React Query hooks have typed return values
- WatermelonDB model decorators match schema definitions

### Stage 4 — Unit & Component Tests

\`\`\`bash
pnpm test --coverage --ci --reporters=default --reporters=jest-junit
\`\`\`

Verify:
- All tests pass
- Coverage meets **75%** threshold (statements, branches, functions, lines)
- Every new screen has at least one snapshot or component test
- Every new hook has at least one unit test
- Every new service function has at least one unit test
- Accessibility: tests use \`getByLabelText\` / \`getByRole\` where applicable

### Stage 5 — Platform-Specific Checks

#### iOS

\`\`\`bash
# Verify Podfile.lock is up to date
cd ios && pod install --dry-run
# Check Info.plist for required privacy descriptions
# Verify no missing NSCameraUsageDescription, NSPhotoLibraryUsageDescription, etc.
# Verify App Transport Security settings
# Verify minimum deployment target matches Expo config
\`\`\`

Validate:
- \`GoogleService-Info.plist\` exists and matches the current Firebase project
- Push notification entitlements are present in \`ios/<app>.entitlements\`
- Keychain access groups configured for secure storage
- No hardcoded bundle identifiers (should come from \`app.config.ts\`)

#### Android

\`\`\`bash
# Verify Gradle builds without errors
cd android && ./gradlew assembleDebug --dry-run 2>&1 | head -50
# Check AndroidManifest.xml for required permissions
\`\`\`

Validate:
- \`google-services.json\` exists and matches the current Firebase project
- ProGuard/R8 rules include WatermelonDB and other native module keep rules
- \`minSdkVersion\` and \`targetSdkVersion\` match Expo config
- No hardcoded \`applicationId\` (should come from \`app.config.ts\`)

### Stage 6 — Expo & EAS Configuration

\`\`\`bash
npx expo-doctor
npx expo config --type public
\`\`\`

Validate:
- \`app.config.ts\` exports valid configuration
- \`eas.json\` has \`staging\` and \`production\` build profiles
- Expo SDK version matches \`package.json\` dependency (SDK 51)
- All Expo config plugins are listed and resolvable
- Deep linking scheme is defined in \`app.config.ts\`
- Splash screen and app icon assets exist at declared paths

### Stage 7 — Offline & Data Layer

Validate:
- WatermelonDB schema version is incremented if models changed
- Migration file exists for any schema changes
- Sync adapter configuration points to correct Firestore collections
- No direct Firestore reads in components — all data access goes through WatermelonDB or React Query hooks
- Optimistic updates are handled for offline mutations

### Stage 8 — Accessibility Audit

Scan all modified/new \`.tsx\` files:

- Every \`TouchableOpacity\`, \`Pressable\`, \`Button\`, and interactive element has \`accessibilityLabel\`
- Every \`Image\` has \`accessibilityLabel\` or \`accessibilityElementsHidden\`
- \`accessibilityRole\` is set on custom interactive components
- No empty \`accessibilityLabel=""\` values
- Screen readers can navigate the component tree (no orphaned interactive elements)

### Stage 9 — Security Checks

- Sensitive data uses \`expo-secure-store\` or platform Keychain/Keystore — never \`AsyncStorage\`
- Authentication tokens are not stored in Zustand (ephemeral memory only, or secure store)
- Certificate pinning configuration exists for production API endpoints
- Biometric authentication uses \`expo-local-authentication\` with proper fallback
- No \`console.log\` statements with sensitive data (auth tokens, user PII)
- Firebase security rules are present in \`firestore.rules\` and \`storage.rules\`

### Stage 10 — Privacy & Compliance

- GDPR: Data deletion endpoint/function exists and is callable from profile settings
- GDPR: Consent collection flow exists before analytics/tracking initialization
- App Store: Privacy nutrition labels match actual data collection (cross-reference \`app.config.ts\` plugins)
- Google Play: Data safety section declarations align with Firebase services used
- All third-party SDKs are documented in \`docs/PRIVACY.md\` with data collection details
- User data export functionality exists (GDPR right to portability)

### Stage 11 — Dependency Audit

\`\`\`bash
pnpm audit --audit-level moderate
npx expo install --check
\`\`\`

Validate:
- No high or critical vulnerabilities
- All Expo-compatible package versions are aligned (\`npx expo install --check\` passes)
- New native modules have both iOS and Android implementations
- New dependencies were reviewed (check for \`pnpm-lock.yaml\` changes and flag new packages)

### Stage 12 — Commit & Branch Hygiene

- Branch name matches pattern: \`type/TICKET-desc\` (e.g., \`feat/APP-42-add-push-notifications\`)
- All commits follow conventional commit format: \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`, \`test:\`, \`refactor:\`
- No merge commits on the feature branch (rebase workflow)
- AI-generated code is marked with \`// AI-generated\` or \`/* AI-generated */\` comment blocks
- Changed files have corresponding CODEOWNERS coverage

## Output Format

After all stages complete, produce a verification report:

\`\`\`
╔══════════════════════════════════════════════════════╗
║              /verify — Verification Report           ║
╠══════════════════════════════════════════════════════╣
║ Branch: feat/APP-42-add-push-notifications           ║
║ Scope:  src/features/notifications/                  ║
║ Time:   2m 34s                                       ║
╠══════════════════════════════════════════════════════╣
║  Stage                        Status   Duration      ║
║  ─────────────────────────────────────────────────── ║
║  1. File Hygiene              ✅ PASS   0.8s         ║
║  2. Formatting & Linting      ✅ PASS   3.2s         ║
║  3. TypeScript Type Check     ✅ PASS   8.1s         ║
║  4. Unit & Component Tests    ✅ PASS   22.4s        ║
║  5. Platform Checks (iOS)     ✅ PASS   12.0s        ║
║  5. Platform Checks (Android) ✅ PASS   9.6s         ║
║  6. Expo & EAS Config         ✅ PASS   2.1s         ║
║  7. Offline & Data Layer      ✅ PASS   1.4s         ║
║  8. Accessibility Audit       ⚠️ WARN   1.8s         ║
║  9. Security Checks           ✅ PASS   3.0s         ║
║ 10. Privacy & Compliance      ✅ PASS   1.2s         ║
║ 11. Dependency Audit          ✅ PASS   5.4s         ║
║ 12. Commit & Branch Hygiene   ✅ PASS   0.4s         ║
╠══════════════════════════════════════════════════════╣
║  Result: ⚠️ PASS WITH WARNINGS                       ║
║  Coverage: 81.2% (threshold: 75%)                    ║
╚══════════════════════════════════════════════════════╝

Warnings (1):
  [Stage 8] src/features/notifications/components/NotificationCard.tsx:42
    → Pressable missing accessibilityLabel

Recommendations:
  • Add accessibilityLabel="Dismiss notification" to NotificationCard Pressable
  • Consider adding accessibilityHint for screen reader context
\`\`\`

## Result Interpretation

| Result | Meaning | Action |
|--------|---------|--------|
| ✅ **PASS** | All stages green | Safe to open PR |
| ⚠️ **PASS WITH WARNINGS** | No failures, non-blocking issues found | Safe to open PR, address warnings in follow-up |
| ❌ **FAIL** | One or more stages failed | Fix failures before opening PR |

## Quick Mode (\`--quick\`)

Runs only stages 1–4 for rapid iteration during development. Use full \`/verify\` before opening a PR.

## CI Mode (\`--ci\`)

Mirrors the exact GitHub Actions CI pipeline defined in \`.github/workflows/ci.yml\`:
1. Lint + Format check
2. TypeScript type check
3. Unit tests with coverage
4. EAS Build dry run (both platforms)
5. Detox E2E (if \`e2e/\` specs changed)

This ensures local verification matches what CI will enforce.

## Integration with Other Commands

- Run \`/verify --quick\` during TDD cycles with \`/tdd\`
- Run \`/verify\` before submitting code from \`/code-review\`
- The \`/plan\` command includes a verification checklist that maps to these stages
- Build failures surfaced here can be debugged with the \`build-error-resolver\` agent

## Sensitive Path Escalation

If \`/verify\` detects changes to sensitive paths (\`src/services/auth/**\`, \`src/config/**\`, \`.env*\`, Firebase config files), it will:

1. Flag the changes prominently in the report
2. Remind that these paths require review from \`@mobile-leads\` per CODEOWNERS
3. Run additional security checks on those files (secret scanning, secure storage validation)
4. Recommend the \`code-reviewer\` agent for a focused security review`,

  'plugin/codeforge-react-native/hooks/hooks.json': `{
  "version": "1.0.0",
  "hooks": {
    "pre-commit": {
      "description": "Validates code quality before committing to the React Native project",
      "triggers": ["commit"],
      "phase": "pre",
      "steps": [
        {
          "id": "check-typescript",
          "name": "TypeScript Type Check",
          "command": "pnpm tsc --noEmit",
          "description": "Run strict TypeScript compilation to catch type errors before commit",
          "failOnError": true,
          "timeout": 120,
          "paths": ["src/**/*.ts", "src/**/*.tsx", "e2e/**/*.ts"]
        },
        {
          "id": "lint-staged-files",
          "name": "ESLint Staged Files",
          "command": "pnpm lint-staged",
          "description": "Lint only staged TypeScript and TSX files using react-native-community config",
          "failOnError": true,
          "timeout": 60,
          "paths": ["src/**/*.ts", "src/**/*.tsx"]
        },
        {
          "id": "format-check",
          "name": "Prettier Format Check",
          "command": "pnpm prettier --check --ignore-unknown",
          "description": "Verify formatting matches Prettier config (singleQuote, trailingComma: all, semi: true)",
          "failOnError": true,
          "timeout": 30,
          "paths": ["src/**/*.ts", "src/**/*.tsx", "src/**/*.json"]
        },
        {
          "id": "check-no-any",
          "name": "Reject TypeScript any",
          "command": "grep -rn --include='*.ts' --include='*.tsx' ': any' src/ && echo 'ERROR: Found explicit any types. Use strict typing.' && exit 1 || exit 0",
          "description": "Prevent explicit 'any' types from being committed per strict mode policy",
          "failOnError": true,
          "timeout": 15,
          "paths": ["src/**/*.ts", "src/**/*.tsx"]
        },
        {
          "id": "check-file-length",
          "name": "Max File Length Check",
          "command": "node scripts/check-file-length.js --max 250",
          "description": "Enforce 250-line maximum file length across source files",
          "failOnError": true,
          "timeout": 15,
          "paths": ["src/**/*.ts", "src/**/*.tsx"]
        },
        {
          "id": "check-naming-conventions",
          "name": "Naming Convention Check",
          "command": "node scripts/check-naming-conventions.js",
          "description": "Verify PascalCase components, camelCase hooks/utils, kebab-case filenames, SCREAMING_SNAKE_CASE constants",
          "failOnError": true,
          "timeout": 15,
          "paths": ["src/**/*"]
        },
        {
          "id": "check-i18n-strings",
          "name": "i18n String Check",
          "command": "node scripts/check-i18n-strings.js",
          "description": "Ensure all user-facing text goes through the i18n system, no hardcoded strings in JSX",
          "failOnError": true,
          "timeout": 20,
          "paths": ["src/**/*.tsx"]
        },
        {
          "id": "check-accessibility",
          "name": "Accessibility Labels Check",
          "command": "node scripts/check-accessibility-labels.js",
          "description": "Verify all interactive elements (Pressable, TouchableOpacity, Button) have accessibilityLabel",
          "failOnError": true,
          "timeout": 20,
          "paths": ["src/**/*.tsx"]
        },
        {
          "id": "check-sensitive-files",
          "name": "Sensitive File Guard",
          "command": "node scripts/check-sensitive-files.js",
          "description": "Prevent accidental commits of .env files, google-services.json, GoogleService-Info.plist, and secrets",
          "failOnError": true,
          "timeout": 10,
          "patterns": [
            ".env",
            ".env.*",
            "google-services.json",
            "GoogleService-Info.plist",
            "*.keystore",
            "*.jks",
            "*.p12",
            "*.mobileprovision",
            "*.certifsigninfo"
          ]
        },
        {
          "id": "check-ai-attribution",
          "name": "AI Code Attribution Check",
          "command": "node scripts/check-ai-attribution.js",
          "description": "Verify AI-generated code blocks include proper attribution comments per AI-USAGE-POLICY",
          "failOnError": false,
          "timeout": 10,
          "paths": ["src/**/*.ts", "src/**/*.tsx"]
        },
        {
          "id": "run-affected-tests",
          "name": "Run Affected Unit Tests",
          "command": "pnpm jest --bail --findRelatedTests --passWithNoTests",
          "description": "Run Jest tests related to staged files to catch regressions early",
          "failOnError": true,
          "timeout": 180,
          "paths": ["src/**/*.ts", "src/**/*.tsx"]
        }
      ],
      "config": {
        "parallel": false,
        "stopOnFirstFailure": true,
        "skipOnRebase": true,
        "skipFlag": "--no-verify"
      }
    },
    "post-commit": {
      "description": "Post-commit actions for tracking, notifications, and build validation",
      "triggers": ["commit"],
      "phase": "post",
      "steps": [
        {
          "id": "log-commit-metadata",
          "name": "Log Commit Metadata",
          "command": "node scripts/log-commit-metadata.js",
          "description": "Record commit hash, author, timestamp, changed features, and AI attribution flag for audit trail",
          "failOnError": false,
          "timeout": 10
        },
        {
          "id": "validate-conventional-commit",
          "name": "Conventional Commit Validation",
          "command": "node scripts/validate-conventional-commit.js",
          "description": "Warn if commit message doesn't follow conventional commits format (feat:, fix:, chore:, docs:)",
          "failOnError": false,
          "timeout": 5
        },
        {
          "id": "update-feature-index",
          "name": "Update Feature Index",
          "command": "node scripts/update-feature-index.js",
          "description": "Auto-update feature module index when new features are added under src/features/",
          "failOnError": false,
          "timeout": 10,
          "paths": ["src/features/**/index.ts"]
        },
        {
          "id": "check-native-module-parity",
          "name": "Native Module Parity Check",
          "command": "node scripts/check-native-parity.js",
          "description": "Warn if native module changes exist for one platform but not the other (iOS/Android parity)",
          "failOnError": false,
          "timeout": 15,
          "paths": ["ios/**/*", "android/**/*", "modules/**/*"]
        },
        {
          "id": "notify-sensitive-change",
          "name": "Sensitive Path Change Notification",
          "command": "node scripts/notify-sensitive-change.js",
          "description": "Send Slack notification when commits touch auth services, config, or navigation security paths",
          "failOnError": false,
          "timeout": 10,
          "paths": [
            "src/services/auth/**",
            "src/config/**",
            "src/navigation/**",
            "src/features/payments/**"
          ]
        },
        {
          "id": "coverage-delta",
          "name": "Coverage Delta Report",
          "command": "node scripts/coverage-delta.js",
          "description": "Calculate test coverage delta for changed files and warn if below 75% threshold",
          "failOnError": false,
          "timeout": 30,
          "paths": ["src/**/*.ts", "src/**/*.tsx"]
        },
        {
          "id": "sync-watermelondb-schema",
          "name": "WatermelonDB Schema Sync Check",
          "command": "node scripts/check-watermelondb-schema.js",
          "description": "Detect WatermelonDB schema or migration changes and remind developer to bump schema version",
          "failOnError": false,
          "timeout": 10,
          "paths": ["src/services/database/**", "src/models/**"]
        }
      ],
      "config": {
        "parallel": true,
        "stopOnFirstFailure": false,
        "silent": false
      }
    },
    "pre-push": {
      "description": "Validates build readiness before pushing to remote",
      "triggers": ["push"],
      "phase": "pre",
      "steps": [
        {
          "id": "full-type-check",
          "name": "Full TypeScript Check",
          "command": "pnpm tsc --noEmit",
          "description": "Complete TypeScript strict mode compilation check",
          "failOnError": true,
          "timeout": 180
        },
        {
          "id": "full-lint",
          "name": "Full ESLint Check",
          "command": "pnpm lint",
          "description": "Run ESLint across entire codebase with react-native-community config",
          "failOnError": true,
          "timeout": 120
        },
        {
          "id": "unit-tests",
          "name": "Full Unit Test Suite",
          "command": "pnpm test -- --coverage --coverageThreshold='{\\"global\\":{\\"branches\\":75,\\"functions\\":75,\\"lines\\":75,\\"statements\\":75}}'",
          "description": "Run complete Jest + React Native Testing Library suite with 75% coverage enforcement",
          "failOnError": true,
          "timeout": 300
        },
        {
          "id": "expo-doctor",
          "name": "Expo Doctor Check",
          "command": "npx expo-doctor",
          "description": "Validate Expo SDK 51 configuration, native module compatibility, and dependency versions",
          "failOnError": false,
          "timeout": 60
        },
        {
          "id": "check-branch-naming",
          "name": "Branch Naming Convention",
          "command": "node scripts/check-branch-naming.js",
          "description": "Verify branch follows type/ticket-desc pattern (e.g., feat/APP-42-add-push-notifications)",
          "failOnError": true,
          "timeout": 5
        }
      ],
      "config": {
        "parallel": false,
        "stopOnFirstFailure": true,
        "skipOnRebase": true,
        "protectedBranches": ["main"]
      }
    }
  },
  "settings": {
    "hooksDirectory": "git-hooks",
    "scriptRunner": "pnpm",
    "nodeVersion": ">=18.0.0",
    "platform": {
      "supportedOS": ["darwin", "linux"],
      "requiredTools": ["node", "pnpm", "watchman"]
    },
    "notifications": {
      "slack": {
        "enabled": true,
        "channel": "#mobile-dev",
        "events": ["sensitive-change", "native-parity-warning", "schema-migration"]
      }
    },
    "bypass": {
      "allowSkip": true,
      "skipFlag": "--no-verify",
      "requireReason": true,
      "logSkips": true
    }
  }
}`,

  'plugin/codeforge-react-native/skills/build-fix/SKILL.md': `---
name: build-fix
description: Diagnose and resolve React Native and Expo build failures across iOS, Android, and EAS Build pipelines
version: 1.0.0
author: codeforge-react-native
tags:
  - react-native
  - expo
  - build
  - ios
  - android
  - eas
  - troubleshooting
  - debugging
inputs:
  - name: error_log
    description: Build error output from terminal, Xcode, Gradle, or EAS Build logs
    required: true
  - name: platform
    description: Target platform experiencing the build failure
    type: enum
    values: [ios, android, both, eas-cloud]
    required: true
  - name: build_type
    description: Whether this is a local dev build or cloud EAS build
    type: enum
    values: [local-dev, eas-development, eas-preview, eas-production]
    default: local-dev
  - name: recent_changes
    description: Recent changes that may have triggered the failure (new dependencies, config changes, SDK upgrades)
    required: false
metadata:
  priority: high
  complexity: medium-to-high
  estimated_time: 10-45 minutes depending on root cause
  triggers:
    - build failure
    - compilation error
    - linking error
    - pod install failure
    - gradle sync failure
    - eas build failed
    - metro bundler crash
    - native module error
    - code signing error
    - provisioning profile error
---

# Skill: build-fix

Diagnose and resolve build failures in the React Native + Expo SDK 51 project across local development builds, EAS cloud builds, and platform-specific native compilation pipelines.

## When to Use This Skill

- \`npx expo start\` fails or Metro bundler crashes
- \`npx expo run:ios\` or \`npx expo run:android\` produces native build errors
- \`eas build\` fails on cloud infrastructure for development, preview, or production profiles
- \`pod install\` fails or produces linking errors on iOS
- Gradle sync or compilation fails on Android
- Native module integration causes build breakage
- Code signing, provisioning profile, or keystore errors block distribution builds
- Upgrading Expo SDK, React Native, or a native dependency breaks the build

## Diagnostic Process

### Step 1: Classify the Build Failure

Analyze the provided \`error_log\` and classify into one of these categories:

| Category | Indicators |
|---|---|
| **JavaScript/TypeScript** | TypeScript compilation errors, Metro bundler failures, module resolution errors |
| **iOS Native** | Xcode build errors, CocoaPods failures, Swift/ObjC compilation, linker errors |
| **Android Native** | Gradle errors, Kotlin/Java compilation, DEX errors, manifest merge conflicts |
| **Expo Config** | \`app.json\`/\`app.config.ts\` issues, plugin misconfiguration, prebuild failures |
| **EAS Cloud** | Credential errors, build worker failures, cache issues, environment variable problems |
| **Code Signing** | Provisioning profile mismatch, certificate expiry, keystore corruption |
| **Dependency Conflict** | Version mismatch, peer dependency warnings escalated to errors, duplicate native modules |

### Step 2: Gather Context

Before proposing fixes, check these files for relevant configuration:

\`\`\`
app.config.ts              # Expo configuration (plugins, build properties, version)
eas.json                   # EAS Build profiles (development, preview, production)
tsconfig.json              # TypeScript configuration
package.json               # Dependencies and scripts
ios/Podfile                # CocoaPods configuration (if prebuild has run)
ios/Podfile.lock           # Locked pod versions
android/build.gradle       # Root Gradle config
android/app/build.gradle   # App-level Gradle config
android/gradle.properties  # Gradle JVM and build properties
metro.config.js            # Metro bundler configuration
babel.config.js            # Babel transpilation config
\`\`\`

Check the current environment:

\`\`\`bash
npx expo-doctor            # Expo project health check
npx expo install --check   # Verify dependency compatibility with SDK 51
node --version             # Node.js version
pnpm --version             # Package manager version
\`\`\`

### Step 3: Apply Category-Specific Fixes

---

#### JavaScript/TypeScript Build Errors

**Symptoms**: TypeScript strict mode violations, missing type exports, module not found errors.

**Resolution steps**:

1. Run \`pnpm tsc --noEmit\` to get the full list of type errors
2. Check \`tsconfig.json\` for \`strict: true\` and path aliases matching \`metro.config.js\`
3. Verify all imports use the correct file extensions and path conventions
4. For module resolution errors, check \`metro.config.js\` resolver configuration:
   \`\`\`typescript
   // metro.config.js — verify resolver includes required extensions
   resolver: {
     sourceExts: ['ts', 'tsx', 'js', 'jsx', 'json', 'cjs', 'mjs'],
   }
   \`\`\`
5. Clear Metro cache: \`npx expo start --clear\`
6. Reset pnpm store if node_modules are corrupted: \`pnpm store prune && pnpm install\`

---

#### iOS Native Build Errors

**Symptoms**: \`xcodebuild\` failures, pod linking errors, Swift bridging header issues, architecture mismatches.

**Resolution steps**:

1. Clean and reinstall pods:
   \`\`\`bash
   cd ios
   rm -rf Pods Podfile.lock
   rm -rf ~/Library/Developer/Xcode/DerivedData
   pod install --repo-update
   cd ..
   \`\`\`

2. If using Expo prebuild, regenerate native projects:
   \`\`\`bash
   npx expo prebuild --clean --platform ios
   \`\`\`

3. Check minimum iOS deployment target in \`app.config.ts\`:
   \`\`\`typescript
   // app.config.ts
   ios: {
     deploymentTarget: '15.1', // Must match all native dependencies
   }
   \`\`\`

4. For architecture issues (arm64 vs x86_64 on Apple Silicon):
   \`\`\`ruby
   # ios/Podfile — ensure proper architecture exclusion
   post_install do |installer|
     installer.pods_project.targets.each do |target|
       target.build_configurations.each do |config|
         config.build_settings['EXCLUDED_ARCHS[sdk=iphonesimulator*]'] = 'arm64'
       end
     end
   end
   \`\`\`

5. For Swift module compatibility, verify \`use_frameworks!\` setting in Podfile matches what native dependencies expect

6. Check that \`IPHONEOS_DEPLOYMENT_TARGET\` is consistent across all targets

---

#### Android Native Build Errors

**Symptoms**: Gradle sync failures, \`compileSdkVersion\` mismatches, DEX method limit, manifest merge conflicts, JDK version issues.

**Resolution steps**:

1. Clean Gradle caches:
   \`\`\`bash
   cd android
   ./gradlew clean
   rm -rf .gradle
   rm -rf app/build
   cd ..
   \`\`\`

2. If using Expo prebuild, regenerate:
   \`\`\`bash
   npx expo prebuild --clean --platform android
   \`\`\`

3. Verify SDK versions in \`app.config.ts\`:
   \`\`\`typescript
   // app.config.ts
   plugins: [
     ['expo-build-properties', {
       android: {
         compileSdkVersion: 34,
         targetSdkVersion: 34,
         minSdkVersion: 24,
         buildToolsVersion: '34.0.0',
         kotlinVersion: '1.9.23',
       },
     }],
   ]
   \`\`\`

4. For JDK version issues, ensure JDK 17 is active:
   \`\`\`bash
   java -version  # Must be 17.x for React Native 0.74
   \`\`\`

5. For DEX method limit errors, verify multidex is enabled:
   \`\`\`gradle
   // android/app/build.gradle
   defaultConfig {
       multiDexEnabled true
   }
   \`\`\`

6. For manifest merge conflicts, check \`android/app/src/main/AndroidManifest.xml\` for duplicate permissions or conflicting \`<application>\` attributes. Use \`tools:replace\` to resolve:
   \`\`\`xml
   <application
       tools:replace="android:allowBackup"
       android:allowBackup="false">
   \`\`\`

7. For Gradle memory issues, increase heap in \`android/gradle.properties\`:
   \`\`\`properties
   org.gradle.jvmargs=-Xmx4096m -XX:MaxMetaspaceSize=1024m
   \`\`\`

---

#### Expo Config and Plugin Errors

**Symptoms**: \`expo prebuild\` failures, plugin execution errors, invalid \`app.config.ts\` values.

**Resolution steps**:

1. Validate config:
   \`\`\`bash
   npx expo config --type public
   npx expo config --type introspect
   \`\`\`

2. Check that all Expo config plugins are compatible with SDK 51:
   \`\`\`bash
   npx expo install --check
   \`\`\`

3. For custom config plugins in \`plugins/\`, verify they follow the Expo Modules API:
   \`\`\`typescript
   // plugins/withCustomConfig.ts
   import { ConfigPlugin, withInfoPlist } from 'expo/config-plugins';

   const withCustomConfig: ConfigPlugin = (config) => {
     return withInfoPlist(config, (mod) => {
       // Modify Info.plist
       return mod;
     });
   };

   export default withCustomConfig;
   \`\`\`

4. Ensure \`app.config.ts\` exports a valid config and all environment variables are defined:
   \`\`\`bash
   # Verify .env files exist for the target environment
   ls -la .env .env.staging .env.production
   \`\`\`

---

#### EAS Cloud Build Errors

**Symptoms**: Build fails on EAS servers but works locally, credential issues, cache problems.

**Resolution steps**:

1. Check EAS build logs in detail:
   \`\`\`bash
   eas build:list --limit 5
   eas build:view <build-id>  # Get full logs URL
   \`\`\`

2. For credential issues:
   \`\`\`bash
   # iOS
   eas credentials --platform ios
   # Verify provisioning profile matches bundle identifier

   # Android
   eas credentials --platform android
   # Verify keystore is valid and not expired
   \`\`\`

3. For cache-related failures, trigger a build with no cache:
   \`\`\`bash
   eas build --platform <platform> --clear-cache
   \`\`\`

4. Verify \`eas.json\` profile configuration:
   \`\`\`json
   {
     "build": {
       "development": {
         "developmentClient": true,
         "distribution": "internal",
         "env": {
           "APP_ENV": "development"
         }
       },
       "preview": {
         "distribution": "internal",
         "channel": "staging",
         "env": {
           "APP_ENV": "staging"
         }
       },
       "production": {
         "channel": "production",
         "autoIncrement": true,
         "env": {
           "APP_ENV": "production"
         }
       }
     }
   }
   \`\`\`

5. For environment variable issues, verify secrets are set:
   \`\`\`bash
   eas secret:list
   eas secret:create --name FIREBASE_API_KEY --value <value> --scope project
   \`\`\`

6. Ensure \`node\` and \`pnpm\` versions match between local and EAS:
   \`\`\`json
   // package.json
   {
     "engines": {
       "node": ">=20.0.0"
     },
     "packageManager": "pnpm@9.1.0"
   }
   \`\`\`

---

#### Code Signing Errors

**Symptoms**: Provisioning profile not found, certificate expired, keystore password incorrect, distribution certificate mismatch.

**Resolution steps for iOS**:

1. Check current credentials:
   \`\`\`bash
   eas credentials --platform ios
   \`\`\`

2. For expired certificates, regenerate:
   \`\`\`bash
   eas credentials --platform ios
   # Select "Build Credentials" → "Distribution Certificate" → "Generate new"
   \`\`\`

3. For provisioning profile mismatch, ensure \`bundleIdentifier\` in \`app.config.ts\` matches Apple Developer portal

4. For Ad Hoc distribution (preview builds), verify test devices are registered:
   \`\`\`bash
   eas device:list
   eas device:create  # Register new device UDID
   \`\`\`

**Resolution steps for Android**:

1. Verify keystore:
   \`\`\`bash
   eas credentials --platform android
   \`\`\`

2. For upload key issues with Google Play, ensure the correct keystore is configured in EAS and matches what Google Play expects

3. For debug builds, clear and regenerate debug keystore:
   \`\`\`bash
   rm -f android/app/debug.keystore
   keytool -genkeypair -v -storetype PKCS12 -keystore android/app/debug.keystore \\
     -storepass android -alias androiddebugkey -keypass android \\
     -keyalg RSA -keysize 2048 -validity 10000
   \`\`\`

---

#### Dependency Conflict Errors

**Symptoms**: Peer dependency warnings, duplicate native modules, version resolution failures, autolinking conflicts.

**Resolution steps**:

1. Check for Expo SDK compatibility:
   \`\`\`bash
   npx expo install --check
   npx expo install --fix  # Auto-fix version mismatches
   \`\`\`

2. Run the Expo doctor:
   \`\`\`bash
   npx expo-doctor
   \`\`\`

3. For duplicate native module errors (e.g., two packages both include \`react-native-gesture-handler\`):
   \`\`\`bash
   pnpm why react-native-gesture-handler  # Find all dependents
   \`\`\`
   Add resolution in \`package.json\`:
   \`\`\`json
   {
     "pnpm": {
       "overrides": {
         "react-native-gesture-handler": "~2.16.0"
       }
     }
   }
   \`\`\`

4. For WatermelonDB native build issues specifically:
   - Ensure JSI is properly configured
   - Verify Hermes is enabled (required for React Native 0.74)
   - Check that \`@nozbe/watermelondb\` version is compatible with RN 0.74

5. After resolving conflicts:
   \`\`\`bash
   rm -rf node_modules
   pnpm install
   npx expo prebuild --clean
   \`\`\`

### Step 4: Verify the Fix

After applying fixes, run the verification sequence:

\`\`\`bash
# 1. Clean install
rm -rf node_modules
pnpm install

# 2. Type check
pnpm tsc --noEmit

# 3. Lint
pnpm lint

# 4. Unit tests
pnpm test

# 5. Local build (platform-specific)
npx expo run:ios        # iOS local build
npx expo run:android    # Android local build

# 6. If EAS build was failing, trigger a new build
eas build --platform <platform> --profile <profile>
\`\`\`

### Step 5: Document the Fix

After resolving the build failure:

1. If the fix involved a workaround, add a comment in the relevant config file explaining why
2. If a dependency was pinned, document the reason in \`docs/dependency-decisions.md\`
3. If the fix affects CI/CD, update \`.github/workflows/\` accordingly
4. If the fix is a known issue, add it to \`docs/troubleshooting.md\` for the team

## Common Quick Fixes Reference

| Error Pattern | Quick Fix |
|---|---|
| \`Unable to resolve module\` | \`npx expo start --clear\` |
| \`No matching provisioning profiles found\` | \`eas credentials --platform ios\` |
| \`Execution failed for task ':app:mergeDebugNativeLibs'\` | \`cd android && ./gradlew clean\` |
| \`The following build commands failed: PhaseScriptExecution\` | \`npx expo prebuild --clean --platform ios\` |
| \`Could not resolve all files for configuration\` | Check \`compileSdkVersion\` and Gradle plugin version |
| \`Duplicate class\` | Add \`pnpm.overrides\` to deduplicate |
| \`node_modules/react-native/scripts/generate-codegen-artifacts.js\` | Ensure Hermes is enabled, run \`npx expo prebuild --clean\` |
| \`Firebase/Core not found\` | \`cd ios && pod install --repo-update\` |
| \`WatermelonDB: JSI not available\` | Verify Hermes is enabled and JSI bridge is configured |
| \`EAS Build timeout\` | Increase \`build.timeout\` in \`eas.json\` or optimize native dependencies |

## Security Considerations

- Never log or commit credentials, keystores, or provisioning profiles
- When debugging code signing, use \`eas credentials\` CLI rather than manually handling certificates
- If \`.env\` files are involved in the build failure, verify they are listed in \`.gitignore\`
- Sensitive build configuration (API keys, signing secrets) must use EAS Secrets, not hardcoded values
- Review \`google-services.json\` and \`GoogleService-Info.plist\` — these are sensitive paths per project policy

## Escalation

If the build failure cannot be resolved after following this skill:

1. Search [Expo GitHub Issues](https://github.com/expo/expo/issues) for the specific error
2. Check [React Native Upgrade Helper](https://react-native-community.github.io/upgrade-helper/) if the issue started after an upgrade
3. Post in the team Slack channel with the full error log and steps already attempted
4. For EAS-specific issues, contact Expo support with the build ID`,

  'plugin/codeforge-react-native/skills/code-review/SKILL.md': `---
skill: code-review
version: 1.0.0
description: Performs comprehensive code review for React Native mobile app PRs with focus on mobile-specific patterns, performance, accessibility, and security
triggers:
  - pull_request
  - manual
inputs:
  - name: pr_number
    type: number
    required: true
    description: GitHub PR number to review
  - name: review_depth
    type: string
    required: false
    default: standard
    enum: [quick, standard, deep]
    description: Depth of review — quick (surface), standard (thorough), deep (security + perf audit)
  - name: focus_areas
    type: array
    required: false
    default: []
    description: Optional focus areas (e.g., security, performance, accessibility, offline, navigation)
tags:
  - code-review
  - react-native
  - quality
  - mobile
---

# Code Review Skill — React Native Mobile App

## Purpose

Perform thorough, actionable code reviews on pull requests for the react-native-mobile-app project. Reviews cover correctness, mobile-specific patterns, performance, accessibility, security, offline behavior, and adherence to project conventions.

## Pre-Review Checklist

Before starting the review, gather context:

1. **Fetch the PR** using GitHub MCP: get PR diff, description, linked issues, and changed file list
2. **Identify the feature area** from the branch name (e.g., \`feat/APP-42-add-push-notifications\` → \`src/features/notifications/\`)
3. **Check the linked GitHub Issue** for acceptance criteria and requirements
4. **Note the author's seniority** if known — calibrate feedback accordingly (more educational for juniors, more architectural for seniors)
5. **Check if files touch sensitive paths**: \`src/services/auth/**\`, \`src/config/**\`, \`google-services.json\`, \`GoogleService-Info.plist\`, \`.env*\`

## Review Process

### Step 1: High-Level Assessment

Evaluate the PR holistically before diving into line-level feedback:

- Does the PR description clearly explain what changed and why?
- Is the scope appropriate? (Single concern, not mixing unrelated changes)
- Does the branch name follow \`type/ticket-desc\` convention?
- Are commits using conventional commit format (\`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`)?
- Is the PR size reasonable? Flag PRs over 400 lines of meaningful changes

### Step 2: Architecture & Structure

Verify adherence to the feature-based architecture:

\`\`\`
src/features/{feature}/
  screens/          # Screen components (connected to navigation)
  components/       # Feature-specific UI components
  hooks/            # Feature-specific hooks
  types/            # Feature-specific TypeScript types
  __tests__/        # Co-located tests
\`\`\`

Check for:
- **Feature isolation**: No direct imports between feature directories (use shared \`src/components/\`, \`src/hooks/\`, \`src/services/\`)
- **Correct layer usage**: Screens compose components, components use hooks, hooks call services
- **Navigation typing**: All navigation props use typed navigators from \`src/navigation/types\`
- **State management separation**: Zustand for client state (\`src/store/\`), React Query/TanStack Query for server state
- **No business logic in components**: Extract to hooks or services
- **File length**: Flag files exceeding 250 lines — suggest splitting

### Step 3: TypeScript & Type Safety

- **Strict mode compliance**: No \`any\` types, no \`@ts-ignore\` without justification
- **Proper typing for navigation**: \`NativeStackScreenProps\`, \`CompositeScreenProps\` from React Navigation
- **Firebase types**: Firestore document types defined and used consistently
- **WatermelonDB models**: Proper \`@field\`, \`@relation\`, \`@children\` decorators with TypeScript types
- **API response types**: All Firebase Cloud Function responses typed
- **Zustand store types**: State and actions properly typed, no implicit \`any\`
- **React Query types**: \`useQuery<TData, TError>\` and \`useMutation\` properly parameterized
- **Platform-specific types**: \`Platform.select()\` return types handled correctly

### Step 4: React Native & Expo Patterns

#### Component Patterns
- Use functional components exclusively (no class components)
- \`React.memo()\` on list item components and expensive renders
- \`useCallback\` for event handlers passed to children
- \`useMemo\` for expensive computations and derived data
- Avoid inline styles — use \`StyleSheet.create()\` or the theme system from \`src/theme/\`
- No direct style objects in JSX (performance penalty on re-renders)

#### Performance
- **FlatList best practices**: \`keyExtractor\`, \`getItemLayout\` when possible, \`removeClippedSubviews\`, \`maxToRenderPerBatch\`
- **Image optimization**: Use \`expo-image\` with proper \`contentFit\`, caching, and placeholder
- **Bundle size**: Flag large imports — prefer tree-shakeable imports (e.g., \`import { doc } from 'firebase/firestore'\` not \`import firebase from 'firebase'\`)
- **Avoid re-renders**: Check for new object/array literals in render (e.g., \`style={{ flex: 1 }}\` should be in StyleSheet)
- **Animation**: Use \`react-native-reanimated\` worklets for animations, not \`Animated\` API with JS thread
- **Memory leaks**: Verify cleanup in \`useEffect\` return functions, especially for subscriptions and listeners
- **Hermes compatibility**: No unsupported JS features, verify BigInt/Intl usage

#### Navigation
- All screens registered in typed navigators
- Deep linking configuration updated in \`src/navigation/linking.ts\` for new screens
- Screen options set via \`options\` prop, not imperative \`navigation.setOptions()\` in effects
- Proper use of \`useFocusEffect\` instead of \`useEffect\` for screen-focus-dependent logic
- Back handler behavior correct on Android (\`BackHandler\` or \`headerBackVisible\`)

#### Platform-Specific Code
- Use \`Platform.OS\` checks or \`.ios.tsx\`/\`.android.tsx\` file extensions
- Native module changes must have both iOS and Android implementations
- Test on both platforms — flag platform-specific code without corresponding platform checks
- Safe area handling via \`react-native-safe-area-context\`, not hardcoded padding
- Status bar management consistent across screens

### Step 5: Offline-First & Data Sync

- **WatermelonDB usage**: Models extend \`Model\`, use proper decorators
- **Sync logic**: Changes go through WatermelonDB sync protocol, not direct Firestore writes from UI
- **Optimistic updates**: UI reflects local changes immediately, syncs in background
- **Conflict resolution**: Strategy defined for concurrent edits (last-write-wins, merge, or prompt user)
- **Network state**: Use \`@react-native-community/netinfo\` to detect connectivity
- **Queue management**: Offline mutations queued and replayed on reconnect
- **Error handling**: Sync failures surface user-friendly messages, don't crash silently

### Step 6: Security Review

**Always review when sensitive paths are touched.**

- **Secure storage**: Tokens, secrets, biometric keys stored in \`expo-secure-store\` (Keychain on iOS, Keystore on Android) — never AsyncStorage
- **Authentication flows**: Firebase Auth tokens refreshed properly, session expiry handled
- **Biometric auth**: Uses \`expo-local-authentication\` with proper fallback to PIN/password
- **API keys**: No hardcoded keys in source — must come from \`react-native-config\` / \`.env\` files
- **Certificate pinning**: Verify SSL pinning config for production API calls
- **Deep link validation**: Incoming deep links validated before navigation (prevent open redirect)
- **Input sanitization**: User input sanitized before Firestore writes
- **Data exposure**: No sensitive data in logs (\`console.log\`), error messages, or analytics events
- **Code obfuscation**: ProGuard (Android) and Hermes bytecode (iOS) enabled for production builds
- **Permissions**: Only request necessary permissions, handle denial gracefully

### Step 7: Privacy & Compliance

- **GDPR**: User consent collected before analytics/tracking, data deletion endpoint accessible
- **App Store privacy labels**: New data collection reflected in privacy manifest
- **Google Play data safety**: Data safety section updated for new data types
- **i18n**: All user-facing text goes through \`src/i18n/\` — no hardcoded strings
- **Tracking transparency**: ATT prompt on iOS before IDFA access (\`expo-tracking-transparency\`)
- **Data minimization**: Only collect data that's necessary for the feature
- **Consent management**: Check that consent state is respected before firing analytics events

### Step 8: Accessibility

- **Labels**: All interactive elements have \`accessibilityLabel\` (or \`aria-label\`)
- **Roles**: Correct \`accessibilityRole\` on buttons, links, headers, images
- **Hints**: \`accessibilityHint\` for non-obvious interactions
- **States**: \`accessibilityState\` for disabled, selected, checked, expanded
- **Touch targets**: Minimum 44x44pt touch targets (Apple HIG) / 48x48dp (Material)
- **Screen reader**: Test with VoiceOver (iOS) and TalkBack (Android) considerations
- **Color contrast**: Text meets WCAG AA (4.5:1 for normal text, 3:1 for large text)
- **Reduced motion**: Respect \`useReducedMotion()\` from \`react-native-reanimated\`
- **Dynamic type**: Text scales with system font size settings

### Step 9: Testing

- **Unit tests**: New utility functions and hooks have tests
- **Component tests**: New screens/components have React Native Testing Library tests
- **Snapshot tests**: Used sparingly — only for stable, presentational components
- **Mock strategy**: Firebase services mocked at the service layer, not inline
- **E2E coverage**: New user flows have Detox test specs in \`e2e/\`
- **Coverage**: Changes don't drop coverage below 75% threshold
- **Test naming**: Descriptive \`it('should ...')\` or \`test('renders error state when API fails')\`
- **Async testing**: Proper use of \`waitFor\`, \`findBy*\` queries — no arbitrary \`sleep\`/\`delay\`

### Step 10: AI-Generated Code Check

If the PR contains AI-generated code:

- Verify the \`AI-Generated\` label or \`🤖\` marker is present in the PR description
- Check for the \`// AI-generated\` comment on substantial AI-authored blocks
- Ensure AI-generated code has been reviewed and understood by the author
- Verify AI-generated code has adequate test coverage (same 75% threshold)
- Check for common AI pitfalls: hallucinated APIs, outdated patterns, overly verbose code, missing error handling

## Review Output Format

Structure the review as follows:

### Summary
One paragraph: what the PR does, overall quality assessment, and whether it's ready to merge.

### Severity Levels
- 🔴 **Blocker**: Must fix before merge (security issues, crashes, data loss, broken builds)
- 🟠 **Major**: Should fix before merge (performance regressions, accessibility violations, missing tests)
- 🟡 **Minor**: Nice to fix (style inconsistencies, minor refactors, documentation gaps)
- 🟢 **Suggestion**: Optional improvements (alternative approaches, future considerations)
- 💚 **Praise**: Call out excellent code, clever solutions, good patterns

### Findings

For each finding, provide:

\`\`\`
**[SEVERITY] File:Line — Brief Title**

Description of the issue with context on why it matters for mobile.

Suggested fix (code snippet if helpful).
\`\`\`

### Checklist Summary

| Category | Status | Notes |
|----------|--------|-------|
| Architecture | ✅/⚠️/❌ | |
| TypeScript | ✅/⚠️/❌ | |
| Performance | ✅/⚠️/❌ | |
| Security | ✅/⚠️/❌ | |
| Accessibility | ✅/⚠️/❌ | |
| Offline/Sync | ✅/⚠️/❌ | |
| Testing | ✅/⚠️/❌ | |
| Privacy/GDPR | ✅/⚠️/❌ | |
| Conventions | ✅/⚠️/❌ | |

### Verdict

One of:
- ✅ **Approve** — Ready to merge
- ✅ **Approve with suggestions** — Merge after optional improvements
- 🔄 **Request changes** — Must address blockers/majors before re-review
- ❌ **Reject** — Fundamental issues requiring rethink

## Depth Modifiers

### Quick Review
Focus on Steps 1, 2, 3, and 10 only. Surface-level check for obvious issues. Suitable for documentation changes, config updates, and trivial fixes.

### Standard Review (default)
All steps. Thorough review covering architecture, types, performance, security, accessibility, and testing.

### Deep Review
All steps plus:
- **Performance profiling suggestions**: Identify potential jank, large bundle impacts, memory pressure
- **Security threat modeling**: Consider attack vectors specific to the changed code paths
- **Sync edge cases**: Network interruption during sync, partial writes, stale cache scenarios
- **Platform parity audit**: Verify behavior matches on both iOS and Android
- **Upgrade compatibility**: Check if changes are compatible with upcoming Expo SDK / React Native versions

## Focus Area Overrides

When \`focus_areas\` is specified, prioritize those sections but still do a quick pass on all others:

- \`security\` → Emphasize Steps 6, 7
- \`performance\` → Emphasize Step 4 (Performance subsection), Step 5
- \`accessibility\` → Emphasize Step 8
- \`offline\` → Emphasize Step 5
- \`navigation\` → Emphasize Step 4 (Navigation subsection)
- \`testing\` → Emphasize Step 9

## Integration with Project Tools

- Use **GitHub MCP** to fetch PR details, post review comments, and set review status
- Reference **GitHub Issues** for acceptance criteria validation
- Check **CODEOWNERS** (\`.github/CODEOWNERS\`) to verify appropriate reviewers are assigned
- Cross-reference \`docs/ARCHITECTURE.md\` for architectural decisions
- Cross-reference \`docs/CONTRIBUTING.md\` for coding standards
- Verify CI status from GitHub Actions (\`ci.yml\`) — lint, type-check, test results

## Common React Native Anti-Patterns to Flag

1. **Using \`console.log\` in production code** — Use a logger service that's stripped in production builds
2. **Storing sensitive data in AsyncStorage** — Must use \`expo-secure-store\`
3. **Not handling keyboard on forms** — Use \`KeyboardAvoidingView\` or \`react-native-keyboard-aware-scroll-view\`
4. **Hardcoded dimensions** — Use \`useWindowDimensions()\` or responsive utilities
5. **Missing error boundaries** — Screens should have error boundaries to prevent full-app crashes
6. **Direct Firestore calls from components** — Must go through service layer in \`src/services/\`
7. **Untyped navigation params** — All \`route.params\` must be typed via navigator definitions
8. **Missing loading/error states** — Every async operation needs loading, success, and error UI states
9. **Ignoring app state changes** — Use \`AppState\` listener for background/foreground transitions
10. **Not cleaning up listeners** — Firebase \`onSnapshot\`, event emitters, and timers must be cleaned up`,

  'plugin/codeforge-react-native/skills/phase/SKILL.md': `---
skill: phase
version: 1.0.0
description: Navigate React Native development workflow phases — from discovery through production release
triggers:
  - "phase"
  - "workflow"
  - "development phase"
  - "what phase"
  - "next phase"
  - "phase transition"
inputs:
  - name: phase_name
    type: string
    required: false
    description: "Target phase: discovery, design, implement, test, release, monitor"
  - name: ticket_id
    type: string
    required: false
    description: "GitHub Issue ID (e.g., APP-42) to track through phases"
  - name: action
    type: string
    required: false
    description: "Action: start, status, checklist, transition, complete"
tools:
  - github_issues
  - filesystem
  - slack
tags:
  - workflow
  - methodology
  - react-native
  - mobile
---

# Skill: Phase — React Native Development Workflow

You are a development workflow navigator for a React Native mobile application built with Expo SDK 51, TypeScript, and Firebase. Guide developers through structured phases ensuring quality, compliance, and mobile-specific concerns are addressed at every stage.

## Phase Overview

The React Native development workflow consists of six phases. Each phase has entry criteria, activities, deliverables, and exit criteria tailored to mobile development.

\`\`\`
┌─────────────┐    ┌──────────┐    ┌─────────────┐    ┌──────────┐    ┌──────────────┐    ┌──────────────┐
│  Discovery   │───▶│  Design  │───▶│  Implement  │───▶│   Test   │───▶│   Release    │───▶│   Monitor    │
│              │    │          │    │             │    │          │    │              │    │              │
│ Requirements │    │ API/UI   │    │ Code + TDD  │    │ QA + E2E │    │ EAS Build +  │    │ Crashlytics  │
│ Feasibility  │    │ Offline  │    │ Feature dev │    │ Devices  │    │ App Stores   │    │ Analytics    │
│ Platform     │    │ Nav flow │    │ Integration │    │ Perf     │    │ OTA Updates  │    │ User feedback│
└─────────────┘    └──────────┘    └─────────────┘    └──────────┘    └──────────────┘    └──────────────┘
\`\`\`

## Phase Definitions

### Phase 1: Discovery

**Purpose**: Understand requirements, assess feasibility across iOS and Android, identify platform-specific constraints.

**Entry Criteria**:
- GitHub Issue created with clear description
- Feature request or bug report template filled out
- Stakeholder approval or priority assignment

**Activities**:

1. **Requirements Analysis**
   - Parse the GitHub Issue for acceptance criteria
   - Identify user stories and edge cases
   - Determine if feature requires native module work
   - Check if Expo SDK supports required APIs or if a custom dev client is needed

2. **Platform Feasibility**
   - Verify iOS compatibility (minimum iOS 16)
   - Verify Android compatibility (minimum API 24)
   - Check if required native APIs exist on both platforms
   - Assess if Expo Modules API can bridge any gaps
   - Review App Store Guidelines and Google Play Policies for compliance

3. **Offline-First Assessment**
   - Determine if feature needs offline support
   - Plan WatermelonDB schema changes if needed
   - Design sync strategy with Firestore
   - Identify conflict resolution approach

4. **Privacy & Compliance Check**
   - GDPR implications (data collection, consent, deletion rights)
   - App Store privacy nutrition labels impact
   - Google Play data safety section updates
   - Biometric data handling requirements

5. **Dependency Review**
   - Check if new native modules are needed
   - Verify compatibility with Expo SDK 51
   - Review bundle size impact
   - Check for known vulnerabilities

**Deliverables**:
- Updated GitHub Issue with technical notes
- Feasibility assessment (platform support, offline needs, compliance)
- Dependency impact analysis
- Estimated complexity (S/M/L/XL)

**Exit Criteria**:
- [ ] Requirements are clear and unambiguous
- [ ] Platform feasibility confirmed for both iOS and Android
- [ ] Offline strategy defined (if applicable)
- [ ] Privacy/compliance concerns documented
- [ ] No blocking dependency issues identified
- [ ] Issue labeled and estimated

**Phase Commands**:
\`\`\`
# Check Expo SDK compatibility
npx expo install --check

# Verify native module compatibility
npx expo-doctor

# Review current dependencies
pnpm outdated
\`\`\`

---

### Phase 2: Design

**Purpose**: Design the technical solution including navigation flows, component architecture, data models, and API contracts.

**Entry Criteria**:
- Discovery phase completed
- Requirements documented and approved
- Platform feasibility confirmed

**Activities**:

1. **Feature Architecture**
   - Define feature directory structure under \`src/features/<feature-name>/\`
   - Plan screens, components, hooks, and types
   - Design navigation flow with typed React Navigation routes
   - Determine state management split (Zustand vs React Query)

2. **Data Model Design**
   - Design WatermelonDB models and migrations
   - Define Firestore document structure
   - Plan sync protocol (push/pull, conflict resolution)
   - Design React Query cache keys and invalidation strategy

3. **API Contract Design**
   - Define Firebase Cloud Functions endpoints
   - Specify request/response TypeScript types
   - Plan error handling and retry strategies
   - Design offline queue for failed requests

4. **UI/UX Design Review**
   - Map screens to React Navigation routes
   - Plan deep linking URLs for the feature
   - Design loading, error, and empty states
   - Plan accessibility (labels, roles, hints)
   - Design for both iOS and Android platform conventions

5. **Security Design**
   - Plan secure storage usage (expo-secure-store)
   - Design authentication flow changes
   - Plan certificate pinning if new endpoints added
   - Review data encryption needs

**Deliverables**:
- Feature directory scaffold
- TypeScript type definitions in \`<feature>/types/\`
- Navigation type updates in \`src/navigation/types.ts\`
- WatermelonDB migration file (if needed)
- API contract types
- Deep linking configuration updates

**Exit Criteria**:
- [ ] Feature directory structure created
- [ ] TypeScript types defined for all data models
- [ ] Navigation routes typed and registered
- [ ] Offline sync strategy documented
- [ ] Deep linking URLs defined
- [ ] Accessibility requirements specified
- [ ] Security considerations documented

**Phase Commands**:
\`\`\`
# Create feature directory structure
mkdir -p src/features/<feature>/{screens,components,hooks,types,__tests__}

# Generate navigation types
# Update src/navigation/types.ts with new route params

# Create WatermelonDB migration
# Add migration in src/services/database/migrations/
\`\`\`

---

### Phase 3: Implement

**Purpose**: Build the feature using TDD, following project conventions, with proper offline support and platform handling.

**Entry Criteria**:
- Design phase completed
- Types and interfaces defined
- Feature directory scaffolded
- Branch created: \`feat/<ticket-id>-<description>\`

**Activities**:

1. **Branch Setup**
   \`\`\`bash
   git checkout -b feat/APP-<id>-<description> main
   \`\`\`

2. **TDD Implementation Cycle**
   - Write failing tests first (Jest + React Native Testing Library)
   - Implement minimum code to pass
   - Refactor while keeping tests green
   - Follow the \`tdd\` skill for detailed TDD workflow

3. **Component Development**
   - Build components in \`<feature>/components/\`
   - Use shared components from \`src/components/\` where possible
   - Apply theme tokens from \`src/theme/\`
   - Add accessibility labels to all interactive elements
   - Handle both iOS and Android platform differences with \`Platform.select()\`

4. **Hook Development**
   - Create feature hooks in \`<feature>/hooks/\`
   - Use React Query for server state (Firebase data)
   - Use Zustand for client state (UI state, preferences)
   - Implement offline-aware hooks with WatermelonDB observables

5. **Screen Development**
   - Build screens in \`<feature>/screens/\`
   - Connect to navigation with typed route props
   - Implement loading, error, and empty states
   - Handle keyboard avoidance, safe areas, and gestures
   - Support both portrait and landscape if required

6. **Service Integration**
   - Integrate Firebase services (Auth, Firestore, Functions)
   - Implement WatermelonDB sync logic
   - Add analytics events via \`src/services/analytics/\`
   - Add crash reporting breadcrumbs via Sentry

7. **Internationalization**
   - Add all user-facing strings to \`src/i18n/\`
   - Never hardcode text in components
   - Support RTL layouts if applicable

8. **Code Quality Gates**
   - Files must not exceed 250 lines
   - No TypeScript \`any\` types
   - All hooks must have proper dependency arrays
   - All async operations must have error handling
   - Platform-specific code must be clearly separated

**Deliverables**:
- Feature implementation with full test coverage
- Unit tests for hooks and utilities
- Component tests for all screens and components
- Updated i18n translation files
- Analytics events documented

**Exit Criteria**:
- [ ] All tests passing (\`pnpm test\`)
- [ ] TypeScript compiles with no errors (\`pnpm typecheck\`)
- [ ] ESLint passes with no warnings (\`pnpm lint\`)
- [ ] Prettier formatting applied (\`pnpm format\`)
- [ ] Coverage ≥ 75% for new code
- [ ] No files exceed 250 lines
- [ ] All text goes through i18n
- [ ] Accessibility labels on all interactive elements
- [ ] Conventional commit messages used
- [ ] AI-generated code marked with \`// AI-generated\` comment

**Phase Commands**:
\`\`\`bash
# Run tests in watch mode during development
pnpm test --watch --coverage

# Type check
pnpm typecheck

# Lint and format
pnpm lint --fix
pnpm format

# Start Expo dev server for manual testing
npx expo start

# Run on specific platform
npx expo run:ios
npx expo run:android
\`\`\`

---

### Phase 4: Test

**Purpose**: Comprehensive testing including E2E tests, device testing, performance profiling, and platform-specific QA.

**Entry Criteria**:
- Implementation complete
- Unit and component tests passing
- PR created and passing CI checks

**Activities**:

1. **E2E Test Development**
   - Write Detox E2E tests in \`e2e/\` directory
   - Cover critical user flows (happy path + error cases)
   - Test on both iOS Simulator and Android Emulator
   - Test offline scenarios (airplane mode, poor connectivity)
   - Test deep linking flows

2. **Device Testing Matrix**
   - Test on physical iOS device (latest + one version back)
   - Test on physical Android device (various screen sizes)
   - Test on tablets if supported
   - Verify notch/dynamic island handling
   - Test with system dark mode and light mode

3. **Performance Testing**
   - Profile with React Native Performance Monitor
   - Check JS thread frame rate (target: 60fps)
   - Measure app startup time (cold + warm)
   - Check memory usage and detect leaks
   - Verify bundle size impact
   - Test WatermelonDB query performance with large datasets

4. **Offline Testing**
   - Enable airplane mode and verify offline functionality
   - Test sync when connectivity restored
   - Verify conflict resolution works correctly
   - Test with intermittent connectivity
   - Verify offline queue processes in correct order

5. **Accessibility Testing**
   - Run iOS VoiceOver through all new screens
   - Run Android TalkBack through all new screens
   - Verify focus order is logical
   - Test with increased font sizes (Dynamic Type / Font Scale)
   - Verify touch targets are minimum 44x44 points

6. **Security Testing**
   - Verify sensitive data uses secure storage
   - Check no secrets in JS bundle
   - Verify authentication tokens refresh correctly
   - Test biometric authentication flows
   - Verify certificate pinning (if applicable)

7. **Code Review**
   - Follow the \`code-review\` skill for detailed review process
   - Ensure at least 1 approval from a team member
   - Address all review comments
   - Verify CODEOWNERS approval for sensitive paths

**Deliverables**:
- Detox E2E test suite for the feature
- Device testing report (platforms, screen sizes, OS versions)
- Performance benchmark results
- Accessibility audit results
- Security review checklist completed

**Exit Criteria**:
- [ ] Detox E2E tests passing on iOS and Android
- [ ] Tested on physical devices (iOS + Android)
- [ ] Performance within acceptable thresholds (60fps, <2s cold start)
- [ ] Offline flows verified
- [ ] Accessibility audit passed (VoiceOver + TalkBack)
- [ ] No security issues found
- [ ] Code review approved (≥1 approval)
- [ ] All CI checks green

**Phase Commands**:
\`\`\`bash
# Run Detox E2E tests
npx detox build --configuration ios.sim.release
npx detox test --configuration ios.sim.release

npx detox build --configuration android.emu.release
npx detox test --configuration android.emu.release

# Run full test suite
pnpm test --coverage

# Build for testing
eas build --profile preview --platform ios
eas build --profile preview --platform android

# Performance profiling
npx expo start --dev-client
# Use React DevTools Profiler and Flipper
\`\`\`

---

### Phase 5: Release

**Purpose**: Build, sign, and distribute the app through EAS Build, TestFlight/Internal Testing, and App Store/Google Play.

**Entry Criteria**:
- All tests passing (unit, component, E2E)
- Code review approved and merged to main
- No blocking issues or regressions

**Activities**:

1. **Version Management**
   - Update version in \`app.json\` / \`app.config.ts\`
   - Follow semver: major.minor.patch
   - Update \`ios.buildNumber\` and \`android.versionCode\`
   - Update CHANGELOG.md with conventional commit summary

2. **Staging Deployment (OTA)**
   - Deploy to staging channel via EAS Update
   \`\`\`bash
   eas update --branch staging --message "feat: <description>"
   \`\`\`
   - Verify update downloads and applies correctly
   - Run smoke tests on staging builds
   - Verify Firebase staging environment connectivity

3. **Production Build**
   - Trigger EAS Build for both platforms
   \`\`\`bash
   eas build --profile production --platform all
   \`\`\`
   - Verify code signing (iOS certificates, Android keystore)
   - Verify app icons, splash screen, and metadata
   - Check bundle size is within limits

4. **App Store Submission (iOS)**
   - Submit via EAS Submit
   \`\`\`bash
   eas submit --platform ios
   \`\`\`
   - Update App Store Connect metadata
   - Update privacy nutrition labels if data collection changed
   - Prepare screenshots if UI changed
   - Submit for App Review

5. **Google Play Submission (Android)**
   - Submit via EAS Submit
   \`\`\`bash
   eas submit --platform android
   \`\`\`
   - Update Google Play Console listing
   - Update data safety section if data collection changed
   - Submit to internal testing track first
   - Promote to production after validation

6. **Post-Submission Verification**
   - Monitor App Store review status
   - Monitor Google Play review status
   - Prepare rollback plan (previous build + EAS Update revert)
   - Notify team via Slack of submission status

**Deliverables**:
- Production builds for iOS and Android
- App Store and Google Play submissions
- Updated CHANGELOG.md
- Release notes for both stores
- Rollback plan documented

**Exit Criteria**:
- [ ] Version bumped and tagged in git
- [ ] Staging deployment verified
- [ ] Production builds successful (iOS + Android)
- [ ] App Store submission accepted
- [ ] Google Play submission accepted
- [ ] Privacy labels / data safety updated (if needed)
- [ ] CHANGELOG.md updated
- [ ] Team notified via Slack
- [ ] Rollback plan documented

**Phase Commands**:
\`\`\`bash
# OTA update to staging
eas update --branch staging --message "feat: description"

# Production builds
eas build --profile production --platform ios
eas build --profile production --platform android

# Submit to stores
eas submit --platform ios
eas submit --platform android

# Tag release
git tag -a v1.x.x -m "Release v1.x.x"
git push origin v1.x.x
\`\`\`

---

### Phase 6: Monitor

**Purpose**: Monitor app health, user behavior, crash rates, and performance in production. Respond to issues quickly.

**Entry Criteria**:
- App released to production (App Store + Google Play)
- Monitoring tools configured (Sentry, Firebase Analytics, Crashlytics)

**Activities**:

1. **Crash Monitoring**
   - Monitor Sentry for new exceptions and ANRs
   - Monitor Firebase Crashlytics for crash-free rate
   - Target: >99.5% crash-free sessions
   - Triage crashes by severity and user impact
   - Create GitHub Issues for critical crashes

2. **Performance Monitoring**
   - Track app startup time trends
   - Monitor API response times via Firebase Performance
   - Track JS bundle load time
   - Monitor memory usage patterns
   - Alert on performance regressions

3. **Analytics Review**
   - Review Firebase Analytics for feature adoption
   - Track user flows through the new feature
   - Monitor conversion funnels (if applicable)
   - Review retention impact
   - Track in-app purchase metrics (if applicable)

4. **User Feedback**
   - Monitor App Store reviews and ratings
   - Monitor Google Play reviews and ratings
   - Track in-app feedback submissions
   - Respond to critical user reports

5. **OTA Hotfix Capability**
   - For JS-only fixes, deploy via EAS Update
   \`\`\`bash
   eas update --branch production --message "fix: critical bug description"
   \`\`\`
   - For native fixes, trigger emergency EAS Build
   - Follow expedited review process for critical fixes

6. **Sync & Offline Health**
   - Monitor WatermelonDB sync success rates
   - Track sync conflict frequency
   - Monitor Firestore read/write quotas
   - Alert on sync failures exceeding threshold

**Deliverables**:
- Weekly monitoring report (crash rate, performance, adoption)
- GitHub Issues for any production bugs discovered
- Hotfix deployments if critical issues found
- Analytics insights for product team

**Exit Criteria**:
- [ ] Crash-free rate >99.5% maintained for 7 days
- [ ] No critical performance regressions
- [ ] Feature adoption metrics collected
- [ ] User feedback reviewed and triaged
- [ ] Sync health verified
- [ ] Monitoring dashboards updated

---

## Phase Transition Rules

### Automatic Transitions
- **Discovery → Design**: When all discovery exit criteria are checked and issue is labeled \`ready-for-design\`
- **Implement → Test**: When PR is created and CI checks pass
- **Test → Release**: When PR is merged to \`main\` and all test criteria met

### Manual Transitions
- **Design → Implement**: Requires lead/senior review of design decisions
- **Release → Monitor**: After successful store submission
- **Monitor → Discovery**: When monitoring reveals need for new feature/fix (creates new issue)

### Rollback Rules
- Any phase can roll back to the previous phase if exit criteria cannot be met
- Document the reason for rollback in the GitHub Issue
- Rollbacks from Release phase require immediate team notification via Slack

## Using This Skill

### Check Current Phase
When asked "what phase am I in?" or "phase status":
1. Look at the GitHub Issue state and labels
2. Check branch status and PR state
3. Assess which exit criteria are met
4. Report current phase and remaining checklist items

### Start a Phase
When asked to "start <phase>" or "begin <phase>":
1. Verify entry criteria for the requested phase
2. List any unmet prerequisites
3. Generate the phase checklist
4. Provide the relevant commands and next steps

### Get Phase Checklist
When asked for "checklist" or "what's left":
1. Identify current phase from context
2. List all exit criteria with status (done/pending)
3. Highlight blocking items
4. Suggest next action

### Transition Between Phases
When asked to "transition" or "move to next phase":
1. Verify all exit criteria for current phase
2. List any unmet criteria as blockers
3. If all met, confirm transition and present next phase entry criteria
4. Update GitHub Issue labels if MCP tools available

## Mobile-Specific Phase Considerations

Throughout all phases, keep these React Native concerns in mind:

- **Platform parity**: Features must work on both iOS and Android unless explicitly scoped
- **Expo compatibility**: Verify all dependencies work with Expo SDK 51 managed workflow
- **Bundle size**: Monitor JS bundle size impact at implement and release phases
- **Native modules**: Any new native module requires both platform implementations and dev client rebuild
- **OTA vs native updates**: Determine if changes are OTA-eligible (JS only) or require store submission
- **App review**: Factor in 1-3 day App Store review time for release planning
- **Backward compatibility**: EAS Update must be compatible with currently deployed native runtime versions`,

  'plugin/codeforge-react-native/skills/plan/SKILL.md': `---
skill: plan
version: 1.0.0
description: Plan and decompose React Native feature work into actionable implementation steps
triggers:
  - plan
  - breakdown
  - decompose
  - design
  - architect
inputs:
  - name: feature
    description: Feature name or ticket reference (e.g., APP-42, push-notifications)
    required: true
  - name: scope
    description: Scope of planning — full feature, single screen, or component
    required: false
    default: feature
  - name: platform
    description: Target platform focus — ios, android, or both
    required: false
    default: both
tags:
  - planning
  - architecture
  - react-native
  - mobile
---

# Skill: Plan — React Native Development Workflow

You are a senior React Native architect planning implementation work for the **react-native-mobile-app** project. Your job is to decompose features into well-structured, actionable implementation plans that follow the project's architecture and conventions.

## Context Gathering

Before creating a plan, gather context from these sources:

1. **Ticket details** — Use GitHub Issues MCP to fetch the issue description, acceptance criteria, and labels
2. **Existing code** — Read relevant files in \`src/features/\`, \`src/services/\`, \`src/navigation/\` to understand current patterns
3. **Architecture docs** — Reference \`docs/ARCHITECTURE.md\` for system design decisions
4. **Dependencies** — Check \`package.json\` for available libraries before suggesting new ones

## Planning Process

### Step 1: Understand the Requirement

Parse the feature request and identify:

- **User-facing behavior**: What does the user see and interact with?
- **Platform considerations**: iOS-specific, Android-specific, or shared behavior?
- **Offline requirements**: Does this feature need to work offline? What data syncs?
- **Navigation impact**: New screens, modals, deep links?
- **State management**: Server state (React Query) vs. client state (Zustand)?
- **Backend dependencies**: Firebase services needed (Auth, Firestore, Functions, Messaging, Storage)?
- **Privacy/compliance**: GDPR consent, App Store privacy labels, data safety section updates?

### Step 2: Decompose into Tasks

Break the feature into tasks following this order:

1. **Types & interfaces** — Define TypeScript types in \`src/features/<feature>/types/\`
2. **Data layer** — WatermelonDB models, Firestore collections, React Query hooks
3. **Services** — Firebase service functions in \`src/services/\` or \`src/features/<feature>/hooks/\`
4. **State** — Zustand store slices if client state is needed in \`src/store/\`
5. **Components** — Reusable UI components in \`src/features/<feature>/components/\`
6. **Screens** — Screen components in \`src/features/<feature>/screens/\`
7. **Navigation** — Navigator updates, deep link config in \`src/navigation/\`
8. **i18n** — Translation keys in \`src/i18n/\`
9. **Tests** — Unit tests, component tests, E2E specs
10. **Platform-specific** — iOS/Android native module work, permissions, entitlements

### Step 3: Estimate and Sequence

For each task, provide:

- **File paths** — Exact files to create or modify
- **Estimated complexity** — S (< 1hr), M (1-4hr), L (4-8hr), XL (> 8hr)
- **Dependencies** — Which tasks must complete first
- **Developer level** — Suitable for junior, mid, senior, or lead
- **Platform** — iOS, Android, or shared

### Step 4: Identify Risks and Decisions

Flag:

- **Native module requirements** — Any new native dependencies need review per dependency policy
- **Breaking changes** — Navigation structure changes, database migrations
- **Security concerns** — Changes to \`src/services/auth/**\`, \`src/config/**\`, or credential files
- **Performance considerations** — Large lists (FlashList), heavy computation (move to native thread), image handling
- **App Store/Play Store impact** — New permissions, entitlements, privacy manifest updates

## Output Format

Structure the plan as follows:

\`\`\`markdown
## Feature Plan: [Feature Name]

**Ticket**: [APP-XXX](link)
**Scope**: [Full feature | Screen | Component]
**Platforms**: [iOS + Android | iOS only | Android only]
**Estimated Total**: [Sum of task estimates]
**Branch**: \`feat/APP-XXX-short-description\`

### Prerequisites
- [ ] List any required setup, environment changes, or blocking work

### Architecture Decisions
- **State approach**: [React Query for X, Zustand for Y]
- **Offline strategy**: [WatermelonDB sync | Cache-only | Online-required]
- **Navigation pattern**: [Stack | Tab | Modal | Bottom Sheet]

### Implementation Tasks

#### Phase 1: Foundation
| # | Task | Files | Size | Depends On | Level |
|---|------|-------|------|------------|-------|
| 1 | Define types | \`src/features/X/types/index.ts\` | S | — | Mid |
| 2 | Create service | \`src/services/X.ts\` | M | 1 | Mid |

#### Phase 2: UI & Navigation
| # | Task | Files | Size | Depends On | Level |
|---|------|-------|------|------------|-------|
| 3 | Build screen | \`src/features/X/screens/XScreen.tsx\` | M | 1, 2 | Mid |
| 4 | Add navigation | \`src/navigation/types.ts\`, \`src/navigation/MainNavigator.tsx\` | S | 3 | Senior |

#### Phase 3: Polish & Testing
| # | Task | Files | Size | Depends On | Level |
|---|------|-------|------|------------|-------|
| 5 | Unit tests | \`src/features/X/__tests__/\` | M | 1-4 | Mid |
| 6 | E2E tests | \`e2e/X.test.ts\` | L | 3, 4 | Senior |
| 7 | i18n strings | \`src/i18n/en.json\` | S | 3 | Junior |
| 8 | Accessibility | Update components with a11y labels | S | 3 | Junior |

### Risks & Mitigations
- **Risk**: [Description] → **Mitigation**: [Approach]

### Compliance Checklist
- [ ] GDPR: User consent collected before data processing
- [ ] GDPR: Data deletion endpoint available for user data
- [ ] App Store: Privacy nutrition labels updated in App Store Connect
- [ ] Play Store: Data safety section updated in Play Console
- [ ] Accessibility: All interactive elements have accessibility labels
- [ ] i18n: All user-facing strings go through translation system

### Definition of Done
- [ ] All tasks completed and merged to \`main\`
- [ ] Unit test coverage ≥ 75% for new code
- [ ] Component tests for all new screens
- [ ] E2E test for critical user path
- [ ] Works offline (if applicable)
- [ ] Tested on iOS simulator and Android emulator
- [ ] Tested on physical device (iOS + Android)
- [ ] No new TypeScript errors (\`strict\` mode)
- [ ] No new ESLint warnings
- [ ] PR reviewed and approved by at least 1 reviewer
- [ ] Conventional commit messages used
\`\`\`

## Project-Specific Conventions

### File Naming
- Components/Screens: \`PascalCase.tsx\` (e.g., \`LoginScreen.tsx\`, \`PushNotificationCard.tsx\`)
- Hooks: \`camelCase.ts\` (e.g., \`useAuth.ts\`, \`usePushPermission.ts\`)
- Utils: \`camelCase.ts\` (e.g., \`formatDate.ts\`, \`validateEmail.ts\`)
- Types: \`index.ts\` inside a \`types/\` directory per feature
- Constants: \`SCREAMING_SNAKE_CASE\` exports (e.g., \`export const MAX_RETRY_COUNT = 3;\`)

### Feature Directory Structure
\`\`\`
src/features/<feature-name>/
├── screens/           # Screen components (one per file)
├── components/        # Feature-specific UI components
├── hooks/             # Feature-specific hooks (data fetching, business logic)
├── types/             # TypeScript interfaces and types
│   └── index.ts
├── __tests__/         # Unit and component tests
│   ├── screens/
│   ├── components/
│   └── hooks/
└── index.ts           # Public API barrel export
\`\`\`

### State Management Rules
- **Server state** (API data, Firestore documents) → React Query / TanStack Query
- **Client state** (UI preferences, theme, auth session) → Zustand stores in \`src/store/\`
- **Offline data** (synced collections, queued mutations) → WatermelonDB in \`src/database/\`
- **Form state** → Local component state or React Hook Form
- Never duplicate server state in Zustand — use React Query cache

### Navigation Rules
- All navigator params must be typed in \`src/navigation/types.ts\`
- Deep link config must be updated in \`src/navigation/linking.ts\`
- Use \`useNavigation<ScreenNavigationProp>()\` — never untyped navigation
- Modal screens use \`presentation: 'modal'\` in stack options

### Testing Rules
- Unit tests for hooks and utils — Jest
- Component tests for screens and components — React Native Testing Library
- E2E tests for critical user flows — Detox
- Mock Firebase services, never call real Firebase in tests
- Test both online and offline states for offline-capable features
- Test both iOS and Android platform branches

### Security-Sensitive Paths
When the plan touches these paths, flag for senior/lead review:
- \`src/services/auth/**\` — Authentication logic
- \`src/config/**\` — App configuration, API keys
- \`google-services.json\` — Firebase Android config
- \`GoogleService-Info.plist\` — Firebase iOS config
- \`.env*\` — Environment variables
- \`src/features/payments/**\` — In-app purchase logic
- \`ios/*.entitlements\` — iOS entitlements
- \`android/app/src/main/AndroidManifest.xml\` — Android permissions

## Mobile-Specific Considerations

Always evaluate these for each feature:

### Permissions
- Camera, photo library, location, notifications, biometrics, contacts, microphone
- Request at point of use, not at app launch
- Handle "denied" and "never ask again" states gracefully

### App Lifecycle
- Handle background → foreground transitions
- Preserve state across app restarts
- Handle deep links arriving when app is cold-started vs. already running

### Performance
- Use \`FlashList\` instead of \`FlatList\` for large lists
- Memoize expensive renders with \`React.memo\` and \`useMemo\`
- Avoid inline styles — use \`StyleSheet.create\`
- Images: use \`expo-image\` with caching, specify dimensions
- Animations: prefer \`react-native-reanimated\` (UI thread)

### Platform Differences
- Note any iOS vs. Android behavioral differences
- Test safe area handling (notch, dynamic island, navigation bar)
- Handle keyboard avoidance on both platforms
- Check haptic feedback availability (iOS vs. Android)

## Commands Reference

When referencing commands in the plan, use the project's actual tooling:

- **Start dev server**: \`npx expo start\`
- **Run iOS**: \`npx expo run:ios\`
- **Run Android**: \`npx expo run:android\`
- **Run tests**: \`pnpm test\`
- **Run tests with coverage**: \`pnpm test --coverage\`
- **Type check**: \`pnpm tsc --noEmit\`
- **Lint**: \`pnpm lint\`
- **E2E (iOS)**: \`npx detox test --configuration ios.sim.debug\`
- **E2E (Android)**: \`npx detox test --configuration android.emu.debug\`
- **Build staging**: \`eas build --profile staging --platform all\`
- **Build production**: \`eas build --profile production --platform all\`
- **OTA update**: \`eas update --branch staging --message "description"\`
- **Submit iOS**: \`eas submit --platform ios\`
- **Submit Android**: \`eas submit --platform android\``,

  'plugin/codeforge-react-native/skills/tdd/SKILL.md': `---
skill: tdd
name: Test-Driven Development for React Native
version: 1.0.0
description: >
  Red-Green-Refactor workflow adapted for React Native with Expo SDK 51,
  covering unit tests (Jest), component tests (React Native Testing Library),
  and E2E tests (Detox). Handles platform-specific code, offline-first
  patterns, navigation, and native module mocking.
tags:
  - testing
  - tdd
  - react-native
  - jest
  - detox
  - quality
triggers:
  - test
  - tdd
  - red-green-refactor
  - write tests
  - add tests
  - fix failing test
inputs:
  - name: feature
    description: Feature or module under test (e.g., auth, payments, notifications)
    required: true
  - name: scope
    description: Test scope — unit, component, integration, e2e, or all
    required: false
    default: component
  - name: target
    description: Specific file, hook, screen, or service to test
    required: false
outputs:
  - Test files following naming convention *.test.ts / *.test.tsx / *.e2e.ts
  - Updated test coverage meeting 75% threshold
  - Mocks for native modules and Firebase services
---

# Test-Driven Development for React Native

## Philosophy

Every feature in this React Native app is built test-first. We follow the **Red-Green-Refactor** cycle:

1. **Red** — Write a failing test that describes the desired behavior
2. **Green** — Write the minimum code to make the test pass
3. **Refactor** — Improve the code while keeping tests green

Tests are not an afterthought. They are the specification.

## Test Pyramid for This Project

\`\`\`
        ╱  E2E (Detox)  ╲          — Critical user journeys only
       ╱   Integration    ╲        — Navigation flows, offline sync
      ╱    Component       ╲       — Screen rendering, user interactions
     ╱     Unit (hooks/utils) ╲    — Pure logic, transformations, stores
    ╱──────────────────────────╲
\`\`\`

**Target distribution:**
- **Unit tests**: 50% — hooks, utils, stores, services
- **Component tests**: 35% — screens, shared components, forms
- **Integration tests**: 10% — navigation flows, data sync
- **E2E tests**: 5% — critical paths (login, purchase, onboarding)

## Directory Conventions

Tests live alongside the code they test:

\`\`\`
src/features/auth/
  screens/
    LoginScreen.tsx
    LoginScreen.test.tsx          ← Component test
  hooks/
    useLogin.ts
    useLogin.test.ts              ← Unit test
  components/
    BiometricPrompt.tsx
    BiometricPrompt.test.tsx      ← Component test
  services/
    authService.ts
    authService.test.ts           ← Unit test

src/components/
  Button.tsx
  Button.test.tsx                 ← Shared component test

e2e/
  auth.e2e.ts                    ← Detox E2E test
  payments.e2e.ts
  onboarding.e2e.ts
\`\`\`

## Step-by-Step TDD Workflow

### Step 1: Understand the Requirement

Before writing any test, clarify:
- What is the user-visible behavior?
- What are the inputs and expected outputs?
- What are the edge cases (offline, error states, platform differences)?
- What accessibility requirements exist?

Check the GitHub Issue for acceptance criteria. If criteria are vague, ask for clarification before proceeding.

### Step 2: Write the Failing Test (Red)

Choose the appropriate test level based on what you are building:

#### For a Zustand Store or Utility Function → Unit Test

\`\`\`typescript
// src/store/auth.test.ts
import { useAuthStore } from './auth';

describe('useAuthStore', () => {
  beforeEach(() => {
    useAuthStore.getState().reset();
  });

  it('should set authenticated state after successful login', () => {
    const { login } = useAuthStore.getState();

    login({ uid: 'user-123', email: 'test@example.com', displayName: 'Test' });

    const state = useAuthStore.getState();
    expect(state.isAuthenticated).toBe(true);
    expect(state.user?.uid).toBe('user-123');
  });

  it('should clear user data on logout', () => {
    useAuthStore.getState().login({ uid: 'user-123', email: 'test@example.com', displayName: 'Test' });
    useAuthStore.getState().logout();

    expect(useAuthStore.getState().isAuthenticated).toBe(false);
    expect(useAuthStore.getState().user).toBeNull();
  });
});
\`\`\`

#### For a Custom Hook → Unit Test with renderHook

\`\`\`typescript
// src/features/auth/hooks/useLogin.test.ts
import { renderHook, act, waitFor } from '@testing-library/react-native';
import { useLogin } from './useLogin';
import { authService } from '@/services/auth/authService';
import { createQueryWrapper } from '@/test-utils/wrappers';

jest.mock('@/services/auth/authService');

const mockAuthService = jest.mocked(authService);

describe('useLogin', () => {
  it('should return loading state while authenticating', async () => {
    mockAuthService.signInWithEmail.mockImplementation(
      () => new Promise(() => {}), // Never resolves
    );

    const { result } = renderHook(() => useLogin(), {
      wrapper: createQueryWrapper(),
    });

    act(() => {
      result.current.login({ email: 'test@example.com', password: 'password123' });
    });

    expect(result.current.isLoading).toBe(true);
  });

  it('should return error on invalid credentials', async () => {
    mockAuthService.signInWithEmail.mockRejectedValue(
      new Error('auth/wrong-password'),
    );

    const { result } = renderHook(() => useLogin(), {
      wrapper: createQueryWrapper(),
    });

    act(() => {
      result.current.login({ email: 'test@example.com', password: 'wrong' });
    });

    await waitFor(() => {
      expect(result.current.isError).toBe(true);
      expect(result.current.error?.message).toBe('auth/wrong-password');
    });
  });
});
\`\`\`

#### For a Screen or Component → Component Test

\`\`\`typescript
// src/features/auth/screens/LoginScreen.test.tsx
import React from 'react';
import { render, screen, fireEvent, waitFor } from '@testing-library/react-native';
import { LoginScreen } from './LoginScreen';
import { createTestNavigator } from '@/test-utils/navigation';
import { authService } from '@/services/auth/authService';

jest.mock('@/services/auth/authService');

const mockAuthService = jest.mocked(authService);

describe('LoginScreen', () => {
  const renderScreen = () => {
    const Screen = createTestNavigator(LoginScreen, 'Login');
    return render(<Screen />);
  };

  it('should render email and password inputs', () => {
    renderScreen();

    expect(screen.getByLabelText('Email address')).toBeTruthy();
    expect(screen.getByLabelText('Password')).toBeTruthy();
    expect(screen.getByRole('button', { name: 'Sign In' })).toBeTruthy();
  });

  it('should show validation error for empty email', async () => {
    renderScreen();

    fireEvent.press(screen.getByRole('button', { name: 'Sign In' }));

    await waitFor(() => {
      expect(screen.getByText('Email is required')).toBeTruthy();
    });
  });

  it('should call authService on valid submission', async () => {
    mockAuthService.signInWithEmail.mockResolvedValue({
      uid: 'user-123',
      email: 'test@example.com',
      displayName: 'Test User',
    });

    renderScreen();

    fireEvent.changeText(screen.getByLabelText('Email address'), 'test@example.com');
    fireEvent.changeText(screen.getByLabelText('Password'), 'password123');
    fireEvent.press(screen.getByRole('button', { name: 'Sign In' }));

    await waitFor(() => {
      expect(mockAuthService.signInWithEmail).toHaveBeenCalledWith(
        'test@example.com',
        'password123',
      );
    });
  });

  it('should display error message on auth failure', async () => {
    mockAuthService.signInWithEmail.mockRejectedValue(
      new Error('Invalid credentials'),
    );

    renderScreen();

    fireEvent.changeText(screen.getByLabelText('Email address'), 'test@example.com');
    fireEvent.changeText(screen.getByLabelText('Password'), 'wrong');
    fireEvent.press(screen.getByRole('button', { name: 'Sign In' }));

    await waitFor(() => {
      expect(screen.getByText('Invalid credentials')).toBeTruthy();
    });
  });

  it('should have accessible labels on all interactive elements', () => {
    renderScreen();

    expect(screen.getByLabelText('Email address')).toBeTruthy();
    expect(screen.getByLabelText('Password')).toBeTruthy();
    expect(screen.getByRole('button', { name: 'Sign In' })).toBeTruthy();
    expect(screen.getByRole('button', { name: 'Forgot password?' })).toBeTruthy();
  });
});
\`\`\`

#### For a Critical User Journey → Detox E2E Test

\`\`\`typescript
// e2e/auth.e2e.ts
import { by, device, element, expect } from 'detox';

describe('Authentication Flow', () => {
  beforeAll(async () => {
    await device.launchApp({ newInstance: true });
  });

  beforeEach(async () => {
    await device.reloadReactNative();
  });

  it('should allow user to log in with valid credentials', async () => {
    await element(by.label('Email address')).typeText('e2e-test@example.com');
    await element(by.label('Password')).typeText('TestPassword123!');
    await element(by.label('Sign In')).tap();

    await expect(element(by.text('Welcome back'))).toBeVisible();
    await expect(element(by.id('home-screen'))).toBeVisible();
  });

  it('should show error for invalid credentials', async () => {
    await element(by.label('Email address')).typeText('wrong@example.com');
    await element(by.label('Password')).typeText('wrong');
    await element(by.label('Sign In')).tap();

    await expect(element(by.text('Invalid credentials'))).toBeVisible();
  });
});
\`\`\`

### Step 3: Run the Test and Confirm It Fails (Red)

\`\`\`bash
# Unit and component tests
pnpm test --watch --testPathPattern="<path-to-test-file>"

# Single test file
pnpm test src/features/auth/hooks/useLogin.test.ts

# E2E tests (requires built app)
npx detox test --configuration ios.sim.debug e2e/auth.e2e.ts
\`\`\`

**Verify the test fails for the right reason.** The error should indicate missing implementation, not a broken test setup. If the test errors on import or mock configuration, fix the test infrastructure first.

### Step 4: Write Minimum Code to Pass (Green)

Implement only what the test requires. Do not add extra logic, optimizations, or edge case handling that is not yet tested.

\`\`\`typescript
// src/features/auth/hooks/useLogin.ts
import { useMutation } from '@tanstack/react-query';
import { authService } from '@/services/auth/authService';
import { useAuthStore } from '@/store/auth';
import type { LoginCredentials } from '../types';

export const useLogin = () => {
  const { login: setAuth } = useAuthStore();

  const mutation = useMutation({
    mutationFn: ({ email, password }: LoginCredentials) =>
      authService.signInWithEmail(email, password),
    onSuccess: (user) => {
      setAuth(user);
    },
  });

  return {
    login: mutation.mutate,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
\`\`\`

Run the test again:

\`\`\`bash
pnpm test src/features/auth/hooks/useLogin.test.ts
\`\`\`

All tests should pass. If any test still fails, adjust the implementation — not the test (unless the test itself has a bug).

### Step 5: Refactor (Refactor)

With green tests as your safety net, improve the code:

- Extract shared logic into utility functions
- Improve type definitions
- Add proper error mapping (Firebase error codes → user-friendly messages)
- Ensure i18n keys are used instead of hardcoded strings
- Verify accessibility labels are present
- Check file length stays under 250 lines

Run the full test suite after refactoring:

\`\`\`bash
pnpm test
\`\`\`

### Step 6: Add Edge Case Tests

Now expand coverage with additional scenarios:

\`\`\`typescript
it('should handle network offline gracefully', async () => {
  mockAuthService.signInWithEmail.mockRejectedValue(
    new Error('network-request-failed'),
  );

  const { result } = renderHook(() => useLogin(), {
    wrapper: createQueryWrapper(),
  });

  act(() => {
    result.current.login({ email: 'test@example.com', password: 'password123' });
  });

  await waitFor(() => {
    expect(result.current.error?.message).toBe('network-request-failed');
  });
});

it('should handle rate limiting', async () => {
  mockAuthService.signInWithEmail.mockRejectedValue(
    new Error('too-many-requests'),
  );

  // ...
});
\`\`\`

### Step 7: Check Coverage

\`\`\`bash
pnpm test --coverage --collectCoverageFrom="src/features/auth/**/*.{ts,tsx}"
\`\`\`

Ensure the feature meets the **75% coverage threshold**. Focus on:
- Statement coverage for business logic
- Branch coverage for conditional paths (platform checks, error handling)
- Function coverage for exported APIs

## Mocking Strategies

### Firebase Services

Create centralized mocks in \`src/test-utils/mocks/\`:

\`\`\`typescript
// src/test-utils/mocks/firebase.ts
export const mockFirebaseAuth = {
  signInWithEmailAndPassword: jest.fn(),
  createUserWithEmailAndPassword: jest.fn(),
  signOut: jest.fn(),
  onAuthStateChanged: jest.fn(),
  currentUser: null,
};

export const mockFirestore = {
  collection: jest.fn(),
  doc: jest.fn(),
  getDoc: jest.fn(),
  setDoc: jest.fn(),
  onSnapshot: jest.fn(),
};

jest.mock('@react-native-firebase/auth', () => () => mockFirebaseAuth);
jest.mock('@react-native-firebase/firestore', () => () => mockFirestore);
\`\`\`

### Native Modules

\`\`\`typescript
// jest.setup.ts (referenced in jest.config)
jest.mock('react-native/Libraries/Animated/NativeAnimatedHelper');

jest.mock('@react-native-async-storage/async-storage', () =>
  require('@react-native-async-storage/async-storage/jest/async-storage-mock'),
);

jest.mock('react-native-keychain', () => ({
  setGenericPassword: jest.fn().mockResolvedValue(true),
  getGenericPassword: jest.fn().mockResolvedValue({ username: 'user', password: 'token' }),
  resetGenericPassword: jest.fn().mockResolvedValue(true),
  BIOMETRY_TYPE: { TOUCH_ID: 'TouchID', FACE_ID: 'FaceID' },
  getSupportedBiometryType: jest.fn().mockResolvedValue('FaceID'),
}));

jest.mock('expo-local-authentication', () => ({
  hasHardwareAsync: jest.fn().mockResolvedValue(true),
  isEnrolledAsync: jest.fn().mockResolvedValue(true),
  authenticateAsync: jest.fn().mockResolvedValue({ success: true }),
  AuthenticationType: { FINGERPRINT: 1, FACIAL_RECOGNITION: 2 },
}));

jest.mock('expo-notifications', () => ({
  getPermissionsAsync: jest.fn().mockResolvedValue({ status: 'granted' }),
  requestPermissionsAsync: jest.fn().mockResolvedValue({ status: 'granted' }),
  getExpoPushTokenAsync: jest.fn().mockResolvedValue({ data: 'ExponentPushToken[xxx]' }),
  setNotificationHandler: jest.fn(),
  addNotificationReceivedListener: jest.fn(() => ({ remove: jest.fn() })),
  addNotificationResponseReceivedListener: jest.fn(() => ({ remove: jest.fn() })),
}));
\`\`\`

### WatermelonDB (Offline-First)

\`\`\`typescript
// src/test-utils/mocks/watermelondb.ts
import { Database } from '@nozbe/watermelondb';
import LokiJSAdapter from '@nozbe/watermelondb/adapters/lokijs';
import { schema } from '@/database/schema';
import { modelClasses } from '@/database/models';

export const createTestDatabase = (): Database => {
  const adapter = new LokiJSAdapter({
    schema,
    useWebWorker: false,
    useIncrementalIndexedDB: false,
  });

  return new Database({
    adapter,
    modelClasses,
  });
};
\`\`\`

### React Navigation

\`\`\`typescript
// src/test-utils/navigation.ts
import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

const Stack = createNativeStackNavigator();

export const createTestNavigator = (
  Screen: React.ComponentType<any>,
  name: string,
  params?: Record<string, unknown>,
) => {
  return function TestNavigator() {
    return (
      <NavigationContainer>
        <Stack.Navigator>
          <Stack.Screen
            name={name}
            component={Screen}
            initialParams={params}
          />
        </Stack.Navigator>
      </NavigationContainer>
    );
  };
};
\`\`\`

### React Query Wrapper

\`\`\`typescript
// src/test-utils/wrappers.tsx
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export const createQueryWrapper = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { retry: false, gcTime: 0 },
      mutations: { retry: false },
    },
  });

  return function QueryWrapper({ children }: { children: React.ReactNode }) {
    return (
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    );
  };
};
\`\`\`

## Platform-Specific Testing

When code branches on \`Platform.OS\`, test both paths:

\`\`\`typescript
import { Platform } from 'react-native';

describe('PlatformButton', () => {
  it('should render haptic feedback on iOS', () => {
    Platform.OS = 'ios';
    const { getByRole } = render(<PlatformButton label="Tap me" />);
    fireEvent.press(getByRole('button'));
    expect(mockHaptics.impactAsync).toHaveBeenCalled();
  });

  it('should render vibration on Android', () => {
    Platform.OS = 'android';
    const { getByRole } = render(<PlatformButton label="Tap me" />);
    fireEvent.press(getByRole('button'));
    expect(Vibration.vibrate).toHaveBeenCalledWith(50);
  });
});
\`\`\`

## Offline-First Testing

Test both online and offline scenarios:

\`\`\`typescript
import NetInfo from '@react-native-community/netinfo';

jest.mock('@react-native-community/netinfo');

describe('useSync', () => {
  it('should queue mutations when offline', async () => {
    (NetInfo.fetch as jest.Mock).mockResolvedValue({ isConnected: false });

    const { result } = renderHook(() => useSync());

    await act(async () => {
      await result.current.saveItem({ id: '1', name: 'Test' });
    });

    expect(result.current.pendingSync).toBe(1);
  });

  it('should flush queue when connection is restored', async () => {
    (NetInfo.fetch as jest.Mock).mockResolvedValue({ isConnected: true });

    const { result } = renderHook(() => useSync());

    await act(async () => {
      await result.current.flushQueue();
    });

    expect(result.current.pendingSync).toBe(0);
    expect(mockFirestore.setDoc).toHaveBeenCalled();
  });
});
\`\`\`

## Accessibility Testing

Every interactive element must have accessibility labels. Test them:

\`\`\`typescript
it('should meet accessibility requirements', () => {
  const { getByRole, getByLabelText } = render(<ProfileScreen />);

  // All buttons have accessible names
  expect(getByRole('button', { name: 'Edit profile' })).toBeTruthy();
  expect(getByRole('button', { name: 'Sign out' })).toBeTruthy();

  // All images have labels
  expect(getByLabelText('Profile photo')).toBeTruthy();

  // Form inputs have labels
  expect(getByLabelText('Display name')).toBeTruthy();
});
\`\`\`

## Running Tests

\`\`\`bash
# Run all tests
pnpm test

# Watch mode during development
pnpm test --watch

# Run tests for a specific feature
pnpm test --testPathPattern="src/features/auth"

# Run with coverage report
pnpm test --coverage

# Run only changed files (CI-friendly)
pnpm test --changedSince=main

# Run Detox E2E (iOS simulator)
npx detox build --configuration ios.sim.debug
npx detox test --configuration ios.sim.debug

# Run Detox E2E (Android emulator)
npx detox build --configuration android.emu.debug
npx detox test --configuration android.emu.debug
\`\`\`

## TDD Checklist

Before marking a task as complete, verify:

- [ ] All new code has corresponding tests written **before** implementation
- [ ] Tests cover happy path, error states, and edge cases
- [ ] Platform-specific branches are tested for both iOS and Android
- [ ] Offline scenarios are tested where applicable
- [ ] Accessibility labels are tested on all interactive elements
- [ ] i18n keys are used (no hardcoded user-facing strings)
- [ ] Mocks are properly typed (no \`any\`)
- [ ] Coverage meets 75% threshold for the changed files
- [ ] No snapshot tests (prefer explicit assertions)
- [ ] Test file is under 250 lines (split into describe blocks or separate files)
- [ ] Tests run in isolation (no shared mutable state between tests)
- [ ] E2E tests added for new critical user journeys

## Anti-Patterns to Avoid

1. **Testing implementation details** — Test behavior, not internal state or method calls
2. **Snapshot tests for complex components** — They break on every style change and provide no insight
3. **Mocking what you don't own without integration tests** — Mock Firebase in unit tests, but verify real integration in E2E
4. **Testing library internals** — Don't test React Navigation's behavior; test that your screen navigates correctly
5. **Ignoring async cleanup** — Always use \`waitFor\` and clean up subscriptions in \`afterEach\`
6. **Using \`any\` in test files** — Test files follow the same strict TypeScript rules as production code
7. **Writing tests after the fact** — If you find yourself writing tests to match existing code, you are doing coverage, not TDD

## Related Files

- \`jest.config.ts\` — Jest configuration with module name mapping and transform settings
- \`jest.setup.ts\` — Global mocks for native modules and Firebase
- \`.detoxrc.js\` — Detox configuration for iOS and Android
- \`src/test-utils/\` — Shared test utilities, wrappers, and mock factories
- \`docs/CONTRIBUTING.md\` — Testing requirements for pull requests
- \`.github/workflows/ci.yml\` — CI pipeline running tests on every push`,

  'plugin/codeforge-react-native/skills/verify/SKILL.md': `---
name: verify
description: Comprehensive verification skill for React Native mobile app — runs lint, type check, unit tests, component tests, and optional E2E tests to ensure code quality before commit or PR submission
version: 1.0.0
author: codeforge-react-native
tags:
  - verification
  - testing
  - quality
  - react-native
  - mobile
inputs:
  - name: scope
    description: What to verify — all, lint, types, unit, component, e2e, build
    type: string
    default: all
  - name: platform
    description: Target platform for build/E2E verification
    type: string
    default: both
    enum: [ios, android, both]
  - name: fix
    description: Auto-fix lint and formatting issues
    type: boolean
    default: false
  - name: coverage
    description: Enforce coverage thresholds
    type: boolean
    default: true
  - name: changed-only
    description: Only verify files changed since main branch
    type: boolean
    default: false
metadata:
  priority: high
  category: quality-assurance
  estimated_duration: 2-10 minutes depending on scope
  requires:
    - node >= 20
    - pnpm >= 9
    - typescript >= 5.4
  environment:
    - FIREBASE_PROJECT_ID
  ci_compatible: true
---

# Verify Skill

Runs the full verification pipeline for the React Native mobile app. This skill ensures code quality, type safety, test coverage, and build integrity before code is committed or a PR is opened.

## Purpose

Mobile apps have a higher cost of failure than web apps — a bug shipped to production requires an App Store/Google Play review cycle to fix. The verify skill catches issues early across multiple dimensions: static analysis, type correctness, runtime behavior, and build compilation.

## Verification Pipeline

The full pipeline runs in this order. Each stage gates the next — if a stage fails, subsequent stages are skipped unless \`--scope\` targets a specific stage.

### 1. Lint (\`scope: lint\`)

Runs ESLint with the \`@react-native-community\` config plus project-specific rules.

\`\`\`bash
# All files
pnpm eslint src/ e2e/ --ext .ts,.tsx --max-warnings 0

# Changed files only
pnpm eslint $(git diff --name-only --diff-filter=d main -- '*.ts' '*.tsx') --max-warnings 0

# With auto-fix
pnpm eslint src/ e2e/ --ext .ts,.tsx --max-warnings 0 --fix
\`\`\`

**What it checks:**
- React Native best practices (no inline styles in lists, no direct Text outside Text components)
- Import ordering and unused imports
- Accessibility: \`accessibilityLabel\` required on all \`TouchableOpacity\`, \`Pressable\`, \`Button\`
- No \`any\` types (enforced via \`@typescript-eslint/no-explicit-any\`)
- i18n enforcement: no hardcoded user-facing strings outside \`src/i18n/\`
- Platform-specific file naming (\`.ios.ts\`, \`.android.ts\`)
- No \`console.log\` (use the structured logger from \`src/services/logger\`)

### 2. Formatting (\`scope: lint\`)

Runs Prettier to verify consistent formatting.

\`\`\`bash
pnpm prettier --check "src/**/*.{ts,tsx,json}" "e2e/**/*.{ts,tsx}"

# With auto-fix
pnpm prettier --write "src/**/*.{ts,tsx,json}" "e2e/**/*.{ts,tsx}"
\`\`\`

**Config:** singleQuote, trailingComma: all, semi: true, printWidth: 100

### 3. Type Check (\`scope: types\`)

Runs the TypeScript compiler in strict mode with no emit.

\`\`\`bash
pnpm tsc --noEmit
\`\`\`

**What it catches:**
- Strict null checks (no implicit \`undefined\` access)
- React Navigation type mismatches (screen params, navigator types)
- Zustand store type drift
- React Query key/data type mismatches
- WatermelonDB model/schema type alignment
- Firebase document type assertions
- Missing platform-specific implementations

### 4. Unit Tests (\`scope: unit\`)

Runs Jest for pure logic — hooks, utilities, services, store actions.

\`\`\`bash
# All unit tests
pnpm jest --testPathPattern="src/.*(test|spec)\\\\.ts$" --passWithNoTests

# Changed files only
pnpm jest --onlyChanged --testPathPattern="src/.*(test|spec)\\\\.ts$"

# With coverage enforcement
pnpm jest --testPathPattern="src/.*(test|spec)\\\\.ts$" --coverage --coverageThreshold='{"global":{"branches":75,"functions":75,"lines":75,"statements":75}}'
\`\`\`

**Coverage thresholds (75% minimum):**
- \`src/services/**\` — 80% (critical backend integration)
- \`src/hooks/**\` — 75%
- \`src/utils/**\` — 85% (pure functions, easy to test)
- \`src/store/**\` — 75%
- \`src/features/**/hooks/**\` — 75%

**Key test patterns:**
- Zustand stores: test state transitions and selectors
- React Query hooks: mock Firebase calls, test cache behavior
- WatermelonDB: test sync conflict resolution logic
- Auth service: test token refresh, biometric fallback
- Deep linking: test URL parsing and navigation resolution

### 5. Component Tests (\`scope: component\`)

Runs React Native Testing Library tests for UI components and screens.

\`\`\`bash
# All component tests
pnpm jest --testPathPattern="src/.*(test|spec)\\\\.tsx$" --passWithNoTests

# With coverage
pnpm jest --testPathPattern="src/.*(test|spec)\\\\.tsx$" --coverage
\`\`\`

**What to verify in component tests:**
- Renders without crashing on iOS and Android
- Accessibility labels present and correct
- User interactions trigger expected state changes
- Loading, error, and empty states render correctly
- Offline state UI displays appropriately
- Navigation calls fire with correct params
- i18n keys resolve (no missing translations)

### 6. Build Check (\`scope: build\`)

Validates that the app compiles for the target platform(s) without running a full EAS build.

\`\`\`bash
# Expo doctor — checks config consistency
npx expo-doctor

# Validate app.config.ts
npx expo config --type public

# Check native dependencies compatibility
npx expo install --check

# iOS build check (requires macOS)
npx expo prebuild --platform ios --clean
cd ios && xcodebuild -workspace ReactNativeMobileApp.xcworkspace -scheme ReactNativeMobileApp -configuration Debug -sdk iphonesimulator -dry-run

# Android build check
npx expo prebuild --platform android --clean
cd android && ./gradlew assembleDebug --dry-run
\`\`\`

### 7. E2E Tests (\`scope: e2e\`)

Runs Detox end-to-end tests against a built app on simulators/emulators.

\`\`\`bash
# Build for E2E
npx detox build --configuration ios.sim.debug
npx detox build --configuration android.emu.debug

# Run E2E tests
npx detox test --configuration ios.sim.debug --cleanup --headless
npx detox test --configuration android.emu.debug --cleanup --headless
\`\`\`

**Critical E2E flows:**
- Authentication: sign up → verify email → sign in → biometric enrollment
- Offline: load data → airplane mode → navigate → come back online → sync
- Push notifications: receive → tap → deep link resolves correctly
- In-app purchase: initiate → confirm → entitlement granted
- Deep linking: cold start with URL → correct screen with params

## Scope Combinations

| Scope | What Runs | Typical Duration |
|-------|-----------|-----------------|
| \`all\` | Lint + Types + Unit + Component | ~3-5 min |
| \`lint\` | ESLint + Prettier | ~30s |
| \`types\` | TypeScript compiler | ~20s |
| \`unit\` | Jest unit tests | ~1-2 min |
| \`component\` | Jest component tests | ~1-2 min |
| \`build\` | Expo doctor + prebuild check | ~3-5 min |
| \`e2e\` | Detox build + test | ~8-15 min |

> **Note:** \`e2e\` and \`build\` are not included in \`all\` by default — they require explicit invocation due to duration and environment requirements.

## Usage Examples

### Pre-commit (fast feedback)
\`\`\`
Run verify with scope=lint and changed-only=true, then scope=types
\`\`\`

### Pre-PR (thorough check)
\`\`\`
Run verify with scope=all and coverage=true
\`\`\`

### CI pipeline (full verification)
\`\`\`
Run verify with scope=all, then scope=build with platform=both
\`\`\`

### Debugging a specific area
\`\`\`
Run verify with scope=unit and changed-only=true
\`\`\`

## Sensitive Path Verification

When changes touch sensitive paths, additional checks are triggered automatically:

| Path | Additional Verification |
|------|------------------------|
| \`src/services/auth/**\` | Run auth E2E flow, check secure storage usage, verify no plaintext credentials |
| \`src/config/**\` | Validate env vars, check no secrets in bundle, verify app.config.ts |
| \`src/features/payments/**\` | Run purchase E2E flow, verify receipt validation logic |
| \`google-services.json\` | Validate JSON structure, check package name matches |
| \`GoogleService-Info.plist\` | Validate plist structure, check bundle ID matches |
| \`.env*\` | Ensure \`.env\` files are in \`.gitignore\`, no secrets committed |
| \`src/navigation/**\` | Run deep link resolution tests, verify typed navigator params |
| \`src/i18n/**\` | Check all keys have translations in all supported locales |

## Failure Handling

When verification fails:

1. **Identify the failing stage** — report which step failed and why
2. **Show the specific errors** — file, line, error message
3. **Suggest fixes** — for common issues, provide the fix inline
4. **Do not skip failures** — all issues must be resolved before proceeding
5. **For flaky E2E tests** — retry once, then report as flaky with the test name

## Common Fix Patterns

| Error | Fix |
|-------|-----|
| Missing accessibility label | Add \`accessibilityLabel={t('component.action')}\` |
| Hardcoded string | Move to \`src/i18n/locales/en.json\` and use \`useTranslation()\` |
| \`any\` type | Replace with proper type from feature's \`types/\` directory |
| Console.log | Replace with \`Logger.debug()\` from \`src/services/logger\` |
| Inline style in FlatList | Extract to \`StyleSheet.create()\` outside component |
| Missing platform impl | Add \`.ios.ts\` and \`.android.ts\` variants or use \`Platform.select()\` |
| Coverage below 75% | Add tests for uncovered branches — focus on error paths and edge cases |

## Integration with CI/CD

This skill maps directly to the GitHub Actions pipeline stages:

\`\`\`
Lint → Type Check → Unit Tests → Component Tests → EAS Build → Detox E2E → Deploy
\`\`\`

In CI, the verify skill runs with \`scope=all\` and \`coverage=true\`. Build and E2E stages are handled by dedicated workflow jobs that invoke \`scope=build\` and \`scope=e2e\` respectively.

## AI-Generated Code Flag

When verify runs on AI-generated code, ensure:
- The \`// AI-generated\` comment is present on new files or substantially modified functions
- Generated code passes all the same checks as human-written code — no exceptions
- Coverage requirements apply equally to AI-generated code`,

  'plugin/marketplace.json.example': `{
  "slug": "codeforge-react-native",
  "name": "CodeForge React Native",
  "version": "1.0.0",
  "description": "Claude Code plugin for React Native + Expo + Firebase mobile app development. Provides AI-powered agents, skills, and commands for planning, TDD, code review, build troubleshooting, and deployment workflows tailored to cross-platform mobile development.",
  "author": {
    "name": "CodeForge Team",
    "email": "plugins@codeforge.example.com",
    "url": "https://github.com/codeforge/codeforge-react-native"
  },
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/codeforge/codeforge-react-native.git"
  },
  "homepage": "https://github.com/codeforge/codeforge-react-native#readme",
  "bugs": {
    "url": "https://github.com/codeforge/codeforge-react-native/issues"
  },
  "categories": [
    "mobile-development",
    "react-native",
    "expo",
    "firebase",
    "cross-platform",
    "developer-tools"
  ],
  "tags": [
    "react-native",
    "expo",
    "firebase",
    "typescript",
    "mobile",
    "ios",
    "android",
    "offline-first",
    "watermelondb",
    "zustand",
    "react-query",
    "detox",
    "eas-build",
    "push-notifications",
    "biometric-auth",
    "in-app-purchases",
    "tdd",
    "code-review",
    "ci-cd"
  ],
  "compatibility": {
    "claude_code": ">=1.0.0",
    "node": ">=18.0.0",
    "platforms": ["macos", "linux", "windows"]
  },
  "tech_stack": {
    "language": "TypeScript (strict mode)",
    "framework": "React Native 0.74 + Expo SDK 51",
    "navigation": "React Navigation v6",
    "state_management": ["Zustand", "TanStack Query"],
    "local_database": "WatermelonDB",
    "backend": "Firebase (Auth, Firestore, Cloud Functions, FCM, Storage)",
    "testing": ["Jest", "React Native Testing Library", "Detox"],
    "ci_cd": "GitHub Actions + EAS Build + EAS Submit",
    "package_manager": "pnpm"
  },
  "agents": [
    {
      "id": "planner",
      "name": "Planner",
      "description": "Breaks down mobile features into phased implementation plans with platform-specific considerations for iOS and Android."
    },
    {
      "id": "architect",
      "name": "Architect",
      "description": "Designs feature-based architecture following offline-first patterns, typed navigation, and React Native best practices."
    },
    {
      "id": "code-reviewer",
      "name": "Code Reviewer",
      "description": "Reviews React Native code for performance, accessibility, platform parity, security, and adherence to project conventions."
    },
    {
      "id": "tdd-guide",
      "name": "TDD Guide",
      "description": "Guides test-driven development with Jest, React Native Testing Library, and Detox E2E test patterns."
    },
    {
      "id": "build-error-resolver",
      "name": "Build Error Resolver",
      "description": "Diagnoses and resolves native build failures for iOS (Xcode/CocoaPods) and Android (Gradle) including EAS Build issues."
    }
  ],
  "commands": [
    {
      "id": "plan",
      "name": "/plan",
      "description": "Generate a phased implementation plan for a mobile feature, including platform considerations and offline support."
    },
    {
      "id": "tdd",
      "name": "/tdd",
      "description": "Start a TDD cycle: write failing tests first, implement to pass, then refactor. Supports unit, component, and E2E tests."
    },
    {
      "id": "code-review",
      "name": "/code-review",
      "description": "Run a comprehensive code review checking performance, accessibility, security, platform parity, and conventions."
    },
    {
      "id": "build-fix",
      "name": "/build-fix",
      "description": "Diagnose and fix native build errors for iOS, Android, or EAS Build failures."
    },
    {
      "id": "verify",
      "name": "/verify",
      "description": "Run the full verification pipeline: lint, type check, unit tests, component tests, and coverage validation."
    },
    {
      "id": "phase",
      "name": "/phase",
      "description": "Execute a specific development methodology phase (discover, plan, implement, verify, release)."
    }
  ],
  "skills": [
    {
      "id": "plan",
      "name": "Plan",
      "description": "Feature planning with mobile-specific breakdown including offline sync, deep linking, and platform considerations."
    },
    {
      "id": "code-review",
      "name": "Code Review",
      "description": "Mobile-focused code review covering React Native performance, native module safety, and accessibility compliance."
    },
    {
      "id": "tdd",
      "name": "TDD",
      "description": "Test-driven development workflow for React Native with Jest, RNTL, and Detox integration."
    },
    {
      "id": "build-fix",
      "name": "Build Fix",
      "description": "Native build error resolution for Xcode, Gradle, CocoaPods, Metro bundler, and EAS Build."
    },
    {
      "id": "verify",
      "name": "Verify",
      "description": "Full project verification pipeline with 75% coverage threshold enforcement."
    },
    {
      "id": "phase",
      "name": "Phase",
      "description": "Development methodology phase execution following the project playbook."
    }
  ],
  "hooks": [
    {
      "event": "pre-commit",
      "description": "Validates conventional commit format, checks for secrets/credentials, ensures no .env files are committed."
    },
    {
      "event": "post-file-edit",
      "description": "Reminds about platform parity when editing platform-specific code, flags missing accessibility labels."
    },
    {
      "event": "pre-push",
      "description": "Runs lint, type check, and unit tests before pushing to remote."
    }
  ],
  "configuration": {
    "coverage_threshold": 75,
    "max_file_length": 250,
    "architecture": "feature-based",
    "naming_conventions": {
      "components": "PascalCase",
      "hooks": "camelCase (use prefix)",
      "utils": "camelCase",
      "files": "kebab-case",
      "constants": "SCREAMING_SNAKE_CASE"
    },
    "compliance": ["GDPR", "App Store Guidelines", "Google Play Policies"],
    "sensitive_paths": [
      "src/services/auth/**",
      "src/config/**",
      "google-services.json",
      "GoogleService-Info.plist",
      ".env*"
    ]
  },
  "screenshots": [
    {
      "url": "https://raw.githubusercontent.com/codeforge/codeforge-react-native/main/docs/assets/plan-command.png",
      "alt": "The /plan command generating a phased implementation plan for a push notifications feature",
      "caption": "Feature planning with platform-specific considerations"
    },
    {
      "url": "https://raw.githubusercontent.com/codeforge/codeforge-react-native/main/docs/assets/build-fix-command.png",
      "alt": "The /build-fix command diagnosing and resolving a CocoaPods linking error",
      "caption": "Automated native build error resolution"
    },
    {
      "url": "https://raw.githubusercontent.com/codeforge/codeforge-react-native/main/docs/assets/code-review-command.png",
      "alt": "The /code-review command analyzing a screen component for performance and accessibility issues",
      "caption": "Mobile-focused code review with actionable feedback"
    }
  ],
  "install": {
    "method": "script",
    "command": "bash install.sh",
    "post_install": [
      "Run \`pnpm install\` to install project dependencies",
      "Copy \`.env.example\` to \`.env\` and configure Firebase credentials",
      "Run \`npx expo start\` to verify the development environment"
    ]
  },
  "pricing": {
    "model": "free",
    "tier": "community"
  },
  "metrics": {
    "downloads": 0,
    "stars": 0,
    "last_updated": "2024-12-01T00:00:00Z"
  }
}`,

  'tsconfig.json': `{
  "extends": "expo/tsconfig.base",
  "compilerOptions": {
    "strict": true,
    "noUncheckedIndexedAccess": true,
    "noImplicitReturns": true,
    "noFallthroughCasesInSwitch": true,
    "noPropertyAccessFromIndexSignature": true,
    "forceConsistentCasingInFileNames": true,
    "exactOptionalPropertyTypes": false,
    "skipLibCheck": true,
    "esModuleInterop": true,
    "allowSyntheticDefaultImports": true,
    "resolveJsonModule": true,
    "isolatedModules": true,
    "jsx": "react-jsx",
    "moduleResolution": "bundler",
    "target": "ESNext",
    "module": "ESNext",
    "lib": ["ESNext"],
    "types": ["jest", "@types/react", "detox"],
    "baseUrl": ".",
    "paths": {
      "@/*": ["src/*"],
      "@features/*": ["src/features/*"],
      "@components/*": ["src/components/*"],
      "@hooks/*": ["src/hooks/*"],
      "@services/*": ["src/services/*"],
      "@navigation/*": ["src/navigation/*"],
      "@store/*": ["src/store/*"],
      "@utils/*": ["src/utils/*"],
      "@i18n/*": ["src/i18n/*"],
      "@theme/*": ["src/theme/*"],
      "@assets/*": ["src/assets/*"]
    }
  },
  "include": [
    "src/**/*.ts",
    "src/**/*.tsx",
    "e2e/**/*.ts",
    "app.config.ts",
    "metro.config.js",
    "babel.config.js",
    "global.d.ts"
  ],
  "exclude": [
    "node_modules",
    "android",
    "ios",
    ".expo",
    "dist",
    "build",
    "coverage",
    "plugin"
  ]
}`,

};
